
(function() {
'use strict';

function F2(fun)
{
  function wrapper(a) { return function(b) { return fun(a,b); }; }
  wrapper.arity = 2;
  wrapper.func = fun;
  return wrapper;
}

function F3(fun)
{
  function wrapper(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  }
  wrapper.arity = 3;
  wrapper.func = fun;
  return wrapper;
}

function F4(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  }
  wrapper.arity = 4;
  wrapper.func = fun;
  return wrapper;
}

function F5(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  }
  wrapper.arity = 5;
  wrapper.func = fun;
  return wrapper;
}

function F6(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  }
  wrapper.arity = 6;
  wrapper.func = fun;
  return wrapper;
}

function F7(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  }
  wrapper.arity = 7;
  wrapper.func = fun;
  return wrapper;
}

function F8(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  }
  wrapper.arity = 8;
  wrapper.func = fun;
  return wrapper;
}

function F9(fun)
{
  function wrapper(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  }
  wrapper.arity = 9;
  wrapper.func = fun;
  return wrapper;
}

function A2(fun, a, b)
{
  return fun.arity === 2
    ? fun.func(a, b)
    : fun(a)(b);
}
function A3(fun, a, b, c)
{
  return fun.arity === 3
    ? fun.func(a, b, c)
    : fun(a)(b)(c);
}
function A4(fun, a, b, c, d)
{
  return fun.arity === 4
    ? fun.func(a, b, c, d)
    : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e)
{
  return fun.arity === 5
    ? fun.func(a, b, c, d, e)
    : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f)
{
  return fun.arity === 6
    ? fun.func(a, b, c, d, e, f)
    : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g)
{
  return fun.arity === 7
    ? fun.func(a, b, c, d, e, f, g)
    : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h)
{
  return fun.arity === 8
    ? fun.func(a, b, c, d, e, f, g, h)
    : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i)
{
  return fun.arity === 9
    ? fun.func(a, b, c, d, e, f, g, h, i)
    : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

//import Result //

var _elm_lang$core$Native_Date = function() {

function fromString(str)
{
	var date = new Date(str);
	return isNaN(date.getTime())
		? _elm_lang$core$Result$Err('Unable to parse \'' + str + '\' as a date. Dates must be in the ISO 8601 format.')
		: _elm_lang$core$Result$Ok(date);
}

var dayTable = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var monthTable =
	['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
	 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];


return {
	fromString: fromString,
	year: function(d) { return d.getFullYear(); },
	month: function(d) { return { ctor: monthTable[d.getMonth()] }; },
	day: function(d) { return d.getDate(); },
	hour: function(d) { return d.getHours(); },
	minute: function(d) { return d.getMinutes(); },
	second: function(d) { return d.getSeconds(); },
	millisecond: function(d) { return d.getMilliseconds(); },
	toTime: function(d) { return d.getTime(); },
	fromTime: function(t) { return new Date(t); },
	dayOfWeek: function(d) { return { ctor: dayTable[d.getDay()] }; }
};

}();
//import Native.Utils //

var _elm_lang$core$Native_Basics = function() {

function div(a, b)
{
	return (a / b) | 0;
}
function rem(a, b)
{
	return a % b;
}
function mod(a, b)
{
	if (b === 0)
	{
		throw new Error('Cannot perform mod 0. Division by zero error.');
	}
	var r = a % b;
	var m = a === 0 ? 0 : (b > 0 ? (a >= 0 ? r : r + b) : -mod(-a, -b));

	return m === b ? 0 : m;
}
function logBase(base, n)
{
	return Math.log(n) / Math.log(base);
}
function negate(n)
{
	return -n;
}
function abs(n)
{
	return n < 0 ? -n : n;
}

function min(a, b)
{
	return _elm_lang$core$Native_Utils.cmp(a, b) < 0 ? a : b;
}
function max(a, b)
{
	return _elm_lang$core$Native_Utils.cmp(a, b) > 0 ? a : b;
}
function clamp(lo, hi, n)
{
	return _elm_lang$core$Native_Utils.cmp(n, lo) < 0
		? lo
		: _elm_lang$core$Native_Utils.cmp(n, hi) > 0
			? hi
			: n;
}

var ord = ['LT', 'EQ', 'GT'];

function compare(x, y)
{
	return { ctor: ord[_elm_lang$core$Native_Utils.cmp(x, y) + 1] };
}

function xor(a, b)
{
	return a !== b;
}
function not(b)
{
	return !b;
}
function isInfinite(n)
{
	return n === Infinity || n === -Infinity;
}

function truncate(n)
{
	return n | 0;
}

function degrees(d)
{
	return d * Math.PI / 180;
}
function turns(t)
{
	return 2 * Math.PI * t;
}
function fromPolar(point)
{
	var r = point._0;
	var t = point._1;
	return _elm_lang$core$Native_Utils.Tuple2(r * Math.cos(t), r * Math.sin(t));
}
function toPolar(point)
{
	var x = point._0;
	var y = point._1;
	return _elm_lang$core$Native_Utils.Tuple2(Math.sqrt(x * x + y * y), Math.atan2(y, x));
}

return {
	div: F2(div),
	rem: F2(rem),
	mod: F2(mod),

	pi: Math.PI,
	e: Math.E,
	cos: Math.cos,
	sin: Math.sin,
	tan: Math.tan,
	acos: Math.acos,
	asin: Math.asin,
	atan: Math.atan,
	atan2: F2(Math.atan2),

	degrees: degrees,
	turns: turns,
	fromPolar: fromPolar,
	toPolar: toPolar,

	sqrt: Math.sqrt,
	logBase: F2(logBase),
	negate: negate,
	abs: abs,
	min: F2(min),
	max: F2(max),
	clamp: F3(clamp),
	compare: F2(compare),

	xor: F2(xor),
	not: not,

	truncate: truncate,
	ceiling: Math.ceil,
	floor: Math.floor,
	round: Math.round,
	toFloat: function(x) { return x; },
	isNaN: isNaN,
	isInfinite: isInfinite
};

}();
//import //

var _elm_lang$core$Native_Utils = function() {

// COMPARISONS

function eq(x, y)
{
	var stack = [];
	var isEqual = eqHelp(x, y, 0, stack);
	var pair;
	while (isEqual && (pair = stack.pop()))
	{
		isEqual = eqHelp(pair.x, pair.y, 0, stack);
	}
	return isEqual;
}


function eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push({ x: x, y: y });
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object')
	{
		if (typeof x === 'function')
		{
			throw new Error(
				'Trying to use `(==)` on functions. There is no way to know if functions are "the same" in the Elm sense.'
				+ ' Read more about this at http://package.elm-lang.org/packages/elm-lang/core/latest/Basics#=='
				+ ' which describes why it is this way and what the better version will look like.'
			);
		}
		return false;
	}

	if (x === null || y === null)
	{
		return false
	}

	if (x instanceof Date)
	{
		return x.getTime() === y.getTime();
	}

	if (!('ctor' in x))
	{
		for (var key in x)
		{
			if (!eqHelp(x[key], y[key], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}

	// convert Dicts and Sets to lists
	if (x.ctor === 'RBNode_elm_builtin' || x.ctor === 'RBEmpty_elm_builtin')
	{
		x = _elm_lang$core$Dict$toList(x);
		y = _elm_lang$core$Dict$toList(y);
	}
	if (x.ctor === 'Set_elm_builtin')
	{
		x = _elm_lang$core$Set$toList(x);
		y = _elm_lang$core$Set$toList(y);
	}

	// check if lists are equal without recursion
	if (x.ctor === '::')
	{
		var a = x;
		var b = y;
		while (a.ctor === '::' && b.ctor === '::')
		{
			if (!eqHelp(a._0, b._0, depth + 1, stack))
			{
				return false;
			}
			a = a._1;
			b = b._1;
		}
		return a.ctor === b.ctor;
	}

	// check if Arrays are equal
	if (x.ctor === '_Array')
	{
		var xs = _elm_lang$core$Native_Array.toJSArray(x);
		var ys = _elm_lang$core$Native_Array.toJSArray(y);
		if (xs.length !== ys.length)
		{
			return false;
		}
		for (var i = 0; i < xs.length; i++)
		{
			if (!eqHelp(xs[i], ys[i], depth + 1, stack))
			{
				return false;
			}
		}
		return true;
	}

	if (!eqHelp(x.ctor, y.ctor, depth + 1, stack))
	{
		return false;
	}

	for (var key in x)
	{
		if (!eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

var LT = -1, EQ = 0, GT = 1;

function cmp(x, y)
{
	if (typeof x !== 'object')
	{
		return x === y ? EQ : x < y ? LT : GT;
	}

	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? EQ : a < b ? LT : GT;
	}

	if (x.ctor === '::' || x.ctor === '[]')
	{
		while (x.ctor === '::' && y.ctor === '::')
		{
			var ord = cmp(x._0, y._0);
			if (ord !== EQ)
			{
				return ord;
			}
			x = x._1;
			y = y._1;
		}
		return x.ctor === y.ctor ? EQ : x.ctor === '[]' ? LT : GT;
	}

	if (x.ctor.slice(0, 6) === '_Tuple')
	{
		var ord;
		var n = x.ctor.slice(6) - 0;
		var err = 'cannot compare tuples with more than 6 elements.';
		if (n === 0) return EQ;
		if (n >= 1) { ord = cmp(x._0, y._0); if (ord !== EQ) return ord;
		if (n >= 2) { ord = cmp(x._1, y._1); if (ord !== EQ) return ord;
		if (n >= 3) { ord = cmp(x._2, y._2); if (ord !== EQ) return ord;
		if (n >= 4) { ord = cmp(x._3, y._3); if (ord !== EQ) return ord;
		if (n >= 5) { ord = cmp(x._4, y._4); if (ord !== EQ) return ord;
		if (n >= 6) { ord = cmp(x._5, y._5); if (ord !== EQ) return ord;
		if (n >= 7) throw new Error('Comparison error: ' + err); } } } } } }
		return EQ;
	}

	throw new Error(
		'Comparison error: comparison is only defined on ints, '
		+ 'floats, times, chars, strings, lists of comparable values, '
		+ 'and tuples of comparable values.'
	);
}


// COMMON VALUES

var Tuple0 = {
	ctor: '_Tuple0'
};

function Tuple2(x, y)
{
	return {
		ctor: '_Tuple2',
		_0: x,
		_1: y
	};
}

function chr(c)
{
	return new String(c);
}


// GUID

var count = 0;
function guid(_)
{
	return count++;
}


// RECORDS

function update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


//// LIST STUFF ////

var Nil = { ctor: '[]' };

function Cons(hd, tl)
{
	return {
		ctor: '::',
		_0: hd,
		_1: tl
	};
}

function append(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (xs.ctor === '[]')
	{
		return ys;
	}
	var root = Cons(xs._0, Nil);
	var curr = root;
	xs = xs._1;
	while (xs.ctor !== '[]')
	{
		curr._1 = Cons(xs._0, Nil);
		xs = xs._1;
		curr = curr._1;
	}
	curr._1 = ys;
	return root;
}


// CRASHES

function crash(moduleName, region)
{
	return function(message) {
		throw new Error(
			'Ran into a `Debug.crash` in module `' + moduleName + '` ' + regionToString(region) + '\n'
			+ 'The message provided by the code author is:\n\n    '
			+ message
		);
	};
}

function crashCase(moduleName, region, value)
{
	return function(message) {
		throw new Error(
			'Ran into a `Debug.crash` in module `' + moduleName + '`\n\n'
			+ 'This was caused by the `case` expression ' + regionToString(region) + '.\n'
			+ 'One of the branches ended with a crash and the following value got through:\n\n    ' + toString(value) + '\n\n'
			+ 'The message provided by the code author is:\n\n    '
			+ message
		);
	};
}

function regionToString(region)
{
	if (region.start.line == region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'between lines ' + region.start.line + ' and ' + region.end.line;
}


// TO STRING

function toString(v)
{
	var type = typeof v;
	if (type === 'function')
	{
		return '<function>';
	}

	if (type === 'boolean')
	{
		return v ? 'True' : 'False';
	}

	if (type === 'number')
	{
		return v + '';
	}

	if (v instanceof String)
	{
		return '\'' + addSlashes(v, true) + '\'';
	}

	if (type === 'string')
	{
		return '"' + addSlashes(v, false) + '"';
	}

	if (v === null)
	{
		return 'null';
	}

	if (type === 'object' && 'ctor' in v)
	{
		var ctorStarter = v.ctor.substring(0, 5);

		if (ctorStarter === '_Tupl')
		{
			var output = [];
			for (var k in v)
			{
				if (k === 'ctor') continue;
				output.push(toString(v[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (ctorStarter === '_Task')
		{
			return '<task>'
		}

		if (v.ctor === '_Array')
		{
			var list = _elm_lang$core$Array$toList(v);
			return 'Array.fromList ' + toString(list);
		}

		if (v.ctor === '<decoder>')
		{
			return '<decoder>';
		}

		if (v.ctor === '_Process')
		{
			return '<process:' + v.id + '>';
		}

		if (v.ctor === '::')
		{
			var output = '[' + toString(v._0);
			v = v._1;
			while (v.ctor === '::')
			{
				output += ',' + toString(v._0);
				v = v._1;
			}
			return output + ']';
		}

		if (v.ctor === '[]')
		{
			return '[]';
		}

		if (v.ctor === 'Set_elm_builtin')
		{
			return 'Set.fromList ' + toString(_elm_lang$core$Set$toList(v));
		}

		if (v.ctor === 'RBNode_elm_builtin' || v.ctor === 'RBEmpty_elm_builtin')
		{
			return 'Dict.fromList ' + toString(_elm_lang$core$Dict$toList(v));
		}

		var output = '';
		for (var i in v)
		{
			if (i === 'ctor') continue;
			var str = toString(v[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return v.ctor + output;
	}

	if (type === 'object')
	{
		if (v instanceof Date)
		{
			return '<' + v.toString() + '>';
		}

		if (v.elm_web_socket)
		{
			return '<websocket>';
		}

		var output = [];
		for (var k in v)
		{
			output.push(k + ' = ' + toString(v[k]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return '<internal structure>';
}

function addSlashes(str, isChar)
{
	var s = str.replace(/\\/g, '\\\\')
			  .replace(/\n/g, '\\n')
			  .replace(/\t/g, '\\t')
			  .replace(/\r/g, '\\r')
			  .replace(/\v/g, '\\v')
			  .replace(/\0/g, '\\0');
	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}


return {
	eq: eq,
	cmp: cmp,
	Tuple0: Tuple0,
	Tuple2: Tuple2,
	chr: chr,
	update: update,
	guid: guid,

	append: F2(append),

	crash: crash,
	crashCase: crashCase,

	toString: toString
};

}();
var _elm_lang$core$Basics$never = function (_p0) {
	never:
	while (true) {
		var _p1 = _p0;
		var _v1 = _p1._0;
		_p0 = _v1;
		continue never;
	}
};
var _elm_lang$core$Basics$uncurry = F2(
	function (f, _p2) {
		var _p3 = _p2;
		return A2(f, _p3._0, _p3._1);
	});
var _elm_lang$core$Basics$curry = F3(
	function (f, a, b) {
		return f(
			{ctor: '_Tuple2', _0: a, _1: b});
	});
var _elm_lang$core$Basics$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var _elm_lang$core$Basics$always = F2(
	function (a, _p4) {
		return a;
	});
var _elm_lang$core$Basics$identity = function (x) {
	return x;
};
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<|'] = F2(
	function (f, x) {
		return f(x);
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['|>'] = F2(
	function (x, f) {
		return f(x);
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>>'] = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<<'] = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['++'] = _elm_lang$core$Native_Utils.append;
var _elm_lang$core$Basics$toString = _elm_lang$core$Native_Utils.toString;
var _elm_lang$core$Basics$isInfinite = _elm_lang$core$Native_Basics.isInfinite;
var _elm_lang$core$Basics$isNaN = _elm_lang$core$Native_Basics.isNaN;
var _elm_lang$core$Basics$toFloat = _elm_lang$core$Native_Basics.toFloat;
var _elm_lang$core$Basics$ceiling = _elm_lang$core$Native_Basics.ceiling;
var _elm_lang$core$Basics$floor = _elm_lang$core$Native_Basics.floor;
var _elm_lang$core$Basics$truncate = _elm_lang$core$Native_Basics.truncate;
var _elm_lang$core$Basics$round = _elm_lang$core$Native_Basics.round;
var _elm_lang$core$Basics$not = _elm_lang$core$Native_Basics.not;
var _elm_lang$core$Basics$xor = _elm_lang$core$Native_Basics.xor;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['||'] = _elm_lang$core$Native_Basics.or;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['&&'] = _elm_lang$core$Native_Basics.and;
var _elm_lang$core$Basics$max = _elm_lang$core$Native_Basics.max;
var _elm_lang$core$Basics$min = _elm_lang$core$Native_Basics.min;
var _elm_lang$core$Basics$compare = _elm_lang$core$Native_Basics.compare;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>='] = _elm_lang$core$Native_Basics.ge;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<='] = _elm_lang$core$Native_Basics.le;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['>'] = _elm_lang$core$Native_Basics.gt;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['<'] = _elm_lang$core$Native_Basics.lt;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['/='] = _elm_lang$core$Native_Basics.neq;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['=='] = _elm_lang$core$Native_Basics.eq;
var _elm_lang$core$Basics$e = _elm_lang$core$Native_Basics.e;
var _elm_lang$core$Basics$pi = _elm_lang$core$Native_Basics.pi;
var _elm_lang$core$Basics$clamp = _elm_lang$core$Native_Basics.clamp;
var _elm_lang$core$Basics$logBase = _elm_lang$core$Native_Basics.logBase;
var _elm_lang$core$Basics$abs = _elm_lang$core$Native_Basics.abs;
var _elm_lang$core$Basics$negate = _elm_lang$core$Native_Basics.negate;
var _elm_lang$core$Basics$sqrt = _elm_lang$core$Native_Basics.sqrt;
var _elm_lang$core$Basics$atan2 = _elm_lang$core$Native_Basics.atan2;
var _elm_lang$core$Basics$atan = _elm_lang$core$Native_Basics.atan;
var _elm_lang$core$Basics$asin = _elm_lang$core$Native_Basics.asin;
var _elm_lang$core$Basics$acos = _elm_lang$core$Native_Basics.acos;
var _elm_lang$core$Basics$tan = _elm_lang$core$Native_Basics.tan;
var _elm_lang$core$Basics$sin = _elm_lang$core$Native_Basics.sin;
var _elm_lang$core$Basics$cos = _elm_lang$core$Native_Basics.cos;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['^'] = _elm_lang$core$Native_Basics.exp;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['%'] = _elm_lang$core$Native_Basics.mod;
var _elm_lang$core$Basics$rem = _elm_lang$core$Native_Basics.rem;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['//'] = _elm_lang$core$Native_Basics.div;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['/'] = _elm_lang$core$Native_Basics.floatDiv;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['*'] = _elm_lang$core$Native_Basics.mul;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['-'] = _elm_lang$core$Native_Basics.sub;
var _elm_lang$core$Basics_ops = _elm_lang$core$Basics_ops || {};
_elm_lang$core$Basics_ops['+'] = _elm_lang$core$Native_Basics.add;
var _elm_lang$core$Basics$toPolar = _elm_lang$core$Native_Basics.toPolar;
var _elm_lang$core$Basics$fromPolar = _elm_lang$core$Native_Basics.fromPolar;
var _elm_lang$core$Basics$turns = _elm_lang$core$Native_Basics.turns;
var _elm_lang$core$Basics$degrees = _elm_lang$core$Native_Basics.degrees;
var _elm_lang$core$Basics$radians = function (t) {
	return t;
};
var _elm_lang$core$Basics$GT = {ctor: 'GT'};
var _elm_lang$core$Basics$EQ = {ctor: 'EQ'};
var _elm_lang$core$Basics$LT = {ctor: 'LT'};
var _elm_lang$core$Basics$JustOneMore = function (a) {
	return {ctor: 'JustOneMore', _0: a};
};

var _elm_lang$core$Maybe$withDefault = F2(
	function ($default, maybe) {
		var _p0 = maybe;
		if (_p0.ctor === 'Just') {
			return _p0._0;
		} else {
			return $default;
		}
	});
var _elm_lang$core$Maybe$Nothing = {ctor: 'Nothing'};
var _elm_lang$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		var _p1 = maybeValue;
		if (_p1.ctor === 'Just') {
			return callback(_p1._0);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$Just = function (a) {
	return {ctor: 'Just', _0: a};
};
var _elm_lang$core$Maybe$map = F2(
	function (f, maybe) {
		var _p2 = maybe;
		if (_p2.ctor === 'Just') {
			return _elm_lang$core$Maybe$Just(
				f(_p2._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		var _p3 = {ctor: '_Tuple2', _0: ma, _1: mb};
		if (((_p3.ctor === '_Tuple2') && (_p3._0.ctor === 'Just')) && (_p3._1.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A2(func, _p3._0._0, _p3._1._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		var _p4 = {ctor: '_Tuple3', _0: ma, _1: mb, _2: mc};
		if ((((_p4.ctor === '_Tuple3') && (_p4._0.ctor === 'Just')) && (_p4._1.ctor === 'Just')) && (_p4._2.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A3(func, _p4._0._0, _p4._1._0, _p4._2._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		var _p5 = {ctor: '_Tuple4', _0: ma, _1: mb, _2: mc, _3: md};
		if (((((_p5.ctor === '_Tuple4') && (_p5._0.ctor === 'Just')) && (_p5._1.ctor === 'Just')) && (_p5._2.ctor === 'Just')) && (_p5._3.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A4(func, _p5._0._0, _p5._1._0, _p5._2._0, _p5._3._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_lang$core$Maybe$map5 = F6(
	function (func, ma, mb, mc, md, me) {
		var _p6 = {ctor: '_Tuple5', _0: ma, _1: mb, _2: mc, _3: md, _4: me};
		if ((((((_p6.ctor === '_Tuple5') && (_p6._0.ctor === 'Just')) && (_p6._1.ctor === 'Just')) && (_p6._2.ctor === 'Just')) && (_p6._3.ctor === 'Just')) && (_p6._4.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				A5(func, _p6._0._0, _p6._1._0, _p6._2._0, _p6._3._0, _p6._4._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});

//import Native.Utils //

var _elm_lang$core$Native_List = function() {

var Nil = { ctor: '[]' };

function Cons(hd, tl)
{
	return { ctor: '::', _0: hd, _1: tl };
}

function fromArray(arr)
{
	var out = Nil;
	for (var i = arr.length; i--; )
	{
		out = Cons(arr[i], out);
	}
	return out;
}

function toArray(xs)
{
	var out = [];
	while (xs.ctor !== '[]')
	{
		out.push(xs._0);
		xs = xs._1;
	}
	return out;
}

function foldr(f, b, xs)
{
	var arr = toArray(xs);
	var acc = b;
	for (var i = arr.length; i--; )
	{
		acc = A2(f, arr[i], acc);
	}
	return acc;
}

function map2(f, xs, ys)
{
	var arr = [];
	while (xs.ctor !== '[]' && ys.ctor !== '[]')
	{
		arr.push(A2(f, xs._0, ys._0));
		xs = xs._1;
		ys = ys._1;
	}
	return fromArray(arr);
}

function map3(f, xs, ys, zs)
{
	var arr = [];
	while (xs.ctor !== '[]' && ys.ctor !== '[]' && zs.ctor !== '[]')
	{
		arr.push(A3(f, xs._0, ys._0, zs._0));
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function map4(f, ws, xs, ys, zs)
{
	var arr = [];
	while (   ws.ctor !== '[]'
		   && xs.ctor !== '[]'
		   && ys.ctor !== '[]'
		   && zs.ctor !== '[]')
	{
		arr.push(A4(f, ws._0, xs._0, ys._0, zs._0));
		ws = ws._1;
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function map5(f, vs, ws, xs, ys, zs)
{
	var arr = [];
	while (   vs.ctor !== '[]'
		   && ws.ctor !== '[]'
		   && xs.ctor !== '[]'
		   && ys.ctor !== '[]'
		   && zs.ctor !== '[]')
	{
		arr.push(A5(f, vs._0, ws._0, xs._0, ys._0, zs._0));
		vs = vs._1;
		ws = ws._1;
		xs = xs._1;
		ys = ys._1;
		zs = zs._1;
	}
	return fromArray(arr);
}

function sortBy(f, xs)
{
	return fromArray(toArray(xs).sort(function(a, b) {
		return _elm_lang$core$Native_Utils.cmp(f(a), f(b));
	}));
}

function sortWith(f, xs)
{
	return fromArray(toArray(xs).sort(function(a, b) {
		var ord = f(a)(b).ctor;
		return ord === 'EQ' ? 0 : ord === 'LT' ? -1 : 1;
	}));
}

return {
	Nil: Nil,
	Cons: Cons,
	cons: F2(Cons),
	toArray: toArray,
	fromArray: fromArray,

	foldr: F3(foldr),

	map2: F3(map2),
	map3: F4(map3),
	map4: F5(map4),
	map5: F6(map5),
	sortBy: F2(sortBy),
	sortWith: F2(sortWith)
};

}();
var _elm_lang$core$List$sortWith = _elm_lang$core$Native_List.sortWith;
var _elm_lang$core$List$sortBy = _elm_lang$core$Native_List.sortBy;
var _elm_lang$core$List$sort = function (xs) {
	return A2(_elm_lang$core$List$sortBy, _elm_lang$core$Basics$identity, xs);
};
var _elm_lang$core$List$singleton = function (value) {
	return {
		ctor: '::',
		_0: value,
		_1: {ctor: '[]'}
	};
};
var _elm_lang$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return list;
			} else {
				var _p0 = list;
				if (_p0.ctor === '[]') {
					return list;
				} else {
					var _v1 = n - 1,
						_v2 = _p0._1;
					n = _v1;
					list = _v2;
					continue drop;
				}
			}
		}
	});
var _elm_lang$core$List$map5 = _elm_lang$core$Native_List.map5;
var _elm_lang$core$List$map4 = _elm_lang$core$Native_List.map4;
var _elm_lang$core$List$map3 = _elm_lang$core$Native_List.map3;
var _elm_lang$core$List$map2 = _elm_lang$core$Native_List.map2;
var _elm_lang$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			var _p1 = list;
			if (_p1.ctor === '[]') {
				return false;
			} else {
				if (isOkay(_p1._0)) {
					return true;
				} else {
					var _v4 = isOkay,
						_v5 = _p1._1;
					isOkay = _v4;
					list = _v5;
					continue any;
				}
			}
		}
	});
var _elm_lang$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			_elm_lang$core$List$any,
			function (_p2) {
				return !isOkay(_p2);
			},
			list);
	});
var _elm_lang$core$List$foldr = _elm_lang$core$Native_List.foldr;
var _elm_lang$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			var _p3 = list;
			if (_p3.ctor === '[]') {
				return acc;
			} else {
				var _v7 = func,
					_v8 = A2(func, _p3._0, acc),
					_v9 = _p3._1;
				func = _v7;
				acc = _v8;
				list = _v9;
				continue foldl;
			}
		}
	});
var _elm_lang$core$List$length = function (xs) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (_p4, i) {
				return i + 1;
			}),
		0,
		xs);
};
var _elm_lang$core$List$sum = function (numbers) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return x + y;
			}),
		0,
		numbers);
};
var _elm_lang$core$List$product = function (numbers) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return x * y;
			}),
		1,
		numbers);
};
var _elm_lang$core$List$maximum = function (list) {
	var _p5 = list;
	if (_p5.ctor === '::') {
		return _elm_lang$core$Maybe$Just(
			A3(_elm_lang$core$List$foldl, _elm_lang$core$Basics$max, _p5._0, _p5._1));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$minimum = function (list) {
	var _p6 = list;
	if (_p6.ctor === '::') {
		return _elm_lang$core$Maybe$Just(
			A3(_elm_lang$core$List$foldl, _elm_lang$core$Basics$min, _p6._0, _p6._1));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$member = F2(
	function (x, xs) {
		return A2(
			_elm_lang$core$List$any,
			function (a) {
				return _elm_lang$core$Native_Utils.eq(a, x);
			},
			xs);
	});
var _elm_lang$core$List$isEmpty = function (xs) {
	var _p7 = xs;
	if (_p7.ctor === '[]') {
		return true;
	} else {
		return false;
	}
};
var _elm_lang$core$List$tail = function (list) {
	var _p8 = list;
	if (_p8.ctor === '::') {
		return _elm_lang$core$Maybe$Just(_p8._1);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List$head = function (list) {
	var _p9 = list;
	if (_p9.ctor === '::') {
		return _elm_lang$core$Maybe$Just(_p9._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$List_ops = _elm_lang$core$List_ops || {};
_elm_lang$core$List_ops['::'] = _elm_lang$core$Native_List.cons;
var _elm_lang$core$List$map = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldr,
			F2(
				function (x, acc) {
					return {
						ctor: '::',
						_0: f(x),
						_1: acc
					};
				}),
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$filter = F2(
	function (pred, xs) {
		var conditionalCons = F2(
			function (front, back) {
				return pred(front) ? {ctor: '::', _0: front, _1: back} : back;
			});
		return A3(
			_elm_lang$core$List$foldr,
			conditionalCons,
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _p10 = f(mx);
		if (_p10.ctor === 'Just') {
			return {ctor: '::', _0: _p10._0, _1: xs};
		} else {
			return xs;
		}
	});
var _elm_lang$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$foldr,
			_elm_lang$core$List$maybeCons(f),
			{ctor: '[]'},
			xs);
	});
var _elm_lang$core$List$reverse = function (list) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			}),
		{ctor: '[]'},
		list);
};
var _elm_lang$core$List$scanl = F3(
	function (f, b, xs) {
		var scan1 = F2(
			function (x, accAcc) {
				var _p11 = accAcc;
				if (_p11.ctor === '::') {
					return {
						ctor: '::',
						_0: A2(f, x, _p11._0),
						_1: accAcc
					};
				} else {
					return {ctor: '[]'};
				}
			});
		return _elm_lang$core$List$reverse(
			A3(
				_elm_lang$core$List$foldl,
				scan1,
				{
					ctor: '::',
					_0: b,
					_1: {ctor: '[]'}
				},
				xs));
	});
var _elm_lang$core$List$append = F2(
	function (xs, ys) {
		var _p12 = ys;
		if (_p12.ctor === '[]') {
			return xs;
		} else {
			return A3(
				_elm_lang$core$List$foldr,
				F2(
					function (x, y) {
						return {ctor: '::', _0: x, _1: y};
					}),
				ys,
				xs);
		}
	});
var _elm_lang$core$List$concat = function (lists) {
	return A3(
		_elm_lang$core$List$foldr,
		_elm_lang$core$List$append,
		{ctor: '[]'},
		lists);
};
var _elm_lang$core$List$concatMap = F2(
	function (f, list) {
		return _elm_lang$core$List$concat(
			A2(_elm_lang$core$List$map, f, list));
	});
var _elm_lang$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _p13) {
				var _p14 = _p13;
				var _p16 = _p14._0;
				var _p15 = _p14._1;
				return pred(x) ? {
					ctor: '_Tuple2',
					_0: {ctor: '::', _0: x, _1: _p16},
					_1: _p15
				} : {
					ctor: '_Tuple2',
					_0: _p16,
					_1: {ctor: '::', _0: x, _1: _p15}
				};
			});
		return A3(
			_elm_lang$core$List$foldr,
			step,
			{
				ctor: '_Tuple2',
				_0: {ctor: '[]'},
				_1: {ctor: '[]'}
			},
			list);
	});
var _elm_lang$core$List$unzip = function (pairs) {
	var step = F2(
		function (_p18, _p17) {
			var _p19 = _p18;
			var _p20 = _p17;
			return {
				ctor: '_Tuple2',
				_0: {ctor: '::', _0: _p19._0, _1: _p20._0},
				_1: {ctor: '::', _0: _p19._1, _1: _p20._1}
			};
		});
	return A3(
		_elm_lang$core$List$foldr,
		step,
		{
			ctor: '_Tuple2',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'}
		},
		pairs);
};
var _elm_lang$core$List$intersperse = F2(
	function (sep, xs) {
		var _p21 = xs;
		if (_p21.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var step = F2(
				function (x, rest) {
					return {
						ctor: '::',
						_0: sep,
						_1: {ctor: '::', _0: x, _1: rest}
					};
				});
			var spersed = A3(
				_elm_lang$core$List$foldr,
				step,
				{ctor: '[]'},
				_p21._1);
			return {ctor: '::', _0: _p21._0, _1: spersed};
		}
	});
var _elm_lang$core$List$takeReverse = F3(
	function (n, list, taken) {
		takeReverse:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return taken;
			} else {
				var _p22 = list;
				if (_p22.ctor === '[]') {
					return taken;
				} else {
					var _v23 = n - 1,
						_v24 = _p22._1,
						_v25 = {ctor: '::', _0: _p22._0, _1: taken};
					n = _v23;
					list = _v24;
					taken = _v25;
					continue takeReverse;
				}
			}
		}
	});
var _elm_lang$core$List$takeTailRec = F2(
	function (n, list) {
		return _elm_lang$core$List$reverse(
			A3(
				_elm_lang$core$List$takeReverse,
				n,
				list,
				{ctor: '[]'}));
	});
var _elm_lang$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
			return {ctor: '[]'};
		} else {
			var _p23 = {ctor: '_Tuple2', _0: n, _1: list};
			_v26_5:
			do {
				_v26_1:
				do {
					if (_p23.ctor === '_Tuple2') {
						if (_p23._1.ctor === '[]') {
							return list;
						} else {
							if (_p23._1._1.ctor === '::') {
								switch (_p23._0) {
									case 1:
										break _v26_1;
									case 2:
										return {
											ctor: '::',
											_0: _p23._1._0,
											_1: {
												ctor: '::',
												_0: _p23._1._1._0,
												_1: {ctor: '[]'}
											}
										};
									case 3:
										if (_p23._1._1._1.ctor === '::') {
											return {
												ctor: '::',
												_0: _p23._1._0,
												_1: {
													ctor: '::',
													_0: _p23._1._1._0,
													_1: {
														ctor: '::',
														_0: _p23._1._1._1._0,
														_1: {ctor: '[]'}
													}
												}
											};
										} else {
											break _v26_5;
										}
									default:
										if ((_p23._1._1._1.ctor === '::') && (_p23._1._1._1._1.ctor === '::')) {
											var _p28 = _p23._1._1._1._0;
											var _p27 = _p23._1._1._0;
											var _p26 = _p23._1._0;
											var _p25 = _p23._1._1._1._1._0;
											var _p24 = _p23._1._1._1._1._1;
											return (_elm_lang$core$Native_Utils.cmp(ctr, 1000) > 0) ? {
												ctor: '::',
												_0: _p26,
												_1: {
													ctor: '::',
													_0: _p27,
													_1: {
														ctor: '::',
														_0: _p28,
														_1: {
															ctor: '::',
															_0: _p25,
															_1: A2(_elm_lang$core$List$takeTailRec, n - 4, _p24)
														}
													}
												}
											} : {
												ctor: '::',
												_0: _p26,
												_1: {
													ctor: '::',
													_0: _p27,
													_1: {
														ctor: '::',
														_0: _p28,
														_1: {
															ctor: '::',
															_0: _p25,
															_1: A3(_elm_lang$core$List$takeFast, ctr + 1, n - 4, _p24)
														}
													}
												}
											};
										} else {
											break _v26_5;
										}
								}
							} else {
								if (_p23._0 === 1) {
									break _v26_1;
								} else {
									break _v26_5;
								}
							}
						}
					} else {
						break _v26_5;
					}
				} while(false);
				return {
					ctor: '::',
					_0: _p23._1._0,
					_1: {ctor: '[]'}
				};
			} while(false);
			return list;
		}
	});
var _elm_lang$core$List$take = F2(
	function (n, list) {
		return A3(_elm_lang$core$List$takeFast, 0, n, list);
	});
var _elm_lang$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return result;
			} else {
				var _v27 = {ctor: '::', _0: value, _1: result},
					_v28 = n - 1,
					_v29 = value;
				result = _v27;
				n = _v28;
				value = _v29;
				continue repeatHelp;
			}
		}
	});
var _elm_lang$core$List$repeat = F2(
	function (n, value) {
		return A3(
			_elm_lang$core$List$repeatHelp,
			{ctor: '[]'},
			n,
			value);
	});
var _elm_lang$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(lo, hi) < 1) {
				var _v30 = lo,
					_v31 = hi - 1,
					_v32 = {ctor: '::', _0: hi, _1: list};
				lo = _v30;
				hi = _v31;
				list = _v32;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var _elm_lang$core$List$range = F2(
	function (lo, hi) {
		return A3(
			_elm_lang$core$List$rangeHelp,
			lo,
			hi,
			{ctor: '[]'});
	});
var _elm_lang$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			_elm_lang$core$List$map2,
			f,
			A2(
				_elm_lang$core$List$range,
				0,
				_elm_lang$core$List$length(xs) - 1),
			xs);
	});

//import Native.Utils //

var _elm_lang$core$Native_Scheduler = function() {

var MAX_STEPS = 10000;


// TASKS

function succeed(value)
{
	return {
		ctor: '_Task_succeed',
		value: value
	};
}

function fail(error)
{
	return {
		ctor: '_Task_fail',
		value: error
	};
}

function nativeBinding(callback)
{
	return {
		ctor: '_Task_nativeBinding',
		callback: callback,
		cancel: null
	};
}

function andThen(callback, task)
{
	return {
		ctor: '_Task_andThen',
		callback: callback,
		task: task
	};
}

function onError(callback, task)
{
	return {
		ctor: '_Task_onError',
		callback: callback,
		task: task
	};
}

function receive(callback)
{
	return {
		ctor: '_Task_receive',
		callback: callback
	};
}


// PROCESSES

function rawSpawn(task)
{
	var process = {
		ctor: '_Process',
		id: _elm_lang$core$Native_Utils.guid(),
		root: task,
		stack: null,
		mailbox: []
	};

	enqueue(process);

	return process;
}

function spawn(task)
{
	return nativeBinding(function(callback) {
		var process = rawSpawn(task);
		callback(succeed(process));
	});
}

function rawSend(process, msg)
{
	process.mailbox.push(msg);
	enqueue(process);
}

function send(process, msg)
{
	return nativeBinding(function(callback) {
		rawSend(process, msg);
		callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function kill(process)
{
	return nativeBinding(function(callback) {
		var root = process.root;
		if (root.ctor === '_Task_nativeBinding' && root.cancel)
		{
			root.cancel();
		}

		process.root = null;

		callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function sleep(time)
{
	return nativeBinding(function(callback) {
		var id = setTimeout(function() {
			callback(succeed(_elm_lang$core$Native_Utils.Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}


// STEP PROCESSES

function step(numSteps, process)
{
	while (numSteps < MAX_STEPS)
	{
		var ctor = process.root.ctor;

		if (ctor === '_Task_succeed')
		{
			while (process.stack && process.stack.ctor === '_Task_onError')
			{
				process.stack = process.stack.rest;
			}
			if (process.stack === null)
			{
				break;
			}
			process.root = process.stack.callback(process.root.value);
			process.stack = process.stack.rest;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_fail')
		{
			while (process.stack && process.stack.ctor === '_Task_andThen')
			{
				process.stack = process.stack.rest;
			}
			if (process.stack === null)
			{
				break;
			}
			process.root = process.stack.callback(process.root.value);
			process.stack = process.stack.rest;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_andThen')
		{
			process.stack = {
				ctor: '_Task_andThen',
				callback: process.root.callback,
				rest: process.stack
			};
			process.root = process.root.task;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_onError')
		{
			process.stack = {
				ctor: '_Task_onError',
				callback: process.root.callback,
				rest: process.stack
			};
			process.root = process.root.task;
			++numSteps;
			continue;
		}

		if (ctor === '_Task_nativeBinding')
		{
			process.root.cancel = process.root.callback(function(newRoot) {
				process.root = newRoot;
				enqueue(process);
			});

			break;
		}

		if (ctor === '_Task_receive')
		{
			var mailbox = process.mailbox;
			if (mailbox.length === 0)
			{
				break;
			}

			process.root = process.root.callback(mailbox.shift());
			++numSteps;
			continue;
		}

		throw new Error(ctor);
	}

	if (numSteps < MAX_STEPS)
	{
		return numSteps + 1;
	}
	enqueue(process);

	return numSteps;
}


// WORK QUEUE

var working = false;
var workQueue = [];

function enqueue(process)
{
	workQueue.push(process);

	if (!working)
	{
		setTimeout(work, 0);
		working = true;
	}
}

function work()
{
	var numSteps = 0;
	var process;
	while (numSteps < MAX_STEPS && (process = workQueue.shift()))
	{
		if (process.root)
		{
			numSteps = step(numSteps, process);
		}
	}
	if (!process)
	{
		working = false;
		return;
	}
	setTimeout(work, 0);
}


return {
	succeed: succeed,
	fail: fail,
	nativeBinding: nativeBinding,
	andThen: F2(andThen),
	onError: F2(onError),
	receive: receive,

	spawn: spawn,
	kill: kill,
	sleep: sleep,
	send: F2(send),

	rawSpawn: rawSpawn,
	rawSend: rawSend
};

}();
//import //

var _elm_lang$core$Native_Platform = function() {


// PROGRAMS

function program(impl)
{
	return function(flagDecoder)
	{
		return function(object, moduleName)
		{
			object['worker'] = function worker(flags)
			{
				if (typeof flags !== 'undefined')
				{
					throw new Error(
						'The `' + moduleName + '` module does not need flags.\n'
						+ 'Call ' + moduleName + '.worker() with no arguments and you should be all set!'
					);
				}

				return initialize(
					impl.init,
					impl.update,
					impl.subscriptions,
					renderer
				);
			};
		};
	};
}

function programWithFlags(impl)
{
	return function(flagDecoder)
	{
		return function(object, moduleName)
		{
			object['worker'] = function worker(flags)
			{
				if (typeof flagDecoder === 'undefined')
				{
					throw new Error(
						'Are you trying to sneak a Never value into Elm? Trickster!\n'
						+ 'It looks like ' + moduleName + '.main is defined with `programWithFlags` but has type `Program Never`.\n'
						+ 'Use `program` instead if you do not want flags.'
					);
				}

				var result = A2(_elm_lang$core$Native_Json.run, flagDecoder, flags);
				if (result.ctor === 'Err')
				{
					throw new Error(
						moduleName + '.worker(...) was called with an unexpected argument.\n'
						+ 'I tried to convert it to an Elm value, but ran into this problem:\n\n'
						+ result._0
					);
				}

				return initialize(
					impl.init(result._0),
					impl.update,
					impl.subscriptions,
					renderer
				);
			};
		};
	};
}

function renderer(enqueue, _)
{
	return function(_) {};
}


// HTML TO PROGRAM

function htmlToProgram(vnode)
{
	var emptyBag = batch(_elm_lang$core$Native_List.Nil);
	var noChange = _elm_lang$core$Native_Utils.Tuple2(
		_elm_lang$core$Native_Utils.Tuple0,
		emptyBag
	);

	return _elm_lang$virtual_dom$VirtualDom$program({
		init: noChange,
		view: function(model) { return main; },
		update: F2(function(msg, model) { return noChange; }),
		subscriptions: function (model) { return emptyBag; }
	});
}


// INITIALIZE A PROGRAM

function initialize(init, update, subscriptions, renderer)
{
	// ambient state
	var managers = {};
	var updateView;

	// init and update state in main process
	var initApp = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {
		var model = init._0;
		updateView = renderer(enqueue, model);
		var cmds = init._1;
		var subs = subscriptions(model);
		dispatchEffects(managers, cmds, subs);
		callback(_elm_lang$core$Native_Scheduler.succeed(model));
	});

	function onMessage(msg, model)
	{
		return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {
			var results = A2(update, msg, model);
			model = results._0;
			updateView(model);
			var cmds = results._1;
			var subs = subscriptions(model);
			dispatchEffects(managers, cmds, subs);
			callback(_elm_lang$core$Native_Scheduler.succeed(model));
		});
	}

	var mainProcess = spawnLoop(initApp, onMessage);

	function enqueue(msg)
	{
		_elm_lang$core$Native_Scheduler.rawSend(mainProcess, msg);
	}

	var ports = setupEffects(managers, enqueue);

	return ports ? { ports: ports } : {};
}


// EFFECT MANAGERS

var effectManagers = {};

function setupEffects(managers, callback)
{
	var ports;

	// setup all necessary effect managers
	for (var key in effectManagers)
	{
		var manager = effectManagers[key];

		if (manager.isForeign)
		{
			ports = ports || {};
			ports[key] = manager.tag === 'cmd'
				? setupOutgoingPort(key)
				: setupIncomingPort(key, callback);
		}

		managers[key] = makeManager(manager, callback);
	}

	return ports;
}

function makeManager(info, callback)
{
	var router = {
		main: callback,
		self: undefined
	};

	var tag = info.tag;
	var onEffects = info.onEffects;
	var onSelfMsg = info.onSelfMsg;

	function onMessage(msg, state)
	{
		if (msg.ctor === 'self')
		{
			return A3(onSelfMsg, router, msg._0, state);
		}

		var fx = msg._0;
		switch (tag)
		{
			case 'cmd':
				return A3(onEffects, router, fx.cmds, state);

			case 'sub':
				return A3(onEffects, router, fx.subs, state);

			case 'fx':
				return A4(onEffects, router, fx.cmds, fx.subs, state);
		}
	}

	var process = spawnLoop(info.init, onMessage);
	router.self = process;
	return process;
}

function sendToApp(router, msg)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		router.main(msg);
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function sendToSelf(router, msg)
{
	return A2(_elm_lang$core$Native_Scheduler.send, router.self, {
		ctor: 'self',
		_0: msg
	});
}


// HELPER for STATEFUL LOOPS

function spawnLoop(init, onMessage)
{
	var andThen = _elm_lang$core$Native_Scheduler.andThen;

	function loop(state)
	{
		var handleMsg = _elm_lang$core$Native_Scheduler.receive(function(msg) {
			return onMessage(msg, state);
		});
		return A2(andThen, loop, handleMsg);
	}

	var task = A2(andThen, loop, init);

	return _elm_lang$core$Native_Scheduler.rawSpawn(task);
}


// BAGS

function leaf(home)
{
	return function(value)
	{
		return {
			type: 'leaf',
			home: home,
			value: value
		};
	};
}

function batch(list)
{
	return {
		type: 'node',
		branches: list
	};
}

function map(tagger, bag)
{
	return {
		type: 'map',
		tagger: tagger,
		tree: bag
	}
}


// PIPE BAGS INTO EFFECT MANAGERS

function dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	gatherEffects(true, cmdBag, effectsDict, null);
	gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		var fx = home in effectsDict
			? effectsDict[home]
			: {
				cmds: _elm_lang$core$Native_List.Nil,
				subs: _elm_lang$core$Native_List.Nil
			};

		_elm_lang$core$Native_Scheduler.rawSend(managers[home], { ctor: 'fx', _0: fx });
	}
}

function gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.type)
	{
		case 'leaf':
			var home = bag.home;
			var effect = toEffect(isCmd, home, taggers, bag.value);
			effectsDict[home] = insert(isCmd, effect, effectsDict[home]);
			return;

		case 'node':
			var list = bag.branches;
			while (list.ctor !== '[]')
			{
				gatherEffects(isCmd, list._0, effectsDict, taggers);
				list = list._1;
			}
			return;

		case 'map':
			gatherEffects(isCmd, bag.tree, effectsDict, {
				tagger: bag.tagger,
				rest: taggers
			});
			return;
	}
}

function toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		var temp = taggers;
		while (temp)
		{
			x = temp.tagger(x);
			temp = temp.rest;
		}
		return x;
	}

	var map = isCmd
		? effectManagers[home].cmdMap
		: effectManagers[home].subMap;

	return A2(map, applyTaggers, value)
}

function insert(isCmd, newEffect, effects)
{
	effects = effects || {
		cmds: _elm_lang$core$Native_List.Nil,
		subs: _elm_lang$core$Native_List.Nil
	};
	if (isCmd)
	{
		effects.cmds = _elm_lang$core$Native_List.Cons(newEffect, effects.cmds);
		return effects;
	}
	effects.subs = _elm_lang$core$Native_List.Cons(newEffect, effects.subs);
	return effects;
}


// PORTS

function checkPortName(name)
{
	if (name in effectManagers)
	{
		throw new Error('There can only be one port named `' + name + '`, but your program has multiple.');
	}
}


// OUTGOING PORTS

function outgoingPort(name, converter)
{
	checkPortName(name);
	effectManagers[name] = {
		tag: 'cmd',
		cmdMap: outgoingPortMap,
		converter: converter,
		isForeign: true
	};
	return leaf(name);
}

var outgoingPortMap = F2(function cmdMap(tagger, value) {
	return value;
});

function setupOutgoingPort(name)
{
	var subs = [];
	var converter = effectManagers[name].converter;

	// CREATE MANAGER

	var init = _elm_lang$core$Native_Scheduler.succeed(null);

	function onEffects(router, cmdList, state)
	{
		while (cmdList.ctor !== '[]')
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = converter(cmdList._0);
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
			cmdList = cmdList._1;
		}
		return init;
	}

	effectManagers[name].init = init;
	effectManagers[name].onEffects = F3(onEffects);

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}


// INCOMING PORTS

function incomingPort(name, converter)
{
	checkPortName(name);
	effectManagers[name] = {
		tag: 'sub',
		subMap: incomingPortMap,
		converter: converter,
		isForeign: true
	};
	return leaf(name);
}

var incomingPortMap = F2(function subMap(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});

function setupIncomingPort(name, callback)
{
	var sentBeforeInit = [];
	var subs = _elm_lang$core$Native_List.Nil;
	var converter = effectManagers[name].converter;
	var currentOnEffects = preInitOnEffects;
	var currentSend = preInitSend;

	// CREATE MANAGER

	var init = _elm_lang$core$Native_Scheduler.succeed(null);

	function preInitOnEffects(router, subList, state)
	{
		var postInitResult = postInitOnEffects(router, subList, state);

		for(var i = 0; i < sentBeforeInit.length; i++)
		{
			postInitSend(sentBeforeInit[i]);
		}

		sentBeforeInit = null; // to release objects held in queue
		currentSend = postInitSend;
		currentOnEffects = postInitOnEffects;
		return postInitResult;
	}

	function postInitOnEffects(router, subList, state)
	{
		subs = subList;
		return init;
	}

	function onEffects(router, subList, state)
	{
		return currentOnEffects(router, subList, state);
	}

	effectManagers[name].init = init;
	effectManagers[name].onEffects = F3(onEffects);

	// PUBLIC API

	function preInitSend(value)
	{
		sentBeforeInit.push(value);
	}

	function postInitSend(value)
	{
		var temp = subs;
		while (temp.ctor !== '[]')
		{
			callback(temp._0(value));
			temp = temp._1;
		}
	}

	function send(incomingValue)
	{
		var result = A2(_elm_lang$core$Json_Decode$decodeValue, converter, incomingValue);
		if (result.ctor === 'Err')
		{
			throw new Error('Trying to send an unexpected type of value through port `' + name + '`:\n' + result._0);
		}

		currentSend(result._0);
	}

	return { send: send };
}

return {
	// routers
	sendToApp: F2(sendToApp),
	sendToSelf: F2(sendToSelf),

	// global setup
	effectManagers: effectManagers,
	outgoingPort: outgoingPort,
	incomingPort: incomingPort,

	htmlToProgram: htmlToProgram,
	program: program,
	programWithFlags: programWithFlags,
	initialize: initialize,

	// effect bags
	leaf: leaf,
	batch: batch,
	map: F2(map)
};

}();

var _elm_lang$core$Platform_Cmd$batch = _elm_lang$core$Native_Platform.batch;
var _elm_lang$core$Platform_Cmd$none = _elm_lang$core$Platform_Cmd$batch(
	{ctor: '[]'});
var _elm_lang$core$Platform_Cmd_ops = _elm_lang$core$Platform_Cmd_ops || {};
_elm_lang$core$Platform_Cmd_ops['!'] = F2(
	function (model, commands) {
		return {
			ctor: '_Tuple2',
			_0: model,
			_1: _elm_lang$core$Platform_Cmd$batch(commands)
		};
	});
var _elm_lang$core$Platform_Cmd$map = _elm_lang$core$Native_Platform.map;
var _elm_lang$core$Platform_Cmd$Cmd = {ctor: 'Cmd'};

var _elm_lang$core$Platform_Sub$batch = _elm_lang$core$Native_Platform.batch;
var _elm_lang$core$Platform_Sub$none = _elm_lang$core$Platform_Sub$batch(
	{ctor: '[]'});
var _elm_lang$core$Platform_Sub$map = _elm_lang$core$Native_Platform.map;
var _elm_lang$core$Platform_Sub$Sub = {ctor: 'Sub'};

var _elm_lang$core$Platform$hack = _elm_lang$core$Native_Scheduler.succeed;
var _elm_lang$core$Platform$sendToSelf = _elm_lang$core$Native_Platform.sendToSelf;
var _elm_lang$core$Platform$sendToApp = _elm_lang$core$Native_Platform.sendToApp;
var _elm_lang$core$Platform$programWithFlags = _elm_lang$core$Native_Platform.programWithFlags;
var _elm_lang$core$Platform$program = _elm_lang$core$Native_Platform.program;
var _elm_lang$core$Platform$Program = {ctor: 'Program'};
var _elm_lang$core$Platform$Task = {ctor: 'Task'};
var _elm_lang$core$Platform$ProcessId = {ctor: 'ProcessId'};
var _elm_lang$core$Platform$Router = {ctor: 'Router'};

var _elm_lang$core$Result$toMaybe = function (result) {
	var _p0 = result;
	if (_p0.ctor === 'Ok') {
		return _elm_lang$core$Maybe$Just(_p0._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _elm_lang$core$Result$withDefault = F2(
	function (def, result) {
		var _p1 = result;
		if (_p1.ctor === 'Ok') {
			return _p1._0;
		} else {
			return def;
		}
	});
var _elm_lang$core$Result$Err = function (a) {
	return {ctor: 'Err', _0: a};
};
var _elm_lang$core$Result$andThen = F2(
	function (callback, result) {
		var _p2 = result;
		if (_p2.ctor === 'Ok') {
			return callback(_p2._0);
		} else {
			return _elm_lang$core$Result$Err(_p2._0);
		}
	});
var _elm_lang$core$Result$Ok = function (a) {
	return {ctor: 'Ok', _0: a};
};
var _elm_lang$core$Result$map = F2(
	function (func, ra) {
		var _p3 = ra;
		if (_p3.ctor === 'Ok') {
			return _elm_lang$core$Result$Ok(
				func(_p3._0));
		} else {
			return _elm_lang$core$Result$Err(_p3._0);
		}
	});
var _elm_lang$core$Result$map2 = F3(
	function (func, ra, rb) {
		var _p4 = {ctor: '_Tuple2', _0: ra, _1: rb};
		if (_p4._0.ctor === 'Ok') {
			if (_p4._1.ctor === 'Ok') {
				return _elm_lang$core$Result$Ok(
					A2(func, _p4._0._0, _p4._1._0));
			} else {
				return _elm_lang$core$Result$Err(_p4._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p4._0._0);
		}
	});
var _elm_lang$core$Result$map3 = F4(
	function (func, ra, rb, rc) {
		var _p5 = {ctor: '_Tuple3', _0: ra, _1: rb, _2: rc};
		if (_p5._0.ctor === 'Ok') {
			if (_p5._1.ctor === 'Ok') {
				if (_p5._2.ctor === 'Ok') {
					return _elm_lang$core$Result$Ok(
						A3(func, _p5._0._0, _p5._1._0, _p5._2._0));
				} else {
					return _elm_lang$core$Result$Err(_p5._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p5._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p5._0._0);
		}
	});
var _elm_lang$core$Result$map4 = F5(
	function (func, ra, rb, rc, rd) {
		var _p6 = {ctor: '_Tuple4', _0: ra, _1: rb, _2: rc, _3: rd};
		if (_p6._0.ctor === 'Ok') {
			if (_p6._1.ctor === 'Ok') {
				if (_p6._2.ctor === 'Ok') {
					if (_p6._3.ctor === 'Ok') {
						return _elm_lang$core$Result$Ok(
							A4(func, _p6._0._0, _p6._1._0, _p6._2._0, _p6._3._0));
					} else {
						return _elm_lang$core$Result$Err(_p6._3._0);
					}
				} else {
					return _elm_lang$core$Result$Err(_p6._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p6._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p6._0._0);
		}
	});
var _elm_lang$core$Result$map5 = F6(
	function (func, ra, rb, rc, rd, re) {
		var _p7 = {ctor: '_Tuple5', _0: ra, _1: rb, _2: rc, _3: rd, _4: re};
		if (_p7._0.ctor === 'Ok') {
			if (_p7._1.ctor === 'Ok') {
				if (_p7._2.ctor === 'Ok') {
					if (_p7._3.ctor === 'Ok') {
						if (_p7._4.ctor === 'Ok') {
							return _elm_lang$core$Result$Ok(
								A5(func, _p7._0._0, _p7._1._0, _p7._2._0, _p7._3._0, _p7._4._0));
						} else {
							return _elm_lang$core$Result$Err(_p7._4._0);
						}
					} else {
						return _elm_lang$core$Result$Err(_p7._3._0);
					}
				} else {
					return _elm_lang$core$Result$Err(_p7._2._0);
				}
			} else {
				return _elm_lang$core$Result$Err(_p7._1._0);
			}
		} else {
			return _elm_lang$core$Result$Err(_p7._0._0);
		}
	});
var _elm_lang$core$Result$mapError = F2(
	function (f, result) {
		var _p8 = result;
		if (_p8.ctor === 'Ok') {
			return _elm_lang$core$Result$Ok(_p8._0);
		} else {
			return _elm_lang$core$Result$Err(
				f(_p8._0));
		}
	});
var _elm_lang$core$Result$fromMaybe = F2(
	function (err, maybe) {
		var _p9 = maybe;
		if (_p9.ctor === 'Just') {
			return _elm_lang$core$Result$Ok(_p9._0);
		} else {
			return _elm_lang$core$Result$Err(err);
		}
	});

var _elm_lang$core$Task$onError = _elm_lang$core$Native_Scheduler.onError;
var _elm_lang$core$Task$andThen = _elm_lang$core$Native_Scheduler.andThen;
var _elm_lang$core$Task$spawnCmd = F2(
	function (router, _p0) {
		var _p1 = _p0;
		return _elm_lang$core$Native_Scheduler.spawn(
			A2(
				_elm_lang$core$Task$andThen,
				_elm_lang$core$Platform$sendToApp(router),
				_p1._0));
	});
var _elm_lang$core$Task$fail = _elm_lang$core$Native_Scheduler.fail;
var _elm_lang$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			_elm_lang$core$Task$onError,
			function (_p2) {
				return _elm_lang$core$Task$fail(
					convert(_p2));
			},
			task);
	});
var _elm_lang$core$Task$succeed = _elm_lang$core$Native_Scheduler.succeed;
var _elm_lang$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return _elm_lang$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var _elm_lang$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return _elm_lang$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return _elm_lang$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map4 = F5(
	function (func, taskA, taskB, taskC, taskD) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return A2(
									_elm_lang$core$Task$andThen,
									function (d) {
										return _elm_lang$core$Task$succeed(
											A4(func, a, b, c, d));
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$map5 = F6(
	function (func, taskA, taskB, taskC, taskD, taskE) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (a) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (b) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (c) {
								return A2(
									_elm_lang$core$Task$andThen,
									function (d) {
										return A2(
											_elm_lang$core$Task$andThen,
											function (e) {
												return _elm_lang$core$Task$succeed(
													A5(func, a, b, c, d, e));
											},
											taskE);
									},
									taskD);
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var _elm_lang$core$Task$sequence = function (tasks) {
	var _p3 = tasks;
	if (_p3.ctor === '[]') {
		return _elm_lang$core$Task$succeed(
			{ctor: '[]'});
	} else {
		return A3(
			_elm_lang$core$Task$map2,
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				}),
			_p3._0,
			_elm_lang$core$Task$sequence(_p3._1));
	}
};
var _elm_lang$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			_elm_lang$core$Task$map,
			function (_p4) {
				return {ctor: '_Tuple0'};
			},
			_elm_lang$core$Task$sequence(
				A2(
					_elm_lang$core$List$map,
					_elm_lang$core$Task$spawnCmd(router),
					commands)));
	});
var _elm_lang$core$Task$init = _elm_lang$core$Task$succeed(
	{ctor: '_Tuple0'});
var _elm_lang$core$Task$onSelfMsg = F3(
	function (_p7, _p6, _p5) {
		return _elm_lang$core$Task$succeed(
			{ctor: '_Tuple0'});
	});
var _elm_lang$core$Task$command = _elm_lang$core$Native_Platform.leaf('Task');
var _elm_lang$core$Task$Perform = function (a) {
	return {ctor: 'Perform', _0: a};
};
var _elm_lang$core$Task$perform = F2(
	function (toMessage, task) {
		return _elm_lang$core$Task$command(
			_elm_lang$core$Task$Perform(
				A2(_elm_lang$core$Task$map, toMessage, task)));
	});
var _elm_lang$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return _elm_lang$core$Task$command(
			_elm_lang$core$Task$Perform(
				A2(
					_elm_lang$core$Task$onError,
					function (_p8) {
						return _elm_lang$core$Task$succeed(
							resultToMessage(
								_elm_lang$core$Result$Err(_p8)));
					},
					A2(
						_elm_lang$core$Task$andThen,
						function (_p9) {
							return _elm_lang$core$Task$succeed(
								resultToMessage(
									_elm_lang$core$Result$Ok(_p9)));
						},
						task))));
	});
var _elm_lang$core$Task$cmdMap = F2(
	function (tagger, _p10) {
		var _p11 = _p10;
		return _elm_lang$core$Task$Perform(
			A2(_elm_lang$core$Task$map, tagger, _p11._0));
	});
_elm_lang$core$Native_Platform.effectManagers['Task'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Task$init, onEffects: _elm_lang$core$Task$onEffects, onSelfMsg: _elm_lang$core$Task$onSelfMsg, tag: 'cmd', cmdMap: _elm_lang$core$Task$cmdMap};

//import Native.Utils //

var _elm_lang$core$Native_Debug = function() {

function log(tag, value)
{
	var msg = tag + ': ' + _elm_lang$core$Native_Utils.toString(value);
	var process = process || {};
	if (process.stdout)
	{
		process.stdout.write(msg);
	}
	else
	{
		console.log(msg);
	}
	return value;
}

function crash(message)
{
	throw new Error(message);
}

return {
	crash: crash,
	log: F2(log)
};

}();
//import Maybe, Native.List, Native.Utils, Result //

var _elm_lang$core$Native_String = function() {

function isEmpty(str)
{
	return str.length === 0;
}
function cons(chr, str)
{
	return chr + str;
}
function uncons(str)
{
	var hd = str[0];
	if (hd)
	{
		return _elm_lang$core$Maybe$Just(_elm_lang$core$Native_Utils.Tuple2(_elm_lang$core$Native_Utils.chr(hd), str.slice(1)));
	}
	return _elm_lang$core$Maybe$Nothing;
}
function append(a, b)
{
	return a + b;
}
function concat(strs)
{
	return _elm_lang$core$Native_List.toArray(strs).join('');
}
function length(str)
{
	return str.length;
}
function map(f, str)
{
	var out = str.split('');
	for (var i = out.length; i--; )
	{
		out[i] = f(_elm_lang$core$Native_Utils.chr(out[i]));
	}
	return out.join('');
}
function filter(pred, str)
{
	return str.split('').map(_elm_lang$core$Native_Utils.chr).filter(pred).join('');
}
function reverse(str)
{
	return str.split('').reverse().join('');
}
function foldl(f, b, str)
{
	var len = str.length;
	for (var i = 0; i < len; ++i)
	{
		b = A2(f, _elm_lang$core$Native_Utils.chr(str[i]), b);
	}
	return b;
}
function foldr(f, b, str)
{
	for (var i = str.length; i--; )
	{
		b = A2(f, _elm_lang$core$Native_Utils.chr(str[i]), b);
	}
	return b;
}
function split(sep, str)
{
	return _elm_lang$core$Native_List.fromArray(str.split(sep));
}
function join(sep, strs)
{
	return _elm_lang$core$Native_List.toArray(strs).join(sep);
}
function repeat(n, str)
{
	var result = '';
	while (n > 0)
	{
		if (n & 1)
		{
			result += str;
		}
		n >>= 1, str += str;
	}
	return result;
}
function slice(start, end, str)
{
	return str.slice(start, end);
}
function left(n, str)
{
	return n < 1 ? '' : str.slice(0, n);
}
function right(n, str)
{
	return n < 1 ? '' : str.slice(-n);
}
function dropLeft(n, str)
{
	return n < 1 ? str : str.slice(n);
}
function dropRight(n, str)
{
	return n < 1 ? str : str.slice(0, -n);
}
function pad(n, chr, str)
{
	var half = (n - str.length) / 2;
	return repeat(Math.ceil(half), chr) + str + repeat(half | 0, chr);
}
function padRight(n, chr, str)
{
	return str + repeat(n - str.length, chr);
}
function padLeft(n, chr, str)
{
	return repeat(n - str.length, chr) + str;
}

function trim(str)
{
	return str.trim();
}
function trimLeft(str)
{
	return str.replace(/^\s+/, '');
}
function trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function words(str)
{
	return _elm_lang$core$Native_List.fromArray(str.trim().split(/\s+/g));
}
function lines(str)
{
	return _elm_lang$core$Native_List.fromArray(str.split(/\r\n|\r|\n/g));
}

function toUpper(str)
{
	return str.toUpperCase();
}
function toLower(str)
{
	return str.toLowerCase();
}

function any(pred, str)
{
	for (var i = str.length; i--; )
	{
		if (pred(_elm_lang$core$Native_Utils.chr(str[i])))
		{
			return true;
		}
	}
	return false;
}
function all(pred, str)
{
	for (var i = str.length; i--; )
	{
		if (!pred(_elm_lang$core$Native_Utils.chr(str[i])))
		{
			return false;
		}
	}
	return true;
}

function contains(sub, str)
{
	return str.indexOf(sub) > -1;
}
function startsWith(sub, str)
{
	return str.indexOf(sub) === 0;
}
function endsWith(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
}
function indexes(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _elm_lang$core$Native_List.Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _elm_lang$core$Native_List.fromArray(is);
}


function toInt(s)
{
	var len = s.length;

	// if empty
	if (len === 0)
	{
		return intErr(s);
	}

	// if hex
	var c = s[0];
	if (c === '0' && s[1] === 'x')
	{
		for (var i = 2; i < len; ++i)
		{
			var c = s[i];
			if (('0' <= c && c <= '9') || ('A' <= c && c <= 'F') || ('a' <= c && c <= 'f'))
			{
				continue;
			}
			return intErr(s);
		}
		return _elm_lang$core$Result$Ok(parseInt(s, 16));
	}

	// is decimal
	if (c > '9' || (c < '0' && c !== '-' && c !== '+'))
	{
		return intErr(s);
	}
	for (var i = 1; i < len; ++i)
	{
		var c = s[i];
		if (c < '0' || '9' < c)
		{
			return intErr(s);
		}
	}

	return _elm_lang$core$Result$Ok(parseInt(s, 10));
}

function intErr(s)
{
	return _elm_lang$core$Result$Err("could not convert string '" + s + "' to an Int");
}


function toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return floatErr(s);
	}
	var n = +s;
	// faster isNaN check
	return n === n ? _elm_lang$core$Result$Ok(n) : floatErr(s);
}

function floatErr(s)
{
	return _elm_lang$core$Result$Err("could not convert string '" + s + "' to a Float");
}


function toList(str)
{
	return _elm_lang$core$Native_List.fromArray(str.split('').map(_elm_lang$core$Native_Utils.chr));
}
function fromList(chars)
{
	return _elm_lang$core$Native_List.toArray(chars).join('');
}

return {
	isEmpty: isEmpty,
	cons: F2(cons),
	uncons: uncons,
	append: F2(append),
	concat: concat,
	length: length,
	map: F2(map),
	filter: F2(filter),
	reverse: reverse,
	foldl: F3(foldl),
	foldr: F3(foldr),

	split: F2(split),
	join: F2(join),
	repeat: F2(repeat),

	slice: F3(slice),
	left: F2(left),
	right: F2(right),
	dropLeft: F2(dropLeft),
	dropRight: F2(dropRight),

	pad: F3(pad),
	padLeft: F3(padLeft),
	padRight: F3(padRight),

	trim: trim,
	trimLeft: trimLeft,
	trimRight: trimRight,

	words: words,
	lines: lines,

	toUpper: toUpper,
	toLower: toLower,

	any: F2(any),
	all: F2(all),

	contains: F2(contains),
	startsWith: F2(startsWith),
	endsWith: F2(endsWith),
	indexes: F2(indexes),

	toInt: toInt,
	toFloat: toFloat,
	toList: toList,
	fromList: fromList
};

}();

//import Native.Utils //

var _elm_lang$core$Native_Char = function() {

return {
	fromCode: function(c) { return _elm_lang$core$Native_Utils.chr(String.fromCharCode(c)); },
	toCode: function(c) { return c.charCodeAt(0); },
	toUpper: function(c) { return _elm_lang$core$Native_Utils.chr(c.toUpperCase()); },
	toLower: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLowerCase()); },
	toLocaleUpper: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLocaleUpperCase()); },
	toLocaleLower: function(c) { return _elm_lang$core$Native_Utils.chr(c.toLocaleLowerCase()); }
};

}();
var _elm_lang$core$Char$fromCode = _elm_lang$core$Native_Char.fromCode;
var _elm_lang$core$Char$toCode = _elm_lang$core$Native_Char.toCode;
var _elm_lang$core$Char$toLocaleLower = _elm_lang$core$Native_Char.toLocaleLower;
var _elm_lang$core$Char$toLocaleUpper = _elm_lang$core$Native_Char.toLocaleUpper;
var _elm_lang$core$Char$toLower = _elm_lang$core$Native_Char.toLower;
var _elm_lang$core$Char$toUpper = _elm_lang$core$Native_Char.toUpper;
var _elm_lang$core$Char$isBetween = F3(
	function (low, high, $char) {
		var code = _elm_lang$core$Char$toCode($char);
		return (_elm_lang$core$Native_Utils.cmp(
			code,
			_elm_lang$core$Char$toCode(low)) > -1) && (_elm_lang$core$Native_Utils.cmp(
			code,
			_elm_lang$core$Char$toCode(high)) < 1);
	});
var _elm_lang$core$Char$isUpper = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('A'),
	_elm_lang$core$Native_Utils.chr('Z'));
var _elm_lang$core$Char$isLower = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('a'),
	_elm_lang$core$Native_Utils.chr('z'));
var _elm_lang$core$Char$isDigit = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('0'),
	_elm_lang$core$Native_Utils.chr('9'));
var _elm_lang$core$Char$isOctDigit = A2(
	_elm_lang$core$Char$isBetween,
	_elm_lang$core$Native_Utils.chr('0'),
	_elm_lang$core$Native_Utils.chr('7'));
var _elm_lang$core$Char$isHexDigit = function ($char) {
	return _elm_lang$core$Char$isDigit($char) || (A3(
		_elm_lang$core$Char$isBetween,
		_elm_lang$core$Native_Utils.chr('a'),
		_elm_lang$core$Native_Utils.chr('f'),
		$char) || A3(
		_elm_lang$core$Char$isBetween,
		_elm_lang$core$Native_Utils.chr('A'),
		_elm_lang$core$Native_Utils.chr('F'),
		$char));
};

var _elm_lang$core$String$fromList = _elm_lang$core$Native_String.fromList;
var _elm_lang$core$String$toList = _elm_lang$core$Native_String.toList;
var _elm_lang$core$String$toFloat = _elm_lang$core$Native_String.toFloat;
var _elm_lang$core$String$toInt = _elm_lang$core$Native_String.toInt;
var _elm_lang$core$String$indices = _elm_lang$core$Native_String.indexes;
var _elm_lang$core$String$indexes = _elm_lang$core$Native_String.indexes;
var _elm_lang$core$String$endsWith = _elm_lang$core$Native_String.endsWith;
var _elm_lang$core$String$startsWith = _elm_lang$core$Native_String.startsWith;
var _elm_lang$core$String$contains = _elm_lang$core$Native_String.contains;
var _elm_lang$core$String$all = _elm_lang$core$Native_String.all;
var _elm_lang$core$String$any = _elm_lang$core$Native_String.any;
var _elm_lang$core$String$toLower = _elm_lang$core$Native_String.toLower;
var _elm_lang$core$String$toUpper = _elm_lang$core$Native_String.toUpper;
var _elm_lang$core$String$lines = _elm_lang$core$Native_String.lines;
var _elm_lang$core$String$words = _elm_lang$core$Native_String.words;
var _elm_lang$core$String$trimRight = _elm_lang$core$Native_String.trimRight;
var _elm_lang$core$String$trimLeft = _elm_lang$core$Native_String.trimLeft;
var _elm_lang$core$String$trim = _elm_lang$core$Native_String.trim;
var _elm_lang$core$String$padRight = _elm_lang$core$Native_String.padRight;
var _elm_lang$core$String$padLeft = _elm_lang$core$Native_String.padLeft;
var _elm_lang$core$String$pad = _elm_lang$core$Native_String.pad;
var _elm_lang$core$String$dropRight = _elm_lang$core$Native_String.dropRight;
var _elm_lang$core$String$dropLeft = _elm_lang$core$Native_String.dropLeft;
var _elm_lang$core$String$right = _elm_lang$core$Native_String.right;
var _elm_lang$core$String$left = _elm_lang$core$Native_String.left;
var _elm_lang$core$String$slice = _elm_lang$core$Native_String.slice;
var _elm_lang$core$String$repeat = _elm_lang$core$Native_String.repeat;
var _elm_lang$core$String$join = _elm_lang$core$Native_String.join;
var _elm_lang$core$String$split = _elm_lang$core$Native_String.split;
var _elm_lang$core$String$foldr = _elm_lang$core$Native_String.foldr;
var _elm_lang$core$String$foldl = _elm_lang$core$Native_String.foldl;
var _elm_lang$core$String$reverse = _elm_lang$core$Native_String.reverse;
var _elm_lang$core$String$filter = _elm_lang$core$Native_String.filter;
var _elm_lang$core$String$map = _elm_lang$core$Native_String.map;
var _elm_lang$core$String$length = _elm_lang$core$Native_String.length;
var _elm_lang$core$String$concat = _elm_lang$core$Native_String.concat;
var _elm_lang$core$String$append = _elm_lang$core$Native_String.append;
var _elm_lang$core$String$uncons = _elm_lang$core$Native_String.uncons;
var _elm_lang$core$String$cons = _elm_lang$core$Native_String.cons;
var _elm_lang$core$String$fromChar = function ($char) {
	return A2(_elm_lang$core$String$cons, $char, '');
};
var _elm_lang$core$String$isEmpty = _elm_lang$core$Native_String.isEmpty;

var _elm_lang$core$Dict$foldr = F3(
	function (f, acc, t) {
		foldr:
		while (true) {
			var _p0 = t;
			if (_p0.ctor === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var _v1 = f,
					_v2 = A3(
					f,
					_p0._1,
					_p0._2,
					A3(_elm_lang$core$Dict$foldr, f, acc, _p0._4)),
					_v3 = _p0._3;
				f = _v1;
				acc = _v2;
				t = _v3;
				continue foldr;
			}
		}
	});
var _elm_lang$core$Dict$keys = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return {ctor: '::', _0: key, _1: keyList};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$values = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return {ctor: '::', _0: value, _1: valueList};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$toList = function (dict) {
	return A3(
		_elm_lang$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: key, _1: value},
					_1: list
				};
			}),
		{ctor: '[]'},
		dict);
};
var _elm_lang$core$Dict$foldl = F3(
	function (f, acc, dict) {
		foldl:
		while (true) {
			var _p1 = dict;
			if (_p1.ctor === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var _v5 = f,
					_v6 = A3(
					f,
					_p1._1,
					_p1._2,
					A3(_elm_lang$core$Dict$foldl, f, acc, _p1._3)),
					_v7 = _p1._4;
				f = _v5;
				acc = _v6;
				dict = _v7;
				continue foldl;
			}
		}
	});
var _elm_lang$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _p2) {
				stepState:
				while (true) {
					var _p3 = _p2;
					var _p9 = _p3._1;
					var _p8 = _p3._0;
					var _p4 = _p8;
					if (_p4.ctor === '[]') {
						return {
							ctor: '_Tuple2',
							_0: _p8,
							_1: A3(rightStep, rKey, rValue, _p9)
						};
					} else {
						var _p7 = _p4._1;
						var _p6 = _p4._0._1;
						var _p5 = _p4._0._0;
						if (_elm_lang$core$Native_Utils.cmp(_p5, rKey) < 0) {
							var _v10 = rKey,
								_v11 = rValue,
								_v12 = {
								ctor: '_Tuple2',
								_0: _p7,
								_1: A3(leftStep, _p5, _p6, _p9)
							};
							rKey = _v10;
							rValue = _v11;
							_p2 = _v12;
							continue stepState;
						} else {
							if (_elm_lang$core$Native_Utils.cmp(_p5, rKey) > 0) {
								return {
									ctor: '_Tuple2',
									_0: _p8,
									_1: A3(rightStep, rKey, rValue, _p9)
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: _p7,
									_1: A4(bothStep, _p5, _p6, rValue, _p9)
								};
							}
						}
					}
				}
			});
		var _p10 = A3(
			_elm_lang$core$Dict$foldl,
			stepState,
			{
				ctor: '_Tuple2',
				_0: _elm_lang$core$Dict$toList(leftDict),
				_1: initialResult
			},
			rightDict);
		var leftovers = _p10._0;
		var intermediateResult = _p10._1;
		return A3(
			_elm_lang$core$List$foldl,
			F2(
				function (_p11, result) {
					var _p12 = _p11;
					return A3(leftStep, _p12._0, _p12._1, result);
				}),
			intermediateResult,
			leftovers);
	});
var _elm_lang$core$Dict$reportRemBug = F4(
	function (msg, c, lgot, rgot) {
		return _elm_lang$core$Native_Debug.crash(
			_elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'Internal red-black tree invariant violated, expected ',
					_1: {
						ctor: '::',
						_0: msg,
						_1: {
							ctor: '::',
							_0: ' and got ',
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Basics$toString(c),
								_1: {
									ctor: '::',
									_0: '/',
									_1: {
										ctor: '::',
										_0: lgot,
										_1: {
											ctor: '::',
											_0: '/',
											_1: {
												ctor: '::',
												_0: rgot,
												_1: {
													ctor: '::',
													_0: '\nPlease report this bug to <https://github.com/elm-lang/core/issues>',
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}
					}
				}));
	});
var _elm_lang$core$Dict$isBBlack = function (dict) {
	var _p13 = dict;
	_v14_2:
	do {
		if (_p13.ctor === 'RBNode_elm_builtin') {
			if (_p13._0.ctor === 'BBlack') {
				return true;
			} else {
				break _v14_2;
			}
		} else {
			if (_p13._0.ctor === 'LBBlack') {
				return true;
			} else {
				break _v14_2;
			}
		}
	} while(false);
	return false;
};
var _elm_lang$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			var _p14 = dict;
			if (_p14.ctor === 'RBEmpty_elm_builtin') {
				return n;
			} else {
				var _v16 = A2(_elm_lang$core$Dict$sizeHelp, n + 1, _p14._4),
					_v17 = _p14._3;
				n = _v16;
				dict = _v17;
				continue sizeHelp;
			}
		}
	});
var _elm_lang$core$Dict$size = function (dict) {
	return A2(_elm_lang$core$Dict$sizeHelp, 0, dict);
};
var _elm_lang$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			var _p15 = dict;
			if (_p15.ctor === 'RBEmpty_elm_builtin') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p16 = A2(_elm_lang$core$Basics$compare, targetKey, _p15._1);
				switch (_p16.ctor) {
					case 'LT':
						var _v20 = targetKey,
							_v21 = _p15._3;
						targetKey = _v20;
						dict = _v21;
						continue get;
					case 'EQ':
						return _elm_lang$core$Maybe$Just(_p15._2);
					default:
						var _v22 = targetKey,
							_v23 = _p15._4;
						targetKey = _v22;
						dict = _v23;
						continue get;
				}
			}
		}
	});
var _elm_lang$core$Dict$member = F2(
	function (key, dict) {
		var _p17 = A2(_elm_lang$core$Dict$get, key, dict);
		if (_p17.ctor === 'Just') {
			return true;
		} else {
			return false;
		}
	});
var _elm_lang$core$Dict$maxWithDefault = F3(
	function (k, v, r) {
		maxWithDefault:
		while (true) {
			var _p18 = r;
			if (_p18.ctor === 'RBEmpty_elm_builtin') {
				return {ctor: '_Tuple2', _0: k, _1: v};
			} else {
				var _v26 = _p18._1,
					_v27 = _p18._2,
					_v28 = _p18._4;
				k = _v26;
				v = _v27;
				r = _v28;
				continue maxWithDefault;
			}
		}
	});
var _elm_lang$core$Dict$NBlack = {ctor: 'NBlack'};
var _elm_lang$core$Dict$BBlack = {ctor: 'BBlack'};
var _elm_lang$core$Dict$Black = {ctor: 'Black'};
var _elm_lang$core$Dict$blackish = function (t) {
	var _p19 = t;
	if (_p19.ctor === 'RBNode_elm_builtin') {
		var _p20 = _p19._0;
		return _elm_lang$core$Native_Utils.eq(_p20, _elm_lang$core$Dict$Black) || _elm_lang$core$Native_Utils.eq(_p20, _elm_lang$core$Dict$BBlack);
	} else {
		return true;
	}
};
var _elm_lang$core$Dict$Red = {ctor: 'Red'};
var _elm_lang$core$Dict$moreBlack = function (color) {
	var _p21 = color;
	switch (_p21.ctor) {
		case 'Black':
			return _elm_lang$core$Dict$BBlack;
		case 'Red':
			return _elm_lang$core$Dict$Black;
		case 'NBlack':
			return _elm_lang$core$Dict$Red;
		default:
			return _elm_lang$core$Native_Debug.crash('Can\'t make a double black node more black!');
	}
};
var _elm_lang$core$Dict$lessBlack = function (color) {
	var _p22 = color;
	switch (_p22.ctor) {
		case 'BBlack':
			return _elm_lang$core$Dict$Black;
		case 'Black':
			return _elm_lang$core$Dict$Red;
		case 'Red':
			return _elm_lang$core$Dict$NBlack;
		default:
			return _elm_lang$core$Native_Debug.crash('Can\'t make a negative black node less black!');
	}
};
var _elm_lang$core$Dict$LBBlack = {ctor: 'LBBlack'};
var _elm_lang$core$Dict$LBlack = {ctor: 'LBlack'};
var _elm_lang$core$Dict$RBEmpty_elm_builtin = function (a) {
	return {ctor: 'RBEmpty_elm_builtin', _0: a};
};
var _elm_lang$core$Dict$empty = _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
var _elm_lang$core$Dict$isEmpty = function (dict) {
	return _elm_lang$core$Native_Utils.eq(dict, _elm_lang$core$Dict$empty);
};
var _elm_lang$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {ctor: 'RBNode_elm_builtin', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _elm_lang$core$Dict$ensureBlackRoot = function (dict) {
	var _p23 = dict;
	if ((_p23.ctor === 'RBNode_elm_builtin') && (_p23._0.ctor === 'Red')) {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p23._1, _p23._2, _p23._3, _p23._4);
	} else {
		return dict;
	}
};
var _elm_lang$core$Dict$lessBlackTree = function (dict) {
	var _p24 = dict;
	if (_p24.ctor === 'RBNode_elm_builtin') {
		return A5(
			_elm_lang$core$Dict$RBNode_elm_builtin,
			_elm_lang$core$Dict$lessBlack(_p24._0),
			_p24._1,
			_p24._2,
			_p24._3,
			_p24._4);
	} else {
		return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
	}
};
var _elm_lang$core$Dict$balancedTree = function (col) {
	return function (xk) {
		return function (xv) {
			return function (yk) {
				return function (yv) {
					return function (zk) {
						return function (zv) {
							return function (a) {
								return function (b) {
									return function (c) {
										return function (d) {
											return A5(
												_elm_lang$core$Dict$RBNode_elm_builtin,
												_elm_lang$core$Dict$lessBlack(col),
												yk,
												yv,
												A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, xk, xv, a, b),
												A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, zk, zv, c, d));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_lang$core$Dict$blacken = function (t) {
	var _p25 = t;
	if (_p25.ctor === 'RBEmpty_elm_builtin') {
		return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
	} else {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p25._1, _p25._2, _p25._3, _p25._4);
	}
};
var _elm_lang$core$Dict$redden = function (t) {
	var _p26 = t;
	if (_p26.ctor === 'RBEmpty_elm_builtin') {
		return _elm_lang$core$Native_Debug.crash('can\'t make a Leaf red');
	} else {
		return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Red, _p26._1, _p26._2, _p26._3, _p26._4);
	}
};
var _elm_lang$core$Dict$balanceHelp = function (tree) {
	var _p27 = tree;
	_v36_6:
	do {
		_v36_5:
		do {
			_v36_4:
			do {
				_v36_3:
				do {
					_v36_2:
					do {
						_v36_1:
						do {
							_v36_0:
							do {
								if (_p27.ctor === 'RBNode_elm_builtin') {
									if (_p27._3.ctor === 'RBNode_elm_builtin') {
										if (_p27._4.ctor === 'RBNode_elm_builtin') {
											switch (_p27._3._0.ctor) {
												case 'Red':
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																		break _v36_2;
																	} else {
																		if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																			break _v36_3;
																		} else {
																			break _v36_6;
																		}
																	}
																}
															}
														case 'NBlack':
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																		break _v36_4;
																	} else {
																		break _v36_6;
																	}
																}
															}
														default:
															if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
																break _v36_0;
															} else {
																if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
																	break _v36_1;
																} else {
																	break _v36_6;
																}
															}
													}
												case 'NBlack':
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																break _v36_2;
															} else {
																if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																	break _v36_3;
																} else {
																	if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																		break _v36_5;
																	} else {
																		break _v36_6;
																	}
																}
															}
														case 'NBlack':
															if (_p27._0.ctor === 'BBlack') {
																if ((((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																	break _v36_4;
																} else {
																	if ((((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																		break _v36_5;
																	} else {
																		break _v36_6;
																	}
																}
															} else {
																break _v36_6;
															}
														default:
															if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
																break _v36_5;
															} else {
																break _v36_6;
															}
													}
												default:
													switch (_p27._4._0.ctor) {
														case 'Red':
															if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
																break _v36_2;
															} else {
																if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
																	break _v36_3;
																} else {
																	break _v36_6;
																}
															}
														case 'NBlack':
															if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
																break _v36_4;
															} else {
																break _v36_6;
															}
														default:
															break _v36_6;
													}
											}
										} else {
											switch (_p27._3._0.ctor) {
												case 'Red':
													if ((_p27._3._3.ctor === 'RBNode_elm_builtin') && (_p27._3._3._0.ctor === 'Red')) {
														break _v36_0;
													} else {
														if ((_p27._3._4.ctor === 'RBNode_elm_builtin') && (_p27._3._4._0.ctor === 'Red')) {
															break _v36_1;
														} else {
															break _v36_6;
														}
													}
												case 'NBlack':
													if (((((_p27._0.ctor === 'BBlack') && (_p27._3._3.ctor === 'RBNode_elm_builtin')) && (_p27._3._3._0.ctor === 'Black')) && (_p27._3._4.ctor === 'RBNode_elm_builtin')) && (_p27._3._4._0.ctor === 'Black')) {
														break _v36_5;
													} else {
														break _v36_6;
													}
												default:
													break _v36_6;
											}
										}
									} else {
										if (_p27._4.ctor === 'RBNode_elm_builtin') {
											switch (_p27._4._0.ctor) {
												case 'Red':
													if ((_p27._4._3.ctor === 'RBNode_elm_builtin') && (_p27._4._3._0.ctor === 'Red')) {
														break _v36_2;
													} else {
														if ((_p27._4._4.ctor === 'RBNode_elm_builtin') && (_p27._4._4._0.ctor === 'Red')) {
															break _v36_3;
														} else {
															break _v36_6;
														}
													}
												case 'NBlack':
													if (((((_p27._0.ctor === 'BBlack') && (_p27._4._3.ctor === 'RBNode_elm_builtin')) && (_p27._4._3._0.ctor === 'Black')) && (_p27._4._4.ctor === 'RBNode_elm_builtin')) && (_p27._4._4._0.ctor === 'Black')) {
														break _v36_4;
													} else {
														break _v36_6;
													}
												default:
													break _v36_6;
											}
										} else {
											break _v36_6;
										}
									}
								} else {
									break _v36_6;
								}
							} while(false);
							return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._3._3._1)(_p27._3._3._2)(_p27._3._1)(_p27._3._2)(_p27._1)(_p27._2)(_p27._3._3._3)(_p27._3._3._4)(_p27._3._4)(_p27._4);
						} while(false);
						return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._3._1)(_p27._3._2)(_p27._3._4._1)(_p27._3._4._2)(_p27._1)(_p27._2)(_p27._3._3)(_p27._3._4._3)(_p27._3._4._4)(_p27._4);
					} while(false);
					return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._1)(_p27._2)(_p27._4._3._1)(_p27._4._3._2)(_p27._4._1)(_p27._4._2)(_p27._3)(_p27._4._3._3)(_p27._4._3._4)(_p27._4._4);
				} while(false);
				return _elm_lang$core$Dict$balancedTree(_p27._0)(_p27._1)(_p27._2)(_p27._4._1)(_p27._4._2)(_p27._4._4._1)(_p27._4._4._2)(_p27._3)(_p27._4._3)(_p27._4._4._3)(_p27._4._4._4);
			} while(false);
			return A5(
				_elm_lang$core$Dict$RBNode_elm_builtin,
				_elm_lang$core$Dict$Black,
				_p27._4._3._1,
				_p27._4._3._2,
				A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p27._1, _p27._2, _p27._3, _p27._4._3._3),
				A5(
					_elm_lang$core$Dict$balance,
					_elm_lang$core$Dict$Black,
					_p27._4._1,
					_p27._4._2,
					_p27._4._3._4,
					_elm_lang$core$Dict$redden(_p27._4._4)));
		} while(false);
		return A5(
			_elm_lang$core$Dict$RBNode_elm_builtin,
			_elm_lang$core$Dict$Black,
			_p27._3._4._1,
			_p27._3._4._2,
			A5(
				_elm_lang$core$Dict$balance,
				_elm_lang$core$Dict$Black,
				_p27._3._1,
				_p27._3._2,
				_elm_lang$core$Dict$redden(_p27._3._3),
				_p27._3._4._3),
			A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p27._1, _p27._2, _p27._3._4._4, _p27._4));
	} while(false);
	return tree;
};
var _elm_lang$core$Dict$balance = F5(
	function (c, k, v, l, r) {
		var tree = A5(_elm_lang$core$Dict$RBNode_elm_builtin, c, k, v, l, r);
		return _elm_lang$core$Dict$blackish(tree) ? _elm_lang$core$Dict$balanceHelp(tree) : tree;
	});
var _elm_lang$core$Dict$bubble = F5(
	function (c, k, v, l, r) {
		return (_elm_lang$core$Dict$isBBlack(l) || _elm_lang$core$Dict$isBBlack(r)) ? A5(
			_elm_lang$core$Dict$balance,
			_elm_lang$core$Dict$moreBlack(c),
			k,
			v,
			_elm_lang$core$Dict$lessBlackTree(l),
			_elm_lang$core$Dict$lessBlackTree(r)) : A5(_elm_lang$core$Dict$RBNode_elm_builtin, c, k, v, l, r);
	});
var _elm_lang$core$Dict$removeMax = F5(
	function (c, k, v, l, r) {
		var _p28 = r;
		if (_p28.ctor === 'RBEmpty_elm_builtin') {
			return A3(_elm_lang$core$Dict$rem, c, l, r);
		} else {
			return A5(
				_elm_lang$core$Dict$bubble,
				c,
				k,
				v,
				l,
				A5(_elm_lang$core$Dict$removeMax, _p28._0, _p28._1, _p28._2, _p28._3, _p28._4));
		}
	});
var _elm_lang$core$Dict$rem = F3(
	function (color, left, right) {
		var _p29 = {ctor: '_Tuple2', _0: left, _1: right};
		if (_p29._0.ctor === 'RBEmpty_elm_builtin') {
			if (_p29._1.ctor === 'RBEmpty_elm_builtin') {
				var _p30 = color;
				switch (_p30.ctor) {
					case 'Red':
						return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
					case 'Black':
						return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBBlack);
					default:
						return _elm_lang$core$Native_Debug.crash('cannot have bblack or nblack nodes at this point');
				}
			} else {
				var _p33 = _p29._1._0;
				var _p32 = _p29._0._0;
				var _p31 = {ctor: '_Tuple3', _0: color, _1: _p32, _2: _p33};
				if ((((_p31.ctor === '_Tuple3') && (_p31._0.ctor === 'Black')) && (_p31._1.ctor === 'LBlack')) && (_p31._2.ctor === 'Red')) {
					return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p29._1._1, _p29._1._2, _p29._1._3, _p29._1._4);
				} else {
					return A4(
						_elm_lang$core$Dict$reportRemBug,
						'Black/LBlack/Red',
						color,
						_elm_lang$core$Basics$toString(_p32),
						_elm_lang$core$Basics$toString(_p33));
				}
			}
		} else {
			if (_p29._1.ctor === 'RBEmpty_elm_builtin') {
				var _p36 = _p29._1._0;
				var _p35 = _p29._0._0;
				var _p34 = {ctor: '_Tuple3', _0: color, _1: _p35, _2: _p36};
				if ((((_p34.ctor === '_Tuple3') && (_p34._0.ctor === 'Black')) && (_p34._1.ctor === 'Red')) && (_p34._2.ctor === 'LBlack')) {
					return A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Black, _p29._0._1, _p29._0._2, _p29._0._3, _p29._0._4);
				} else {
					return A4(
						_elm_lang$core$Dict$reportRemBug,
						'Black/Red/LBlack',
						color,
						_elm_lang$core$Basics$toString(_p35),
						_elm_lang$core$Basics$toString(_p36));
				}
			} else {
				var _p40 = _p29._0._2;
				var _p39 = _p29._0._4;
				var _p38 = _p29._0._1;
				var newLeft = A5(_elm_lang$core$Dict$removeMax, _p29._0._0, _p38, _p40, _p29._0._3, _p39);
				var _p37 = A3(_elm_lang$core$Dict$maxWithDefault, _p38, _p40, _p39);
				var k = _p37._0;
				var v = _p37._1;
				return A5(_elm_lang$core$Dict$bubble, color, k, v, newLeft, right);
			}
		}
	});
var _elm_lang$core$Dict$map = F2(
	function (f, dict) {
		var _p41 = dict;
		if (_p41.ctor === 'RBEmpty_elm_builtin') {
			return _elm_lang$core$Dict$RBEmpty_elm_builtin(_elm_lang$core$Dict$LBlack);
		} else {
			var _p42 = _p41._1;
			return A5(
				_elm_lang$core$Dict$RBNode_elm_builtin,
				_p41._0,
				_p42,
				A2(f, _p42, _p41._2),
				A2(_elm_lang$core$Dict$map, f, _p41._3),
				A2(_elm_lang$core$Dict$map, f, _p41._4));
		}
	});
var _elm_lang$core$Dict$Same = {ctor: 'Same'};
var _elm_lang$core$Dict$Remove = {ctor: 'Remove'};
var _elm_lang$core$Dict$Insert = {ctor: 'Insert'};
var _elm_lang$core$Dict$update = F3(
	function (k, alter, dict) {
		var up = function (dict) {
			var _p43 = dict;
			if (_p43.ctor === 'RBEmpty_elm_builtin') {
				var _p44 = alter(_elm_lang$core$Maybe$Nothing);
				if (_p44.ctor === 'Nothing') {
					return {ctor: '_Tuple2', _0: _elm_lang$core$Dict$Same, _1: _elm_lang$core$Dict$empty};
				} else {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Dict$Insert,
						_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _elm_lang$core$Dict$Red, k, _p44._0, _elm_lang$core$Dict$empty, _elm_lang$core$Dict$empty)
					};
				}
			} else {
				var _p55 = _p43._2;
				var _p54 = _p43._4;
				var _p53 = _p43._3;
				var _p52 = _p43._1;
				var _p51 = _p43._0;
				var _p45 = A2(_elm_lang$core$Basics$compare, k, _p52);
				switch (_p45.ctor) {
					case 'EQ':
						var _p46 = alter(
							_elm_lang$core$Maybe$Just(_p55));
						if (_p46.ctor === 'Nothing') {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Dict$Remove,
								_1: A3(_elm_lang$core$Dict$rem, _p51, _p53, _p54)
							};
						} else {
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Dict$Same,
								_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p46._0, _p53, _p54)
							};
						}
					case 'LT':
						var _p47 = up(_p53);
						var flag = _p47._0;
						var newLeft = _p47._1;
						var _p48 = flag;
						switch (_p48.ctor) {
							case 'Same':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Same,
									_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p55, newLeft, _p54)
								};
							case 'Insert':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Insert,
									_1: A5(_elm_lang$core$Dict$balance, _p51, _p52, _p55, newLeft, _p54)
								};
							default:
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Remove,
									_1: A5(_elm_lang$core$Dict$bubble, _p51, _p52, _p55, newLeft, _p54)
								};
						}
					default:
						var _p49 = up(_p54);
						var flag = _p49._0;
						var newRight = _p49._1;
						var _p50 = flag;
						switch (_p50.ctor) {
							case 'Same':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Same,
									_1: A5(_elm_lang$core$Dict$RBNode_elm_builtin, _p51, _p52, _p55, _p53, newRight)
								};
							case 'Insert':
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Insert,
									_1: A5(_elm_lang$core$Dict$balance, _p51, _p52, _p55, _p53, newRight)
								};
							default:
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Dict$Remove,
									_1: A5(_elm_lang$core$Dict$bubble, _p51, _p52, _p55, _p53, newRight)
								};
						}
				}
			}
		};
		var _p56 = up(dict);
		var flag = _p56._0;
		var updatedDict = _p56._1;
		var _p57 = flag;
		switch (_p57.ctor) {
			case 'Same':
				return updatedDict;
			case 'Insert':
				return _elm_lang$core$Dict$ensureBlackRoot(updatedDict);
			default:
				return _elm_lang$core$Dict$blacken(updatedDict);
		}
	});
var _elm_lang$core$Dict$insert = F3(
	function (key, value, dict) {
		return A3(
			_elm_lang$core$Dict$update,
			key,
			_elm_lang$core$Basics$always(
				_elm_lang$core$Maybe$Just(value)),
			dict);
	});
var _elm_lang$core$Dict$singleton = F2(
	function (key, value) {
		return A3(_elm_lang$core$Dict$insert, key, value, _elm_lang$core$Dict$empty);
	});
var _elm_lang$core$Dict$union = F2(
	function (t1, t2) {
		return A3(_elm_lang$core$Dict$foldl, _elm_lang$core$Dict$insert, t2, t1);
	});
var _elm_lang$core$Dict$filter = F2(
	function (predicate, dictionary) {
		var add = F3(
			function (key, value, dict) {
				return A2(predicate, key, value) ? A3(_elm_lang$core$Dict$insert, key, value, dict) : dict;
			});
		return A3(_elm_lang$core$Dict$foldl, add, _elm_lang$core$Dict$empty, dictionary);
	});
var _elm_lang$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			_elm_lang$core$Dict$filter,
			F2(
				function (k, _p58) {
					return A2(_elm_lang$core$Dict$member, k, t2);
				}),
			t1);
	});
var _elm_lang$core$Dict$partition = F2(
	function (predicate, dict) {
		var add = F3(
			function (key, value, _p59) {
				var _p60 = _p59;
				var _p62 = _p60._1;
				var _p61 = _p60._0;
				return A2(predicate, key, value) ? {
					ctor: '_Tuple2',
					_0: A3(_elm_lang$core$Dict$insert, key, value, _p61),
					_1: _p62
				} : {
					ctor: '_Tuple2',
					_0: _p61,
					_1: A3(_elm_lang$core$Dict$insert, key, value, _p62)
				};
			});
		return A3(
			_elm_lang$core$Dict$foldl,
			add,
			{ctor: '_Tuple2', _0: _elm_lang$core$Dict$empty, _1: _elm_lang$core$Dict$empty},
			dict);
	});
var _elm_lang$core$Dict$fromList = function (assocs) {
	return A3(
		_elm_lang$core$List$foldl,
		F2(
			function (_p63, dict) {
				var _p64 = _p63;
				return A3(_elm_lang$core$Dict$insert, _p64._0, _p64._1, dict);
			}),
		_elm_lang$core$Dict$empty,
		assocs);
};
var _elm_lang$core$Dict$remove = F2(
	function (key, dict) {
		return A3(
			_elm_lang$core$Dict$update,
			key,
			_elm_lang$core$Basics$always(_elm_lang$core$Maybe$Nothing),
			dict);
	});
var _elm_lang$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			_elm_lang$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2(_elm_lang$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});

//import Native.Scheduler //

var _elm_lang$core$Native_Time = function() {

var now = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
{
	callback(_elm_lang$core$Native_Scheduler.succeed(Date.now()));
});

function setInterval_(interval, task)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var id = setInterval(function() {
			_elm_lang$core$Native_Scheduler.rawSpawn(task);
		}, interval);

		return function() { clearInterval(id); };
	});
}

return {
	now: now,
	setInterval_: F2(setInterval_)
};

}();
var _elm_lang$core$Time$setInterval = _elm_lang$core$Native_Time.setInterval_;
var _elm_lang$core$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		var _p0 = intervals;
		if (_p0.ctor === '[]') {
			return _elm_lang$core$Task$succeed(processes);
		} else {
			var _p1 = _p0._0;
			var spawnRest = function (id) {
				return A3(
					_elm_lang$core$Time$spawnHelp,
					router,
					_p0._1,
					A3(_elm_lang$core$Dict$insert, _p1, id, processes));
			};
			var spawnTimer = _elm_lang$core$Native_Scheduler.spawn(
				A2(
					_elm_lang$core$Time$setInterval,
					_p1,
					A2(_elm_lang$core$Platform$sendToSelf, router, _p1)));
			return A2(_elm_lang$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var _elm_lang$core$Time$addMySub = F2(
	function (_p2, state) {
		var _p3 = _p2;
		var _p6 = _p3._1;
		var _p5 = _p3._0;
		var _p4 = A2(_elm_lang$core$Dict$get, _p5, state);
		if (_p4.ctor === 'Nothing') {
			return A3(
				_elm_lang$core$Dict$insert,
				_p5,
				{
					ctor: '::',
					_0: _p6,
					_1: {ctor: '[]'}
				},
				state);
		} else {
			return A3(
				_elm_lang$core$Dict$insert,
				_p5,
				{ctor: '::', _0: _p6, _1: _p4._0},
				state);
		}
	});
var _elm_lang$core$Time$inMilliseconds = function (t) {
	return t;
};
var _elm_lang$core$Time$millisecond = 1;
var _elm_lang$core$Time$second = 1000 * _elm_lang$core$Time$millisecond;
var _elm_lang$core$Time$minute = 60 * _elm_lang$core$Time$second;
var _elm_lang$core$Time$hour = 60 * _elm_lang$core$Time$minute;
var _elm_lang$core$Time$inHours = function (t) {
	return t / _elm_lang$core$Time$hour;
};
var _elm_lang$core$Time$inMinutes = function (t) {
	return t / _elm_lang$core$Time$minute;
};
var _elm_lang$core$Time$inSeconds = function (t) {
	return t / _elm_lang$core$Time$second;
};
var _elm_lang$core$Time$now = _elm_lang$core$Native_Time.now;
var _elm_lang$core$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _p7 = A2(_elm_lang$core$Dict$get, interval, state.taggers);
		if (_p7.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var tellTaggers = function (time) {
				return _elm_lang$core$Task$sequence(
					A2(
						_elm_lang$core$List$map,
						function (tagger) {
							return A2(
								_elm_lang$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						_p7._0));
			};
			return A2(
				_elm_lang$core$Task$andThen,
				function (_p8) {
					return _elm_lang$core$Task$succeed(state);
				},
				A2(_elm_lang$core$Task$andThen, tellTaggers, _elm_lang$core$Time$now));
		}
	});
var _elm_lang$core$Time$subscription = _elm_lang$core$Native_Platform.leaf('Time');
var _elm_lang$core$Time$State = F2(
	function (a, b) {
		return {taggers: a, processes: b};
	});
var _elm_lang$core$Time$init = _elm_lang$core$Task$succeed(
	A2(_elm_lang$core$Time$State, _elm_lang$core$Dict$empty, _elm_lang$core$Dict$empty));
var _elm_lang$core$Time$onEffects = F3(
	function (router, subs, _p9) {
		var _p10 = _p9;
		var rightStep = F3(
			function (_p12, id, _p11) {
				var _p13 = _p11;
				return {
					ctor: '_Tuple3',
					_0: _p13._0,
					_1: _p13._1,
					_2: A2(
						_elm_lang$core$Task$andThen,
						function (_p14) {
							return _p13._2;
						},
						_elm_lang$core$Native_Scheduler.kill(id))
				};
			});
		var bothStep = F4(
			function (interval, taggers, id, _p15) {
				var _p16 = _p15;
				return {
					ctor: '_Tuple3',
					_0: _p16._0,
					_1: A3(_elm_lang$core$Dict$insert, interval, id, _p16._1),
					_2: _p16._2
				};
			});
		var leftStep = F3(
			function (interval, taggers, _p17) {
				var _p18 = _p17;
				return {
					ctor: '_Tuple3',
					_0: {ctor: '::', _0: interval, _1: _p18._0},
					_1: _p18._1,
					_2: _p18._2
				};
			});
		var newTaggers = A3(_elm_lang$core$List$foldl, _elm_lang$core$Time$addMySub, _elm_lang$core$Dict$empty, subs);
		var _p19 = A6(
			_elm_lang$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			_p10.processes,
			{
				ctor: '_Tuple3',
				_0: {ctor: '[]'},
				_1: _elm_lang$core$Dict$empty,
				_2: _elm_lang$core$Task$succeed(
					{ctor: '_Tuple0'})
			});
		var spawnList = _p19._0;
		var existingDict = _p19._1;
		var killTask = _p19._2;
		return A2(
			_elm_lang$core$Task$andThen,
			function (newProcesses) {
				return _elm_lang$core$Task$succeed(
					A2(_elm_lang$core$Time$State, newTaggers, newProcesses));
			},
			A2(
				_elm_lang$core$Task$andThen,
				function (_p20) {
					return A3(_elm_lang$core$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var _elm_lang$core$Time$Every = F2(
	function (a, b) {
		return {ctor: 'Every', _0: a, _1: b};
	});
var _elm_lang$core$Time$every = F2(
	function (interval, tagger) {
		return _elm_lang$core$Time$subscription(
			A2(_elm_lang$core$Time$Every, interval, tagger));
	});
var _elm_lang$core$Time$subMap = F2(
	function (f, _p21) {
		var _p22 = _p21;
		return A2(
			_elm_lang$core$Time$Every,
			_p22._0,
			function (_p23) {
				return f(
					_p22._1(_p23));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Time'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Time$init, onEffects: _elm_lang$core$Time$onEffects, onSelfMsg: _elm_lang$core$Time$onSelfMsg, tag: 'sub', subMap: _elm_lang$core$Time$subMap};

var _elm_lang$core$Date$millisecond = _elm_lang$core$Native_Date.millisecond;
var _elm_lang$core$Date$second = _elm_lang$core$Native_Date.second;
var _elm_lang$core$Date$minute = _elm_lang$core$Native_Date.minute;
var _elm_lang$core$Date$hour = _elm_lang$core$Native_Date.hour;
var _elm_lang$core$Date$dayOfWeek = _elm_lang$core$Native_Date.dayOfWeek;
var _elm_lang$core$Date$day = _elm_lang$core$Native_Date.day;
var _elm_lang$core$Date$month = _elm_lang$core$Native_Date.month;
var _elm_lang$core$Date$year = _elm_lang$core$Native_Date.year;
var _elm_lang$core$Date$fromTime = _elm_lang$core$Native_Date.fromTime;
var _elm_lang$core$Date$toTime = _elm_lang$core$Native_Date.toTime;
var _elm_lang$core$Date$fromString = _elm_lang$core$Native_Date.fromString;
var _elm_lang$core$Date$now = A2(_elm_lang$core$Task$map, _elm_lang$core$Date$fromTime, _elm_lang$core$Time$now);
var _elm_lang$core$Date$Date = {ctor: 'Date'};
var _elm_lang$core$Date$Sun = {ctor: 'Sun'};
var _elm_lang$core$Date$Sat = {ctor: 'Sat'};
var _elm_lang$core$Date$Fri = {ctor: 'Fri'};
var _elm_lang$core$Date$Thu = {ctor: 'Thu'};
var _elm_lang$core$Date$Wed = {ctor: 'Wed'};
var _elm_lang$core$Date$Tue = {ctor: 'Tue'};
var _elm_lang$core$Date$Mon = {ctor: 'Mon'};
var _elm_lang$core$Date$Dec = {ctor: 'Dec'};
var _elm_lang$core$Date$Nov = {ctor: 'Nov'};
var _elm_lang$core$Date$Oct = {ctor: 'Oct'};
var _elm_lang$core$Date$Sep = {ctor: 'Sep'};
var _elm_lang$core$Date$Aug = {ctor: 'Aug'};
var _elm_lang$core$Date$Jul = {ctor: 'Jul'};
var _elm_lang$core$Date$Jun = {ctor: 'Jun'};
var _elm_lang$core$Date$May = {ctor: 'May'};
var _elm_lang$core$Date$Apr = {ctor: 'Apr'};
var _elm_lang$core$Date$Mar = {ctor: 'Mar'};
var _elm_lang$core$Date$Feb = {ctor: 'Feb'};
var _elm_lang$core$Date$Jan = {ctor: 'Jan'};

//import Native.List //

var _elm_lang$core$Native_Array = function() {

// A RRB-Tree has two distinct data types.
// Leaf -> "height"  is always 0
//         "table"   is an array of elements
// Node -> "height"  is always greater than 0
//         "table"   is an array of child nodes
//         "lengths" is an array of accumulated lengths of the child nodes

// M is the maximal table size. 32 seems fast. E is the allowed increase
// of search steps when concatting to find an index. Lower values will
// decrease balancing, but will increase search steps.
var M = 32;
var E = 2;

// An empty array.
var empty = {
	ctor: '_Array',
	height: 0,
	table: []
};


function get(i, array)
{
	if (i < 0 || i >= length(array))
	{
		throw new Error(
			'Index ' + i + ' is out of range. Check the length of ' +
			'your array first or use getMaybe or getWithDefault.');
	}
	return unsafeGet(i, array);
}


function unsafeGet(i, array)
{
	for (var x = array.height; x > 0; x--)
	{
		var slot = i >> (x * 5);
		while (array.lengths[slot] <= i)
		{
			slot++;
		}
		if (slot > 0)
		{
			i -= array.lengths[slot - 1];
		}
		array = array.table[slot];
	}
	return array.table[i];
}


// Sets the value at the index i. Only the nodes leading to i will get
// copied and updated.
function set(i, item, array)
{
	if (i < 0 || length(array) <= i)
	{
		return array;
	}
	return unsafeSet(i, item, array);
}


function unsafeSet(i, item, array)
{
	array = nodeCopy(array);

	if (array.height === 0)
	{
		array.table[i] = item;
	}
	else
	{
		var slot = getSlot(i, array);
		if (slot > 0)
		{
			i -= array.lengths[slot - 1];
		}
		array.table[slot] = unsafeSet(i, item, array.table[slot]);
	}
	return array;
}


function initialize(len, f)
{
	if (len <= 0)
	{
		return empty;
	}
	var h = Math.floor( Math.log(len) / Math.log(M) );
	return initialize_(f, h, 0, len);
}

function initialize_(f, h, from, to)
{
	if (h === 0)
	{
		var table = new Array((to - from) % (M + 1));
		for (var i = 0; i < table.length; i++)
		{
		  table[i] = f(from + i);
		}
		return {
			ctor: '_Array',
			height: 0,
			table: table
		};
	}

	var step = Math.pow(M, h);
	var table = new Array(Math.ceil((to - from) / step));
	var lengths = new Array(table.length);
	for (var i = 0; i < table.length; i++)
	{
		table[i] = initialize_(f, h - 1, from + (i * step), Math.min(from + ((i + 1) * step), to));
		lengths[i] = length(table[i]) + (i > 0 ? lengths[i-1] : 0);
	}
	return {
		ctor: '_Array',
		height: h,
		table: table,
		lengths: lengths
	};
}

function fromList(list)
{
	if (list.ctor === '[]')
	{
		return empty;
	}

	// Allocate M sized blocks (table) and write list elements to it.
	var table = new Array(M);
	var nodes = [];
	var i = 0;

	while (list.ctor !== '[]')
	{
		table[i] = list._0;
		list = list._1;
		i++;

		// table is full, so we can push a leaf containing it into the
		// next node.
		if (i === M)
		{
			var leaf = {
				ctor: '_Array',
				height: 0,
				table: table
			};
			fromListPush(leaf, nodes);
			table = new Array(M);
			i = 0;
		}
	}

	// Maybe there is something left on the table.
	if (i > 0)
	{
		var leaf = {
			ctor: '_Array',
			height: 0,
			table: table.splice(0, i)
		};
		fromListPush(leaf, nodes);
	}

	// Go through all of the nodes and eventually push them into higher nodes.
	for (var h = 0; h < nodes.length - 1; h++)
	{
		if (nodes[h].table.length > 0)
		{
			fromListPush(nodes[h], nodes);
		}
	}

	var head = nodes[nodes.length - 1];
	if (head.height > 0 && head.table.length === 1)
	{
		return head.table[0];
	}
	else
	{
		return head;
	}
}

// Push a node into a higher node as a child.
function fromListPush(toPush, nodes)
{
	var h = toPush.height;

	// Maybe the node on this height does not exist.
	if (nodes.length === h)
	{
		var node = {
			ctor: '_Array',
			height: h + 1,
			table: [],
			lengths: []
		};
		nodes.push(node);
	}

	nodes[h].table.push(toPush);
	var len = length(toPush);
	if (nodes[h].lengths.length > 0)
	{
		len += nodes[h].lengths[nodes[h].lengths.length - 1];
	}
	nodes[h].lengths.push(len);

	if (nodes[h].table.length === M)
	{
		fromListPush(nodes[h], nodes);
		nodes[h] = {
			ctor: '_Array',
			height: h + 1,
			table: [],
			lengths: []
		};
	}
}

// Pushes an item via push_ to the bottom right of a tree.
function push(item, a)
{
	var pushed = push_(item, a);
	if (pushed !== null)
	{
		return pushed;
	}

	var newTree = create(item, a.height);
	return siblise(a, newTree);
}

// Recursively tries to push an item to the bottom-right most
// tree possible. If there is no space left for the item,
// null will be returned.
function push_(item, a)
{
	// Handle resursion stop at leaf level.
	if (a.height === 0)
	{
		if (a.table.length < M)
		{
			var newA = {
				ctor: '_Array',
				height: 0,
				table: a.table.slice()
			};
			newA.table.push(item);
			return newA;
		}
		else
		{
		  return null;
		}
	}

	// Recursively push
	var pushed = push_(item, botRight(a));

	// There was space in the bottom right tree, so the slot will
	// be updated.
	if (pushed !== null)
	{
		var newA = nodeCopy(a);
		newA.table[newA.table.length - 1] = pushed;
		newA.lengths[newA.lengths.length - 1]++;
		return newA;
	}

	// When there was no space left, check if there is space left
	// for a new slot with a tree which contains only the item
	// at the bottom.
	if (a.table.length < M)
	{
		var newSlot = create(item, a.height - 1);
		var newA = nodeCopy(a);
		newA.table.push(newSlot);
		newA.lengths.push(newA.lengths[newA.lengths.length - 1] + length(newSlot));
		return newA;
	}
	else
	{
		return null;
	}
}

// Converts an array into a list of elements.
function toList(a)
{
	return toList_(_elm_lang$core$Native_List.Nil, a);
}

function toList_(list, a)
{
	for (var i = a.table.length - 1; i >= 0; i--)
	{
		list =
			a.height === 0
				? _elm_lang$core$Native_List.Cons(a.table[i], list)
				: toList_(list, a.table[i]);
	}
	return list;
}

// Maps a function over the elements of an array.
function map(f, a)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: new Array(a.table.length)
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths;
	}
	for (var i = 0; i < a.table.length; i++)
	{
		newA.table[i] =
			a.height === 0
				? f(a.table[i])
				: map(f, a.table[i]);
	}
	return newA;
}

// Maps a function over the elements with their index as first argument.
function indexedMap(f, a)
{
	return indexedMap_(f, a, 0);
}

function indexedMap_(f, a, from)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: new Array(a.table.length)
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths;
	}
	for (var i = 0; i < a.table.length; i++)
	{
		newA.table[i] =
			a.height === 0
				? A2(f, from + i, a.table[i])
				: indexedMap_(f, a.table[i], i == 0 ? from : from + a.lengths[i - 1]);
	}
	return newA;
}

function foldl(f, b, a)
{
	if (a.height === 0)
	{
		for (var i = 0; i < a.table.length; i++)
		{
			b = A2(f, a.table[i], b);
		}
	}
	else
	{
		for (var i = 0; i < a.table.length; i++)
		{
			b = foldl(f, b, a.table[i]);
		}
	}
	return b;
}

function foldr(f, b, a)
{
	if (a.height === 0)
	{
		for (var i = a.table.length; i--; )
		{
			b = A2(f, a.table[i], b);
		}
	}
	else
	{
		for (var i = a.table.length; i--; )
		{
			b = foldr(f, b, a.table[i]);
		}
	}
	return b;
}

// TODO: currently, it slices the right, then the left. This can be
// optimized.
function slice(from, to, a)
{
	if (from < 0)
	{
		from += length(a);
	}
	if (to < 0)
	{
		to += length(a);
	}
	return sliceLeft(from, sliceRight(to, a));
}

function sliceRight(to, a)
{
	if (to === length(a))
	{
		return a;
	}

	// Handle leaf level.
	if (a.height === 0)
	{
		var newA = { ctor:'_Array', height:0 };
		newA.table = a.table.slice(0, to);
		return newA;
	}

	// Slice the right recursively.
	var right = getSlot(to, a);
	var sliced = sliceRight(to - (right > 0 ? a.lengths[right - 1] : 0), a.table[right]);

	// Maybe the a node is not even needed, as sliced contains the whole slice.
	if (right === 0)
	{
		return sliced;
	}

	// Create new node.
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice(0, right),
		lengths: a.lengths.slice(0, right)
	};
	if (sliced.table.length > 0)
	{
		newA.table[right] = sliced;
		newA.lengths[right] = length(sliced) + (right > 0 ? newA.lengths[right - 1] : 0);
	}
	return newA;
}

function sliceLeft(from, a)
{
	if (from === 0)
	{
		return a;
	}

	// Handle leaf level.
	if (a.height === 0)
	{
		var newA = { ctor:'_Array', height:0 };
		newA.table = a.table.slice(from, a.table.length + 1);
		return newA;
	}

	// Slice the left recursively.
	var left = getSlot(from, a);
	var sliced = sliceLeft(from - (left > 0 ? a.lengths[left - 1] : 0), a.table[left]);

	// Maybe the a node is not even needed, as sliced contains the whole slice.
	if (left === a.table.length - 1)
	{
		return sliced;
	}

	// Create new node.
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice(left, a.table.length + 1),
		lengths: new Array(a.table.length - left)
	};
	newA.table[0] = sliced;
	var len = 0;
	for (var i = 0; i < newA.table.length; i++)
	{
		len += length(newA.table[i]);
		newA.lengths[i] = len;
	}

	return newA;
}

// Appends two trees.
function append(a,b)
{
	if (a.table.length === 0)
	{
		return b;
	}
	if (b.table.length === 0)
	{
		return a;
	}

	var c = append_(a, b);

	// Check if both nodes can be crunshed together.
	if (c[0].table.length + c[1].table.length <= M)
	{
		if (c[0].table.length === 0)
		{
			return c[1];
		}
		if (c[1].table.length === 0)
		{
			return c[0];
		}

		// Adjust .table and .lengths
		c[0].table = c[0].table.concat(c[1].table);
		if (c[0].height > 0)
		{
			var len = length(c[0]);
			for (var i = 0; i < c[1].lengths.length; i++)
			{
				c[1].lengths[i] += len;
			}
			c[0].lengths = c[0].lengths.concat(c[1].lengths);
		}

		return c[0];
	}

	if (c[0].height > 0)
	{
		var toRemove = calcToRemove(a, b);
		if (toRemove > E)
		{
			c = shuffle(c[0], c[1], toRemove);
		}
	}

	return siblise(c[0], c[1]);
}

// Returns an array of two nodes; right and left. One node _may_ be empty.
function append_(a, b)
{
	if (a.height === 0 && b.height === 0)
	{
		return [a, b];
	}

	if (a.height !== 1 || b.height !== 1)
	{
		if (a.height === b.height)
		{
			a = nodeCopy(a);
			b = nodeCopy(b);
			var appended = append_(botRight(a), botLeft(b));

			insertRight(a, appended[1]);
			insertLeft(b, appended[0]);
		}
		else if (a.height > b.height)
		{
			a = nodeCopy(a);
			var appended = append_(botRight(a), b);

			insertRight(a, appended[0]);
			b = parentise(appended[1], appended[1].height + 1);
		}
		else
		{
			b = nodeCopy(b);
			var appended = append_(a, botLeft(b));

			var left = appended[0].table.length === 0 ? 0 : 1;
			var right = left === 0 ? 1 : 0;
			insertLeft(b, appended[left]);
			a = parentise(appended[right], appended[right].height + 1);
		}
	}

	// Check if balancing is needed and return based on that.
	if (a.table.length === 0 || b.table.length === 0)
	{
		return [a, b];
	}

	var toRemove = calcToRemove(a, b);
	if (toRemove <= E)
	{
		return [a, b];
	}
	return shuffle(a, b, toRemove);
}

// Helperfunctions for append_. Replaces a child node at the side of the parent.
function insertRight(parent, node)
{
	var index = parent.table.length - 1;
	parent.table[index] = node;
	parent.lengths[index] = length(node);
	parent.lengths[index] += index > 0 ? parent.lengths[index - 1] : 0;
}

function insertLeft(parent, node)
{
	if (node.table.length > 0)
	{
		parent.table[0] = node;
		parent.lengths[0] = length(node);

		var len = length(parent.table[0]);
		for (var i = 1; i < parent.lengths.length; i++)
		{
			len += length(parent.table[i]);
			parent.lengths[i] = len;
		}
	}
	else
	{
		parent.table.shift();
		for (var i = 1; i < parent.lengths.length; i++)
		{
			parent.lengths[i] = parent.lengths[i] - parent.lengths[0];
		}
		parent.lengths.shift();
	}
}

// Returns the extra search steps for E. Refer to the paper.
function calcToRemove(a, b)
{
	var subLengths = 0;
	for (var i = 0; i < a.table.length; i++)
	{
		subLengths += a.table[i].table.length;
	}
	for (var i = 0; i < b.table.length; i++)
	{
		subLengths += b.table[i].table.length;
	}

	var toRemove = a.table.length + b.table.length;
	return toRemove - (Math.floor((subLengths - 1) / M) + 1);
}

// get2, set2 and saveSlot are helpers for accessing elements over two arrays.
function get2(a, b, index)
{
	return index < a.length
		? a[index]
		: b[index - a.length];
}

function set2(a, b, index, value)
{
	if (index < a.length)
	{
		a[index] = value;
	}
	else
	{
		b[index - a.length] = value;
	}
}

function saveSlot(a, b, index, slot)
{
	set2(a.table, b.table, index, slot);

	var l = (index === 0 || index === a.lengths.length)
		? 0
		: get2(a.lengths, a.lengths, index - 1);

	set2(a.lengths, b.lengths, index, l + length(slot));
}

// Creates a node or leaf with a given length at their arrays for perfomance.
// Is only used by shuffle.
function createNode(h, length)
{
	if (length < 0)
	{
		length = 0;
	}
	var a = {
		ctor: '_Array',
		height: h,
		table: new Array(length)
	};
	if (h > 0)
	{
		a.lengths = new Array(length);
	}
	return a;
}

// Returns an array of two balanced nodes.
function shuffle(a, b, toRemove)
{
	var newA = createNode(a.height, Math.min(M, a.table.length + b.table.length - toRemove));
	var newB = createNode(a.height, newA.table.length - (a.table.length + b.table.length - toRemove));

	// Skip the slots with size M. More precise: copy the slot references
	// to the new node
	var read = 0;
	while (get2(a.table, b.table, read).table.length % M === 0)
	{
		set2(newA.table, newB.table, read, get2(a.table, b.table, read));
		set2(newA.lengths, newB.lengths, read, get2(a.lengths, b.lengths, read));
		read++;
	}

	// Pulling items from left to right, caching in a slot before writing
	// it into the new nodes.
	var write = read;
	var slot = new createNode(a.height - 1, 0);
	var from = 0;

	// If the current slot is still containing data, then there will be at
	// least one more write, so we do not break this loop yet.
	while (read - write - (slot.table.length > 0 ? 1 : 0) < toRemove)
	{
		// Find out the max possible items for copying.
		var source = get2(a.table, b.table, read);
		var to = Math.min(M - slot.table.length, source.table.length);

		// Copy and adjust size table.
		slot.table = slot.table.concat(source.table.slice(from, to));
		if (slot.height > 0)
		{
			var len = slot.lengths.length;
			for (var i = len; i < len + to - from; i++)
			{
				slot.lengths[i] = length(slot.table[i]);
				slot.lengths[i] += (i > 0 ? slot.lengths[i - 1] : 0);
			}
		}

		from += to;

		// Only proceed to next slots[i] if the current one was
		// fully copied.
		if (source.table.length <= to)
		{
			read++; from = 0;
		}

		// Only create a new slot if the current one is filled up.
		if (slot.table.length === M)
		{
			saveSlot(newA, newB, write, slot);
			slot = createNode(a.height - 1, 0);
			write++;
		}
	}

	// Cleanup after the loop. Copy the last slot into the new nodes.
	if (slot.table.length > 0)
	{
		saveSlot(newA, newB, write, slot);
		write++;
	}

	// Shift the untouched slots to the left
	while (read < a.table.length + b.table.length )
	{
		saveSlot(newA, newB, write, get2(a.table, b.table, read));
		read++;
		write++;
	}

	return [newA, newB];
}

// Navigation functions
function botRight(a)
{
	return a.table[a.table.length - 1];
}
function botLeft(a)
{
	return a.table[0];
}

// Copies a node for updating. Note that you should not use this if
// only updating only one of "table" or "lengths" for performance reasons.
function nodeCopy(a)
{
	var newA = {
		ctor: '_Array',
		height: a.height,
		table: a.table.slice()
	};
	if (a.height > 0)
	{
		newA.lengths = a.lengths.slice();
	}
	return newA;
}

// Returns how many items are in the tree.
function length(array)
{
	if (array.height === 0)
	{
		return array.table.length;
	}
	else
	{
		return array.lengths[array.lengths.length - 1];
	}
}

// Calculates in which slot of "table" the item probably is, then
// find the exact slot via forward searching in  "lengths". Returns the index.
function getSlot(i, a)
{
	var slot = i >> (5 * a.height);
	while (a.lengths[slot] <= i)
	{
		slot++;
	}
	return slot;
}

// Recursively creates a tree with a given height containing
// only the given item.
function create(item, h)
{
	if (h === 0)
	{
		return {
			ctor: '_Array',
			height: 0,
			table: [item]
		};
	}
	return {
		ctor: '_Array',
		height: h,
		table: [create(item, h - 1)],
		lengths: [1]
	};
}

// Recursively creates a tree that contains the given tree.
function parentise(tree, h)
{
	if (h === tree.height)
	{
		return tree;
	}

	return {
		ctor: '_Array',
		height: h,
		table: [parentise(tree, h - 1)],
		lengths: [length(tree)]
	};
}

// Emphasizes blood brotherhood beneath two trees.
function siblise(a, b)
{
	return {
		ctor: '_Array',
		height: a.height + 1,
		table: [a, b],
		lengths: [length(a), length(a) + length(b)]
	};
}

function toJSArray(a)
{
	var jsArray = new Array(length(a));
	toJSArray_(jsArray, 0, a);
	return jsArray;
}

function toJSArray_(jsArray, i, a)
{
	for (var t = 0; t < a.table.length; t++)
	{
		if (a.height === 0)
		{
			jsArray[i + t] = a.table[t];
		}
		else
		{
			var inc = t === 0 ? 0 : a.lengths[t - 1];
			toJSArray_(jsArray, i + inc, a.table[t]);
		}
	}
}

function fromJSArray(jsArray)
{
	if (jsArray.length === 0)
	{
		return empty;
	}
	var h = Math.floor(Math.log(jsArray.length) / Math.log(M));
	return fromJSArray_(jsArray, h, 0, jsArray.length);
}

function fromJSArray_(jsArray, h, from, to)
{
	if (h === 0)
	{
		return {
			ctor: '_Array',
			height: 0,
			table: jsArray.slice(from, to)
		};
	}

	var step = Math.pow(M, h);
	var table = new Array(Math.ceil((to - from) / step));
	var lengths = new Array(table.length);
	for (var i = 0; i < table.length; i++)
	{
		table[i] = fromJSArray_(jsArray, h - 1, from + (i * step), Math.min(from + ((i + 1) * step), to));
		lengths[i] = length(table[i]) + (i > 0 ? lengths[i - 1] : 0);
	}
	return {
		ctor: '_Array',
		height: h,
		table: table,
		lengths: lengths
	};
}

return {
	empty: empty,
	fromList: fromList,
	toList: toList,
	initialize: F2(initialize),
	append: F2(append),
	push: F2(push),
	slice: F3(slice),
	get: F2(get),
	set: F3(set),
	map: F2(map),
	indexedMap: F2(indexedMap),
	foldl: F3(foldl),
	foldr: F3(foldr),
	length: length,

	toJSArray: toJSArray,
	fromJSArray: fromJSArray
};

}();
var _elm_lang$core$Array$append = _elm_lang$core$Native_Array.append;
var _elm_lang$core$Array$length = _elm_lang$core$Native_Array.length;
var _elm_lang$core$Array$isEmpty = function (array) {
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Array$length(array),
		0);
};
var _elm_lang$core$Array$slice = _elm_lang$core$Native_Array.slice;
var _elm_lang$core$Array$set = _elm_lang$core$Native_Array.set;
var _elm_lang$core$Array$get = F2(
	function (i, array) {
		return ((_elm_lang$core$Native_Utils.cmp(0, i) < 1) && (_elm_lang$core$Native_Utils.cmp(
			i,
			_elm_lang$core$Native_Array.length(array)) < 0)) ? _elm_lang$core$Maybe$Just(
			A2(_elm_lang$core$Native_Array.get, i, array)) : _elm_lang$core$Maybe$Nothing;
	});
var _elm_lang$core$Array$push = _elm_lang$core$Native_Array.push;
var _elm_lang$core$Array$empty = _elm_lang$core$Native_Array.empty;
var _elm_lang$core$Array$filter = F2(
	function (isOkay, arr) {
		var update = F2(
			function (x, xs) {
				return isOkay(x) ? A2(_elm_lang$core$Native_Array.push, x, xs) : xs;
			});
		return A3(_elm_lang$core$Native_Array.foldl, update, _elm_lang$core$Native_Array.empty, arr);
	});
var _elm_lang$core$Array$foldr = _elm_lang$core$Native_Array.foldr;
var _elm_lang$core$Array$foldl = _elm_lang$core$Native_Array.foldl;
var _elm_lang$core$Array$indexedMap = _elm_lang$core$Native_Array.indexedMap;
var _elm_lang$core$Array$map = _elm_lang$core$Native_Array.map;
var _elm_lang$core$Array$toIndexedList = function (array) {
	return A3(
		_elm_lang$core$List$map2,
		F2(
			function (v0, v1) {
				return {ctor: '_Tuple2', _0: v0, _1: v1};
			}),
		A2(
			_elm_lang$core$List$range,
			0,
			_elm_lang$core$Native_Array.length(array) - 1),
		_elm_lang$core$Native_Array.toList(array));
};
var _elm_lang$core$Array$toList = _elm_lang$core$Native_Array.toList;
var _elm_lang$core$Array$fromList = _elm_lang$core$Native_Array.fromList;
var _elm_lang$core$Array$initialize = _elm_lang$core$Native_Array.initialize;
var _elm_lang$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			_elm_lang$core$Array$initialize,
			n,
			_elm_lang$core$Basics$always(e));
	});
var _elm_lang$core$Array$Array = {ctor: 'Array'};

//import Maybe, Native.Array, Native.List, Native.Utils, Result //

var _elm_lang$core$Native_Json = function() {


// CORE DECODERS

function succeed(msg)
{
	return {
		ctor: '<decoder>',
		tag: 'succeed',
		msg: msg
	};
}

function fail(msg)
{
	return {
		ctor: '<decoder>',
		tag: 'fail',
		msg: msg
	};
}

function decodePrimitive(tag)
{
	return {
		ctor: '<decoder>',
		tag: tag
	};
}

function decodeContainer(tag, decoder)
{
	return {
		ctor: '<decoder>',
		tag: tag,
		decoder: decoder
	};
}

function decodeNull(value)
{
	return {
		ctor: '<decoder>',
		tag: 'null',
		value: value
	};
}

function decodeField(field, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'field',
		field: field,
		decoder: decoder
	};
}

function decodeIndex(index, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'index',
		index: index,
		decoder: decoder
	};
}

function decodeKeyValuePairs(decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'key-value',
		decoder: decoder
	};
}

function mapMany(f, decoders)
{
	return {
		ctor: '<decoder>',
		tag: 'map-many',
		func: f,
		decoders: decoders
	};
}

function andThen(callback, decoder)
{
	return {
		ctor: '<decoder>',
		tag: 'andThen',
		decoder: decoder,
		callback: callback
	};
}

function oneOf(decoders)
{
	return {
		ctor: '<decoder>',
		tag: 'oneOf',
		decoders: decoders
	};
}


// DECODING OBJECTS

function map1(f, d1)
{
	return mapMany(f, [d1]);
}

function map2(f, d1, d2)
{
	return mapMany(f, [d1, d2]);
}

function map3(f, d1, d2, d3)
{
	return mapMany(f, [d1, d2, d3]);
}

function map4(f, d1, d2, d3, d4)
{
	return mapMany(f, [d1, d2, d3, d4]);
}

function map5(f, d1, d2, d3, d4, d5)
{
	return mapMany(f, [d1, d2, d3, d4, d5]);
}

function map6(f, d1, d2, d3, d4, d5, d6)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6]);
}

function map7(f, d1, d2, d3, d4, d5, d6, d7)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
}

function map8(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
}


// DECODE HELPERS

function ok(value)
{
	return { tag: 'ok', value: value };
}

function badPrimitive(type, value)
{
	return { tag: 'primitive', type: type, value: value };
}

function badIndex(index, nestedProblems)
{
	return { tag: 'index', index: index, rest: nestedProblems };
}

function badField(field, nestedProblems)
{
	return { tag: 'field', field: field, rest: nestedProblems };
}

function badIndex(index, nestedProblems)
{
	return { tag: 'index', index: index, rest: nestedProblems };
}

function badOneOf(problems)
{
	return { tag: 'oneOf', problems: problems };
}

function bad(msg)
{
	return { tag: 'fail', msg: msg };
}

function badToString(problem)
{
	var context = '_';
	while (problem)
	{
		switch (problem.tag)
		{
			case 'primitive':
				return 'Expecting ' + problem.type
					+ (context === '_' ? '' : ' at ' + context)
					+ ' but instead got: ' + jsToString(problem.value);

			case 'index':
				context += '[' + problem.index + ']';
				problem = problem.rest;
				break;

			case 'field':
				context += '.' + problem.field;
				problem = problem.rest;
				break;

			case 'oneOf':
				var problems = problem.problems;
				for (var i = 0; i < problems.length; i++)
				{
					problems[i] = badToString(problems[i]);
				}
				return 'I ran into the following problems'
					+ (context === '_' ? '' : ' at ' + context)
					+ ':\n\n' + problems.join('\n');

			case 'fail':
				return 'I ran into a `fail` decoder'
					+ (context === '_' ? '' : ' at ' + context)
					+ ': ' + problem.msg;
		}
	}
}

function jsToString(value)
{
	return value === undefined
		? 'undefined'
		: JSON.stringify(value);
}


// DECODE

function runOnString(decoder, string)
{
	var json;
	try
	{
		json = JSON.parse(string);
	}
	catch (e)
	{
		return _elm_lang$core$Result$Err('Given an invalid JSON: ' + e.message);
	}
	return run(decoder, json);
}

function run(decoder, value)
{
	var result = runHelp(decoder, value);
	return (result.tag === 'ok')
		? _elm_lang$core$Result$Ok(result.value)
		: _elm_lang$core$Result$Err(badToString(result));
}

function runHelp(decoder, value)
{
	switch (decoder.tag)
	{
		case 'bool':
			return (typeof value === 'boolean')
				? ok(value)
				: badPrimitive('a Bool', value);

		case 'int':
			if (typeof value !== 'number') {
				return badPrimitive('an Int', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return ok(value);
			}

			return badPrimitive('an Int', value);

		case 'float':
			return (typeof value === 'number')
				? ok(value)
				: badPrimitive('a Float', value);

		case 'string':
			return (typeof value === 'string')
				? ok(value)
				: (value instanceof String)
					? ok(value + '')
					: badPrimitive('a String', value);

		case 'null':
			return (value === null)
				? ok(decoder.value)
				: badPrimitive('null', value);

		case 'value':
			return ok(value);

		case 'list':
			if (!(value instanceof Array))
			{
				return badPrimitive('a List', value);
			}

			var list = _elm_lang$core$Native_List.Nil;
			for (var i = value.length; i--; )
			{
				var result = runHelp(decoder.decoder, value[i]);
				if (result.tag !== 'ok')
				{
					return badIndex(i, result)
				}
				list = _elm_lang$core$Native_List.Cons(result.value, list);
			}
			return ok(list);

		case 'array':
			if (!(value instanceof Array))
			{
				return badPrimitive('an Array', value);
			}

			var len = value.length;
			var array = new Array(len);
			for (var i = len; i--; )
			{
				var result = runHelp(decoder.decoder, value[i]);
				if (result.tag !== 'ok')
				{
					return badIndex(i, result);
				}
				array[i] = result.value;
			}
			return ok(_elm_lang$core$Native_Array.fromJSArray(array));

		case 'maybe':
			var result = runHelp(decoder.decoder, value);
			return (result.tag === 'ok')
				? ok(_elm_lang$core$Maybe$Just(result.value))
				: ok(_elm_lang$core$Maybe$Nothing);

		case 'field':
			var field = decoder.field;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return badPrimitive('an object with a field named `' + field + '`', value);
			}

			var result = runHelp(decoder.decoder, value[field]);
			return (result.tag === 'ok') ? result : badField(field, result);

		case 'index':
			var index = decoder.index;
			if (!(value instanceof Array))
			{
				return badPrimitive('an array', value);
			}
			if (index >= value.length)
			{
				return badPrimitive('a longer array. Need index ' + index + ' but there are only ' + value.length + ' entries', value);
			}

			var result = runHelp(decoder.decoder, value[index]);
			return (result.tag === 'ok') ? result : badIndex(index, result);

		case 'key-value':
			if (typeof value !== 'object' || value === null || value instanceof Array)
			{
				return badPrimitive('an object', value);
			}

			var keyValuePairs = _elm_lang$core$Native_List.Nil;
			for (var key in value)
			{
				var result = runHelp(decoder.decoder, value[key]);
				if (result.tag !== 'ok')
				{
					return badField(key, result);
				}
				var pair = _elm_lang$core$Native_Utils.Tuple2(key, result.value);
				keyValuePairs = _elm_lang$core$Native_List.Cons(pair, keyValuePairs);
			}
			return ok(keyValuePairs);

		case 'map-many':
			var answer = decoder.func;
			var decoders = decoder.decoders;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = runHelp(decoders[i], value);
				if (result.tag !== 'ok')
				{
					return result;
				}
				answer = answer(result.value);
			}
			return ok(answer);

		case 'andThen':
			var result = runHelp(decoder.decoder, value);
			return (result.tag !== 'ok')
				? result
				: runHelp(decoder.callback(result.value), value);

		case 'oneOf':
			var errors = [];
			var temp = decoder.decoders;
			while (temp.ctor !== '[]')
			{
				var result = runHelp(temp._0, value);

				if (result.tag === 'ok')
				{
					return result;
				}

				errors.push(result);

				temp = temp._1;
			}
			return badOneOf(errors);

		case 'fail':
			return bad(decoder.msg);

		case 'succeed':
			return ok(decoder.msg);
	}
}


// EQUALITY

function equality(a, b)
{
	if (a === b)
	{
		return true;
	}

	if (a.tag !== b.tag)
	{
		return false;
	}

	switch (a.tag)
	{
		case 'succeed':
		case 'fail':
			return a.msg === b.msg;

		case 'bool':
		case 'int':
		case 'float':
		case 'string':
		case 'value':
			return true;

		case 'null':
			return a.value === b.value;

		case 'list':
		case 'array':
		case 'maybe':
		case 'key-value':
			return equality(a.decoder, b.decoder);

		case 'field':
			return a.field === b.field && equality(a.decoder, b.decoder);

		case 'index':
			return a.index === b.index && equality(a.decoder, b.decoder);

		case 'map-many':
			if (a.func !== b.func)
			{
				return false;
			}
			return listEquality(a.decoders, b.decoders);

		case 'andThen':
			return a.callback === b.callback && equality(a.decoder, b.decoder);

		case 'oneOf':
			return listEquality(a.decoders, b.decoders);
	}
}

function listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

function encode(indentLevel, value)
{
	return JSON.stringify(value, null, indentLevel);
}

function identity(value)
{
	return value;
}

function encodeObject(keyValuePairs)
{
	var obj = {};
	while (keyValuePairs.ctor !== '[]')
	{
		var pair = keyValuePairs._0;
		obj[pair._0] = pair._1;
		keyValuePairs = keyValuePairs._1;
	}
	return obj;
}

return {
	encode: F2(encode),
	runOnString: F2(runOnString),
	run: F2(run),

	decodeNull: decodeNull,
	decodePrimitive: decodePrimitive,
	decodeContainer: F2(decodeContainer),

	decodeField: F2(decodeField),
	decodeIndex: F2(decodeIndex),

	map1: F2(map1),
	map2: F3(map2),
	map3: F4(map3),
	map4: F5(map4),
	map5: F6(map5),
	map6: F7(map6),
	map7: F8(map7),
	map8: F9(map8),
	decodeKeyValuePairs: decodeKeyValuePairs,

	andThen: F2(andThen),
	fail: fail,
	succeed: succeed,
	oneOf: oneOf,

	identity: identity,
	encodeNull: null,
	encodeArray: _elm_lang$core$Native_Array.toJSArray,
	encodeList: _elm_lang$core$Native_List.toArray,
	encodeObject: encodeObject,

	equality: equality
};

}();

var _elm_lang$core$Json_Encode$list = _elm_lang$core$Native_Json.encodeList;
var _elm_lang$core$Json_Encode$array = _elm_lang$core$Native_Json.encodeArray;
var _elm_lang$core$Json_Encode$object = _elm_lang$core$Native_Json.encodeObject;
var _elm_lang$core$Json_Encode$null = _elm_lang$core$Native_Json.encodeNull;
var _elm_lang$core$Json_Encode$bool = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$float = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$int = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$string = _elm_lang$core$Native_Json.identity;
var _elm_lang$core$Json_Encode$encode = _elm_lang$core$Native_Json.encode;
var _elm_lang$core$Json_Encode$Value = {ctor: 'Value'};

var _elm_lang$core$Json_Decode$null = _elm_lang$core$Native_Json.decodeNull;
var _elm_lang$core$Json_Decode$value = _elm_lang$core$Native_Json.decodePrimitive('value');
var _elm_lang$core$Json_Decode$andThen = _elm_lang$core$Native_Json.andThen;
var _elm_lang$core$Json_Decode$fail = _elm_lang$core$Native_Json.fail;
var _elm_lang$core$Json_Decode$succeed = _elm_lang$core$Native_Json.succeed;
var _elm_lang$core$Json_Decode$lazy = function (thunk) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		thunk,
		_elm_lang$core$Json_Decode$succeed(
			{ctor: '_Tuple0'}));
};
var _elm_lang$core$Json_Decode$decodeValue = _elm_lang$core$Native_Json.run;
var _elm_lang$core$Json_Decode$decodeString = _elm_lang$core$Native_Json.runOnString;
var _elm_lang$core$Json_Decode$map8 = _elm_lang$core$Native_Json.map8;
var _elm_lang$core$Json_Decode$map7 = _elm_lang$core$Native_Json.map7;
var _elm_lang$core$Json_Decode$map6 = _elm_lang$core$Native_Json.map6;
var _elm_lang$core$Json_Decode$map5 = _elm_lang$core$Native_Json.map5;
var _elm_lang$core$Json_Decode$map4 = _elm_lang$core$Native_Json.map4;
var _elm_lang$core$Json_Decode$map3 = _elm_lang$core$Native_Json.map3;
var _elm_lang$core$Json_Decode$map2 = _elm_lang$core$Native_Json.map2;
var _elm_lang$core$Json_Decode$map = _elm_lang$core$Native_Json.map1;
var _elm_lang$core$Json_Decode$oneOf = _elm_lang$core$Native_Json.oneOf;
var _elm_lang$core$Json_Decode$maybe = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'maybe', decoder);
};
var _elm_lang$core$Json_Decode$index = _elm_lang$core$Native_Json.decodeIndex;
var _elm_lang$core$Json_Decode$field = _elm_lang$core$Native_Json.decodeField;
var _elm_lang$core$Json_Decode$at = F2(
	function (fields, decoder) {
		return A3(_elm_lang$core$List$foldr, _elm_lang$core$Json_Decode$field, decoder, fields);
	});
var _elm_lang$core$Json_Decode$keyValuePairs = _elm_lang$core$Native_Json.decodeKeyValuePairs;
var _elm_lang$core$Json_Decode$dict = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Dict$fromList,
		_elm_lang$core$Json_Decode$keyValuePairs(decoder));
};
var _elm_lang$core$Json_Decode$array = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'array', decoder);
};
var _elm_lang$core$Json_Decode$list = function (decoder) {
	return A2(_elm_lang$core$Native_Json.decodeContainer, 'list', decoder);
};
var _elm_lang$core$Json_Decode$nullable = function (decoder) {
	return _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, decoder),
				_1: {ctor: '[]'}
			}
		});
};
var _elm_lang$core$Json_Decode$float = _elm_lang$core$Native_Json.decodePrimitive('float');
var _elm_lang$core$Json_Decode$int = _elm_lang$core$Native_Json.decodePrimitive('int');
var _elm_lang$core$Json_Decode$bool = _elm_lang$core$Native_Json.decodePrimitive('bool');
var _elm_lang$core$Json_Decode$string = _elm_lang$core$Native_Json.decodePrimitive('string');
var _elm_lang$core$Json_Decode$Decoder = {ctor: 'Decoder'};

var _elm_lang$core$Debug$crash = _elm_lang$core$Native_Debug.crash;
var _elm_lang$core$Debug$log = _elm_lang$core$Native_Debug.log;

var _elm_lang$core$Tuple$mapSecond = F2(
	function (func, _p0) {
		var _p1 = _p0;
		return {
			ctor: '_Tuple2',
			_0: _p1._0,
			_1: func(_p1._1)
		};
	});
var _elm_lang$core$Tuple$mapFirst = F2(
	function (func, _p2) {
		var _p3 = _p2;
		return {
			ctor: '_Tuple2',
			_0: func(_p3._0),
			_1: _p3._1
		};
	});
var _elm_lang$core$Tuple$second = function (_p4) {
	var _p5 = _p4;
	return _p5._1;
};
var _elm_lang$core$Tuple$first = function (_p6) {
	var _p7 = _p6;
	return _p7._0;
};

var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode = _elm_lang$core$Json_Decode$succeed;
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$resolve = _elm_lang$core$Json_Decode$andThen(_elm_lang$core$Basics$identity);
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom = F2(
	function (decoder, wrapped) {
		return A3(
			_elm_lang$core$Json_Decode$map2,
			F2(
				function (x, y) {
					return x(y);
				}),
			wrapped,
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded = function (_p0) {
	return _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom(
		_elm_lang$core$Json_Decode$succeed(_p0));
};
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return _elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: decoder,
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$null(fallback),
						_1: {ctor: '[]'}
					}
				});
		};
		var handleResult = function (input) {
			var _p1 = A2(_elm_lang$core$Json_Decode$decodeValue, pathDecoder, input);
			if (_p1.ctor === 'Ok') {
				var _p2 = A2(
					_elm_lang$core$Json_Decode$decodeValue,
					nullOr(valDecoder),
					_p1._0);
				if (_p2.ctor === 'Ok') {
					return _elm_lang$core$Json_Decode$succeed(_p2._0);
				} else {
					return _elm_lang$core$Json_Decode$fail(_p2._0);
				}
			} else {
				var _p3 = A2(
					_elm_lang$core$Json_Decode$decodeValue,
					_elm_lang$core$Json_Decode$keyValuePairs(_elm_lang$core$Json_Decode$value),
					input);
				if (_p3.ctor === 'Ok') {
					return _elm_lang$core$Json_Decode$succeed(fallback);
				} else {
					return _elm_lang$core$Json_Decode$fail(_p3._0);
				}
			}
		};
		return A2(_elm_lang$core$Json_Decode$andThen, handleResult, _elm_lang$core$Json_Decode$value);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalDecoder,
				A2(_elm_lang$core$Json_Decode$at, path, _elm_lang$core$Json_Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optionalDecoder,
				A2(_elm_lang$core$Json_Decode$field, key, _elm_lang$core$Json_Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A2(_elm_lang$core$Json_Decode$at, path, valDecoder),
			decoder);
	});
var _NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A2(_elm_lang$core$Json_Decode$field, key, valDecoder),
			decoder);
	});

var _rluiten$elm_date_extra$Date_Extra_Internal2$prevMonth = function (month) {
	var _p0 = month;
	switch (_p0.ctor) {
		case 'Jan':
			return _elm_lang$core$Date$Dec;
		case 'Feb':
			return _elm_lang$core$Date$Jan;
		case 'Mar':
			return _elm_lang$core$Date$Feb;
		case 'Apr':
			return _elm_lang$core$Date$Mar;
		case 'May':
			return _elm_lang$core$Date$Apr;
		case 'Jun':
			return _elm_lang$core$Date$May;
		case 'Jul':
			return _elm_lang$core$Date$Jun;
		case 'Aug':
			return _elm_lang$core$Date$Jul;
		case 'Sep':
			return _elm_lang$core$Date$Aug;
		case 'Oct':
			return _elm_lang$core$Date$Sep;
		case 'Nov':
			return _elm_lang$core$Date$Oct;
		default:
			return _elm_lang$core$Date$Nov;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$nextMonth = function (month) {
	var _p1 = month;
	switch (_p1.ctor) {
		case 'Jan':
			return _elm_lang$core$Date$Feb;
		case 'Feb':
			return _elm_lang$core$Date$Mar;
		case 'Mar':
			return _elm_lang$core$Date$Apr;
		case 'Apr':
			return _elm_lang$core$Date$May;
		case 'May':
			return _elm_lang$core$Date$Jun;
		case 'Jun':
			return _elm_lang$core$Date$Jul;
		case 'Jul':
			return _elm_lang$core$Date$Aug;
		case 'Aug':
			return _elm_lang$core$Date$Sep;
		case 'Sep':
			return _elm_lang$core$Date$Oct;
		case 'Oct':
			return _elm_lang$core$Date$Nov;
		case 'Nov':
			return _elm_lang$core$Date$Dec;
		default:
			return _elm_lang$core$Date$Jan;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$intToMonth = function (month) {
	return (_elm_lang$core$Native_Utils.cmp(month, 1) < 1) ? _elm_lang$core$Date$Jan : (_elm_lang$core$Native_Utils.eq(month, 2) ? _elm_lang$core$Date$Feb : (_elm_lang$core$Native_Utils.eq(month, 3) ? _elm_lang$core$Date$Mar : (_elm_lang$core$Native_Utils.eq(month, 4) ? _elm_lang$core$Date$Apr : (_elm_lang$core$Native_Utils.eq(month, 5) ? _elm_lang$core$Date$May : (_elm_lang$core$Native_Utils.eq(month, 6) ? _elm_lang$core$Date$Jun : (_elm_lang$core$Native_Utils.eq(month, 7) ? _elm_lang$core$Date$Jul : (_elm_lang$core$Native_Utils.eq(month, 8) ? _elm_lang$core$Date$Aug : (_elm_lang$core$Native_Utils.eq(month, 9) ? _elm_lang$core$Date$Sep : (_elm_lang$core$Native_Utils.eq(month, 10) ? _elm_lang$core$Date$Oct : (_elm_lang$core$Native_Utils.eq(month, 11) ? _elm_lang$core$Date$Nov : _elm_lang$core$Date$Dec))))))))));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$monthToInt = function (month) {
	var _p2 = month;
	switch (_p2.ctor) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear = function (year) {
	return (_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], year, 4),
		0) && (!_elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], year, 100),
		0))) || _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], year, 400),
		0);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYearDate = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear(
		_elm_lang$core$Date$year(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$yearToDayLength = function (year) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear(year) ? 366 : 365;
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth = F2(
	function (year, month) {
		var _p3 = month;
		switch (_p3.ctor) {
			case 'Jan':
				return 31;
			case 'Feb':
				return _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear(year) ? 29 : 28;
			case 'Mar':
				return 31;
			case 'Apr':
				return 30;
			case 'May':
				return 31;
			case 'Jun':
				return 30;
			case 'Jul':
				return 31;
			case 'Aug':
				return 31;
			case 'Sep':
				return 30;
			case 'Oct':
				return 31;
			case 'Nov':
				return 30;
			default:
				return 31;
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$monthList = {
	ctor: '::',
	_0: _elm_lang$core$Date$Jan,
	_1: {
		ctor: '::',
		_0: _elm_lang$core$Date$Feb,
		_1: {
			ctor: '::',
			_0: _elm_lang$core$Date$Mar,
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Date$Apr,
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Date$May,
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Date$Jun,
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Date$Jul,
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Date$Aug,
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Date$Sep,
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Date$Oct,
										_1: {
											ctor: '::',
											_0: _elm_lang$core$Date$Nov,
											_1: {
												ctor: '::',
												_0: _elm_lang$core$Date$Dec,
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$toTime = function (_p4) {
	return _elm_lang$core$Basics$floor(
		_elm_lang$core$Date$toTime(_p4));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime = function (_p5) {
	return _elm_lang$core$Date$fromTime(
		_elm_lang$core$Basics$toFloat(_p5));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$prevDay = function (day) {
	var _p6 = day;
	switch (_p6.ctor) {
		case 'Mon':
			return _elm_lang$core$Date$Sun;
		case 'Tue':
			return _elm_lang$core$Date$Mon;
		case 'Wed':
			return _elm_lang$core$Date$Tue;
		case 'Thu':
			return _elm_lang$core$Date$Wed;
		case 'Fri':
			return _elm_lang$core$Date$Thu;
		case 'Sat':
			return _elm_lang$core$Date$Fri;
		default:
			return _elm_lang$core$Date$Sat;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$nextDay = function (day) {
	var _p7 = day;
	switch (_p7.ctor) {
		case 'Mon':
			return _elm_lang$core$Date$Tue;
		case 'Tue':
			return _elm_lang$core$Date$Wed;
		case 'Wed':
			return _elm_lang$core$Date$Thu;
		case 'Thu':
			return _elm_lang$core$Date$Fri;
		case 'Fri':
			return _elm_lang$core$Date$Sat;
		case 'Sat':
			return _elm_lang$core$Date$Sun;
		default:
			return _elm_lang$core$Date$Mon;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$isoDayOfWeek = function (day) {
	var _p8 = day;
	switch (_p8.ctor) {
		case 'Mon':
			return 1;
		case 'Tue':
			return 2;
		case 'Wed':
			return 3;
		case 'Thu':
			return 4;
		case 'Fri':
			return 5;
		case 'Sat':
			return 6;
		default:
			return 7;
	}
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond = _elm_lang$core$Basics$floor(_elm_lang$core$Time$millisecond);
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond * 1000;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond * 60;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute * 60;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour * 24;
var _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay * 7;
var _rluiten$elm_date_extra$Date_Extra_Internal2$lastOfMonthTicks = function (date) {
	var dateTicks = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date);
	var day = _elm_lang$core$Date$day(date);
	var month = _elm_lang$core$Date$month(date);
	var year = _elm_lang$core$Date$year(date);
	var daysInMonthVal = A2(_rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth, year, month);
	var addDays = daysInMonthVal - day;
	return dateTicks + (addDays * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$firstOfNextMonthDate = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
		_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfMonthTicks(date) + _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInNextMonth = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate(
		_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfNextMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$firstOfMonthTicks = function (date) {
	var dateTicks = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date);
	var day = _elm_lang$core$Date$day(date);
	return dateTicks + ((1 - day) * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$lastOfPrevMonthDate = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
		_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfMonthTicks(date) - _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay);
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$daysInPrevMonth = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate(
		_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfPrevMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal2$epochDateStr = '1970-01-01T00:00:00Z';

var _rluiten$elm_date_extra$Date_Extra_Period$diff = F2(
	function (date1, date2) {
		var millisecondDiff = _elm_lang$core$Date$millisecond(date1) - _elm_lang$core$Date$millisecond(date2);
		var secondDiff = _elm_lang$core$Date$second(date1) - _elm_lang$core$Date$second(date2);
		var minuteDiff = _elm_lang$core$Date$minute(date1) - _elm_lang$core$Date$minute(date2);
		var hourDiff = _elm_lang$core$Date$hour(date1) - _elm_lang$core$Date$hour(date2);
		var ticksDiff = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date1) - _rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date2);
		var ticksDayDiff = (((ticksDiff - (hourDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour)) - (minuteDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute)) - (secondDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond)) - (millisecondDiff * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond);
		var onlyDaysDiff = (ticksDayDiff / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay) | 0;
		var _p0 = function () {
			if (_elm_lang$core$Native_Utils.cmp(onlyDaysDiff, 0) < 0) {
				var absDayDiff = _elm_lang$core$Basics$abs(onlyDaysDiff);
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Basics$negate((absDayDiff / 7) | 0),
					_1: _elm_lang$core$Basics$negate(
						A2(_elm_lang$core$Basics_ops['%'], absDayDiff, 7))
				};
			} else {
				return {
					ctor: '_Tuple2',
					_0: (onlyDaysDiff / 7) | 0,
					_1: A2(_elm_lang$core$Basics_ops['%'], onlyDaysDiff, 7)
				};
			}
		}();
		var weekDiff = _p0._0;
		var dayDiff = _p0._1;
		return {week: weekDiff, day: dayDiff, hour: hourDiff, minute: minuteDiff, second: secondDiff, millisecond: millisecondDiff};
	});
var _rluiten$elm_date_extra$Date_Extra_Period$addTimeUnit = F3(
	function (unit, addend, date) {
		return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			A2(
				F2(
					function (x, y) {
						return x + y;
					}),
				addend * unit,
				_rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date)));
	});
var _rluiten$elm_date_extra$Date_Extra_Period$toTicks = function (period) {
	var _p1 = period;
	switch (_p1.ctor) {
		case 'Millisecond':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond;
		case 'Second':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond;
		case 'Minute':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute;
		case 'Hour':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour;
		case 'Day':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay;
		case 'Week':
			return _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek;
		default:
			var _p2 = _p1._0;
			return (((((_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond * _p2.millisecond) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond * _p2.second)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute * _p2.minute)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour * _p2.hour)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay * _p2.day)) + (_rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek * _p2.week);
	}
};
var _rluiten$elm_date_extra$Date_Extra_Period$add = function (period) {
	return _rluiten$elm_date_extra$Date_Extra_Period$addTimeUnit(
		_rluiten$elm_date_extra$Date_Extra_Period$toTicks(period));
};
var _rluiten$elm_date_extra$Date_Extra_Period$zeroDelta = {week: 0, day: 0, hour: 0, minute: 0, second: 0, millisecond: 0};
var _rluiten$elm_date_extra$Date_Extra_Period$DeltaRecord = F6(
	function (a, b, c, d, e, f) {
		return {week: a, day: b, hour: c, minute: d, second: e, millisecond: f};
	});
var _rluiten$elm_date_extra$Date_Extra_Period$Delta = function (a) {
	return {ctor: 'Delta', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Period$Week = {ctor: 'Week'};
var _rluiten$elm_date_extra$Date_Extra_Period$Day = {ctor: 'Day'};
var _rluiten$elm_date_extra$Date_Extra_Period$Hour = {ctor: 'Hour'};
var _rluiten$elm_date_extra$Date_Extra_Period$Minute = {ctor: 'Minute'};
var _rluiten$elm_date_extra$Date_Extra_Period$Second = {ctor: 'Second'};
var _rluiten$elm_date_extra$Date_Extra_Period$Millisecond = {ctor: 'Millisecond'};

var _rluiten$elm_date_extra$Date_Extra_TypeAlias$TimeFromFields = F4(
	function (a, b, c, d) {
		return {hour: a, minute: b, second: c, millisecond: d};
	});
var _rluiten$elm_date_extra$Date_Extra_TypeAlias$DateFromFields = F7(
	function (a, b, c, d, e, f, g) {
		return {year: a, month: b, day: c, hour: d, minute: e, second: f, millisecond: g};
	});

var _rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil = F3(
	function (year, month, day) {
		var doy = (((((153 * (month + ((_elm_lang$core$Native_Utils.cmp(month, 2) > 0) ? -3 : 9))) + 2) / 5) | 0) + day) - 1;
		var y = year - ((_elm_lang$core$Native_Utils.cmp(month, 2) < 1) ? 1 : 0);
		var era = (((_elm_lang$core$Native_Utils.cmp(y, 0) > -1) ? y : (y - 399)) / 400) | 0;
		var yoe = y - (era * 400);
		var doe = (((yoe * 365) + ((yoe / 4) | 0)) - ((yoe / 100) | 0)) + doy;
		return ((era * 146097) + doe) - 719468;
	});
var _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		var monthInt = _rluiten$elm_date_extra$Date_Extra_Internal2$monthToInt(month);
		var clampYear = (_elm_lang$core$Native_Utils.cmp(year, 0) < 0) ? 0 : year;
		var clampDay = A3(
			_elm_lang$core$Basics$clamp,
			1,
			A2(_rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth, clampYear, month),
			day);
		var dayCount = A3(_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil, clampYear, monthInt, clampDay);
		return _rluiten$elm_date_extra$Date_Extra_Period$toTicks(
			_rluiten$elm_date_extra$Date_Extra_Period$Delta(
				{
					millisecond: A3(_elm_lang$core$Basics$clamp, 0, 999, millisecond),
					second: A3(_elm_lang$core$Basics$clamp, 0, 59, second),
					minute: A3(_elm_lang$core$Basics$clamp, 0, 59, minute),
					hour: A3(_elm_lang$core$Basics$clamp, 0, 23, hour),
					day: dayCount,
					week: 0
				}));
	});
var _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromDateFields = function (date) {
	return A7(
		_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields,
		_elm_lang$core$Date$year(date),
		_elm_lang$core$Date$month(date),
		_elm_lang$core$Date$day(date),
		_elm_lang$core$Date$hour(date),
		_elm_lang$core$Date$minute(date),
		_elm_lang$core$Date$second(date),
		_elm_lang$core$Date$millisecond(date));
};
var _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset = function (date) {
	var v1Ticks = _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromDateFields(date);
	var dateTicks = _elm_lang$core$Basics$floor(
		_elm_lang$core$Date$toTime(date));
	return ((dateTicks - v1Ticks) / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute) | 0;
};
var _rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFieldsRecord = function (_p0) {
	var _p1 = _p0;
	return A7(_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields, _p1.year, _p1.month, _p1.day, _p1.hour, _p1.minute, _p1.second, _p1.millisecond);
};
var _rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsOffset = F2(
	function (offsetMinutes, date) {
		return _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			A2(
				F2(
					function (x, y) {
						return x + y;
					}),
				offsetMinutes * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute,
				_rluiten$elm_date_extra$Date_Extra_Internal2$toTime(date)));
	});
var _rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsUtc = function (date) {
	var offset = _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset(date);
	var oHours = (offset / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour) | 0;
	var oMinutes = ((offset - (oHours * _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour)) / _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute) | 0;
	return A2(_rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsOffset, offset, date);
};

var _rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset = F2(
	function (date1, date2) {
		return A3(
			_rluiten$elm_date_extra$Date_Extra_Period$add,
			_rluiten$elm_date_extra$Date_Extra_Period$Minute,
			_rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset(date2) - _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset(date1),
			date2);
	});
var _rluiten$elm_date_extra$Date_Extra_Core$lastOfMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfMonthTicks(date)));
};
var _rluiten$elm_date_extra$Date_Extra_Core$toFirstOfMonth = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$fromTime(
			_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfMonthTicks(date)));
};
var _rluiten$elm_date_extra$Date_Extra_Core$lastOfPrevMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$lastOfPrevMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Core$firstOfNextMonthDate = function (date) {
	return A2(
		_rluiten$elm_date_extra$Date_Extra_Core$compensateZoneOffset,
		date,
		_rluiten$elm_date_extra$Date_Extra_Internal2$firstOfNextMonthDate(date));
};
var _rluiten$elm_date_extra$Date_Extra_Core$yearToDayLength = _rluiten$elm_date_extra$Date_Extra_Internal2$yearToDayLength;
var _rluiten$elm_date_extra$Date_Extra_Core$toTime = _rluiten$elm_date_extra$Date_Extra_Internal2$toTime;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAWeek = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAWeek;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksASecond = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksASecond;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMinute;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAMillisecond = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAMillisecond;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksADay = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksADay;
var _rluiten$elm_date_extra$Date_Extra_Core$ticksAnHour = _rluiten$elm_date_extra$Date_Extra_Internal2$ticksAnHour;
var _rluiten$elm_date_extra$Date_Extra_Core$prevMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$prevMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$prevDay = _rluiten$elm_date_extra$Date_Extra_Internal2$prevDay;
var _rluiten$elm_date_extra$Date_Extra_Core$nextMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$nextMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$nextDay = _rluiten$elm_date_extra$Date_Extra_Internal2$nextDay;
var _rluiten$elm_date_extra$Date_Extra_Core$monthToInt = _rluiten$elm_date_extra$Date_Extra_Internal2$monthToInt;
var _rluiten$elm_date_extra$Date_Extra_Core$monthList = _rluiten$elm_date_extra$Date_Extra_Internal2$monthList;
var _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek = _rluiten$elm_date_extra$Date_Extra_Internal2$isoDayOfWeek;
var _rluiten$elm_date_extra$Date_Extra_Core$daysBackToStartOfWeek = F2(
	function (dateDay, startOfWeekDay) {
		var startOfWeekDayIndex = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(startOfWeekDay);
		var dateDayIndex = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(dateDay);
		return (_elm_lang$core$Native_Utils.cmp(dateDayIndex, startOfWeekDayIndex) < 0) ? ((7 + dateDayIndex) - startOfWeekDayIndex) : (dateDayIndex - startOfWeekDayIndex);
	});
var _rluiten$elm_date_extra$Date_Extra_Core$isLeapYearDate = _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYearDate;
var _rluiten$elm_date_extra$Date_Extra_Core$isLeapYear = _rluiten$elm_date_extra$Date_Extra_Internal2$isLeapYear;
var _rluiten$elm_date_extra$Date_Extra_Core$intToMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$intToMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$fromTime = _rluiten$elm_date_extra$Date_Extra_Internal2$fromTime;
var _rluiten$elm_date_extra$Date_Extra_Core$epochDateStr = _rluiten$elm_date_extra$Date_Extra_Internal2$epochDateStr;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonthDate;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInPrevMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInPrevMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInNextMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInNextMonth;
var _rluiten$elm_date_extra$Date_Extra_Core$daysInMonth = _rluiten$elm_date_extra$Date_Extra_Internal2$daysInMonth;

var _rluiten$elm_date_extra$Date_Extra_Compare$is3 = F4(
	function (comp, date1, date2, date3) {
		var time3 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date3);
		var time2 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date2);
		var highBound = A2(_elm_lang$core$Basics$max, time2, time3);
		var lowBound = A2(_elm_lang$core$Basics$min, time2, time3);
		var time1 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date1);
		var _p0 = comp;
		switch (_p0.ctor) {
			case 'Between':
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > 0) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 0);
			case 'BetweenOpenStart':
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > -1) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 0);
			case 'BetweenOpenEnd':
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > 0) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 1);
			default:
				return (_elm_lang$core$Native_Utils.cmp(time1, lowBound) > -1) && (_elm_lang$core$Native_Utils.cmp(time1, highBound) < 1);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Compare$is = F3(
	function (comp, date1, date2) {
		var time2 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date2);
		var time1 = _rluiten$elm_date_extra$Date_Extra_Core$toTime(date1);
		var _p1 = comp;
		switch (_p1.ctor) {
			case 'Before':
				return _elm_lang$core$Native_Utils.cmp(time1, time2) < 0;
			case 'After':
				return _elm_lang$core$Native_Utils.cmp(time1, time2) > 0;
			case 'Same':
				return _elm_lang$core$Native_Utils.eq(time1, time2);
			case 'SameOrBefore':
				return _elm_lang$core$Native_Utils.cmp(time1, time2) < 1;
			default:
				return _elm_lang$core$Native_Utils.cmp(time1, time2) > -1;
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Compare$SameOrBefore = {ctor: 'SameOrBefore'};
var _rluiten$elm_date_extra$Date_Extra_Compare$SameOrAfter = {ctor: 'SameOrAfter'};
var _rluiten$elm_date_extra$Date_Extra_Compare$Same = {ctor: 'Same'};
var _rluiten$elm_date_extra$Date_Extra_Compare$Before = {ctor: 'Before'};
var _rluiten$elm_date_extra$Date_Extra_Compare$After = {ctor: 'After'};
var _rluiten$elm_date_extra$Date_Extra_Compare$BetweenOpen = {ctor: 'BetweenOpen'};
var _rluiten$elm_date_extra$Date_Extra_Compare$BetweenOpenEnd = {ctor: 'BetweenOpenEnd'};
var _rluiten$elm_date_extra$Date_Extra_Compare$BetweenOpenStart = {ctor: 'BetweenOpenStart'};
var _rluiten$elm_date_extra$Date_Extra_Compare$Between = {ctor: 'Between'};

var _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$PM = {ctor: 'PM'};
var _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$AM = {ctor: 'AM'};
var _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$twelveHourPeriod = function (d) {
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$Date$hour(d),
		12) < 0) ? _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$AM : _rluiten$elm_date_extra$Date_Extra_TwelveHourClock$PM;
};

var _rluiten$elm_date_extra$Date_Extra_Config$Config = F2(
	function (a, b) {
		return {i18n: a, format: b};
	});

var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayOfMonthWithSuffix = F2(
	function (pad, day) {
		var value = function () {
			var _p0 = day;
			switch (_p0) {
				case 1:
					return '1st';
				case 21:
					return '21st';
				case 2:
					return '2nd';
				case 22:
					return '22nd';
				case 3:
					return '3rd';
				case 23:
					return '23rd';
				case 31:
					return '31st';
				default:
					return A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(day),
						'th');
			}
		}();
		return pad ? A3(
			_elm_lang$core$String$padLeft,
			4,
			_elm_lang$core$Native_Utils.chr(' '),
			value) : value;
	});
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthName = function (month) {
	var _p1 = month;
	switch (_p1.ctor) {
		case 'Jan':
			return 'January';
		case 'Feb':
			return 'February';
		case 'Mar':
			return 'March';
		case 'Apr':
			return 'April';
		case 'May':
			return 'May';
		case 'Jun':
			return 'June';
		case 'Jul':
			return 'July';
		case 'Aug':
			return 'August';
		case 'Sep':
			return 'September';
		case 'Oct':
			return 'October';
		case 'Nov':
			return 'November';
		default:
			return 'December';
	}
};
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthShort = function (month) {
	var _p2 = month;
	switch (_p2.ctor) {
		case 'Jan':
			return 'Jan';
		case 'Feb':
			return 'Feb';
		case 'Mar':
			return 'Mar';
		case 'Apr':
			return 'Apr';
		case 'May':
			return 'May';
		case 'Jun':
			return 'Jun';
		case 'Jul':
			return 'Jul';
		case 'Aug':
			return 'Aug';
		case 'Sep':
			return 'Sep';
		case 'Oct':
			return 'Oct';
		case 'Nov':
			return 'Nov';
		default:
			return 'Dec';
	}
};
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayName = function (day) {
	var _p3 = day;
	switch (_p3.ctor) {
		case 'Mon':
			return 'Monday';
		case 'Tue':
			return 'Tuesday';
		case 'Wed':
			return 'Wednesday';
		case 'Thu':
			return 'Thursday';
		case 'Fri':
			return 'Friday';
		case 'Sat':
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayShort = function (day) {
	var _p4 = day;
	switch (_p4.ctor) {
		case 'Mon':
			return 'Mon';
		case 'Tue':
			return 'Tue';
		case 'Wed':
			return 'Wed';
		case 'Thu':
			return 'Thu';
		case 'Fri':
			return 'Fri';
		case 'Sat':
			return 'Sat';
		default:
			return 'Sun';
	}
};

var _rluiten$elm_date_extra$Date_Extra_I18n_I_default$twelveHourPeriod = function (period) {
	var _p0 = period;
	if (_p0.ctor === 'AM') {
		return 'AM';
	} else {
		return 'PM';
	}
};

var _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config = {
	i18n: {dayShort: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayShort, dayName: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayName, monthShort: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthShort, monthName: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$monthName, dayOfMonthWithSuffix: _rluiten$elm_date_extra$Date_Extra_I18n_I_en_us$dayOfMonthWithSuffix, twelveHourPeriod: _rluiten$elm_date_extra$Date_Extra_I18n_I_default$twelveHourPeriod},
	format: {date: '%-m/%-d/%Y', longDate: '%A, %B %d, %Y', time: '%-I:%M %p', longTime: '%-I:%M:%S %p', dateTime: '%-m/%-d/%Y %-I:%M %p', firstDayOfWeek: _elm_lang$core$Date$Sun}
};

var _rluiten$elm_date_extra$Date_Extra_Create$epochDate = _elm_lang$core$Date$fromTime(0);
var _rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset = function () {
	var inMinutes = (_elm_lang$core$Date$hour(_rluiten$elm_date_extra$Date_Extra_Create$epochDate) * 60) + _elm_lang$core$Date$minute(_rluiten$elm_date_extra$Date_Extra_Create$epochDate);
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$Date$year(_rluiten$elm_date_extra$Date_Extra_Create$epochDate),
		1969) ? (0 - (inMinutes - (24 * 60))) : (0 - inMinutes);
}();
var _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset = _rluiten$elm_date_extra$Date_Extra_Internal$getTimezoneOffset;
var _rluiten$elm_date_extra$Date_Extra_Create$adjustedTicksToDate = function (ticks) {
	var date = A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Millisecond, ticks + (_rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset * _rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute), _rluiten$elm_date_extra$Date_Extra_Create$epochDate);
	var dateOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date);
	return _elm_lang$core$Native_Utils.eq(dateOffset, _rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset) ? date : A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Minute, dateOffset - _rluiten$elm_date_extra$Date_Extra_Create$epochTimezoneOffset, date);
};
var _rluiten$elm_date_extra$Date_Extra_Create$dateFromFields = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return _rluiten$elm_date_extra$Date_Extra_Create$adjustedTicksToDate(
			A7(_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFields, year, month, day, hour, minute, second, millisecond));
	});
var _rluiten$elm_date_extra$Date_Extra_Create$timeFromFields = A3(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, 1970, _elm_lang$core$Date$Jan, 1);
var _rluiten$elm_date_extra$Date_Extra_Create$timeFromFieldsRecord = function (_p0) {
	var _p1 = _p0;
	return A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, 1970, _elm_lang$core$Date$Jan, 1, _p1.hour, _p1.minute, _p1.second, _p1.millisecond);
};
var _rluiten$elm_date_extra$Date_Extra_Create$dateFromFieldsRecord = function (_p2) {
	return _rluiten$elm_date_extra$Date_Extra_Create$adjustedTicksToDate(
		_rluiten$elm_date_extra$Date_Extra_Internal$ticksFromFieldsRecord(_p2));
};

var _rluiten$elm_date_extra$Date_Extra_Duration$positiveDiffDays = F3(
	function (date1, date2, multiplier) {
		var date2DaysFromCivil = A3(
			_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil,
			_elm_lang$core$Date$year(date2),
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
				_elm_lang$core$Date$month(date2)),
			_elm_lang$core$Date$day(date2));
		var date1DaysFromCivil = A3(
			_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil,
			_elm_lang$core$Date$year(date1),
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
				_elm_lang$core$Date$month(date1)),
			_elm_lang$core$Date$day(date1));
		return (date1DaysFromCivil - date2DaysFromCivil) * multiplier;
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$diffDays = F2(
	function (date1, date2) {
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$After, date1, date2) ? A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiffDays, date1, date2, 1) : A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiffDays, date2, date1, -1);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$positiveDiff = F3(
	function (date1, date2, multiplier) {
		var propogateCarry = F3(
			function (current, carry, maxVal) {
				var adjusted = current + carry;
				return (_elm_lang$core$Native_Utils.cmp(adjusted, 0) < 0) ? {ctor: '_Tuple2', _0: maxVal + adjusted, _1: -1} : {ctor: '_Tuple2', _0: adjusted, _1: 0};
			});
		var accumulatedDiff = F4(
			function (acc, v1, v2, maxV2) {
				return (_elm_lang$core$Native_Utils.cmp(v1, v2) < 0) ? {ctor: '_Tuple2', _0: acc - 1, _1: (maxV2 + v1) - v2} : {ctor: '_Tuple2', _0: acc, _1: v1 - v2};
			});
		var msec2 = _elm_lang$core$Date$millisecond(date2);
		var msec1 = _elm_lang$core$Date$millisecond(date1);
		var second2 = _elm_lang$core$Date$second(date2);
		var second1 = _elm_lang$core$Date$second(date1);
		var minute2 = _elm_lang$core$Date$minute(date2);
		var minute1 = _elm_lang$core$Date$minute(date1);
		var hour2 = _elm_lang$core$Date$hour(date2);
		var hour1 = _elm_lang$core$Date$hour(date1);
		var day2 = _elm_lang$core$Date$day(date2);
		var day1 = _elm_lang$core$Date$day(date1);
		var month2Mon = _elm_lang$core$Date$month(date2);
		var month2 = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month2Mon);
		var month1Mon = _elm_lang$core$Date$month(date1);
		var month1 = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month1Mon);
		var year2 = _elm_lang$core$Date$year(date2);
		var daysInDate2Month = A2(_rluiten$elm_date_extra$Date_Extra_Core$daysInMonth, year2, month2Mon);
		var year1 = _elm_lang$core$Date$year(date1);
		var daysInDate1Month = A2(_rluiten$elm_date_extra$Date_Extra_Core$daysInMonth, year1, month1Mon);
		var _p0 = A4(accumulatedDiff, year1 - year2, month1, month2, 12);
		var yearDiff = _p0._0;
		var monthDiffA = _p0._1;
		var _p1 = A4(accumulatedDiff, monthDiffA, day1, day2, daysInDate2Month);
		var monthDiff = _p1._0;
		var dayDiffA = _p1._1;
		var _p2 = A4(accumulatedDiff, dayDiffA, hour1, hour2, 24);
		var dayDiff = _p2._0;
		var hourDiffA = _p2._1;
		var _p3 = A4(accumulatedDiff, hourDiffA, minute1, minute2, 60);
		var hourDiff = _p3._0;
		var minuteDiffA = _p3._1;
		var _p4 = A4(accumulatedDiff, minuteDiffA, second1, second2, 60);
		var minuteDiff = _p4._0;
		var secondDiffA = _p4._1;
		var _p5 = A4(accumulatedDiff, secondDiffA, msec1, msec2, 1000);
		var secondDiff = _p5._0;
		var msecDiff = _p5._1;
		var _p6 = A3(propogateCarry, msecDiff, 0, 1000);
		var msecX = _p6._0;
		var secondCarry = _p6._1;
		var _p7 = A3(propogateCarry, secondDiff, secondCarry, 60);
		var secondX = _p7._0;
		var minuteCarry = _p7._1;
		var _p8 = A3(propogateCarry, minuteDiff, minuteCarry, 60);
		var minuteX = _p8._0;
		var hourCarry = _p8._1;
		var _p9 = A3(propogateCarry, hourDiff, hourCarry, 60);
		var hourX = _p9._0;
		var dayCarry = _p9._1;
		var _p10 = A3(propogateCarry, dayDiff, dayCarry, daysInDate1Month);
		var dayX = _p10._0;
		var monthCarry = _p10._1;
		var _p11 = A3(propogateCarry, monthDiff, monthCarry, 12);
		var monthX = _p11._0;
		var yearCarry = _p11._1;
		var _p12 = A3(propogateCarry, yearDiff, yearCarry, 0);
		var yearX = _p12._0;
		return {year: yearX * multiplier, month: monthX * multiplier, day: dayX * multiplier, hour: hourX * multiplier, minute: minuteX * multiplier, second: secondX * multiplier, millisecond: msecX * multiplier};
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$diff = F2(
	function (date1, date2) {
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$After, date1, date2) ? A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiff, date1, date2, 1) : A3(_rluiten$elm_date_extra$Date_Extra_Duration$positiveDiff, date2, date1, -1);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$addMonth = F2(
	function (monthCount, date) {
		var day = _elm_lang$core$Date$day(date);
		var monthInt = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
			_elm_lang$core$Date$month(date));
		var newMonthInt = monthInt + monthCount;
		var targetMonthInt = A2(_elm_lang$core$Basics_ops['%'], newMonthInt, 12);
		var yearOffset = ((_elm_lang$core$Native_Utils.cmp(newMonthInt, 0) < 0) && (!_elm_lang$core$Native_Utils.eq(targetMonthInt, 0))) ? (((newMonthInt / 12) | 0) - 1) : ((newMonthInt / 12) | 0);
		var year = _elm_lang$core$Date$year(date);
		var inputCivil = A3(_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil, year, monthInt, day);
		var newYear = year + yearOffset;
		var newDay = A2(
			_elm_lang$core$Basics$min,
			A2(
				_rluiten$elm_date_extra$Date_Extra_Core$daysInMonth,
				newYear,
				_rluiten$elm_date_extra$Date_Extra_Core$intToMonth(newMonthInt)),
			day);
		var newCivil = A3(_rluiten$elm_date_extra$Date_Extra_Internal$daysFromCivil, newYear, targetMonthInt, newDay);
		var daysDifferent = newCivil - inputCivil;
		return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Day, daysDifferent, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$addYear = F2(
	function (yearCount, date) {
		return A2(_rluiten$elm_date_extra$Date_Extra_Duration$addMonth, 12 * yearCount, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$daylightOffsetCompensate = F2(
	function (dateBefore, dateAfter) {
		var offsetAfter = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(dateAfter);
		var offsetBefore = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(dateBefore);
		if (!_elm_lang$core$Native_Utils.eq(offsetBefore, offsetAfter)) {
			var adjustedDate = A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Millisecond, (offsetAfter - offsetBefore) * _rluiten$elm_date_extra$Date_Extra_Core$ticksAMinute, dateAfter);
			var adjustedOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(adjustedDate);
			return (!_elm_lang$core$Native_Utils.eq(adjustedOffset, offsetAfter)) ? dateAfter : adjustedDate;
		} else {
			return dateAfter;
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$requireDaylightCompensateInAdd = function (duration) {
	var _p13 = duration;
	switch (_p13.ctor) {
		case 'Millisecond':
			return false;
		case 'Second':
			return false;
		case 'Minute':
			return false;
		case 'Hour':
			return false;
		case 'Day':
			return true;
		case 'Week':
			return true;
		case 'Month':
			return true;
		case 'Year':
			return true;
		default:
			var _p14 = _p13._0;
			return (!_elm_lang$core$Native_Utils.eq(_p14.day, 0)) || ((!_elm_lang$core$Native_Utils.eq(_p14.month, 0)) || (!_elm_lang$core$Native_Utils.eq(_p14.year, 0)));
	}
};
var _rluiten$elm_date_extra$Date_Extra_Duration$zeroDelta = {year: 0, month: 0, day: 0, hour: 0, minute: 0, second: 0, millisecond: 0};
var _rluiten$elm_date_extra$Date_Extra_Duration$DeltaRecord = F7(
	function (a, b, c, d, e, f, g) {
		return {year: a, month: b, day: c, hour: d, minute: e, second: f, millisecond: g};
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$Delta = function (a) {
	return {ctor: 'Delta', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Duration$Year = {ctor: 'Year'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Month = {ctor: 'Month'};
var _rluiten$elm_date_extra$Date_Extra_Duration$doAdd = F3(
	function (duration, addend, date) {
		var _p15 = duration;
		switch (_p15.ctor) {
			case 'Millisecond':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Millisecond, addend, date);
			case 'Second':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Second, addend, date);
			case 'Minute':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Minute, addend, date);
			case 'Hour':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Hour, addend, date);
			case 'Day':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Day, addend, date);
			case 'Week':
				return A3(_rluiten$elm_date_extra$Date_Extra_Period$add, _rluiten$elm_date_extra$Date_Extra_Period$Week, addend, date);
			case 'Month':
				return A2(_rluiten$elm_date_extra$Date_Extra_Duration$addMonth, addend, date);
			case 'Year':
				return A2(_rluiten$elm_date_extra$Date_Extra_Duration$addYear, addend, date);
			default:
				var _p16 = _p15._0;
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Period$add,
					_rluiten$elm_date_extra$Date_Extra_Period$Delta(
						{week: 0, day: _p16.day, hour: _p16.hour, minute: _p16.minute, second: _p16.second, millisecond: _p16.millisecond}),
					addend,
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$doAdd,
						_rluiten$elm_date_extra$Date_Extra_Duration$Month,
						_p16.month,
						A3(_rluiten$elm_date_extra$Date_Extra_Duration$doAdd, _rluiten$elm_date_extra$Date_Extra_Duration$Year, _p16.year, date)));
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$add = F3(
	function (duration, addend, date) {
		var outputDate = A3(_rluiten$elm_date_extra$Date_Extra_Duration$doAdd, duration, addend, date);
		return _rluiten$elm_date_extra$Date_Extra_Duration$requireDaylightCompensateInAdd(duration) ? A2(_rluiten$elm_date_extra$Date_Extra_Duration$daylightOffsetCompensate, date, outputDate) : outputDate;
	});
var _rluiten$elm_date_extra$Date_Extra_Duration$Week = {ctor: 'Week'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Day = {ctor: 'Day'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Hour = {ctor: 'Hour'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Minute = {ctor: 'Minute'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Second = {ctor: 'Second'};
var _rluiten$elm_date_extra$Date_Extra_Duration$Millisecond = {ctor: 'Millisecond'};

var _rluiten$elm_date_extra$Date_Extra_Field$dayOfWeekToDate = F3(
	function (newDayOfWeek, startOfWeekDay, date) {
		var targetIsoDay = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(newDayOfWeek);
		var dayOfWeek = _elm_lang$core$Date$dayOfWeek(date);
		var daysToStartOfWeek = A2(_rluiten$elm_date_extra$Date_Extra_Core$daysBackToStartOfWeek, dayOfWeek, startOfWeekDay);
		var isoDay = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(dayOfWeek);
		var dayDiff = targetIsoDay - isoDay;
		var adjustedDiff = (_elm_lang$core$Native_Utils.cmp(daysToStartOfWeek + dayDiff, 0) < 0) ? (dayDiff + 7) : dayDiff;
		return A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Day, adjustedDiff, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Field$monthToDate = F2(
	function (month, date) {
		var monthInt = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
			_elm_lang$core$Date$month(date));
		var targetMonthInt = _rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month);
		return A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Month, targetMonthInt - monthInt, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp = F2(
	function (field, date) {
		var _p0 = field;
		switch (_p0.ctor) {
			case 'Millisecond':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Millisecond,
					A3(_elm_lang$core$Basics$clamp, 0, 999, _p0._0) - _elm_lang$core$Date$millisecond(date),
					date);
			case 'Second':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Second,
					A3(_elm_lang$core$Basics$clamp, 0, 59, _p0._0) - _elm_lang$core$Date$second(date),
					date);
			case 'Minute':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Minute,
					A3(_elm_lang$core$Basics$clamp, 0, 59, _p0._0) - _elm_lang$core$Date$minute(date),
					date);
			case 'Hour':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Hour,
					A3(_elm_lang$core$Basics$clamp, 0, 23, _p0._0) - _elm_lang$core$Date$hour(date),
					date);
			case 'DayOfWeek':
				return A3(_rluiten$elm_date_extra$Date_Extra_Field$dayOfWeekToDate, _p0._0._0, _p0._0._1, date);
			case 'DayOfMonth':
				var maxDays = _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate(date);
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Day,
					A3(_elm_lang$core$Basics$clamp, 1, maxDays, _p0._0) - _elm_lang$core$Date$day(date),
					date);
			case 'Month':
				return A2(_rluiten$elm_date_extra$Date_Extra_Field$monthToDate, _p0._0, date);
			default:
				var _p1 = _p0._0;
				var minYear = (_elm_lang$core$Native_Utils.cmp(_p1, 0) < 0) ? 0 : _p1;
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Duration$add,
					_rluiten$elm_date_extra$Date_Extra_Duration$Year,
					minYear - _elm_lang$core$Date$year(date),
					date);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Field$fieldToDate = F2(
	function (field, date) {
		var _p2 = field;
		switch (_p2.ctor) {
			case 'Millisecond':
				var _p3 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p3, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p3, 999) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Millisecond,
						_p3 - _elm_lang$core$Date$millisecond(date),
						date));
			case 'Second':
				var _p4 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p4, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p4, 59) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Second,
						_p4 - _elm_lang$core$Date$second(date),
						date));
			case 'Minute':
				var _p5 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p5, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p5, 59) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Minute,
						_p5 - _elm_lang$core$Date$minute(date),
						date));
			case 'Hour':
				var _p6 = _p2._0;
				return ((_elm_lang$core$Native_Utils.cmp(_p6, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(_p6, 23) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Hour,
						_p6 - _elm_lang$core$Date$hour(date),
						date));
			case 'DayOfWeek':
				return _elm_lang$core$Maybe$Just(
					A3(_rluiten$elm_date_extra$Date_Extra_Field$dayOfWeekToDate, _p2._0._0, _p2._0._1, date));
			case 'DayOfMonth':
				var _p7 = _p2._0;
				var maxDays = _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate(date);
				return ((_elm_lang$core$Native_Utils.cmp(_p7, 1) < 0) || (_elm_lang$core$Native_Utils.cmp(_p7, maxDays) > 0)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Day,
						_p7 - _elm_lang$core$Date$day(date),
						date));
			case 'Month':
				return _elm_lang$core$Maybe$Just(
					A2(_rluiten$elm_date_extra$Date_Extra_Field$monthToDate, _p2._0, date));
			default:
				var _p8 = _p2._0;
				return (_elm_lang$core$Native_Utils.cmp(_p8, 0) < 0) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
					A3(
						_rluiten$elm_date_extra$Date_Extra_Duration$add,
						_rluiten$elm_date_extra$Date_Extra_Duration$Year,
						_p8 - _elm_lang$core$Date$year(date),
						date));
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Field$Year = function (a) {
	return {ctor: 'Year', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Month = function (a) {
	return {ctor: 'Month', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth = function (a) {
	return {ctor: 'DayOfMonth', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$DayOfWeek = function (a) {
	return {ctor: 'DayOfWeek', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Hour = function (a) {
	return {ctor: 'Hour', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Minute = function (a) {
	return {ctor: 'Minute', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Second = function (a) {
	return {ctor: 'Second', _0: a};
};
var _rluiten$elm_date_extra$Date_Extra_Field$Millisecond = function (a) {
	return {ctor: 'Millisecond', _0: a};
};

var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Year = {ctor: 'Year'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Month = {ctor: 'Month'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Day = {ctor: 'Day'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Hour = {ctor: 'Hour'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Minute = {ctor: 'Minute'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Second = {ctor: 'Second'};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime = F2(
	function (unit, date) {
		var _p0 = unit;
		switch (_p0.ctor) {
			case 'Millisecond':
				return date;
			case 'Second':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Millisecond(0),
					date);
			case 'Minute':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Second(0),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Second, date));
			case 'Hour':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Minute(0),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Minute, date));
			case 'Day':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Hour(0),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Hour, date));
			case 'Month':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth(1),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Day, date));
			default:
				return _rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTimeYear(date);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTimeYear = function (date) {
	var startMonthDate = A2(
		_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
		_rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth(1),
		date);
	var startYearDate = A2(
		_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
		_rluiten$elm_date_extra$Date_Extra_Field$Month(_elm_lang$core$Date$Jan),
		startMonthDate);
	var monthTicks = _rluiten$elm_date_extra$Date_Extra_Core$toTime(startMonthDate) - _rluiten$elm_date_extra$Date_Extra_Core$toTime(startYearDate);
	var updatedDate = _rluiten$elm_date_extra$Date_Extra_Core$fromTime(
		_rluiten$elm_date_extra$Date_Extra_Core$toTime(date) - monthTicks);
	return A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Month, updatedDate);
};
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime = F2(
	function (unit, date) {
		var _p1 = unit;
		switch (_p1.ctor) {
			case 'Millisecond':
				return date;
			case 'Second':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Millisecond(999),
					date);
			case 'Minute':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Second(59),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Second, date));
			case 'Hour':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Minute(59),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Minute, date));
			case 'Day':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$Hour(23),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Hour, date));
			case 'Month':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Field$fieldToDateClamp,
					_rluiten$elm_date_extra$Date_Extra_Field$DayOfMonth(31),
					A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$endOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Day, date));
			default:
				var extraYear = A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Year, 1, date);
				var startYear = A2(_rluiten$elm_date_extra$Date_Extra_TimeUnit$startOfTime, _rluiten$elm_date_extra$Date_Extra_TimeUnit$Year, extraYear);
				return A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Millisecond, -1, startYear);
		}
	});
var _rluiten$elm_date_extra$Date_Extra_TimeUnit$Millisecond = {ctor: 'Millisecond'};

//import Maybe, Native.List //

var _elm_lang$core$Native_Regex = function() {

function escape(str)
{
	return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function caseInsensitive(re)
{
	return new RegExp(re.source, 'gi');
}
function regex(raw)
{
	return new RegExp(raw, 'g');
}

function contains(re, string)
{
	return string.match(re) !== null;
}

function find(n, re, str)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex === re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch === undefined
				? _elm_lang$core$Maybe$Nothing
				: _elm_lang$core$Maybe$Just(submatch);
		}
		out.push({
			match: result[0],
			submatches: _elm_lang$core$Native_List.fromArray(subs),
			index: result.index,
			number: number
		});
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _elm_lang$core$Native_List.fromArray(out);
}

function replace(n, re, replacer, string)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch === undefined
				? _elm_lang$core$Maybe$Nothing
				: _elm_lang$core$Maybe$Just(submatch);
		}
		return replacer({
			match: match,
			submatches: _elm_lang$core$Native_List.fromArray(submatches),
			index: arguments[arguments.length - 2],
			number: count
		});
	}
	return string.replace(re, jsReplacer);
}

function split(n, re, str)
{
	n = n.ctor === 'All' ? Infinity : n._0;
	if (n === Infinity)
	{
		return _elm_lang$core$Native_List.fromArray(str.split(re));
	}
	var string = str;
	var result;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		if (!(result = re.exec(string))) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _elm_lang$core$Native_List.fromArray(out);
}

return {
	regex: regex,
	caseInsensitive: caseInsensitive,
	escape: escape,

	contains: F2(contains),
	find: F3(find),
	replace: F4(replace),
	split: F3(split)
};

}();

var _elm_lang$core$Regex$split = _elm_lang$core$Native_Regex.split;
var _elm_lang$core$Regex$replace = _elm_lang$core$Native_Regex.replace;
var _elm_lang$core$Regex$find = _elm_lang$core$Native_Regex.find;
var _elm_lang$core$Regex$contains = _elm_lang$core$Native_Regex.contains;
var _elm_lang$core$Regex$caseInsensitive = _elm_lang$core$Native_Regex.caseInsensitive;
var _elm_lang$core$Regex$regex = _elm_lang$core$Native_Regex.regex;
var _elm_lang$core$Regex$escape = _elm_lang$core$Native_Regex.escape;
var _elm_lang$core$Regex$Match = F4(
	function (a, b, c, d) {
		return {match: a, submatches: b, index: c, number: d};
	});
var _elm_lang$core$Regex$Regex = {ctor: 'Regex'};
var _elm_lang$core$Regex$AtMost = function (a) {
	return {ctor: 'AtMost', _0: a};
};
var _elm_lang$core$Regex$All = {ctor: 'All'};

var _rluiten$elm_date_extra$Date_Extra_Utils$unsafeFromString = function (dateStr) {
	var _p0 = _elm_lang$core$Date$fromString(dateStr);
	if (_p0.ctor === 'Ok') {
		return _p0._0;
	} else {
		return _elm_lang$core$Native_Utils.crashCase(
			'Date.Extra.Utils',
			{
				start: {line: 146, column: 5},
				end: {line: 151, column: 43}
			},
			_p0)('unsafeFromString');
	}
};
var _rluiten$elm_date_extra$Date_Extra_Utils$isoDayofWeekMonday = _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(_elm_lang$core$Date$Mon);
var _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne = function (year) {
	var dateJan4 = A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, year, _elm_lang$core$Date$Jan, 4, 0, 0, 0, 0);
	return A3(
		_rluiten$elm_date_extra$Date_Extra_Duration$add,
		_rluiten$elm_date_extra$Date_Extra_Duration$Day,
		_rluiten$elm_date_extra$Date_Extra_Utils$isoDayofWeekMonday - _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(
			_elm_lang$core$Date$dayOfWeek(dateJan4)),
		dateJan4);
};
var _rluiten$elm_date_extra$Date_Extra_Utils$getYearIsoWeekDate = function (date) {
	var inputYear = _elm_lang$core$Date$year(date);
	var maxIsoWeekDateInYear = A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, inputYear, _elm_lang$core$Date$Dec, 29, 0, 0, 0, 0);
	if (A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$SameOrAfter, date, maxIsoWeekDateInYear)) {
		var nextYearIsoWeek1Date = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear + 1);
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$Before, date, nextYearIsoWeek1Date) ? {
			ctor: '_Tuple2',
			_0: inputYear,
			_1: _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear)
		} : {ctor: '_Tuple2', _0: inputYear + 1, _1: nextYearIsoWeek1Date};
	} else {
		var thisYearIsoWeek1Date = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear);
		return A3(_rluiten$elm_date_extra$Date_Extra_Compare$is, _rluiten$elm_date_extra$Date_Extra_Compare$Before, date, thisYearIsoWeek1Date) ? {
			ctor: '_Tuple2',
			_0: inputYear - 1,
			_1: _rluiten$elm_date_extra$Date_Extra_Utils$isoWeekOne(inputYear - 1)
		} : {ctor: '_Tuple2', _0: inputYear, _1: thisYearIsoWeek1Date};
	}
};
var _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek = function (date) {
	var _p2 = _rluiten$elm_date_extra$Date_Extra_Utils$getYearIsoWeekDate(date);
	var year = _p2._0;
	var isoWeek1Date = _p2._1;
	var daysSinceIsoWeek1 = A2(_rluiten$elm_date_extra$Date_Extra_Duration$diffDays, date, isoWeek1Date);
	return {
		ctor: '_Tuple3',
		_0: year,
		_1: ((daysSinceIsoWeek1 / 7) | 0) + 1,
		_2: _rluiten$elm_date_extra$Date_Extra_Core$isoDayOfWeek(
			_elm_lang$core$Date$dayOfWeek(date))
	};
};
var _rluiten$elm_date_extra$Date_Extra_Utils$dayList_ = F3(
	function (dayCount, date, list) {
		dayList_:
		while (true) {
			if (_elm_lang$core$Native_Utils.eq(dayCount, 0)) {
				return list;
			} else {
				if (_elm_lang$core$Native_Utils.cmp(dayCount, 0) > 0) {
					var _v1 = dayCount - 1,
						_v2 = A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Day, 1, date),
						_v3 = {ctor: '::', _0: date, _1: list};
					dayCount = _v1;
					date = _v2;
					list = _v3;
					continue dayList_;
				} else {
					var _v4 = dayCount + 1,
						_v5 = A3(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Day, -1, date),
						_v6 = {ctor: '::', _0: date, _1: list};
					dayCount = _v4;
					date = _v5;
					list = _v6;
					continue dayList_;
				}
			}
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Utils$dayList = F2(
	function (dayCount, startDate) {
		return _elm_lang$core$List$reverse(
			A3(
				_rluiten$elm_date_extra$Date_Extra_Utils$dayList_,
				dayCount,
				startDate,
				{ctor: '[]'}));
	});

var _rluiten$elm_date_extra$Date_Extra_Format$toHourMin = function (offsetMinutes) {
	return {
		ctor: '_Tuple2',
		_0: (offsetMinutes / 60) | 0,
		_1: A2(_elm_lang$core$Basics_ops['%'], offsetMinutes, 60)
	};
};
var _rluiten$elm_date_extra$Date_Extra_Format$padWithN = F2(
	function (n, c) {
		return function (_p0) {
			return A3(
				_elm_lang$core$String$padLeft,
				n,
				c,
				_elm_lang$core$Basics$toString(_p0));
		};
	});
var _rluiten$elm_date_extra$Date_Extra_Format$padWith = function (c) {
	return function (_p1) {
		return A3(
			_elm_lang$core$String$padLeft,
			2,
			c,
			_elm_lang$core$Basics$toString(_p1));
	};
};
var _rluiten$elm_date_extra$Date_Extra_Format$hourMod12 = function (h) {
	return _elm_lang$core$Native_Utils.eq(
		A2(_elm_lang$core$Basics_ops['%'], h, 12),
		0) ? 12 : A2(_elm_lang$core$Basics_ops['%'], h, 12);
};
var _rluiten$elm_date_extra$Date_Extra_Format$formatOffsetStr = F2(
	function (betweenHoursMinutes, offset) {
		var _p2 = _rluiten$elm_date_extra$Date_Extra_Format$toHourMin(
			_elm_lang$core$Basics$abs(offset));
		var hour = _p2._0;
		var minute = _p2._1;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			(_elm_lang$core$Native_Utils.cmp(offset, 0) < 1) ? '+' : '-',
			A2(
				_elm_lang$core$Basics_ops['++'],
				A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					hour),
				A2(
					_elm_lang$core$Basics_ops['++'],
					betweenHoursMinutes,
					A2(
						_rluiten$elm_date_extra$Date_Extra_Format$padWith,
						_elm_lang$core$Native_Utils.chr('0'),
						minute))));
	});
var _rluiten$elm_date_extra$Date_Extra_Format$collapse = function (m) {
	return A2(_elm_lang$core$Maybe$andThen, _elm_lang$core$Basics$identity, m);
};
var _rluiten$elm_date_extra$Date_Extra_Format$formatToken = F4(
	function (config, offset, d, m) {
		var symbol = A2(
			_elm_lang$core$Maybe$withDefault,
			' ',
			_rluiten$elm_date_extra$Date_Extra_Format$collapse(
				_elm_lang$core$List$head(m.submatches)));
		var _p3 = symbol;
		switch (_p3) {
			case 'Y':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
					4,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$year(d));
			case 'y':
				return A2(
					_elm_lang$core$String$right,
					2,
					A3(
						_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
						2,
						_elm_lang$core$Native_Utils.chr('0'),
						_elm_lang$core$Date$year(d)));
			case 'm':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
						_elm_lang$core$Date$month(d)));
			case '_m':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
						_elm_lang$core$Date$month(d)));
			case '-m':
				return _elm_lang$core$Basics$toString(
					_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
						_elm_lang$core$Date$month(d)));
			case 'B':
				return config.i18n.monthName(
					_elm_lang$core$Date$month(d));
			case '^B':
				return _elm_lang$core$String$toUpper(
					config.i18n.monthName(
						_elm_lang$core$Date$month(d)));
			case 'b':
				return config.i18n.monthShort(
					_elm_lang$core$Date$month(d));
			case '^b':
				return _elm_lang$core$String$toUpper(
					config.i18n.monthShort(
						_elm_lang$core$Date$month(d)));
			case 'd':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$day(d));
			case '-d':
				return _elm_lang$core$Basics$toString(
					_elm_lang$core$Date$day(d));
			case '-@d':
				return A2(
					config.i18n.dayOfMonthWithSuffix,
					false,
					_elm_lang$core$Date$day(d));
			case 'e':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_elm_lang$core$Date$day(d));
			case '@e':
				return A2(
					config.i18n.dayOfMonthWithSuffix,
					true,
					_elm_lang$core$Date$day(d));
			case 'A':
				return config.i18n.dayName(
					_elm_lang$core$Date$dayOfWeek(d));
			case '^A':
				return _elm_lang$core$String$toUpper(
					config.i18n.dayName(
						_elm_lang$core$Date$dayOfWeek(d)));
			case 'a':
				return config.i18n.dayShort(
					_elm_lang$core$Date$dayOfWeek(d));
			case '^a':
				return _elm_lang$core$String$toUpper(
					config.i18n.dayShort(
						_elm_lang$core$Date$dayOfWeek(d)));
			case 'H':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$hour(d));
			case '-H':
				return _elm_lang$core$Basics$toString(
					_elm_lang$core$Date$hour(d));
			case 'k':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_elm_lang$core$Date$hour(d));
			case 'I':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_rluiten$elm_date_extra$Date_Extra_Format$hourMod12(
						_elm_lang$core$Date$hour(d)));
			case '-I':
				return _elm_lang$core$Basics$toString(
					_rluiten$elm_date_extra$Date_Extra_Format$hourMod12(
						_elm_lang$core$Date$hour(d)));
			case 'l':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr(' '),
					_rluiten$elm_date_extra$Date_Extra_Format$hourMod12(
						_elm_lang$core$Date$hour(d)));
			case 'p':
				return _elm_lang$core$String$toUpper(
					config.i18n.twelveHourPeriod(
						_rluiten$elm_date_extra$Date_Extra_TwelveHourClock$twelveHourPeriod(d)));
			case 'P':
				return config.i18n.twelveHourPeriod(
					_rluiten$elm_date_extra$Date_Extra_TwelveHourClock$twelveHourPeriod(d));
			case 'M':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$minute(d));
			case 'S':
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$second(d));
			case 'L':
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
					3,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Date$millisecond(d));
			case '%':
				return symbol;
			case 'z':
				return A2(_rluiten$elm_date_extra$Date_Extra_Format$formatOffsetStr, '', offset);
			case ':z':
				return A2(_rluiten$elm_date_extra$Date_Extra_Format$formatOffsetStr, ':', offset);
			case 'G':
				var _p4 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Format$padWithN,
					3,
					_elm_lang$core$Native_Utils.chr('0'),
					_p4._0);
			case 'V':
				var _p5 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return A2(
					_rluiten$elm_date_extra$Date_Extra_Format$padWith,
					_elm_lang$core$Native_Utils.chr('0'),
					_p5._1);
			case '-V':
				var _p6 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return _elm_lang$core$Basics$toString(_p6._1);
			case 'u':
				var _p7 = _rluiten$elm_date_extra$Date_Extra_Utils$isoWeek(d);
				return _elm_lang$core$Basics$toString(_p7._2);
			default:
				return '';
		}
	});
var _rluiten$elm_date_extra$Date_Extra_Format$formatRegex = _elm_lang$core$Regex$regex('%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L|z|:z|G|V|-V|u)');
var _rluiten$elm_date_extra$Date_Extra_Format$formatOffset = F4(
	function (config, targetOffset, formatStr, date) {
		var dateOffset = _rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date);
		var hackOffset = dateOffset - targetOffset;
		return A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_rluiten$elm_date_extra$Date_Extra_Format$formatRegex,
			A3(
				_rluiten$elm_date_extra$Date_Extra_Format$formatToken,
				config,
				targetOffset,
				A2(_rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsOffset, hackOffset, date)),
			formatStr);
	});
var _rluiten$elm_date_extra$Date_Extra_Format$format = F3(
	function (config, formatStr, date) {
		return A4(
			_rluiten$elm_date_extra$Date_Extra_Format$formatOffset,
			config,
			_rluiten$elm_date_extra$Date_Extra_Create$getTimezoneOffset(date),
			formatStr,
			date);
	});
var _rluiten$elm_date_extra$Date_Extra_Format$formatUtc = F3(
	function (config, formatStr, date) {
		return A4(_rluiten$elm_date_extra$Date_Extra_Format$formatOffset, config, 0, formatStr, date);
	});
var _rluiten$elm_date_extra$Date_Extra_Format$isoDateString = function (date) {
	var day = _elm_lang$core$Date$day(date);
	var month = _elm_lang$core$Date$month(date);
	var year = _elm_lang$core$Date$year(date);
	return A2(
		_elm_lang$core$Basics_ops['++'],
		A3(
			_elm_lang$core$String$padLeft,
			4,
			_elm_lang$core$Native_Utils.chr('0'),
			_elm_lang$core$Basics$toString(year)),
		A2(
			_elm_lang$core$Basics_ops['++'],
			'-',
			A2(
				_elm_lang$core$Basics_ops['++'],
				A3(
					_elm_lang$core$String$padLeft,
					2,
					_elm_lang$core$Native_Utils.chr('0'),
					_elm_lang$core$Basics$toString(
						_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month))),
				A2(
					_elm_lang$core$Basics_ops['++'],
					'-',
					A3(
						_elm_lang$core$String$padLeft,
						2,
						_elm_lang$core$Native_Utils.chr('0'),
						_elm_lang$core$Basics$toString(day))))));
};
var _rluiten$elm_date_extra$Date_Extra_Format$utcIsoDateString = function (date) {
	return _rluiten$elm_date_extra$Date_Extra_Format$isoDateString(
		_rluiten$elm_date_extra$Date_Extra_Internal$hackDateAsUtc(date));
};
var _rluiten$elm_date_extra$Date_Extra_Format$yearInt = function (year) {
	return A3(
		_elm_lang$core$String$padLeft,
		4,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(year));
};
var _rluiten$elm_date_extra$Date_Extra_Format$year = function (date) {
	return A3(
		_elm_lang$core$String$padLeft,
		4,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(
			_elm_lang$core$Date$year(date)));
};
var _rluiten$elm_date_extra$Date_Extra_Format$monthMonth = function (month) {
	return A3(
		_elm_lang$core$String$padLeft,
		2,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(month)));
};
var _rluiten$elm_date_extra$Date_Extra_Format$month = function (date) {
	return A3(
		_elm_lang$core$String$padLeft,
		2,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(
			_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
				_elm_lang$core$Date$month(date))));
};
var _rluiten$elm_date_extra$Date_Extra_Format$isoTimeFormat = '%H:%M:%S';
var _rluiten$elm_date_extra$Date_Extra_Format$isoDateFormat = '%Y-%m-%d';
var _rluiten$elm_date_extra$Date_Extra_Format$isoMsecOffsetFormat = '%Y-%m-%dT%H:%M:%S.%L%:z';
var _rluiten$elm_date_extra$Date_Extra_Format$isoString = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _rluiten$elm_date_extra$Date_Extra_Format$isoMsecOffsetFormat);
var _rluiten$elm_date_extra$Date_Extra_Format$isoOffsetFormat = '%Y-%m-%dT%H:%M:%S%z';
var _rluiten$elm_date_extra$Date_Extra_Format$isoMsecFormat = '%Y-%m-%dT%H:%M:%S.%L';
var _rluiten$elm_date_extra$Date_Extra_Format$isoStringNoOffset = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _rluiten$elm_date_extra$Date_Extra_Format$isoMsecFormat);
var _rluiten$elm_date_extra$Date_Extra_Format$utcIsoString = function (date) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		A3(_rluiten$elm_date_extra$Date_Extra_Format$formatUtc, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _rluiten$elm_date_extra$Date_Extra_Format$isoMsecFormat, date),
		'Z');
};
var _rluiten$elm_date_extra$Date_Extra_Format$isoFormat = '%Y-%m-%dT%H:%M:%S';

var _elm_lang$virtual_dom$VirtualDom_Debug$wrap;
var _elm_lang$virtual_dom$VirtualDom_Debug$wrapWithFlags;

var _elm_lang$virtual_dom$Native_VirtualDom = function() {

var STYLE_KEY = 'STYLE';
var EVENT_KEY = 'EVENT';
var ATTR_KEY = 'ATTR';
var ATTR_NS_KEY = 'ATTR_NS';

var localDoc = typeof document !== 'undefined' ? document : {};


////////////  VIRTUAL DOM NODES  ////////////


function text(string)
{
	return {
		type: 'text',
		text: string
	};
}


function node(tag)
{
	return F2(function(factList, kidList) {
		return nodeHelp(tag, factList, kidList);
	});
}


function nodeHelp(tag, factList, kidList)
{
	var organized = organizeFacts(factList);
	var namespace = organized.namespace;
	var facts = organized.facts;

	var children = [];
	var descendantsCount = 0;
	while (kidList.ctor !== '[]')
	{
		var kid = kidList._0;
		descendantsCount += (kid.descendantsCount || 0);
		children.push(kid);
		kidList = kidList._1;
	}
	descendantsCount += children.length;

	return {
		type: 'node',
		tag: tag,
		facts: facts,
		children: children,
		namespace: namespace,
		descendantsCount: descendantsCount
	};
}


function keyedNode(tag, factList, kidList)
{
	var organized = organizeFacts(factList);
	var namespace = organized.namespace;
	var facts = organized.facts;

	var children = [];
	var descendantsCount = 0;
	while (kidList.ctor !== '[]')
	{
		var kid = kidList._0;
		descendantsCount += (kid._1.descendantsCount || 0);
		children.push(kid);
		kidList = kidList._1;
	}
	descendantsCount += children.length;

	return {
		type: 'keyed-node',
		tag: tag,
		facts: facts,
		children: children,
		namespace: namespace,
		descendantsCount: descendantsCount
	};
}


function custom(factList, model, impl)
{
	var facts = organizeFacts(factList).facts;

	return {
		type: 'custom',
		facts: facts,
		model: model,
		impl: impl
	};
}


function map(tagger, node)
{
	return {
		type: 'tagger',
		tagger: tagger,
		node: node,
		descendantsCount: 1 + (node.descendantsCount || 0)
	};
}


function thunk(func, args, thunk)
{
	return {
		type: 'thunk',
		func: func,
		args: args,
		thunk: thunk,
		node: undefined
	};
}

function lazy(fn, a)
{
	return thunk(fn, [a], function() {
		return fn(a);
	});
}

function lazy2(fn, a, b)
{
	return thunk(fn, [a,b], function() {
		return A2(fn, a, b);
	});
}

function lazy3(fn, a, b, c)
{
	return thunk(fn, [a,b,c], function() {
		return A3(fn, a, b, c);
	});
}



// FACTS


function organizeFacts(factList)
{
	var namespace, facts = {};

	while (factList.ctor !== '[]')
	{
		var entry = factList._0;
		var key = entry.key;

		if (key === ATTR_KEY || key === ATTR_NS_KEY || key === EVENT_KEY)
		{
			var subFacts = facts[key] || {};
			subFacts[entry.realKey] = entry.value;
			facts[key] = subFacts;
		}
		else if (key === STYLE_KEY)
		{
			var styles = facts[key] || {};
			var styleList = entry.value;
			while (styleList.ctor !== '[]')
			{
				var style = styleList._0;
				styles[style._0] = style._1;
				styleList = styleList._1;
			}
			facts[key] = styles;
		}
		else if (key === 'namespace')
		{
			namespace = entry.value;
		}
		else if (key === 'className')
		{
			var classes = facts[key];
			facts[key] = typeof classes === 'undefined'
				? entry.value
				: classes + ' ' + entry.value;
		}
 		else
		{
			facts[key] = entry.value;
		}
		factList = factList._1;
	}

	return {
		facts: facts,
		namespace: namespace
	};
}



////////////  PROPERTIES AND ATTRIBUTES  ////////////


function style(value)
{
	return {
		key: STYLE_KEY,
		value: value
	};
}


function property(key, value)
{
	return {
		key: key,
		value: value
	};
}


function attribute(key, value)
{
	return {
		key: ATTR_KEY,
		realKey: key,
		value: value
	};
}


function attributeNS(namespace, key, value)
{
	return {
		key: ATTR_NS_KEY,
		realKey: key,
		value: {
			value: value,
			namespace: namespace
		}
	};
}


function on(name, options, decoder)
{
	return {
		key: EVENT_KEY,
		realKey: name,
		value: {
			options: options,
			decoder: decoder
		}
	};
}


function equalEvents(a, b)
{
	if (a.options !== b.options)
	{
		if (a.options.stopPropagation !== b.options.stopPropagation || a.options.preventDefault !== b.options.preventDefault)
		{
			return false;
		}
	}
	return _elm_lang$core$Native_Json.equality(a.decoder, b.decoder);
}


function mapProperty(func, property)
{
	if (property.key !== EVENT_KEY)
	{
		return property;
	}
	return on(
		property.realKey,
		property.value.options,
		A2(_elm_lang$core$Json_Decode$map, func, property.value.decoder)
	);
}


////////////  RENDER  ////////////


function render(vNode, eventNode)
{
	switch (vNode.type)
	{
		case 'thunk':
			if (!vNode.node)
			{
				vNode.node = vNode.thunk();
			}
			return render(vNode.node, eventNode);

		case 'tagger':
			var subNode = vNode.node;
			var tagger = vNode.tagger;

			while (subNode.type === 'tagger')
			{
				typeof tagger !== 'object'
					? tagger = [tagger, subNode.tagger]
					: tagger.push(subNode.tagger);

				subNode = subNode.node;
			}

			var subEventRoot = { tagger: tagger, parent: eventNode };
			var domNode = render(subNode, subEventRoot);
			domNode.elm_event_node_ref = subEventRoot;
			return domNode;

		case 'text':
			return localDoc.createTextNode(vNode.text);

		case 'node':
			var domNode = vNode.namespace
				? localDoc.createElementNS(vNode.namespace, vNode.tag)
				: localDoc.createElement(vNode.tag);

			applyFacts(domNode, eventNode, vNode.facts);

			var children = vNode.children;

			for (var i = 0; i < children.length; i++)
			{
				domNode.appendChild(render(children[i], eventNode));
			}

			return domNode;

		case 'keyed-node':
			var domNode = vNode.namespace
				? localDoc.createElementNS(vNode.namespace, vNode.tag)
				: localDoc.createElement(vNode.tag);

			applyFacts(domNode, eventNode, vNode.facts);

			var children = vNode.children;

			for (var i = 0; i < children.length; i++)
			{
				domNode.appendChild(render(children[i]._1, eventNode));
			}

			return domNode;

		case 'custom':
			var domNode = vNode.impl.render(vNode.model);
			applyFacts(domNode, eventNode, vNode.facts);
			return domNode;
	}
}



////////////  APPLY FACTS  ////////////


function applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		switch (key)
		{
			case STYLE_KEY:
				applyStyles(domNode, value);
				break;

			case EVENT_KEY:
				applyEvents(domNode, eventNode, value);
				break;

			case ATTR_KEY:
				applyAttrs(domNode, value);
				break;

			case ATTR_NS_KEY:
				applyAttrsNS(domNode, value);
				break;

			case 'value':
				if (domNode[key] !== value)
				{
					domNode[key] = value;
				}
				break;

			default:
				domNode[key] = value;
				break;
		}
	}
}

function applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}

function applyEvents(domNode, eventNode, events)
{
	var allHandlers = domNode.elm_handlers || {};

	for (var key in events)
	{
		var handler = allHandlers[key];
		var value = events[key];

		if (typeof value === 'undefined')
		{
			domNode.removeEventListener(key, handler);
			allHandlers[key] = undefined;
		}
		else if (typeof handler === 'undefined')
		{
			var handler = makeEventHandler(eventNode, value);
			domNode.addEventListener(key, handler);
			allHandlers[key] = handler;
		}
		else
		{
			handler.info = value;
		}
	}

	domNode.elm_handlers = allHandlers;
}

function makeEventHandler(eventNode, info)
{
	function eventHandler(event)
	{
		var info = eventHandler.info;

		var value = A2(_elm_lang$core$Native_Json.run, info.decoder, event);

		if (value.ctor === 'Ok')
		{
			var options = info.options;
			if (options.stopPropagation)
			{
				event.stopPropagation();
			}
			if (options.preventDefault)
			{
				event.preventDefault();
			}

			var message = value._0;

			var currentEventNode = eventNode;
			while (currentEventNode)
			{
				var tagger = currentEventNode.tagger;
				if (typeof tagger === 'function')
				{
					message = tagger(message);
				}
				else
				{
					for (var i = tagger.length; i--; )
					{
						message = tagger[i](message);
					}
				}
				currentEventNode = currentEventNode.parent;
			}
		}
	};

	eventHandler.info = info;

	return eventHandler;
}

function applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		if (typeof value === 'undefined')
		{
			domNode.removeAttribute(key);
		}
		else
		{
			domNode.setAttribute(key, value);
		}
	}
}

function applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.namespace;
		var value = pair.value;

		if (typeof value === 'undefined')
		{
			domNode.removeAttributeNS(namespace, key);
		}
		else
		{
			domNode.setAttributeNS(namespace, key, value);
		}
	}
}



////////////  DIFF  ////////////


function diff(a, b)
{
	var patches = [];
	diffHelp(a, b, patches, 0);
	return patches;
}


function makePatch(type, index, data)
{
	return {
		index: index,
		type: type,
		data: data,
		domNode: undefined,
		eventNode: undefined
	};
}


function diffHelp(a, b, patches, index)
{
	if (a === b)
	{
		return;
	}

	var aType = a.type;
	var bType = b.type;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (aType !== bType)
	{
		patches.push(makePatch('p-redraw', index, b));
		return;
	}

	// Now we know that both nodes are the same type.
	switch (bType)
	{
		case 'thunk':
			var aArgs = a.args;
			var bArgs = b.args;
			var i = aArgs.length;
			var same = a.func === b.func && i === bArgs.length;
			while (same && i--)
			{
				same = aArgs[i] === bArgs[i];
			}
			if (same)
			{
				b.node = a.node;
				return;
			}
			b.node = b.thunk();
			var subPatches = [];
			diffHelp(a.node, b.node, subPatches, 0);
			if (subPatches.length > 0)
			{
				patches.push(makePatch('p-thunk', index, subPatches));
			}
			return;

		case 'tagger':
			// gather nested taggers
			var aTaggers = a.tagger;
			var bTaggers = b.tagger;
			var nesting = false;

			var aSubNode = a.node;
			while (aSubNode.type === 'tagger')
			{
				nesting = true;

				typeof aTaggers !== 'object'
					? aTaggers = [aTaggers, aSubNode.tagger]
					: aTaggers.push(aSubNode.tagger);

				aSubNode = aSubNode.node;
			}

			var bSubNode = b.node;
			while (bSubNode.type === 'tagger')
			{
				nesting = true;

				typeof bTaggers !== 'object'
					? bTaggers = [bTaggers, bSubNode.tagger]
					: bTaggers.push(bSubNode.tagger);

				bSubNode = bSubNode.node;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && aTaggers.length !== bTaggers.length)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !pairwiseRefEqual(aTaggers, bTaggers) : aTaggers !== bTaggers)
			{
				patches.push(makePatch('p-tagger', index, bTaggers));
			}

			// diff everything below the taggers
			diffHelp(aSubNode, bSubNode, patches, index + 1);
			return;

		case 'text':
			if (a.text !== b.text)
			{
				patches.push(makePatch('p-text', index, b.text));
				return;
			}

			return;

		case 'node':
			// Bail if obvious indicators have changed. Implies more serious
			// structural changes such that it's not worth it to diff.
			if (a.tag !== b.tag || a.namespace !== b.namespace)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);

			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			diffChildren(a, b, patches, index);
			return;

		case 'keyed-node':
			// Bail if obvious indicators have changed. Implies more serious
			// structural changes such that it's not worth it to diff.
			if (a.tag !== b.tag || a.namespace !== b.namespace)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);

			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			diffKeyedChildren(a, b, patches, index);
			return;

		case 'custom':
			if (a.impl !== b.impl)
			{
				patches.push(makePatch('p-redraw', index, b));
				return;
			}

			var factsDiff = diffFacts(a.facts, b.facts);
			if (typeof factsDiff !== 'undefined')
			{
				patches.push(makePatch('p-facts', index, factsDiff));
			}

			var patch = b.impl.diff(a,b);
			if (patch)
			{
				patches.push(makePatch('p-custom', index, patch));
				return;
			}

			return;
	}
}


// assumes the incoming arrays are the same length
function pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function diffFacts(a, b, category)
{
	var diff;

	// look for changes and removals
	for (var aKey in a)
	{
		if (aKey === STYLE_KEY || aKey === EVENT_KEY || aKey === ATTR_KEY || aKey === ATTR_NS_KEY)
		{
			var subDiff = diffFacts(a[aKey], b[aKey] || {}, aKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[aKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(aKey in b))
		{
			diff = diff || {};
			diff[aKey] =
				(typeof category === 'undefined')
					? (typeof a[aKey] === 'string' ? '' : null)
					:
				(category === STYLE_KEY)
					? ''
					:
				(category === EVENT_KEY || category === ATTR_KEY)
					? undefined
					:
				{ namespace: a[aKey].namespace, value: undefined };

			continue;
		}

		var aValue = a[aKey];
		var bValue = b[aKey];

		// reference equal, so don't worry about it
		if (aValue === bValue && aKey !== 'value'
			|| category === EVENT_KEY && equalEvents(aValue, bValue))
		{
			continue;
		}

		diff = diff || {};
		diff[aKey] = bValue;
	}

	// add new stuff
	for (var bKey in b)
	{
		if (!(bKey in a))
		{
			diff = diff || {};
			diff[bKey] = b[bKey];
		}
	}

	return diff;
}


function diffChildren(aParent, bParent, patches, rootIndex)
{
	var aChildren = aParent.children;
	var bChildren = bParent.children;

	var aLen = aChildren.length;
	var bLen = bChildren.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (aLen > bLen)
	{
		patches.push(makePatch('p-remove-last', rootIndex, aLen - bLen));
	}
	else if (aLen < bLen)
	{
		patches.push(makePatch('p-append', rootIndex, bChildren.slice(aLen)));
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	var index = rootIndex;
	var minLen = aLen < bLen ? aLen : bLen;
	for (var i = 0; i < minLen; i++)
	{
		index++;
		var aChild = aChildren[i];
		diffHelp(aChild, bChildren[i], patches, index);
		index += aChild.descendantsCount || 0;
	}
}



////////////  KEYED DIFF  ////////////


function diffKeyedChildren(aParent, bParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var aChildren = aParent.children;
	var bChildren = bParent.children;
	var aLen = aChildren.length;
	var bLen = bChildren.length;
	var aIndex = 0;
	var bIndex = 0;

	var index = rootIndex;

	while (aIndex < aLen && bIndex < bLen)
	{
		var a = aChildren[aIndex];
		var b = bChildren[bIndex];

		var aKey = a._0;
		var bKey = b._0;
		var aNode = a._1;
		var bNode = b._1;

		// check if keys match

		if (aKey === bKey)
		{
			index++;
			diffHelp(aNode, bNode, localPatches, index);
			index += aNode.descendantsCount || 0;

			aIndex++;
			bIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var aLookAhead = aIndex + 1 < aLen;
		var bLookAhead = bIndex + 1 < bLen;

		if (aLookAhead)
		{
			var aNext = aChildren[aIndex + 1];
			var aNextKey = aNext._0;
			var aNextNode = aNext._1;
			var oldMatch = bKey === aNextKey;
		}

		if (bLookAhead)
		{
			var bNext = bChildren[bIndex + 1];
			var bNextKey = bNext._0;
			var bNextNode = bNext._1;
			var newMatch = aKey === bNextKey;
		}


		// swap a and b
		if (aLookAhead && bLookAhead && newMatch && oldMatch)
		{
			index++;
			diffHelp(aNode, bNextNode, localPatches, index);
			insertNode(changes, localPatches, aKey, bNode, bIndex, inserts);
			index += aNode.descendantsCount || 0;

			index++;
			removeNode(changes, localPatches, aKey, aNextNode, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 2;
			continue;
		}

		// insert b
		if (bLookAhead && newMatch)
		{
			index++;
			insertNode(changes, localPatches, bKey, bNode, bIndex, inserts);
			diffHelp(aNode, bNextNode, localPatches, index);
			index += aNode.descendantsCount || 0;

			aIndex += 1;
			bIndex += 2;
			continue;
		}

		// remove a
		if (aLookAhead && oldMatch)
		{
			index++;
			removeNode(changes, localPatches, aKey, aNode, index);
			index += aNode.descendantsCount || 0;

			index++;
			diffHelp(aNextNode, bNode, localPatches, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 1;
			continue;
		}

		// remove a, insert b
		if (aLookAhead && bLookAhead && aNextKey === bNextKey)
		{
			index++;
			removeNode(changes, localPatches, aKey, aNode, index);
			insertNode(changes, localPatches, bKey, bNode, bIndex, inserts);
			index += aNode.descendantsCount || 0;

			index++;
			diffHelp(aNextNode, bNextNode, localPatches, index);
			index += aNextNode.descendantsCount || 0;

			aIndex += 2;
			bIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (aIndex < aLen)
	{
		index++;
		var a = aChildren[aIndex];
		var aNode = a._1;
		removeNode(changes, localPatches, a._0, aNode, index);
		index += aNode.descendantsCount || 0;
		aIndex++;
	}

	var endInserts;
	while (bIndex < bLen)
	{
		endInserts = endInserts || [];
		var b = bChildren[bIndex];
		insertNode(changes, localPatches, b._0, b._1, undefined, endInserts);
		bIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || typeof endInserts !== 'undefined')
	{
		patches.push(makePatch('p-reorder', rootIndex, {
			patches: localPatches,
			inserts: inserts,
			endInserts: endInserts
		}));
	}
}



////////////  CHANGES FROM KEYED DIFF  ////////////


var POSTFIX = '_elmW6BL';


function insertNode(changes, localPatches, key, vnode, bIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (typeof entry === 'undefined')
	{
		entry = {
			tag: 'insert',
			vnode: vnode,
			index: bIndex,
			data: undefined
		};

		inserts.push({ index: bIndex, entry: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.tag === 'remove')
	{
		inserts.push({ index: bIndex, entry: entry });

		entry.tag = 'move';
		var subPatches = [];
		diffHelp(entry.vnode, vnode, subPatches, entry.index);
		entry.index = bIndex;
		entry.data.data = {
			patches: subPatches,
			entry: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	insertNode(changes, localPatches, key + POSTFIX, vnode, bIndex, inserts);
}


function removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (typeof entry === 'undefined')
	{
		var patch = makePatch('p-remove', index, undefined);
		localPatches.push(patch);

		changes[key] = {
			tag: 'remove',
			vnode: vnode,
			index: index,
			data: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.tag === 'insert')
	{
		entry.tag = 'move';
		var subPatches = [];
		diffHelp(vnode, entry.vnode, subPatches, index);

		var patch = makePatch('p-remove', index, {
			patches: subPatches,
			entry: entry
		});
		localPatches.push(patch);

		return;
	}

	// this key has already been removed or moved, a duplicate!
	removeNode(changes, localPatches, key + POSTFIX, vnode, index);
}



////////////  ADD DOM NODES  ////////////
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function addDomNodes(domNode, vNode, patches, eventNode)
{
	addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.descendantsCount, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.index;

	while (index === low)
	{
		var patchType = patch.type;

		if (patchType === 'p-thunk')
		{
			addDomNodes(domNode, vNode.node, patch.data, eventNode);
		}
		else if (patchType === 'p-reorder')
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;

			var subPatches = patch.data.patches;
			if (subPatches.length > 0)
			{
				addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 'p-remove')
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;

			var data = patch.data;
			if (typeof data !== 'undefined')
			{
				data.entry.data = domNode;
				var subPatches = data.patches;
				if (subPatches.length > 0)
				{
					addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.domNode = domNode;
			patch.eventNode = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.index) > high)
		{
			return i;
		}
	}

	switch (vNode.type)
	{
		case 'tagger':
			var subNode = vNode.node;

			while (subNode.type === "tagger")
			{
				subNode = subNode.node;
			}

			return addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);

		case 'node':
			var vChildren = vNode.children;
			var childNodes = domNode.childNodes;
			for (var j = 0; j < vChildren.length; j++)
			{
				low++;
				var vChild = vChildren[j];
				var nextLow = low + (vChild.descendantsCount || 0);
				if (low <= index && index <= nextLow)
				{
					i = addDomNodesHelp(childNodes[j], vChild, patches, i, low, nextLow, eventNode);
					if (!(patch = patches[i]) || (index = patch.index) > high)
					{
						return i;
					}
				}
				low = nextLow;
			}
			return i;

		case 'keyed-node':
			var vChildren = vNode.children;
			var childNodes = domNode.childNodes;
			for (var j = 0; j < vChildren.length; j++)
			{
				low++;
				var vChild = vChildren[j]._1;
				var nextLow = low + (vChild.descendantsCount || 0);
				if (low <= index && index <= nextLow)
				{
					i = addDomNodesHelp(childNodes[j], vChild, patches, i, low, nextLow, eventNode);
					if (!(patch = patches[i]) || (index = patch.index) > high)
					{
						return i;
					}
				}
				low = nextLow;
			}
			return i;

		case 'text':
		case 'thunk':
			throw new Error('should never traverse `text` or `thunk` nodes like this');
	}
}



////////////  APPLY PATCHES  ////////////


function applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return applyPatchesHelp(rootDomNode, patches);
}

function applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.domNode
		var newNode = applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function applyPatch(domNode, patch)
{
	switch (patch.type)
	{
		case 'p-redraw':
			return applyPatchRedraw(domNode, patch.data, patch.eventNode);

		case 'p-facts':
			applyFacts(domNode, patch.eventNode, patch.data);
			return domNode;

		case 'p-text':
			domNode.replaceData(0, domNode.length, patch.data);
			return domNode;

		case 'p-thunk':
			return applyPatchesHelp(domNode, patch.data);

		case 'p-tagger':
			if (typeof domNode.elm_event_node_ref !== 'undefined')
			{
				domNode.elm_event_node_ref.tagger = patch.data;
			}
			else
			{
				domNode.elm_event_node_ref = { tagger: patch.data, parent: patch.eventNode };
			}
			return domNode;

		case 'p-remove-last':
			var i = patch.data;
			while (i--)
			{
				domNode.removeChild(domNode.lastChild);
			}
			return domNode;

		case 'p-append':
			var newNodes = patch.data;
			for (var i = 0; i < newNodes.length; i++)
			{
				domNode.appendChild(render(newNodes[i], patch.eventNode));
			}
			return domNode;

		case 'p-remove':
			var data = patch.data;
			if (typeof data === 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.entry;
			if (typeof entry.index !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.data = applyPatchesHelp(domNode, data.patches);
			return domNode;

		case 'p-reorder':
			return applyPatchReorder(domNode, patch);

		case 'p-custom':
			var impl = patch.data;
			return impl.applyPatch(domNode, impl.data);

		default:
			throw new Error('Ran into an unknown patch!');
	}
}


function applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = render(vNode, eventNode);

	if (typeof newNode.elm_event_node_ref === 'undefined')
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function applyPatchReorder(domNode, patch)
{
	var data = patch.data;

	// remove end inserts
	var frag = applyPatchReorderEndInsertsHelp(data.endInserts, patch);

	// removals
	domNode = applyPatchesHelp(domNode, data.patches);

	// inserts
	var inserts = data.inserts;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.entry;
		var node = entry.tag === 'move'
			? entry.data
			: render(entry.vnode, patch.eventNode);
		domNode.insertBefore(node, domNode.childNodes[insert.index]);
	}

	// add end inserts
	if (typeof frag !== 'undefined')
	{
		domNode.appendChild(frag);
	}

	return domNode;
}


function applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (typeof endInserts === 'undefined')
	{
		return;
	}

	var frag = localDoc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.entry;
		frag.appendChild(entry.tag === 'move'
			? entry.data
			: render(entry.vnode, patch.eventNode)
		);
	}
	return frag;
}


// PROGRAMS

var program = makeProgram(checkNoFlags);
var programWithFlags = makeProgram(checkYesFlags);

function makeProgram(flagChecker)
{
	return F2(function(debugWrap, impl)
	{
		return function(flagDecoder)
		{
			return function(object, moduleName, debugMetadata)
			{
				var checker = flagChecker(flagDecoder, moduleName);
				if (typeof debugMetadata === 'undefined')
				{
					normalSetup(impl, object, moduleName, checker);
				}
				else
				{
					debugSetup(A2(debugWrap, debugMetadata, impl), object, moduleName, checker);
				}
			};
		};
	});
}

function staticProgram(vNode)
{
	var nothing = _elm_lang$core$Native_Utils.Tuple2(
		_elm_lang$core$Native_Utils.Tuple0,
		_elm_lang$core$Platform_Cmd$none
	);
	return A2(program, _elm_lang$virtual_dom$VirtualDom_Debug$wrap, {
		init: nothing,
		view: function() { return vNode; },
		update: F2(function() { return nothing; }),
		subscriptions: function() { return _elm_lang$core$Platform_Sub$none; }
	})();
}


// FLAG CHECKERS

function checkNoFlags(flagDecoder, moduleName)
{
	return function(init, flags, domNode)
	{
		if (typeof flags === 'undefined')
		{
			return init;
		}

		var errorMessage =
			'The `' + moduleName + '` module does not need flags.\n'
			+ 'Initialize it with no arguments and you should be all set!';

		crash(errorMessage, domNode);
	};
}

function checkYesFlags(flagDecoder, moduleName)
{
	return function(init, flags, domNode)
	{
		if (typeof flagDecoder === 'undefined')
		{
			var errorMessage =
				'Are you trying to sneak a Never value into Elm? Trickster!\n'
				+ 'It looks like ' + moduleName + '.main is defined with `programWithFlags` but has type `Program Never`.\n'
				+ 'Use `program` instead if you do not want flags.'

			crash(errorMessage, domNode);
		}

		var result = A2(_elm_lang$core$Native_Json.run, flagDecoder, flags);
		if (result.ctor === 'Ok')
		{
			return init(result._0);
		}

		var errorMessage =
			'Trying to initialize the `' + moduleName + '` module with an unexpected flag.\n'
			+ 'I tried to convert it to an Elm value, but ran into this problem:\n\n'
			+ result._0;

		crash(errorMessage, domNode);
	};
}

function crash(errorMessage, domNode)
{
	if (domNode)
	{
		domNode.innerHTML =
			'<div style="padding-left:1em;">'
			+ '<h2 style="font-weight:normal;"><b>Oops!</b> Something went wrong when starting your Elm program.</h2>'
			+ '<pre style="padding-left:1em;">' + errorMessage + '</pre>'
			+ '</div>';
	}

	throw new Error(errorMessage);
}


//  NORMAL SETUP

function normalSetup(impl, object, moduleName, flagChecker)
{
	object['embed'] = function embed(node, flags)
	{
		while (node.lastChild)
		{
			node.removeChild(node.lastChild);
		}

		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, node),
			impl.update,
			impl.subscriptions,
			normalRenderer(node, impl.view)
		);
	};

	object['fullscreen'] = function fullscreen(flags)
	{
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, document.body),
			impl.update,
			impl.subscriptions,
			normalRenderer(document.body, impl.view)
		);
	};
}

function normalRenderer(parentNode, view)
{
	return function(tagger, initialModel)
	{
		var eventNode = { tagger: tagger, parent: undefined };
		var initialVirtualNode = view(initialModel);
		var domNode = render(initialVirtualNode, eventNode);
		parentNode.appendChild(domNode);
		return makeStepper(domNode, view, initialVirtualNode, eventNode);
	};
}


// STEPPER

var rAF =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { setTimeout(callback, 1000 / 60); };

function makeStepper(domNode, view, initialVirtualNode, eventNode)
{
	var state = 'NO_REQUEST';
	var currNode = initialVirtualNode;
	var nextModel;

	function updateIfNeeded()
	{
		switch (state)
		{
			case 'NO_REQUEST':
				throw new Error(
					'Unexpected draw callback.\n' +
					'Please report this to <https://github.com/elm-lang/virtual-dom/issues>.'
				);

			case 'PENDING_REQUEST':
				rAF(updateIfNeeded);
				state = 'EXTRA_REQUEST';

				var nextNode = view(nextModel);
				var patches = diff(currNode, nextNode);
				domNode = applyPatches(domNode, currNode, patches, eventNode);
				currNode = nextNode;

				return;

			case 'EXTRA_REQUEST':
				state = 'NO_REQUEST';
				return;
		}
	}

	return function stepper(model)
	{
		if (state === 'NO_REQUEST')
		{
			rAF(updateIfNeeded);
		}
		state = 'PENDING_REQUEST';
		nextModel = model;
	};
}


// DEBUG SETUP

function debugSetup(impl, object, moduleName, flagChecker)
{
	object['fullscreen'] = function fullscreen(flags)
	{
		var popoutRef = { doc: undefined };
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, document.body),
			impl.update(scrollTask(popoutRef)),
			impl.subscriptions,
			debugRenderer(moduleName, document.body, popoutRef, impl.view, impl.viewIn, impl.viewOut)
		);
	};

	object['embed'] = function fullscreen(node, flags)
	{
		var popoutRef = { doc: undefined };
		return _elm_lang$core$Native_Platform.initialize(
			flagChecker(impl.init, flags, node),
			impl.update(scrollTask(popoutRef)),
			impl.subscriptions,
			debugRenderer(moduleName, node, popoutRef, impl.view, impl.viewIn, impl.viewOut)
		);
	};
}

function scrollTask(popoutRef)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var doc = popoutRef.doc;
		if (doc)
		{
			var msgs = doc.getElementsByClassName('debugger-sidebar-messages')[0];
			if (msgs)
			{
				msgs.scrollTop = msgs.scrollHeight;
			}
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}


function debugRenderer(moduleName, parentNode, popoutRef, view, viewIn, viewOut)
{
	return function(tagger, initialModel)
	{
		var appEventNode = { tagger: tagger, parent: undefined };
		var eventNode = { tagger: tagger, parent: undefined };

		// make normal stepper
		var appVirtualNode = view(initialModel);
		var appNode = render(appVirtualNode, appEventNode);
		parentNode.appendChild(appNode);
		var appStepper = makeStepper(appNode, view, appVirtualNode, appEventNode);

		// make overlay stepper
		var overVirtualNode = viewIn(initialModel)._1;
		var overNode = render(overVirtualNode, eventNode);
		parentNode.appendChild(overNode);
		var wrappedViewIn = wrapViewIn(appEventNode, overNode, viewIn);
		var overStepper = makeStepper(overNode, wrappedViewIn, overVirtualNode, eventNode);

		// make debugger stepper
		var debugStepper = makeDebugStepper(initialModel, viewOut, eventNode, parentNode, moduleName, popoutRef);

		return function stepper(model)
		{
			appStepper(model);
			overStepper(model);
			debugStepper(model);
		}
	};
}

function makeDebugStepper(initialModel, view, eventNode, parentNode, moduleName, popoutRef)
{
	var curr;
	var domNode;

	return function stepper(model)
	{
		if (!model.isDebuggerOpen)
		{
			return;
		}

		if (!popoutRef.doc)
		{
			curr = view(model);
			domNode = openDebugWindow(moduleName, popoutRef, curr, eventNode);
			return;
		}

		// switch to document of popout
		localDoc = popoutRef.doc;

		var next = view(model);
		var patches = diff(curr, next);
		domNode = applyPatches(domNode, curr, patches, eventNode);
		curr = next;

		// switch back to normal document
		localDoc = document;
	};
}

function openDebugWindow(moduleName, popoutRef, virtualNode, eventNode)
{
	var w = 900;
	var h = 360;
	var x = screen.width - w;
	var y = screen.height - h;
	var debugWindow = window.open('', '', 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y);

	// switch to window document
	localDoc = debugWindow.document;

	popoutRef.doc = localDoc;
	localDoc.title = 'Debugger - ' + moduleName;
	localDoc.body.style.margin = '0';
	localDoc.body.style.padding = '0';
	var domNode = render(virtualNode, eventNode);
	localDoc.body.appendChild(domNode);

	localDoc.addEventListener('keydown', function(event) {
		if (event.metaKey && event.which === 82)
		{
			window.location.reload();
		}
		if (event.which === 38)
		{
			eventNode.tagger({ ctor: 'Up' });
			event.preventDefault();
		}
		if (event.which === 40)
		{
			eventNode.tagger({ ctor: 'Down' });
			event.preventDefault();
		}
	});

	function close()
	{
		popoutRef.doc = undefined;
		debugWindow.close();
	}
	window.addEventListener('unload', close);
	debugWindow.addEventListener('unload', function() {
		popoutRef.doc = undefined;
		window.removeEventListener('unload', close);
		eventNode.tagger({ ctor: 'Close' });
	});

	// switch back to the normal document
	localDoc = document;

	return domNode;
}


// BLOCK EVENTS

function wrapViewIn(appEventNode, overlayNode, viewIn)
{
	var ignorer = makeIgnorer(overlayNode);
	var blocking = 'Normal';
	var overflow;

	var normalTagger = appEventNode.tagger;
	var blockTagger = function() {};

	return function(model)
	{
		var tuple = viewIn(model);
		var newBlocking = tuple._0.ctor;
		appEventNode.tagger = newBlocking === 'Normal' ? normalTagger : blockTagger;
		if (blocking !== newBlocking)
		{
			traverse('removeEventListener', ignorer, blocking);
			traverse('addEventListener', ignorer, newBlocking);

			if (blocking === 'Normal')
			{
				overflow = document.body.style.overflow;
				document.body.style.overflow = 'hidden';
			}

			if (newBlocking === 'Normal')
			{
				document.body.style.overflow = overflow;
			}

			blocking = newBlocking;
		}
		return tuple._1;
	}
}

function traverse(verbEventListener, ignorer, blocking)
{
	switch(blocking)
	{
		case 'Normal':
			return;

		case 'Pause':
			return traverseHelp(verbEventListener, ignorer, mostEvents);

		case 'Message':
			return traverseHelp(verbEventListener, ignorer, allEvents);
	}
}

function traverseHelp(verbEventListener, handler, eventNames)
{
	for (var i = 0; i < eventNames.length; i++)
	{
		document.body[verbEventListener](eventNames[i], handler, true);
	}
}

function makeIgnorer(overlayNode)
{
	return function(event)
	{
		if (event.type === 'keydown' && event.metaKey && event.which === 82)
		{
			return;
		}

		var isScroll = event.type === 'scroll' || event.type === 'wheel';

		var node = event.target;
		while (node !== null)
		{
			if (node.className === 'elm-overlay-message-details' && isScroll)
			{
				return;
			}

			if (node === overlayNode && !isScroll)
			{
				return;
			}
			node = node.parentNode;
		}

		event.stopPropagation();
		event.preventDefault();
	}
}

var mostEvents = [
	'click', 'dblclick', 'mousemove',
	'mouseup', 'mousedown', 'mouseenter', 'mouseleave',
	'touchstart', 'touchend', 'touchcancel', 'touchmove',
	'pointerdown', 'pointerup', 'pointerover', 'pointerout',
	'pointerenter', 'pointerleave', 'pointermove', 'pointercancel',
	'dragstart', 'drag', 'dragend', 'dragenter', 'dragover', 'dragleave', 'drop',
	'keyup', 'keydown', 'keypress',
	'input', 'change',
	'focus', 'blur'
];

var allEvents = mostEvents.concat('wheel', 'scroll');


return {
	node: node,
	text: text,
	custom: custom,
	map: F2(map),

	on: F3(on),
	style: style,
	property: F2(property),
	attribute: F2(attribute),
	attributeNS: F3(attributeNS),
	mapProperty: F2(mapProperty),

	lazy: F2(lazy),
	lazy2: F3(lazy2),
	lazy3: F4(lazy3),
	keyedNode: F3(keyedNode),

	program: program,
	programWithFlags: programWithFlags,
	staticProgram: staticProgram
};

}();

var _elm_lang$virtual_dom$VirtualDom$programWithFlags = function (impl) {
	return A2(_elm_lang$virtual_dom$Native_VirtualDom.programWithFlags, _elm_lang$virtual_dom$VirtualDom_Debug$wrapWithFlags, impl);
};
var _elm_lang$virtual_dom$VirtualDom$program = function (impl) {
	return A2(_elm_lang$virtual_dom$Native_VirtualDom.program, _elm_lang$virtual_dom$VirtualDom_Debug$wrap, impl);
};
var _elm_lang$virtual_dom$VirtualDom$keyedNode = _elm_lang$virtual_dom$Native_VirtualDom.keyedNode;
var _elm_lang$virtual_dom$VirtualDom$lazy3 = _elm_lang$virtual_dom$Native_VirtualDom.lazy3;
var _elm_lang$virtual_dom$VirtualDom$lazy2 = _elm_lang$virtual_dom$Native_VirtualDom.lazy2;
var _elm_lang$virtual_dom$VirtualDom$lazy = _elm_lang$virtual_dom$Native_VirtualDom.lazy;
var _elm_lang$virtual_dom$VirtualDom$defaultOptions = {stopPropagation: false, preventDefault: false};
var _elm_lang$virtual_dom$VirtualDom$onWithOptions = _elm_lang$virtual_dom$Native_VirtualDom.on;
var _elm_lang$virtual_dom$VirtualDom$on = F2(
	function (eventName, decoder) {
		return A3(_elm_lang$virtual_dom$VirtualDom$onWithOptions, eventName, _elm_lang$virtual_dom$VirtualDom$defaultOptions, decoder);
	});
var _elm_lang$virtual_dom$VirtualDom$style = _elm_lang$virtual_dom$Native_VirtualDom.style;
var _elm_lang$virtual_dom$VirtualDom$mapProperty = _elm_lang$virtual_dom$Native_VirtualDom.mapProperty;
var _elm_lang$virtual_dom$VirtualDom$attributeNS = _elm_lang$virtual_dom$Native_VirtualDom.attributeNS;
var _elm_lang$virtual_dom$VirtualDom$attribute = _elm_lang$virtual_dom$Native_VirtualDom.attribute;
var _elm_lang$virtual_dom$VirtualDom$property = _elm_lang$virtual_dom$Native_VirtualDom.property;
var _elm_lang$virtual_dom$VirtualDom$map = _elm_lang$virtual_dom$Native_VirtualDom.map;
var _elm_lang$virtual_dom$VirtualDom$text = _elm_lang$virtual_dom$Native_VirtualDom.text;
var _elm_lang$virtual_dom$VirtualDom$node = _elm_lang$virtual_dom$Native_VirtualDom.node;
var _elm_lang$virtual_dom$VirtualDom$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});
var _elm_lang$virtual_dom$VirtualDom$Node = {ctor: 'Node'};
var _elm_lang$virtual_dom$VirtualDom$Property = {ctor: 'Property'};

var _elm_lang$html$Html$programWithFlags = _elm_lang$virtual_dom$VirtualDom$programWithFlags;
var _elm_lang$html$Html$program = _elm_lang$virtual_dom$VirtualDom$program;
var _elm_lang$html$Html$beginnerProgram = function (_p0) {
	var _p1 = _p0;
	return _elm_lang$html$Html$program(
		{
			init: A2(
				_elm_lang$core$Platform_Cmd_ops['!'],
				_p1.model,
				{ctor: '[]'}),
			update: F2(
				function (msg, model) {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						A2(_p1.update, msg, model),
						{ctor: '[]'});
				}),
			view: _p1.view,
			subscriptions: function (_p2) {
				return _elm_lang$core$Platform_Sub$none;
			}
		});
};
var _elm_lang$html$Html$map = _elm_lang$virtual_dom$VirtualDom$map;
var _elm_lang$html$Html$text = _elm_lang$virtual_dom$VirtualDom$text;
var _elm_lang$html$Html$node = _elm_lang$virtual_dom$VirtualDom$node;
var _elm_lang$html$Html$body = _elm_lang$html$Html$node('body');
var _elm_lang$html$Html$section = _elm_lang$html$Html$node('section');
var _elm_lang$html$Html$nav = _elm_lang$html$Html$node('nav');
var _elm_lang$html$Html$article = _elm_lang$html$Html$node('article');
var _elm_lang$html$Html$aside = _elm_lang$html$Html$node('aside');
var _elm_lang$html$Html$h1 = _elm_lang$html$Html$node('h1');
var _elm_lang$html$Html$h2 = _elm_lang$html$Html$node('h2');
var _elm_lang$html$Html$h3 = _elm_lang$html$Html$node('h3');
var _elm_lang$html$Html$h4 = _elm_lang$html$Html$node('h4');
var _elm_lang$html$Html$h5 = _elm_lang$html$Html$node('h5');
var _elm_lang$html$Html$h6 = _elm_lang$html$Html$node('h6');
var _elm_lang$html$Html$header = _elm_lang$html$Html$node('header');
var _elm_lang$html$Html$footer = _elm_lang$html$Html$node('footer');
var _elm_lang$html$Html$address = _elm_lang$html$Html$node('address');
var _elm_lang$html$Html$main_ = _elm_lang$html$Html$node('main');
var _elm_lang$html$Html$p = _elm_lang$html$Html$node('p');
var _elm_lang$html$Html$hr = _elm_lang$html$Html$node('hr');
var _elm_lang$html$Html$pre = _elm_lang$html$Html$node('pre');
var _elm_lang$html$Html$blockquote = _elm_lang$html$Html$node('blockquote');
var _elm_lang$html$Html$ol = _elm_lang$html$Html$node('ol');
var _elm_lang$html$Html$ul = _elm_lang$html$Html$node('ul');
var _elm_lang$html$Html$li = _elm_lang$html$Html$node('li');
var _elm_lang$html$Html$dl = _elm_lang$html$Html$node('dl');
var _elm_lang$html$Html$dt = _elm_lang$html$Html$node('dt');
var _elm_lang$html$Html$dd = _elm_lang$html$Html$node('dd');
var _elm_lang$html$Html$figure = _elm_lang$html$Html$node('figure');
var _elm_lang$html$Html$figcaption = _elm_lang$html$Html$node('figcaption');
var _elm_lang$html$Html$div = _elm_lang$html$Html$node('div');
var _elm_lang$html$Html$a = _elm_lang$html$Html$node('a');
var _elm_lang$html$Html$em = _elm_lang$html$Html$node('em');
var _elm_lang$html$Html$strong = _elm_lang$html$Html$node('strong');
var _elm_lang$html$Html$small = _elm_lang$html$Html$node('small');
var _elm_lang$html$Html$s = _elm_lang$html$Html$node('s');
var _elm_lang$html$Html$cite = _elm_lang$html$Html$node('cite');
var _elm_lang$html$Html$q = _elm_lang$html$Html$node('q');
var _elm_lang$html$Html$dfn = _elm_lang$html$Html$node('dfn');
var _elm_lang$html$Html$abbr = _elm_lang$html$Html$node('abbr');
var _elm_lang$html$Html$time = _elm_lang$html$Html$node('time');
var _elm_lang$html$Html$code = _elm_lang$html$Html$node('code');
var _elm_lang$html$Html$var = _elm_lang$html$Html$node('var');
var _elm_lang$html$Html$samp = _elm_lang$html$Html$node('samp');
var _elm_lang$html$Html$kbd = _elm_lang$html$Html$node('kbd');
var _elm_lang$html$Html$sub = _elm_lang$html$Html$node('sub');
var _elm_lang$html$Html$sup = _elm_lang$html$Html$node('sup');
var _elm_lang$html$Html$i = _elm_lang$html$Html$node('i');
var _elm_lang$html$Html$b = _elm_lang$html$Html$node('b');
var _elm_lang$html$Html$u = _elm_lang$html$Html$node('u');
var _elm_lang$html$Html$mark = _elm_lang$html$Html$node('mark');
var _elm_lang$html$Html$ruby = _elm_lang$html$Html$node('ruby');
var _elm_lang$html$Html$rt = _elm_lang$html$Html$node('rt');
var _elm_lang$html$Html$rp = _elm_lang$html$Html$node('rp');
var _elm_lang$html$Html$bdi = _elm_lang$html$Html$node('bdi');
var _elm_lang$html$Html$bdo = _elm_lang$html$Html$node('bdo');
var _elm_lang$html$Html$span = _elm_lang$html$Html$node('span');
var _elm_lang$html$Html$br = _elm_lang$html$Html$node('br');
var _elm_lang$html$Html$wbr = _elm_lang$html$Html$node('wbr');
var _elm_lang$html$Html$ins = _elm_lang$html$Html$node('ins');
var _elm_lang$html$Html$del = _elm_lang$html$Html$node('del');
var _elm_lang$html$Html$img = _elm_lang$html$Html$node('img');
var _elm_lang$html$Html$iframe = _elm_lang$html$Html$node('iframe');
var _elm_lang$html$Html$embed = _elm_lang$html$Html$node('embed');
var _elm_lang$html$Html$object = _elm_lang$html$Html$node('object');
var _elm_lang$html$Html$param = _elm_lang$html$Html$node('param');
var _elm_lang$html$Html$video = _elm_lang$html$Html$node('video');
var _elm_lang$html$Html$audio = _elm_lang$html$Html$node('audio');
var _elm_lang$html$Html$source = _elm_lang$html$Html$node('source');
var _elm_lang$html$Html$track = _elm_lang$html$Html$node('track');
var _elm_lang$html$Html$canvas = _elm_lang$html$Html$node('canvas');
var _elm_lang$html$Html$math = _elm_lang$html$Html$node('math');
var _elm_lang$html$Html$table = _elm_lang$html$Html$node('table');
var _elm_lang$html$Html$caption = _elm_lang$html$Html$node('caption');
var _elm_lang$html$Html$colgroup = _elm_lang$html$Html$node('colgroup');
var _elm_lang$html$Html$col = _elm_lang$html$Html$node('col');
var _elm_lang$html$Html$tbody = _elm_lang$html$Html$node('tbody');
var _elm_lang$html$Html$thead = _elm_lang$html$Html$node('thead');
var _elm_lang$html$Html$tfoot = _elm_lang$html$Html$node('tfoot');
var _elm_lang$html$Html$tr = _elm_lang$html$Html$node('tr');
var _elm_lang$html$Html$td = _elm_lang$html$Html$node('td');
var _elm_lang$html$Html$th = _elm_lang$html$Html$node('th');
var _elm_lang$html$Html$form = _elm_lang$html$Html$node('form');
var _elm_lang$html$Html$fieldset = _elm_lang$html$Html$node('fieldset');
var _elm_lang$html$Html$legend = _elm_lang$html$Html$node('legend');
var _elm_lang$html$Html$label = _elm_lang$html$Html$node('label');
var _elm_lang$html$Html$input = _elm_lang$html$Html$node('input');
var _elm_lang$html$Html$button = _elm_lang$html$Html$node('button');
var _elm_lang$html$Html$select = _elm_lang$html$Html$node('select');
var _elm_lang$html$Html$datalist = _elm_lang$html$Html$node('datalist');
var _elm_lang$html$Html$optgroup = _elm_lang$html$Html$node('optgroup');
var _elm_lang$html$Html$option = _elm_lang$html$Html$node('option');
var _elm_lang$html$Html$textarea = _elm_lang$html$Html$node('textarea');
var _elm_lang$html$Html$keygen = _elm_lang$html$Html$node('keygen');
var _elm_lang$html$Html$output = _elm_lang$html$Html$node('output');
var _elm_lang$html$Html$progress = _elm_lang$html$Html$node('progress');
var _elm_lang$html$Html$meter = _elm_lang$html$Html$node('meter');
var _elm_lang$html$Html$details = _elm_lang$html$Html$node('details');
var _elm_lang$html$Html$summary = _elm_lang$html$Html$node('summary');
var _elm_lang$html$Html$menuitem = _elm_lang$html$Html$node('menuitem');
var _elm_lang$html$Html$menu = _elm_lang$html$Html$node('menu');

var _elm_lang$html$Html_Events$keyCode = A2(_elm_lang$core$Json_Decode$field, 'keyCode', _elm_lang$core$Json_Decode$int);
var _elm_lang$html$Html_Events$targetChecked = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'checked',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$bool);
var _elm_lang$html$Html_Events$targetValue = A2(
	_elm_lang$core$Json_Decode$at,
	{
		ctor: '::',
		_0: 'target',
		_1: {
			ctor: '::',
			_0: 'value',
			_1: {ctor: '[]'}
		}
	},
	_elm_lang$core$Json_Decode$string);
var _elm_lang$html$Html_Events$defaultOptions = _elm_lang$virtual_dom$VirtualDom$defaultOptions;
var _elm_lang$html$Html_Events$onWithOptions = _elm_lang$virtual_dom$VirtualDom$onWithOptions;
var _elm_lang$html$Html_Events$on = _elm_lang$virtual_dom$VirtualDom$on;
var _elm_lang$html$Html_Events$onFocus = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'focus',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onBlur = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'blur',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onSubmitOptions = _elm_lang$core$Native_Utils.update(
	_elm_lang$html$Html_Events$defaultOptions,
	{preventDefault: true});
var _elm_lang$html$Html_Events$onSubmit = function (msg) {
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'submit',
		_elm_lang$html$Html_Events$onSubmitOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onCheck = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'change',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$targetChecked));
};
var _elm_lang$html$Html_Events$onInput = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'input',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$targetValue));
};
var _elm_lang$html$Html_Events$onMouseOut = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseout',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseOver = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseover',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseLeave = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseleave',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseEnter = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseenter',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseUp = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mouseup',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onMouseDown = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mousedown',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onDoubleClick = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'dblclick',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$onClick = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'click',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _elm_lang$html$Html_Events$Options = F2(
	function (a, b) {
		return {stopPropagation: a, preventDefault: b};
	});

var _CareerPlug$ats$Library_Core$onEnter = function (msg) {
	var isEnter = function (code) {
		return _elm_lang$core$Native_Utils.eq(code, 13) ? _elm_lang$core$Json_Decode$succeed(msg) : _elm_lang$core$Json_Decode$fail('not ENTER');
	};
	return A2(
		_elm_lang$html$Html_Events$on,
		'keydown',
		A2(_elm_lang$core$Json_Decode$andThen, isEnter, _elm_lang$html$Html_Events$keyCode));
};
var _CareerPlug$ats$Library_Core$capitalize = function (string) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_elm_lang$core$String$toUpper(
			A2(_elm_lang$core$String$left, 1, string)),
		A2(_elm_lang$core$String$dropLeft, 1, string));
};
var _CareerPlug$ats$Library_Core$traceDecoder = F2(
	function (message, decoder) {
		var showError = function (value) {
			var _p0 = A2(_elm_lang$core$Json_Decode$decodeValue, decoder, value);
			if (_p0.ctor === 'Ok') {
				return _elm_lang$core$Json_Decode$succeed(_p0._0);
			} else {
				return _elm_lang$core$Json_Decode$fail(
					A2(_elm_lang$core$Debug$log, message, _p0._0));
			}
		};
		return A2(_elm_lang$core$Json_Decode$andThen, showError, _elm_lang$core$Json_Decode$value);
	});
var _CareerPlug$ats$Library_Core$downcaseKeys = function (source) {
	var downcaseKey = F3(
		function (key, val, dict) {
			return A3(
				_elm_lang$core$Dict$insert,
				_elm_lang$core$String$toLower(key),
				val,
				dict);
		});
	return A3(_elm_lang$core$Dict$foldr, downcaseKey, _elm_lang$core$Dict$empty, source);
};
var _CareerPlug$ats$Library_Core$dateDecoder = function () {
	var date = function (val) {
		var _p1 = _elm_lang$core$Date$fromString(val);
		if (_p1.ctor === 'Ok') {
			return _elm_lang$core$Json_Decode$succeed(_p1._0);
		} else {
			return _elm_lang$core$Json_Decode$fail(_p1._0);
		}
	};
	return A2(_elm_lang$core$Json_Decode$andThen, date, _elm_lang$core$Json_Decode$string);
}();
var _CareerPlug$ats$Library_Core$boolEncoder = function (val) {
	var trans = val ? 1 : 0;
	return _elm_lang$core$Json_Encode$int(trans);
};
var _CareerPlug$ats$Library_Core$flexBoolDecoder = function ($default) {
	var stringD = function (v) {
		return _elm_lang$core$Native_Utils.eq(v, 'true') ? true : false;
	};
	var intD = function (v) {
		return (_elm_lang$core$Native_Utils.cmp(v, 1) > 0) ? true : false;
	};
	return _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$bool,
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, intD, _elm_lang$core$Json_Decode$int),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$core$Json_Decode$map, stringD, _elm_lang$core$Json_Decode$string),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$null($default),
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _CareerPlug$ats$Library_Core$emailRegex = _elm_lang$core$Regex$caseInsensitive(
	_elm_lang$core$Regex$regex('[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+'));
var _CareerPlug$ats$Library_Core$validEmail = _elm_lang$core$Regex$contains(_CareerPlug$ats$Library_Core$emailRegex);
var _CareerPlug$ats$Library_Core$truncateString = F2(
	function (len, str) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(str),
			len) > 0) ? A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$String$left, len, str),
			'…') : str;
	});
var _CareerPlug$ats$Library_Core$sortByDate = F2(
	function (list, dateResolver) {
		var dateComparison = F2(
			function (a, b) {
				return A3(
					_rluiten$elm_date_extra$Date_Extra_Compare$is,
					_rluiten$elm_date_extra$Date_Extra_Compare$After,
					dateResolver(a),
					dateResolver(b)) ? _elm_lang$core$Basics$GT : _elm_lang$core$Basics$LT;
			});
		return A2(_elm_lang$core$List$sortWith, dateComparison, list);
	});
var _CareerPlug$ats$Library_Core$longDate = function (d) {
	return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%B %e, %Y', d);
};
var _CareerPlug$ats$Library_Core$shortTime = function (d) {
	return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%l:%M %P', d);
};
var _CareerPlug$ats$Library_Core$shortDate = function (d) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%m-%d-', d),
		A2(
			_elm_lang$core$String$right,
			2,
			A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%Y', d)));
};
var _CareerPlug$ats$Library_Core$daysAgo = F2(
	function (now, d) {
		var ago = F2(
			function (thing, val) {
				var plural = _elm_lang$core$Native_Utils.eq(val, 1) ? '' : 's';
				return _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(val),
						_1: {
							ctor: '::',
							_0: ' ',
							_1: {
								ctor: '::',
								_0: thing,
								_1: {
									ctor: '::',
									_0: plural,
									_1: {
										ctor: '::',
										_0: ' ago',
										_1: {ctor: '[]'}
									}
								}
							}
						}
					});
			});
		var delta = A2(
			_rluiten$elm_date_extra$Date_Extra_Duration$diff,
			_elm_lang$core$Date$fromTime(now),
			d);
		return (_elm_lang$core$Native_Utils.eq(delta.day, 0) && ((_elm_lang$core$Native_Utils.cmp(delta.month, 1) < 0) && (_elm_lang$core$Native_Utils.cmp(delta.year, 1) < 0))) ? ((_elm_lang$core$Native_Utils.eq(delta.hour, 0) && (_elm_lang$core$Native_Utils.cmp(delta.minute, 5) < 0)) ? 'just now' : ((_elm_lang$core$Native_Utils.cmp(
			delta.hour,
			_elm_lang$core$Date$hour(
				_elm_lang$core$Date$fromTime(now))) < 0) ? 'today' : A2(ago, 'day', 1))) : (((_elm_lang$core$Native_Utils.cmp(delta.month, 1) < 0) && (_elm_lang$core$Native_Utils.cmp(delta.year, 1) < 0)) ? A2(ago, 'day', delta.day) : ((_elm_lang$core$Native_Utils.cmp(delta.year, 1) < 0) ? A2(ago, 'month', delta.month) : _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%b', d),
				_1: {
					ctor: '::',
					_0: ' ‘',
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$core$String$right,
							2,
							A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%Y', d)),
						_1: {ctor: '[]'}
					}
				}
			})));
	});
var _CareerPlug$ats$Library_Core$tightDate = function (d) {
	return A2(
		_elm_lang$core$String$join,
		'/',
		{
			ctor: '::',
			_0: _elm_lang$core$Basics$toString(
				_rluiten$elm_date_extra$Date_Extra_Core$monthToInt(
					_elm_lang$core$Date$month(d))),
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Basics$toString(
					_elm_lang$core$Date$day(d)),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Library_Core$floatPrecision = F2(
	function (decimals, n) {
		var decpow = Math.pow(10, decimals);
		var nshift = n * _elm_lang$core$Basics$toFloat(decpow);
		var nshifti = _elm_lang$core$Basics$round(nshift);
		var nshifti_ = _elm_lang$core$Basics$abs(nshifti);
		var ni = (nshifti_ / decpow) | 0;
		var nis = (_elm_lang$core$Native_Utils.cmp(nshifti, 0) < 0) ? _elm_lang$core$Basics$toString(0 - ni) : _elm_lang$core$Basics$toString(ni);
		var nf = nshifti_ - (ni * decpow);
		var nfs = _elm_lang$core$Basics$toString(nf);
		return A2(
			_elm_lang$core$Basics_ops['++'],
			nis,
			A3(
				_elm_lang$core$String$padLeft,
				decimals,
				_elm_lang$core$Native_Utils.chr('0'),
				nfs));
	});

var _CareerPlug$ats$AlertCenter_Model$applicationAlertsAsList = function (applicationAlerts) {
	return A2(
		_elm_lang$core$List$map,
		function (_p0) {
			var _p1 = _p0;
			return _p1._1;
		},
		_elm_lang$core$Dict$toList(applicationAlerts));
};
var _CareerPlug$ats$AlertCenter_Model$unreadAlerts = function (applicationAlerts) {
	return A2(
		_elm_lang$core$List$filter,
		function (alert) {
			var _p2 = alert.readAt;
			if (_p2.ctor === 'Nothing') {
				return true;
			} else {
				return false;
			}
		},
		_CareerPlug$ats$AlertCenter_Model$applicationAlertsAsList(applicationAlerts));
};
var _CareerPlug$ats$AlertCenter_Model$decodeOrCrash = F2(
	function (decoder, value) {
		var _p3 = A2(_elm_lang$core$Json_Decode$decodeValue, decoder, value);
		if (_p3.ctor === 'Ok') {
			return _p3._0;
		} else {
			return _elm_lang$core$Native_Utils.crashCase(
				'AlertCenter.Model',
				{
					start: {line: 168, column: 5},
					end: {line: 173, column: 28}
				},
				_p3)(_p3._0);
		}
	});
var _CareerPlug$ats$AlertCenter_Model$unionTypeDecoder = function (typeResolver) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (s) {
			return typeResolver(s);
		},
		_elm_lang$core$Json_Decode$string);
};
var _CareerPlug$ats$AlertCenter_Model$blankConfig = {authToken: '', authParam: ''};
var _CareerPlug$ats$AlertCenter_Model$ApplicationAlert = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {id: a, title: b, body: c, alertType: d, actionType: e, actionData: f, readAt: g, receivedAt: h, userId: i};
	});
var _CareerPlug$ats$AlertCenter_Model$Config = F2(
	function (a, b) {
		return {authToken: a, authParam: b};
	});
var _CareerPlug$ats$AlertCenter_Model$configDecoder = A3(
	_elm_lang$core$Json_Decode$map2,
	_CareerPlug$ats$AlertCenter_Model$Config,
	A2(_elm_lang$core$Json_Decode$field, 'authToken', _elm_lang$core$Json_Decode$string),
	A2(_elm_lang$core$Json_Decode$field, 'authParam', _elm_lang$core$Json_Decode$string));
var _CareerPlug$ats$AlertCenter_Model$Model = F7(
	function (a, b, c, d, e, f, g) {
		return {viewState: a, displayState: b, voyager: c, applicationAlerts: d, config: e, currentDate: f, websocketState: g};
	});
var _CareerPlug$ats$AlertCenter_Model$Flags = F4(
	function (a, b, c, d) {
		return {application_alerts: a, display_state: b, voyager: c, config: d};
	});
var _CareerPlug$ats$AlertCenter_Model$Sms = {ctor: 'Sms'};
var _CareerPlug$ats$AlertCenter_Model$Generic = {ctor: 'Generic'};
var _CareerPlug$ats$AlertCenter_Model$alertTypeResolver = function (alertType) {
	var _p5 = alertType;
	switch (_p5) {
		case 'generic':
			return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Model$Generic);
		case 'sms':
			return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Model$Sms);
		default:
			return _elm_lang$core$Json_Decode$fail(
				A2(_elm_lang$core$Basics_ops['++'], 'Unrecognized display alert type ', alertType));
	}
};
var _CareerPlug$ats$AlertCenter_Model$Closed = {ctor: 'Closed'};
var _CareerPlug$ats$AlertCenter_Model$Open = {ctor: 'Open'};
var _CareerPlug$ats$AlertCenter_Model$URL = {ctor: 'URL'};
var _CareerPlug$ats$AlertCenter_Model$actionTypeResolver = function (actionType) {
	var _p6 = actionType;
	if (_p6 === 'url') {
		return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Model$URL);
	} else {
		return _elm_lang$core$Json_Decode$fail(
			A2(_elm_lang$core$Basics_ops['++'], 'Unrecognized display action type ', actionType));
	}
};
var _CareerPlug$ats$AlertCenter_Model$applicationAlertDecoder = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'user_id',
	_elm_lang$core$Json_Decode$int,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'received_at',
		_CareerPlug$ats$Library_Core$dateDecoder,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'read_at',
			_elm_lang$core$Json_Decode$nullable(_CareerPlug$ats$Library_Core$dateDecoder),
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'action_data',
				_elm_lang$core$Json_Decode$string,
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'action_type',
					_CareerPlug$ats$AlertCenter_Model$unionTypeDecoder(_CareerPlug$ats$AlertCenter_Model$actionTypeResolver),
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'alert_type',
						_CareerPlug$ats$AlertCenter_Model$unionTypeDecoder(_CareerPlug$ats$AlertCenter_Model$alertTypeResolver),
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'body',
							_elm_lang$core$Json_Decode$string,
							A3(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
								'title',
								_elm_lang$core$Json_Decode$string,
								A3(
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
									'id',
									_elm_lang$core$Json_Decode$int,
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$AlertCenter_Model$ApplicationAlert))))))))));
var _CareerPlug$ats$AlertCenter_Model$applicationAlertsDecoder = _elm_lang$core$Json_Decode$list(_CareerPlug$ats$AlertCenter_Model$applicationAlertDecoder);
var _CareerPlug$ats$AlertCenter_Model$NavBar = {ctor: 'NavBar'};
var _CareerPlug$ats$AlertCenter_Model$Mobile = {ctor: 'Mobile'};
var _CareerPlug$ats$AlertCenter_Model$displayStateResolver = function (displayState) {
	var _p7 = displayState;
	switch (_p7) {
		case 'mobile':
			return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Model$Mobile);
		case 'navbar':
			return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Model$NavBar);
		default:
			return _elm_lang$core$Json_Decode$fail(
				A2(_elm_lang$core$Basics_ops['++'], 'Unrecognized display state ', displayState));
	}
};
var _CareerPlug$ats$AlertCenter_Model$NotConnected = {ctor: 'NotConnected'};
var _CareerPlug$ats$AlertCenter_Model$initialModel = {viewState: _CareerPlug$ats$AlertCenter_Model$Closed, displayState: _CareerPlug$ats$AlertCenter_Model$NavBar, voyager: false, applicationAlerts: _elm_lang$core$Dict$empty, config: _CareerPlug$ats$AlertCenter_Model$blankConfig, currentDate: _elm_lang$core$Maybe$Nothing, websocketState: _CareerPlug$ats$AlertCenter_Model$NotConnected};
var _CareerPlug$ats$AlertCenter_Model$Connected = {ctor: 'Connected'};

var _CareerPlug$ats$AlertCenter_OutsideInfo$alertCenterOut = _elm_lang$core$Native_Platform.outgoingPort(
	'alertCenterOut',
	function (v) {
		return {tag: v.tag, data: v.data};
	});
var _CareerPlug$ats$AlertCenter_OutsideInfo$sendInfoOutside = function (info) {
	var _p0 = info;
	return _CareerPlug$ats$AlertCenter_OutsideInfo$alertCenterOut(
		{tag: 'AppLoaded', data: _elm_lang$core$Json_Encode$null});
};
var _CareerPlug$ats$AlertCenter_OutsideInfo$alertCenterIn = _elm_lang$core$Native_Platform.incomingPort(
	'alertCenterIn',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (tag) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (data) {
					return _elm_lang$core$Json_Decode$succeed(
						{tag: tag, data: data});
				},
				A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
		},
		A2(_elm_lang$core$Json_Decode$field, 'tag', _elm_lang$core$Json_Decode$string)));
var _CareerPlug$ats$AlertCenter_OutsideInfo$GenericOutsideData = F2(
	function (a, b) {
		return {tag: a, data: b};
	});
var _CareerPlug$ats$AlertCenter_OutsideInfo$AppLoaded = {ctor: 'AppLoaded'};
var _CareerPlug$ats$AlertCenter_OutsideInfo$WebsocketConnected = {ctor: 'WebsocketConnected'};
var _CareerPlug$ats$AlertCenter_OutsideInfo$WebsocketDisconnected = {ctor: 'WebsocketDisconnected'};
var _CareerPlug$ats$AlertCenter_OutsideInfo$CloseRequest = {ctor: 'CloseRequest'};
var _CareerPlug$ats$AlertCenter_OutsideInfo$ApplicationAlertReceived = function (a) {
	return {ctor: 'ApplicationAlertReceived', _0: a};
};
var _CareerPlug$ats$AlertCenter_OutsideInfo$getInfoFromOutside = F2(
	function (tagger, onError) {
		return _CareerPlug$ats$AlertCenter_OutsideInfo$alertCenterIn(
			function (outsideInfo) {
				var _p1 = outsideInfo.tag;
				switch (_p1) {
					case 'ApplicationAlertReceived':
						var _p2 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$AlertCenter_Model$applicationAlertDecoder, outsideInfo.data);
						if (_p2.ctor === 'Ok') {
							return tagger(
								_CareerPlug$ats$AlertCenter_OutsideInfo$ApplicationAlertReceived(_p2._0));
						} else {
							return onError(_p2._0);
						}
					case 'CloseRequest':
						return tagger(_CareerPlug$ats$AlertCenter_OutsideInfo$CloseRequest);
					case 'WebsocketDisconnected':
						return tagger(_CareerPlug$ats$AlertCenter_OutsideInfo$WebsocketDisconnected);
					case 'WebsocketConnected':
						return tagger(_CareerPlug$ats$AlertCenter_OutsideInfo$WebsocketConnected);
					default:
						return onError(
							A2(
								_elm_lang$core$Basics_ops['++'],
								'Unexpected info from outside: ',
								_elm_lang$core$Basics$toString(outsideInfo)));
				}
			});
	});

var _elm_lang$http$Native_Http = function() {


// ENCODING AND DECODING

function encodeUri(string)
{
	return encodeURIComponent(string);
}

function decodeUri(string)
{
	try
	{
		return _elm_lang$core$Maybe$Just(decodeURIComponent(string));
	}
	catch(e)
	{
		return _elm_lang$core$Maybe$Nothing;
	}
}


// SEND REQUEST

function toTask(request, maybeProgress)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'NetworkError' }));
		});
		xhr.addEventListener('timeout', function() {
			callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'Timeout' }));
		});
		xhr.addEventListener('load', function() {
			callback(handleResponse(xhr, request.expect.responseToResult));
		});

		try
		{
			xhr.open(request.method, request.url, true);
		}
		catch (e)
		{
			return callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'BadUrl', _0: request.url }));
		}

		configureRequest(xhr, request);
		send(xhr, request.body);

		return function() { xhr.abort(); };
	});
}

function configureProgress(xhr, maybeProgress)
{
	if (maybeProgress.ctor === 'Nothing')
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_elm_lang$core$Native_Scheduler.rawSpawn(maybeProgress._0({
			bytes: event.loaded,
			bytesExpected: event.total
		}));
	});
}

function configureRequest(xhr, request)
{
	function setHeader(pair)
	{
		xhr.setRequestHeader(pair._0, pair._1);
	}

	A2(_elm_lang$core$List$map, setHeader, request.headers);
	xhr.responseType = request.expect.responseType;
	xhr.withCredentials = request.withCredentials;

	if (request.timeout.ctor === 'Just')
	{
		xhr.timeout = request.timeout._0;
	}
}

function send(xhr, body)
{
	switch (body.ctor)
	{
		case 'EmptyBody':
			xhr.send();
			return;

		case 'StringBody':
			xhr.setRequestHeader('Content-Type', body._0);
			xhr.send(body._1);
			return;

		case 'FormDataBody':
			xhr.send(body._0);
			return;
	}
}


// RESPONSES

function handleResponse(xhr, responseToResult)
{
	var response = toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _elm_lang$core$Native_Scheduler.fail({
			ctor: 'BadStatus',
			_0: response
		});
	}

	var result = responseToResult(response);

	if (result.ctor === 'Ok')
	{
		return _elm_lang$core$Native_Scheduler.succeed(result._0);
	}
	else
	{
		response.body = xhr.responseText;
		return _elm_lang$core$Native_Scheduler.fail({
			ctor: 'BadPayload',
			_0: result._0,
			_1: response
		});
	}
}

function toResponse(xhr)
{
	return {
		status: { code: xhr.status, message: xhr.statusText },
		headers: parseHeaders(xhr.getAllResponseHeaders()),
		url: xhr.responseURL,
		body: xhr.response
	};
}

function parseHeaders(rawHeaders)
{
	var headers = _elm_lang$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3(_elm_lang$core$Dict$update, key, function(oldValue) {
				if (oldValue.ctor === 'Just')
				{
					return _elm_lang$core$Maybe$Just(value + ', ' + oldValue._0);
				}
				return _elm_lang$core$Maybe$Just(value);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function expectStringResponse(responseToResult)
{
	return {
		responseType: 'text',
		responseToResult: responseToResult
	};
}

function mapExpect(func, expect)
{
	return {
		responseType: expect.responseType,
		responseToResult: function(response) {
			var convertedResponse = expect.responseToResult(response);
			return A2(_elm_lang$core$Result$map, func, convertedResponse);
		}
	};
}


// BODY

function multipart(parts)
{
	var formData = new FormData();

	while (parts.ctor !== '[]')
	{
		var part = parts._0;
		formData.append(part._0, part._1);
		parts = parts._1;
	}

	return { ctor: 'FormDataBody', _0: formData };
}

return {
	toTask: F2(toTask),
	expectStringResponse: expectStringResponse,
	mapExpect: F2(mapExpect),
	multipart: multipart,
	encodeUri: encodeUri,
	decodeUri: decodeUri
};

}();

var _elm_lang$http$Http_Internal$map = F2(
	function (func, request) {
		return _elm_lang$core$Native_Utils.update(
			request,
			{
				expect: A2(_elm_lang$http$Native_Http.mapExpect, func, request.expect)
			});
	});
var _elm_lang$http$Http_Internal$RawRequest = F7(
	function (a, b, c, d, e, f, g) {
		return {method: a, headers: b, url: c, body: d, expect: e, timeout: f, withCredentials: g};
	});
var _elm_lang$http$Http_Internal$Request = function (a) {
	return {ctor: 'Request', _0: a};
};
var _elm_lang$http$Http_Internal$Expect = {ctor: 'Expect'};
var _elm_lang$http$Http_Internal$FormDataBody = {ctor: 'FormDataBody'};
var _elm_lang$http$Http_Internal$StringBody = F2(
	function (a, b) {
		return {ctor: 'StringBody', _0: a, _1: b};
	});
var _elm_lang$http$Http_Internal$EmptyBody = {ctor: 'EmptyBody'};
var _elm_lang$http$Http_Internal$Header = F2(
	function (a, b) {
		return {ctor: 'Header', _0: a, _1: b};
	});

var _elm_lang$http$Http$decodeUri = _elm_lang$http$Native_Http.decodeUri;
var _elm_lang$http$Http$encodeUri = _elm_lang$http$Native_Http.encodeUri;
var _elm_lang$http$Http$expectStringResponse = _elm_lang$http$Native_Http.expectStringResponse;
var _elm_lang$http$Http$expectJson = function (decoder) {
	return _elm_lang$http$Http$expectStringResponse(
		function (response) {
			return A2(_elm_lang$core$Json_Decode$decodeString, decoder, response.body);
		});
};
var _elm_lang$http$Http$expectString = _elm_lang$http$Http$expectStringResponse(
	function (response) {
		return _elm_lang$core$Result$Ok(response.body);
	});
var _elm_lang$http$Http$multipartBody = _elm_lang$http$Native_Http.multipart;
var _elm_lang$http$Http$stringBody = _elm_lang$http$Http_Internal$StringBody;
var _elm_lang$http$Http$jsonBody = function (value) {
	return A2(
		_elm_lang$http$Http_Internal$StringBody,
		'application/json',
		A2(_elm_lang$core$Json_Encode$encode, 0, value));
};
var _elm_lang$http$Http$emptyBody = _elm_lang$http$Http_Internal$EmptyBody;
var _elm_lang$http$Http$header = _elm_lang$http$Http_Internal$Header;
var _elm_lang$http$Http$request = _elm_lang$http$Http_Internal$Request;
var _elm_lang$http$Http$post = F3(
	function (url, body, decoder) {
		return _elm_lang$http$Http$request(
			{
				method: 'POST',
				headers: {ctor: '[]'},
				url: url,
				body: body,
				expect: _elm_lang$http$Http$expectJson(decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _elm_lang$http$Http$get = F2(
	function (url, decoder) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: {ctor: '[]'},
				url: url,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(decoder),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _elm_lang$http$Http$getString = function (url) {
	return _elm_lang$http$Http$request(
		{
			method: 'GET',
			headers: {ctor: '[]'},
			url: url,
			body: _elm_lang$http$Http$emptyBody,
			expect: _elm_lang$http$Http$expectString,
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false
		});
};
var _elm_lang$http$Http$toTask = function (_p0) {
	var _p1 = _p0;
	return A2(_elm_lang$http$Native_Http.toTask, _p1._0, _elm_lang$core$Maybe$Nothing);
};
var _elm_lang$http$Http$send = F2(
	function (resultToMessage, request) {
		return A2(
			_elm_lang$core$Task$attempt,
			resultToMessage,
			_elm_lang$http$Http$toTask(request));
	});
var _elm_lang$http$Http$Response = F4(
	function (a, b, c, d) {
		return {url: a, status: b, headers: c, body: d};
	});
var _elm_lang$http$Http$BadPayload = F2(
	function (a, b) {
		return {ctor: 'BadPayload', _0: a, _1: b};
	});
var _elm_lang$http$Http$BadStatus = function (a) {
	return {ctor: 'BadStatus', _0: a};
};
var _elm_lang$http$Http$NetworkError = {ctor: 'NetworkError'};
var _elm_lang$http$Http$Timeout = {ctor: 'Timeout'};
var _elm_lang$http$Http$BadUrl = function (a) {
	return {ctor: 'BadUrl', _0: a};
};
var _elm_lang$http$Http$StringPart = F2(
	function (a, b) {
		return {ctor: 'StringPart', _0: a, _1: b};
	});
var _elm_lang$http$Http$stringPart = _elm_lang$http$Http$StringPart;

var _CareerPlug$ats$AlertCenter_Message$LogErr = function (a) {
	return {ctor: 'LogErr', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$Outside = function (a) {
	return {ctor: 'Outside', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$FetchAlertsResp = function (a) {
	return {ctor: 'FetchAlertsResp', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$MarkAsReadResp = function (a) {
	return {ctor: 'MarkAsReadResp', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$MarkAllAsRead = {ctor: 'MarkAllAsRead'};
var _CareerPlug$ats$AlertCenter_Message$MarkAsRead = function (a) {
	return {ctor: 'MarkAsRead', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$ToggleViewState = {ctor: 'ToggleViewState'};
var _CareerPlug$ats$AlertCenter_Message$Tick = function (a) {
	return {ctor: 'Tick', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$SetDate = function (a) {
	return {ctor: 'SetDate', _0: a};
};
var _CareerPlug$ats$AlertCenter_Message$NoOp = {ctor: 'NoOp'};

var _CareerPlug$ats$AlertCenter_Service$fetchApplicationAlerts = function (model) {
	var request = _elm_lang$http$Http$request(
		{
			body: _elm_lang$http$Http$emptyBody,
			expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$AlertCenter_Model$applicationAlertsDecoder),
			headers: {
				ctor: '::',
				_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', model.config.authToken),
					_1: {ctor: '[]'}
				}
			},
			url: '/manage/application_alerts.json',
			method: 'GET',
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false
		});
	return A2(_elm_lang$http$Http$send, _CareerPlug$ats$AlertCenter_Message$FetchAlertsResp, request);
};
var _CareerPlug$ats$AlertCenter_Service$markApplicationAlertAsRead = F2(
	function (model, alertId) {
		var request = _elm_lang$http$Http$request(
			{
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$AlertCenter_Model$applicationAlertDecoder),
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', model.config.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: A2(
					_elm_lang$core$Basics_ops['++'],
					'/manage/application_alerts/',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(alertId),
						'.json')),
				method: 'PATCH',
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
		return A2(_elm_lang$http$Http$send, _CareerPlug$ats$AlertCenter_Message$MarkAsReadResp, request);
	});

var _CareerPlug$ats$AlertCenter_Update$updateAlert = F2(
	function (alert, alerts) {
		var updateAlert = function (foundAlert) {
			var _p0 = foundAlert;
			if (_p0.ctor === 'Just') {
				return _elm_lang$core$Maybe$Just(alert);
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		};
		return A3(_elm_lang$core$Dict$update, alert.id, updateAlert, alerts);
	});
var _CareerPlug$ats$AlertCenter_Update$update = F2(
	function (msg, model) {
		var _p1 = msg;
		switch (_p1.ctor) {
			case 'NoOp':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'Tick':
				var commands = function () {
					var _p2 = model.websocketState;
					if (_p2.ctor === 'NotConnected') {
						return {
							ctor: '::',
							_0: _CareerPlug$ats$AlertCenter_Service$fetchApplicationAlerts(model),
							_1: {ctor: '[]'}
						};
					} else {
						return {ctor: '[]'};
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							currentDate: _elm_lang$core$Maybe$Just(
								_elm_lang$core$Date$fromTime(_p1._0))
						}),
					commands);
			case 'SetDate':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{currentDate: _p1._0}),
					{ctor: '[]'});
			case 'ToggleViewState':
				var newViewState = function () {
					var _p3 = model.viewState;
					if (_p3.ctor === 'Open') {
						return _CareerPlug$ats$AlertCenter_Model$Closed;
					} else {
						return _CareerPlug$ats$AlertCenter_Model$Open;
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{viewState: newViewState}),
					{ctor: '[]'});
			case 'MarkAsRead':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: A2(_CareerPlug$ats$AlertCenter_Service$markApplicationAlertAsRead, model, _p1._0),
						_1: {ctor: '[]'}
					});
			case 'MarkAllAsRead':
				var commands = A2(
					_elm_lang$core$List$map,
					function (alert) {
						return A2(_CareerPlug$ats$AlertCenter_Service$markApplicationAlertAsRead, model, alert.id);
					},
					_CareerPlug$ats$AlertCenter_Model$unreadAlerts(model.applicationAlerts));
				return A2(_elm_lang$core$Platform_Cmd_ops['!'], model, commands);
			case 'MarkAsReadResp':
				if (_p1._0.ctor === 'Err') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								applicationAlerts: A2(_CareerPlug$ats$AlertCenter_Update$updateAlert, _p1._0._0, model.applicationAlerts)
							}),
						{ctor: '[]'});
				}
			case 'FetchAlertsResp':
				if (_p1._0.ctor === 'Err') {
					var debug = A2(_elm_lang$core$Debug$log, 'Fetch Alert Error', _p1._0._0);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var alertsDict = _elm_lang$core$Dict$fromList(
						A2(
							_elm_lang$core$List$map,
							function (alert) {
								return {ctor: '_Tuple2', _0: alert.id, _1: alert};
							},
							_p1._0._0));
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{applicationAlerts: alertsDict}),
						{ctor: '[]'});
				}
			case 'Outside':
				var _p4 = _p1._0;
				switch (_p4.ctor) {
					case 'ApplicationAlertReceived':
						var _p6 = _p4._0;
						var foundAlert = A2(_elm_lang$core$Dict$get, _p6.id, model.applicationAlerts);
						var alerts = function () {
							var _p5 = foundAlert;
							if (_p5.ctor === 'Just') {
								return A2(_CareerPlug$ats$AlertCenter_Update$updateAlert, _p6, model.applicationAlerts);
							} else {
								return A3(_elm_lang$core$Dict$insert, _p6.id, _p6, model.applicationAlerts);
							}
						}();
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{applicationAlerts: alerts}),
							{ctor: '[]'});
					case 'CloseRequest':
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{viewState: _CareerPlug$ats$AlertCenter_Model$Closed}),
							{ctor: '[]'});
					case 'WebsocketDisconnected':
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{websocketState: _CareerPlug$ats$AlertCenter_Model$NotConnected}),
							{ctor: '[]'});
					default:
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{websocketState: _CareerPlug$ats$AlertCenter_Model$Connected}),
							{
								ctor: '::',
								_0: _CareerPlug$ats$AlertCenter_Service$fetchApplicationAlerts(model),
								_1: {ctor: '[]'}
							});
				}
			default:
				var debug = A2(_elm_lang$core$Debug$log, 'Alert Center Outside Info Error: ', _p1._0);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
		}
	});

var _elm_lang$html$Html_Attributes$map = _elm_lang$virtual_dom$VirtualDom$mapProperty;
var _elm_lang$html$Html_Attributes$attribute = _elm_lang$virtual_dom$VirtualDom$attribute;
var _elm_lang$html$Html_Attributes$contextmenu = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'contextmenu', value);
};
var _elm_lang$html$Html_Attributes$draggable = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'draggable', value);
};
var _elm_lang$html$Html_Attributes$itemprop = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'itemprop', value);
};
var _elm_lang$html$Html_Attributes$tabindex = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'tabIndex',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$charset = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'charset', value);
};
var _elm_lang$html$Html_Attributes$height = function (value) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'height',
		_elm_lang$core$Basics$toString(value));
};
var _elm_lang$html$Html_Attributes$width = function (value) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'width',
		_elm_lang$core$Basics$toString(value));
};
var _elm_lang$html$Html_Attributes$formaction = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'formAction', value);
};
var _elm_lang$html$Html_Attributes$list = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'list', value);
};
var _elm_lang$html$Html_Attributes$minlength = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'minLength',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$maxlength = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'maxlength',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$size = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'size',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$form = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'form', value);
};
var _elm_lang$html$Html_Attributes$cols = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'cols',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$rows = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'rows',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$challenge = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'challenge', value);
};
var _elm_lang$html$Html_Attributes$media = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'media', value);
};
var _elm_lang$html$Html_Attributes$rel = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'rel', value);
};
var _elm_lang$html$Html_Attributes$datetime = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'datetime', value);
};
var _elm_lang$html$Html_Attributes$pubdate = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'pubdate', value);
};
var _elm_lang$html$Html_Attributes$colspan = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'colspan',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$rowspan = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$attribute,
		'rowspan',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$manifest = function (value) {
	return A2(_elm_lang$html$Html_Attributes$attribute, 'manifest', value);
};
var _elm_lang$html$Html_Attributes$property = _elm_lang$virtual_dom$VirtualDom$property;
var _elm_lang$html$Html_Attributes$stringProperty = F2(
	function (name, string) {
		return A2(
			_elm_lang$html$Html_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$string(string));
	});
var _elm_lang$html$Html_Attributes$class = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'className', name);
};
var _elm_lang$html$Html_Attributes$id = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'id', name);
};
var _elm_lang$html$Html_Attributes$title = function (name) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'title', name);
};
var _elm_lang$html$Html_Attributes$accesskey = function ($char) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'accessKey',
		_elm_lang$core$String$fromChar($char));
};
var _elm_lang$html$Html_Attributes$dir = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'dir', value);
};
var _elm_lang$html$Html_Attributes$dropzone = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'dropzone', value);
};
var _elm_lang$html$Html_Attributes$lang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'lang', value);
};
var _elm_lang$html$Html_Attributes$content = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'content', value);
};
var _elm_lang$html$Html_Attributes$httpEquiv = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'httpEquiv', value);
};
var _elm_lang$html$Html_Attributes$language = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'language', value);
};
var _elm_lang$html$Html_Attributes$src = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'src', value);
};
var _elm_lang$html$Html_Attributes$alt = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'alt', value);
};
var _elm_lang$html$Html_Attributes$preload = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'preload', value);
};
var _elm_lang$html$Html_Attributes$poster = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'poster', value);
};
var _elm_lang$html$Html_Attributes$kind = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'kind', value);
};
var _elm_lang$html$Html_Attributes$srclang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'srclang', value);
};
var _elm_lang$html$Html_Attributes$sandbox = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'sandbox', value);
};
var _elm_lang$html$Html_Attributes$srcdoc = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'srcdoc', value);
};
var _elm_lang$html$Html_Attributes$type_ = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'type', value);
};
var _elm_lang$html$Html_Attributes$value = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'value', value);
};
var _elm_lang$html$Html_Attributes$defaultValue = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'defaultValue', value);
};
var _elm_lang$html$Html_Attributes$placeholder = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'placeholder', value);
};
var _elm_lang$html$Html_Attributes$accept = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'accept', value);
};
var _elm_lang$html$Html_Attributes$acceptCharset = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'acceptCharset', value);
};
var _elm_lang$html$Html_Attributes$action = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'action', value);
};
var _elm_lang$html$Html_Attributes$autocomplete = function (bool) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var _elm_lang$html$Html_Attributes$enctype = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'enctype', value);
};
var _elm_lang$html$Html_Attributes$method = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'method', value);
};
var _elm_lang$html$Html_Attributes$name = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'name', value);
};
var _elm_lang$html$Html_Attributes$pattern = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'pattern', value);
};
var _elm_lang$html$Html_Attributes$for = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'htmlFor', value);
};
var _elm_lang$html$Html_Attributes$max = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'max', value);
};
var _elm_lang$html$Html_Attributes$min = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'min', value);
};
var _elm_lang$html$Html_Attributes$step = function (n) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'step', n);
};
var _elm_lang$html$Html_Attributes$wrap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'wrap', value);
};
var _elm_lang$html$Html_Attributes$usemap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'useMap', value);
};
var _elm_lang$html$Html_Attributes$shape = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'shape', value);
};
var _elm_lang$html$Html_Attributes$coords = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'coords', value);
};
var _elm_lang$html$Html_Attributes$keytype = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'keytype', value);
};
var _elm_lang$html$Html_Attributes$align = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'align', value);
};
var _elm_lang$html$Html_Attributes$cite = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'cite', value);
};
var _elm_lang$html$Html_Attributes$href = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'href', value);
};
var _elm_lang$html$Html_Attributes$target = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'target', value);
};
var _elm_lang$html$Html_Attributes$downloadAs = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'download', value);
};
var _elm_lang$html$Html_Attributes$hreflang = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'hreflang', value);
};
var _elm_lang$html$Html_Attributes$ping = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'ping', value);
};
var _elm_lang$html$Html_Attributes$start = function (n) {
	return A2(
		_elm_lang$html$Html_Attributes$stringProperty,
		'start',
		_elm_lang$core$Basics$toString(n));
};
var _elm_lang$html$Html_Attributes$headers = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'headers', value);
};
var _elm_lang$html$Html_Attributes$scope = function (value) {
	return A2(_elm_lang$html$Html_Attributes$stringProperty, 'scope', value);
};
var _elm_lang$html$Html_Attributes$boolProperty = F2(
	function (name, bool) {
		return A2(
			_elm_lang$html$Html_Attributes$property,
			name,
			_elm_lang$core$Json_Encode$bool(bool));
	});
var _elm_lang$html$Html_Attributes$hidden = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'hidden', bool);
};
var _elm_lang$html$Html_Attributes$contenteditable = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'contentEditable', bool);
};
var _elm_lang$html$Html_Attributes$spellcheck = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'spellcheck', bool);
};
var _elm_lang$html$Html_Attributes$async = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'async', bool);
};
var _elm_lang$html$Html_Attributes$defer = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'defer', bool);
};
var _elm_lang$html$Html_Attributes$scoped = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'scoped', bool);
};
var _elm_lang$html$Html_Attributes$autoplay = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'autoplay', bool);
};
var _elm_lang$html$Html_Attributes$controls = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'controls', bool);
};
var _elm_lang$html$Html_Attributes$loop = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'loop', bool);
};
var _elm_lang$html$Html_Attributes$default = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'default', bool);
};
var _elm_lang$html$Html_Attributes$seamless = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'seamless', bool);
};
var _elm_lang$html$Html_Attributes$checked = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'checked', bool);
};
var _elm_lang$html$Html_Attributes$selected = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'selected', bool);
};
var _elm_lang$html$Html_Attributes$autofocus = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'autofocus', bool);
};
var _elm_lang$html$Html_Attributes$disabled = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'disabled', bool);
};
var _elm_lang$html$Html_Attributes$multiple = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'multiple', bool);
};
var _elm_lang$html$Html_Attributes$novalidate = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'noValidate', bool);
};
var _elm_lang$html$Html_Attributes$readonly = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'readOnly', bool);
};
var _elm_lang$html$Html_Attributes$required = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'required', bool);
};
var _elm_lang$html$Html_Attributes$ismap = function (value) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'isMap', value);
};
var _elm_lang$html$Html_Attributes$download = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'download', bool);
};
var _elm_lang$html$Html_Attributes$reversed = function (bool) {
	return A2(_elm_lang$html$Html_Attributes$boolProperty, 'reversed', bool);
};
var _elm_lang$html$Html_Attributes$classList = function (list) {
	return _elm_lang$html$Html_Attributes$class(
		A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$map,
				_elm_lang$core$Tuple$first,
				A2(_elm_lang$core$List$filter, _elm_lang$core$Tuple$second, list))));
};
var _elm_lang$html$Html_Attributes$style = _elm_lang$virtual_dom$VirtualDom$style;

var _CareerPlug$ats$AlertCenter_View$alertActionsView = A2(
	_elm_lang$html$Html$div,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('alert-actions'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$a,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('action'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$AlertCenter_Message$MarkAllAsRead),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('Mark All As Read'),
				_1: {ctor: '[]'}
			}),
		_1: {ctor: '[]'}
	});
var _CareerPlug$ats$AlertCenter_View$alertItemView = F2(
	function (model, _p0) {
		var _p1 = _p0;
		var _p12 = _p1.receivedAt;
		var _p11 = _p1.readAt;
		var _p10 = _p1.id;
		var handleClick = function () {
			var _p2 = _p11;
			if (_p2.ctor === 'Nothing') {
				return _elm_lang$html$Html_Events$onClick(
					_CareerPlug$ats$AlertCenter_Message$MarkAsRead(_p10));
			} else {
				return _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$AlertCenter_Message$NoOp);
			}
		}();
		var unreadBadge = function () {
			var _p3 = _p11;
			if (_p3.ctor === 'Nothing') {
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('unread-badge'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'});
			} else {
				return _elm_lang$html$Html$text('');
			}
		}();
		var footerContent = function () {
			var _p4 = _p11;
			if (_p4.ctor === 'Nothing') {
				return A2(
					_elm_lang$html$Html$a,
					{
						ctor: '::',
						_0: A3(
							_elm_lang$html$Html_Events$onWithOptions,
							'click',
							{stopPropagation: true, preventDefault: true},
							_elm_lang$core$Json_Decode$succeed(
								_CareerPlug$ats$AlertCenter_Message$MarkAsRead(_p10))),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Mark As Read'),
						_1: {ctor: '[]'}
					});
			} else {
				return A2(
					_elm_lang$html$Html$span,
					{ctor: '[]'},
					{ctor: '[]'});
			}
		}();
		var dateText = function () {
			var _p5 = model.currentDate;
			if (_p5.ctor === 'Nothing') {
				return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%d %b', _p12);
			} else {
				var _p6 = _p5._0;
				var dateTense = F2(
					function (value, interval) {
						var tense = _elm_lang$core$Native_Utils.eq(value, 1) ? interval : A2(_elm_lang$core$Basics_ops['++'], interval, 's');
						return A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(value),
							A2(
								_elm_lang$core$Basics_ops['++'],
								' ',
								A2(_elm_lang$core$Basics_ops['++'], tense, ' ago')));
					});
				var minutesApart = function (t) {
					return (t / 1000) / 60;
				}(
					_elm_lang$core$Date$toTime(_p6) - _elm_lang$core$Date$toTime(_p12));
				return (_elm_lang$core$Native_Utils.cmp(minutesApart, 1) < 0) ? 'Just Now' : ((_elm_lang$core$Native_Utils.cmp(minutesApart, 60) < 0) ? A2(
					dateTense,
					_elm_lang$core$Basics$floor(minutesApart),
					'minute') : ((_elm_lang$core$Native_Utils.cmp(minutesApart / 60, 24) < 0) ? A2(
					dateTense,
					_elm_lang$core$Basics$floor(minutesApart / 60),
					'hour') : (_elm_lang$core$Native_Utils.eq(
					_elm_lang$core$Date$year(_p6),
					_elm_lang$core$Date$year(_p12)) ? A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%d %b', _p12) : A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%d %b %Y', _p12))));
			}
		}();
		var contentTitle = function () {
			var _p7 = _p1.actionType;
			return A2(
				_elm_lang$html$Html$a,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$href(_p1.actionData),
					_1: {
						ctor: '::',
						_0: A3(
							_elm_lang$html$Html_Events$onWithOptions,
							'click',
							{stopPropagation: true, preventDefault: false},
							_elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Message$NoOp)),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p1.title),
					_1: {ctor: '[]'}
				});
		}();
		var _p8 = function () {
			var _p9 = _p1.alertType;
			if (_p9.ctor === 'Sms') {
				return {ctor: '_Tuple2', _0: 'fa fa-comments', _1: 'New Text Message'};
			} else {
				return {ctor: '_Tuple2', _0: 'fa fa-bell-o', _1: ''};
			}
		}();
		var iconClass = _p8._0;
		var headingText = _p8._1;
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('alert-item-view'),
				_1: {
					ctor: '::',
					_0: handleClick,
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('heading-row'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class(iconClass),
								_1: {ctor: '[]'}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: unreadBadge,
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$span,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('heading-text'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(headingText),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('date-text'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(dateText),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('content-row'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('content-title'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: contentTitle,
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('content-body'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(_p1.body),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('footer-row'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: footerContent,
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _CareerPlug$ats$AlertCenter_View$alertsListView = function (model) {
	var applicationAlerts = _CareerPlug$ats$AlertCenter_Model$applicationAlertsAsList(model.applicationAlerts);
	var content = (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$List$length(applicationAlerts),
		0) > 0) ? A2(
		_elm_lang$core$List$map,
		_CareerPlug$ats$AlertCenter_View$alertItemView(model),
		_elm_lang$core$List$reverse(
			A2(
				_CareerPlug$ats$Library_Core$sortByDate,
				applicationAlerts,
				function (alert) {
					return alert.receivedAt;
				}))) : {
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('empty-alerts'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('No Current Notifications'),
				_1: {ctor: '[]'}
			}),
		_1: {ctor: '[]'}
	};
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('alerts-list-view'),
			_1: {ctor: '[]'}
		},
		content);
};
var _CareerPlug$ats$AlertCenter_View$alertsHeaderView = A2(
	_elm_lang$html$Html$div,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('alerts-container-header'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: _elm_lang$html$Html$text('Notifications'),
		_1: {ctor: '[]'}
	});
var _CareerPlug$ats$AlertCenter_View$alertsContainerView = function (model) {
	var isOpen = function () {
		var _p13 = model.viewState;
		if (_p13.ctor === 'Open') {
			return true;
		} else {
			return false;
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$classList(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'alerts-container', _1: true},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'open', _1: isOpen},
						_1: {ctor: '[]'}
					}
				}),
			_1: {
				ctor: '::',
				_0: A3(
					_elm_lang$html$Html_Events$onWithOptions,
					'click',
					{stopPropagation: true, preventDefault: false},
					_elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AlertCenter_Message$NoOp)),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: _CareerPlug$ats$AlertCenter_View$alertsHeaderView,
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$AlertCenter_View$alertsListView(model),
				_1: {
					ctor: '::',
					_0: _CareerPlug$ats$AlertCenter_View$alertActionsView,
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$AlertCenter_View$view = function (model) {
	var iconClass = model.voyager ? 'fal fa-comment-lines' : 'fa fa-bell';
	var badgeCount = function () {
		var count = _elm_lang$core$List$length(
			_CareerPlug$ats$AlertCenter_Model$unreadAlerts(model.applicationAlerts));
		return (_elm_lang$core$Native_Utils.cmp(count, 0) > 0) ? (model.voyager ? A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{ctor: '[]'}) : A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('badge-count'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					_elm_lang$core$Basics$toString(count)),
				_1: {ctor: '[]'}
			})) : _elm_lang$html$Html$text('');
	}();
	return A2(
		_elm_lang$html$Html$a,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$id('alert-center'),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$AlertCenter_Message$ToggleViewState),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$i,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(
						A2(_elm_lang$core$Basics_ops['++'], iconClass, ' display-icon')),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: badgeCount,
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$AlertCenter_View$alertsContainerView(model),
				_1: {ctor: '[]'}
			}
		});
};

var _CareerPlug$ats$AlertCenterMain$init = function (flags) {
	var applicationAlerts = _elm_lang$core$Dict$fromList(
		A2(
			_elm_lang$core$List$map,
			function (alert) {
				return {ctor: '_Tuple2', _0: alert.id, _1: alert};
			},
			A2(_CareerPlug$ats$AlertCenter_Model$decodeOrCrash, _CareerPlug$ats$AlertCenter_Model$applicationAlertsDecoder, flags.application_alerts)));
	var voyager = A2(_CareerPlug$ats$AlertCenter_Model$decodeOrCrash, _elm_lang$core$Json_Decode$bool, flags.voyager);
	var displayState = A2(
		_CareerPlug$ats$AlertCenter_Model$decodeOrCrash,
		_CareerPlug$ats$AlertCenter_Model$unionTypeDecoder(_CareerPlug$ats$AlertCenter_Model$displayStateResolver),
		flags.display_state);
	var config = A2(_CareerPlug$ats$AlertCenter_Model$decodeOrCrash, _CareerPlug$ats$AlertCenter_Model$configDecoder, flags.config);
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$AlertCenter_Model$initialModel,
			{config: config, displayState: displayState, voyager: voyager, applicationAlerts: applicationAlerts}),
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Task$perform,
				function (_p0) {
					return _CareerPlug$ats$AlertCenter_Message$SetDate(
						_elm_lang$core$Maybe$Just(_p0));
				},
				_elm_lang$core$Date$now),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$AlertCenter_OutsideInfo$sendInfoOutside(_CareerPlug$ats$AlertCenter_OutsideInfo$AppLoaded),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$AlertCenterMain$main = _elm_lang$html$Html$programWithFlags(
	{
		init: _CareerPlug$ats$AlertCenterMain$init,
		update: _CareerPlug$ats$AlertCenter_Update$update,
		view: _CareerPlug$ats$AlertCenter_View$view,
		subscriptions: function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: A2(_elm_lang$core$Time$every, _elm_lang$core$Time$minute, _CareerPlug$ats$AlertCenter_Message$Tick),
					_1: {
						ctor: '::',
						_0: A2(_CareerPlug$ats$AlertCenter_OutsideInfo$getInfoFromOutside, _CareerPlug$ats$AlertCenter_Message$Outside, _CareerPlug$ats$AlertCenter_Message$LogErr),
						_1: {ctor: '[]'}
					}
				});
		}
	})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (application_alerts) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (config) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (display_state) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (voyager) {
									return _elm_lang$core$Json_Decode$succeed(
										{application_alerts: application_alerts, config: config, display_state: display_state, voyager: voyager});
								},
								A2(_elm_lang$core$Json_Decode$field, 'voyager', _elm_lang$core$Json_Decode$value));
						},
						A2(_elm_lang$core$Json_Decode$field, 'display_state', _elm_lang$core$Json_Decode$value));
				},
				A2(_elm_lang$core$Json_Decode$field, 'config', _elm_lang$core$Json_Decode$value));
		},
		A2(_elm_lang$core$Json_Decode$field, 'application_alerts', _elm_lang$core$Json_Decode$value)));

var _CareerPlug$ats$Appointments_Model$readyToSchedule = function (model) {
	var _p0 = model.selectedTime;
	if (_p0.ctor === 'Just') {
		return !model.waitingForScheduleResponse;
	} else {
		return false;
	}
};
var _CareerPlug$ats$Appointments_Model$readableTime = function (d) {
	return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%l:%M %p', d);
};
var _CareerPlug$ats$Appointments_Model$readableDate = function (d) {
	return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%A, %B %e', d);
};
var _CareerPlug$ats$Appointments_Model$availableDayCount = function (model) {
	return _elm_lang$core$List$length(
		_elm_lang$core$Dict$keys(model.availability));
};
var _CareerPlug$ats$Appointments_Model$dateFromString = function (str) {
	var _p1 = _elm_lang$core$Date$fromString(str);
	if (_p1.ctor === 'Ok') {
		return _p1._0;
	} else {
		return _elm_lang$core$Date$fromTime(0);
	}
};
var _CareerPlug$ats$Appointments_Model$selectedTimeFromConfig = function (config) {
	var _p2 = config.selectedTime;
	if (_p2.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			{
				start: _CareerPlug$ats$Appointments_Model$dateFromString(_p2._0._0),
				end: _CareerPlug$ats$Appointments_Model$dateFromString(_p2._0._1)
			});
	}
};
var _CareerPlug$ats$Appointments_Model$minutes = function (numMinutes) {
	return _elm_lang$core$Basics$toFloat(numMinutes) * _elm_lang$core$Time$minute;
};
var _CareerPlug$ats$Appointments_Model$timeSlot = F3(
	function (slotStartTime, endTime, timeSlotDuration) {
		var slotEndTime = slotStartTime + _CareerPlug$ats$Appointments_Model$minutes(timeSlotDuration);
		var _p3 = _elm_lang$core$Native_Utils.cmp(slotEndTime, endTime) > 0;
		if (_p3 === false) {
			return _elm_lang$core$Maybe$Just(
				{
					start: _elm_lang$core$Date$fromTime(slotStartTime),
					end: _elm_lang$core$Date$fromTime(slotEndTime)
				});
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _CareerPlug$ats$Appointments_Model$timeSlotsForRange = F2(
	function (timeSlotDuration, _p4) {
		var _p5 = _p4;
		var _p7 = _p5._0;
		var _p6 = _p5._1;
		var minute = _elm_lang$core$Date$minute(
			_elm_lang$core$Date$fromTime(_p7));
		var modStartTime = (_elm_lang$core$Native_Utils.eq(minute, 0) || _elm_lang$core$Native_Utils.eq(minute, 30)) ? _p7 : (_p7 + _CareerPlug$ats$Appointments_Model$minutes(15));
		var numSlots = function () {
			var halfHourSlots = _elm_lang$core$Basics$truncate(
				(_p6 - modStartTime) / _CareerPlug$ats$Appointments_Model$minutes(30));
			return halfHourSlots;
		}();
		var startTimes = A2(
			_elm_lang$core$List$map,
			function (multiplier) {
				return modStartTime + (_elm_lang$core$Basics$toFloat(multiplier) * _CareerPlug$ats$Appointments_Model$minutes(30));
			},
			A2(_elm_lang$core$List$range, 0, numSlots - 1));
		return A2(
			_elm_lang$core$List$filterMap,
			function (slotStartTime) {
				return A3(_CareerPlug$ats$Appointments_Model$timeSlot, slotStartTime, _p6, timeSlotDuration);
			},
			startTimes);
	});
var _CareerPlug$ats$Appointments_Model$timeSlotsForDay = F2(
	function (timeSlotDuration, scheduleList) {
		var timeSlots = function (freeBusySlot) {
			return A2(
				_CareerPlug$ats$Appointments_Model$timeSlotsForRange,
				timeSlotDuration,
				{
					ctor: '_Tuple2',
					_0: _elm_lang$core$Date$toTime(freeBusySlot.start),
					_1: _elm_lang$core$Date$toTime(freeBusySlot.end)
				});
		};
		return A2(_elm_lang$core$List$concatMap, timeSlots, scheduleList);
	});
var _CareerPlug$ats$Appointments_Model$availabilitySlotsFromConfig = function (config) {
	var availabilityToDates = function (availability) {
		return {
			start: _CareerPlug$ats$Appointments_Model$dateFromString(availability.start),
			end: _CareerPlug$ats$Appointments_Model$dateFromString(availability.end)
		};
	};
	var dayAndTimes = function (_p8) {
		var _p9 = _p8;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Date$toTime(
				_CareerPlug$ats$Appointments_Model$dateFromString(_p9._0)),
			_1: A2(
				_CareerPlug$ats$Appointments_Model$timeSlotsForDay,
				config.timeSlotDuration,
				A2(_elm_lang$core$List$map, availabilityToDates, _p9._1))
		};
	};
	return _elm_lang$core$Dict$fromList(
		A2(_elm_lang$core$List$map, dayAndTimes, config.availability));
};
var _CareerPlug$ats$Appointments_Model$emptyConfig = {
	authParam: '',
	authToken: '',
	availability: {ctor: '[]'},
	timeSlotDuration: 15,
	location: '',
	contactEmail: '',
	accountName: '',
	appointmentName: '',
	appointmentPrefix: 'An',
	appointmentId: 0,
	view: 'Scheduling',
	selectedTime: _elm_lang$core$Maybe$Nothing,
	timezone: '',
	timezoneAbbr: '',
	error: _elm_lang$core$Maybe$Nothing,
	mobileSwitchpoint: 992
};
var _CareerPlug$ats$Appointments_Model$Config = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return {authParam: a, authToken: b, availability: c, timeSlotDuration: d, contactEmail: e, accountName: f, location: g, appointmentName: h, appointmentPrefix: i, appointmentId: j, view: k, selectedTime: l, timezone: m, timezoneAbbr: n, error: o, mobileSwitchpoint: p};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Appointments_Model$FreeBusySlot = F2(
	function (a, b) {
		return {start: a, end: b};
	});
var _CareerPlug$ats$Appointments_Model$Model = F8(
	function (a, b, c, d, e, f, g, h) {
		return {config: a, availability: b, selectedTime: c, displayedDays: d, currentView: e, errorMessage: f, mobile: g, waitingForScheduleResponse: h};
	});
var _CareerPlug$ats$Appointments_Model$Reference = {ctor: 'Reference'};
var _CareerPlug$ats$Appointments_Model$Scheduling = {ctor: 'Scheduling'};
var _CareerPlug$ats$Appointments_Model$initialModel = {config: _CareerPlug$ats$Appointments_Model$emptyConfig, availability: _elm_lang$core$Dict$empty, selectedTime: _elm_lang$core$Maybe$Nothing, displayedDays: 7, currentView: _CareerPlug$ats$Appointments_Model$Scheduling, errorMessage: _elm_lang$core$Maybe$Nothing, mobile: false, waitingForScheduleResponse: false};
var _CareerPlug$ats$Appointments_Model$Expired = {ctor: 'Expired'};
var _CareerPlug$ats$Appointments_Model$currentViewFromConfig = function (config) {
	var configStr = config.view;
	var _p10 = configStr;
	switch (_p10) {
		case 'Expired':
			return _CareerPlug$ats$Appointments_Model$Expired;
		case 'Scheduling':
			return _CareerPlug$ats$Appointments_Model$Scheduling;
		case 'Reference':
			return _CareerPlug$ats$Appointments_Model$Reference;
		default:
			return _CareerPlug$ats$Appointments_Model$Scheduling;
	}
};

var _elm_lang$dom$Native_Dom = function() {

var fakeNode = {
	addEventListener: function() {},
	removeEventListener: function() {}
};

var onDocument = on(typeof document !== 'undefined' ? document : fakeNode);
var onWindow = on(typeof window !== 'undefined' ? window : fakeNode);

function on(node)
{
	return function(eventName, decoder, toTask)
	{
		return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback) {

			function performTask(event)
			{
				var result = A2(_elm_lang$core$Json_Decode$decodeValue, decoder, event);
				if (result.ctor === 'Ok')
				{
					_elm_lang$core$Native_Scheduler.rawSpawn(toTask(result._0));
				}
			}

			node.addEventListener(eventName, performTask);

			return function()
			{
				node.removeEventListener(eventName, performTask);
			};
		});
	};
}

var rAF = typeof requestAnimationFrame !== 'undefined'
	? requestAnimationFrame
	: function(callback) { callback(); };

function withNode(id, doStuff)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		rAF(function()
		{
			var node = document.getElementById(id);
			if (node === null)
			{
				callback(_elm_lang$core$Native_Scheduler.fail({ ctor: 'NotFound', _0: id }));
				return;
			}
			callback(_elm_lang$core$Native_Scheduler.succeed(doStuff(node)));
		});
	});
}


// FOCUS

function focus(id)
{
	return withNode(id, function(node) {
		node.focus();
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function blur(id)
{
	return withNode(id, function(node) {
		node.blur();
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}


// SCROLLING

function getScrollTop(id)
{
	return withNode(id, function(node) {
		return node.scrollTop;
	});
}

function setScrollTop(id, desiredScrollTop)
{
	return withNode(id, function(node) {
		node.scrollTop = desiredScrollTop;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function toBottom(id)
{
	return withNode(id, function(node) {
		node.scrollTop = node.scrollHeight;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function getScrollLeft(id)
{
	return withNode(id, function(node) {
		return node.scrollLeft;
	});
}

function setScrollLeft(id, desiredScrollLeft)
{
	return withNode(id, function(node) {
		node.scrollLeft = desiredScrollLeft;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}

function toRight(id)
{
	return withNode(id, function(node) {
		node.scrollLeft = node.scrollWidth;
		return _elm_lang$core$Native_Utils.Tuple0;
	});
}


// SIZE

function width(options, id)
{
	return withNode(id, function(node) {
		switch (options.ctor)
		{
			case 'Content':
				return node.scrollWidth;
			case 'VisibleContent':
				return node.clientWidth;
			case 'VisibleContentWithBorders':
				return node.offsetWidth;
			case 'VisibleContentWithBordersAndMargins':
				var rect = node.getBoundingClientRect();
				return rect.right - rect.left;
		}
	});
}

function height(options, id)
{
	return withNode(id, function(node) {
		switch (options.ctor)
		{
			case 'Content':
				return node.scrollHeight;
			case 'VisibleContent':
				return node.clientHeight;
			case 'VisibleContentWithBorders':
				return node.offsetHeight;
			case 'VisibleContentWithBordersAndMargins':
				var rect = node.getBoundingClientRect();
				return rect.bottom - rect.top;
		}
	});
}

return {
	onDocument: F3(onDocument),
	onWindow: F3(onWindow),

	focus: focus,
	blur: blur,

	getScrollTop: getScrollTop,
	setScrollTop: F2(setScrollTop),
	getScrollLeft: getScrollLeft,
	setScrollLeft: F2(setScrollLeft),
	toBottom: toBottom,
	toRight: toRight,

	height: F2(height),
	width: F2(width)
};

}();

var _elm_lang$dom$Dom_LowLevel$onWindow = _elm_lang$dom$Native_Dom.onWindow;
var _elm_lang$dom$Dom_LowLevel$onDocument = _elm_lang$dom$Native_Dom.onDocument;

var _elm_lang$window$Native_Window = function()
{

var size = _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)	{
	callback(_elm_lang$core$Native_Scheduler.succeed({
		width: window.innerWidth,
		height: window.innerHeight
	}));
});

return {
	size: size
};

}();
var _elm_lang$core$Process$kill = _elm_lang$core$Native_Scheduler.kill;
var _elm_lang$core$Process$sleep = _elm_lang$core$Native_Scheduler.sleep;
var _elm_lang$core$Process$spawn = _elm_lang$core$Native_Scheduler.spawn;

var _elm_lang$window$Window_ops = _elm_lang$window$Window_ops || {};
_elm_lang$window$Window_ops['&>'] = F2(
	function (task1, task2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p0) {
				return task2;
			},
			task1);
	});
var _elm_lang$window$Window$onSelfMsg = F3(
	function (router, dimensions, state) {
		var _p1 = state;
		if (_p1.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var send = function (_p2) {
				var _p3 = _p2;
				return A2(
					_elm_lang$core$Platform$sendToApp,
					router,
					_p3._0(dimensions));
			};
			return A2(
				_elm_lang$window$Window_ops['&>'],
				_elm_lang$core$Task$sequence(
					A2(_elm_lang$core$List$map, send, _p1._0.subs)),
				_elm_lang$core$Task$succeed(state));
		}
	});
var _elm_lang$window$Window$init = _elm_lang$core$Task$succeed(_elm_lang$core$Maybe$Nothing);
var _elm_lang$window$Window$size = _elm_lang$window$Native_Window.size;
var _elm_lang$window$Window$width = A2(
	_elm_lang$core$Task$map,
	function (_) {
		return _.width;
	},
	_elm_lang$window$Window$size);
var _elm_lang$window$Window$height = A2(
	_elm_lang$core$Task$map,
	function (_) {
		return _.height;
	},
	_elm_lang$window$Window$size);
var _elm_lang$window$Window$onEffects = F3(
	function (router, newSubs, oldState) {
		var _p4 = {ctor: '_Tuple2', _0: oldState, _1: newSubs};
		if (_p4._0.ctor === 'Nothing') {
			if (_p4._1.ctor === '[]') {
				return _elm_lang$core$Task$succeed(_elm_lang$core$Maybe$Nothing);
			} else {
				return A2(
					_elm_lang$core$Task$andThen,
					function (pid) {
						return _elm_lang$core$Task$succeed(
							_elm_lang$core$Maybe$Just(
								{subs: newSubs, pid: pid}));
					},
					_elm_lang$core$Process$spawn(
						A3(
							_elm_lang$dom$Dom_LowLevel$onWindow,
							'resize',
							_elm_lang$core$Json_Decode$succeed(
								{ctor: '_Tuple0'}),
							function (_p5) {
								return A2(
									_elm_lang$core$Task$andThen,
									_elm_lang$core$Platform$sendToSelf(router),
									_elm_lang$window$Window$size);
							})));
			}
		} else {
			if (_p4._1.ctor === '[]') {
				return A2(
					_elm_lang$window$Window_ops['&>'],
					_elm_lang$core$Process$kill(_p4._0._0.pid),
					_elm_lang$core$Task$succeed(_elm_lang$core$Maybe$Nothing));
			} else {
				return _elm_lang$core$Task$succeed(
					_elm_lang$core$Maybe$Just(
						{subs: newSubs, pid: _p4._0._0.pid}));
			}
		}
	});
var _elm_lang$window$Window$subscription = _elm_lang$core$Native_Platform.leaf('Window');
var _elm_lang$window$Window$Size = F2(
	function (a, b) {
		return {width: a, height: b};
	});
var _elm_lang$window$Window$MySub = function (a) {
	return {ctor: 'MySub', _0: a};
};
var _elm_lang$window$Window$resizes = function (tagger) {
	return _elm_lang$window$Window$subscription(
		_elm_lang$window$Window$MySub(tagger));
};
var _elm_lang$window$Window$subMap = F2(
	function (func, _p6) {
		var _p7 = _p6;
		return _elm_lang$window$Window$MySub(
			function (_p8) {
				return func(
					_p7._0(_p8));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Window'] = {pkg: 'elm-lang/window', init: _elm_lang$window$Window$init, onEffects: _elm_lang$window$Window$onEffects, onSelfMsg: _elm_lang$window$Window$onSelfMsg, tag: 'sub', subMap: _elm_lang$window$Window$subMap};

var _CareerPlug$ats$Appointments_Message$NoOp = {ctor: 'NoOp'};
var _CareerPlug$ats$Appointments_Message$ResizeWindow = function (a) {
	return {ctor: 'ResizeWindow', _0: a};
};
var _CareerPlug$ats$Appointments_Message$DismissError = {ctor: 'DismissError'};
var _CareerPlug$ats$Appointments_Message$ChangeView = function (a) {
	return {ctor: 'ChangeView', _0: a};
};
var _CareerPlug$ats$Appointments_Message$ScheduleUpdated = function (a) {
	return {ctor: 'ScheduleUpdated', _0: a};
};
var _CareerPlug$ats$Appointments_Message$Schedule = {ctor: 'Schedule'};
var _CareerPlug$ats$Appointments_Message$ShowMore = {ctor: 'ShowMore'};
var _CareerPlug$ats$Appointments_Message$SelectTime = function (a) {
	return {ctor: 'SelectTime', _0: a};
};

var _CareerPlug$ats$Appointments_Ports$subscriptions = function (_p0) {
	var subs = {
		ctor: '::',
		_0: _elm_lang$window$Window$resizes(_CareerPlug$ats$Appointments_Message$ResizeWindow),
		_1: {ctor: '[]'}
	};
	return _elm_lang$core$Platform_Sub$batch(subs);
};

var _CareerPlug$ats$Appointments_Service$appointmentUpdateAsJson = function (model) {
	var removeTags = function (dateStr) {
		return A2(
			_elm_lang$core$String$filter,
			function (c) {
				return (!_elm_lang$core$Native_Utils.eq(
					c,
					_elm_lang$core$Native_Utils.chr('<'))) && (!_elm_lang$core$Native_Utils.eq(
					c,
					_elm_lang$core$Native_Utils.chr('>')));
			},
			dateStr);
	};
	var _p0 = function () {
		var _p1 = model.selectedTime;
		if (_p1.ctor === 'Just') {
			var _p2 = _p1._0;
			return {
				ctor: '_Tuple2',
				_0: removeTags(
					_elm_lang$core$Basics$toString(_p2.start)),
				_1: removeTags(
					_elm_lang$core$Basics$toString(_p2.end))
			};
		} else {
			return {ctor: '_Tuple2', _0: '', _1: ''};
		}
	}();
	var startTime = _p0._0;
	var endTime = _p0._1;
	return {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'appointment_id',
			_1: _elm_lang$core$Json_Encode$string(
				_elm_lang$core$Basics$toString(model.config.appointmentId))
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'start_time',
				_1: _elm_lang$core$Json_Encode$string(startTime)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'end_time',
					_1: _elm_lang$core$Json_Encode$string(endTime)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'timezone',
						_1: _elm_lang$core$Json_Encode$string(model.config.timezone)
					},
					_1: {ctor: '[]'}
				}
			}
		}
	};
};
var _CareerPlug$ats$Appointments_Service$appointmentsUrl = function (appointmentId) {
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: '/appointments',
			_1: {
				ctor: '::',
				_0: '/',
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(appointmentId),
					_1: {
						ctor: '::',
						_0: '/appointment_updates',
						_1: {
							ctor: '::',
							_0: '.json',
							_1: {ctor: '[]'}
						}
					}
				}
			}
		});
};
var _CareerPlug$ats$Appointments_Service$submitApptUpdateHttp = function (model) {
	var body = _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'appointment_update',
				_1: _elm_lang$core$Json_Encode$object(
					_CareerPlug$ats$Appointments_Service$appointmentUpdateAsJson(model))
			},
			_1: {ctor: '[]'}
		});
	var url = _CareerPlug$ats$Appointments_Service$appointmentsUrl(model.config.appointmentId);
	return _elm_lang$http$Http$request(
		{
			method: 'POST',
			headers: {
				ctor: '::',
				_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', model.config.authToken),
					_1: {ctor: '[]'}
				}
			},
			url: url,
			body: _elm_lang$http$Http$jsonBody(body),
			expect: _elm_lang$http$Http$expectStringResponse(
				function (_p3) {
					return _elm_lang$core$Result$Ok(
						{ctor: '_Tuple0'});
				}),
			timeout: _elm_lang$core$Maybe$Nothing,
			withCredentials: false
		});
};
var _CareerPlug$ats$Appointments_Service$submitApptUpdate = function (model) {
	return A2(
		_elm_lang$http$Http$send,
		_CareerPlug$ats$Appointments_Message$ScheduleUpdated,
		_CareerPlug$ats$Appointments_Service$submitApptUpdateHttp(model));
};

var _CareerPlug$ats$Library_Update$msgEffect = function (msg) {
	return A2(
		_elm_lang$core$Task$perform,
		_elm_lang$core$Basics$identity,
		_elm_lang$core$Task$succeed(msg));
};

var _CareerPlug$ats$Appointments_Update$update = F2(
	function (msg, model) {
		var _p0 = msg;
		switch (_p0.ctor) {
			case 'SelectTime':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							selectedTime: _elm_lang$core$Maybe$Just(_p0._0)
						}),
					{ctor: '[]'});
			case 'ShowMore':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							displayedDays: A2(
								_elm_lang$core$Basics$min,
								model.displayedDays + 7,
								_CareerPlug$ats$Appointments_Model$availableDayCount(model))
						}),
					{ctor: '[]'});
			case 'ChangeView':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{currentView: _p0._0}),
					{
						ctor: '::',
						_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Appointments_Message$DismissError),
						_1: {ctor: '[]'}
					});
			case 'Schedule':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{waitingForScheduleResponse: true}),
					{
						ctor: '::',
						_0: _CareerPlug$ats$Appointments_Service$submitApptUpdate(model),
						_1: {ctor: '[]'}
					});
			case 'ScheduleUpdated':
				var model_ = _elm_lang$core$Native_Utils.update(
					model,
					{waitingForScheduleResponse: false});
				var _p1 = _p0._0;
				if (_p1.ctor === 'Ok') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model_,
						{
							ctor: '::',
							_0: _CareerPlug$ats$Library_Update$msgEffect(
								_CareerPlug$ats$Appointments_Message$ChangeView(_CareerPlug$ats$Appointments_Model$Reference)),
							_1: {ctor: '[]'}
						});
				} else {
					var _p2 = _p1._0;
					if (_p2.ctor === 'BadStatus') {
						var errors = function () {
							var _p3 = A2(
								_elm_lang$core$Json_Decode$decodeString,
								_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string),
								_p2._0.body);
							if (_p3.ctor === 'Ok') {
								return _p3._0;
							} else {
								return {
									ctor: '::',
									_0: 'Server Error',
									_1: {ctor: '[]'}
								};
							}
						}();
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model_,
								{
									errorMessage: _elm_lang$core$Maybe$Just(errors)
								}),
							{ctor: '[]'});
					} else {
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model_,
								{
									errorMessage: _elm_lang$core$Maybe$Just(
										{
											ctor: '::',
											_0: 'Server or Network Error',
											_1: {ctor: '[]'}
										})
								}),
							{ctor: '[]'});
					}
				}
			case 'DismissError':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{errorMessage: _elm_lang$core$Maybe$Nothing}),
					{ctor: '[]'});
			case 'ResizeWindow':
				var mobile_ = _elm_lang$core$Native_Utils.cmp(_p0._0.width, model.config.mobileSwitchpoint) < 0;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{mobile: mobile_}),
					{ctor: '[]'});
			default:
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
		}
	});

var _CareerPlug$ats$Appointments_Views_Scheduling$timesArea = F2(
	function (model, day) {
		var emptyDay = {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('col-xs-12'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('well'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('No availability today'),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		};
		var timeBlock = function (freeBusySlot) {
			var selected = function () {
				var _p0 = model.selectedTime;
				if (_p0.ctor === 'Just') {
					return _elm_lang$core$Native_Utils.eq(freeBusySlot, _p0._0);
				} else {
					return false;
				}
			}();
			var selectedStr = function () {
				var _p1 = selected;
				if (_p1 === true) {
					return 'btn-primary';
				} else {
					return 'btn-default';
				}
			}();
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('col-xs-3'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$button,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(
								A2(
									_elm_lang$core$String$join,
									' ',
									{
										ctor: '::',
										_0: 'btn',
										_1: {
											ctor: '::',
											_0: selectedStr,
											_1: {ctor: '[]'}
										}
									})),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									_CareerPlug$ats$Appointments_Message$SelectTime(freeBusySlot)),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								_CareerPlug$ats$Appointments_Model$readableTime(freeBusySlot.start)),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				});
		};
		var timesForDay = function () {
			var _p2 = A2(_elm_lang$core$Dict$get, day, model.availability);
			if (_p2.ctor === 'Nothing') {
				return emptyDay;
			} else {
				var _p4 = _p2._0;
				var _p3 = _elm_lang$core$List$length(_p4);
				if (_p3 === 0) {
					return emptyDay;
				} else {
					return A2(_elm_lang$core$List$map, timeBlock, _p4);
				}
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('time_selector'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('times row'),
						_1: {ctor: '[]'}
					},
					timesForDay),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$Appointments_Views_Scheduling$daysArea = function (model) {
	var dayBlock = function (time) {
		var date = _elm_lang$core$Date$fromTime(time);
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('day_block'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$id(
						_elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: 'day_block_',
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Basics$toString(time),
									_1: {ctor: '[]'}
								}
							})),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$h2,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('day_contents'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							_CareerPlug$ats$Appointments_Model$readableDate(date)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(_CareerPlug$ats$Appointments_Views_Scheduling$timesArea, model, time),
					_1: {ctor: '[]'}
				}
			});
	};
	var showMoreBlock = function () {
		var _p5 = _elm_lang$core$Native_Utils.cmp(
			model.displayedDays,
			_CareerPlug$ats$Appointments_Model$availableDayCount(model)) < 0;
		if (_p5 === true) {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('show_more_block'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$button,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('btn btn-default btn-full'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$Appointments_Message$ShowMore),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$i,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('fa fa-lg fa-chevron-down'),
										_1: {ctor: '[]'}
									},
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			};
		} else {
			return {ctor: '[]'};
		}
	}();
	var getDays = A2(
		_elm_lang$core$List$take,
		model.displayedDays,
		_elm_lang$core$Dict$keys(model.availability));
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('calendar_selector'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('days'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{ctor: '[]'},
						A2(
							_elm_lang$core$Basics_ops['++'],
							A2(_elm_lang$core$List$map, dayBlock, getDays),
							showMoreBlock)),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Appointments_Views_Scheduling$introArea = function (model) {
	var howLong = function () {
		if (_elm_lang$core$Native_Utils.cmp(model.config.timeSlotDuration, 30) < 0) {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(model.config.timeSlotDuration),
				' minutes');
		} else {
			if (_elm_lang$core$Native_Utils.cmp(model.config.timeSlotDuration, 60) < 0) {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(model.config.timeSlotDuration),
					' minutes');
			} else {
				if (_elm_lang$core$Native_Utils.eq(model.config.timeSlotDuration, 60)) {
					return '1 hour';
				} else {
					if (_elm_lang$core$Native_Utils.cmp(model.config.timeSlotDuration, 120) < 0) {
						return A2(
							_elm_lang$core$String$join,
							' ',
							{
								ctor: '::',
								_0: 'an hour and',
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Basics$toString(model.config.timeSlotDuration - 60),
									_1: {
										ctor: '::',
										_0: 'minutes',
										_1: {ctor: '[]'}
									}
								}
							});
					} else {
						var hours = (model.config.timeSlotDuration / 60) | 0;
						return A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(hours),
							' hours');
					}
				}
			}
		}
	}();
	var verbiage = _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: 'Choose a start time for your interview with ',
			_1: {
				ctor: '::',
				_0: model.config.accountName,
				_1: {
					ctor: '::',
					_0: ' below. ',
					_1: {
						ctor: '::',
						_0: 'The interview will last for approximately ',
						_1: {
							ctor: '::',
							_0: howLong,
							_1: {
								ctor: '::',
								_0: '.',
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
	return A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$p,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(verbiage),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Appointments_Views_Scheduling$schedulingView = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('scheduler'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _CareerPlug$ats$Appointments_Views_Scheduling$introArea(model),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$Appointments_Views_Scheduling$daysArea(model),
				_1: {ctor: '[]'}
			}
		});
};

var _CareerPlug$ats$Appointments_Views_Expired$disabledCalendar = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('disabled_calendar'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _CareerPlug$ats$Appointments_Views_Scheduling$schedulingView(model),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Appointments_Views_Expired$expiredMessage = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('expire_message'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$p,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('This link is expired and scheduling is no longer available.'),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$p,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							_elm_lang$core$String$concat(
								{
									ctor: '::',
									_0: 'Please contact ',
									_1: {
										ctor: '::',
										_0: model.config.contactEmail,
										_1: {
											ctor: '::',
											_0: ' if you wish to reschedule.',
											_1: {ctor: '[]'}
										}
									}
								})),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Appointments_Views_Expired$expiredView = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: _CareerPlug$ats$Appointments_Views_Expired$expiredMessage(model),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$Appointments_Views_Expired$disabledCalendar(model),
				_1: {ctor: '[]'}
			}
		});
};

var _CareerPlug$ats$Appointments_Views_Reference$referenceView = function (model) {
	var locationElement = A2(_elm_lang$core$String$startsWith, 'http', model.config.location) ? _elm_lang$html$Html$a(
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$href(model.config.location),
			_1: {ctor: '[]'}
		}) : _elm_lang$html$Html$p(
		{ctor: '[]'});
	var _p0 = function () {
		var _p1 = model.selectedTime;
		if (_p1.ctor === 'Nothing') {
			return {ctor: '_Tuple2', _0: '', _1: ''};
		} else {
			var _p2 = _p1._0;
			return {
				ctor: '_Tuple2',
				_0: _CareerPlug$ats$Appointments_Model$readableDate(_p2.start),
				_1: _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: _CareerPlug$ats$Appointments_Model$readableTime(_p2.start),
						_1: {
							ctor: '::',
							_0: ' - ',
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Appointments_Model$readableTime(_p2.end),
								_1: {
									ctor: '::',
									_0: ' ',
									_1: {
										ctor: '::',
										_0: model.config.timezoneAbbr,
										_1: {ctor: '[]'}
									}
								}
							}
						}
					})
			};
		}
	}();
	var date = _p0._0;
	var time = _p0._1;
	return A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('appointment_details'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$p,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('Here are the details for your interview:'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$p,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(date),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$p,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(time),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: locationElement(
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(model.config.location),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$br,
										{ctor: '[]'},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$p,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(
													_elm_lang$core$String$concat(
														{
															ctor: '::',
															_0: 'Please contact ',
															_1: {
																ctor: '::',
																_0: model.config.contactEmail,
																_1: {
																	ctor: '::',
																	_0: ' to make any changes.',
																	_1: {ctor: '[]'}
																}
															}
														})),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}),
			_1: {ctor: '[]'}
		});
};

var _CareerPlug$ats$Appointments_View$titleBar = function (label) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('appointment_name'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$h1,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(label),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Appointments_View$actionButton = F3(
	function (label, action, enabled) {
		var btnAction = function () {
			var _p0 = enabled;
			if (_p0 === false) {
				return _CareerPlug$ats$Appointments_Message$NoOp;
			} else {
				return action;
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$button,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('btn btn-action schedule btn-full'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onClick(btnAction),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$disabled(!enabled),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(label),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$Appointments_View$view = function (model) {
	var titleText = A2(
		_elm_lang$core$String$join,
		' ',
		{
			ctor: '::',
			_0: 'Schedule',
			_1: {
				ctor: '::',
				_0: model.config.appointmentPrefix,
				_1: {
					ctor: '::',
					_0: model.config.appointmentName,
					_1: {ctor: '[]'}
				}
			}
		});
	var errorContent = function () {
		var _p1 = model.errorMessage;
		if (_p1.ctor === 'Nothing') {
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('scheduler_error hidden'),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'});
		} else {
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('scheduler_error'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$button,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('dismiss pull-right btn btn-action'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$Appointments_Message$DismissError),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('X'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$p,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('There was a problem submitting your request.'),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$ul,
								{ctor: '[]'},
								A2(
									_elm_lang$core$List$map,
									function (msg) {
										return A2(
											_elm_lang$html$Html$li,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('warning'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(msg),
												_1: {ctor: '[]'}
											});
									},
									_p1._0)),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$p,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text('Please try again later.'),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}
				});
		}
	}();
	var mainView = function () {
		var _p2 = model.currentView;
		switch (_p2.ctor) {
			case 'Expired':
				return {
					ctor: '::',
					_0: _CareerPlug$ats$Appointments_View$titleBar(titleText),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Appointments_Views_Expired$expiredView(model),
						_1: {ctor: '[]'}
					}
				};
			case 'Scheduling':
				return {
					ctor: '::',
					_0: _CareerPlug$ats$Appointments_View$titleBar(titleText),
					_1: {
						ctor: '::',
						_0: errorContent,
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Appointments_Views_Scheduling$schedulingView(model),
							_1: {
								ctor: '::',
								_0: A3(
									_CareerPlug$ats$Appointments_View$actionButton,
									'Schedule Interview',
									_CareerPlug$ats$Appointments_Message$Schedule,
									_CareerPlug$ats$Appointments_Model$readyToSchedule(model)),
								_1: {ctor: '[]'}
							}
						}
					}
				};
			default:
				return {
					ctor: '::',
					_0: _CareerPlug$ats$Appointments_View$titleBar(
						_elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: model.config.appointmentName,
								_1: {
									ctor: '::',
									_0: ' Details',
									_1: {ctor: '[]'}
								}
							})),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Appointments_Views_Reference$referenceView(model),
						_1: {ctor: '[]'}
					}
				};
		}
	}();
	var mobileClass = function () {
		var _p3 = model.mobile;
		if (_p3 === true) {
			return ' mobile';
		} else {
			return '';
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class(
				_elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: 'appointment_scheduler',
						_1: {
							ctor: '::',
							_0: mobileClass,
							_1: {ctor: '[]'}
						}
					})),
			_1: {ctor: '[]'}
		},
		mainView);
};

var _CareerPlug$ats$AppointmentsMain$initialSize = A2(_elm_lang$core$Task$perform, _CareerPlug$ats$Appointments_Message$ResizeWindow, _elm_lang$window$Window$size);
var _CareerPlug$ats$AppointmentsMain$init = function (flags) {
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$Appointments_Model$initialModel,
			{
				config: flags,
				availability: _CareerPlug$ats$Appointments_Model$availabilitySlotsFromConfig(flags),
				selectedTime: _CareerPlug$ats$Appointments_Model$selectedTimeFromConfig(flags),
				displayedDays: 7,
				currentView: _CareerPlug$ats$Appointments_Model$currentViewFromConfig(flags),
				errorMessage: function () {
					var _p0 = flags.error;
					if (_p0.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Maybe$Just(
							{
								ctor: '::',
								_0: _p0._0,
								_1: {ctor: '[]'}
							});
					}
				}()
			}),
		{
			ctor: '::',
			_0: _CareerPlug$ats$AppointmentsMain$initialSize,
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$AppointmentsMain$main = _elm_lang$html$Html$programWithFlags(
	{init: _CareerPlug$ats$AppointmentsMain$init, update: _CareerPlug$ats$Appointments_Update$update, view: _CareerPlug$ats$Appointments_View$view, subscriptions: _CareerPlug$ats$Appointments_Ports$subscriptions})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (accountName) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (appointmentId) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (appointmentName) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (appointmentPrefix) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (authParam) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (authToken) {
													return A2(
														_elm_lang$core$Json_Decode$andThen,
														function (availability) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (contactEmail) {
																	return A2(
																		_elm_lang$core$Json_Decode$andThen,
																		function (error) {
																			return A2(
																				_elm_lang$core$Json_Decode$andThen,
																				function (location) {
																					return A2(
																						_elm_lang$core$Json_Decode$andThen,
																						function (mobileSwitchpoint) {
																							return A2(
																								_elm_lang$core$Json_Decode$andThen,
																								function (selectedTime) {
																									return A2(
																										_elm_lang$core$Json_Decode$andThen,
																										function (timeSlotDuration) {
																											return A2(
																												_elm_lang$core$Json_Decode$andThen,
																												function (timezone) {
																													return A2(
																														_elm_lang$core$Json_Decode$andThen,
																														function (timezoneAbbr) {
																															return A2(
																																_elm_lang$core$Json_Decode$andThen,
																																function (view) {
																																	return _elm_lang$core$Json_Decode$succeed(
																																		{accountName: accountName, appointmentId: appointmentId, appointmentName: appointmentName, appointmentPrefix: appointmentPrefix, authParam: authParam, authToken: authToken, availability: availability, contactEmail: contactEmail, error: error, location: location, mobileSwitchpoint: mobileSwitchpoint, selectedTime: selectedTime, timeSlotDuration: timeSlotDuration, timezone: timezone, timezoneAbbr: timezoneAbbr, view: view});
																																},
																																A2(_elm_lang$core$Json_Decode$field, 'view', _elm_lang$core$Json_Decode$string));
																														},
																														A2(_elm_lang$core$Json_Decode$field, 'timezoneAbbr', _elm_lang$core$Json_Decode$string));
																												},
																												A2(_elm_lang$core$Json_Decode$field, 'timezone', _elm_lang$core$Json_Decode$string));
																										},
																										A2(_elm_lang$core$Json_Decode$field, 'timeSlotDuration', _elm_lang$core$Json_Decode$int));
																								},
																								A2(
																									_elm_lang$core$Json_Decode$field,
																									'selectedTime',
																									_elm_lang$core$Json_Decode$oneOf(
																										{
																											ctor: '::',
																											_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																											_1: {
																												ctor: '::',
																												_0: A2(
																													_elm_lang$core$Json_Decode$map,
																													_elm_lang$core$Maybe$Just,
																													A2(
																														_elm_lang$core$Json_Decode$andThen,
																														function (x0) {
																															return A2(
																																_elm_lang$core$Json_Decode$andThen,
																																function (x1) {
																																	return _elm_lang$core$Json_Decode$succeed(
																																		{ctor: '_Tuple2', _0: x0, _1: x1});
																																},
																																A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																														},
																														A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string))),
																												_1: {ctor: '[]'}
																											}
																										})));
																						},
																						A2(_elm_lang$core$Json_Decode$field, 'mobileSwitchpoint', _elm_lang$core$Json_Decode$int));
																				},
																				A2(_elm_lang$core$Json_Decode$field, 'location', _elm_lang$core$Json_Decode$string));
																		},
																		A2(
																			_elm_lang$core$Json_Decode$field,
																			'error',
																			_elm_lang$core$Json_Decode$oneOf(
																				{
																					ctor: '::',
																					_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																					_1: {
																						ctor: '::',
																						_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
																						_1: {ctor: '[]'}
																					}
																				})));
																},
																A2(_elm_lang$core$Json_Decode$field, 'contactEmail', _elm_lang$core$Json_Decode$string));
														},
														A2(
															_elm_lang$core$Json_Decode$field,
															'availability',
															_elm_lang$core$Json_Decode$list(
																A2(
																	_elm_lang$core$Json_Decode$andThen,
																	function (x0) {
																		return A2(
																			_elm_lang$core$Json_Decode$andThen,
																			function (x1) {
																				return _elm_lang$core$Json_Decode$succeed(
																					{ctor: '_Tuple2', _0: x0, _1: x1});
																			},
																			A2(
																				_elm_lang$core$Json_Decode$index,
																				1,
																				_elm_lang$core$Json_Decode$list(
																					A2(
																						_elm_lang$core$Json_Decode$andThen,
																						function (end) {
																							return A2(
																								_elm_lang$core$Json_Decode$andThen,
																								function (start) {
																									return _elm_lang$core$Json_Decode$succeed(
																										{end: end, start: start});
																								},
																								A2(_elm_lang$core$Json_Decode$field, 'start', _elm_lang$core$Json_Decode$string));
																						},
																						A2(_elm_lang$core$Json_Decode$field, 'end', _elm_lang$core$Json_Decode$string)))));
																	},
																	A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string)))));
												},
												A2(_elm_lang$core$Json_Decode$field, 'authToken', _elm_lang$core$Json_Decode$string));
										},
										A2(_elm_lang$core$Json_Decode$field, 'authParam', _elm_lang$core$Json_Decode$string));
								},
								A2(_elm_lang$core$Json_Decode$field, 'appointmentPrefix', _elm_lang$core$Json_Decode$string));
						},
						A2(_elm_lang$core$Json_Decode$field, 'appointmentName', _elm_lang$core$Json_Decode$string));
				},
				A2(_elm_lang$core$Json_Decode$field, 'appointmentId', _elm_lang$core$Json_Decode$int));
		},
		A2(_elm_lang$core$Json_Decode$field, 'accountName', _elm_lang$core$Json_Decode$string)));

var _elm_lang$dom$Dom$blur = _elm_lang$dom$Native_Dom.blur;
var _elm_lang$dom$Dom$focus = _elm_lang$dom$Native_Dom.focus;
var _elm_lang$dom$Dom$NotFound = function (a) {
	return {ctor: 'NotFound', _0: a};
};

var _elm_lang$dom$Dom_Size$width = _elm_lang$dom$Native_Dom.width;
var _elm_lang$dom$Dom_Size$height = _elm_lang$dom$Native_Dom.height;
var _elm_lang$dom$Dom_Size$VisibleContentWithBordersAndMargins = {ctor: 'VisibleContentWithBordersAndMargins'};
var _elm_lang$dom$Dom_Size$VisibleContentWithBorders = {ctor: 'VisibleContentWithBorders'};
var _elm_lang$dom$Dom_Size$VisibleContent = {ctor: 'VisibleContent'};
var _elm_lang$dom$Dom_Size$Content = {ctor: 'Content'};

var _elm_lang$dom$Dom_Scroll$toX = _elm_lang$dom$Native_Dom.setScrollLeft;
var _elm_lang$dom$Dom_Scroll$x = _elm_lang$dom$Native_Dom.getScrollLeft;
var _elm_lang$dom$Dom_Scroll$toRight = _elm_lang$dom$Native_Dom.toRight;
var _elm_lang$dom$Dom_Scroll$toLeft = function (id) {
	return A2(_elm_lang$dom$Dom_Scroll$toX, id, 0);
};
var _elm_lang$dom$Dom_Scroll$toY = _elm_lang$dom$Native_Dom.setScrollTop;
var _elm_lang$dom$Dom_Scroll$y = _elm_lang$dom$Native_Dom.getScrollTop;
var _elm_lang$dom$Dom_Scroll$toBottom = _elm_lang$dom$Native_Dom.toBottom;
var _elm_lang$dom$Dom_Scroll$toTop = function (id) {
	return A2(_elm_lang$dom$Dom_Scroll$toY, id, 0);
};

var _elm_lang$core$Set$foldr = F3(
	function (f, b, _p0) {
		var _p1 = _p0;
		return A3(
			_elm_lang$core$Dict$foldr,
			F3(
				function (k, _p2, b) {
					return A2(f, k, b);
				}),
			b,
			_p1._0);
	});
var _elm_lang$core$Set$foldl = F3(
	function (f, b, _p3) {
		var _p4 = _p3;
		return A3(
			_elm_lang$core$Dict$foldl,
			F3(
				function (k, _p5, b) {
					return A2(f, k, b);
				}),
			b,
			_p4._0);
	});
var _elm_lang$core$Set$toList = function (_p6) {
	var _p7 = _p6;
	return _elm_lang$core$Dict$keys(_p7._0);
};
var _elm_lang$core$Set$size = function (_p8) {
	var _p9 = _p8;
	return _elm_lang$core$Dict$size(_p9._0);
};
var _elm_lang$core$Set$member = F2(
	function (k, _p10) {
		var _p11 = _p10;
		return A2(_elm_lang$core$Dict$member, k, _p11._0);
	});
var _elm_lang$core$Set$isEmpty = function (_p12) {
	var _p13 = _p12;
	return _elm_lang$core$Dict$isEmpty(_p13._0);
};
var _elm_lang$core$Set$Set_elm_builtin = function (a) {
	return {ctor: 'Set_elm_builtin', _0: a};
};
var _elm_lang$core$Set$empty = _elm_lang$core$Set$Set_elm_builtin(_elm_lang$core$Dict$empty);
var _elm_lang$core$Set$singleton = function (k) {
	return _elm_lang$core$Set$Set_elm_builtin(
		A2(
			_elm_lang$core$Dict$singleton,
			k,
			{ctor: '_Tuple0'}));
};
var _elm_lang$core$Set$insert = F2(
	function (k, _p14) {
		var _p15 = _p14;
		return _elm_lang$core$Set$Set_elm_builtin(
			A3(
				_elm_lang$core$Dict$insert,
				k,
				{ctor: '_Tuple0'},
				_p15._0));
	});
var _elm_lang$core$Set$fromList = function (xs) {
	return A3(_elm_lang$core$List$foldl, _elm_lang$core$Set$insert, _elm_lang$core$Set$empty, xs);
};
var _elm_lang$core$Set$map = F2(
	function (f, s) {
		return _elm_lang$core$Set$fromList(
			A2(
				_elm_lang$core$List$map,
				f,
				_elm_lang$core$Set$toList(s)));
	});
var _elm_lang$core$Set$remove = F2(
	function (k, _p16) {
		var _p17 = _p16;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$remove, k, _p17._0));
	});
var _elm_lang$core$Set$union = F2(
	function (_p19, _p18) {
		var _p20 = _p19;
		var _p21 = _p18;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$union, _p20._0, _p21._0));
	});
var _elm_lang$core$Set$intersect = F2(
	function (_p23, _p22) {
		var _p24 = _p23;
		var _p25 = _p22;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$intersect, _p24._0, _p25._0));
	});
var _elm_lang$core$Set$diff = F2(
	function (_p27, _p26) {
		var _p28 = _p27;
		var _p29 = _p26;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(_elm_lang$core$Dict$diff, _p28._0, _p29._0));
	});
var _elm_lang$core$Set$filter = F2(
	function (p, _p30) {
		var _p31 = _p30;
		return _elm_lang$core$Set$Set_elm_builtin(
			A2(
				_elm_lang$core$Dict$filter,
				F2(
					function (k, _p32) {
						return p(k);
					}),
				_p31._0));
	});
var _elm_lang$core$Set$partition = F2(
	function (p, _p33) {
		var _p34 = _p33;
		var _p35 = A2(
			_elm_lang$core$Dict$partition,
			F2(
				function (k, _p36) {
					return p(k);
				}),
			_p34._0);
		var p1 = _p35._0;
		var p2 = _p35._1;
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Set$Set_elm_builtin(p1),
			_1: _elm_lang$core$Set$Set_elm_builtin(p2)
		};
	});

var _elm_community$json_extra$Json_Decode_Extra$when = F3(
	function (checkDecoder, check, passDecoder) {
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			function (checkVal) {
				return check(checkVal) ? passDecoder : _elm_lang$core$Json_Decode$fail(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'Check failed with input `',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(checkVal),
							'`')));
			},
			checkDecoder);
	});
var _elm_community$json_extra$Json_Decode_Extra$combine = A2(
	_elm_lang$core$List$foldr,
	_elm_lang$core$Json_Decode$map2(
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			})),
	_elm_lang$core$Json_Decode$succeed(
		{ctor: '[]'}));
var _elm_community$json_extra$Json_Decode_Extra$collection = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (length) {
			return _elm_community$json_extra$Json_Decode_Extra$combine(
				A2(
					_elm_lang$core$List$map,
					function (index) {
						return A2(
							_elm_lang$core$Json_Decode$field,
							_elm_lang$core$Basics$toString(index),
							decoder);
					},
					A2(_elm_lang$core$List$range, 0, length - 1)));
		},
		A2(_elm_lang$core$Json_Decode$field, 'length', _elm_lang$core$Json_Decode$int));
};
var _elm_community$json_extra$Json_Decode_Extra$fromResult = function (result) {
	var _p0 = result;
	if (_p0.ctor === 'Ok') {
		return _elm_lang$core$Json_Decode$succeed(_p0._0);
	} else {
		return _elm_lang$core$Json_Decode$fail(_p0._0);
	}
};
var _elm_community$json_extra$Json_Decode_Extra$parseInt = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p1) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$String$toInt(_p1));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$parseFloat = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p2) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$String$toFloat(_p2));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$doubleEncoded = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (_p3) {
			return _elm_community$json_extra$Json_Decode_Extra$fromResult(
				A2(_elm_lang$core$Json_Decode$decodeString, decoder, _p3));
		},
		_elm_lang$core$Json_Decode$string);
};
var _elm_community$json_extra$Json_Decode_Extra$keys = A2(
	_elm_lang$core$Json_Decode$map,
	A2(
		_elm_lang$core$List$foldl,
		F2(
			function (_p4, acc) {
				var _p5 = _p4;
				return {ctor: '::', _0: _p5._0, _1: acc};
			}),
		{ctor: '[]'}),
	_elm_lang$core$Json_Decode$keyValuePairs(
		_elm_lang$core$Json_Decode$succeed(
			{ctor: '_Tuple0'})));
var _elm_community$json_extra$Json_Decode_Extra$sequenceHelp = F2(
	function (decoders, jsonValues) {
		return (!_elm_lang$core$Native_Utils.eq(
			_elm_lang$core$List$length(jsonValues),
			_elm_lang$core$List$length(decoders))) ? _elm_lang$core$Json_Decode$fail('Number of decoders does not match number of values') : _elm_community$json_extra$Json_Decode_Extra$fromResult(
			A3(
				_elm_lang$core$List$foldr,
				_elm_lang$core$Result$map2(
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						})),
				_elm_lang$core$Result$Ok(
					{ctor: '[]'}),
				A3(_elm_lang$core$List$map2, _elm_lang$core$Json_Decode$decodeValue, decoders, jsonValues)));
	});
var _elm_community$json_extra$Json_Decode_Extra$sequence = function (decoders) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		_elm_community$json_extra$Json_Decode_Extra$sequenceHelp(decoders),
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value));
};
var _elm_community$json_extra$Json_Decode_Extra$indexedList = function (indexedDecoder) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (values) {
			return _elm_community$json_extra$Json_Decode_Extra$sequence(
				A2(
					_elm_lang$core$List$map,
					indexedDecoder,
					A2(
						_elm_lang$core$List$range,
						0,
						_elm_lang$core$List$length(values) - 1)));
		},
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$value));
};
var _elm_community$json_extra$Json_Decode_Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _p6 = A2(
				_elm_lang$core$Json_Decode$decodeValue,
				A2(_elm_lang$core$Json_Decode$field, fieldName, _elm_lang$core$Json_Decode$value),
				json);
			if (_p6.ctor === 'Ok') {
				return A2(
					_elm_lang$core$Json_Decode$map,
					_elm_lang$core$Maybe$Just,
					A2(_elm_lang$core$Json_Decode$field, fieldName, decoder));
			} else {
				return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing);
			}
		};
		return A2(_elm_lang$core$Json_Decode$andThen, finishDecoding, _elm_lang$core$Json_Decode$value);
	});
var _elm_community$json_extra$Json_Decode_Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			_elm_lang$core$Json_Decode$map,
			_elm_lang$core$Maybe$withDefault(fallback),
			_elm_lang$core$Json_Decode$maybe(decoder));
	});
var _elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples = F2(
	function (keyDecoder, tuples) {
		var _p7 = tuples;
		if (_p7.ctor === '[]') {
			return _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Dict$empty);
		} else {
			var _p8 = A2(_elm_lang$core$Json_Decode$decodeString, keyDecoder, _p7._0._0);
			if (_p8.ctor === 'Ok') {
				return A2(
					_elm_lang$core$Json_Decode$andThen,
					function (_p9) {
						return _elm_lang$core$Json_Decode$succeed(
							A3(_elm_lang$core$Dict$insert, _p8._0, _p7._0._1, _p9));
					},
					A2(_elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples, keyDecoder, _p7._1));
			} else {
				return _elm_lang$core$Json_Decode$fail(_p8._0);
			}
		}
	});
var _elm_community$json_extra$Json_Decode_Extra$dict2 = F2(
	function (keyDecoder, valueDecoder) {
		return A2(
			_elm_lang$core$Json_Decode$andThen,
			_elm_community$json_extra$Json_Decode_Extra$decodeDictFromTuples(keyDecoder),
			_elm_lang$core$Json_Decode$keyValuePairs(valueDecoder));
	});
var _elm_community$json_extra$Json_Decode_Extra$set = function (decoder) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Set$fromList,
		_elm_lang$core$Json_Decode$list(decoder));
};
var _elm_community$json_extra$Json_Decode_Extra$date = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (_p10) {
		return _elm_community$json_extra$Json_Decode_Extra$fromResult(
			_elm_lang$core$Date$fromString(_p10));
	},
	_elm_lang$core$Json_Decode$string);
var _elm_community$json_extra$Json_Decode_Extra$andMap = _elm_lang$core$Json_Decode$map2(
	F2(
		function (x, y) {
			return y(x);
		}));
var _elm_community$json_extra$Json_Decode_Extra_ops = _elm_community$json_extra$Json_Decode_Extra_ops || {};
_elm_community$json_extra$Json_Decode_Extra_ops['|:'] = _elm_lang$core$Basics$flip(_elm_community$json_extra$Json_Decode_Extra$andMap);

var _CareerPlug$ats$AvailabilityPicker$pointDecoder = function (msgGen) {
	return A2(
		_elm_lang$core$Json_Decode$map,
		msgGen,
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'clientY',
				_1: {ctor: '[]'}
			},
			_elm_lang$core$Json_Decode$float));
};
var _CareerPlug$ats$AvailabilityPicker$stopOptions = {stopPropagation: true, preventDefault: true};
var _CareerPlug$ats$AvailabilityPicker$timeParts = function (time) {
	var _p0 = (_elm_lang$core$Native_Utils.cmp(time.hour, 12) < 0) ? (_elm_lang$core$Native_Utils.eq(time.hour, 0) ? {ctor: '_Tuple2', _0: '12', _1: 'am'} : {
		ctor: '_Tuple2',
		_0: _elm_lang$core$Basics$toString(time.hour),
		_1: 'am'
	}) : (_elm_lang$core$Native_Utils.eq(time.hour, 12) ? {ctor: '_Tuple2', _0: '12', _1: 'pm'} : (_elm_lang$core$Native_Utils.eq(time.hour, 24) ? {ctor: '_Tuple2', _0: '12', _1: 'am'} : {
		ctor: '_Tuple2',
		_0: _elm_lang$core$Basics$toString(time.hour - 12),
		_1: 'pm'
	}));
	var h = _p0._0;
	var mer = _p0._1;
	var m = A3(
		_elm_lang$core$String$padLeft,
		2,
		_elm_lang$core$Native_Utils.chr('0'),
		_elm_lang$core$Basics$toString(time.minute));
	return {ctor: '_Tuple3', _0: h, _1: m, _2: mer};
};
var _CareerPlug$ats$AvailabilityPicker$timeString = function (time) {
	var _p1 = _CareerPlug$ats$AvailabilityPicker$timeParts(time);
	var h = _p1._0;
	var m = _p1._1;
	var mer = _p1._2;
	return (_elm_lang$core$Native_Utils.cmp(time.minute, 0) > 0) ? _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: h,
			_1: {
				ctor: '::',
				_0: ':',
				_1: {
					ctor: '::',
					_0: m,
					_1: {
						ctor: '::',
						_0: mer,
						_1: {ctor: '[]'}
					}
				}
			}
		}) : _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: h,
			_1: {
				ctor: '::',
				_0: mer,
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$AvailabilityPicker$timeOutputString = function (time) {
	var _p2 = _CareerPlug$ats$AvailabilityPicker$timeParts(time);
	var h = _p2._0;
	var m = _p2._1;
	var mer = _p2._2;
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: h,
			_1: {
				ctor: '::',
				_0: ':',
				_1: {
					ctor: '::',
					_0: m,
					_1: {
						ctor: '::',
						_0: ' ',
						_1: {
							ctor: '::',
							_0: _elm_lang$core$String$toUpper(mer),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		});
};
var _CareerPlug$ats$AvailabilityPicker$hourString = function (time) {
	var _p3 = _CareerPlug$ats$AvailabilityPicker$timeParts(time);
	var h = _p3._0;
	var mer = _p3._2;
	return _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: h,
			_1: {
				ctor: '::',
				_0: mer,
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$AvailabilityPicker$timeColumn = function () {
	var row = function (h) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('hour'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					_CareerPlug$ats$AvailabilityPicker$hourString(
						{hour: h, minute: 0})),
				_1: {ctor: '[]'}
			});
	};
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('time'),
			_1: {ctor: '[]'}
		},
		A2(
			_elm_lang$core$List$map,
			row,
			A2(_elm_lang$core$List$range, 0, 23)));
}();
var _CareerPlug$ats$AvailabilityPicker$headerRows = {
	ctor: '::',
	_0: A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text('SUN'),
			_1: {ctor: '[]'}
		}),
	_1: {
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('MON'),
				_1: {ctor: '[]'}
			}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('TUE'),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('WED'),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('THU'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('FRI'),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('SAT'),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		}
	}
};
var _CareerPlug$ats$AvailabilityPicker$saveCurrentSlot = function (model) {
	var _p4 = model.slot;
	if (_p4.ctor === 'Just') {
		return _elm_lang$core$Native_Utils.update(
			model,
			{
				slot: _elm_lang$core$Maybe$Nothing,
				grid: {ctor: '::', _0: _p4._0, _1: model.grid}
			});
	} else {
		return model;
	}
};
var _CareerPlug$ats$AvailabilityPicker$roundTime = function (time) {
	var h = (_elm_lang$core$Native_Utils.cmp(time.minute, 52) > 0) ? (_elm_lang$core$Native_Utils.eq(time.hour, 23) ? 0 : (time.hour + 1)) : time.hour;
	var m = A2(
		_elm_lang$core$Basics_ops['%'],
		_elm_lang$core$Basics$round(
			_elm_lang$core$Basics$toFloat(time.minute) / 15.0) * 15,
		60);
	return {hour: h, minute: m};
};
var _CareerPlug$ats$AvailabilityPicker$minutesToTime = function (minutes) {
	return {
		hour: (minutes / 60) | 0,
		minute: A2(_elm_lang$core$Basics$rem, minutes, 60)
	};
};
var _CareerPlug$ats$AvailabilityPicker$timeToMinutes = function (time) {
	return (time.hour * 60) + time.minute;
};
var _CareerPlug$ats$AvailabilityPicker$addMinutesToTime = F2(
	function (diff, time) {
		return _CareerPlug$ats$AvailabilityPicker$minutesToTime(
			_CareerPlug$ats$AvailabilityPicker$timeToMinutes(time) + diff);
	});
var _CareerPlug$ats$AvailabilityPicker$timeCompare = F2(
	function (start, end) {
		return A2(
			_elm_lang$core$Basics$compare,
			_CareerPlug$ats$AvailabilityPicker$timeToMinutes(start),
			_CareerPlug$ats$AvailabilityPicker$timeToMinutes(end));
	});
var _CareerPlug$ats$AvailabilityPicker$diffToTime = F3(
	function (initial, startY, endY) {
		var dMinutes = _elm_lang$core$Basics$floor((endY - startY) * 2.0);
		return _CareerPlug$ats$AvailabilityPicker$roundTime(
			A2(_CareerPlug$ats$AvailabilityPicker$addMinutesToTime, dMinutes, initial));
	});
var _CareerPlug$ats$AvailabilityPicker$forDay = F2(
	function (day, grid) {
		return A2(
			_elm_lang$core$List$filter,
			function (s) {
				return _elm_lang$core$Native_Utils.eq(s.day, day);
			},
			grid);
	});
var _CareerPlug$ats$AvailabilityPicker$butSlot = F2(
	function (slot, grid) {
		return A2(
			_elm_lang$core$List$filter,
			function (s) {
				return !_elm_lang$core$Native_Utils.eq(s, slot);
			},
			grid);
	});
var _CareerPlug$ats$AvailabilityPicker$slotCeiling = F2(
	function (slot, grid) {
		return A2(
			_elm_lang$core$Maybe$map,
			function (_) {
				return _.end;
			},
			_elm_lang$core$List$head(
				_elm_lang$core$List$reverse(
					A2(
						_elm_lang$core$List$sortBy,
						function (s) {
							return _CareerPlug$ats$AvailabilityPicker$timeToMinutes(s.end);
						},
						A2(
							_elm_lang$core$List$filter,
							function (s) {
								return _elm_lang$core$Native_Utils.eq(
									A2(_CareerPlug$ats$AvailabilityPicker$timeCompare, slot.start, s.end),
									_elm_lang$core$Basics$GT);
							},
							A2(
								_CareerPlug$ats$AvailabilityPicker$butSlot,
								slot,
								A2(_CareerPlug$ats$AvailabilityPicker$forDay, slot.day, grid)))))));
	});
var _CareerPlug$ats$AvailabilityPicker$moveSlotStart = F6(
	function (both, initial, grid, dy, y, slot) {
		var ceil = A2(_CareerPlug$ats$AvailabilityPicker$slotCeiling, slot, grid);
		var start = A3(_CareerPlug$ats$AvailabilityPicker$diffToTime, initial, dy, y);
		if (both || _elm_lang$core$Native_Utils.eq(
			A2(_CareerPlug$ats$AvailabilityPicker$timeCompare, start, slot.end),
			_elm_lang$core$Basics$LT)) {
			var _p5 = ceil;
			if (_p5.ctor === 'Just') {
				return _elm_lang$core$Native_Utils.eq(
					A2(_CareerPlug$ats$AvailabilityPicker$timeCompare, start, _p5._0),
					_elm_lang$core$Basics$GT) ? _elm_lang$core$Maybe$Just(
					_elm_lang$core$Native_Utils.update(
						slot,
						{start: start})) : _elm_lang$core$Maybe$Nothing;
			} else {
				return (!_elm_lang$core$Native_Utils.eq(
					A2(
						_CareerPlug$ats$AvailabilityPicker$timeCompare,
						start,
						{hour: 0, minute: 0}),
					_elm_lang$core$Basics$LT)) ? _elm_lang$core$Maybe$Just(
					_elm_lang$core$Native_Utils.update(
						slot,
						{start: start})) : _elm_lang$core$Maybe$Nothing;
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _CareerPlug$ats$AvailabilityPicker$slotFloor = F2(
	function (slot, grid) {
		return A2(
			_elm_lang$core$Maybe$map,
			function (_) {
				return _.start;
			},
			_elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$sortBy,
					function (s) {
						return _CareerPlug$ats$AvailabilityPicker$timeToMinutes(s.start);
					},
					A2(
						_elm_lang$core$List$filter,
						function (s) {
							return _elm_lang$core$Native_Utils.eq(
								A2(_CareerPlug$ats$AvailabilityPicker$timeCompare, slot.end, s.start),
								_elm_lang$core$Basics$LT);
						},
						A2(
							_CareerPlug$ats$AvailabilityPicker$butSlot,
							slot,
							A2(_CareerPlug$ats$AvailabilityPicker$forDay, slot.day, grid))))));
	});
var _CareerPlug$ats$AvailabilityPicker$moveSlotEnd = F6(
	function (both, initial, grid, dy, y, slot) {
		var fl = A2(_CareerPlug$ats$AvailabilityPicker$slotFloor, slot, grid);
		var end = A3(_CareerPlug$ats$AvailabilityPicker$diffToTime, initial, dy, y);
		if (both || _elm_lang$core$Native_Utils.eq(
			A2(_CareerPlug$ats$AvailabilityPicker$timeCompare, end, slot.start),
			_elm_lang$core$Basics$GT)) {
			var _p6 = fl;
			if (_p6.ctor === 'Just') {
				return _elm_lang$core$Native_Utils.eq(
					A2(_CareerPlug$ats$AvailabilityPicker$timeCompare, end, _p6._0),
					_elm_lang$core$Basics$LT) ? _elm_lang$core$Maybe$Just(
					_elm_lang$core$Native_Utils.update(
						slot,
						{end: end})) : _elm_lang$core$Maybe$Nothing;
			} else {
				return (!_elm_lang$core$Native_Utils.eq(
					A2(
						_CareerPlug$ats$AvailabilityPicker$timeCompare,
						end,
						{hour: 24, minute: 0}),
					_elm_lang$core$Basics$GT)) ? _elm_lang$core$Maybe$Just(
					_elm_lang$core$Native_Utils.update(
						slot,
						{end: end})) : _elm_lang$core$Maybe$Nothing;
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _CareerPlug$ats$AvailabilityPicker$moveSlotBody = F5(
	function (initial, grid, dy, y, slot) {
		var mEnd = A6(_CareerPlug$ats$AvailabilityPicker$moveSlotEnd, true, initial.end, grid, dy, y, slot);
		var mStart = A6(_CareerPlug$ats$AvailabilityPicker$moveSlotStart, true, initial.start, grid, dy, y, slot);
		var _p7 = {ctor: '_Tuple2', _0: mStart, _1: mEnd};
		if (((_p7.ctor === '_Tuple2') && (_p7._0.ctor === 'Just')) && (_p7._1.ctor === 'Just')) {
			return _elm_lang$core$Maybe$Just(
				_elm_lang$core$Native_Utils.update(
					slot,
					{start: _p7._0._0.start, end: _p7._1._0.end}));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _CareerPlug$ats$AvailabilityPicker$moveSlot = F5(
	function (grid, handle, dy, y, slot) {
		var fn = function () {
			var _p8 = handle;
			switch (_p8.ctor) {
				case 'Start':
					return A2(_CareerPlug$ats$AvailabilityPicker$moveSlotStart, false, _p8._0);
				case 'End':
					return A2(_CareerPlug$ats$AvailabilityPicker$moveSlotEnd, false, _p8._0);
				default:
					return _CareerPlug$ats$AvailabilityPicker$moveSlotBody(_p8._0);
			}
		}();
		return A4(fn, grid, dy, y, slot);
	});
var _CareerPlug$ats$AvailabilityPicker$dayString = function (day) {
	var _p9 = day;
	switch (_p9.ctor) {
		case 'Sunday':
			return 'Sunday';
		case 'Monday':
			return 'Monday';
		case 'Tuesday':
			return 'Tuesday';
		case 'Wednesday':
			return 'Wednesday';
		case 'Thursday':
			return 'Thursday';
		case 'Friday':
			return 'Friday';
		default:
			return 'Saturday';
	}
};
var _CareerPlug$ats$AvailabilityPicker$timeR = _elm_lang$core$Regex$regex('[: ]');
var _CareerPlug$ats$AvailabilityPicker$strToTime = function (time) {
	var convert = F3(
		function (h, m, p) {
			var h_ = (_elm_lang$core$Native_Utils.eq(p, 'PM') && (_elm_lang$core$Native_Utils.cmp(h, 12) < 0)) ? (h + 12) : h;
			return {hour: h_, minute: m};
		});
	var parts = A3(_elm_lang$core$Regex$split, _elm_lang$core$Regex$All, _CareerPlug$ats$AvailabilityPicker$timeR, time);
	var hourS = _elm_lang$core$List$head(parts);
	var minS = _elm_lang$core$List$head(
		A2(_elm_lang$core$List$drop, 1, parts));
	var merS = _elm_lang$core$List$head(
		A2(_elm_lang$core$List$drop, 2, parts));
	var _p10 = {ctor: '_Tuple3', _0: hourS, _1: minS, _2: merS};
	if ((((_p10.ctor === '_Tuple3') && (_p10._0.ctor === 'Just')) && (_p10._1.ctor === 'Just')) && (_p10._2.ctor === 'Just')) {
		return A4(
			_elm_lang$core$Result$map3,
			convert,
			_elm_lang$core$String$toInt(_p10._0._0),
			_elm_lang$core$String$toInt(_p10._1._0),
			_elm_lang$core$Result$Ok(_p10._2._0));
	} else {
		return _elm_lang$core$Result$Err(
			A2(_elm_lang$core$Basics_ops['++'], 'Could not parse time: ', time));
	}
};
var _CareerPlug$ats$AvailabilityPicker$blankGrid = {ctor: '[]'};
var _CareerPlug$ats$AvailabilityPicker$availPicker = _elm_lang$core$Native_Platform.incomingPort('availPicker', _elm_lang$core$Json_Decode$string);
var _CareerPlug$ats$AvailabilityPicker$Time = F2(
	function (a, b) {
		return {hour: a, minute: b};
	});
var _CareerPlug$ats$AvailabilityPicker$Slot = F3(
	function (a, b, c) {
		return {day: a, start: b, end: c};
	});
var _CareerPlug$ats$AvailabilityPicker$Model = F3(
	function (a, b, c) {
		return {grid: a, dragging: b, slot: c};
	});
var _CareerPlug$ats$AvailabilityPicker$Saturday = {ctor: 'Saturday'};
var _CareerPlug$ats$AvailabilityPicker$Friday = {ctor: 'Friday'};
var _CareerPlug$ats$AvailabilityPicker$Thursday = {ctor: 'Thursday'};
var _CareerPlug$ats$AvailabilityPicker$Wednesday = {ctor: 'Wednesday'};
var _CareerPlug$ats$AvailabilityPicker$Tuesday = {ctor: 'Tuesday'};
var _CareerPlug$ats$AvailabilityPicker$Monday = {ctor: 'Monday'};
var _CareerPlug$ats$AvailabilityPicker$Sunday = {ctor: 'Sunday'};
var _CareerPlug$ats$AvailabilityPicker$jsonGrid = function () {
	var combine = F7(
		function (sa, m, t, w, th, f, su) {
			return _elm_lang$core$List$concat(
				{
					ctor: '::',
					_0: sa,
					_1: {
						ctor: '::',
						_0: m,
						_1: {
							ctor: '::',
							_0: t,
							_1: {
								ctor: '::',
								_0: w,
								_1: {
									ctor: '::',
									_0: th,
									_1: {
										ctor: '::',
										_0: f,
										_1: {
											ctor: '::',
											_0: su,
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				});
		});
	var time = A2(
		_elm_lang$core$Json_Decode$andThen,
		function (v) {
			return _elm_community$json_extra$Json_Decode_Extra$fromResult(
				_CareerPlug$ats$AvailabilityPicker$strToTime(v));
		},
		_elm_lang$core$Json_Decode$string);
	var slot = function (day) {
		return A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'end',
			time,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'start',
				time,
				A2(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded,
					day,
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$AvailabilityPicker$Slot))));
	};
	var slots = function (day) {
		return _elm_lang$core$Json_Decode$list(
			slot(day));
	};
	var normal = A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'Saturday',
		slots(_CareerPlug$ats$AvailabilityPicker$Saturday),
		{ctor: '[]'},
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'Friday',
			slots(_CareerPlug$ats$AvailabilityPicker$Friday),
			{ctor: '[]'},
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'Thursday',
				slots(_CareerPlug$ats$AvailabilityPicker$Thursday),
				{ctor: '[]'},
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'Wednesday',
					slots(_CareerPlug$ats$AvailabilityPicker$Wednesday),
					{ctor: '[]'},
					A4(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
						'Tuesday',
						slots(_CareerPlug$ats$AvailabilityPicker$Tuesday),
						{ctor: '[]'},
						A4(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
							'Monday',
							slots(_CareerPlug$ats$AvailabilityPicker$Monday),
							{ctor: '[]'},
							A4(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
								'Sunday',
								slots(_CareerPlug$ats$AvailabilityPicker$Sunday),
								{ctor: '[]'},
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(combine))))))));
	return _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: normal,
			_1: {
				ctor: '::',
				_0: _elm_lang$core$Json_Decode$null(_CareerPlug$ats$AvailabilityPicker$blankGrid),
				_1: {ctor: '[]'}
			}
		});
}();
var _CareerPlug$ats$AvailabilityPicker$outputView = function (grid) {
	var slotInput = F3(
		function (dname, aname, val) {
			var iname = _elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'calendar[available][',
					_1: {
						ctor: '::',
						_0: dname,
						_1: {
							ctor: '::',
							_0: '][][',
							_1: {
								ctor: '::',
								_0: aname,
								_1: {
									ctor: '::',
									_0: ']',
									_1: {ctor: '[]'}
								}
							}
						}
					}
				});
			return A2(
				_elm_lang$html$Html$input,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$type_('hidden'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$name(iname),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$value(val),
							_1: {ctor: '[]'}
						}
					}
				},
				{ctor: '[]'});
		});
	var addSlot = F2(
		function (slot, dict) {
			var key = _CareerPlug$ats$AvailabilityPicker$dayString(slot.day);
			var _p11 = A2(_elm_lang$core$Dict$get, key, dict);
			if (_p11.ctor === 'Just') {
				return A3(
					_elm_lang$core$Dict$insert,
					key,
					{ctor: '::', _0: slot, _1: _p11._0},
					dict);
			} else {
				return A3(
					_elm_lang$core$Dict$insert,
					key,
					{
						ctor: '::',
						_0: slot,
						_1: {ctor: '[]'}
					},
					dict);
			}
		});
	var consolidated = A3(_elm_lang$core$List$foldr, addSlot, _elm_lang$core$Dict$empty, grid);
	var day = function (d) {
		var key = _CareerPlug$ats$AvailabilityPicker$dayString(d);
		var slotPair = function (s) {
			return {
				ctor: '::',
				_0: A3(
					slotInput,
					key,
					'start',
					_CareerPlug$ats$AvailabilityPicker$timeOutputString(s.start)),
				_1: {
					ctor: '::',
					_0: A3(
						slotInput,
						key,
						'end',
						_CareerPlug$ats$AvailabilityPicker$timeOutputString(s.end)),
					_1: {ctor: '[]'}
				}
			};
		};
		var _p12 = A2(_elm_lang$core$Dict$get, key, consolidated);
		if (_p12.ctor === 'Just') {
			return _elm_lang$core$List$concat(
				A2(_elm_lang$core$List$map, slotPair, _p12._0));
		} else {
			return {
				ctor: '::',
				_0: A3(slotInput, key, 'start', ''),
				_1: {
					ctor: '::',
					_0: A3(slotInput, key, 'end', ''),
					_1: {ctor: '[]'}
				}
			};
		}
	};
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('availability-output'),
			_1: {ctor: '[]'}
		},
		_elm_lang$core$List$concat(
			{
				ctor: '::',
				_0: day(_CareerPlug$ats$AvailabilityPicker$Sunday),
				_1: {
					ctor: '::',
					_0: day(_CareerPlug$ats$AvailabilityPicker$Monday),
					_1: {
						ctor: '::',
						_0: day(_CareerPlug$ats$AvailabilityPicker$Tuesday),
						_1: {
							ctor: '::',
							_0: day(_CareerPlug$ats$AvailabilityPicker$Wednesday),
							_1: {
								ctor: '::',
								_0: day(_CareerPlug$ats$AvailabilityPicker$Thursday),
								_1: {
									ctor: '::',
									_0: day(_CareerPlug$ats$AvailabilityPicker$Friday),
									_1: {
										ctor: '::',
										_0: day(_CareerPlug$ats$AvailabilityPicker$Saturday),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			}));
};
var _CareerPlug$ats$AvailabilityPicker$End = function (a) {
	return {ctor: 'End', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$Start = function (a) {
	return {ctor: 'Start', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$Body = function (a) {
	return {ctor: 'Body', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$Dragging = F2(
	function (a, b) {
		return {ctor: 'Dragging', _0: a, _1: b};
	});
var _CareerPlug$ats$AvailabilityPicker$NotDragging = {ctor: 'NotDragging'};
var _CareerPlug$ats$AvailabilityPicker$blankModel = {grid: _CareerPlug$ats$AvailabilityPicker$blankGrid, dragging: _CareerPlug$ats$AvailabilityPicker$NotDragging, slot: _elm_lang$core$Maybe$Nothing};
var _CareerPlug$ats$AvailabilityPicker$init = function (flags) {
	var grid = function () {
		var _p13 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$AvailabilityPicker$jsonGrid, flags);
		if (_p13.ctor === 'Ok') {
			return _p13._0;
		} else {
			var _p14 = A2(_elm_lang$core$Debug$log, 'Decoding Flags', _p13._0);
			return _CareerPlug$ats$AvailabilityPicker$blankGrid;
		}
	}();
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$AvailabilityPicker$blankModel,
			{grid: grid}),
		{ctor: '[]'});
};
var _CareerPlug$ats$AvailabilityPicker$Inbound = function (a) {
	return {ctor: 'Inbound', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$ScrollIntoView = {ctor: 'ScrollIntoView'};
var _CareerPlug$ats$AvailabilityPicker$RemoveSlot = function (a) {
	return {ctor: 'RemoveSlot', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$SaveSlot = {ctor: 'SaveSlot'};
var _CareerPlug$ats$AvailabilityPicker$MoveSlot = function (a) {
	return {ctor: 'MoveSlot', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$EditSlot = F3(
	function (a, b, c) {
		return {ctor: 'EditSlot', _0: a, _1: b, _2: c};
	});
var _CareerPlug$ats$AvailabilityPicker$slotsDay = F2(
	function (model, day) {
		var styleAttr = function (s) {
			var height = ((_elm_lang$core$Basics$toFloat(s.end.hour) + (_elm_lang$core$Basics$toFloat(s.end.minute) / 60.0)) - (_elm_lang$core$Basics$toFloat(s.start.hour) + (_elm_lang$core$Basics$toFloat(s.start.minute) / 60.0))) * 30.0;
			var top = (_elm_lang$core$Basics$toFloat(s.start.hour) + (_elm_lang$core$Basics$toFloat(s.start.minute) / 60.0)) * 30.0;
			return _elm_lang$html$Html_Attributes$style(
				{
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'top',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(top),
							'px')
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'height',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(height),
								'px')
						},
						_1: {ctor: '[]'}
					}
				});
		};
		var title = function (s) {
			return A2(
				_elm_lang$core$String$join,
				' - ',
				{
					ctor: '::',
					_0: _CareerPlug$ats$AvailabilityPicker$timeString(s.start),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$AvailabilityPicker$timeString(s.end),
						_1: {ctor: '[]'}
					}
				});
		};
		var slot = F5(
			function (className, bEvents, sEvents, eEvents, s) {
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'slot', className)),
						_1: {
							ctor: '::',
							_0: styleAttr(s),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							A2(
								_elm_lang$core$Basics_ops['++'],
								bEvents,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('slot-content'),
									_1: {ctor: '[]'}
								}),
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									title(s)),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$a,
										A2(
											_elm_lang$core$Basics_ops['++'],
											sEvents,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('drag start'),
												_1: {ctor: '[]'}
											}),
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(''),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$a,
											A2(
												_elm_lang$core$Basics_ops['++'],
												eEvents,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('drag end'),
													_1: {ctor: '[]'}
												}),
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(''),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$a,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('action remove'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Events$onClick(
															_CareerPlug$ats$AvailabilityPicker$RemoveSlot(s)),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$i,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('fa fa-times fa-lg'),
															_1: {ctor: '[]'}
														},
														{ctor: '[]'}),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}
								}
							}),
						_1: {ctor: '[]'}
					});
			});
		var normalSlot = function (s) {
			var events = function (handle) {
				return {
					ctor: '::',
					_0: A3(
						_elm_lang$html$Html_Events$onWithOptions,
						'mousedown',
						_CareerPlug$ats$AvailabilityPicker$stopOptions,
						_CareerPlug$ats$AvailabilityPicker$pointDecoder(
							A2(_CareerPlug$ats$AvailabilityPicker$EditSlot, handle, s))),
					_1: {
						ctor: '::',
						_0: A3(
							_elm_lang$html$Html_Events$onWithOptions,
							'touchstart',
							_CareerPlug$ats$AvailabilityPicker$stopOptions,
							_CareerPlug$ats$AvailabilityPicker$pointDecoder(
								A2(_CareerPlug$ats$AvailabilityPicker$EditSlot, handle, s))),
						_1: {ctor: '[]'}
					}
				};
			};
			return A5(
				slot,
				'',
				events(
					_CareerPlug$ats$AvailabilityPicker$Body(s)),
				events(
					_CareerPlug$ats$AvailabilityPicker$Start(s.start)),
				events(
					_CareerPlug$ats$AvailabilityPicker$End(s.end)),
				s);
		};
		var slotEditor = function (s) {
			var events = function () {
				var _p15 = model.dragging;
				if (_p15.ctor === 'Dragging') {
					return {
						ctor: '::',
						_0: A3(
							_elm_lang$html$Html_Events$onWithOptions,
							'touchmove',
							_CareerPlug$ats$AvailabilityPicker$stopOptions,
							_CareerPlug$ats$AvailabilityPicker$pointDecoder(_CareerPlug$ats$AvailabilityPicker$MoveSlot)),
						_1: {
							ctor: '::',
							_0: A3(
								_elm_lang$html$Html_Events$onWithOptions,
								'touchend',
								_CareerPlug$ats$AvailabilityPicker$stopOptions,
								_elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AvailabilityPicker$SaveSlot)),
							_1: {
								ctor: '::',
								_0: A3(
									_elm_lang$html$Html_Events$onWithOptions,
									'touchcancel',
									_CareerPlug$ats$AvailabilityPicker$stopOptions,
									_elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AvailabilityPicker$SaveSlot)),
								_1: {ctor: '[]'}
							}
						}
					};
				} else {
					return {ctor: '[]'};
				}
			}();
			return A5(slot, ' editing', events, events, events, s);
		};
		var today = A2(_CareerPlug$ats$AvailabilityPicker$forDay, day, model.grid);
		var slots = A2(_elm_lang$core$List$map, normalSlot, today);
		var _p16 = model.slot;
		if (_p16.ctor === 'Just') {
			var _p17 = _p16._0;
			return _elm_lang$core$Native_Utils.eq(_p17.day, day) ? {
				ctor: '::',
				_0: slotEditor(_p17),
				_1: slots
			} : slots;
		} else {
			return slots;
		}
	});
var _CareerPlug$ats$AvailabilityPicker$AddSlot = function (a) {
	return {ctor: 'AddSlot', _0: a};
};
var _CareerPlug$ats$AvailabilityPicker$gridCell = F2(
	function (day, hr) {
		var newSlot = {
			day: day,
			start: {hour: hr, minute: 0},
			end: {hour: hr + 1, minute: 0}
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('cell'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onClick(
						_CareerPlug$ats$AvailabilityPicker$AddSlot(newSlot)),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(''),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$AvailabilityPicker$gridDay = F2(
	function (model, day) {
		var slots = A2(_CareerPlug$ats$AvailabilityPicker$slotsDay, model, day);
		var cells = A2(
			_elm_lang$core$List$map,
			function (hr) {
				return A2(_CareerPlug$ats$AvailabilityPicker$gridCell, day, hr);
			},
			A2(_elm_lang$core$List$range, 0, 23));
		return A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			A2(_elm_lang$core$Basics_ops['++'], cells, slots));
	});
var _CareerPlug$ats$AvailabilityPicker$gridRows = function (model) {
	var events = function () {
		var _p18 = {ctor: '_Tuple2', _0: model.slot, _1: model.dragging};
		if (((_p18.ctor === '_Tuple2') && (_p18._0.ctor === 'Just')) && (_p18._1.ctor === 'Dragging')) {
			return {
				ctor: '::',
				_0: A3(
					_elm_lang$html$Html_Events$onWithOptions,
					'mousemove',
					_CareerPlug$ats$AvailabilityPicker$stopOptions,
					_CareerPlug$ats$AvailabilityPicker$pointDecoder(_CareerPlug$ats$AvailabilityPicker$MoveSlot)),
				_1: {
					ctor: '::',
					_0: A3(
						_elm_lang$html$Html_Events$onWithOptions,
						'mouseup',
						_CareerPlug$ats$AvailabilityPicker$stopOptions,
						_elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AvailabilityPicker$SaveSlot)),
					_1: {
						ctor: '::',
						_0: A3(
							_elm_lang$html$Html_Events$onWithOptions,
							'mouseleave',
							_CareerPlug$ats$AvailabilityPicker$stopOptions,
							_elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$AvailabilityPicker$SaveSlot)),
						_1: {ctor: '[]'}
					}
				}
			};
		} else {
			return {ctor: '[]'};
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('grid'),
			_1: events
		},
		{
			ctor: '::',
			_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Sunday),
			_1: {
				ctor: '::',
				_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Monday),
				_1: {
					ctor: '::',
					_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Tuesday),
					_1: {
						ctor: '::',
						_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Wednesday),
						_1: {
							ctor: '::',
							_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Thursday),
							_1: {
								ctor: '::',
								_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Friday),
								_1: {
									ctor: '::',
									_0: A2(_CareerPlug$ats$AvailabilityPicker$gridDay, model, _CareerPlug$ats$AvailabilityPicker$Saturday),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		});
};
var _CareerPlug$ats$AvailabilityPicker$view = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('availability-wrapper'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('availability-header'),
					_1: {ctor: '[]'}
				},
				_CareerPlug$ats$AvailabilityPicker$headerRows),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$id('availability-scroll'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('availability-grid'),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _CareerPlug$ats$AvailabilityPicker$timeColumn,
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$AvailabilityPicker$gridRows(model),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: _CareerPlug$ats$AvailabilityPicker$outputView(model.grid),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$AvailabilityPicker$NoOp = {ctor: 'NoOp'};
var _CareerPlug$ats$AvailabilityPicker$update = F2(
	function (msg, model) {
		var _p19 = msg;
		switch (_p19.ctor) {
			case 'NoOp':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'AddSlot':
				var model_ = _CareerPlug$ats$AvailabilityPicker$saveCurrentSlot(model);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_CareerPlug$ats$AvailabilityPicker$saveCurrentSlot(
						_elm_lang$core$Native_Utils.update(
							model_,
							{
								slot: _elm_lang$core$Maybe$Just(_p19._0)
							})),
					{ctor: '[]'});
			case 'EditSlot':
				var _p20 = _p19._1;
				var model_ = _CareerPlug$ats$AvailabilityPicker$saveCurrentSlot(model);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model_,
						{
							slot: _elm_lang$core$Maybe$Just(_p20),
							grid: A2(_CareerPlug$ats$AvailabilityPicker$butSlot, _p20, model.grid),
							dragging: A2(_CareerPlug$ats$AvailabilityPicker$Dragging, _p19._0, _p19._2)
						}),
					{ctor: '[]'});
			case 'MoveSlot':
				var _p21 = {ctor: '_Tuple2', _0: model.slot, _1: model.dragging};
				if (((_p21.ctor === '_Tuple2') && (_p21._0.ctor === 'Just')) && (_p21._1.ctor === 'Dragging')) {
					var _p22 = A5(_CareerPlug$ats$AvailabilityPicker$moveSlot, model.grid, _p21._1._0, _p21._1._1, _p19._0, _p21._0._0);
					if (_p22.ctor === 'Just') {
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{
									slot: _elm_lang$core$Maybe$Just(_p22._0)
								}),
							{ctor: '[]'});
					} else {
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							model,
							{ctor: '[]'});
					}
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			case 'SaveSlot':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_CareerPlug$ats$AvailabilityPicker$saveCurrentSlot(
						_elm_lang$core$Native_Utils.update(
							model,
							{dragging: _CareerPlug$ats$AvailabilityPicker$NotDragging})),
					{ctor: '[]'});
			case 'RemoveSlot':
				var model_ = _CareerPlug$ats$AvailabilityPicker$saveCurrentSlot(model);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model_,
						{
							grid: A2(_CareerPlug$ats$AvailabilityPicker$butSlot, _p19._0, model.grid)
						}),
					{ctor: '[]'});
			case 'ScrollIntoView':
				var showY = function () {
					var _p23 = _elm_lang$core$List$minimum(
						A2(
							_elm_lang$core$List$map,
							function (s) {
								return s.start.hour;
							},
							model.grid));
					if (_p23.ctor === 'Just') {
						return A2(
							_elm_lang$core$Basics$max,
							(_elm_lang$core$Basics$toFloat(_p23._0) - 1.0) * 30.0,
							0.0);
					} else {
						return 240;
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Task$attempt,
							function (_p24) {
								return _CareerPlug$ats$AvailabilityPicker$NoOp;
							},
							A2(_elm_lang$dom$Dom_Scroll$toY, 'availability-scroll', showY)),
						_1: {ctor: '[]'}
					});
			default:
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$AvailabilityPicker$ScrollIntoView),
						_1: {ctor: '[]'}
					});
		}
	});
var _CareerPlug$ats$AvailabilityPicker$main = _elm_lang$html$Html$programWithFlags(
	{
		init: _CareerPlug$ats$AvailabilityPicker$init,
		update: _CareerPlug$ats$AvailabilityPicker$update,
		view: _CareerPlug$ats$AvailabilityPicker$view,
		subscriptions: function (_p25) {
			return _CareerPlug$ats$AvailabilityPicker$availPicker(_CareerPlug$ats$AvailabilityPicker$Inbound);
		}
	})(_elm_lang$core$Json_Decode$value);

var _CareerPlug$ats$Models_Common$optionsFromIdPairs = function (pairs) {
	var conv = function (pair) {
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Basics$toString(pair.id),
			_1: pair.name
		};
	};
	return A2(_elm_lang$core$List$map, conv, pairs);
};
var _CareerPlug$ats$Models_Common$jsonErrors = _elm_lang$core$Json_Decode$dict(
	_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
var _CareerPlug$ats$Models_Common$IdPair = F2(
	function (a, b) {
		return {id: a, name: b};
	});
var _CareerPlug$ats$Models_Common$jsonIdPair = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'name',
	_elm_lang$core$Json_Decode$string,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'id',
		_elm_lang$core$Json_Decode$int,
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_Common$IdPair)));

var _CareerPlug$ats$Models_MessageTemplate$MessageTemplate = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return {id: a, name: b, subject: c, body: d, account_id: e, action_event: f, enabled: g, primary: h, invite: i, invite_schedule: j, template_type: k, location: l, include_signature: m, appointment_config: n, attachments: o};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Models_MessageTemplate$Attachment = F5(
	function (a, b, c, d, e) {
		return {id: a, name: b, attachment: c, newRecord: d, destroy: e};
	});
var _CareerPlug$ats$Models_MessageTemplate$jsonAttachment = A2(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded,
	false,
	A2(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded,
		true,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'attachment',
			_elm_lang$core$Json_Decode$string,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'name',
				_elm_lang$core$Json_Decode$string,
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'id',
					_elm_lang$core$Json_Decode$int,
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_MessageTemplate$Attachment))))));
var _CareerPlug$ats$Models_MessageTemplate$AppointmentConfig = F3(
	function (a, b, c) {
		return {schedule_owner_id: a, expires_in: b, duration: c};
	});
var _CareerPlug$ats$Models_MessageTemplate$jsonAppointmentConfig = A2(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
	A2(
		_elm_lang$core$Json_Decode$field,
		'duration',
		_elm_lang$core$Json_Decode$oneOf(
			{
				ctor: '::',
				_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$int),
					_1: {ctor: '[]'}
				}
			})),
	A2(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
		A2(
			_elm_lang$core$Json_Decode$field,
			'expires_in',
			_elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$int),
						_1: {ctor: '[]'}
					}
				})),
		A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A2(
				_elm_lang$core$Json_Decode$field,
				'schedule_owner_id',
				_elm_lang$core$Json_Decode$oneOf(
					{
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$int),
							_1: {ctor: '[]'}
						}
					})),
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_MessageTemplate$AppointmentConfig))));
var _CareerPlug$ats$Models_MessageTemplate$SmsTemplate = {ctor: 'SmsTemplate'};
var _CareerPlug$ats$Models_MessageTemplate$EmailTemplate = {ctor: 'EmailTemplate'};
var _CareerPlug$ats$Models_MessageTemplate$templateTypeDecoder = A2(
	_elm_lang$core$Json_Decode$andThen,
	function (templateType) {
		var _p0 = templateType;
		switch (_p0) {
			case 'email':
				return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$Models_MessageTemplate$EmailTemplate);
			case 'sms':
				return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$Models_MessageTemplate$SmsTemplate);
			default:
				return _elm_lang$core$Json_Decode$fail(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'Unrecognized energy ',
						_elm_lang$core$Basics$toString(templateType)));
		}
	},
	_elm_lang$core$Json_Decode$string);
var _CareerPlug$ats$Models_MessageTemplate$jsonMessageTemplate = A2(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
	A2(
		_elm_lang$core$Json_Decode$field,
		'attachments',
		_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Models_MessageTemplate$jsonAttachment)),
	A2(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
		A2(_elm_lang$core$Json_Decode$field, 'appointment_config', _CareerPlug$ats$Models_MessageTemplate$jsonAppointmentConfig),
		A2(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
			A2(
				_elm_lang$core$Json_Decode$field,
				'include_signature',
				_elm_lang$core$Json_Decode$oneOf(
					{
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$null(false),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Json_Decode$bool,
							_1: {ctor: '[]'}
						}
					})),
			A2(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
				A2(
					_elm_lang$core$Json_Decode$field,
					'location',
					_elm_lang$core$Json_Decode$oneOf(
						{
							ctor: '::',
							_0: _elm_lang$core$Json_Decode$null(''),
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Json_Decode$string,
								_1: {ctor: '[]'}
							}
						})),
				A2(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
					A2(_elm_lang$core$Json_Decode$field, 'template_type', _CareerPlug$ats$Models_MessageTemplate$templateTypeDecoder),
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'invite_schedule',
						_elm_lang$core$Json_Decode$bool,
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'invite',
							_elm_lang$core$Json_Decode$bool,
							A3(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
								'primary',
								_elm_lang$core$Json_Decode$bool,
								A3(
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
									'enabled',
									_elm_lang$core$Json_Decode$bool,
									A2(
										_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
										A2(
											_elm_lang$core$Json_Decode$field,
											'action_event',
											_elm_lang$core$Json_Decode$oneOf(
												{
													ctor: '::',
													_0: _elm_lang$core$Json_Decode$null(''),
													_1: {
														ctor: '::',
														_0: _elm_lang$core$Json_Decode$string,
														_1: {ctor: '[]'}
													}
												})),
										A2(
											_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
											A2(
												_elm_lang$core$Json_Decode$field,
												'account_id',
												_elm_lang$core$Json_Decode$oneOf(
													{
														ctor: '::',
														_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
														_1: {
															ctor: '::',
															_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$int),
															_1: {ctor: '[]'}
														}
													})),
											A3(
												_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
												'body',
												_elm_lang$core$Json_Decode$string,
												A3(
													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
													'subject',
													_elm_lang$core$Json_Decode$string,
													A3(
														_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
														'name',
														_elm_lang$core$Json_Decode$string,
														A3(
															_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
															'id',
															_elm_lang$core$Json_Decode$int,
															_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_MessageTemplate$MessageTemplate))))))))))))))));

var _CareerPlug$ats$Email_Models_Activate$templateTypeDecoder = _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$Models_MessageTemplate$EmailTemplate);
var _CareerPlug$ats$Email_Models_Activate$Activate = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return {edit: a, to: b, subject: c, body: d, include_signature: e, location: f, event: g, commands: h, invite: i, invite_schedule: j, templates: k, template_type: l, interviewers: m, scorecards: n, title: o, timezone: p, interviewer: q, invite_expires_in: r, interview_duration: s};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Email_Models_Activate$jsonActivate = A4(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
	'interview_duration',
	_elm_lang$core$Json_Decode$string,
	'30',
	A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'invite_expires_in',
		_elm_lang$core$Json_Decode$string,
		'7',
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'interviewer',
			_elm_lang$core$Json_Decode$string,
			'',
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'timezone',
				_elm_lang$core$Json_Decode$string,
				'',
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'title',
					_elm_lang$core$Json_Decode$string,
					'Sending Email',
					A4(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
						'scorecards',
						_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Models_Common$jsonIdPair),
						{ctor: '[]'},
						A4(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
							'interviewers',
							_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Models_Common$jsonIdPair),
							{ctor: '[]'},
							A4(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
								'template_type',
								_CareerPlug$ats$Email_Models_Activate$templateTypeDecoder,
								_CareerPlug$ats$Models_MessageTemplate$EmailTemplate,
								A4(
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
									'templates',
									_elm_lang$core$Json_Decode$string,
									'',
									A4(
										_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
										'invite_schedule',
										_CareerPlug$ats$Library_Core$flexBoolDecoder(false),
										false,
										A4(
											_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
											'invite',
											_CareerPlug$ats$Library_Core$flexBoolDecoder(false),
											false,
											A4(
												_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
												'commands',
												_elm_lang$core$Json_Decode$string,
												'',
												A4(
													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
													'event',
													_elm_lang$core$Json_Decode$string,
													'',
													A4(
														_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
														'location',
														_elm_lang$core$Json_Decode$string,
														'',
														A4(
															_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
															'include_signature',
															_CareerPlug$ats$Library_Core$flexBoolDecoder(false),
															false,
															A4(
																_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																'body',
																_elm_lang$core$Json_Decode$string,
																'',
																A4(
																	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																	'subject',
																	_elm_lang$core$Json_Decode$string,
																	'',
																	A4(
																		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																		'to',
																		_elm_lang$core$Json_Decode$string,
																		'',
																		A4(
																			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																			'edit',
																			_elm_lang$core$Json_Decode$int,
																			0,
																			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Email_Models_Activate$Activate))))))))))))))))))));

var _CareerPlug$ats$Email_Models_Email$attAsJson = function (att) {
	var attID = att.newRecord ? _elm_lang$core$Json_Encode$null : _elm_lang$core$Json_Encode$int(att.id);
	return {
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'id', _1: attID},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'name',
				_1: _elm_lang$core$Json_Encode$string(att.name)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'attachment',
					_1: _elm_lang$core$Json_Encode$string(att.attachment)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: '_destroy',
						_1: _CareerPlug$ats$Library_Core$boolEncoder(att.destroy)
					},
					_1: {ctor: '[]'}
				}
			}
		}
	};
};
var _CareerPlug$ats$Email_Models_Email$encId = function (id) {
	var _p0 = id;
	if (_p0.ctor === 'Just') {
		return _elm_lang$core$Json_Encode$int(_p0._0);
	} else {
		return _elm_lang$core$Json_Encode$null;
	}
};
var _CareerPlug$ats$Email_Models_Email$emailAsJson = function (email) {
	var encAtts = function (atts) {
		return _elm_lang$core$Json_Encode$list(
			A2(
				_elm_lang$core$List$map,
				function (att) {
					return _elm_lang$core$Json_Encode$object(
						_CareerPlug$ats$Email_Models_Email$attAsJson(att));
				},
				atts));
	};
	return {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'id',
			_1: _CareerPlug$ats$Email_Models_Email$encId(email.id)
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'event',
				_1: _elm_lang$core$Json_Encode$string(email.event)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'commands',
					_1: _elm_lang$core$Json_Encode$string(email.commands)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'to',
						_1: _elm_lang$core$Json_Encode$string(email.to)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'subject',
							_1: _elm_lang$core$Json_Encode$string(email.subject)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'body',
								_1: _elm_lang$core$Json_Encode$string(email.body)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'copy',
									_1: _CareerPlug$ats$Library_Core$boolEncoder(email.copy)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'account_id',
										_1: _elm_lang$core$Json_Encode$int(email.account_id)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'invite',
											_1: _CareerPlug$ats$Library_Core$boolEncoder(email.invite)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'invite_schedule',
												_1: _CareerPlug$ats$Library_Core$boolEncoder(email.invite_schedule)
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'cc',
													_1: _elm_lang$core$Json_Encode$string(email.cc)
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'bcc',
														_1: _elm_lang$core$Json_Encode$string(email.bcc)
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'date',
															_1: _elm_lang$core$Json_Encode$string(email.date)
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '_Tuple2',
																_0: 'start_time',
																_1: _elm_lang$core$Json_Encode$string(email.start_time)
															},
															_1: {
																ctor: '::',
																_0: {
																	ctor: '_Tuple2',
																	_0: 'end_time',
																	_1: _elm_lang$core$Json_Encode$string(email.end_time)
																},
																_1: {
																	ctor: '::',
																	_0: {
																		ctor: '_Tuple2',
																		_0: 'timezone',
																		_1: _elm_lang$core$Json_Encode$string(email.timezone)
																	},
																	_1: {
																		ctor: '::',
																		_0: {
																			ctor: '_Tuple2',
																			_0: 'location',
																			_1: _elm_lang$core$Json_Encode$string(email.location)
																		},
																		_1: {
																			ctor: '::',
																			_0: {
																				ctor: '_Tuple2',
																				_0: 'interviewer_id',
																				_1: _elm_lang$core$Json_Encode$int(email.interviewer_id)
																			},
																			_1: {
																				ctor: '::',
																				_0: {
																					ctor: '_Tuple2',
																					_0: 'invite_expires_in',
																					_1: _elm_lang$core$Json_Encode$int(email.invite_expires_in)
																				},
																				_1: {
																					ctor: '::',
																					_0: {
																						ctor: '_Tuple2',
																						_0: 'interview_duration',
																						_1: _elm_lang$core$Json_Encode$int(email.interview_duration)
																					},
																					_1: {
																						ctor: '::',
																						_0: {
																							ctor: '_Tuple2',
																							_0: 'interview_future_days',
																							_1: _elm_lang$core$Json_Encode$int(email.interview_future_days)
																						},
																						_1: {
																							ctor: '::',
																							_0: {
																								ctor: '_Tuple2',
																								_0: 'share',
																								_1: _CareerPlug$ats$Library_Core$boolEncoder(email.share)
																							},
																							_1: {
																								ctor: '::',
																								_0: {
																									ctor: '_Tuple2',
																									_0: 'scorecard_id',
																									_1: _elm_lang$core$Json_Encode$int(email.scorecard_id)
																								},
																								_1: {
																									ctor: '::',
																									_0: {
																										ctor: '_Tuple2',
																										_0: 'include_signature',
																										_1: _CareerPlug$ats$Library_Core$boolEncoder(email.include_signature)
																									},
																									_1: {
																										ctor: '::',
																										_0: {
																											ctor: '_Tuple2',
																											_0: 'scheduled_date',
																											_1: _elm_lang$core$Json_Encode$string(email.scheduled_date)
																										},
																										_1: {
																											ctor: '::',
																											_0: {
																												ctor: '_Tuple2',
																												_0: 'scheduled_time',
																												_1: _elm_lang$core$Json_Encode$string(email.scheduled_time)
																											},
																											_1: {
																												ctor: '::',
																												_0: {
																													ctor: '_Tuple2',
																													_0: 'has_attachments_attributes',
																													_1: encAtts(email.attachments)
																												},
																												_1: {ctor: '[]'}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
};
var _CareerPlug$ats$Email_Models_Email$Email = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return function (_2) {
																												return function (_3) {
																													return {id: a, event: b, commands: c, to: d, subject: e, body: f, copy: g, account_id: h, invite: i, invite_schedule: j, cc: k, cc_list: l, bcc: m, bcc_list: n, date: o, start_time: p, end_time: q, timezone: r, location: s, interviewer_id: t, invite_expires_in: u, interview_duration: v, interview_future_days: w, share: x, scorecard_id: y, include_signature: z, scheduled_date: _1, scheduled_time: _2, attachments: _3};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Email_Models_Email$Recipient = F2(
	function (a, b) {
		return {id: a, name: b};
	});
var _CareerPlug$ats$Email_Models_Email$jsonRecipient = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'name',
	_elm_lang$core$Json_Decode$string,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'id',
		_elm_lang$core$Json_Decode$int,
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Email_Models_Email$Recipient)));
var _CareerPlug$ats$Email_Models_Email$Attachment = F5(
	function (a, b, c, d, e) {
		return {id: a, name: b, attachment: c, newRecord: d, destroy: e};
	});
var _CareerPlug$ats$Email_Models_Email$jsonAttachment = A2(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
	_elm_lang$core$Json_Decode$succeed(false),
	A2(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
		_elm_lang$core$Json_Decode$succeed(false),
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'attachment',
			_elm_lang$core$Json_Decode$string,
			'',
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'name',
				_elm_lang$core$Json_Decode$string,
				'',
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'id',
					_elm_lang$core$Json_Decode$int,
					0,
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Email_Models_Email$Attachment))))));
var _CareerPlug$ats$Email_Models_Email$jsonEmail = A2(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
	A2(
		_elm_lang$core$Json_Decode$field,
		'attachments',
		_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Email_Models_Email$jsonAttachment)),
	A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'scheduled_time',
		_elm_lang$core$Json_Decode$string,
		'',
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'scheduled_date',
			_elm_lang$core$Json_Decode$string,
			'',
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'include_signature',
				_elm_lang$core$Json_Decode$bool,
				false,
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'scorecard_id',
					_elm_lang$core$Json_Decode$int,
					0,
					A4(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
						'share',
						_elm_lang$core$Json_Decode$bool,
						false,
						A4(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
							'interview_future_days',
							_elm_lang$core$Json_Decode$int,
							14,
							A4(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
								'interview_duration',
								_elm_lang$core$Json_Decode$int,
								30,
								A4(
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
									'invite_expires_in',
									_elm_lang$core$Json_Decode$int,
									7,
									A4(
										_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
										'interviewer_id',
										_elm_lang$core$Json_Decode$int,
										0,
										A4(
											_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
											'location',
											_elm_lang$core$Json_Decode$string,
											'',
											A4(
												_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
												'timezone',
												_elm_lang$core$Json_Decode$string,
												'',
												A4(
													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
													'end_time',
													_elm_lang$core$Json_Decode$string,
													'',
													A4(
														_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
														'start_time',
														_elm_lang$core$Json_Decode$string,
														'',
														A4(
															_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
															'date',
															_elm_lang$core$Json_Decode$string,
															'',
															A2(
																_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
																A2(
																	_elm_lang$core$Json_Decode$field,
																	'bcc_list',
																	_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Email_Models_Email$jsonRecipient)),
																A4(
																	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																	'bcc',
																	_elm_lang$core$Json_Decode$string,
																	'',
																	A2(
																		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
																		A2(
																			_elm_lang$core$Json_Decode$field,
																			'cc_list',
																			_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Email_Models_Email$jsonRecipient)),
																		A4(
																			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																			'cc',
																			_elm_lang$core$Json_Decode$string,
																			'',
																			A4(
																				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																				'invite_schedule',
																				_elm_lang$core$Json_Decode$bool,
																				false,
																				A4(
																					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																					'invite',
																					_elm_lang$core$Json_Decode$bool,
																					false,
																					A4(
																						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																						'account_id',
																						_elm_lang$core$Json_Decode$int,
																						0,
																						A4(
																							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																							'copy',
																							_elm_lang$core$Json_Decode$bool,
																							false,
																							A3(
																								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
																								'body',
																								_elm_lang$core$Json_Decode$string,
																								A3(
																									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
																									'subject',
																									_elm_lang$core$Json_Decode$string,
																									A4(
																										_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																										'to',
																										_elm_lang$core$Json_Decode$string,
																										'',
																										A2(
																											_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded,
																											'',
																											A4(
																												_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																												'event',
																												_elm_lang$core$Json_Decode$string,
																												'',
																												A2(
																													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$custom,
																													_elm_lang$core$Json_Decode$maybe(
																														A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int)),
																													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Email_Models_Email$Email))))))))))))))))))))))))))))));

var _CareerPlug$ats$Email_Models_ExternalForm$externalFormAsJson = function (extForm) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'body',
				_1: _elm_lang$core$Json_Encode$string(extForm.body)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'date',
					_1: _elm_lang$core$Json_Encode$string(extForm.date)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'startTime',
						_1: _elm_lang$core$Json_Encode$string(extForm.startTime)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'endTime',
							_1: _elm_lang$core$Json_Encode$string(extForm.endTime)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'scheduleDate',
								_1: _elm_lang$core$Json_Encode$string(extForm.scheduleDate)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'scheduleTime',
									_1: _elm_lang$core$Json_Encode$string(extForm.scheduleTime)
								},
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		});
};
var _CareerPlug$ats$Email_Models_ExternalForm$fieldValid = function (f) {
	return _elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(f),
		0) > 0;
};
var _CareerPlug$ats$Email_Models_ExternalForm$valid = F2(
	function (model, fields) {
		var schedFields = model.scheduling ? (_CareerPlug$ats$Email_Models_ExternalForm$fieldValid(fields.scheduleDate) && _CareerPlug$ats$Email_Models_ExternalForm$fieldValid(fields.scheduleTime)) : true;
		var inviteFields = model.invite ? (_CareerPlug$ats$Email_Models_ExternalForm$fieldValid(fields.date) && (_CareerPlug$ats$Email_Models_ExternalForm$fieldValid(fields.startTime) && _CareerPlug$ats$Email_Models_ExternalForm$fieldValid(fields.endTime))) : true;
		return inviteFields && (schedFields && _CareerPlug$ats$Email_Models_ExternalForm$fieldValid(fields.body));
	});
var _CareerPlug$ats$Email_Models_ExternalForm$blankExternalForm = {body: '', date: '', startTime: '', endTime: '', scheduleDate: '', scheduleTime: ''};
var _CareerPlug$ats$Email_Models_ExternalForm$ExternalForm = F6(
	function (a, b, c, d, e, f) {
		return {body: a, date: b, startTime: c, endTime: d, scheduleDate: e, scheduleTime: f};
	});

var _CareerPlug$ats$Email_Models_RelatedApp$blankRelatedApp = {name: '', score: ''};
var _CareerPlug$ats$Email_Models_RelatedApp$RelatedApp = F2(
	function (a, b) {
		return {name: a, score: b};
	});
var _CareerPlug$ats$Email_Models_RelatedApp$jsonRelatedApp = A4(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
	'score',
	_elm_lang$core$Json_Decode$string,
	'',
	A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'name',
		_elm_lang$core$Json_Decode$string,
		'',
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Email_Models_RelatedApp$RelatedApp)));

var _elm_lang$html$Html_Keyed$node = _elm_lang$virtual_dom$VirtualDom$keyedNode;
var _elm_lang$html$Html_Keyed$ol = _elm_lang$html$Html_Keyed$node('ol');
var _elm_lang$html$Html_Keyed$ul = _elm_lang$html$Html_Keyed$node('ul');

var _elm_lang$keyboard$Keyboard$onSelfMsg = F3(
	function (router, _p0, state) {
		var _p1 = _p0;
		var _p2 = A2(_elm_lang$core$Dict$get, _p1.category, state);
		if (_p2.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var send = function (tagger) {
				return A2(
					_elm_lang$core$Platform$sendToApp,
					router,
					tagger(_p1.keyCode));
			};
			return A2(
				_elm_lang$core$Task$andThen,
				function (_p3) {
					return _elm_lang$core$Task$succeed(state);
				},
				_elm_lang$core$Task$sequence(
					A2(_elm_lang$core$List$map, send, _p2._0.taggers)));
		}
	});
var _elm_lang$keyboard$Keyboard_ops = _elm_lang$keyboard$Keyboard_ops || {};
_elm_lang$keyboard$Keyboard_ops['&>'] = F2(
	function (task1, task2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p4) {
				return task2;
			},
			task1);
	});
var _elm_lang$keyboard$Keyboard$init = _elm_lang$core$Task$succeed(_elm_lang$core$Dict$empty);
var _elm_lang$keyboard$Keyboard$categorizeHelpHelp = F2(
	function (value, maybeValues) {
		var _p5 = maybeValues;
		if (_p5.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Just(
				{
					ctor: '::',
					_0: value,
					_1: {ctor: '[]'}
				});
		} else {
			return _elm_lang$core$Maybe$Just(
				{ctor: '::', _0: value, _1: _p5._0});
		}
	});
var _elm_lang$keyboard$Keyboard$categorizeHelp = F2(
	function (subs, subDict) {
		categorizeHelp:
		while (true) {
			var _p6 = subs;
			if (_p6.ctor === '[]') {
				return subDict;
			} else {
				var _v4 = _p6._1,
					_v5 = A3(
					_elm_lang$core$Dict$update,
					_p6._0._0,
					_elm_lang$keyboard$Keyboard$categorizeHelpHelp(_p6._0._1),
					subDict);
				subs = _v4;
				subDict = _v5;
				continue categorizeHelp;
			}
		}
	});
var _elm_lang$keyboard$Keyboard$categorize = function (subs) {
	return A2(_elm_lang$keyboard$Keyboard$categorizeHelp, subs, _elm_lang$core$Dict$empty);
};
var _elm_lang$keyboard$Keyboard$keyCode = A2(_elm_lang$core$Json_Decode$field, 'keyCode', _elm_lang$core$Json_Decode$int);
var _elm_lang$keyboard$Keyboard$subscription = _elm_lang$core$Native_Platform.leaf('Keyboard');
var _elm_lang$keyboard$Keyboard$Watcher = F2(
	function (a, b) {
		return {taggers: a, pid: b};
	});
var _elm_lang$keyboard$Keyboard$Msg = F2(
	function (a, b) {
		return {category: a, keyCode: b};
	});
var _elm_lang$keyboard$Keyboard$onEffects = F3(
	function (router, newSubs, oldState) {
		var rightStep = F3(
			function (category, taggers, task) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (state) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (pid) {
								return _elm_lang$core$Task$succeed(
									A3(
										_elm_lang$core$Dict$insert,
										category,
										A2(_elm_lang$keyboard$Keyboard$Watcher, taggers, pid),
										state));
							},
							_elm_lang$core$Process$spawn(
								A3(
									_elm_lang$dom$Dom_LowLevel$onDocument,
									category,
									_elm_lang$keyboard$Keyboard$keyCode,
									function (_p7) {
										return A2(
											_elm_lang$core$Platform$sendToSelf,
											router,
											A2(_elm_lang$keyboard$Keyboard$Msg, category, _p7));
									})));
					},
					task);
			});
		var bothStep = F4(
			function (category, _p8, taggers, task) {
				var _p9 = _p8;
				return A2(
					_elm_lang$core$Task$map,
					A2(
						_elm_lang$core$Dict$insert,
						category,
						A2(_elm_lang$keyboard$Keyboard$Watcher, taggers, _p9.pid)),
					task);
			});
		var leftStep = F3(
			function (category, _p10, task) {
				var _p11 = _p10;
				return A2(
					_elm_lang$keyboard$Keyboard_ops['&>'],
					_elm_lang$core$Process$kill(_p11.pid),
					task);
			});
		return A6(
			_elm_lang$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			oldState,
			_elm_lang$keyboard$Keyboard$categorize(newSubs),
			_elm_lang$core$Task$succeed(_elm_lang$core$Dict$empty));
	});
var _elm_lang$keyboard$Keyboard$MySub = F2(
	function (a, b) {
		return {ctor: 'MySub', _0: a, _1: b};
	});
var _elm_lang$keyboard$Keyboard$presses = function (tagger) {
	return _elm_lang$keyboard$Keyboard$subscription(
		A2(_elm_lang$keyboard$Keyboard$MySub, 'keypress', tagger));
};
var _elm_lang$keyboard$Keyboard$downs = function (tagger) {
	return _elm_lang$keyboard$Keyboard$subscription(
		A2(_elm_lang$keyboard$Keyboard$MySub, 'keydown', tagger));
};
var _elm_lang$keyboard$Keyboard$ups = function (tagger) {
	return _elm_lang$keyboard$Keyboard$subscription(
		A2(_elm_lang$keyboard$Keyboard$MySub, 'keyup', tagger));
};
var _elm_lang$keyboard$Keyboard$subMap = F2(
	function (func, _p12) {
		var _p13 = _p12;
		return A2(
			_elm_lang$keyboard$Keyboard$MySub,
			_p13._0,
			function (_p14) {
				return func(
					_p13._1(_p14));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Keyboard'] = {pkg: 'elm-lang/keyboard', init: _elm_lang$keyboard$Keyboard$init, onEffects: _elm_lang$keyboard$Keyboard$onEffects, onSelfMsg: _elm_lang$keyboard$Keyboard$onSelfMsg, tag: 'sub', subMap: _elm_lang$keyboard$Keyboard$subMap};

var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$sectionConfig = function (_p0) {
	var _p1 = _p0;
	return {toId: _p1.toId, getData: _p1.getData, ul: _p1.ul, li: _p1.li};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewWithSectionsConfig = function (_p2) {
	var _p3 = _p2;
	return {toId: _p3.toId, ul: _p3.ul, li: _p3.li, section: _p3.section};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewConfig = function (_p4) {
	var _p5 = _p4;
	return {toId: _p5.toId, ul: _p5.ul, li: _p5.li};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$getPrevious = F3(
	function (id, selectedId, resultId) {
		return _elm_lang$core$Native_Utils.eq(selectedId, id) ? _elm_lang$core$Maybe$Just(id) : (_elm_lang$core$Native_Utils.eq(
			A2(_elm_lang$core$Maybe$withDefault, '', resultId),
			id) ? _elm_lang$core$Maybe$Just(selectedId) : resultId);
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$getNextItemId = F2(
	function (ids, selectedId) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			selectedId,
			A3(
				_elm_lang$core$List$foldl,
				_thebritican$elm_autocomplete$Autocomplete_Autocomplete$getPrevious(selectedId),
				_elm_lang$core$Maybe$Nothing,
				ids));
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$getPreviousItemId = F2(
	function (ids, selectedId) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			selectedId,
			A3(
				_elm_lang$core$List$foldr,
				_thebritican$elm_autocomplete$Autocomplete_Autocomplete$getPrevious(selectedId),
				_elm_lang$core$Maybe$Nothing,
				ids));
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$navigateWithKey = F3(
	function (code, ids, maybeId) {
		var _p6 = code;
		switch (_p6) {
			case 38:
				return A2(
					_elm_lang$core$Maybe$map,
					_thebritican$elm_autocomplete$Autocomplete_Autocomplete$getPreviousItemId(ids),
					maybeId);
			case 40:
				return A2(
					_elm_lang$core$Maybe$map,
					_thebritican$elm_autocomplete$Autocomplete_Autocomplete$getNextItemId(ids),
					maybeId);
			default:
				return maybeId;
		}
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetMouseStateWithId = F3(
	function (separateSelections, id, state) {
		return separateSelections ? {
			key: state.key,
			mouse: _elm_lang$core$Maybe$Just(id)
		} : {
			key: _elm_lang$core$Maybe$Just(id),
			mouse: _elm_lang$core$Maybe$Just(id)
		};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$updateConfig = function (_p7) {
	var _p8 = _p7;
	return {toId: _p8.toId, onKeyDown: _p8.onKeyDown, onTooLow: _p8.onTooLow, onTooHigh: _p8.onTooHigh, onMouseEnter: _p8.onMouseEnter, onMouseLeave: _p8.onMouseLeave, onMouseClick: _p8.onMouseClick, separateSelections: _p8.separateSelections};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$empty = {key: _elm_lang$core$Maybe$Nothing, mouse: _elm_lang$core$Maybe$Nothing};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$reset = F2(
	function (_p10, _p9) {
		var _p11 = _p10;
		var _p12 = _p9;
		return _p11.separateSelections ? {key: _elm_lang$core$Maybe$Nothing, mouse: _p12.mouse} : _thebritican$elm_autocomplete$Autocomplete_Autocomplete$empty;
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToFirst = F3(
	function (config, data, state) {
		var _p13 = config;
		var toId = _p13.toId;
		var separateSelections = _p13.separateSelections;
		var setFirstItem = F2(
			function (datum, newState) {
				return _elm_lang$core$Native_Utils.update(
					newState,
					{
						key: _elm_lang$core$Maybe$Just(
							toId(datum))
					});
			});
		var _p14 = _elm_lang$core$List$head(data);
		if (_p14.ctor === 'Nothing') {
			return _thebritican$elm_autocomplete$Autocomplete_Autocomplete$empty;
		} else {
			var _p15 = _p14._0;
			return separateSelections ? A2(
				setFirstItem,
				_p15,
				A2(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$reset, config, state)) : A2(setFirstItem, _p15, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$empty);
		}
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToFirstItem = F4(
	function (config, data, howManyToShow, state) {
		return A3(
			_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToFirst,
			config,
			A2(_elm_lang$core$List$take, howManyToShow, data),
			state);
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToLastItem = F4(
	function (config, data, howManyToShow, state) {
		var reversedData = _elm_lang$core$List$reverse(
			A2(_elm_lang$core$List$take, howManyToShow, data));
		return A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToFirst, config, reversedData, state);
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$State = F2(
	function (a, b) {
		return {key: a, mouse: b};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$UpdateConfig = F8(
	function (a, b, c, d, e, f, g, h) {
		return {onKeyDown: a, onTooLow: b, onTooHigh: c, onMouseEnter: d, onMouseLeave: e, onMouseClick: f, toId: g, separateSelections: h};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$HtmlDetails = F2(
	function (a, b) {
		return {attributes: a, children: b};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$ViewConfig = F3(
	function (a, b, c) {
		return {toId: a, ul: b, li: c};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$ViewWithSectionsConfig = F4(
	function (a, b, c, d) {
		return {toId: a, ul: b, li: c, section: d};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$SectionConfig = F4(
	function (a, b, c, d) {
		return {toId: a, getData: b, ul: c, li: d};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$SectionNode = F3(
	function (a, b, c) {
		return {nodeType: a, attributes: b, children: c};
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$NoOp = {ctor: 'NoOp'};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg = function (msg) {
	return A2(
		_elm_lang$html$Html_Attributes$map,
		function (_p16) {
			return _thebritican$elm_autocomplete$Autocomplete_Autocomplete$NoOp;
		},
		msg);
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseClick = function (a) {
	return {ctor: 'MouseClick', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseLeave = function (a) {
	return {ctor: 'MouseLeave', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseEnter = function (a) {
	return {ctor: 'MouseEnter', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewData = F3(
	function (_p18, _p17, data) {
		var _p19 = _p18;
		var _p20 = _p17;
		var id = _p19.toId(data);
		var isSelected = function (maybeId) {
			var _p21 = maybeId;
			if (_p21.ctor === 'Just') {
				return _elm_lang$core$Native_Utils.eq(_p21._0, id);
			} else {
				return false;
			}
		};
		var listItemData = A3(
			_p19.li,
			isSelected(_p20.key),
			isSelected(_p20.mouse),
			data);
		var customAttributes = A2(_elm_lang$core$List$map, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg, listItemData.attributes);
		var customLiAttr = A2(
			_elm_lang$core$List$append,
			customAttributes,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onMouseEnter(
					_thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseEnter(id)),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onMouseLeave(
						_thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseLeave(id)),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseClick(id)),
						_1: {ctor: '[]'}
					}
				}
			});
		return A2(
			_elm_lang$html$Html$li,
			customLiAttr,
			A2(
				_elm_lang$core$List$map,
				_elm_lang$html$Html$map(
					function (html) {
						return _thebritican$elm_autocomplete$Autocomplete_Autocomplete$NoOp;
					}),
				listItemData.children));
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewSection = F3(
	function (config, state, section) {
		var getKeyedItems = function (datum) {
			return {
				ctor: '_Tuple2',
				_0: config.toId(datum),
				_1: A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewData, config, state, datum)
			};
		};
		var viewItemList = A2(
			_elm_lang$html$Html_Keyed$ul,
			A2(_elm_lang$core$List$map, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg, config.ul),
			A2(
				_elm_lang$core$List$map,
				getKeyedItems,
				config.section.getData(section)));
		var sectionNode = config.section.li(section);
		var attributes = A2(_elm_lang$core$List$map, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg, sectionNode.attributes);
		var customChildren = A2(
			_elm_lang$core$List$map,
			_elm_lang$html$Html$map(
				function (html) {
					return _thebritican$elm_autocomplete$Autocomplete_Autocomplete$NoOp;
				}),
			sectionNode.children);
		var children = A2(
			_elm_lang$core$List$append,
			customChildren,
			{
				ctor: '::',
				_0: viewItemList,
				_1: {ctor: '[]'}
			});
		return A2(
			_elm_lang$html$Html$li,
			attributes,
			{
				ctor: '::',
				_0: A3(_elm_lang$html$Html$node, sectionNode.nodeType, attributes, children),
				_1: {ctor: '[]'}
			});
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewWithSections = F4(
	function (config, howManyToShow, state, sections) {
		var getKeyedItems = function (section) {
			return {
				ctor: '_Tuple2',
				_0: config.section.toId(section),
				_1: A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewSection, config, state, section)
			};
		};
		return A2(
			_elm_lang$html$Html_Keyed$ul,
			A2(_elm_lang$core$List$map, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg, config.section.ul),
			A2(_elm_lang$core$List$map, getKeyedItems, sections));
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewItem = F3(
	function (_p23, _p22, data) {
		var _p24 = _p23;
		var _p25 = _p22;
		var id = _p24.toId(data);
		var isSelected = function (maybeId) {
			var _p26 = maybeId;
			if (_p26.ctor === 'Just') {
				return _elm_lang$core$Native_Utils.eq(_p26._0, id);
			} else {
				return false;
			}
		};
		var listItemData = A3(
			_p24.li,
			isSelected(_p25.key),
			isSelected(_p25.mouse),
			data);
		var customAttributes = A2(_elm_lang$core$List$map, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg, listItemData.attributes);
		var customLiAttr = A2(
			_elm_lang$core$List$append,
			customAttributes,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onMouseEnter(
					_thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseEnter(id)),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onMouseLeave(
						_thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseLeave(id)),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_thebritican$elm_autocomplete$Autocomplete_Autocomplete$MouseClick(id)),
						_1: {ctor: '[]'}
					}
				}
			});
		return A2(
			_elm_lang$html$Html$li,
			customLiAttr,
			A2(
				_elm_lang$core$List$map,
				_elm_lang$html$Html$map(
					function (html) {
						return _thebritican$elm_autocomplete$Autocomplete_Autocomplete$NoOp;
					}),
				listItemData.children));
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewList = F4(
	function (config, howManyToShow, state, data) {
		var getKeyedItems = function (datum) {
			return {
				ctor: '_Tuple2',
				_0: config.toId(datum),
				_1: A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewItem, config, state, datum)
			};
		};
		var customUlAttr = A2(_elm_lang$core$List$map, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$mapNeverToMsg, config.ul);
		return A2(
			_elm_lang$html$Html_Keyed$ul,
			customUlAttr,
			A2(
				_elm_lang$core$List$map,
				getKeyedItems,
				A2(_elm_lang$core$List$take, howManyToShow, data)));
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$view = F4(
	function (config, howManyToShow, state, data) {
		return A4(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewList, config, howManyToShow, state, data);
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$WentTooHigh = {ctor: 'WentTooHigh'};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$WentTooLow = {ctor: 'WentTooLow'};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$update = F5(
	function (config, msg, howManyToShow, state, data) {
		update:
		while (true) {
			var _p27 = msg;
			switch (_p27.ctor) {
				case 'KeyDown':
					var _p28 = _p27._0;
					var boundedList = A2(
						_elm_lang$core$List$take,
						howManyToShow,
						A2(_elm_lang$core$List$map, config.toId, data));
					var newKey = A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$navigateWithKey, _p28, boundedList, state.key);
					if (_elm_lang$core$Native_Utils.eq(newKey, state.key) && _elm_lang$core$Native_Utils.eq(_p28, 38)) {
						var _v15 = config,
							_v16 = _thebritican$elm_autocomplete$Autocomplete_Autocomplete$WentTooHigh,
							_v17 = howManyToShow,
							_v18 = state,
							_v19 = data;
						config = _v15;
						msg = _v16;
						howManyToShow = _v17;
						state = _v18;
						data = _v19;
						continue update;
					} else {
						if (_elm_lang$core$Native_Utils.eq(newKey, state.key) && _elm_lang$core$Native_Utils.eq(_p28, 40)) {
							var _v20 = config,
								_v21 = _thebritican$elm_autocomplete$Autocomplete_Autocomplete$WentTooLow,
								_v22 = howManyToShow,
								_v23 = state,
								_v24 = data;
							config = _v20;
							msg = _v21;
							howManyToShow = _v22;
							state = _v23;
							data = _v24;
							continue update;
						} else {
							if (config.separateSelections) {
								return {
									ctor: '_Tuple2',
									_0: _elm_lang$core$Native_Utils.update(
										state,
										{key: newKey}),
									_1: A2(config.onKeyDown, _p28, newKey)
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: {key: newKey, mouse: newKey},
									_1: A2(config.onKeyDown, _p28, newKey)
								};
							}
						}
					}
				case 'WentTooLow':
					return {ctor: '_Tuple2', _0: state, _1: config.onTooLow};
				case 'WentTooHigh':
					return {ctor: '_Tuple2', _0: state, _1: config.onTooHigh};
				case 'MouseEnter':
					var _p29 = _p27._0;
					return {
						ctor: '_Tuple2',
						_0: A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetMouseStateWithId, config.separateSelections, _p29, state),
						_1: config.onMouseEnter(_p29)
					};
				case 'MouseLeave':
					var _p30 = _p27._0;
					return {
						ctor: '_Tuple2',
						_0: A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetMouseStateWithId, config.separateSelections, _p30, state),
						_1: config.onMouseLeave(_p30)
					};
				case 'MouseClick':
					var _p31 = _p27._0;
					return {
						ctor: '_Tuple2',
						_0: A3(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetMouseStateWithId, config.separateSelections, _p31, state),
						_1: config.onMouseClick(_p31)
					};
				default:
					return {ctor: '_Tuple2', _0: state, _1: _elm_lang$core$Maybe$Nothing};
			}
		}
	});
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$KeyDown = function (a) {
	return {ctor: 'KeyDown', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete_Autocomplete$subscription = _elm_lang$keyboard$Keyboard$downs(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$KeyDown);

var _thebritican$elm_autocomplete$Autocomplete$HtmlDetails = F2(
	function (a, b) {
		return {attributes: a, children: b};
	});
var _thebritican$elm_autocomplete$Autocomplete$SectionNode = F3(
	function (a, b, c) {
		return {nodeType: a, attributes: b, children: c};
	});
var _thebritican$elm_autocomplete$Autocomplete$State = function (a) {
	return {ctor: 'State', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete$empty = _thebritican$elm_autocomplete$Autocomplete$State(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$empty);
var _thebritican$elm_autocomplete$Autocomplete$reset = F2(
	function (_p1, _p0) {
		var _p2 = _p1;
		var _p3 = _p0;
		return _thebritican$elm_autocomplete$Autocomplete$State(
			A2(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$reset, _p2._0, _p3._0));
	});
var _thebritican$elm_autocomplete$Autocomplete$resetToFirstItem = F4(
	function (_p5, data, howManyToShow, _p4) {
		var _p6 = _p5;
		var _p7 = _p4;
		return _thebritican$elm_autocomplete$Autocomplete$State(
			A4(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToFirstItem, _p6._0, data, howManyToShow, _p7._0));
	});
var _thebritican$elm_autocomplete$Autocomplete$resetToLastItem = F4(
	function (_p9, data, howManyToShow, _p8) {
		var _p10 = _p9;
		var _p11 = _p8;
		return _thebritican$elm_autocomplete$Autocomplete$State(
			A4(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$resetToLastItem, _p10._0, data, howManyToShow, _p11._0));
	});
var _thebritican$elm_autocomplete$Autocomplete$update = F5(
	function (_p14, _p13, howManyToShow, _p12, data) {
		var _p15 = _p14;
		var _p16 = _p13;
		var _p17 = _p12;
		var _p18 = A5(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$update, _p15._0, _p16._0, howManyToShow, _p17._0, data);
		var newState = _p18._0;
		var maybeMsg = _p18._1;
		return {
			ctor: '_Tuple2',
			_0: _thebritican$elm_autocomplete$Autocomplete$State(newState),
			_1: maybeMsg
		};
	});
var _thebritican$elm_autocomplete$Autocomplete$Msg = function (a) {
	return {ctor: 'Msg', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete$subscription = A2(_elm_lang$core$Platform_Sub$map, _thebritican$elm_autocomplete$Autocomplete$Msg, _thebritican$elm_autocomplete$Autocomplete_Autocomplete$subscription);
var _thebritican$elm_autocomplete$Autocomplete$view = F4(
	function (_p20, howManyToShow, _p19, data) {
		var _p21 = _p20;
		var _p22 = _p19;
		return A2(
			_elm_lang$html$Html$map,
			_thebritican$elm_autocomplete$Autocomplete$Msg,
			A4(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$view, _p21._0, howManyToShow, _p22._0, data));
	});
var _thebritican$elm_autocomplete$Autocomplete$viewWithSections = F4(
	function (_p24, howManyToShow, _p23, sections) {
		var _p25 = _p24;
		var _p26 = _p23;
		return A2(
			_elm_lang$html$Html$map,
			_thebritican$elm_autocomplete$Autocomplete$Msg,
			A4(_thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewWithSections, _p25._0, howManyToShow, _p26._0, sections));
	});
var _thebritican$elm_autocomplete$Autocomplete$UpdateConfig = function (a) {
	return {ctor: 'UpdateConfig', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete$updateConfig = function (config) {
	return _thebritican$elm_autocomplete$Autocomplete$UpdateConfig(
		_thebritican$elm_autocomplete$Autocomplete_Autocomplete$updateConfig(config));
};
var _thebritican$elm_autocomplete$Autocomplete$ViewConfig = function (a) {
	return {ctor: 'ViewConfig', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete$viewConfig = function (config) {
	return _thebritican$elm_autocomplete$Autocomplete$ViewConfig(
		_thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewConfig(config));
};
var _thebritican$elm_autocomplete$Autocomplete$ViewWithSectionsConfig = function (a) {
	return {ctor: 'ViewWithSectionsConfig', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete$viewWithSectionsConfig = function (config) {
	return _thebritican$elm_autocomplete$Autocomplete$ViewWithSectionsConfig(
		function () {
			var _p27 = config.section;
			return _thebritican$elm_autocomplete$Autocomplete_Autocomplete$viewWithSectionsConfig(
				_elm_lang$core$Native_Utils.update(
					config,
					{section: _p27._0}));
		}());
};
var _thebritican$elm_autocomplete$Autocomplete$SectionConfig = function (a) {
	return {ctor: 'SectionConfig', _0: a};
};
var _thebritican$elm_autocomplete$Autocomplete$sectionConfig = function (section) {
	return _thebritican$elm_autocomplete$Autocomplete$SectionConfig(
		_thebritican$elm_autocomplete$Autocomplete_Autocomplete$sectionConfig(section));
};

var _CareerPlug$ats$Features_Autocomplete_Message$translator = F2(
	function (_p0, msg) {
		var _p1 = _p0;
		var _p2 = msg;
		if (_p2.ctor === 'ForSelf') {
			return _p1.onInternalMessage(_p2._0);
		} else {
			return A2(_p1.onUpdated, _p2._0._0, _p2._0._1);
		}
	});
var _CareerPlug$ats$Features_Autocomplete_Message$TranslationDictionary = F2(
	function (a, b) {
		return {onInternalMessage: a, onUpdated: b};
	});
var _CareerPlug$ats$Features_Autocomplete_Message$NoOp = {ctor: 'NoOp'};
var _CareerPlug$ats$Features_Autocomplete_Message$OnEnter = {ctor: 'OnEnter'};
var _CareerPlug$ats$Features_Autocomplete_Message$OnBlur = {ctor: 'OnBlur'};
var _CareerPlug$ats$Features_Autocomplete_Message$OnFocus = {ctor: 'OnFocus'};
var _CareerPlug$ats$Features_Autocomplete_Message$PreviewItem = function (a) {
	return {ctor: 'PreviewItem', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$SelectItemMouse = function (a) {
	return {ctor: 'SelectItemMouse', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$SelectItemKeyboard = function (a) {
	return {ctor: 'SelectItemKeyboard', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$HandleEscape = {ctor: 'HandleEscape'};
var _CareerPlug$ats$Features_Autocomplete_Message$Reset = {ctor: 'Reset'};
var _CareerPlug$ats$Features_Autocomplete_Message$Wrap = function (a) {
	return {ctor: 'Wrap', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$SetAutoState = function (a) {
	return {ctor: 'SetAutoState', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$SetQuery = function (a) {
	return {ctor: 'SetQuery', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$Commit = {ctor: 'Commit'};
var _CareerPlug$ats$Features_Autocomplete_Message$Escape = {ctor: 'Escape'};
var _CareerPlug$ats$Features_Autocomplete_Message$Updated = F2(
	function (a, b) {
		return {ctor: 'Updated', _0: a, _1: b};
	});
var _CareerPlug$ats$Features_Autocomplete_Message$ForParent = function (a) {
	return {ctor: 'ForParent', _0: a};
};
var _CareerPlug$ats$Features_Autocomplete_Message$ForSelf = function (a) {
	return {ctor: 'ForSelf', _0: a};
};

var _etaque$elm_form$Form_Tree$updateListAtIndex = F2(
	function (index, updater) {
		return _elm_lang$core$List$indexedMap(
			F2(
				function (i, f) {
					return _elm_lang$core$Native_Utils.eq(i, index) ? updater(f) : f;
				}));
	});
var _etaque$elm_form$Form_Tree$asList = function (value) {
	var _p0 = value;
	if (_p0.ctor === 'List') {
		return _p0._0;
	} else {
		return {ctor: '[]'};
	}
};
var _etaque$elm_form$Form_Tree$asValue = function (node) {
	var _p1 = node;
	if (_p1.ctor === 'Value') {
		return _elm_lang$core$Maybe$Just(_p1._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _etaque$elm_form$Form_Tree$valuesWithPath = function (tree) {
	var mapGroupItem = F2(
		function (path, _p2) {
			var _p3 = _p2;
			return A2(
				walkTree,
				A2(
					_elm_lang$core$Basics_ops['++'],
					path,
					{
						ctor: '::',
						_0: _p3._0,
						_1: {ctor: '[]'}
					}),
				_p3._1);
		});
	var walkTree = F2(
		function (path, value) {
			var _p4 = value;
			switch (_p4.ctor) {
				case 'Group':
					return A2(
						_elm_lang$core$List$concatMap,
						mapGroupItem(path),
						_elm_lang$core$Dict$toList(_p4._0));
				case 'List':
					return A2(
						_elm_lang$core$List$concatMap,
						mapGroupItem(path),
						A2(
							_elm_lang$core$List$indexedMap,
							F2(
								function (index, item) {
									return {
										ctor: '_Tuple2',
										_0: _elm_lang$core$Basics$toString(index),
										_1: item
									};
								}),
							_p4._0));
				default:
					return {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: A2(_elm_lang$core$String$join, '.', path),
							_1: _p4._0
						},
						_1: {ctor: '[]'}
					};
			}
		});
	return A2(
		walkTree,
		{ctor: '[]'},
		tree);
};
var _etaque$elm_form$Form_Tree$getAtIndex = F2(
	function (index, value) {
		return _elm_lang$core$List$head(
			A2(
				_elm_lang$core$List$drop,
				index,
				_etaque$elm_form$Form_Tree$asList(value)));
	});
var _etaque$elm_form$Form_Tree$getAtName = F2(
	function (name, value) {
		var _p5 = value;
		if (_p5.ctor === 'Group') {
			return A2(_elm_lang$core$Dict$get, name, _p5._0);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _etaque$elm_form$Form_Tree$Value = function (a) {
	return {ctor: 'Value', _0: a};
};
var _etaque$elm_form$Form_Tree$List = function (a) {
	return {ctor: 'List', _0: a};
};
var _etaque$elm_form$Form_Tree$Group = function (a) {
	return {ctor: 'Group', _0: a};
};
var _etaque$elm_form$Form_Tree$group = function (items) {
	return _etaque$elm_form$Form_Tree$Group(
		_elm_lang$core$Dict$fromList(items));
};
var _etaque$elm_form$Form_Tree$merge = F2(
	function (t1, t2) {
		var _p6 = {ctor: '_Tuple2', _0: t1, _1: t2};
		if (((_p6.ctor === '_Tuple2') && (_p6._0.ctor === 'Group')) && (_p6._1.ctor === 'Group')) {
			return _etaque$elm_form$Form_Tree$Group(
				A2(_elm_lang$core$Dict$union, _p6._0._0, _p6._1._0));
		} else {
			return t1;
		}
	});
var _etaque$elm_form$Form_Tree$recursiveSet = F3(
	function (fragments, node, tree) {
		var _p7 = fragments;
		if (_p7.ctor === '::') {
			var _p10 = _p7._1;
			var _p8 = _p7._0;
			if (_p8.ctor === 'IntFragment') {
				return _etaque$elm_form$Form_Tree$List(
					A3(
						_etaque$elm_form$Form_Tree$updateListAtIndex,
						_p8._0,
						A2(_etaque$elm_form$Form_Tree$recursiveSet, _p10, node),
						_etaque$elm_form$Form_Tree$asList(tree)));
			} else {
				var _p9 = _p8._0;
				var target = A2(
					_elm_lang$core$Maybe$withDefault,
					_etaque$elm_form$Form_Tree$Group(_elm_lang$core$Dict$empty),
					A2(_etaque$elm_form$Form_Tree$getAtName, _p9, tree));
				var childNode = A3(_etaque$elm_form$Form_Tree$recursiveSet, _p10, node, target);
				return A2(
					_etaque$elm_form$Form_Tree$merge,
					_etaque$elm_form$Form_Tree$Group(
						_elm_lang$core$Dict$fromList(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: _p9, _1: childNode},
								_1: {ctor: '[]'}
							})),
					tree);
			}
		} else {
			return node;
		}
	});
var _etaque$elm_form$Form_Tree$IntFragment = function (a) {
	return {ctor: 'IntFragment', _0: a};
};
var _etaque$elm_form$Form_Tree$StringFragment = function (a) {
	return {ctor: 'StringFragment', _0: a};
};
var _etaque$elm_form$Form_Tree$toFragment = function (s) {
	var _p11 = _elm_lang$core$String$toInt(s);
	if (_p11.ctor === 'Ok') {
		return _etaque$elm_form$Form_Tree$IntFragment(_p11._0);
	} else {
		return _etaque$elm_form$Form_Tree$StringFragment(s);
	}
};
var _etaque$elm_form$Form_Tree$extractFragments = function (name) {
	return A2(
		_elm_lang$core$List$map,
		_etaque$elm_form$Form_Tree$toFragment,
		A2(_elm_lang$core$String$split, '.', name));
};
var _etaque$elm_form$Form_Tree$getAtPath = F2(
	function (path, tree) {
		var walkPath = F2(
			function (fragment, maybeField) {
				var _p12 = fragment;
				if (_p12.ctor === 'IntFragment') {
					return A2(
						_elm_lang$core$Maybe$andThen,
						_etaque$elm_form$Form_Tree$getAtIndex(_p12._0),
						maybeField);
				} else {
					return A2(
						_elm_lang$core$Maybe$andThen,
						_etaque$elm_form$Form_Tree$getAtName(_p12._0),
						maybeField);
				}
			});
		return A3(
			_elm_lang$core$List$foldl,
			walkPath,
			_elm_lang$core$Maybe$Just(tree),
			_etaque$elm_form$Form_Tree$extractFragments(path));
	});
var _etaque$elm_form$Form_Tree$setAtPath = F3(
	function (path, node, tree) {
		return A3(
			_etaque$elm_form$Form_Tree$recursiveSet,
			_etaque$elm_form$Form_Tree$extractFragments(path),
			node,
			tree);
	});

var _etaque$elm_form$Form_Error$value = _etaque$elm_form$Form_Tree$Value;
var _etaque$elm_form$Form_Error$CustomError = function (a) {
	return {ctor: 'CustomError', _0: a};
};
var _etaque$elm_form$Form_Error$NotIncludedIn = {ctor: 'NotIncludedIn'};
var _etaque$elm_form$Form_Error$LongerStringThan = function (a) {
	return {ctor: 'LongerStringThan', _0: a};
};
var _etaque$elm_form$Form_Error$ShorterStringThan = function (a) {
	return {ctor: 'ShorterStringThan', _0: a};
};
var _etaque$elm_form$Form_Error$GreaterFloatThan = function (a) {
	return {ctor: 'GreaterFloatThan', _0: a};
};
var _etaque$elm_form$Form_Error$SmallerFloatThan = function (a) {
	return {ctor: 'SmallerFloatThan', _0: a};
};
var _etaque$elm_form$Form_Error$GreaterIntThan = function (a) {
	return {ctor: 'GreaterIntThan', _0: a};
};
var _etaque$elm_form$Form_Error$SmallerIntThan = function (a) {
	return {ctor: 'SmallerIntThan', _0: a};
};
var _etaque$elm_form$Form_Error$InvalidDate = {ctor: 'InvalidDate'};
var _etaque$elm_form$Form_Error$InvalidBool = {ctor: 'InvalidBool'};
var _etaque$elm_form$Form_Error$InvalidFloat = {ctor: 'InvalidFloat'};
var _etaque$elm_form$Form_Error$InvalidInt = {ctor: 'InvalidInt'};
var _etaque$elm_form$Form_Error$InvalidFormat = {ctor: 'InvalidFormat'};
var _etaque$elm_form$Form_Error$InvalidUrl = {ctor: 'InvalidUrl'};
var _etaque$elm_form$Form_Error$InvalidEmail = {ctor: 'InvalidEmail'};
var _etaque$elm_form$Form_Error$InvalidString = {ctor: 'InvalidString'};
var _etaque$elm_form$Form_Error$Empty = {ctor: 'Empty'};

var _etaque$elm_form$Form_Field$asString = function (field) {
	var _p0 = field;
	if ((_p0.ctor === 'Value') && (_p0._0.ctor === 'String')) {
		return _elm_lang$core$Maybe$Just(_p0._0._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _etaque$elm_form$Form_Field$asBool = function (field) {
	var _p1 = field;
	if ((_p1.ctor === 'Value') && (_p1._0.ctor === 'Bool')) {
		return _elm_lang$core$Maybe$Just(_p1._0._0);
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _etaque$elm_form$Form_Field$list = _etaque$elm_form$Form_Tree$List;
var _etaque$elm_form$Form_Field$group = _etaque$elm_form$Form_Tree$group;
var _etaque$elm_form$Form_Field$value = _etaque$elm_form$Form_Tree$Value;
var _etaque$elm_form$Form_Field$EmptyField = {ctor: 'EmptyField'};
var _etaque$elm_form$Form_Field$Bool = function (a) {
	return {ctor: 'Bool', _0: a};
};
var _etaque$elm_form$Form_Field$bool = function (_p2) {
	return _etaque$elm_form$Form_Tree$Value(
		_etaque$elm_form$Form_Field$Bool(_p2));
};
var _etaque$elm_form$Form_Field$String = function (a) {
	return {ctor: 'String', _0: a};
};
var _etaque$elm_form$Form_Field$string = function (_p3) {
	return _etaque$elm_form$Form_Tree$Value(
		_etaque$elm_form$Form_Field$String(_p3));
};

var _etaque$elm_form$Form_Validate$list = F2(
	function (validation, field) {
		var _p0 = field;
		if (_p0.ctor === 'List') {
			var indexedErrMaybe = F2(
				function (index, res) {
					var _p1 = res;
					if (_p1.ctor === 'Ok') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Maybe$Just(
							{
								ctor: '_Tuple2',
								_0: _elm_lang$core$Basics$toString(index),
								_1: _p1._0
							});
					}
				});
			var results = A2(_elm_lang$core$List$map, validation, _p0._0);
			var errors = A2(
				_elm_lang$core$List$filterMap,
				_elm_lang$core$Basics$identity,
				A2(_elm_lang$core$List$indexedMap, indexedErrMaybe, results));
			return _elm_lang$core$List$isEmpty(errors) ? _elm_lang$core$Result$Ok(
				A2(_elm_lang$core$List$filterMap, _elm_lang$core$Result$toMaybe, results)) : _elm_lang$core$Result$Err(
				_etaque$elm_form$Form_Tree$group(errors));
		} else {
			return _elm_lang$core$Result$Ok(
				{ctor: '[]'});
		}
	});
var _etaque$elm_form$Form_Validate$oneOf = F2(
	function (validations, field) {
		var walkResults = F2(
			function (result, combined) {
				var _p2 = {ctor: '_Tuple2', _0: combined, _1: result};
				if ((_p2.ctor === '_Tuple2') && (_p2._0.ctor === 'Ok')) {
					return combined;
				} else {
					return result;
				}
			});
		var results = A2(
			_elm_lang$core$List$map,
			function (v) {
				return v(field);
			},
			validations);
		return A3(
			_elm_lang$core$List$foldl,
			walkResults,
			_elm_lang$core$Result$Err(
				_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$Empty)),
			results);
	});
var _etaque$elm_form$Form_Validate$customValidation = F3(
	function (validation, callback, field) {
		return A2(
			_elm_lang$core$Result$andThen,
			callback,
			validation(field));
	});
var _etaque$elm_form$Form_Validate$succeed = F2(
	function (a, field) {
		return _elm_lang$core$Result$Ok(a);
	});
var _etaque$elm_form$Form_Validate$fail = F2(
	function (error, field) {
		return _elm_lang$core$Result$Err(error);
	});
var _etaque$elm_form$Form_Validate$includedIn = F3(
	function (items, s, field) {
		return A2(_elm_lang$core$List$member, s, items) ? _elm_lang$core$Result$Ok(s) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$NotIncludedIn));
	});
var _etaque$elm_form$Form_Validate$validUrlPattern = _elm_lang$core$Regex$caseInsensitive(
	_elm_lang$core$Regex$regex('^(https?://)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\w \\.-]*)*/?$'));
var _etaque$elm_form$Form_Validate$validEmailPattern = _elm_lang$core$Regex$caseInsensitive(
	_elm_lang$core$Regex$regex('^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
var _etaque$elm_form$Form_Validate$format = F3(
	function (regex, s, field) {
		return A2(_elm_lang$core$Regex$contains, regex, s) ? _elm_lang$core$Result$Ok(s) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidFormat));
	});
var _etaque$elm_form$Form_Validate$maxFloat = F3(
	function (max, i, field) {
		return (_elm_lang$core$Native_Utils.cmp(i, max) < 1) ? _elm_lang$core$Result$Ok(i) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(
				_etaque$elm_form$Form_Error$GreaterFloatThan(max)));
	});
var _etaque$elm_form$Form_Validate$minFloat = F3(
	function (min, i, field) {
		return (_elm_lang$core$Native_Utils.cmp(i, min) > -1) ? _elm_lang$core$Result$Ok(i) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(
				_etaque$elm_form$Form_Error$SmallerFloatThan(min)));
	});
var _etaque$elm_form$Form_Validate$maxInt = F3(
	function (max, i, field) {
		return (_elm_lang$core$Native_Utils.cmp(i, max) < 1) ? _elm_lang$core$Result$Ok(i) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(
				_etaque$elm_form$Form_Error$GreaterIntThan(max)));
	});
var _etaque$elm_form$Form_Validate$minInt = F3(
	function (min, i, field) {
		return (_elm_lang$core$Native_Utils.cmp(i, min) > -1) ? _elm_lang$core$Result$Ok(i) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(
				_etaque$elm_form$Form_Error$SmallerIntThan(min)));
	});
var _etaque$elm_form$Form_Validate$maxLength = F3(
	function (max, s, field) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(s),
			max) < 1) ? _elm_lang$core$Result$Ok(s) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(
				_etaque$elm_form$Form_Error$LongerStringThan(max)));
	});
var _etaque$elm_form$Form_Validate$minLength = F3(
	function (min, s, field) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(s),
			min) > -1) ? _elm_lang$core$Result$Ok(s) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(
				_etaque$elm_form$Form_Error$ShorterStringThan(min)));
	});
var _etaque$elm_form$Form_Validate$nonEmpty = F2(
	function (s, field) {
		return _elm_lang$core$String$isEmpty(s) ? _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$Empty)) : _elm_lang$core$Result$Ok(s);
	});
var _etaque$elm_form$Form_Validate$maybe = F2(
	function (validation, field) {
		return _elm_lang$core$Result$Ok(
			_elm_lang$core$Result$toMaybe(
				validation(field)));
	});
var _etaque$elm_form$Form_Validate$date = function (v) {
	var _p3 = _etaque$elm_form$Form_Field$asString(v);
	if (_p3.ctor === 'Just') {
		return A2(
			_elm_lang$core$Result$mapError,
			function (_p4) {
				return _etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidDate);
			},
			_elm_lang$core$Date$fromString(_p3._0));
	} else {
		return _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidDate));
	}
};
var _etaque$elm_form$Form_Validate$bool = function (v) {
	var _p5 = _etaque$elm_form$Form_Field$asBool(v);
	if (_p5.ctor === 'Just') {
		return _elm_lang$core$Result$Ok(_p5._0);
	} else {
		return _elm_lang$core$Result$Ok(false);
	}
};
var _etaque$elm_form$Form_Validate$emptyString = function (v) {
	var _p6 = _etaque$elm_form$Form_Field$asString(v);
	if (_p6.ctor === 'Just') {
		var _p7 = _p6._0;
		return _elm_lang$core$String$isEmpty(_p7) ? _elm_lang$core$Result$Ok(_p7) : _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidString));
	} else {
		return _elm_lang$core$Result$Ok('');
	}
};
var _etaque$elm_form$Form_Validate$string = function (v) {
	var _p8 = _etaque$elm_form$Form_Field$asString(v);
	if (_p8.ctor === 'Just') {
		var _p9 = _p8._0;
		return _elm_lang$core$String$isEmpty(_p9) ? _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$Empty)) : _elm_lang$core$Result$Ok(_p9);
	} else {
		return _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidString));
	}
};
var _etaque$elm_form$Form_Validate$float = function (v) {
	var _p10 = _etaque$elm_form$Form_Field$asString(v);
	if (_p10.ctor === 'Just') {
		return A2(
			_elm_lang$core$Result$mapError,
			function (_p11) {
				return _etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidFloat);
			},
			_elm_lang$core$String$toFloat(_p10._0));
	} else {
		return _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidFloat));
	}
};
var _etaque$elm_form$Form_Validate$int = function (v) {
	var _p12 = _etaque$elm_form$Form_Field$asString(v);
	if (_p12.ctor === 'Just') {
		return A2(
			_elm_lang$core$Result$mapError,
			function (_p13) {
				return _etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidInt);
			},
			_elm_lang$core$String$toInt(_p12._0));
	} else {
		return _elm_lang$core$Result$Err(
			_etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidInt));
	}
};
var _etaque$elm_form$Form_Validate$errMaybe = function (res) {
	var _p14 = res;
	if (_p14.ctor === 'Ok') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(_p14._0);
	}
};
var _etaque$elm_form$Form_Validate$groupErrorsUnion = F2(
	function (e1, e2) {
		var _p15 = {ctor: '_Tuple2', _0: e1, _1: e2};
		if (((_p15.ctor === '_Tuple2') && (_p15._0.ctor === 'Group')) && (_p15._1.ctor === 'Group')) {
			return _etaque$elm_form$Form_Tree$Group(
				A2(_elm_lang$core$Dict$union, _p15._0._0, _p15._1._0));
		} else {
			return e2;
		}
	});
var _etaque$elm_form$Form_Validate$mergeMany = function (errors) {
	return A3(
		_elm_lang$core$List$foldl,
		_etaque$elm_form$Form_Validate$groupErrorsUnion,
		_etaque$elm_form$Form_Tree$group(
			{ctor: '[]'}),
		A2(_elm_lang$core$List$filterMap, _elm_lang$core$Basics$identity, errors));
};
var _etaque$elm_form$Form_Validate$field = F3(
	function (key, validation, field) {
		return A2(
			_elm_lang$core$Result$mapError,
			function (e) {
				return _etaque$elm_form$Form_Tree$group(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: key, _1: e},
						_1: {ctor: '[]'}
					});
			},
			validation(
				A2(
					_elm_lang$core$Maybe$withDefault,
					_etaque$elm_form$Form_Tree$Value(_etaque$elm_form$Form_Field$EmptyField),
					A2(_etaque$elm_form$Form_Tree$getAtName, key, field))));
	});
var _etaque$elm_form$Form_Validate$customError = function (_p16) {
	return _etaque$elm_form$Form_Error$value(
		_etaque$elm_form$Form_Error$CustomError(_p16));
};
var _etaque$elm_form$Form_Validate$mapError = F3(
	function (f, validation, field) {
		return A2(
			_elm_lang$core$Result$mapError,
			f,
			validation(field));
	});
var _etaque$elm_form$Form_Validate$withCustomError = function (_p17) {
	return _etaque$elm_form$Form_Validate$mapError(
		_elm_lang$core$Basics$always(
			_etaque$elm_form$Form_Validate$customError(_p17)));
};
var _etaque$elm_form$Form_Validate$defaultValue = F3(
	function (a, validation, field) {
		return _elm_lang$core$Result$Ok(
			A2(
				_elm_lang$core$Result$withDefault,
				a,
				validation(field)));
	});
var _etaque$elm_form$Form_Validate$andMap = F3(
	function (aValidation, partialValidation, field) {
		var _p18 = {
			ctor: '_Tuple2',
			_0: partialValidation(field),
			_1: aValidation(field)
		};
		if ((_p18._0.ctor === 'Ok') && (_p18._1.ctor === 'Ok')) {
			return _elm_lang$core$Result$Ok(
				_p18._0._0(_p18._1._0));
		} else {
			return _elm_lang$core$Result$Err(
				_etaque$elm_form$Form_Validate$mergeMany(
					{
						ctor: '::',
						_0: _etaque$elm_form$Form_Validate$errMaybe(_p18._0),
						_1: {
							ctor: '::',
							_0: _etaque$elm_form$Form_Validate$errMaybe(_p18._1),
							_1: {ctor: '[]'}
						}
					}));
		}
	});
var _etaque$elm_form$Form_Validate$andThen = F3(
	function (callback, validation, field) {
		return A2(
			_elm_lang$core$Result$andThen,
			function (next) {
				return A2(callback, next, field);
			},
			validation(field));
	});
var _etaque$elm_form$Form_Validate$email = A2(
	_etaque$elm_form$Form_Validate$andThen,
	function (s) {
		return A2(
			_etaque$elm_form$Form_Validate$mapError,
			function (_p19) {
				return _etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidEmail);
			},
			A2(_etaque$elm_form$Form_Validate$format, _etaque$elm_form$Form_Validate$validEmailPattern, s));
	},
	_etaque$elm_form$Form_Validate$string);
var _etaque$elm_form$Form_Validate$url = A2(
	_etaque$elm_form$Form_Validate$andThen,
	function (s) {
		return A2(
			_etaque$elm_form$Form_Validate$mapError,
			function (_p20) {
				return _etaque$elm_form$Form_Error$value(_etaque$elm_form$Form_Error$InvalidUrl);
			},
			A2(_etaque$elm_form$Form_Validate$format, _etaque$elm_form$Form_Validate$validUrlPattern, s));
	},
	_etaque$elm_form$Form_Validate$string);
var _etaque$elm_form$Form_Validate$map = F3(
	function (f, validation, field) {
		return A2(
			_elm_lang$core$Result$map,
			f,
			validation(field));
	});
var _etaque$elm_form$Form_Validate$map2 = F3(
	function (func, v1, v2) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v2,
			A2(_etaque$elm_form$Form_Validate$map, func, v1));
	});
var _etaque$elm_form$Form_Validate$map3 = F4(
	function (func, v1, v2, v3) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v3,
			A3(_etaque$elm_form$Form_Validate$map2, func, v1, v2));
	});
var _etaque$elm_form$Form_Validate$map4 = F5(
	function (func, v1, v2, v3, v4) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v4,
			A4(_etaque$elm_form$Form_Validate$map3, func, v1, v2, v3));
	});
var _etaque$elm_form$Form_Validate$map5 = F6(
	function (func, v1, v2, v3, v4, v5) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v5,
			A5(_etaque$elm_form$Form_Validate$map4, func, v1, v2, v3, v4));
	});
var _etaque$elm_form$Form_Validate$map6 = F7(
	function (func, v1, v2, v3, v4, v5, v6) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v6,
			A6(_etaque$elm_form$Form_Validate$map5, func, v1, v2, v3, v4, v5));
	});
var _etaque$elm_form$Form_Validate$map7 = F8(
	function (func, v1, v2, v3, v4, v5, v6, v7) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v7,
			A7(_etaque$elm_form$Form_Validate$map6, func, v1, v2, v3, v4, v5, v6));
	});
var _etaque$elm_form$Form_Validate$map8 = F9(
	function (func, v1, v2, v3, v4, v5, v6, v7, v8) {
		return A2(
			_etaque$elm_form$Form_Validate$andMap,
			v8,
			A8(_etaque$elm_form$Form_Validate$map7, func, v1, v2, v3, v4, v5, v6, v7));
	});
var _etaque$elm_form$Form_Validate$sequence = function (validations) {
	return A3(
		_elm_lang$core$List$foldr,
		_etaque$elm_form$Form_Validate$map2(
			F2(
				function (x, y) {
					return {ctor: '::', _0: x, _1: y};
				})),
		_etaque$elm_form$Form_Validate$succeed(
			{ctor: '[]'}),
		validations);
};

var _etaque$elm_form$Form$getChangedFields = function (_p0) {
	var _p1 = _p0;
	return _p1._0.changedFields;
};
var _etaque$elm_form$Form$getFocus = function (_p2) {
	var _p3 = _p2;
	return _p3._0.focus;
};
var _etaque$elm_form$Form$isDirtyAt = F2(
	function (qualifiedName, _p4) {
		var _p5 = _p4;
		return A2(_elm_lang$core$Set$member, qualifiedName, _p5._0.dirtyFields);
	});
var _etaque$elm_form$Form$isChangedAt = F2(
	function (qualifiedName, _p6) {
		var _p7 = _p6;
		return A2(_elm_lang$core$Set$member, qualifiedName, _p7._0.changedFields);
	});
var _etaque$elm_form$Form$getErrorAt = F2(
	function (path, _p8) {
		var _p9 = _p8;
		return A2(
			_elm_lang$core$Maybe$andThen,
			_etaque$elm_form$Form_Tree$asValue,
			A2(_etaque$elm_form$Form_Tree$getAtPath, path, _p9._0.errors));
	});
var _etaque$elm_form$Form$getErrors = function (_p10) {
	var _p11 = _p10;
	return _etaque$elm_form$Form_Tree$valuesWithPath(_p11._0.errors);
};
var _etaque$elm_form$Form$isSubmitted = function (_p12) {
	var _p13 = _p12;
	return _p13._0.isSubmitted;
};
var _etaque$elm_form$Form$getLiveErrorAt = F2(
	function (name, form) {
		return (_etaque$elm_form$Form$isSubmitted(form) || (A2(_etaque$elm_form$Form$isChangedAt, name, form) && (!A2(_etaque$elm_form$Form$isDirtyAt, name, form)))) ? A2(_etaque$elm_form$Form$getErrorAt, name, form) : _elm_lang$core$Maybe$Nothing;
	});
var _etaque$elm_form$Form$getOutput = function (_p14) {
	var _p15 = _p14;
	return _p15._0.output;
};
var _etaque$elm_form$Form$setFieldAt = F3(
	function (path, field, model) {
		return A3(_etaque$elm_form$Form_Tree$setAtPath, path, field, model.fields);
	});
var _etaque$elm_form$Form$getFieldAt = F2(
	function (qualifiedName, model) {
		return A2(_etaque$elm_form$Form_Tree$getAtPath, qualifiedName, model.fields);
	});
var _etaque$elm_form$Form$getStringAt = F2(
	function (name, _p16) {
		var _p17 = _p16;
		return A2(
			_elm_lang$core$Maybe$andThen,
			_etaque$elm_form$Form_Field$asString,
			A2(_etaque$elm_form$Form$getFieldAt, name, _p17._0));
	});
var _etaque$elm_form$Form$getBoolAt = F2(
	function (name, _p18) {
		var _p19 = _p18;
		return A2(
			_elm_lang$core$Maybe$andThen,
			_etaque$elm_form$Form_Field$asBool,
			A2(_etaque$elm_form$Form$getFieldAt, name, _p19._0));
	});
var _etaque$elm_form$Form$updateValidate = F2(
	function (validation, model) {
		var _p20 = validation(model.fields);
		if (_p20.ctor === 'Ok') {
			return _elm_lang$core$Native_Utils.update(
				model,
				{
					errors: _etaque$elm_form$Form_Tree$group(
						{ctor: '[]'}),
					output: _elm_lang$core$Maybe$Just(_p20._0)
				});
		} else {
			return _elm_lang$core$Native_Utils.update(
				model,
				{errors: _p20._0, output: _elm_lang$core$Maybe$Nothing});
		}
	});
var _etaque$elm_form$Form$getListIndexes = F2(
	function (path, _p21) {
		var _p22 = _p21;
		var length = A2(
			_elm_lang$core$Maybe$withDefault,
			0,
			A2(
				_elm_lang$core$Maybe$map,
				function (_p23) {
					return _elm_lang$core$List$length(
						_etaque$elm_form$Form_Tree$asList(_p23));
				},
				A2(_etaque$elm_form$Form$getFieldAt, path, _p22._0)));
		return A2(_elm_lang$core$List$range, 0, length - 1);
	});
var _etaque$elm_form$Form$getField = F3(
	function (getValue, path, form) {
		return {
			path: path,
			value: A2(getValue, path, form),
			error: A2(_etaque$elm_form$Form$getErrorAt, path, form),
			liveError: A2(_etaque$elm_form$Form$getLiveErrorAt, path, form),
			isDirty: A2(_etaque$elm_form$Form$isDirtyAt, path, form),
			isChanged: A2(_etaque$elm_form$Form$isChangedAt, path, form),
			hasFocus: _elm_lang$core$Native_Utils.eq(
				_etaque$elm_form$Form$getFocus(form),
				_elm_lang$core$Maybe$Just(path))
		};
	});
var _etaque$elm_form$Form$getFieldAsBool = _etaque$elm_form$Form$getField(_etaque$elm_form$Form$getBoolAt);
var _etaque$elm_form$Form$getFieldAsString = _etaque$elm_form$Form$getField(_etaque$elm_form$Form$getStringAt);
var _etaque$elm_form$Form$Model = F7(
	function (a, b, c, d, e, f, g) {
		return {fields: a, focus: b, dirtyFields: c, changedFields: d, isSubmitted: e, output: f, errors: g};
	});
var _etaque$elm_form$Form$FieldState = F7(
	function (a, b, c, d, e, f, g) {
		return {path: a, value: b, error: c, liveError: d, isDirty: e, isChanged: f, hasFocus: g};
	});
var _etaque$elm_form$Form$F = function (a) {
	return {ctor: 'F', _0: a};
};
var _etaque$elm_form$Form$initial = F2(
	function (initialFields, validation) {
		var model = {
			fields: _etaque$elm_form$Form_Tree$group(initialFields),
			focus: _elm_lang$core$Maybe$Nothing,
			dirtyFields: _elm_lang$core$Set$empty,
			changedFields: _elm_lang$core$Set$empty,
			isSubmitted: false,
			output: _elm_lang$core$Maybe$Nothing,
			errors: _etaque$elm_form$Form_Tree$group(
				{ctor: '[]'})
		};
		return _etaque$elm_form$Form$F(
			A2(_etaque$elm_form$Form$updateValidate, validation, model));
	});
var _etaque$elm_form$Form$update = F3(
	function (validation, msg, _p24) {
		var _p25 = _p24;
		var _p32 = _p25._0;
		var _p26 = msg;
		switch (_p26.ctor) {
			case 'NoOp':
				return _etaque$elm_form$Form$F(_p32);
			case 'Focus':
				var newModel = _elm_lang$core$Native_Utils.update(
					_p32,
					{
						focus: _elm_lang$core$Maybe$Just(_p26._0)
					});
				return _etaque$elm_form$Form$F(newModel);
			case 'Blur':
				var newDirtyFields = A2(_elm_lang$core$Set$remove, _p26._0, _p32.dirtyFields);
				var newModel = _elm_lang$core$Native_Utils.update(
					_p32,
					{focus: _elm_lang$core$Maybe$Nothing, dirtyFields: newDirtyFields});
				return _etaque$elm_form$Form$F(
					A2(_etaque$elm_form$Form$updateValidate, validation, newModel));
			case 'Input':
				var _p28 = _p26._0;
				var newChangedFields = A2(_elm_lang$core$Set$insert, _p28, _p32.changedFields);
				var isDirty = function () {
					var _p27 = _p26._1;
					switch (_p27.ctor) {
						case 'Text':
							return true;
						case 'Textarea':
							return true;
						default:
							return false;
					}
				}();
				var newDirtyFields = isDirty ? A2(_elm_lang$core$Set$insert, _p28, _p32.dirtyFields) : _p32.dirtyFields;
				var newFields = A3(
					_etaque$elm_form$Form$setFieldAt,
					_p28,
					_etaque$elm_form$Form_Tree$Value(_p26._2),
					_p32);
				var newModel = _elm_lang$core$Native_Utils.update(
					_p32,
					{fields: newFields, dirtyFields: newDirtyFields, changedFields: newChangedFields});
				return _etaque$elm_form$Form$F(
					A2(_etaque$elm_form$Form$updateValidate, validation, newModel));
			case 'Append':
				var _p29 = _p26._0;
				var listFields = A2(
					_elm_lang$core$Maybe$withDefault,
					{ctor: '[]'},
					A2(
						_elm_lang$core$Maybe$map,
						_etaque$elm_form$Form_Tree$asList,
						A2(_etaque$elm_form$Form$getFieldAt, _p29, _p32)));
				var newListFields = A2(
					_elm_lang$core$Basics_ops['++'],
					listFields,
					{
						ctor: '::',
						_0: _etaque$elm_form$Form_Tree$Value(_etaque$elm_form$Form_Field$EmptyField),
						_1: {ctor: '[]'}
					});
				var newModel = _elm_lang$core$Native_Utils.update(
					_p32,
					{
						fields: A3(
							_etaque$elm_form$Form$setFieldAt,
							_p29,
							_etaque$elm_form$Form_Tree$List(newListFields),
							_p32)
					});
				return _etaque$elm_form$Form$F(newModel);
			case 'RemoveItem':
				var _p31 = _p26._0;
				var _p30 = _p26._1;
				var listFields = A2(
					_elm_lang$core$Maybe$withDefault,
					{ctor: '[]'},
					A2(
						_elm_lang$core$Maybe$map,
						_etaque$elm_form$Form_Tree$asList,
						A2(_etaque$elm_form$Form$getFieldAt, _p31, _p32)));
				var newListFields = A2(
					_elm_lang$core$Basics_ops['++'],
					A2(_elm_lang$core$List$take, _p30, listFields),
					A2(_elm_lang$core$List$drop, _p30 + 1, listFields));
				var newModel = _elm_lang$core$Native_Utils.update(
					_p32,
					{
						fields: A3(
							_etaque$elm_form$Form$setFieldAt,
							_p31,
							_etaque$elm_form$Form_Tree$List(newListFields),
							_p32)
					});
				return _etaque$elm_form$Form$F(newModel);
			case 'Submit':
				var validatedModel = A2(_etaque$elm_form$Form$updateValidate, validation, _p32);
				return _etaque$elm_form$Form$F(
					_elm_lang$core$Native_Utils.update(
						validatedModel,
						{isSubmitted: true}));
			case 'Validate':
				return _etaque$elm_form$Form$F(
					A2(_etaque$elm_form$Form$updateValidate, validation, _p32));
			default:
				var newModel = _elm_lang$core$Native_Utils.update(
					_p32,
					{
						fields: _etaque$elm_form$Form_Tree$group(_p26._0),
						dirtyFields: _elm_lang$core$Set$empty,
						changedFields: _elm_lang$core$Set$empty,
						isSubmitted: false
					});
				return _etaque$elm_form$Form$F(
					A2(_etaque$elm_form$Form$updateValidate, validation, newModel));
		}
	});
var _etaque$elm_form$Form$Reset = function (a) {
	return {ctor: 'Reset', _0: a};
};
var _etaque$elm_form$Form$Validate = {ctor: 'Validate'};
var _etaque$elm_form$Form$Submit = {ctor: 'Submit'};
var _etaque$elm_form$Form$RemoveItem = F2(
	function (a, b) {
		return {ctor: 'RemoveItem', _0: a, _1: b};
	});
var _etaque$elm_form$Form$Append = function (a) {
	return {ctor: 'Append', _0: a};
};
var _etaque$elm_form$Form$Input = F3(
	function (a, b, c) {
		return {ctor: 'Input', _0: a, _1: b, _2: c};
	});
var _etaque$elm_form$Form$Blur = function (a) {
	return {ctor: 'Blur', _0: a};
};
var _etaque$elm_form$Form$Focus = function (a) {
	return {ctor: 'Focus', _0: a};
};
var _etaque$elm_form$Form$NoOp = {ctor: 'NoOp'};
var _etaque$elm_form$Form$Checkbox = {ctor: 'Checkbox'};
var _etaque$elm_form$Form$Radio = {ctor: 'Radio'};
var _etaque$elm_form$Form$Select = {ctor: 'Select'};
var _etaque$elm_form$Form$Textarea = {ctor: 'Textarea'};
var _etaque$elm_form$Form$Text = {ctor: 'Text'};

var _etaque$elm_form$Form_Input$dumpErrors = function (form) {
	var line = function (_p0) {
		var _p1 = _p0;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			_p1._0,
			A2(
				_elm_lang$core$Basics_ops['++'],
				': ',
				_elm_lang$core$Basics$toString(_p1._1)));
	};
	var content = A2(
		_elm_lang$core$String$join,
		'\n',
		A2(
			_elm_lang$core$List$map,
			line,
			_etaque$elm_form$Form$getErrors(form)));
	return A2(
		_elm_lang$html$Html$pre,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text(content),
			_1: {ctor: '[]'}
		});
};
var _etaque$elm_form$Form_Input$radioInput = F3(
	function (value, state, attrs) {
		var formAttrs = {
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$type_('radio'),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$name(state.path),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(value),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$checked(
							_elm_lang$core$Native_Utils.eq(
								state.value,
								_elm_lang$core$Maybe$Just(value))),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onFocus(
								_etaque$elm_form$Form$Focus(state.path)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onBlur(
									_etaque$elm_form$Form$Blur(state.path)),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html_Events$on,
										'change',
										A2(
											_elm_lang$core$Json_Decode$map,
											function (_p2) {
												return A3(
													_etaque$elm_form$Form$Input,
													state.path,
													_etaque$elm_form$Form$Radio,
													_etaque$elm_form$Form_Field$String(_p2));
											},
											_elm_lang$html$Html_Events$targetValue)),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			}
		};
		return A2(
			_elm_lang$html$Html$input,
			A2(_elm_lang$core$Basics_ops['++'], formAttrs, attrs),
			{ctor: '[]'});
	});
var _etaque$elm_form$Form_Input$checkboxInput = F2(
	function (state, attrs) {
		var formAttrs = {
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$type_('checkbox'),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$checked(
					A2(_elm_lang$core$Maybe$withDefault, false, state.value)),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onCheck(
						function (_p3) {
							return A3(
								_etaque$elm_form$Form$Input,
								state.path,
								_etaque$elm_form$Form$Checkbox,
								_etaque$elm_form$Form_Field$Bool(_p3));
						}),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onFocus(
							_etaque$elm_form$Form$Focus(state.path)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onBlur(
								_etaque$elm_form$Form$Blur(state.path)),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		};
		return A2(
			_elm_lang$html$Html$input,
			A2(_elm_lang$core$Basics_ops['++'], formAttrs, attrs),
			{ctor: '[]'});
	});
var _etaque$elm_form$Form_Input$selectInput = F3(
	function (options, state, attrs) {
		var buildOption = function (_p4) {
			var _p5 = _p4;
			var _p6 = _p5._0;
			return A2(
				_elm_lang$html$Html$option,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(_p6),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$selected(
							_elm_lang$core$Native_Utils.eq(
								state.value,
								_elm_lang$core$Maybe$Just(_p6))),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(_p5._1),
					_1: {ctor: '[]'}
				});
		};
		var formAttrs = {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html_Events$on,
				'change',
				A2(
					_elm_lang$core$Json_Decode$map,
					function (_p7) {
						return A3(
							_etaque$elm_form$Form$Input,
							state.path,
							_etaque$elm_form$Form$Select,
							_etaque$elm_form$Form_Field$String(_p7));
					},
					_elm_lang$html$Html_Events$targetValue)),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onFocus(
					_etaque$elm_form$Form$Focus(state.path)),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onBlur(
						_etaque$elm_form$Form$Blur(state.path)),
					_1: {ctor: '[]'}
				}
			}
		};
		return A2(
			_elm_lang$html$Html$select,
			A2(_elm_lang$core$Basics_ops['++'], formAttrs, attrs),
			A2(_elm_lang$core$List$map, buildOption, options));
	});
var _etaque$elm_form$Form_Input$textArea = F2(
	function (state, attrs) {
		var formAttrs = {
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$defaultValue(
				A2(_elm_lang$core$Maybe$withDefault, '', state.value)),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onInput(
					function (_p8) {
						return A3(
							_etaque$elm_form$Form$Input,
							state.path,
							_etaque$elm_form$Form$Textarea,
							_etaque$elm_form$Form_Field$String(_p8));
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onFocus(
						_etaque$elm_form$Form$Focus(state.path)),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onBlur(
							_etaque$elm_form$Form$Blur(state.path)),
						_1: {ctor: '[]'}
					}
				}
			}
		};
		return A2(
			_elm_lang$html$Html$textarea,
			A2(_elm_lang$core$Basics_ops['++'], formAttrs, attrs),
			{ctor: '[]'});
	});
var _etaque$elm_form$Form_Input$baseInput = F5(
	function (t, toFieldValue, inputType, state, attrs) {
		var formAttrs = {
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$type_(t),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$defaultValue(
					A2(_elm_lang$core$Maybe$withDefault, '', state.value)),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onInput(
						function (_p9) {
							return A3(
								_etaque$elm_form$Form$Input,
								state.path,
								inputType,
								toFieldValue(_p9));
						}),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onFocus(
							_etaque$elm_form$Form$Focus(state.path)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onBlur(
								_etaque$elm_form$Form$Blur(state.path)),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		};
		return A2(
			_elm_lang$html$Html$input,
			A2(_elm_lang$core$Basics_ops['++'], formAttrs, attrs),
			{ctor: '[]'});
	});
var _etaque$elm_form$Form_Input$textInput = A3(_etaque$elm_form$Form_Input$baseInput, 'text', _etaque$elm_form$Form_Field$String, _etaque$elm_form$Form$Text);
var _etaque$elm_form$Form_Input$passwordInput = A3(_etaque$elm_form$Form_Input$baseInput, 'password', _etaque$elm_form$Form_Field$String, _etaque$elm_form$Form$Text);

var _CareerPlug$ats$ProgressBar_ProgressBar$view = A2(
	_elm_lang$html$Html$div,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('progress-bar-container'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('progress-bar-item'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('progress-bar-mover'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}),
		_1: {ctor: '[]'}
	});

var _CareerPlug$ats$PhoneNumberSelect_Main$selectView = function (model) {
	var isSaving = function () {
		var _p0 = model.status;
		if (_p0.ctor === 'Saving') {
			return true;
		} else {
			return false;
		}
	}();
	var buttonContent = isSaving ? {
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('loading-dot'),
				_1: {ctor: '[]'}
			},
			{ctor: '[]'}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('loading-dot'),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('loading-dot'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}
		}
	} : {
		ctor: '::',
		_0: _elm_lang$html$Html$text('Get Phone Number'),
		_1: {ctor: '[]'}
	};
	var progressBar = isSaving ? _CareerPlug$ats$ProgressBar_ProgressBar$view : A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{ctor: '[]'});
	var zipCode = A2(_etaque$elm_form$Form$getFieldAsString, 'zipCode', model.zipCodeForm);
	var httpError = function () {
		var _p1 = model.status;
		if (_p1.ctor === 'Error') {
			return true;
		} else {
			return false;
		}
	}();
	var validationError = function (field) {
		var _p2 = field.liveError;
		if (_p2.ctor === 'Just') {
			return true;
		} else {
			return false;
		}
	};
	var errorContent = function (field) {
		return validationError(field) ? A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('error-container error'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('Must provide valid zipcode.'),
				_1: {ctor: '[]'}
			}) : (httpError ? A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('error-container error'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('Unable to assign phone number for the provided zip code.'),
				_1: {ctor: '[]'}
			}) : A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('error-container'),
				_1: {ctor: '[]'}
			},
			{ctor: '[]'}));
	};
	var isDisabled = function () {
		var zipCodeValue = function () {
			var _p3 = zipCode.value;
			if (_p3.ctor === 'Nothing') {
				return false;
			} else {
				return true;
			}
		}();
		return isSaving || (validationError(zipCode) || (!zipCodeValue));
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$classList(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'phone-number-selector', _1: true},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'saving', _1: isSaving},
						_1: {ctor: '[]'}
					}
				}),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: progressBar,
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$p,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('headline'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('You\'ll need a CareerPlug phone number to communicate with applicants via SMS.'),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$p,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('Enter in a zip code and we\'ll assign a number that can be found in your area.'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$label,
									{
										ctor: '::',
										_0: _CareerPlug$ats$Library_Core$onEnter(_etaque$elm_form$Form$Submit),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('label-text'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text('Zip Code'),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_etaque$elm_form$Form_Input$textInput,
												zipCode,
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$button,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$classList(
												{
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'btn btn-action', _1: true},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'disabled', _1: isDisabled},
														_1: {ctor: '[]'}
													}
												}),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Events$onClick(_etaque$elm_form$Form$Submit),
												_1: {ctor: '[]'}
											}
										},
										buttonContent),
									_1: {ctor: '[]'}
								}
							}),
						_1: {
							ctor: '::',
							_0: errorContent(zipCode),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		});
};
var _CareerPlug$ats$PhoneNumberSelect_Main$applicationPhoneNumberIdDecoder = A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int);
var _CareerPlug$ats$PhoneNumberSelect_Main$applicationPhoneNumberEncoder = function (zipCode) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'application_phone_number',
				_1: _elm_lang$core$Json_Encode$object(
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'zip_code',
							_1: _elm_lang$core$Json_Encode$string(zipCode)
						},
						_1: {ctor: '[]'}
					})
			},
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$PhoneNumberSelect_Main$ZipCodeForm = function (a) {
	return {zipCode: a};
};
var _CareerPlug$ats$PhoneNumberSelect_Main$validation = A2(
	_etaque$elm_form$Form_Validate$andMap,
	A2(
		_etaque$elm_form$Form_Validate$field,
		'zipCode',
		A2(
			_etaque$elm_form$Form_Validate$andThen,
			_etaque$elm_form$Form_Validate$format(
				_elm_lang$core$Regex$regex('^[0-9]*$')),
			A2(
				_etaque$elm_form$Form_Validate$andThen,
				_etaque$elm_form$Form_Validate$maxLength(5),
				A2(
					_etaque$elm_form$Form_Validate$andThen,
					_etaque$elm_form$Form_Validate$minLength(5),
					A2(_etaque$elm_form$Form_Validate$andThen, _etaque$elm_form$Form_Validate$nonEmpty, _etaque$elm_form$Form_Validate$string))))),
	_etaque$elm_form$Form_Validate$succeed(_CareerPlug$ats$PhoneNumberSelect_Main$ZipCodeForm));
var _CareerPlug$ats$PhoneNumberSelect_Main$PhoneNumberSelect = F2(
	function (a, b) {
		return {status: a, zipCodeForm: b};
	});
var _CareerPlug$ats$PhoneNumberSelect_Main$Context = function (a) {
	return {authToken: a};
};
var _CareerPlug$ats$PhoneNumberSelect_Main$Error = function (a) {
	return {ctor: 'Error', _0: a};
};
var _CareerPlug$ats$PhoneNumberSelect_Main$Saving = {ctor: 'Saving'};
var _CareerPlug$ats$PhoneNumberSelect_Main$Ready = {ctor: 'Ready'};
var _CareerPlug$ats$PhoneNumberSelect_Main$initialModel = {
	status: _CareerPlug$ats$PhoneNumberSelect_Main$Ready,
	zipCodeForm: A2(
		_etaque$elm_form$Form$initial,
		{ctor: '[]'},
		_CareerPlug$ats$PhoneNumberSelect_Main$validation)
};
var _CareerPlug$ats$PhoneNumberSelect_Main$HttpResponse = function (a) {
	return {ctor: 'HttpResponse', _0: a};
};
var _CareerPlug$ats$PhoneNumberSelect_Main$handleNewphoneNumber = F2(
	function (context, zipCode) {
		var request = _elm_lang$http$Http$request(
			{
				body: _elm_lang$http$Http$jsonBody(
					_CareerPlug$ats$PhoneNumberSelect_Main$applicationPhoneNumberEncoder(zipCode)),
				expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$PhoneNumberSelect_Main$applicationPhoneNumberIdDecoder),
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', context.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: '/manage/application_phone_numbers.json',
				method: 'POST',
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
		return A2(_elm_lang$http$Http$send, _CareerPlug$ats$PhoneNumberSelect_Main$HttpResponse, request);
	});
var _CareerPlug$ats$PhoneNumberSelect_Main$update = F4(
	function (context, msg, model, effectMapper) {
		var effectMapper_ = _elm_lang$core$List$map(
			_elm_lang$core$Platform_Cmd$map(effectMapper));
		var _p4 = msg;
		switch (_p4.ctor) {
			case 'NoOp':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					effectMapper_(
						{ctor: '[]'}));
			case 'FormMsg':
				var _p9 = _p4._0;
				var zipCodeField = A2(_etaque$elm_form$Form$getFieldAsString, 'zipCode', model.zipCodeForm);
				var _p5 = function () {
					var _p6 = _p9;
					switch (_p6.ctor) {
						case 'Submit':
							var _p7 = _etaque$elm_form$Form$getOutput(model.zipCodeForm);
							if (_p7.ctor === 'Just') {
								var _p8 = zipCodeField.value;
								if (_p8.ctor === 'Just') {
									return {
										ctor: '_Tuple2',
										_0: _elm_lang$core$Native_Utils.update(
											model,
											{status: _CareerPlug$ats$PhoneNumberSelect_Main$Saving}),
										_1: {
											ctor: '::',
											_0: A2(_CareerPlug$ats$PhoneNumberSelect_Main$handleNewphoneNumber, context, _p8._0),
											_1: {ctor: '[]'}
										}
									};
								} else {
									return {
										ctor: '_Tuple2',
										_0: model,
										_1: {ctor: '[]'}
									};
								}
							} else {
								return {
									ctor: '_Tuple2',
									_0: model,
									_1: {ctor: '[]'}
								};
							}
						case 'Input':
							return {
								ctor: '_Tuple2',
								_0: _elm_lang$core$Native_Utils.update(
									model,
									{status: _CareerPlug$ats$PhoneNumberSelect_Main$Ready}),
								_1: {ctor: '[]'}
							};
						default:
							return {
								ctor: '_Tuple2',
								_0: model,
								_1: {ctor: '[]'}
							};
					}
				}();
				var model_ = _p5._0;
				var effects = _p5._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model_,
						{
							zipCodeForm: A3(_etaque$elm_form$Form$update, _CareerPlug$ats$PhoneNumberSelect_Main$validation, _p9, model.zipCodeForm)
						}),
					effectMapper_(effects));
			default:
				if (_p4._0.ctor === 'Err') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								status: _CareerPlug$ats$PhoneNumberSelect_Main$Error('')
							}),
						effectMapper_(
							{ctor: '[]'}));
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{status: _CareerPlug$ats$PhoneNumberSelect_Main$Ready}),
						effectMapper_(
							{ctor: '[]'}));
				}
		}
	});
var _CareerPlug$ats$PhoneNumberSelect_Main$FormMsg = function (a) {
	return {ctor: 'FormMsg', _0: a};
};
var _CareerPlug$ats$PhoneNumberSelect_Main$view = function (model) {
	return A2(
		_elm_lang$html$Html$map,
		function (msg) {
			return _CareerPlug$ats$PhoneNumberSelect_Main$FormMsg(msg);
		},
		_CareerPlug$ats$PhoneNumberSelect_Main$selectView(model));
};
var _CareerPlug$ats$PhoneNumberSelect_Main$NoOp = {ctor: 'NoOp'};

var _krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
	var _p0 = data;
	if (_p0.ctor === 'NotAsked') {
		return true;
	} else {
		return false;
	}
};
var _krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	var _p1 = data;
	if (_p1.ctor === 'Loading') {
		return true;
	} else {
		return false;
	}
};
var _krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	var _p2 = data;
	if (_p2.ctor === 'Failure') {
		return true;
	} else {
		return false;
	}
};
var _krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	var _p3 = data;
	if (_p3.ctor === 'Success') {
		return true;
	} else {
		return false;
	}
};
var _krisajenkins$remotedata$RemoteData$withDefault = F2(
	function ($default, data) {
		var _p4 = data;
		if (_p4.ctor === 'Success') {
			return _p4._0;
		} else {
			return $default;
		}
	});
var _krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {ctor: 'Success', _0: a};
};
var _krisajenkins$remotedata$RemoteData$succeed = _krisajenkins$remotedata$RemoteData$Success;
var _krisajenkins$remotedata$RemoteData$prism = {
	reverseGet: _krisajenkins$remotedata$RemoteData$Success,
	getOption: function (data) {
		var _p5 = data;
		if (_p5.ctor === 'Success') {
			return _elm_lang$core$Maybe$Just(_p5._0);
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	}
};
var _krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {ctor: 'Failure', _0: a};
};
var _krisajenkins$remotedata$RemoteData$fromMaybe = F2(
	function (error, maybe) {
		var _p6 = maybe;
		if (_p6.ctor === 'Nothing') {
			return _krisajenkins$remotedata$RemoteData$Failure(error);
		} else {
			return _krisajenkins$remotedata$RemoteData$Success(_p6._0);
		}
	});
var _krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	var _p7 = result;
	if (_p7.ctor === 'Err') {
		return _krisajenkins$remotedata$RemoteData$Failure(_p7._0);
	} else {
		return _krisajenkins$remotedata$RemoteData$Success(_p7._0);
	}
};
var _krisajenkins$remotedata$RemoteData$asCmd = _elm_lang$core$Task$attempt(_krisajenkins$remotedata$RemoteData$fromResult);
var _krisajenkins$remotedata$RemoteData$sendRequest = _elm_lang$http$Http$send(_krisajenkins$remotedata$RemoteData$fromResult);
var _krisajenkins$remotedata$RemoteData$fromTask = function (_p8) {
	return A2(
		_elm_lang$core$Task$onError,
		function (_p9) {
			return _elm_lang$core$Task$succeed(
				_krisajenkins$remotedata$RemoteData$Failure(_p9));
		},
		A2(_elm_lang$core$Task$map, _krisajenkins$remotedata$RemoteData$Success, _p8));
};
var _krisajenkins$remotedata$RemoteData$Loading = {ctor: 'Loading'};
var _krisajenkins$remotedata$RemoteData$NotAsked = {ctor: 'NotAsked'};
var _krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		var _p10 = data;
		switch (_p10.ctor) {
			case 'Success':
				return _krisajenkins$remotedata$RemoteData$Success(
					f(_p10._0));
			case 'Loading':
				return _krisajenkins$remotedata$RemoteData$Loading;
			case 'NotAsked':
				return _krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return _krisajenkins$remotedata$RemoteData$Failure(_p10._0);
		}
	});
var _krisajenkins$remotedata$RemoteData$toMaybe = function (_p11) {
	return A2(
		_krisajenkins$remotedata$RemoteData$withDefault,
		_elm_lang$core$Maybe$Nothing,
		A2(_krisajenkins$remotedata$RemoteData$map, _elm_lang$core$Maybe$Just, _p11));
};
var _krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		var _p12 = data;
		switch (_p12.ctor) {
			case 'Success':
				return _krisajenkins$remotedata$RemoteData$Success(_p12._0);
			case 'Failure':
				return _krisajenkins$remotedata$RemoteData$Failure(
					f(_p12._0));
			case 'Loading':
				return _krisajenkins$remotedata$RemoteData$Loading;
			default:
				return _krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var _krisajenkins$remotedata$RemoteData$mapBoth = F2(
	function (successFn, errorFn) {
		return function (_p13) {
			return A2(
				_krisajenkins$remotedata$RemoteData$mapError,
				errorFn,
				A2(_krisajenkins$remotedata$RemoteData$map, successFn, _p13));
		};
	});
var _krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		var _p14 = data;
		switch (_p14.ctor) {
			case 'Success':
				return f(_p14._0);
			case 'Failure':
				return _krisajenkins$remotedata$RemoteData$Failure(_p14._0);
			case 'NotAsked':
				return _krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return _krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var _krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _p15 = {ctor: '_Tuple2', _0: wrappedFunction, _1: wrappedValue};
		_v11_5:
		do {
			_v11_4:
			do {
				_v11_3:
				do {
					_v11_2:
					do {
						switch (_p15._0.ctor) {
							case 'Success':
								switch (_p15._1.ctor) {
									case 'Success':
										return _krisajenkins$remotedata$RemoteData$Success(
											_p15._0._0(_p15._1._0));
									case 'Failure':
										break _v11_2;
									case 'Loading':
										break _v11_4;
									default:
										return _krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 'Failure':
								return _krisajenkins$remotedata$RemoteData$Failure(_p15._0._0);
							case 'Loading':
								switch (_p15._1.ctor) {
									case 'Failure':
										break _v11_2;
									case 'Loading':
										break _v11_3;
									case 'NotAsked':
										break _v11_3;
									default:
										break _v11_3;
								}
							default:
								switch (_p15._1.ctor) {
									case 'Failure':
										break _v11_2;
									case 'Loading':
										break _v11_4;
									case 'NotAsked':
										break _v11_5;
									default:
										break _v11_5;
								}
						}
					} while(false);
					return _krisajenkins$remotedata$RemoteData$Failure(_p15._1._0);
				} while(false);
				return _krisajenkins$remotedata$RemoteData$Loading;
			} while(false);
			return _krisajenkins$remotedata$RemoteData$Loading;
		} while(false);
		return _krisajenkins$remotedata$RemoteData$NotAsked;
	});
var _krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			_krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2(_krisajenkins$remotedata$RemoteData$map, f, a));
	});
var _krisajenkins$remotedata$RemoteData$fromList = A2(
	_elm_lang$core$List$foldr,
	_krisajenkins$remotedata$RemoteData$map2(
		F2(
			function (x, y) {
				return {ctor: '::', _0: x, _1: y};
			})),
	_krisajenkins$remotedata$RemoteData$Success(
		{ctor: '[]'}));
var _krisajenkins$remotedata$RemoteData$map3 = F4(
	function (f, a, b, c) {
		return A2(
			_krisajenkins$remotedata$RemoteData$andMap,
			c,
			A2(
				_krisajenkins$remotedata$RemoteData$andMap,
				b,
				A2(_krisajenkins$remotedata$RemoteData$map, f, a)));
	});
var _krisajenkins$remotedata$RemoteData$append = F2(
	function (a, b) {
		return A2(
			_krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2(
				_krisajenkins$remotedata$RemoteData$map,
				F2(
					function (v0, v1) {
						return {ctor: '_Tuple2', _0: v0, _1: v1};
					}),
				a));
	});
var _krisajenkins$remotedata$RemoteData$update = F2(
	function (f, remoteData) {
		var _p16 = remoteData;
		switch (_p16.ctor) {
			case 'Success':
				var _p17 = f(_p16._0);
				var first = _p17._0;
				var second = _p17._1;
				return {
					ctor: '_Tuple2',
					_0: _krisajenkins$remotedata$RemoteData$Success(first),
					_1: second
				};
			case 'NotAsked':
				return {ctor: '_Tuple2', _0: _krisajenkins$remotedata$RemoteData$NotAsked, _1: _elm_lang$core$Platform_Cmd$none};
			case 'Loading':
				return {ctor: '_Tuple2', _0: _krisajenkins$remotedata$RemoteData$Loading, _1: _elm_lang$core$Platform_Cmd$none};
			default:
				return {
					ctor: '_Tuple2',
					_0: _krisajenkins$remotedata$RemoteData$Failure(_p16._0),
					_1: _elm_lang$core$Platform_Cmd$none
				};
		}
	});

var _CareerPlug$ats$Email_Message$Bcc = {ctor: 'Bcc'};
var _CareerPlug$ats$Email_Message$Cc = {ctor: 'Cc'};
var _CareerPlug$ats$Email_Message$PhoneNumberSelectMsg = function (a) {
	return {ctor: 'PhoneNumberSelectMsg', _0: a};
};
var _CareerPlug$ats$Email_Message$FormMsg = function (a) {
	return {ctor: 'FormMsg', _0: a};
};
var _CareerPlug$ats$Email_Message$ACBccMsg = function (a) {
	return {ctor: 'ACBccMsg', _0: a};
};
var _CareerPlug$ats$Email_Message$ACCopyMsg = function (a) {
	return {ctor: 'ACCopyMsg', _0: a};
};
var _CareerPlug$ats$Email_Message$TimezoneUpdated = function (a) {
	return {ctor: 'TimezoneUpdated', _0: a};
};
var _CareerPlug$ats$Email_Message$CloseTimezoneDialog = function (a) {
	return {ctor: 'CloseTimezoneDialog', _0: a};
};
var _CareerPlug$ats$Email_Message$ShowTimezoneDialog = {ctor: 'ShowTimezoneDialog'};
var _CareerPlug$ats$Email_Message$ScheduleButton = function (a) {
	return {ctor: 'ScheduleButton', _0: a};
};
var _CareerPlug$ats$Email_Message$MessageSent = function (a) {
	return {ctor: 'MessageSent', _0: a};
};
var _CareerPlug$ats$Email_Message$EmailDestroyed = function (a) {
	return {ctor: 'EmailDestroyed', _0: a};
};
var _CareerPlug$ats$Email_Message$SendSmsMessage = {ctor: 'SendSmsMessage'};
var _CareerPlug$ats$Email_Message$SendEmail = {ctor: 'SendEmail'};
var _CareerPlug$ats$Email_Message$ScheduleEmail = {ctor: 'ScheduleEmail'};
var _CareerPlug$ats$Email_Message$AttachmentComplete = function (a) {
	return {ctor: 'AttachmentComplete', _0: a};
};
var _CareerPlug$ats$Email_Message$UploadAttachment = function (a) {
	return {ctor: 'UploadAttachment', _0: a};
};
var _CareerPlug$ats$Email_Message$RemoveAttachment = function (a) {
	return {ctor: 'RemoveAttachment', _0: a};
};
var _CareerPlug$ats$Email_Message$AddAttachment = {ctor: 'AddAttachment'};
var _CareerPlug$ats$Email_Message$SelectTemplate = function (a) {
	return {ctor: 'SelectTemplate', _0: a};
};
var _CareerPlug$ats$Email_Message$SwitchTemplate = function (a) {
	return {ctor: 'SwitchTemplate', _0: a};
};
var _CareerPlug$ats$Email_Message$RemoveCarbonItem = F2(
	function (a, b) {
		return {ctor: 'RemoveCarbonItem', _0: a, _1: b};
	});
var _CareerPlug$ats$Email_Message$AddCarbonItem = F3(
	function (a, b, c) {
		return {ctor: 'AddCarbonItem', _0: a, _1: b, _2: c};
	});
var _CareerPlug$ats$Email_Message$acCopyTranslator = _CareerPlug$ats$Features_Autocomplete_Message$translator(
	{
		onInternalMessage: function (msg) {
			return _CareerPlug$ats$Email_Message$ACCopyMsg(msg);
		},
		onUpdated: F2(
			function (utype, val) {
				return A3(_CareerPlug$ats$Email_Message$AddCarbonItem, _CareerPlug$ats$Email_Message$Cc, utype, val);
			})
	});
var _CareerPlug$ats$Email_Message$acBccTranslator = _CareerPlug$ats$Features_Autocomplete_Message$translator(
	{
		onInternalMessage: function (msg) {
			return _CareerPlug$ats$Email_Message$ACBccMsg(msg);
		},
		onUpdated: F2(
			function (utype, val) {
				return A3(_CareerPlug$ats$Email_Message$AddCarbonItem, _CareerPlug$ats$Email_Message$Bcc, utype, val);
			})
	});
var _CareerPlug$ats$Email_Message$ShowCarbon = {ctor: 'ShowCarbon'};
var _CareerPlug$ats$Email_Message$SetFields = function (a) {
	return {ctor: 'SetFields', _0: a};
};
var _CareerPlug$ats$Email_Message$SetRelatedApp = function (a) {
	return {ctor: 'SetRelatedApp', _0: a};
};
var _CareerPlug$ats$Email_Message$SetTemplates = function (a) {
	return {ctor: 'SetTemplates', _0: a};
};
var _CareerPlug$ats$Email_Message$SetExtras = function (a) {
	return {ctor: 'SetExtras', _0: a};
};
var _CareerPlug$ats$Email_Message$SetDefaults = function (a) {
	return {ctor: 'SetDefaults', _0: a};
};
var _CareerPlug$ats$Email_Message$EmailLoaded = function (a) {
	return {ctor: 'EmailLoaded', _0: a};
};
var _CareerPlug$ats$Email_Message$EditEmail = function (a) {
	return {ctor: 'EditEmail', _0: a};
};
var _CareerPlug$ats$Email_Message$ActivateForm = function (a) {
	return {ctor: 'ActivateForm', _0: a};
};
var _CareerPlug$ats$Email_Message$EditorCleared = function (a) {
	return {ctor: 'EditorCleared', _0: a};
};
var _CareerPlug$ats$Email_Message$Reset = {ctor: 'Reset'};
var _CareerPlug$ats$Email_Message$EmailMsg = function (a) {
	return {ctor: 'EmailMsg', _0: a};
};
var _CareerPlug$ats$Email_Message$InitRandIDs = function (a) {
	return {ctor: 'InitRandIDs', _0: a};
};
var _CareerPlug$ats$Email_Message$Discard = {ctor: 'Discard'};
var _CareerPlug$ats$Email_Message$Cancel = {ctor: 'Cancel'};
var _CareerPlug$ats$Email_Message$NoOp = {ctor: 'NoOp'};

var _CareerPlug$ats$Email_Models_Config$blankConfig = {
	authParam: '',
	authToken: '',
	level: 'manage',
	accountId: 0,
	userId: 0,
	userName: '',
	userEmail: '',
	brandName: '',
	timezone: 'America/Chicago',
	signature: false,
	copyDefault: false,
	tinymce: '',
	shareScorecard: false,
	recipients: {ctor: '[]'},
	calendarUsers: {ctor: '[]'},
	inviteExpireOpts: {ctor: '[]'},
	interviewDurationOpts: {ctor: '[]'},
	interviewFutureDays: 14,
	embedded: false,
	accountCanSmsChat: false,
	userCanSmsChat: false
};
var _CareerPlug$ats$Email_Models_Config$Config = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return {authParam: a, authToken: b, level: c, accountId: d, userId: e, userName: f, userEmail: g, brandName: h, timezone: i, signature: j, copyDefault: k, tinymce: l, shareScorecard: m, recipients: n, calendarUsers: o, inviteExpireOpts: p, interviewDurationOpts: q, interviewFutureDays: r, embedded: s, accountCanSmsChat: t, userCanSmsChat: u};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};

var _CareerPlug$ats$Email_Models_EmailForm$emailFields = function (eForm) {
	return {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'addressee',
			_1: _etaque$elm_form$Form_Field$string(eForm.addressee)
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'subject',
				_1: _etaque$elm_form$Form_Field$string(eForm.subject)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'location',
					_1: _etaque$elm_form$Form_Field$string(eForm.location)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'signature',
						_1: _etaque$elm_form$Form_Field$bool(eForm.signature)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'timezone',
							_1: _etaque$elm_form$Form_Field$string(eForm.timezone)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'copy',
								_1: _etaque$elm_form$Form_Field$bool(eForm.copy)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'share',
									_1: _etaque$elm_form$Form_Field$bool(eForm.share)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'share',
										_1: _etaque$elm_form$Form_Field$string(eForm.body)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'scorecard',
											_1: _etaque$elm_form$Form_Field$string(eForm.scorecard)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'interviewer',
												_1: _etaque$elm_form$Form_Field$string(eForm.interviewer)
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple2',
													_0: 'invite_expires_in',
													_1: _etaque$elm_form$Form_Field$string(eForm.invite_expires_in)
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '_Tuple2',
														_0: 'interview_duration',
														_1: _etaque$elm_form$Form_Field$string(eForm.interview_duration)
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '_Tuple2',
															_0: 'interview_future_days',
															_1: _etaque$elm_form$Form_Field$string(
																_elm_lang$core$Basics$toString(eForm.interview_future_days))
														},
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
};
var _CareerPlug$ats$Email_Models_EmailForm$blankEmailForm = {addressee: '', location: '', timezone: '', subject: '', signature: false, copy: false, share: false, body: '', scorecard: '', interviewer: '', invite_expires_in: '', interview_duration: '', interview_future_days: 14};
var _CareerPlug$ats$Email_Models_EmailForm$EmailForm = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return {addressee: a, location: b, timezone: c, subject: d, signature: e, copy: f, share: g, body: h, scorecard: i, interviewer: j, invite_expires_in: k, interview_duration: l, interview_future_days: m};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Email_Models_EmailForm$emailValidate = A2(
	_etaque$elm_form$Form_Validate$andMap,
	A2(_etaque$elm_form$Form_Validate$field, 'interview_future_days', _etaque$elm_form$Form_Validate$int),
	A2(
		_etaque$elm_form$Form_Validate$andMap,
		A2(
			_etaque$elm_form$Form_Validate$field,
			'interview_duration',
			A2(_etaque$elm_form$Form_Validate$andThen, _etaque$elm_form$Form_Validate$nonEmpty, _etaque$elm_form$Form_Validate$string)),
		A2(
			_etaque$elm_form$Form_Validate$andMap,
			A2(
				_etaque$elm_form$Form_Validate$field,
				'invite_expires_in',
				A2(_etaque$elm_form$Form_Validate$andThen, _etaque$elm_form$Form_Validate$nonEmpty, _etaque$elm_form$Form_Validate$string)),
			A2(
				_etaque$elm_form$Form_Validate$andMap,
				A2(
					_etaque$elm_form$Form_Validate$field,
					'interviewer',
					_etaque$elm_form$Form_Validate$oneOf(
						{
							ctor: '::',
							_0: _etaque$elm_form$Form_Validate$emptyString,
							_1: {
								ctor: '::',
								_0: _etaque$elm_form$Form_Validate$string,
								_1: {ctor: '[]'}
							}
						})),
				A2(
					_etaque$elm_form$Form_Validate$andMap,
					A2(
						_etaque$elm_form$Form_Validate$field,
						'scorecard',
						_etaque$elm_form$Form_Validate$oneOf(
							{
								ctor: '::',
								_0: _etaque$elm_form$Form_Validate$emptyString,
								_1: {
									ctor: '::',
									_0: _etaque$elm_form$Form_Validate$string,
									_1: {ctor: '[]'}
								}
							})),
					A2(
						_etaque$elm_form$Form_Validate$andMap,
						A2(
							_etaque$elm_form$Form_Validate$field,
							'body',
							_etaque$elm_form$Form_Validate$oneOf(
								{
									ctor: '::',
									_0: _etaque$elm_form$Form_Validate$emptyString,
									_1: {
										ctor: '::',
										_0: _etaque$elm_form$Form_Validate$string,
										_1: {ctor: '[]'}
									}
								})),
						A2(
							_etaque$elm_form$Form_Validate$andMap,
							A2(_etaque$elm_form$Form_Validate$field, 'share', _etaque$elm_form$Form_Validate$bool),
							A2(
								_etaque$elm_form$Form_Validate$andMap,
								A2(_etaque$elm_form$Form_Validate$field, 'copy', _etaque$elm_form$Form_Validate$bool),
								A2(
									_etaque$elm_form$Form_Validate$andMap,
									A2(_etaque$elm_form$Form_Validate$field, 'signature', _etaque$elm_form$Form_Validate$bool),
									A2(
										_etaque$elm_form$Form_Validate$andMap,
										A2(
											_etaque$elm_form$Form_Validate$field,
											'subject',
											A2(_etaque$elm_form$Form_Validate$andThen, _etaque$elm_form$Form_Validate$nonEmpty, _etaque$elm_form$Form_Validate$string)),
										A2(
											_etaque$elm_form$Form_Validate$andMap,
											A2(
												_etaque$elm_form$Form_Validate$field,
												'timezone',
												_etaque$elm_form$Form_Validate$oneOf(
													{
														ctor: '::',
														_0: _etaque$elm_form$Form_Validate$emptyString,
														_1: {
															ctor: '::',
															_0: _etaque$elm_form$Form_Validate$string,
															_1: {ctor: '[]'}
														}
													})),
											A2(
												_etaque$elm_form$Form_Validate$andMap,
												A2(
													_etaque$elm_form$Form_Validate$field,
													'location',
													_etaque$elm_form$Form_Validate$oneOf(
														{
															ctor: '::',
															_0: _etaque$elm_form$Form_Validate$emptyString,
															_1: {
																ctor: '::',
																_0: _etaque$elm_form$Form_Validate$string,
																_1: {ctor: '[]'}
															}
														})),
												A2(
													_etaque$elm_form$Form_Validate$andMap,
													A2(
														_etaque$elm_form$Form_Validate$field,
														'addressee',
														A2(_etaque$elm_form$Form_Validate$andThen, _etaque$elm_form$Form_Validate$nonEmpty, _etaque$elm_form$Form_Validate$string)),
													_etaque$elm_form$Form_Validate$succeed(_CareerPlug$ats$Email_Models_EmailForm$EmailForm))))))))))))));
var _CareerPlug$ats$Email_Models_EmailForm$smsValidate = A2(
	_etaque$elm_form$Form_Validate$andMap,
	A2(_etaque$elm_form$Form_Validate$field, 'interview_future_days', _etaque$elm_form$Form_Validate$int),
	A2(
		_etaque$elm_form$Form_Validate$andMap,
		A2(
			_etaque$elm_form$Form_Validate$field,
			'interview_duration',
			_etaque$elm_form$Form_Validate$oneOf(
				{
					ctor: '::',
					_0: _etaque$elm_form$Form_Validate$emptyString,
					_1: {
						ctor: '::',
						_0: _etaque$elm_form$Form_Validate$string,
						_1: {ctor: '[]'}
					}
				})),
		A2(
			_etaque$elm_form$Form_Validate$andMap,
			A2(
				_etaque$elm_form$Form_Validate$field,
				'invite_expires_in',
				_etaque$elm_form$Form_Validate$oneOf(
					{
						ctor: '::',
						_0: _etaque$elm_form$Form_Validate$emptyString,
						_1: {
							ctor: '::',
							_0: _etaque$elm_form$Form_Validate$string,
							_1: {ctor: '[]'}
						}
					})),
			A2(
				_etaque$elm_form$Form_Validate$andMap,
				A2(
					_etaque$elm_form$Form_Validate$field,
					'interviewer',
					_etaque$elm_form$Form_Validate$oneOf(
						{
							ctor: '::',
							_0: _etaque$elm_form$Form_Validate$emptyString,
							_1: {
								ctor: '::',
								_0: _etaque$elm_form$Form_Validate$string,
								_1: {ctor: '[]'}
							}
						})),
				A2(
					_etaque$elm_form$Form_Validate$andMap,
					A2(
						_etaque$elm_form$Form_Validate$field,
						'scorecard',
						_etaque$elm_form$Form_Validate$oneOf(
							{
								ctor: '::',
								_0: _etaque$elm_form$Form_Validate$emptyString,
								_1: {
									ctor: '::',
									_0: _etaque$elm_form$Form_Validate$string,
									_1: {ctor: '[]'}
								}
							})),
					A2(
						_etaque$elm_form$Form_Validate$andMap,
						A2(
							_etaque$elm_form$Form_Validate$field,
							'body',
							_etaque$elm_form$Form_Validate$oneOf(
								{
									ctor: '::',
									_0: _etaque$elm_form$Form_Validate$emptyString,
									_1: {
										ctor: '::',
										_0: _etaque$elm_form$Form_Validate$string,
										_1: {ctor: '[]'}
									}
								})),
						A2(
							_etaque$elm_form$Form_Validate$andMap,
							A2(_etaque$elm_form$Form_Validate$field, 'share', _etaque$elm_form$Form_Validate$bool),
							A2(
								_etaque$elm_form$Form_Validate$andMap,
								A2(_etaque$elm_form$Form_Validate$field, 'copy', _etaque$elm_form$Form_Validate$bool),
								A2(
									_etaque$elm_form$Form_Validate$andMap,
									A2(_etaque$elm_form$Form_Validate$field, 'signature', _etaque$elm_form$Form_Validate$bool),
									A2(
										_etaque$elm_form$Form_Validate$andMap,
										A2(
											_etaque$elm_form$Form_Validate$field,
											'subject',
											_etaque$elm_form$Form_Validate$oneOf(
												{
													ctor: '::',
													_0: _etaque$elm_form$Form_Validate$emptyString,
													_1: {
														ctor: '::',
														_0: _etaque$elm_form$Form_Validate$string,
														_1: {ctor: '[]'}
													}
												})),
										A2(
											_etaque$elm_form$Form_Validate$andMap,
											A2(
												_etaque$elm_form$Form_Validate$field,
												'timezone',
												_etaque$elm_form$Form_Validate$oneOf(
													{
														ctor: '::',
														_0: _etaque$elm_form$Form_Validate$emptyString,
														_1: {
															ctor: '::',
															_0: _etaque$elm_form$Form_Validate$string,
															_1: {ctor: '[]'}
														}
													})),
											A2(
												_etaque$elm_form$Form_Validate$andMap,
												A2(
													_etaque$elm_form$Form_Validate$field,
													'location',
													_etaque$elm_form$Form_Validate$oneOf(
														{
															ctor: '::',
															_0: _etaque$elm_form$Form_Validate$emptyString,
															_1: {
																ctor: '::',
																_0: _etaque$elm_form$Form_Validate$string,
																_1: {ctor: '[]'}
															}
														})),
												A2(
													_etaque$elm_form$Form_Validate$andMap,
													A2(
														_etaque$elm_form$Form_Validate$field,
														'addressee',
														_etaque$elm_form$Form_Validate$oneOf(
															{
																ctor: '::',
																_0: _etaque$elm_form$Form_Validate$emptyString,
																_1: {
																	ctor: '::',
																	_0: _etaque$elm_form$Form_Validate$string,
																	_1: {ctor: '[]'}
																}
															})),
													_etaque$elm_form$Form_Validate$succeed(_CareerPlug$ats$Email_Models_EmailForm$EmailForm))))))))))))));

var _CareerPlug$ats$Features_Autocomplete_Model$init = {autoState: _thebritican$elm_autocomplete$Autocomplete$empty, howManyToShow: 5, query: '', selectedItem: _elm_lang$core$Maybe$Nothing, showMenu: false};
var _CareerPlug$ats$Features_Autocomplete_Model$Config = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return {items: a, queryItems: b, toString: c, idToString: d, idFromString: e, domMenuClass: f, domMenuId: g, domInputClass: h, domInputId: i, commitKeys: j};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Features_Autocomplete_Model$Model = F5(
	function (a, b, c, d, e) {
		return {autoState: a, howManyToShow: b, query: c, selectedItem: d, showMenu: e};
	});

var _elm_lang$core$Random$onSelfMsg = F3(
	function (_p1, _p0, seed) {
		return _elm_lang$core$Task$succeed(seed);
	});
var _elm_lang$core$Random$magicNum8 = 2147483562;
var _elm_lang$core$Random$range = function (_p2) {
	return {ctor: '_Tuple2', _0: 0, _1: _elm_lang$core$Random$magicNum8};
};
var _elm_lang$core$Random$magicNum7 = 2147483399;
var _elm_lang$core$Random$magicNum6 = 2147483563;
var _elm_lang$core$Random$magicNum5 = 3791;
var _elm_lang$core$Random$magicNum4 = 40692;
var _elm_lang$core$Random$magicNum3 = 52774;
var _elm_lang$core$Random$magicNum2 = 12211;
var _elm_lang$core$Random$magicNum1 = 53668;
var _elm_lang$core$Random$magicNum0 = 40014;
var _elm_lang$core$Random$step = F2(
	function (_p3, seed) {
		var _p4 = _p3;
		return _p4._0(seed);
	});
var _elm_lang$core$Random$onEffects = F3(
	function (router, commands, seed) {
		var _p5 = commands;
		if (_p5.ctor === '[]') {
			return _elm_lang$core$Task$succeed(seed);
		} else {
			var _p6 = A2(_elm_lang$core$Random$step, _p5._0._0, seed);
			var value = _p6._0;
			var newSeed = _p6._1;
			return A2(
				_elm_lang$core$Task$andThen,
				function (_p7) {
					return A3(_elm_lang$core$Random$onEffects, router, _p5._1, newSeed);
				},
				A2(_elm_lang$core$Platform$sendToApp, router, value));
		}
	});
var _elm_lang$core$Random$listHelp = F4(
	function (list, n, generate, seed) {
		listHelp:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 1) < 0) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$List$reverse(list),
					_1: seed
				};
			} else {
				var _p8 = generate(seed);
				var value = _p8._0;
				var newSeed = _p8._1;
				var _v2 = {ctor: '::', _0: value, _1: list},
					_v3 = n - 1,
					_v4 = generate,
					_v5 = newSeed;
				list = _v2;
				n = _v3;
				generate = _v4;
				seed = _v5;
				continue listHelp;
			}
		}
	});
var _elm_lang$core$Random$minInt = -2147483648;
var _elm_lang$core$Random$maxInt = 2147483647;
var _elm_lang$core$Random$iLogBase = F2(
	function (b, i) {
		return (_elm_lang$core$Native_Utils.cmp(i, b) < 0) ? 1 : (1 + A2(_elm_lang$core$Random$iLogBase, b, (i / b) | 0));
	});
var _elm_lang$core$Random$command = _elm_lang$core$Native_Platform.leaf('Random');
var _elm_lang$core$Random$Generator = function (a) {
	return {ctor: 'Generator', _0: a};
};
var _elm_lang$core$Random$list = F2(
	function (n, _p9) {
		var _p10 = _p9;
		return _elm_lang$core$Random$Generator(
			function (seed) {
				return A4(
					_elm_lang$core$Random$listHelp,
					{ctor: '[]'},
					n,
					_p10._0,
					seed);
			});
	});
var _elm_lang$core$Random$map = F2(
	function (func, _p11) {
		var _p12 = _p11;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p13 = _p12._0(seed0);
				var a = _p13._0;
				var seed1 = _p13._1;
				return {
					ctor: '_Tuple2',
					_0: func(a),
					_1: seed1
				};
			});
	});
var _elm_lang$core$Random$map2 = F3(
	function (func, _p15, _p14) {
		var _p16 = _p15;
		var _p17 = _p14;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p18 = _p16._0(seed0);
				var a = _p18._0;
				var seed1 = _p18._1;
				var _p19 = _p17._0(seed1);
				var b = _p19._0;
				var seed2 = _p19._1;
				return {
					ctor: '_Tuple2',
					_0: A2(func, a, b),
					_1: seed2
				};
			});
	});
var _elm_lang$core$Random$pair = F2(
	function (genA, genB) {
		return A3(
			_elm_lang$core$Random$map2,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			genA,
			genB);
	});
var _elm_lang$core$Random$map3 = F4(
	function (func, _p22, _p21, _p20) {
		var _p23 = _p22;
		var _p24 = _p21;
		var _p25 = _p20;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p26 = _p23._0(seed0);
				var a = _p26._0;
				var seed1 = _p26._1;
				var _p27 = _p24._0(seed1);
				var b = _p27._0;
				var seed2 = _p27._1;
				var _p28 = _p25._0(seed2);
				var c = _p28._0;
				var seed3 = _p28._1;
				return {
					ctor: '_Tuple2',
					_0: A3(func, a, b, c),
					_1: seed3
				};
			});
	});
var _elm_lang$core$Random$map4 = F5(
	function (func, _p32, _p31, _p30, _p29) {
		var _p33 = _p32;
		var _p34 = _p31;
		var _p35 = _p30;
		var _p36 = _p29;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p37 = _p33._0(seed0);
				var a = _p37._0;
				var seed1 = _p37._1;
				var _p38 = _p34._0(seed1);
				var b = _p38._0;
				var seed2 = _p38._1;
				var _p39 = _p35._0(seed2);
				var c = _p39._0;
				var seed3 = _p39._1;
				var _p40 = _p36._0(seed3);
				var d = _p40._0;
				var seed4 = _p40._1;
				return {
					ctor: '_Tuple2',
					_0: A4(func, a, b, c, d),
					_1: seed4
				};
			});
	});
var _elm_lang$core$Random$map5 = F6(
	function (func, _p45, _p44, _p43, _p42, _p41) {
		var _p46 = _p45;
		var _p47 = _p44;
		var _p48 = _p43;
		var _p49 = _p42;
		var _p50 = _p41;
		return _elm_lang$core$Random$Generator(
			function (seed0) {
				var _p51 = _p46._0(seed0);
				var a = _p51._0;
				var seed1 = _p51._1;
				var _p52 = _p47._0(seed1);
				var b = _p52._0;
				var seed2 = _p52._1;
				var _p53 = _p48._0(seed2);
				var c = _p53._0;
				var seed3 = _p53._1;
				var _p54 = _p49._0(seed3);
				var d = _p54._0;
				var seed4 = _p54._1;
				var _p55 = _p50._0(seed4);
				var e = _p55._0;
				var seed5 = _p55._1;
				return {
					ctor: '_Tuple2',
					_0: A5(func, a, b, c, d, e),
					_1: seed5
				};
			});
	});
var _elm_lang$core$Random$andThen = F2(
	function (callback, _p56) {
		var _p57 = _p56;
		return _elm_lang$core$Random$Generator(
			function (seed) {
				var _p58 = _p57._0(seed);
				var result = _p58._0;
				var newSeed = _p58._1;
				var _p59 = callback(result);
				var genB = _p59._0;
				return genB(newSeed);
			});
	});
var _elm_lang$core$Random$State = F2(
	function (a, b) {
		return {ctor: 'State', _0: a, _1: b};
	});
var _elm_lang$core$Random$initState = function (seed) {
	var s = A2(_elm_lang$core$Basics$max, seed, 0 - seed);
	var q = (s / (_elm_lang$core$Random$magicNum6 - 1)) | 0;
	var s2 = A2(_elm_lang$core$Basics_ops['%'], q, _elm_lang$core$Random$magicNum7 - 1);
	var s1 = A2(_elm_lang$core$Basics_ops['%'], s, _elm_lang$core$Random$magicNum6 - 1);
	return A2(_elm_lang$core$Random$State, s1 + 1, s2 + 1);
};
var _elm_lang$core$Random$next = function (_p60) {
	var _p61 = _p60;
	var _p63 = _p61._1;
	var _p62 = _p61._0;
	var k2 = (_p63 / _elm_lang$core$Random$magicNum3) | 0;
	var rawState2 = (_elm_lang$core$Random$magicNum4 * (_p63 - (k2 * _elm_lang$core$Random$magicNum3))) - (k2 * _elm_lang$core$Random$magicNum5);
	var newState2 = (_elm_lang$core$Native_Utils.cmp(rawState2, 0) < 0) ? (rawState2 + _elm_lang$core$Random$magicNum7) : rawState2;
	var k1 = (_p62 / _elm_lang$core$Random$magicNum1) | 0;
	var rawState1 = (_elm_lang$core$Random$magicNum0 * (_p62 - (k1 * _elm_lang$core$Random$magicNum1))) - (k1 * _elm_lang$core$Random$magicNum2);
	var newState1 = (_elm_lang$core$Native_Utils.cmp(rawState1, 0) < 0) ? (rawState1 + _elm_lang$core$Random$magicNum6) : rawState1;
	var z = newState1 - newState2;
	var newZ = (_elm_lang$core$Native_Utils.cmp(z, 1) < 0) ? (z + _elm_lang$core$Random$magicNum8) : z;
	return {
		ctor: '_Tuple2',
		_0: newZ,
		_1: A2(_elm_lang$core$Random$State, newState1, newState2)
	};
};
var _elm_lang$core$Random$split = function (_p64) {
	var _p65 = _p64;
	var _p68 = _p65._1;
	var _p67 = _p65._0;
	var _p66 = _elm_lang$core$Tuple$second(
		_elm_lang$core$Random$next(_p65));
	var t1 = _p66._0;
	var t2 = _p66._1;
	var new_s2 = _elm_lang$core$Native_Utils.eq(_p68, 1) ? (_elm_lang$core$Random$magicNum7 - 1) : (_p68 - 1);
	var new_s1 = _elm_lang$core$Native_Utils.eq(_p67, _elm_lang$core$Random$magicNum6 - 1) ? 1 : (_p67 + 1);
	return {
		ctor: '_Tuple2',
		_0: A2(_elm_lang$core$Random$State, new_s1, t2),
		_1: A2(_elm_lang$core$Random$State, t1, new_s2)
	};
};
var _elm_lang$core$Random$Seed = function (a) {
	return {ctor: 'Seed', _0: a};
};
var _elm_lang$core$Random$int = F2(
	function (a, b) {
		return _elm_lang$core$Random$Generator(
			function (_p69) {
				var _p70 = _p69;
				var _p75 = _p70._0;
				var base = 2147483561;
				var f = F3(
					function (n, acc, state) {
						f:
						while (true) {
							var _p71 = n;
							if (_p71 === 0) {
								return {ctor: '_Tuple2', _0: acc, _1: state};
							} else {
								var _p72 = _p75.next(state);
								var x = _p72._0;
								var nextState = _p72._1;
								var _v27 = n - 1,
									_v28 = x + (acc * base),
									_v29 = nextState;
								n = _v27;
								acc = _v28;
								state = _v29;
								continue f;
							}
						}
					});
				var _p73 = (_elm_lang$core$Native_Utils.cmp(a, b) < 0) ? {ctor: '_Tuple2', _0: a, _1: b} : {ctor: '_Tuple2', _0: b, _1: a};
				var lo = _p73._0;
				var hi = _p73._1;
				var k = (hi - lo) + 1;
				var n = A2(_elm_lang$core$Random$iLogBase, base, k);
				var _p74 = A3(f, n, 1, _p75.state);
				var v = _p74._0;
				var nextState = _p74._1;
				return {
					ctor: '_Tuple2',
					_0: lo + A2(_elm_lang$core$Basics_ops['%'], v, k),
					_1: _elm_lang$core$Random$Seed(
						_elm_lang$core$Native_Utils.update(
							_p75,
							{state: nextState}))
				};
			});
	});
var _elm_lang$core$Random$bool = A2(
	_elm_lang$core$Random$map,
	F2(
		function (x, y) {
			return _elm_lang$core$Native_Utils.eq(x, y);
		})(1),
	A2(_elm_lang$core$Random$int, 0, 1));
var _elm_lang$core$Random$float = F2(
	function (a, b) {
		return _elm_lang$core$Random$Generator(
			function (seed) {
				var _p76 = A2(
					_elm_lang$core$Random$step,
					A2(_elm_lang$core$Random$int, _elm_lang$core$Random$minInt, _elm_lang$core$Random$maxInt),
					seed);
				var number = _p76._0;
				var newSeed = _p76._1;
				var negativeOneToOne = _elm_lang$core$Basics$toFloat(number) / _elm_lang$core$Basics$toFloat(_elm_lang$core$Random$maxInt - _elm_lang$core$Random$minInt);
				var _p77 = (_elm_lang$core$Native_Utils.cmp(a, b) < 0) ? {ctor: '_Tuple2', _0: a, _1: b} : {ctor: '_Tuple2', _0: b, _1: a};
				var lo = _p77._0;
				var hi = _p77._1;
				var scaled = ((lo + hi) / 2) + ((hi - lo) * negativeOneToOne);
				return {ctor: '_Tuple2', _0: scaled, _1: newSeed};
			});
	});
var _elm_lang$core$Random$initialSeed = function (n) {
	return _elm_lang$core$Random$Seed(
		{
			state: _elm_lang$core$Random$initState(n),
			next: _elm_lang$core$Random$next,
			split: _elm_lang$core$Random$split,
			range: _elm_lang$core$Random$range
		});
};
var _elm_lang$core$Random$init = A2(
	_elm_lang$core$Task$andThen,
	function (t) {
		return _elm_lang$core$Task$succeed(
			_elm_lang$core$Random$initialSeed(
				_elm_lang$core$Basics$round(t)));
	},
	_elm_lang$core$Time$now);
var _elm_lang$core$Random$Generate = function (a) {
	return {ctor: 'Generate', _0: a};
};
var _elm_lang$core$Random$generate = F2(
	function (tagger, generator) {
		return _elm_lang$core$Random$command(
			_elm_lang$core$Random$Generate(
				A2(_elm_lang$core$Random$map, tagger, generator)));
	});
var _elm_lang$core$Random$cmdMap = F2(
	function (func, _p78) {
		var _p79 = _p78;
		return _elm_lang$core$Random$Generate(
			A2(_elm_lang$core$Random$map, func, _p79._0));
	});
_elm_lang$core$Native_Platform.effectManagers['Random'] = {pkg: 'elm-lang/core', init: _elm_lang$core$Random$init, onEffects: _elm_lang$core$Random$onEffects, onSelfMsg: _elm_lang$core$Random$onSelfMsg, tag: 'cmd', cmdMap: _elm_lang$core$Random$cmdMap};

var _CareerPlug$ats$Email_Model$userInterviewerFirst = function (model) {
	var partitioned = A2(
		_elm_lang$core$List$partition,
		function (itvr) {
			return _elm_lang$core$Native_Utils.eq(itvr.id, model.config.userId);
		},
		model.interviewers);
	return A2(
		_elm_lang$core$List$append,
		_elm_lang$core$Tuple$first(partitioned),
		_elm_lang$core$Tuple$second(partitioned));
};
var _CareerPlug$ats$Email_Model$attDomName = 'email_attachment_';
var _CareerPlug$ats$Email_Model$templatesInOrder = function (templates) {
	var mtSort = function (mt) {
		return mt.primary ? A2(_elm_lang$core$Basics_ops['++'], '0', mt.name) : A2(_elm_lang$core$Basics_ops['++'], '1', mt.name);
	};
	return A2(
		_elm_lang$core$List$sortBy,
		function (a) {
			return mtSort(
				_elm_lang$core$Tuple$second(a));
		},
		_elm_lang$core$Dict$toList(templates));
};
var _CareerPlug$ats$Email_Model$templatesFromList = function (templates) {
	return _elm_lang$core$Dict$fromList(
		A2(
			_elm_lang$core$List$map,
			function (mt) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Basics$toString(mt.id),
					_1: mt
				};
			},
			templates));
};
var _CareerPlug$ats$Email_Model$idFromString = function (s) {
	var _p0 = _elm_lang$core$String$toInt(s);
	if (_p0.ctor === 'Ok') {
		return _p0._0;
	} else {
		return 0;
	}
};
var _CareerPlug$ats$Email_Model$acceptableItems = F2(
	function (query, items) {
		var lowerQuery = _elm_lang$core$String$toLower(query);
		return A2(
			_elm_lang$core$List$filter,
			function (_p1) {
				return A2(
					_elm_lang$core$String$contains,
					lowerQuery,
					_elm_lang$core$String$toLower(
						_elm_lang$core$Tuple$second(_p1)));
			},
			items);
	});
var _CareerPlug$ats$Email_Model$acConfig = F2(
	function (config, name) {
		return _CareerPlug$ats$Features_Autocomplete_Model$Config(config.recipients)(_CareerPlug$ats$Email_Model$acceptableItems)(_elm_lang$core$Basics$identity)(_elm_lang$core$Basics$toString)(_CareerPlug$ats$Email_Model$idFromString)('autocomplete-list-holder')(
			_elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'email_',
					_1: {
						ctor: '::',
						_0: name,
						_1: {
							ctor: '::',
							_0: '_list',
							_1: {ctor: '[]'}
						}
					}
				}))('form-control')(
			_elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'email_',
					_1: {
						ctor: '::',
						_0: name,
						_1: {
							ctor: '::',
							_0: '_input',
							_1: {ctor: '[]'}
						}
					}
				}))(
			{
				ctor: '::',
				_0: 13,
				_1: {
					ctor: '::',
					_0: 32,
					_1: {
						ctor: '::',
						_0: 188,
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _CareerPlug$ats$Email_Model$CarbonModel = F3(
	function (a, b, c) {
		return {list: a, acModel: b, error: c};
	});
var _CareerPlug$ats$Email_Model$Model = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return function (z) {
																										return function (_1) {
																											return {config: a, randIds: b, emailId: c, status: d, title: e, addressee: f, showCarbon: g, event: h, commands: i, relatedApp: j, templates: k, template: l, scorecards: m, copyField: n, bccField: o, carbonFocus: p, scheduling: q, interviewers: r, invite_expires_in: s, interview_duration: t, attachments: u, serverErrors: v, sending: w, form: x, externalForm: y, emailForm: z, phoneNumberSelect: _1};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Email_Model$None = {ctor: 'None'};
var _CareerPlug$ats$Email_Model$BccField = {ctor: 'BccField'};
var _CareerPlug$ats$Email_Model$CopyField = {ctor: 'CopyField'};
var _CareerPlug$ats$Email_Model$SmsMessage = function (a) {
	return {ctor: 'SmsMessage', _0: a};
};
var _CareerPlug$ats$Email_Model$DefaultTimezone = {ctor: 'DefaultTimezone'};
var _CareerPlug$ats$Email_Model$AppointmentEmail = {ctor: 'AppointmentEmail'};
var _CareerPlug$ats$Email_Model$ICalEmail = {ctor: 'ICalEmail'};
var _CareerPlug$ats$Email_Model$NormalEmail = {ctor: 'NormalEmail'};
var _CareerPlug$ats$Email_Model$Dormant = {ctor: 'Dormant'};
var _CareerPlug$ats$Email_Model$initialModel = {
	config: _CareerPlug$ats$Email_Models_Config$blankConfig,
	randIds: {ctor: '[]'},
	emailId: _elm_lang$core$Maybe$Nothing,
	status: _CareerPlug$ats$Email_Model$Dormant,
	title: 'Sending Email',
	addressee: _elm_lang$core$Maybe$Nothing,
	showCarbon: false,
	event: '',
	commands: '',
	relatedApp: _krisajenkins$remotedata$RemoteData$NotAsked,
	templates: _krisajenkins$remotedata$RemoteData$NotAsked,
	template: _elm_lang$core$Maybe$Nothing,
	scorecards: {ctor: '[]'},
	copyField: {list: _elm_lang$core$Array$empty, acModel: _CareerPlug$ats$Features_Autocomplete_Model$init, error: false},
	bccField: {list: _elm_lang$core$Array$empty, acModel: _CareerPlug$ats$Features_Autocomplete_Model$init, error: false},
	carbonFocus: _CareerPlug$ats$Email_Model$None,
	scheduling: false,
	interviewers: {ctor: '[]'},
	invite_expires_in: {ctor: '[]'},
	interview_duration: {ctor: '[]'},
	attachments: {ctor: '[]'},
	serverErrors: _elm_lang$core$Dict$empty,
	sending: false,
	form: A2(
		_etaque$elm_form$Form$initial,
		_CareerPlug$ats$Email_Models_EmailForm$emailFields(_CareerPlug$ats$Email_Models_EmailForm$blankEmailForm),
		_CareerPlug$ats$Email_Models_EmailForm$emailValidate),
	externalForm: _CareerPlug$ats$Email_Models_ExternalForm$blankExternalForm,
	emailForm: _elm_lang$core$Maybe$Nothing,
	phoneNumberSelect: _CareerPlug$ats$PhoneNumberSelect_Main$initialModel
};
var _CareerPlug$ats$Email_Model$init = function (flags) {
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$Email_Model$initialModel,
			{config: flags}),
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Random$generate,
				_CareerPlug$ats$Email_Message$InitRandIDs,
				A2(
					_elm_lang$core$Random$list,
					50,
					A2(_elm_lang$core$Random$int, 0, _elm_lang$core$Random$maxInt))),
			_1: {ctor: '[]'}
		});
};

var _CareerPlug$ats$Email_Models_SmsMessage$smsMessageAsJson = function (smsMessage) {
	var eventType = function () {
		var _p0 = smsMessage.event_type;
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Json_Encode$string(_p0._0);
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	}();
	var eventId = function () {
		var _p1 = smsMessage.event_id;
		if (_p1.ctor === 'Just') {
			return _elm_lang$core$Json_Encode$int(_p1._0);
		} else {
			return _elm_lang$core$Json_Encode$null;
		}
	}();
	return {
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'event_type', _1: eventType},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'event_id', _1: eventId},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'message',
					_1: _elm_lang$core$Json_Encode$string(smsMessage.message)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'account_id',
						_1: _elm_lang$core$Json_Encode$int(smsMessage.account_id)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'invite_schedule',
							_1: _CareerPlug$ats$Library_Core$boolEncoder(smsMessage.invite_schedule)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'location',
								_1: _elm_lang$core$Json_Encode$string(smsMessage.location)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'interviewer_id',
									_1: _elm_lang$core$Json_Encode$int(smsMessage.interviewer_id)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'invite_expires_in',
										_1: _elm_lang$core$Json_Encode$int(smsMessage.invite_expires_in)
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'interview_duration',
											_1: _elm_lang$core$Json_Encode$int(smsMessage.interview_duration)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'interview_future_days',
												_1: _elm_lang$core$Json_Encode$int(smsMessage.interview_future_days)
											},
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
};
var _CareerPlug$ats$Email_Models_SmsMessage$SmsMessage = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return {account_id: a, event_type: b, event_id: c, invite_schedule: d, interview_duration: e, interview_future_days: f, interviewer_id: g, invite_expires_in: h, location: i, message: j};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};

var _CareerPlug$ats$Email_Ports$email = _elm_lang$core$Native_Platform.incomingPort('email', _elm_lang$core$Json_Decode$value);
var _CareerPlug$ats$Email_Ports$emailFields = _elm_lang$core$Native_Platform.incomingPort(
	'emailFields',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (body) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (date) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (startTime) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (endTime) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (scheduleDate) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (scheduleTime) {
													return _elm_lang$core$Json_Decode$succeed(
														{body: body, date: date, startTime: startTime, endTime: endTime, scheduleDate: scheduleDate, scheduleTime: scheduleTime});
												},
												A2(_elm_lang$core$Json_Decode$field, 'scheduleTime', _elm_lang$core$Json_Decode$string));
										},
										A2(_elm_lang$core$Json_Decode$field, 'scheduleDate', _elm_lang$core$Json_Decode$string));
								},
								A2(_elm_lang$core$Json_Decode$field, 'endTime', _elm_lang$core$Json_Decode$string));
						},
						A2(_elm_lang$core$Json_Decode$field, 'startTime', _elm_lang$core$Json_Decode$string));
				},
				A2(_elm_lang$core$Json_Decode$field, 'date', _elm_lang$core$Json_Decode$string));
		},
		A2(_elm_lang$core$Json_Decode$field, 'body', _elm_lang$core$Json_Decode$string)));
var _CareerPlug$ats$Email_Ports$emailMsg = _elm_lang$core$Native_Platform.incomingPort(
	'emailMsg',
	_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
var _CareerPlug$ats$Email_Ports$subscriptions = function (model) {
	var acSub = function () {
		var _p0 = model.carbonFocus;
		switch (_p0.ctor) {
			case 'CopyField':
				return A2(
					_elm_lang$core$Platform_Sub$map,
					function (msg) {
						return _CareerPlug$ats$Email_Message$ACCopyMsg(
							_CareerPlug$ats$Features_Autocomplete_Message$SetAutoState(msg));
					},
					_thebritican$elm_autocomplete$Autocomplete$subscription);
			case 'BccField':
				return A2(
					_elm_lang$core$Platform_Sub$map,
					function (msg) {
						return _CareerPlug$ats$Email_Message$ACBccMsg(
							_CareerPlug$ats$Features_Autocomplete_Message$SetAutoState(msg));
					},
					_thebritican$elm_autocomplete$Autocomplete$subscription);
			default:
				return _elm_lang$core$Platform_Sub$none;
		}
	}();
	return _elm_lang$core$Platform_Sub$batch(
		{
			ctor: '::',
			_0: acSub,
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$Email_Ports$email(_CareerPlug$ats$Email_Message$ActivateForm),
				_1: {
					ctor: '::',
					_0: _CareerPlug$ats$Email_Ports$emailFields(_CareerPlug$ats$Email_Message$SetFields),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailMsg(_CareerPlug$ats$Email_Message$EmailMsg),
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _CareerPlug$ats$Email_Ports$emailResponse = _elm_lang$core$Native_Platform.outgoingPort(
	'emailResponse',
	function (v) {
		return [v._0, v._1];
	});

var _CareerPlug$ats$Email_Service$updateUserTZHttp = F2(
	function (cfg, tz) {
		var body = _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'user',
					_1: _elm_lang$core$Json_Encode$object(
						{
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'selected_timezone',
								_1: _elm_lang$core$Json_Encode$string(tz)
							},
							_1: {ctor: '[]'}
						})
				},
				_1: {ctor: '[]'}
			});
		var url = _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: '/manage/users/',
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(cfg.userId),
					_1: {
						ctor: '::',
						_0: '.json',
						_1: {ctor: '[]'}
					}
				}
			});
		return _elm_lang$http$Http$request(
			{
				method: 'PATCH',
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', cfg.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: url,
				body: _elm_lang$http$Http$jsonBody(body),
				expect: _elm_lang$http$Http$expectStringResponse(
					function (_p0) {
						return _elm_lang$core$Result$Ok(
							{ctor: '_Tuple0'});
					}),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _CareerPlug$ats$Email_Service$updateUserTimezone = F2(
	function (config, tz) {
		return A2(
			_elm_lang$http$Http$send,
			_CareerPlug$ats$Email_Message$TimezoneUpdated,
			A2(_CareerPlug$ats$Email_Service$updateUserTZHttp, config, tz));
	});
var _CareerPlug$ats$Email_Service$composeEmail = F3(
	function (model, eForm, extForm) {
		var prepareEmails = function (emailsList) {
			var formatEmail = function (val) {
				var sub = A2(
					_elm_lang$core$Maybe$andThen,
					function (match) {
						return _elm_lang$core$List$head(match.submatches);
					},
					_elm_lang$core$List$head(
						A3(
							_elm_lang$core$Regex$find,
							_elm_lang$core$Regex$All,
							_elm_lang$core$Regex$regex('<(.*)>'),
							val)));
				var _p1 = sub;
				if (_p1.ctor === 'Just') {
					return A2(_elm_lang$core$Maybe$withDefault, val, _p1._0);
				} else {
					return val;
				}
			};
			return A2(
				_elm_lang$core$String$join,
				', ',
				_elm_lang$core$Array$toList(
					A2(
						_elm_lang$core$Array$map,
						formatEmail,
						A2(_elm_lang$core$Array$map, _elm_lang$core$Tuple$second, emailsList))));
		};
		var _p2 = function () {
			var _p3 = model.status;
			switch (_p3.ctor) {
				case 'ICalEmail':
					return {ctor: '_Tuple2', _0: true, _1: false};
				case 'AppointmentEmail':
					return {ctor: '_Tuple2', _0: false, _1: true};
				default:
					return {ctor: '_Tuple2', _0: false, _1: false};
			}
		}();
		var invite = _p2._0;
		var invite_schedule = _p2._1;
		var _p4 = model.scheduling ? {ctor: '_Tuple2', _0: extForm.scheduleDate, _1: extForm.scheduleTime} : {ctor: '_Tuple2', _0: '', _1: ''};
		var schedDate = _p4._0;
		var schedTime = _p4._1;
		var intv_duration = function () {
			var _p5 = _elm_lang$core$String$toInt(eForm.interview_duration);
			if (_p5.ctor === 'Err') {
				return 30;
			} else {
				return _p5._0;
			}
		}();
		var expires_in = function () {
			var _p6 = _elm_lang$core$String$toInt(eForm.invite_expires_in);
			if (_p6.ctor === 'Err') {
				return 7;
			} else {
				return _p6._0;
			}
		}();
		var interviewer = function () {
			var _p7 = {
				ctor: '_Tuple2',
				_0: _elm_lang$core$List$head(
					_CareerPlug$ats$Email_Model$userInterviewerFirst(model)),
				_1: _elm_lang$core$String$toInt(eForm.interviewer)
			};
			_v4_2:
			do {
				if (_p7.ctor === '_Tuple2') {
					if (_p7._1.ctor === 'Err') {
						if (_p7._0.ctor === 'Just') {
							return _p7._0._0.id;
						} else {
							break _v4_2;
						}
					} else {
						return _p7._1._0;
					}
				} else {
					break _v4_2;
				}
			} while(false);
			return 0;
		}();
		var scorecard = function () {
			var _p8 = {
				ctor: '_Tuple2',
				_0: _elm_lang$core$List$head(model.scorecards),
				_1: _elm_lang$core$String$toInt(eForm.scorecard)
			};
			_v5_2:
			do {
				if (_p8.ctor === '_Tuple2') {
					if (_p8._1.ctor === 'Err') {
						if (_p8._0.ctor === 'Just') {
							return _p8._0._0.id;
						} else {
							break _v5_2;
						}
					} else {
						return _p8._1._0;
					}
				} else {
					break _v5_2;
				}
			} while(false);
			return 0;
		}();
		return {
			id: model.emailId,
			event: model.event,
			commands: model.commands,
			to: eForm.addressee,
			subject: eForm.subject,
			body: extForm.body,
			copy: eForm.copy,
			account_id: model.config.accountId,
			invite: invite,
			invite_schedule: invite_schedule,
			cc: prepareEmails(model.copyField.list),
			cc_list: {ctor: '[]'},
			bcc: prepareEmails(model.bccField.list),
			bcc_list: {ctor: '[]'},
			date: extForm.date,
			start_time: extForm.startTime,
			end_time: extForm.endTime,
			timezone: eForm.timezone,
			location: eForm.location,
			interviewer_id: interviewer,
			invite_expires_in: expires_in,
			interview_duration: intv_duration,
			interview_future_days: eForm.interview_future_days,
			share: eForm.share,
			scorecard_id: scorecard,
			include_signature: eForm.signature,
			scheduled_date: schedDate,
			scheduled_time: schedTime,
			attachments: A2(
				_elm_lang$core$List$filter,
				function (att) {
					return !(att.newRecord && att.destroy);
				},
				model.attachments)
		};
	});
var _CareerPlug$ats$Email_Service$composeSmsMessage = F3(
	function (model, eForm, extForm) {
		var event_id = function () {
			var appUpdateId = A2(
				_elm_lang$core$Maybe$map,
				_elm_lang$core$String$toInt,
				_elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$drop,
						1,
						A2(_elm_lang$core$String$split, ':', model.event))));
			var _p9 = appUpdateId;
			if (_p9.ctor === 'Just') {
				var _p10 = _p9._0;
				if (_p10.ctor === 'Ok') {
					return _elm_lang$core$Maybe$Just(_p10._0);
				} else {
					return _elm_lang$core$Maybe$Nothing;
				}
			} else {
				return _elm_lang$core$Maybe$Nothing;
			}
		}();
		var event_type = _elm_lang$core$List$head(
			A2(_elm_lang$core$String$split, ':', model.event));
		var invite_schedule = function () {
			var _p11 = model.status;
			if (_p11.ctor === 'SmsMessage') {
				return _p11._0;
			} else {
				return false;
			}
		}();
		var intv_duration = function () {
			var _p12 = _elm_lang$core$String$toInt(eForm.interview_duration);
			if (_p12.ctor === 'Err') {
				return 30;
			} else {
				return _p12._0;
			}
		}();
		var expires_in = function () {
			var _p13 = _elm_lang$core$String$toInt(eForm.invite_expires_in);
			if (_p13.ctor === 'Err') {
				return 7;
			} else {
				return _p13._0;
			}
		}();
		var interviewer = function () {
			var _p14 = {
				ctor: '_Tuple2',
				_0: _elm_lang$core$List$head(
					_CareerPlug$ats$Email_Model$userInterviewerFirst(model)),
				_1: _elm_lang$core$String$toInt(eForm.interviewer)
			};
			_v11_2:
			do {
				if (_p14.ctor === '_Tuple2') {
					if (_p14._1.ctor === 'Err') {
						if (_p14._0.ctor === 'Just') {
							return _p14._0._0.id;
						} else {
							break _v11_2;
						}
					} else {
						return _p14._1._0;
					}
				} else {
					break _v11_2;
				}
			} while(false);
			return 0;
		}();
		return {event_type: event_type, event_id: event_id, message: extForm.body, account_id: model.config.accountId, location: eForm.location, invite_schedule: invite_schedule, interviewer_id: interviewer, invite_expires_in: expires_in, interview_duration: intv_duration, interview_future_days: eForm.interview_future_days};
	});
var _CareerPlug$ats$Email_Service$retrieveRequest = F3(
	function (cfg, url, expect) {
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', cfg.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: url,
				body: _elm_lang$http$Http$emptyBody,
				expect: expect,
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _CareerPlug$ats$Email_Service$serverUrl = F2(
	function (cfg, rest) {
		return _elm_lang$core$String$concat(
			A2(
				_elm_lang$core$Basics_ops['++'],
				{
					ctor: '::',
					_0: '/',
					_1: {
						ctor: '::',
						_0: cfg.level,
						_1: {
							ctor: '::',
							_0: '/emails',
							_1: {ctor: '[]'}
						}
					}
				},
				rest));
	});
var _CareerPlug$ats$Email_Service$emailUrl = F2(
	function (cfg, eId) {
		return A2(
			_CareerPlug$ats$Email_Service$serverUrl,
			cfg,
			{
				ctor: '::',
				_0: '/',
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(eId),
					_1: {
						ctor: '::',
						_0: '.json',
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _CareerPlug$ats$Email_Service$loadEmailHttp = F2(
	function (cfg, emailId) {
		var url = A2(_CareerPlug$ats$Email_Service$emailUrl, cfg, emailId);
		return _elm_lang$http$Http$request(
			{
				method: 'GET',
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', cfg.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: url,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$Email_Models_Email$jsonEmail),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _CareerPlug$ats$Email_Service$loadEmail = F2(
	function (config, emailId) {
		return A2(
			_elm_lang$http$Http$send,
			_CareerPlug$ats$Email_Message$EmailLoaded,
			A2(_CareerPlug$ats$Email_Service$loadEmailHttp, config, emailId));
	});
var _CareerPlug$ats$Email_Service$retrieveTemplatesHttp = F2(
	function (cfg, query) {
		var url = A2(
			_CareerPlug$ats$Email_Service$serverUrl,
			cfg,
			{
				ctor: '::',
				_0: '/preview.json?',
				_1: {
					ctor: '::',
					_0: query,
					_1: {ctor: '[]'}
				}
			});
		return A3(
			_CareerPlug$ats$Email_Service$retrieveRequest,
			cfg,
			url,
			_elm_lang$http$Http$expectJson(
				_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Models_MessageTemplate$jsonMessageTemplate)));
	});
var _CareerPlug$ats$Email_Service$retrieveTemplates = F2(
	function (cfg, query) {
		return A2(
			_elm_lang$core$Platform_Cmd$map,
			_CareerPlug$ats$Email_Message$SetTemplates,
			_krisajenkins$remotedata$RemoteData$sendRequest(
				A2(_CareerPlug$ats$Email_Service$retrieveTemplatesHttp, cfg, query)));
	});
var _CareerPlug$ats$Email_Service$retrieveRelatedAppHttp = F2(
	function (cfg, event) {
		var url = A2(
			_CareerPlug$ats$Email_Service$serverUrl,
			cfg,
			{
				ctor: '::',
				_0: '/app.json?event=',
				_1: {
					ctor: '::',
					_0: event,
					_1: {ctor: '[]'}
				}
			});
		return A3(
			_CareerPlug$ats$Email_Service$retrieveRequest,
			cfg,
			url,
			_elm_lang$http$Http$expectJson(_CareerPlug$ats$Email_Models_RelatedApp$jsonRelatedApp));
	});
var _CareerPlug$ats$Email_Service$retrieveRelatedApp = F2(
	function (cfg, event) {
		return A2(
			_elm_lang$core$Platform_Cmd$map,
			_CareerPlug$ats$Email_Message$SetRelatedApp,
			_krisajenkins$remotedata$RemoteData$sendRequest(
				A2(_CareerPlug$ats$Email_Service$retrieveRelatedAppHttp, cfg, event)));
	});
var _CareerPlug$ats$Email_Service$jsonAppId = _elm_lang$core$Json_Decode$oneOf(
	{
		ctor: '::',
		_0: A2(
			_elm_lang$core$Json_Decode$map,
			_elm_lang$core$Maybe$Just,
			A2(_elm_lang$core$Json_Decode$field, 'app', _elm_lang$core$Json_Decode$int)),
		_1: {
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing),
			_1: {ctor: '[]'}
		}
	});
var _CareerPlug$ats$Email_Service$saveEmailHttp = F2(
	function (cfg, email) {
		var body = _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'email',
					_1: _elm_lang$core$Json_Encode$object(
						_CareerPlug$ats$Email_Models_Email$emailAsJson(email))
				},
				_1: {ctor: '[]'}
			});
		var _p15 = function () {
			var _p16 = email.id;
			if (_p16.ctor === 'Just') {
				return {
					ctor: '_Tuple2',
					_0: A2(_CareerPlug$ats$Email_Service$emailUrl, cfg, _p16._0),
					_1: 'PATCH'
				};
			} else {
				return {
					ctor: '_Tuple2',
					_0: A2(
						_CareerPlug$ats$Email_Service$serverUrl,
						cfg,
						{
							ctor: '::',
							_0: '.json',
							_1: {ctor: '[]'}
						}),
					_1: 'POST'
				};
			}
		}();
		var url = _p15._0;
		var verb = _p15._1;
		return _elm_lang$http$Http$request(
			{
				method: verb,
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', cfg.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: url,
				body: _elm_lang$http$Http$jsonBody(body),
				expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$Email_Service$jsonAppId),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _CareerPlug$ats$Email_Service$saveEmail = F2(
	function (config, email) {
		return A2(
			_elm_lang$http$Http$send,
			_CareerPlug$ats$Email_Message$MessageSent,
			A2(_CareerPlug$ats$Email_Service$saveEmailHttp, config, email));
	});
var _CareerPlug$ats$Email_Service$saveSmsMessageHttp = F2(
	function (cfg, smsMessage) {
		var body = _elm_lang$core$Json_Encode$object(
			_CareerPlug$ats$Email_Models_SmsMessage$smsMessageAsJson(smsMessage));
		return _elm_lang$http$Http$request(
			{
				method: 'POST',
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', cfg.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: '/manage/outbound_sms_messages.json',
				body: _elm_lang$http$Http$jsonBody(body),
				expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$Email_Service$jsonAppId),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _CareerPlug$ats$Email_Service$saveSmsMessage = F2(
	function (config, smsMessage) {
		return A2(
			_elm_lang$http$Http$send,
			_CareerPlug$ats$Email_Message$MessageSent,
			A2(_CareerPlug$ats$Email_Service$saveSmsMessageHttp, config, smsMessage));
	});
var _CareerPlug$ats$Email_Service$destroyEmailHttp = F2(
	function (cfg, emailId) {
		var url = A2(_CareerPlug$ats$Email_Service$emailUrl, cfg, emailId);
		return _elm_lang$http$Http$request(
			{
				method: 'DELETE',
				headers: {
					ctor: '::',
					_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', cfg.authToken),
						_1: {ctor: '[]'}
					}
				},
				url: url,
				body: _elm_lang$http$Http$emptyBody,
				expect: _elm_lang$http$Http$expectJson(_CareerPlug$ats$Email_Service$jsonAppId),
				timeout: _elm_lang$core$Maybe$Nothing,
				withCredentials: false
			});
	});
var _CareerPlug$ats$Email_Service$destroyEmail = F2(
	function (config, emailId) {
		return A2(
			_elm_lang$http$Http$send,
			_CareerPlug$ats$Email_Message$EmailDestroyed,
			A2(_CareerPlug$ats$Email_Service$destroyEmailHttp, config, emailId));
	});
var _CareerPlug$ats$Email_Service$jsonServerErrors = _elm_lang$core$Json_Decode$oneOf(
	{
		ctor: '::',
		_0: A2(_elm_lang$core$Json_Decode$field, 'errors', _CareerPlug$ats$Models_Common$jsonErrors),
		_1: {
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Dict$empty),
			_1: {ctor: '[]'}
		}
	});
var _CareerPlug$ats$Email_Service$importActivate = function (val) {
	return A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$Email_Models_Activate$jsonActivate, val);
};

var _CareerPlug$ats$Features_Autocomplete_Update$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			var _p0 = list;
			if (_p0.ctor === '[]') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p1 = _p0._0;
				if (predicate(_p1)) {
					return _elm_lang$core$Maybe$Just(_p1);
				} else {
					var _v1 = predicate,
						_v2 = _p0._1;
					predicate = _v1;
					list = _v2;
					continue find;
				}
			}
		}
	});
var _CareerPlug$ats$Features_Autocomplete_Update$updateConfig = function (config) {
	return _thebritican$elm_autocomplete$Autocomplete$updateConfig(
		{
			toId: function (_p2) {
				var _p3 = _p2;
				return config.idToString(_p3._0);
			},
			onKeyDown: F2(
				function (code, maybeId) {
					return (_elm_lang$core$Native_Utils.eq(code, 38) || _elm_lang$core$Native_Utils.eq(code, 40)) ? A2(_elm_lang$core$Maybe$map, _CareerPlug$ats$Features_Autocomplete_Message$PreviewItem, maybeId) : (_elm_lang$core$Native_Utils.eq(code, 13) ? A2(_elm_lang$core$Maybe$map, _CareerPlug$ats$Features_Autocomplete_Message$SelectItemKeyboard, maybeId) : _elm_lang$core$Maybe$Just(_CareerPlug$ats$Features_Autocomplete_Message$Reset));
				}),
			onTooLow: _elm_lang$core$Maybe$Just(
				_CareerPlug$ats$Features_Autocomplete_Message$Wrap(false)),
			onTooHigh: _elm_lang$core$Maybe$Just(
				_CareerPlug$ats$Features_Autocomplete_Message$Wrap(true)),
			onMouseEnter: function (id) {
				return _elm_lang$core$Maybe$Just(
					_CareerPlug$ats$Features_Autocomplete_Message$PreviewItem(id));
			},
			onMouseLeave: function (_p4) {
				return _elm_lang$core$Maybe$Nothing;
			},
			onMouseClick: function (id) {
				return _elm_lang$core$Maybe$Just(
					_CareerPlug$ats$Features_Autocomplete_Message$SelectItemMouse(id));
			},
			separateSelections: false
		});
};
var _CareerPlug$ats$Features_Autocomplete_Update$resetMenu = function (model) {
	return _elm_lang$core$Native_Utils.update(
		model,
		{autoState: _thebritican$elm_autocomplete$Autocomplete$empty, showMenu: false});
};
var _CareerPlug$ats$Features_Autocomplete_Update$getItemAtId = F2(
	function (id, items) {
		return A2(
			_elm_lang$core$Maybe$map,
			_elm_lang$core$Tuple$second,
			A2(
				_CareerPlug$ats$Features_Autocomplete_Update$find,
				function (_p5) {
					var _p6 = _p5;
					return _elm_lang$core$Native_Utils.eq(id, _p6._0);
				},
				items));
	});
var _CareerPlug$ats$Features_Autocomplete_Update$setQuery = F3(
	function (config, model, id) {
		return _elm_lang$core$Native_Utils.update(
			model,
			{
				query: A2(
					_elm_lang$core$Maybe$withDefault,
					model.query,
					A2(
						_elm_lang$core$Maybe$map,
						config.toString,
						A2(_CareerPlug$ats$Features_Autocomplete_Update$getItemAtId, id, config.items))),
				selectedItem: _elm_lang$core$Maybe$Just(id)
			});
	});
var _CareerPlug$ats$Features_Autocomplete_Update$removeSelection = function (model) {
	return _elm_lang$core$Native_Utils.update(
		model,
		{selectedItem: _elm_lang$core$Maybe$Nothing});
};
var _CareerPlug$ats$Features_Autocomplete_Update$resetInput = function (model) {
	return _CareerPlug$ats$Features_Autocomplete_Update$resetMenu(
		_CareerPlug$ats$Features_Autocomplete_Update$removeSelection(
			_elm_lang$core$Native_Utils.update(
				model,
				{query: ''})));
};
var _CareerPlug$ats$Features_Autocomplete_Update$handleUpdate = F3(
	function (utype, config, model) {
		var query = A2(
			_elm_lang$core$Maybe$withDefault,
			model.query,
			A2(
				_elm_lang$core$Maybe$map,
				config.toString,
				A2(
					_elm_lang$core$Maybe$andThen,
					function (id) {
						return A2(_CareerPlug$ats$Features_Autocomplete_Update$getItemAtId, id, config.items);
					},
					model.selectedItem)));
		var effects = (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(query),
			0) > 0) ? {
			ctor: '::',
			_0: _CareerPlug$ats$Library_Update$msgEffect(
				_CareerPlug$ats$Features_Autocomplete_Message$ForParent(
					A2(_CareerPlug$ats$Features_Autocomplete_Message$Updated, utype, query))),
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		return A2(
			_elm_lang$core$Platform_Cmd_ops['!'],
			_elm_lang$core$Native_Utils.update(
				model,
				{selectedItem: _elm_lang$core$Maybe$Nothing, query: '', showMenu: false}),
			effects);
	});
var _CareerPlug$ats$Features_Autocomplete_Update$update = F3(
	function (config, msg, model) {
		update:
		while (true) {
			var _p7 = msg;
			switch (_p7.ctor) {
				case 'SetQuery':
					var _p9 = _p7._0;
					var showMenu = function (_p8) {
						return !_elm_lang$core$List$isEmpty(_p8);
					}(
						A2(config.queryItems, _p9, config.items));
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{query: _p9, showMenu: showMenu, selectedItem: _elm_lang$core$Maybe$Nothing}),
						{ctor: '[]'});
				case 'SetAutoState':
					var _p10 = A5(
						_thebritican$elm_autocomplete$Autocomplete$update,
						_CareerPlug$ats$Features_Autocomplete_Update$updateConfig(config),
						_p7._0,
						model.howManyToShow,
						model.autoState,
						A2(config.queryItems, model.query, config.items));
					var newState = _p10._0;
					var maybeMsg = _p10._1;
					var newModel = _elm_lang$core$Native_Utils.update(
						model,
						{autoState: newState});
					var _p11 = maybeMsg;
					if (_p11.ctor === 'Nothing') {
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							newModel,
							{ctor: '[]'});
					} else {
						var _v7 = config,
							_v8 = _p11._0,
							_v9 = newModel;
						config = _v7;
						msg = _v8;
						model = _v9;
						continue update;
					}
				case 'HandleEscape':
					var validOptions = !_elm_lang$core$List$isEmpty(
						A2(config.queryItems, model.query, config.items));
					var handleEscape = validOptions ? _CareerPlug$ats$Features_Autocomplete_Update$resetMenu(
						_CareerPlug$ats$Features_Autocomplete_Update$removeSelection(model)) : _CareerPlug$ats$Features_Autocomplete_Update$resetMenu(
						_CareerPlug$ats$Features_Autocomplete_Update$removeSelection(
							_elm_lang$core$Native_Utils.update(
								model,
								{query: ''})));
					var escapedModel = A2(
						_elm_lang$core$Maybe$withDefault,
						handleEscape,
						A2(
							_elm_lang$core$Maybe$map,
							function (name) {
								return _elm_lang$core$Native_Utils.eq(model.query, name) ? _CareerPlug$ats$Features_Autocomplete_Update$resetInput(model) : handleEscape;
							},
							A2(
								_elm_lang$core$Maybe$map,
								config.toString,
								A2(
									_elm_lang$core$Maybe$andThen,
									function (id) {
										return A2(_CareerPlug$ats$Features_Autocomplete_Update$getItemAtId, id, config.items);
									},
									model.selectedItem))));
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						escapedModel,
						{ctor: '[]'});
				case 'Wrap':
					var _p12 = model.selectedItem;
					if (_p12.ctor === 'Just') {
						var _v11 = config,
							_v12 = _CareerPlug$ats$Features_Autocomplete_Message$Reset,
							_v13 = model;
						config = _v11;
						msg = _v12;
						model = _v13;
						continue update;
					} else {
						var matchedItems = A2(config.queryItems, model.query, config.items);
						return _p7._0 ? A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{
									autoState: A4(
										_thebritican$elm_autocomplete$Autocomplete$resetToLastItem,
										_CareerPlug$ats$Features_Autocomplete_Update$updateConfig(config),
										matchedItems,
										model.howManyToShow,
										model.autoState),
									selectedItem: A2(
										_elm_lang$core$Maybe$map,
										_elm_lang$core$Tuple$first,
										_elm_lang$core$List$head(
											_elm_lang$core$List$reverse(
												A2(_elm_lang$core$List$take, model.howManyToShow, matchedItems))))
								}),
							{ctor: '[]'}) : A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{
									autoState: A4(
										_thebritican$elm_autocomplete$Autocomplete$resetToFirstItem,
										_CareerPlug$ats$Features_Autocomplete_Update$updateConfig(config),
										matchedItems,
										model.howManyToShow,
										model.autoState),
									selectedItem: A2(
										_elm_lang$core$Maybe$map,
										_elm_lang$core$Tuple$first,
										_elm_lang$core$List$head(
											A2(_elm_lang$core$List$take, model.howManyToShow, matchedItems)))
								}),
							{ctor: '[]'});
					}
				case 'Reset':
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								autoState: A2(
									_thebritican$elm_autocomplete$Autocomplete$reset,
									_CareerPlug$ats$Features_Autocomplete_Update$updateConfig(config),
									model.autoState),
								selectedItem: _elm_lang$core$Maybe$Nothing
							}),
						{ctor: '[]'});
				case 'SelectItemKeyboard':
					var newModel = _CareerPlug$ats$Features_Autocomplete_Update$resetMenu(
						A3(
							_CareerPlug$ats$Features_Autocomplete_Update$setQuery,
							config,
							model,
							config.idFromString(_p7._0)));
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						newModel,
						{ctor: '[]'});
				case 'SelectItemMouse':
					var newModel = _CareerPlug$ats$Features_Autocomplete_Update$resetInput(
						A3(
							_CareerPlug$ats$Features_Autocomplete_Update$setQuery,
							config,
							model,
							config.idFromString(_p7._0)));
					return {
						ctor: '_Tuple2',
						_0: newModel,
						_1: A2(
							_elm_lang$core$Task$attempt,
							function (_p13) {
								return _CareerPlug$ats$Features_Autocomplete_Message$ForSelf(_CareerPlug$ats$Features_Autocomplete_Message$NoOp);
							},
							_elm_lang$dom$Dom$focus(config.domInputId))
					};
				case 'PreviewItem':
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								selectedItem: _elm_lang$core$Maybe$Just(
									config.idFromString(_p7._0))
							}),
						{ctor: '[]'});
				case 'OnFocus':
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				case 'OnBlur':
					return A3(_CareerPlug$ats$Features_Autocomplete_Update$handleUpdate, _CareerPlug$ats$Features_Autocomplete_Message$Escape, config, model);
				case 'OnEnter':
					return A3(_CareerPlug$ats$Features_Autocomplete_Update$handleUpdate, _CareerPlug$ats$Features_Autocomplete_Message$Commit, config, model);
				default:
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
			}
		}
	});

var _CareerPlug$ats$Email_Update$handleACMsg = F5(
	function (model, field, name, focus, internal) {
		var _p0 = A3(
			_CareerPlug$ats$Features_Autocomplete_Update$update,
			A2(_CareerPlug$ats$Email_Model$acConfig, model.config, name),
			internal,
			field.acModel);
		var child_ = _p0._0;
		var cmd = _p0._1;
		var newField = _elm_lang$core$Native_Utils.update(
			field,
			{acModel: child_});
		var newModel = function () {
			var _p1 = internal;
			if (_p1.ctor === 'OnFocus') {
				return _elm_lang$core$Native_Utils.update(
					model,
					{carbonFocus: focus});
			} else {
				return model;
			}
		}();
		return {ctor: '_Tuple3', _0: newModel, _1: newField, _2: cmd};
	});
var _CareerPlug$ats$Email_Update$stateFromDefaults = function (defaults) {
	var _p2 = defaults.template_type;
	if (_p2.ctor === 'SmsTemplate') {
		return _CareerPlug$ats$Email_Model$SmsMessage(defaults.invite_schedule);
	} else {
		return defaults.invite ? _CareerPlug$ats$Email_Model$ICalEmail : (defaults.invite_schedule ? _CareerPlug$ats$Email_Model$AppointmentEmail : _CareerPlug$ats$Email_Model$NormalEmail);
	}
};
var _CareerPlug$ats$Email_Update$activateFromEmail = function (email) {
	return {
		edit: 0,
		to: email.to,
		subject: email.subject,
		body: email.body,
		include_signature: email.include_signature,
		location: email.location,
		event: email.event,
		commands: '',
		invite: email.invite,
		invite_schedule: email.invite_schedule,
		templates: '',
		template_type: _CareerPlug$ats$Models_MessageTemplate$EmailTemplate,
		interviewers: {ctor: '[]'},
		scorecards: {ctor: '[]'},
		title: 'Editing Email',
		timezone: email.timezone,
		interviewer: '',
		invite_expires_in: '7',
		interview_duration: '30'
	};
};
var _CareerPlug$ats$Email_Update$convertEmailList = function (recips) {
	var convRecip = function (recip) {
		return {ctor: '_Tuple2', _0: recip.id, _1: recip.name};
	};
	return _elm_lang$core$Array$fromList(
		A2(_elm_lang$core$List$map, convRecip, recips));
};
var _CareerPlug$ats$Email_Update$attById = F2(
	function (model, attId) {
		return _elm_lang$core$List$head(
			A2(
				_elm_lang$core$List$filter,
				function (a) {
					return _elm_lang$core$Native_Utils.eq(a.id, attId);
				},
				model.attachments));
	});
var _CareerPlug$ats$Email_Update$removeCarbonItem = F2(
	function (curList, idx) {
		var partA = A3(_elm_lang$core$Array$slice, 0, idx, curList);
		var aLen = _elm_lang$core$Array$length(curList);
		var partB = A3(_elm_lang$core$Array$slice, idx + 1, aLen, curList);
		var _p3 = idx;
		if (_p3 === 0) {
			return partB;
		} else {
			return A2(_elm_lang$core$Array$append, partA, partB);
		}
	});
var _CareerPlug$ats$Email_Update$addCarbonItem = F3(
	function (totalList, curList, val) {
		var tuple = function () {
			var _p6 = _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filter,
					function (_p4) {
						var _p5 = _p4;
						return _elm_lang$core$Native_Utils.eq(val, _p5._1);
					},
					totalList));
			if (_p6.ctor === 'Just') {
				return _p6._0;
			} else {
				return {ctor: '_Tuple2', _0: 0, _1: val};
			}
		}();
		var existing = _elm_lang$core$Array$length(
			A2(
				_elm_lang$core$Array$filter,
				function (_p7) {
					var _p8 = _p7;
					return _elm_lang$core$Native_Utils.eq(val, _p8._1);
				},
				curList));
		var valid = _CareerPlug$ats$Library_Core$validEmail(val);
		return ((_elm_lang$core$Native_Utils.cmp(existing, 1) < 0) && valid) ? A2(_elm_lang$core$Array$push, tuple, curList) : curList;
	});
var _CareerPlug$ats$Email_Update$update = F2(
	function (msg, model) {
		var _p9 = msg;
		switch (_p9.ctor) {
			case 'NoOp':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'Cancel':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'clearEditor', _1: 'cancel'}),
						_1: {ctor: '[]'}
					});
			case 'Discard':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'clearEditor', _1: 'discard'}),
						_1: {ctor: '[]'}
					});
			case 'InitRandIDs':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							randIds: _elm_lang$core$Set$toList(
								_elm_lang$core$Set$fromList(_p9._0))
						}),
					{ctor: '[]'});
			case 'EmailMsg':
				var _p14 = _p9._0;
				var msg = _elm_lang$core$List$head(_p14);
				var effects = function () {
					var _p10 = msg;
					_v7_4:
					do {
						if (_p10.ctor === 'Just') {
							switch (_p10._0) {
								case 'EditorCleared':
									var _p11 = _elm_lang$core$List$head(
										A2(_elm_lang$core$List$drop, 1, _p14));
									if (_p11.ctor === 'Just') {
										return {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(
												_CareerPlug$ats$Email_Message$EditorCleared(_p11._0)),
											_1: {ctor: '[]'}
										};
									} else {
										return {ctor: '[]'};
									}
								case 'EditorReset':
									var _p12 = _elm_lang$core$List$head(
										A2(_elm_lang$core$List$drop, 1, _p14));
									if (_p12.ctor === 'Just') {
										return {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(
												_CareerPlug$ats$Email_Message$SwitchTemplate(_p12._0)),
											_1: {ctor: '[]'}
										};
									} else {
										return {ctor: '[]'};
									}
								case 'FileResult':
									var _p13 = {
										ctor: '_Tuple3',
										_0: _elm_lang$core$List$head(
											A2(_elm_lang$core$List$drop, 1, _p14)),
										_1: _elm_lang$core$List$head(
											A2(_elm_lang$core$List$drop, 2, _p14)),
										_2: _elm_lang$core$List$head(
											A2(_elm_lang$core$List$drop, 3, _p14))
									};
									if ((((_p13.ctor === '_Tuple3') && (_p13._0.ctor === 'Just')) && (_p13._1.ctor === 'Just')) && (_p13._2.ctor === 'Just')) {
										return {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(
												_CareerPlug$ats$Email_Message$AttachmentComplete(
													{ctor: '_Tuple3', _0: _p13._0._0, _1: _p13._1._0, _2: _p13._2._0})),
											_1: {ctor: '[]'}
										};
									} else {
										return {ctor: '[]'};
									}
								case 'Cancel':
									return {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$Cancel),
										_1: {ctor: '[]'}
									};
								default:
									break _v7_4;
							}
						} else {
							break _v7_4;
						}
					} while(false);
					return {ctor: '[]'};
				}();
				return A2(_elm_lang$core$Platform_Cmd_ops['!'], model, effects);
			case 'Reset':
				return _CareerPlug$ats$Email_Model$init(model.config);
			case 'EditorCleared':
				var snackEffect = function (msg) {
					return _CareerPlug$ats$Email_Ports$emailResponse(
						{ctor: '_Tuple2', _0: 'snackbar', _1: msg});
				};
				var effects = function () {
					var messageType = function () {
						var _p15 = model.status;
						if (_p15.ctor === 'SmsMessage') {
							return 'text message';
						} else {
							return 'email';
						}
					}();
					var msg = model.scheduling ? A2(
						_elm_lang$core$Basics_ops['++'],
						'The ',
						A2(_elm_lang$core$Basics_ops['++'], messageType, ' was scheduled successfully.')) : A2(
						_elm_lang$core$Basics_ops['++'],
						'The ',
						A2(_elm_lang$core$Basics_ops['++'], messageType, ' was sent successfully.'));
					var _p16 = {ctor: '_Tuple3', _0: _p9._0, _1: model.emailId, _2: model.emailForm};
					_v12_4:
					do {
						if (_p16.ctor === '_Tuple3') {
							switch (_p16._0) {
								case 'discard':
									if (_p16._1.ctor === 'Just') {
										return {
											ctor: '::',
											_0: A2(_CareerPlug$ats$Email_Service$destroyEmail, model.config, _p16._1._0),
											_1: {
												ctor: '::',
												_0: _CareerPlug$ats$Email_Ports$emailResponse(
													{ctor: '_Tuple2', _0: 'cancel', _1: ''}),
												_1: {
													ctor: '::',
													_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$Reset),
													_1: {
														ctor: '::',
														_0: snackEffect('The email was discarded.'),
														_1: {ctor: '[]'}
													}
												}
											}
										};
									} else {
										break _v12_4;
									}
								case 'cancel':
									if (_p16._1.ctor === 'Just') {
										return {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$Reset),
											_1: {ctor: '[]'}
										};
									} else {
										break _v12_4;
									}
								case 'sent':
									if (_p16._2.ctor === 'Just') {
										var _p17 = _p16._2._0;
										var diffTZ = !_elm_lang$core$Native_Utils.eq(model.config.timezone, _p17.timezone);
										var emTZ = _elm_lang$core$Native_Utils.cmp(
											_elm_lang$core$String$length(_p17.timezone),
											0) > 0;
										return (emTZ && diffTZ) ? {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$ShowTimezoneDialog),
											_1: {
												ctor: '::',
												_0: _CareerPlug$ats$Email_Ports$emailResponse(
													{ctor: '_Tuple2', _0: 'success', _1: ''}),
												_1: {ctor: '[]'}
											}
										} : {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$Reset),
											_1: {
												ctor: '::',
												_0: _CareerPlug$ats$Email_Ports$emailResponse(
													{ctor: '_Tuple2', _0: 'success', _1: ''}),
												_1: {
													ctor: '::',
													_0: snackEffect(msg),
													_1: {ctor: '[]'}
												}
											}
										};
									} else {
										break _v12_4;
									}
								case 'finished':
									return {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$Reset),
										_1: {
											ctor: '::',
											_0: snackEffect(msg),
											_1: {ctor: '[]'}
										}
									};
								default:
									break _v12_4;
							}
						} else {
							break _v12_4;
						}
					} while(false);
					return {
						ctor: '::',
						_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$Reset),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Email_Ports$emailResponse(
								{ctor: '_Tuple2', _0: 'cancel', _1: ''}),
							_1: {ctor: '[]'}
						}
					};
				}();
				return A2(_elm_lang$core$Platform_Cmd_ops['!'], model, effects);
			case 'ActivateForm':
				var _p21 = _p9._0;
				var effect = function () {
					var _p18 = _CareerPlug$ats$Email_Service$importActivate(_p21);
					if (_p18.ctor === 'Ok') {
						var _p19 = _p18._0;
						return (_elm_lang$core$Native_Utils.cmp(_p19.edit, 0) > 0) ? A2(_CareerPlug$ats$Email_Service$loadEmail, model.config, _p19.edit) : _CareerPlug$ats$Library_Update$msgEffect(
							_CareerPlug$ats$Email_Message$SetDefaults(_p19));
					} else {
						var _p20 = A2(
							_elm_lang$core$Debug$log,
							'Activating',
							{ctor: '_Tuple2', _0: _p18._0, _1: _p21});
						return _elm_lang$core$Platform_Cmd$none;
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: effect,
						_1: {ctor: '[]'}
					});
			case 'EditEmail':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: A2(_CareerPlug$ats$Email_Service$loadEmail, model.config, _p9._0),
						_1: {ctor: '[]'}
					});
			case 'EmailLoaded':
				if (_p9._0.ctor === 'Err') {
					var _p22 = A2(_elm_lang$core$Debug$log, 'EmailLoaded', _p9._0._0);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var _p23 = _p9._0._0;
					var bccField = model.copyField;
					var newBccField = _elm_lang$core$Native_Utils.update(
						bccField,
						{
							list: _CareerPlug$ats$Email_Update$convertEmailList(_p23.bcc_list)
						});
					var copyField = model.copyField;
					var newCopyField = _elm_lang$core$Native_Utils.update(
						copyField,
						{
							list: _CareerPlug$ats$Email_Update$convertEmailList(_p23.cc_list)
						});
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{emailId: _p23.id, attachments: _p23.attachments, copyField: newCopyField, bccField: newBccField}),
						{
							ctor: '::',
							_0: _CareerPlug$ats$Library_Update$msgEffect(
								_CareerPlug$ats$Email_Message$SetDefaults(
									_CareerPlug$ats$Email_Update$activateFromEmail(_p23))),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Library_Update$msgEffect(
									_CareerPlug$ats$Email_Message$SetExtras(_p23)),
								_1: {ctor: '[]'}
							}
						});
				}
			case 'SetDefaults':
				var _p24 = _p9._0;
				var timezone = (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$String$length(_p24.timezone),
					0) > 0) ? _p24.timezone : model.config.timezone;
				var copy = (_p24.invite || _p24.invite_schedule) ? true : model.config.copyDefault;
				var newData = _elm_lang$core$Native_Utils.update(
					_CareerPlug$ats$Email_Models_EmailForm$blankEmailForm,
					{addressee: _p24.to, subject: _p24.subject, signature: _p24.include_signature, location: _p24.location, timezone: timezone, copy: copy, interviewer: _p24.interviewer, invite_expires_in: _p24.invite_expires_in, interview_duration: _p24.interview_duration, interview_future_days: model.config.interviewFutureDays});
				var defEffects = {
					ctor: '::',
					_0: _CareerPlug$ats$Library_Update$msgEffect(
						_CareerPlug$ats$Email_Message$FormMsg(
							_etaque$elm_form$Form$Reset(
								_CareerPlug$ats$Email_Models_EmailForm$emailFields(newData)))),
					_1: {
						ctor: '::',
						_0: A2(_CareerPlug$ats$Email_Service$retrieveRelatedApp, model.config, _p24.event),
						_1: {ctor: '[]'}
					}
				};
				var effects = (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$String$length(_p24.templates),
					0) > 0) ? A2(
					_elm_lang$core$Basics_ops['++'],
					defEffects,
					{
						ctor: '::',
						_0: A2(_CareerPlug$ats$Email_Service$retrieveTemplates, model.config, _p24.templates),
						_1: {ctor: '[]'}
					}) : A2(
					_elm_lang$core$Basics_ops['++'],
					defEffects,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'setBody', _1: _p24.body}),
						_1: {ctor: '[]'}
					});
				var addressee = (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$String$length(_p24.to),
					0) > 0) ? _elm_lang$core$Maybe$Just(_p24.to) : _elm_lang$core$Maybe$Nothing;
				var newModel = _elm_lang$core$Native_Utils.update(
					model,
					{
						status: _CareerPlug$ats$Email_Update$stateFromDefaults(_p24),
						event: _p24.event,
						commands: _p24.commands,
						addressee: addressee,
						title: _p24.title,
						scorecards: _p24.scorecards,
						interviewers: model.config.calendarUsers,
						invite_expires_in: model.config.inviteExpireOpts,
						interview_duration: model.config.interviewDurationOpts
					});
				return A2(_elm_lang$core$Platform_Cmd_ops['!'], newModel, effects);
			case 'SetExtras':
				var _p26 = _p9._0;
				var _p25 = function () {
					if (_elm_lang$core$Native_Utils.cmp(
						_elm_lang$core$String$length(_p26.scheduled_date),
						0) > 0) {
						var extForm = model.externalForm;
						var extForm_ = _elm_lang$core$Native_Utils.update(
							extForm,
							{scheduleDate: _p26.scheduled_date, scheduleTime: _p26.scheduled_time, startTime: _p26.start_time, endTime: _p26.end_time});
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{externalForm: extForm_}),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Library_Update$msgEffect(_CareerPlug$ats$Email_Message$ScheduleEmail),
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Email_Ports$emailResponse(
										{
											ctor: '_Tuple2',
											_0: 'setFields',
											_1: A2(
												_elm_lang$core$Json_Encode$encode,
												0,
												_CareerPlug$ats$Email_Models_ExternalForm$externalFormAsJson(extForm_))
										}),
									_1: {ctor: '[]'}
								}
							}
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: {ctor: '[]'}
						};
					}
				}();
				var newModel = _p25._0;
				var effects = _p25._1;
				return A2(_elm_lang$core$Platform_Cmd_ops['!'], newModel, effects);
			case 'SetTemplates':
				var dict = A2(_krisajenkins$remotedata$RemoteData$map, _CareerPlug$ats$Email_Model$templatesFromList, _p9._0);
				var effects = function () {
					var _p27 = dict;
					if (_p27.ctor === 'Success') {
						var _p28 = _elm_lang$core$List$head(
							_CareerPlug$ats$Email_Model$templatesInOrder(_p27._0));
						if (_p28.ctor === 'Just') {
							return {
								ctor: '::',
								_0: _CareerPlug$ats$Library_Update$msgEffect(
									_CareerPlug$ats$Email_Message$SelectTemplate(_p28._0._0)),
								_1: {ctor: '[]'}
							};
						} else {
							return {ctor: '[]'};
						}
					} else {
						return {ctor: '[]'};
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{templates: dict}),
					effects);
			case 'SetRelatedApp':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{relatedApp: _p9._0}),
					{ctor: '[]'});
			case 'SetFields':
				var _p34 = _p9._0;
				var _p29 = function () {
					var _p30 = model.emailForm;
					if (_p30.ctor === 'Just') {
						var _p33 = _p30._0;
						var flags = {
							invite: function () {
								var _p31 = model.status;
								if (_p31.ctor === 'ICalEmail') {
									return true;
								} else {
									return false;
								}
							}(),
							scheduling: model.scheduling
						};
						var smsMessage = A3(_CareerPlug$ats$Email_Service$composeSmsMessage, model, _p33, _p34);
						var email = A3(_CareerPlug$ats$Email_Service$composeEmail, model, _p33, _p34);
						var effects = function () {
							var _p32 = model.status;
							if (_p32.ctor === 'SmsMessage') {
								return {
									ctor: '::',
									_0: A2(_CareerPlug$ats$Email_Service$saveSmsMessage, model.config, smsMessage),
									_1: {ctor: '[]'}
								};
							} else {
								return {
									ctor: '::',
									_0: A2(_CareerPlug$ats$Email_Service$saveEmail, model.config, email),
									_1: {ctor: '[]'}
								};
							}
						}();
						return A2(_CareerPlug$ats$Email_Models_ExternalForm$valid, flags, _p34) ? {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{sending: true}),
							_1: effects
						} : {
							ctor: '_Tuple2',
							_0: model,
							_1: {ctor: '[]'}
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: {ctor: '[]'}
						};
					}
				}();
				var model_ = _p29._0;
				var effects = _p29._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model_,
						{externalForm: _p34}),
					effects);
			case 'ShowCarbon':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{showCarbon: true}),
					{ctor: '[]'});
			case 'AddCarbonItem':
				var _p41 = _p9._2;
				var addItem = F3(
					function (cField, name, msgType) {
						var domId = _elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: 'email_',
								_1: {
									ctor: '::',
									_0: name,
									_1: {
										ctor: '::',
										_0: '_input',
										_1: {ctor: '[]'}
									}
								}
							});
						var newList = A3(_CareerPlug$ats$Email_Update$addCarbonItem, model.config.recipients, cField.list, _p41);
						var _p35 = function () {
							var _p36 = _p9._1;
							if (_p36.ctor === 'Commit') {
								var defEffects = {
									ctor: '::',
									_0: A2(
										_elm_lang$core$Task$attempt,
										function (_p37) {
											return _CareerPlug$ats$Email_Message$NoOp;
										},
										_elm_lang$dom$Dom$focus(domId)),
									_1: {ctor: '[]'}
								};
								return (!_elm_lang$core$Native_Utils.eq(newList, cField.list)) ? {ctor: '_Tuple2', _0: false, _1: defEffects} : {
									ctor: '_Tuple2',
									_0: true,
									_1: A2(
										_elm_lang$core$Basics_ops['++'],
										defEffects,
										{
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(
												msgType(
													_CareerPlug$ats$Features_Autocomplete_Message$SetQuery(_p41))),
											_1: {ctor: '[]'}
										})
								};
							} else {
								return {
									ctor: '_Tuple2',
									_0: false,
									_1: {ctor: '[]'}
								};
							}
						}();
						var error = _p35._0;
						var effects = _p35._1;
						var newField = _elm_lang$core$Native_Utils.update(
							cField,
							{list: newList, error: error});
						return {ctor: '_Tuple2', _0: newField, _1: effects};
					});
				var _p38 = _p9._0;
				if (_p38.ctor === 'Cc') {
					var _p39 = A3(addItem, model.copyField, 'copy', _CareerPlug$ats$Email_Message$ACCopyMsg);
					var newField = _p39._0;
					var effects = _p39._1;
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{copyField: newField}),
						effects);
				} else {
					var _p40 = A3(addItem, model.bccField, 'bcc', _CareerPlug$ats$Email_Message$ACBccMsg);
					var newField = _p40._0;
					var effects = _p40._1;
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{bccField: newField}),
						effects);
				}
			case 'RemoveCarbonItem':
				var removeItem = function (cField) {
					return _elm_lang$core$Native_Utils.update(
						cField,
						{
							list: A2(_CareerPlug$ats$Email_Update$removeCarbonItem, cField.list, _p9._1)
						});
				};
				var _p42 = _p9._0;
				if (_p42.ctor === 'Cc') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								copyField: removeItem(model.copyField)
							}),
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								bccField: removeItem(model.bccField)
							}),
						{ctor: '[]'});
				}
			case 'SelectTemplate':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'resetEditor', _1: _p9._0}),
						_1: {ctor: '[]'}
					});
			case 'SwitchTemplate':
				var template = function () {
					var _p43 = model.templates;
					if (_p43.ctor === 'Success') {
						return A2(_elm_lang$core$Dict$get, _p9._0, _p43._0);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}();
				var attachments = function () {
					var _p44 = template;
					if (_p44.ctor === 'Just') {
						return _p44._0.attachments;
					} else {
						return {ctor: '[]'};
					}
				}();
				var _p45 = function () {
					var _p46 = template;
					if (_p46.ctor === 'Just') {
						var _p49 = _p46._0;
						var title = function () {
							var _p47 = _p49.template_type;
							if (_p47.ctor === 'SmsTemplate') {
								return 'Sending Text Message';
							} else {
								return 'Sending Email';
							}
						}();
						var stringVal = function (value) {
							var _p48 = value;
							if (_p48.ctor === 'Just') {
								return _elm_lang$core$Basics$toString(_p48._0);
							} else {
								return '';
							}
						};
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									status: _CareerPlug$ats$Email_Update$stateFromDefaults(_p49),
									title: title
								}),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Library_Update$msgEffect(
									_CareerPlug$ats$Email_Message$FormMsg(
										A3(
											_etaque$elm_form$Form$Input,
											'subject',
											_etaque$elm_form$Form$Text,
											_etaque$elm_form$Form_Field$String(_p49.subject)))),
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Library_Update$msgEffect(
										_CareerPlug$ats$Email_Message$FormMsg(
											A3(
												_etaque$elm_form$Form$Input,
												'location',
												_etaque$elm_form$Form$Text,
												_etaque$elm_form$Form_Field$String(_p49.location)))),
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Update$msgEffect(
											_CareerPlug$ats$Email_Message$FormMsg(
												A3(
													_etaque$elm_form$Form$Input,
													'body',
													_etaque$elm_form$Form$Text,
													_etaque$elm_form$Form_Field$String(_p49.body)))),
										_1: {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(
												_CareerPlug$ats$Email_Message$FormMsg(
													A3(
														_etaque$elm_form$Form$Input,
														'signature',
														_etaque$elm_form$Form$Checkbox,
														_etaque$elm_form$Form_Field$Bool(_p49.include_signature)))),
											_1: {
												ctor: '::',
												_0: _CareerPlug$ats$Library_Update$msgEffect(
													_CareerPlug$ats$Email_Message$FormMsg(
														A3(
															_etaque$elm_form$Form$Input,
															'interviewer',
															_etaque$elm_form$Form$Select,
															_etaque$elm_form$Form_Field$String(
																stringVal(_p49.appointment_config.schedule_owner_id))))),
												_1: {
													ctor: '::',
													_0: _CareerPlug$ats$Library_Update$msgEffect(
														_CareerPlug$ats$Email_Message$FormMsg(
															A3(
																_etaque$elm_form$Form$Input,
																'invite_expires_in',
																_etaque$elm_form$Form$Select,
																_etaque$elm_form$Form_Field$String(
																	stringVal(_p49.appointment_config.expires_in))))),
													_1: {
														ctor: '::',
														_0: _CareerPlug$ats$Library_Update$msgEffect(
															_CareerPlug$ats$Email_Message$FormMsg(
																A3(
																	_etaque$elm_form$Form$Input,
																	'interview_duration',
																	_etaque$elm_form$Form$Select,
																	_etaque$elm_form$Form_Field$String(
																		stringVal(_p49.appointment_config.duration))))),
														_1: {
															ctor: '::',
															_0: _CareerPlug$ats$Email_Ports$emailResponse(
																{ctor: '_Tuple2', _0: 'setBody', _1: _p49.body}),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}
									}
								}
							}
						};
					} else {
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: {ctor: '[]'}
						};
					}
				}();
				var model_ = _p45._0;
				var effects = _p45._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model_,
						{template: template, attachments: attachments}),
					effects);
			case 'AddAttachment':
				var noAtts = function (i) {
					return _elm_lang$core$Native_Utils.cmp(
						_elm_lang$core$List$length(
							A2(
								_elm_lang$core$List$filter,
								function (a) {
									return _elm_lang$core$Native_Utils.eq(a.id, i);
								},
								model.attachments)),
						1) < 0;
				};
				var newRands = A2(_elm_lang$core$List$filter, noAtts, model.randIds);
				var attID = function () {
					var _p50 = _elm_lang$core$List$head(newRands);
					if (_p50.ctor === 'Just') {
						return _p50._0;
					} else {
						return 0;
					}
				}();
				var att = {id: attID, name: '', attachment: '', newRecord: true, destroy: false};
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							attachments: A2(
								_elm_lang$core$Basics_ops['++'],
								model.attachments,
								{
									ctor: '::',
									_0: att,
									_1: {ctor: '[]'}
								}),
							randIds: A2(_elm_lang$core$List$drop, 1, newRands)
						}),
					{ctor: '[]'});
			case 'RemoveAttachment':
				var updateAtt = function (att) {
					return _elm_lang$core$Native_Utils.eq(att.id, _p9._0) ? _elm_lang$core$Native_Utils.update(
						att,
						{destroy: true}) : att;
				};
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							attachments: A2(_elm_lang$core$List$map, updateAtt, model.attachments)
						}),
					{ctor: '[]'});
			case 'UploadAttachment':
				var attDomId = function (a) {
					return A2(
						_elm_lang$core$Basics_ops['++'],
						_CareerPlug$ats$Email_Model$attDomName,
						_elm_lang$core$Basics$toString(a.id));
				};
				var effects = function () {
					var _p51 = A2(_CareerPlug$ats$Email_Update$attById, model, _p9._0);
					if (_p51.ctor === 'Just') {
						return {
							ctor: '::',
							_0: _CareerPlug$ats$Email_Ports$emailResponse(
								{
									ctor: '_Tuple2',
									_0: 'fileReader',
									_1: attDomId(_p51._0)
								}),
							_1: {ctor: '[]'}
						};
					} else {
						return {ctor: '[]'};
					}
				}();
				return A2(_elm_lang$core$Platform_Cmd_ops['!'], model, effects);
			case 'AttachmentComplete':
				var attId = function () {
					var _p52 = _elm_lang$core$String$toInt(
						A2(
							_elm_lang$core$String$dropLeft,
							_elm_lang$core$String$length(_CareerPlug$ats$Email_Model$attDomName),
							_p9._0._0));
					if (_p52.ctor === 'Ok') {
						return _p52._0;
					} else {
						return 0;
					}
				}();
				var updateAtt = function (att) {
					return _elm_lang$core$Native_Utils.eq(att.id, attId) ? _elm_lang$core$Native_Utils.update(
						att,
						{name: _p9._0._1, attachment: _p9._0._2}) : att;
				};
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							attachments: A2(_elm_lang$core$List$map, updateAtt, model.attachments)
						}),
					{ctor: '[]'});
			case 'ScheduleEmail':
				return model.scheduling ? A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Library_Update$msgEffect(
							_CareerPlug$ats$Email_Message$FormMsg(_etaque$elm_form$Form$Submit)),
						_1: {ctor: '[]'}
					}) : A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{scheduling: true}),
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'scheduleEnabled', _1: ''}),
						_1: {ctor: '[]'}
					});
			case 'ScheduleButton':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'scheduleButton', _1: _p9._0}),
						_1: {ctor: '[]'}
					});
			case 'SendEmail':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{scheduling: false}),
					{
						ctor: '::',
						_0: _CareerPlug$ats$Library_Update$msgEffect(
							_CareerPlug$ats$Email_Message$FormMsg(_etaque$elm_form$Form$Submit)),
						_1: {ctor: '[]'}
					});
			case 'SendSmsMessage':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'ShowTimezoneDialog':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{status: _CareerPlug$ats$Email_Model$DefaultTimezone}),
					{
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'openModal', _1: 'user-change-default-timezone'}),
						_1: {ctor: '[]'}
					});
			case 'CloseTimezoneDialog':
				var defEffect = _CareerPlug$ats$Email_Ports$emailResponse(
					{ctor: '_Tuple2', _0: 'closeModal', _1: 'user-change-default-timezone'});
				var _p53 = {ctor: '_Tuple2', _0: _p9._0, _1: model.emailForm};
				if (((_p53.ctor === '_Tuple2') && (_p53._0 === true)) && (_p53._1.ctor === 'Just')) {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{
							ctor: '::',
							_0: defEffect,
							_1: {
								ctor: '::',
								_0: A2(_CareerPlug$ats$Email_Service$updateUserTimezone, model.config, _p53._1._0.timezone),
								_1: {ctor: '[]'}
							}
						});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{
							ctor: '::',
							_0: defEffect,
							_1: {ctor: '[]'}
						});
				}
			case 'TimezoneUpdated':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'EmailDestroyed':
				if (_p9._0.ctor === 'Ok') {
					var effects = function () {
						var _p54 = _p9._0._0;
						if (_p54.ctor === 'Just') {
							return {
								ctor: '::',
								_0: _CareerPlug$ats$Email_Ports$emailResponse(
									{
										ctor: '_Tuple2',
										_0: 'refreshApp',
										_1: _elm_lang$core$Basics$toString(_p54._0)
									}),
								_1: {ctor: '[]'}
							};
						} else {
							return {ctor: '[]'};
						}
					}();
					return A2(_elm_lang$core$Platform_Cmd_ops['!'], model, effects);
				} else {
					var _p55 = A2(_elm_lang$core$Debug$log, 'EmailDestroyed', _p9._0._0);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			case 'MessageSent':
				if (_p9._0.ctor === 'Ok') {
					var defEffects = {
						ctor: '::',
						_0: _CareerPlug$ats$Email_Ports$emailResponse(
							{ctor: '_Tuple2', _0: 'clearEditor', _1: 'sent'}),
						_1: {ctor: '[]'}
					};
					var effects = function () {
						var _p56 = _p9._0._0;
						if (_p56.ctor === 'Just') {
							return A2(
								_elm_lang$core$Basics_ops['++'],
								defEffects,
								{
									ctor: '::',
									_0: _CareerPlug$ats$Email_Ports$emailResponse(
										{
											ctor: '_Tuple2',
											_0: 'refreshApp',
											_1: _elm_lang$core$Basics$toString(_p56._0)
										}),
									_1: {ctor: '[]'}
								});
						} else {
							return defEffects;
						}
					}();
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{sending: false}),
						effects);
				} else {
					var _p62 = _p9._0._0;
					var messageType = function () {
						var _p57 = model.status;
						if (_p57.ctor === 'SmsMessage') {
							return 'text message';
						} else {
							return 'email';
						}
					}();
					var defErr = A3(
						_elm_lang$core$Dict$insert,
						'base',
						{
							ctor: '::',
							_0: A2(
								_elm_lang$core$Basics_ops['++'],
								'The ',
								A2(_elm_lang$core$Basics_ops['++'], messageType, ' could not be sent. If this problem persists, please contact support.')),
							_1: {ctor: '[]'}
						},
						_elm_lang$core$Dict$empty);
					var errs = function () {
						var _p58 = _p62;
						if (_p58.ctor === 'BadStatus') {
							var result = A2(_elm_lang$core$Json_Decode$decodeString, _CareerPlug$ats$Email_Service$jsonServerErrors, _p58._0.body);
							var _p59 = result;
							if (_p59.ctor === 'Ok') {
								return _p59._0;
							} else {
								var _p60 = A2(
									_elm_lang$core$Debug$log,
									A2(
										_elm_lang$core$Basics_ops['++'],
										'Decoding ',
										A2(_elm_lang$core$Basics_ops['++'], messageType, ' errors')),
									_p59._0);
								return defErr;
							}
						} else {
							var _p61 = A2(_elm_lang$core$Debug$log, 'Email Server Error', _p62);
							return defErr;
						}
					}();
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{serverErrors: errs, sending: false}),
						{ctor: '[]'});
				}
			case 'ACCopyMsg':
				var _p63 = A5(_CareerPlug$ats$Email_Update$handleACMsg, model, model.copyField, 'copy', _CareerPlug$ats$Email_Model$CopyField, _p9._0);
				var newModel = _p63._0;
				var newCopyField = _p63._1;
				var cmd = _p63._2;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						newModel,
						{copyField: newCopyField}),
					{
						ctor: '::',
						_0: A2(_elm_lang$core$Platform_Cmd$map, _CareerPlug$ats$Email_Message$acCopyTranslator, cmd),
						_1: {ctor: '[]'}
					});
			case 'ACBccMsg':
				var _p64 = A5(_CareerPlug$ats$Email_Update$handleACMsg, model, model.bccField, 'bcc', _CareerPlug$ats$Email_Model$BccField, _p9._0);
				var newModel = _p64._0;
				var newBccField = _p64._1;
				var cmd = _p64._2;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						newModel,
						{bccField: newBccField}),
					{
						ctor: '::',
						_0: A2(_elm_lang$core$Platform_Cmd$map, _CareerPlug$ats$Email_Message$acBccTranslator, cmd),
						_1: {ctor: '[]'}
					});
			case 'FormMsg':
				var _p69 = _p9._0;
				var def = function () {
					var validation = function () {
						var _p65 = model.status;
						if (_p65.ctor === 'SmsMessage') {
							return _CareerPlug$ats$Email_Models_EmailForm$smsValidate;
						} else {
							return _CareerPlug$ats$Email_Models_EmailForm$emailValidate;
						}
					}();
					var updatedModel = _elm_lang$core$Native_Utils.update(
						model,
						{
							form: A3(_etaque$elm_form$Form$update, validation, _p69, model.form)
						});
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						updatedModel,
						{ctor: '[]'});
				}();
				var _p66 = _p69;
				if (_p66.ctor === 'Submit') {
					var _p67 = _etaque$elm_form$Form$getOutput(model.form);
					if (_p67.ctor === 'Just') {
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{
									emailForm: _elm_lang$core$Maybe$Just(_p67._0)
								}),
							{
								ctor: '::',
								_0: _CareerPlug$ats$Email_Ports$emailResponse(
									{ctor: '_Tuple2', _0: 'sendFields', _1: ''}),
								_1: {ctor: '[]'}
							});
					} else {
						var _p68 = A2(
							_elm_lang$core$Debug$log,
							'Form Errors',
							_etaque$elm_form$Form$getErrors(model.form));
						return def;
					}
				} else {
					return def;
				}
			default:
				var _p72 = _p9._0;
				var model_ = function () {
					var _p70 = _p72;
					if ((_p70.ctor === 'HttpResponse') && (_p70._0.ctor === 'Ok')) {
						var config_ = model.config;
						return _elm_lang$core$Native_Utils.update(
							model,
							{
								config: _elm_lang$core$Native_Utils.update(
									config_,
									{userCanSmsChat: true})
							});
					} else {
						return model;
					}
				}();
				var effectMapper = function (msg) {
					return _CareerPlug$ats$Email_Message$PhoneNumberSelectMsg(msg);
				};
				var _p71 = A4(
					_CareerPlug$ats$PhoneNumberSelect_Main$update,
					{authToken: model.config.authToken},
					_p72,
					model.phoneNumberSelect,
					effectMapper);
				var phoneNumberSelectModel = _p71._0;
				var effects = _p71._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model_,
						{phoneNumberSelect: phoneNumberSelectModel}),
					{
						ctor: '::',
						_0: effects,
						_1: {ctor: '[]'}
					});
		}
	});

var _CareerPlug$ats$Features_Autocomplete_View$viewConfig = function (config) {
	var customizedLi = F3(
		function (keySelected, mouseSelected, _p0) {
			var _p1 = _p0;
			return {
				attributes: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$classList(
						{
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'autocomplete-item', _1: true},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'key-selected', _1: keySelected || mouseSelected},
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$id(
							config.idToString(_p1._0)),
						_1: {ctor: '[]'}
					}
				},
				children: {
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						config.toString(_p1._1)),
					_1: {ctor: '[]'}
				}
			};
		});
	return _thebritican$elm_autocomplete$Autocomplete$viewConfig(
		{
			toId: function (_p2) {
				return config.idToString(
					_elm_lang$core$Tuple$first(_p2));
			},
			ul: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('autocomplete-list'),
				_1: {ctor: '[]'}
			},
			li: customizedLi
		});
};
var _CareerPlug$ats$Features_Autocomplete_View$viewMenu = F2(
	function (config, model) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id(config.domMenuId),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(config.domMenuClass),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$map,
					function (msg) {
						return _CareerPlug$ats$Features_Autocomplete_Message$ForSelf(
							_CareerPlug$ats$Features_Autocomplete_Message$SetAutoState(msg));
					},
					A4(
						_thebritican$elm_autocomplete$Autocomplete$view,
						_CareerPlug$ats$Features_Autocomplete_View$viewConfig(config),
						model.howManyToShow,
						model.autoState,
						A2(config.queryItems, model.query, config.items))),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$Features_Autocomplete_View$view = F2(
	function (config, model) {
		var activeDescendant = function (attributes) {
			return A2(
				_elm_lang$core$Maybe$withDefault,
				attributes,
				A2(
					_elm_lang$core$Maybe$map,
					function (name) {
						return {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-activedescendant', name),
							_1: attributes
						};
					},
					A2(
						_elm_lang$core$Maybe$map,
						config.toString,
						A2(
							_elm_lang$core$Maybe$andThen,
							function (id) {
								return A2(_CareerPlug$ats$Features_Autocomplete_Update$getItemAtId, id, config.items);
							},
							model.selectedItem))));
		};
		var query = A2(
			_elm_lang$core$Maybe$withDefault,
			model.query,
			A2(
				_elm_lang$core$Maybe$map,
				config.toString,
				A2(
					_elm_lang$core$Maybe$andThen,
					function (id) {
						return A2(_CareerPlug$ats$Features_Autocomplete_Update$getItemAtId, id, config.items);
					},
					model.selectedItem)));
		var menu = model.showMenu ? {
			ctor: '::',
			_0: A2(_CareerPlug$ats$Features_Autocomplete_View$viewMenu, config, model),
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var codeToResult = function (code) {
			return (_elm_lang$core$Native_Utils.eq(code, 38) || _elm_lang$core$Native_Utils.eq(code, 40)) ? _elm_lang$core$Result$Ok(
				_CareerPlug$ats$Features_Autocomplete_Message$ForSelf(_CareerPlug$ats$Features_Autocomplete_Message$NoOp)) : (_elm_lang$core$Native_Utils.eq(code, 27) ? _elm_lang$core$Result$Ok(
				_CareerPlug$ats$Features_Autocomplete_Message$ForSelf(_CareerPlug$ats$Features_Autocomplete_Message$HandleEscape)) : (A2(_elm_lang$core$List$member, code, config.commitKeys) ? _elm_lang$core$Result$Ok(
				_CareerPlug$ats$Features_Autocomplete_Message$ForSelf(_CareerPlug$ats$Features_Autocomplete_Message$OnEnter)) : _elm_lang$core$Result$Err('not handling that key')));
		};
		var dec = A2(
			_elm_lang$core$Json_Decode$andThen,
			function (_p3) {
				return _elm_community$json_extra$Json_Decode_Extra$fromResult(
					codeToResult(_p3));
			},
			_elm_lang$html$Html_Events$keyCode);
		var options = {preventDefault: true, stopPropagation: false};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('autocomplete-control'),
				_1: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$List$append,
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$input,
						activeDescendant(
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onInput(
									function (val) {
										return _CareerPlug$ats$Features_Autocomplete_Message$ForSelf(
											_CareerPlug$ats$Features_Autocomplete_Message$SetQuery(val));
									}),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onFocus(
										_CareerPlug$ats$Features_Autocomplete_Message$ForSelf(_CareerPlug$ats$Features_Autocomplete_Message$OnFocus)),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onBlur(
											_CareerPlug$ats$Features_Autocomplete_Message$ForSelf(_CareerPlug$ats$Features_Autocomplete_Message$OnBlur)),
										_1: {
											ctor: '::',
											_0: A3(_elm_lang$html$Html_Events$onWithOptions, 'keydown', options, dec),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$value(query),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$id(config.domInputId),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class(config.domInputClass),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$autocomplete(false),
															_1: {
																ctor: '::',
																_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-owns', config.domMenuId),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$html$Html_Attributes$attribute,
																		'aria-expanded',
																		_elm_lang$core$String$toLower(
																			_elm_lang$core$Basics$toString(model.showMenu))),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_lang$html$Html_Attributes$attribute,
																			'aria-haspopup',
																			_elm_lang$core$String$toLower(
																				_elm_lang$core$Basics$toString(model.showMenu))),
																		_1: {
																			ctor: '::',
																			_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'combobox'),
																			_1: {
																				ctor: '::',
																				_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-autocomplete', 'list'),
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}),
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				},
				menu));
	});

var _evancz$elm_markdown$Native_Markdown = function() {


// VIRTUAL-DOM WIDGETS

function toHtml(options, factList, rawMarkdown)
{
	var model = {
		options: options,
		markdown: rawMarkdown
	};
	return _elm_lang$virtual_dom$Native_VirtualDom.custom(factList, model, implementation);
}


// WIDGET IMPLEMENTATION

var implementation = {
	render: render,
	diff: diff
};

function render(model)
{
	var html = marked(model.markdown, formatOptions(model.options));
	var div = document.createElement('div');
	div.innerHTML = html;
	return div;
}

function diff(a, b)
{
	
	if (a.model.markdown === b.model.markdown && a.model.options === b.model.options)
	{
		return null;
	}

	return {
		applyPatch: applyPatch,
		data: marked(b.model.markdown, formatOptions(b.model.options))
	};
}

function applyPatch(domNode, data)
{
	domNode.innerHTML = data;
	return domNode;
}


// ACTUAL MARKDOWN PARSER

var marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && options.defaultHighlighting.ctor === 'Just')
		{
			lang = options.defaultHighlighting._0;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.githubFlavored;
	if (gfm.ctor === 'Just')
	{
		return {
			highlight: toHighlight,
			gfm: true,
			tables: gfm._0.tables,
			breaks: gfm._0.breaks,
			sanitize: options.sanitize,
			smartypants: options.smartypants
		};
	}

	return {
		highlight: toHighlight,
		gfm: false,
		tables: false,
		breaks: false,
		sanitize: options.sanitize,
		smartypants: options.smartypants
	};
}


// EXPORTS

return {
	toHtml: F3(toHtml)
};

}();

var _evancz$elm_markdown$Markdown$toHtmlWith = _evancz$elm_markdown$Native_Markdown.toHtml;
var _evancz$elm_markdown$Markdown$defaultOptions = {
	githubFlavored: _elm_lang$core$Maybe$Just(
		{tables: false, breaks: false}),
	defaultHighlighting: _elm_lang$core$Maybe$Nothing,
	sanitize: false,
	smartypants: false
};
var _evancz$elm_markdown$Markdown$toHtml = F2(
	function (attrs, string) {
		return A3(_evancz$elm_markdown$Native_Markdown.toHtml, _evancz$elm_markdown$Markdown$defaultOptions, attrs, string);
	});
var _evancz$elm_markdown$Markdown$Options = F4(
	function (a, b, c, d) {
		return {githubFlavored: a, defaultHighlighting: b, sanitize: c, smartypants: d};
	});

var _CareerPlug$ats$Models_Timezone$zones = _elm_lang$core$List$concat(
	{
		ctor: '::',
		_0: {
			ctor: '::',
			_0: 'America/New_York',
			_1: {
				ctor: '::',
				_0: 'America/Detroit',
				_1: {
					ctor: '::',
					_0: 'America/Kentucky/Louisville',
					_1: {
						ctor: '::',
						_0: 'America/Kentucky/Monticello',
						_1: {
							ctor: '::',
							_0: 'America/Indiana/Indianapolis',
							_1: {
								ctor: '::',
								_0: 'America/Indiana/Vincennes',
								_1: {
									ctor: '::',
									_0: 'America/Indiana/Winamac',
									_1: {
										ctor: '::',
										_0: 'America/Indiana/Marengo',
										_1: {
											ctor: '::',
											_0: 'America/Indiana/Petersburg',
											_1: {
												ctor: '::',
												_0: 'America/Indiana/Vevay',
												_1: {
													ctor: '::',
													_0: 'America/Chicago',
													_1: {
														ctor: '::',
														_0: 'America/Indiana/Tell_City',
														_1: {
															ctor: '::',
															_0: 'America/Indiana/Knox',
															_1: {
																ctor: '::',
																_0: 'America/Menominee',
																_1: {
																	ctor: '::',
																	_0: 'America/North_Dakota/Center',
																	_1: {
																		ctor: '::',
																		_0: 'America/North_Dakota/New_Salem',
																		_1: {
																			ctor: '::',
																			_0: 'America/North_Dakota/Beulah',
																			_1: {
																				ctor: '::',
																				_0: 'America/Denver',
																				_1: {
																					ctor: '::',
																					_0: 'America/Boise',
																					_1: {
																						ctor: '::',
																						_0: 'America/Phoenix',
																						_1: {
																							ctor: '::',
																							_0: 'America/Los_Angeles',
																							_1: {
																								ctor: '::',
																								_0: 'America/Anchorage',
																								_1: {
																									ctor: '::',
																									_0: 'America/Juneau',
																									_1: {
																										ctor: '::',
																										_0: 'America/Sitka',
																										_1: {
																											ctor: '::',
																											_0: 'America/Metlakatla',
																											_1: {
																												ctor: '::',
																												_0: 'America/Yakutat',
																												_1: {
																													ctor: '::',
																													_0: 'America/Nome',
																													_1: {
																														ctor: '::',
																														_0: 'America/Adak',
																														_1: {ctor: '[]'}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '::',
				_0: 'Pacific/Honolulu',
				_1: {ctor: '[]'}
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '::',
					_0: 'Africa/Abidjan',
					_1: {
						ctor: '::',
						_0: 'Africa/Accra',
						_1: {
							ctor: '::',
							_0: 'Africa/Addis_Ababa',
							_1: {
								ctor: '::',
								_0: 'Africa/Algiers',
								_1: {
									ctor: '::',
									_0: 'Africa/Asmara',
									_1: {
										ctor: '::',
										_0: 'Africa/Asmera',
										_1: {
											ctor: '::',
											_0: 'Africa/Bamako',
											_1: {
												ctor: '::',
												_0: 'Africa/Bangui',
												_1: {
													ctor: '::',
													_0: 'Africa/Banjul',
													_1: {
														ctor: '::',
														_0: 'Africa/Bissau',
														_1: {
															ctor: '::',
															_0: 'Africa/Blantyre',
															_1: {
																ctor: '::',
																_0: 'Africa/Brazzaville',
																_1: {
																	ctor: '::',
																	_0: 'Africa/Bujumbura',
																	_1: {
																		ctor: '::',
																		_0: 'Africa/Cairo',
																		_1: {
																			ctor: '::',
																			_0: 'Africa/Casablanca',
																			_1: {
																				ctor: '::',
																				_0: 'Africa/Ceuta',
																				_1: {
																					ctor: '::',
																					_0: 'Africa/Conakry',
																					_1: {
																						ctor: '::',
																						_0: 'Africa/Dakar',
																						_1: {
																							ctor: '::',
																							_0: 'Africa/Dar_es_Salaam',
																							_1: {
																								ctor: '::',
																								_0: 'Africa/Djibouti',
																								_1: {
																									ctor: '::',
																									_0: 'Africa/Douala',
																									_1: {
																										ctor: '::',
																										_0: 'Africa/El_Aaiun',
																										_1: {
																											ctor: '::',
																											_0: 'Africa/Freetown',
																											_1: {
																												ctor: '::',
																												_0: 'Africa/Gaborone',
																												_1: {
																													ctor: '::',
																													_0: 'Africa/Harare',
																													_1: {
																														ctor: '::',
																														_0: 'Africa/Johannesburg',
																														_1: {
																															ctor: '::',
																															_0: 'Africa/Juba',
																															_1: {
																																ctor: '::',
																																_0: 'Africa/Kampala',
																																_1: {
																																	ctor: '::',
																																	_0: 'Africa/Khartoum',
																																	_1: {
																																		ctor: '::',
																																		_0: 'Africa/Kigali',
																																		_1: {
																																			ctor: '::',
																																			_0: 'Africa/Kinshasa',
																																			_1: {
																																				ctor: '::',
																																				_0: 'Africa/Lagos',
																																				_1: {
																																					ctor: '::',
																																					_0: 'Africa/Libreville',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Africa/Lome',
																																						_1: {
																																							ctor: '::',
																																							_0: 'Africa/Luanda',
																																							_1: {
																																								ctor: '::',
																																								_0: 'Africa/Lubumbashi',
																																								_1: {
																																									ctor: '::',
																																									_0: 'Africa/Lusaka',
																																									_1: {
																																										ctor: '::',
																																										_0: 'Africa/Malabo',
																																										_1: {
																																											ctor: '::',
																																											_0: 'Africa/Maputo',
																																											_1: {
																																												ctor: '::',
																																												_0: 'Africa/Maseru',
																																												_1: {
																																													ctor: '::',
																																													_0: 'Africa/Mbabane',
																																													_1: {
																																														ctor: '::',
																																														_0: 'Africa/Mogadishu',
																																														_1: {
																																															ctor: '::',
																																															_0: 'Africa/Monrovia',
																																															_1: {
																																																ctor: '::',
																																																_0: 'Africa/Nairobi',
																																																_1: {
																																																	ctor: '::',
																																																	_0: 'Africa/Ndjamena',
																																																	_1: {
																																																		ctor: '::',
																																																		_0: 'Africa/Niamey',
																																																		_1: {
																																																			ctor: '::',
																																																			_0: 'Africa/Nouakchott',
																																																			_1: {
																																																				ctor: '::',
																																																				_0: 'Africa/Ouagadougou',
																																																				_1: {
																																																					ctor: '::',
																																																					_0: 'Africa/Porto-Novo',
																																																					_1: {
																																																						ctor: '::',
																																																						_0: 'Africa/Sao_Tome',
																																																						_1: {
																																																							ctor: '::',
																																																							_0: 'Africa/Timbuktu',
																																																							_1: {
																																																								ctor: '::',
																																																								_0: 'Africa/Tripoli',
																																																								_1: {
																																																									ctor: '::',
																																																									_0: 'Africa/Tunis',
																																																									_1: {
																																																										ctor: '::',
																																																										_0: 'Africa/Windhoek',
																																																										_1: {ctor: '[]'}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '::',
						_0: 'America/Anguilla',
						_1: {
							ctor: '::',
							_0: 'America/Antigua',
							_1: {
								ctor: '::',
								_0: 'America/Araguaina',
								_1: {
									ctor: '::',
									_0: 'America/Argentina/Buenos_Aires',
									_1: {
										ctor: '::',
										_0: 'America/Argentina/Catamarca',
										_1: {
											ctor: '::',
											_0: 'America/Argentina/ComodRivadavia',
											_1: {
												ctor: '::',
												_0: 'America/Argentina/Cordoba',
												_1: {
													ctor: '::',
													_0: 'America/Argentina/Jujuy',
													_1: {
														ctor: '::',
														_0: 'America/Argentina/La_Rioja',
														_1: {
															ctor: '::',
															_0: 'America/Argentina/Mendoza',
															_1: {
																ctor: '::',
																_0: 'America/Argentina/Rio_Gallegos',
																_1: {
																	ctor: '::',
																	_0: 'America/Argentina/Salta',
																	_1: {
																		ctor: '::',
																		_0: 'America/Argentina/San_Juan',
																		_1: {
																			ctor: '::',
																			_0: 'America/Argentina/San_Luis',
																			_1: {
																				ctor: '::',
																				_0: 'America/Argentina/Tucuman',
																				_1: {
																					ctor: '::',
																					_0: 'America/Argentina/Ushuaia',
																					_1: {
																						ctor: '::',
																						_0: 'America/Aruba',
																						_1: {
																							ctor: '::',
																							_0: 'America/Asuncion',
																							_1: {
																								ctor: '::',
																								_0: 'America/Atikokan',
																								_1: {
																									ctor: '::',
																									_0: 'America/Atka',
																									_1: {
																										ctor: '::',
																										_0: 'America/Bahia',
																										_1: {
																											ctor: '::',
																											_0: 'America/Bahia_Banderas',
																											_1: {
																												ctor: '::',
																												_0: 'America/Barbados',
																												_1: {
																													ctor: '::',
																													_0: 'America/Belem',
																													_1: {
																														ctor: '::',
																														_0: 'America/Belize',
																														_1: {
																															ctor: '::',
																															_0: 'America/Blanc-Sablon',
																															_1: {
																																ctor: '::',
																																_0: 'America/Boa_Vista',
																																_1: {
																																	ctor: '::',
																																	_0: 'America/Bogota',
																																	_1: {
																																		ctor: '::',
																																		_0: 'America/Buenos_Aires',
																																		_1: {
																																			ctor: '::',
																																			_0: 'America/Cambridge_Bay',
																																			_1: {
																																				ctor: '::',
																																				_0: 'America/Campo_Grande',
																																				_1: {
																																					ctor: '::',
																																					_0: 'America/Cancun',
																																					_1: {
																																						ctor: '::',
																																						_0: 'America/Caracas',
																																						_1: {
																																							ctor: '::',
																																							_0: 'America/Catamarca',
																																							_1: {
																																								ctor: '::',
																																								_0: 'America/Cayenne',
																																								_1: {
																																									ctor: '::',
																																									_0: 'America/Cayman',
																																									_1: {
																																										ctor: '::',
																																										_0: 'America/Chihuahua',
																																										_1: {
																																											ctor: '::',
																																											_0: 'America/Coral_Harbour',
																																											_1: {
																																												ctor: '::',
																																												_0: 'America/Cordoba',
																																												_1: {
																																													ctor: '::',
																																													_0: 'America/Costa_Rica',
																																													_1: {
																																														ctor: '::',
																																														_0: 'America/Creston',
																																														_1: {
																																															ctor: '::',
																																															_0: 'America/Cuiaba',
																																															_1: {
																																																ctor: '::',
																																																_0: 'America/Curacao',
																																																_1: {
																																																	ctor: '::',
																																																	_0: 'America/Danmarkshavn',
																																																	_1: {
																																																		ctor: '::',
																																																		_0: 'America/Dawson',
																																																		_1: {
																																																			ctor: '::',
																																																			_0: 'America/Dawson_Creek',
																																																			_1: {
																																																				ctor: '::',
																																																				_0: 'America/Dominica',
																																																				_1: {
																																																					ctor: '::',
																																																					_0: 'America/Edmonton',
																																																					_1: {
																																																						ctor: '::',
																																																						_0: 'America/Eirunepe',
																																																						_1: {
																																																							ctor: '::',
																																																							_0: 'America/El_Salvador',
																																																							_1: {
																																																								ctor: '::',
																																																								_0: 'America/Ensenada',
																																																								_1: {
																																																									ctor: '::',
																																																									_0: 'America/Fort_Nelson',
																																																									_1: {
																																																										ctor: '::',
																																																										_0: 'America/Fort_Wayne',
																																																										_1: {
																																																											ctor: '::',
																																																											_0: 'America/Fortaleza',
																																																											_1: {
																																																												ctor: '::',
																																																												_0: 'America/Glace_Bay',
																																																												_1: {
																																																													ctor: '::',
																																																													_0: 'America/Godthab',
																																																													_1: {
																																																														ctor: '::',
																																																														_0: 'America/Goose_Bay',
																																																														_1: {
																																																															ctor: '::',
																																																															_0: 'America/Grand_Turk',
																																																															_1: {
																																																																ctor: '::',
																																																																_0: 'America/Grenada',
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: 'America/Guadeloupe',
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: 'America/Guatemala',
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: 'America/Guayaquil',
																																																																			_1: {
																																																																				ctor: '::',
																																																																				_0: 'America/Guyana',
																																																																				_1: {
																																																																					ctor: '::',
																																																																					_0: 'America/Halifax',
																																																																					_1: {
																																																																						ctor: '::',
																																																																						_0: 'America/Havana',
																																																																						_1: {
																																																																							ctor: '::',
																																																																							_0: 'America/Hermosillo',
																																																																							_1: {
																																																																								ctor: '::',
																																																																								_0: 'America/Indianapolis',
																																																																								_1: {
																																																																									ctor: '::',
																																																																									_0: 'America/Inuvik',
																																																																									_1: {
																																																																										ctor: '::',
																																																																										_0: 'America/Iqaluit',
																																																																										_1: {
																																																																											ctor: '::',
																																																																											_0: 'America/Jamaica',
																																																																											_1: {
																																																																												ctor: '::',
																																																																												_0: 'America/Jujuy',
																																																																												_1: {
																																																																													ctor: '::',
																																																																													_0: 'America/Knox_IN',
																																																																													_1: {
																																																																														ctor: '::',
																																																																														_0: 'America/Kralendijk',
																																																																														_1: {
																																																																															ctor: '::',
																																																																															_0: 'America/La_Paz',
																																																																															_1: {
																																																																																ctor: '::',
																																																																																_0: 'America/Lima',
																																																																																_1: {
																																																																																	ctor: '::',
																																																																																	_0: 'America/Louisville',
																																																																																	_1: {
																																																																																		ctor: '::',
																																																																																		_0: 'America/Lower_Princes',
																																																																																		_1: {
																																																																																			ctor: '::',
																																																																																			_0: 'America/Maceio',
																																																																																			_1: {
																																																																																				ctor: '::',
																																																																																				_0: 'America/Managua',
																																																																																				_1: {
																																																																																					ctor: '::',
																																																																																					_0: 'America/Manaus',
																																																																																					_1: {
																																																																																						ctor: '::',
																																																																																						_0: 'America/Marigot',
																																																																																						_1: {
																																																																																							ctor: '::',
																																																																																							_0: 'America/Martinique',
																																																																																							_1: {
																																																																																								ctor: '::',
																																																																																								_0: 'America/Matamoros',
																																																																																								_1: {
																																																																																									ctor: '::',
																																																																																									_0: 'America/Mazatlan',
																																																																																									_1: {
																																																																																										ctor: '::',
																																																																																										_0: 'America/Mendoza',
																																																																																										_1: {
																																																																																											ctor: '::',
																																																																																											_0: 'America/Merida',
																																																																																											_1: {
																																																																																												ctor: '::',
																																																																																												_0: 'America/Mexico_City',
																																																																																												_1: {
																																																																																													ctor: '::',
																																																																																													_0: 'America/Miquelon',
																																																																																													_1: {
																																																																																														ctor: '::',
																																																																																														_0: 'America/Moncton',
																																																																																														_1: {
																																																																																															ctor: '::',
																																																																																															_0: 'America/Monterrey',
																																																																																															_1: {
																																																																																																ctor: '::',
																																																																																																_0: 'America/Montevideo',
																																																																																																_1: {
																																																																																																	ctor: '::',
																																																																																																	_0: 'America/Montreal',
																																																																																																	_1: {
																																																																																																		ctor: '::',
																																																																																																		_0: 'America/Montserrat',
																																																																																																		_1: {
																																																																																																			ctor: '::',
																																																																																																			_0: 'America/Nassau',
																																																																																																			_1: {
																																																																																																				ctor: '::',
																																																																																																				_0: 'America/Nipigon',
																																																																																																				_1: {
																																																																																																					ctor: '::',
																																																																																																					_0: 'America/Noronha',
																																																																																																					_1: {
																																																																																																						ctor: '::',
																																																																																																						_0: 'America/Ojinaga',
																																																																																																						_1: {
																																																																																																							ctor: '::',
																																																																																																							_0: 'America/Panama',
																																																																																																							_1: {
																																																																																																								ctor: '::',
																																																																																																								_0: 'America/Pangnirtung',
																																																																																																								_1: {
																																																																																																									ctor: '::',
																																																																																																									_0: 'America/Paramaribo',
																																																																																																									_1: {
																																																																																																										ctor: '::',
																																																																																																										_0: 'America/Port-au-Prince',
																																																																																																										_1: {
																																																																																																											ctor: '::',
																																																																																																											_0: 'America/Port_of_Spain',
																																																																																																											_1: {
																																																																																																												ctor: '::',
																																																																																																												_0: 'America/Porto_Acre',
																																																																																																												_1: {
																																																																																																													ctor: '::',
																																																																																																													_0: 'America/Porto_Velho',
																																																																																																													_1: {
																																																																																																														ctor: '::',
																																																																																																														_0: 'America/Puerto_Rico',
																																																																																																														_1: {
																																																																																																															ctor: '::',
																																																																																																															_0: 'America/Rainy_River',
																																																																																																															_1: {
																																																																																																																ctor: '::',
																																																																																																																_0: 'America/Rankin_Inlet',
																																																																																																																_1: {
																																																																																																																	ctor: '::',
																																																																																																																	_0: 'America/Recife',
																																																																																																																	_1: {
																																																																																																																		ctor: '::',
																																																																																																																		_0: 'America/Regina',
																																																																																																																		_1: {
																																																																																																																			ctor: '::',
																																																																																																																			_0: 'America/Resolute',
																																																																																																																			_1: {
																																																																																																																				ctor: '::',
																																																																																																																				_0: 'America/Rio_Branco',
																																																																																																																				_1: {
																																																																																																																					ctor: '::',
																																																																																																																					_0: 'America/Rosario',
																																																																																																																					_1: {
																																																																																																																						ctor: '::',
																																																																																																																						_0: 'America/Santa_Isabel',
																																																																																																																						_1: {
																																																																																																																							ctor: '::',
																																																																																																																							_0: 'America/Santarem',
																																																																																																																							_1: {
																																																																																																																								ctor: '::',
																																																																																																																								_0: 'America/Santiago',
																																																																																																																								_1: {
																																																																																																																									ctor: '::',
																																																																																																																									_0: 'America/Santo_Domingo',
																																																																																																																									_1: {
																																																																																																																										ctor: '::',
																																																																																																																										_0: 'America/Sao_Paulo',
																																																																																																																										_1: {
																																																																																																																											ctor: '::',
																																																																																																																											_0: 'America/Scoresbysund',
																																																																																																																											_1: {
																																																																																																																												ctor: '::',
																																																																																																																												_0: 'America/Shiprock',
																																																																																																																												_1: {
																																																																																																																													ctor: '::',
																																																																																																																													_0: 'America/St_Barthelemy',
																																																																																																																													_1: {
																																																																																																																														ctor: '::',
																																																																																																																														_0: 'America/St_Johns',
																																																																																																																														_1: {
																																																																																																																															ctor: '::',
																																																																																																																															_0: 'America/St_Kitts',
																																																																																																																															_1: {
																																																																																																																																ctor: '::',
																																																																																																																																_0: 'America/St_Lucia',
																																																																																																																																_1: {
																																																																																																																																	ctor: '::',
																																																																																																																																	_0: 'America/St_Thomas',
																																																																																																																																	_1: {
																																																																																																																																		ctor: '::',
																																																																																																																																		_0: 'America/St_Vincent',
																																																																																																																																		_1: {
																																																																																																																																			ctor: '::',
																																																																																																																																			_0: 'America/Swift_Current',
																																																																																																																																			_1: {
																																																																																																																																				ctor: '::',
																																																																																																																																				_0: 'America/Tegucigalpa',
																																																																																																																																				_1: {
																																																																																																																																					ctor: '::',
																																																																																																																																					_0: 'America/Thule',
																																																																																																																																					_1: {
																																																																																																																																						ctor: '::',
																																																																																																																																						_0: 'America/Thunder_Bay',
																																																																																																																																						_1: {
																																																																																																																																							ctor: '::',
																																																																																																																																							_0: 'America/Tijuana',
																																																																																																																																							_1: {
																																																																																																																																								ctor: '::',
																																																																																																																																								_0: 'America/Toronto',
																																																																																																																																								_1: {
																																																																																																																																									ctor: '::',
																																																																																																																																									_0: 'America/Tortola',
																																																																																																																																									_1: {
																																																																																																																																										ctor: '::',
																																																																																																																																										_0: 'America/Vancouver',
																																																																																																																																										_1: {
																																																																																																																																											ctor: '::',
																																																																																																																																											_0: 'America/Virgin',
																																																																																																																																											_1: {
																																																																																																																																												ctor: '::',
																																																																																																																																												_0: 'America/Whitehorse',
																																																																																																																																												_1: {
																																																																																																																																													ctor: '::',
																																																																																																																																													_0: 'America/Winnipeg',
																																																																																																																																													_1: {
																																																																																																																																														ctor: '::',
																																																																																																																																														_0: 'America/Yellowknife',
																																																																																																																																														_1: {ctor: '[]'}
																																																																																																																																													}
																																																																																																																																												}
																																																																																																																																											}
																																																																																																																																										}
																																																																																																																																									}
																																																																																																																																								}
																																																																																																																																							}
																																																																																																																																						}
																																																																																																																																					}
																																																																																																																																				}
																																																																																																																																			}
																																																																																																																																		}
																																																																																																																																	}
																																																																																																																																}
																																																																																																																															}
																																																																																																																														}
																																																																																																																													}
																																																																																																																												}
																																																																																																																											}
																																																																																																																										}
																																																																																																																									}
																																																																																																																								}
																																																																																																																							}
																																																																																																																						}
																																																																																																																					}
																																																																																																																				}
																																																																																																																			}
																																																																																																																		}
																																																																																																																	}
																																																																																																																}
																																																																																																															}
																																																																																																														}
																																																																																																													}
																																																																																																												}
																																																																																																											}
																																																																																																										}
																																																																																																									}
																																																																																																								}
																																																																																																							}
																																																																																																						}
																																																																																																					}
																																																																																																				}
																																																																																																			}
																																																																																																		}
																																																																																																	}
																																																																																																}
																																																																																															}
																																																																																														}
																																																																																													}
																																																																																												}
																																																																																											}
																																																																																										}
																																																																																									}
																																																																																								}
																																																																																							}
																																																																																						}
																																																																																					}
																																																																																				}
																																																																																			}
																																																																																		}
																																																																																	}
																																																																																}
																																																																															}
																																																																														}
																																																																													}
																																																																												}
																																																																											}
																																																																										}
																																																																									}
																																																																								}
																																																																							}
																																																																						}
																																																																					}
																																																																				}
																																																																			}
																																																																		}
																																																																	}
																																																																}
																																																															}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '::',
							_0: 'Antarctica/Casey',
							_1: {
								ctor: '::',
								_0: 'Antarctica/Davis',
								_1: {
									ctor: '::',
									_0: 'Antarctica/DumontDUrville',
									_1: {
										ctor: '::',
										_0: 'Antarctica/Macquarie',
										_1: {
											ctor: '::',
											_0: 'Antarctica/Mawson',
											_1: {
												ctor: '::',
												_0: 'Antarctica/McMurdo',
												_1: {
													ctor: '::',
													_0: 'Antarctica/Palmer',
													_1: {
														ctor: '::',
														_0: 'Antarctica/Rothera',
														_1: {
															ctor: '::',
															_0: 'Antarctica/South_Pole',
															_1: {
																ctor: '::',
																_0: 'Antarctica/Syowa',
																_1: {
																	ctor: '::',
																	_0: 'Antarctica/Troll',
																	_1: {
																		ctor: '::',
																		_0: 'Antarctica/Vostok',
																		_1: {
																			ctor: '::',
																			_0: 'Arctic/Longyearbyen',
																			_1: {ctor: '[]'}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '::',
								_0: 'Asia/Aden',
								_1: {
									ctor: '::',
									_0: 'Asia/Almaty',
									_1: {
										ctor: '::',
										_0: 'Asia/Amman',
										_1: {
											ctor: '::',
											_0: 'Asia/Anadyr',
											_1: {
												ctor: '::',
												_0: 'Asia/Aqtau',
												_1: {
													ctor: '::',
													_0: 'Asia/Aqtobe',
													_1: {
														ctor: '::',
														_0: 'Asia/Ashgabat',
														_1: {
															ctor: '::',
															_0: 'Asia/Ashkhabad',
															_1: {
																ctor: '::',
																_0: 'Asia/Baghdad',
																_1: {
																	ctor: '::',
																	_0: 'Asia/Bahrain',
																	_1: {
																		ctor: '::',
																		_0: 'Asia/Baku',
																		_1: {
																			ctor: '::',
																			_0: 'Asia/Bangkok',
																			_1: {
																				ctor: '::',
																				_0: 'Asia/Barnaul',
																				_1: {
																					ctor: '::',
																					_0: 'Asia/Beirut',
																					_1: {
																						ctor: '::',
																						_0: 'Asia/Bishkek',
																						_1: {
																							ctor: '::',
																							_0: 'Asia/Brunei',
																							_1: {
																								ctor: '::',
																								_0: 'Asia/Calcutta',
																								_1: {
																									ctor: '::',
																									_0: 'Asia/Chita',
																									_1: {
																										ctor: '::',
																										_0: 'Asia/Choibalsan',
																										_1: {
																											ctor: '::',
																											_0: 'Asia/Chongqing',
																											_1: {
																												ctor: '::',
																												_0: 'Asia/Chungking',
																												_1: {
																													ctor: '::',
																													_0: 'Asia/Colombo',
																													_1: {
																														ctor: '::',
																														_0: 'Asia/Dacca',
																														_1: {
																															ctor: '::',
																															_0: 'Asia/Damascus',
																															_1: {
																																ctor: '::',
																																_0: 'Asia/Dhaka',
																																_1: {
																																	ctor: '::',
																																	_0: 'Asia/Dili',
																																	_1: {
																																		ctor: '::',
																																		_0: 'Asia/Dubai',
																																		_1: {
																																			ctor: '::',
																																			_0: 'Asia/Dushanbe',
																																			_1: {
																																				ctor: '::',
																																				_0: 'Asia/Gaza',
																																				_1: {
																																					ctor: '::',
																																					_0: 'Asia/Harbin',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Asia/Hebron',
																																						_1: {
																																							ctor: '::',
																																							_0: 'Asia/Ho_Chi_Minh',
																																							_1: {
																																								ctor: '::',
																																								_0: 'Asia/Hong_Kong',
																																								_1: {
																																									ctor: '::',
																																									_0: 'Asia/Hovd',
																																									_1: {
																																										ctor: '::',
																																										_0: 'Asia/Irkutsk',
																																										_1: {
																																											ctor: '::',
																																											_0: 'Asia/Istanbul',
																																											_1: {
																																												ctor: '::',
																																												_0: 'Asia/Jakarta',
																																												_1: {
																																													ctor: '::',
																																													_0: 'Asia/Jayapura',
																																													_1: {
																																														ctor: '::',
																																														_0: 'Asia/Jerusalem',
																																														_1: {
																																															ctor: '::',
																																															_0: 'Asia/Kabul',
																																															_1: {
																																																ctor: '::',
																																																_0: 'Asia/Kamchatka',
																																																_1: {
																																																	ctor: '::',
																																																	_0: 'Asia/Karachi',
																																																	_1: {
																																																		ctor: '::',
																																																		_0: 'Asia/Kashgar',
																																																		_1: {
																																																			ctor: '::',
																																																			_0: 'Asia/Kathmandu',
																																																			_1: {
																																																				ctor: '::',
																																																				_0: 'Asia/Katmandu',
																																																				_1: {
																																																					ctor: '::',
																																																					_0: 'Asia/Khandyga',
																																																					_1: {
																																																						ctor: '::',
																																																						_0: 'Asia/Kolkata',
																																																						_1: {
																																																							ctor: '::',
																																																							_0: 'Asia/Krasnoyarsk',
																																																							_1: {
																																																								ctor: '::',
																																																								_0: 'Asia/Kuala_Lumpur',
																																																								_1: {
																																																									ctor: '::',
																																																									_0: 'Asia/Kuching',
																																																									_1: {
																																																										ctor: '::',
																																																										_0: 'Asia/Kuwait',
																																																										_1: {
																																																											ctor: '::',
																																																											_0: 'Asia/Macao',
																																																											_1: {
																																																												ctor: '::',
																																																												_0: 'Asia/Macau',
																																																												_1: {
																																																													ctor: '::',
																																																													_0: 'Asia/Magadan',
																																																													_1: {
																																																														ctor: '::',
																																																														_0: 'Asia/Makassar',
																																																														_1: {
																																																															ctor: '::',
																																																															_0: 'Asia/Manila',
																																																															_1: {
																																																																ctor: '::',
																																																																_0: 'Asia/Muscat',
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: 'Asia/Nicosia',
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: 'Asia/Novokuznetsk',
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: 'Asia/Novosibirsk',
																																																																			_1: {
																																																																				ctor: '::',
																																																																				_0: 'Asia/Omsk',
																																																																				_1: {
																																																																					ctor: '::',
																																																																					_0: 'Asia/Oral',
																																																																					_1: {
																																																																						ctor: '::',
																																																																						_0: 'Asia/Phnom_Penh',
																																																																						_1: {
																																																																							ctor: '::',
																																																																							_0: 'Asia/Pontianak',
																																																																							_1: {
																																																																								ctor: '::',
																																																																								_0: 'Asia/Pyongyang',
																																																																								_1: {
																																																																									ctor: '::',
																																																																									_0: 'Asia/Qatar',
																																																																									_1: {
																																																																										ctor: '::',
																																																																										_0: 'Asia/Qyzylorda',
																																																																										_1: {
																																																																											ctor: '::',
																																																																											_0: 'Asia/Rangoon',
																																																																											_1: {
																																																																												ctor: '::',
																																																																												_0: 'Asia/Riyadh',
																																																																												_1: {
																																																																													ctor: '::',
																																																																													_0: 'Asia/Saigon',
																																																																													_1: {
																																																																														ctor: '::',
																																																																														_0: 'Asia/Sakhalin',
																																																																														_1: {
																																																																															ctor: '::',
																																																																															_0: 'Asia/Samarkand',
																																																																															_1: {
																																																																																ctor: '::',
																																																																																_0: 'Asia/Seoul',
																																																																																_1: {
																																																																																	ctor: '::',
																																																																																	_0: 'Asia/Shanghai',
																																																																																	_1: {
																																																																																		ctor: '::',
																																																																																		_0: 'Asia/Singapore',
																																																																																		_1: {
																																																																																			ctor: '::',
																																																																																			_0: 'Asia/Srednekolymsk',
																																																																																			_1: {
																																																																																				ctor: '::',
																																																																																				_0: 'Asia/Taipei',
																																																																																				_1: {
																																																																																					ctor: '::',
																																																																																					_0: 'Asia/Tashkent',
																																																																																					_1: {
																																																																																						ctor: '::',
																																																																																						_0: 'Asia/Tbilisi',
																																																																																						_1: {
																																																																																							ctor: '::',
																																																																																							_0: 'Asia/Tehran',
																																																																																							_1: {
																																																																																								ctor: '::',
																																																																																								_0: 'Asia/Tel_Aviv',
																																																																																								_1: {
																																																																																									ctor: '::',
																																																																																									_0: 'Asia/Thimbu',
																																																																																									_1: {
																																																																																										ctor: '::',
																																																																																										_0: 'Asia/Thimphu',
																																																																																										_1: {
																																																																																											ctor: '::',
																																																																																											_0: 'Asia/Tokyo',
																																																																																											_1: {
																																																																																												ctor: '::',
																																																																																												_0: 'Asia/Tomsk',
																																																																																												_1: {
																																																																																													ctor: '::',
																																																																																													_0: 'Asia/Ujung_Pandang',
																																																																																													_1: {
																																																																																														ctor: '::',
																																																																																														_0: 'Asia/Ulaanbaatar',
																																																																																														_1: {
																																																																																															ctor: '::',
																																																																																															_0: 'Asia/Ulan_Bator',
																																																																																															_1: {
																																																																																																ctor: '::',
																																																																																																_0: 'Asia/Urumqi',
																																																																																																_1: {
																																																																																																	ctor: '::',
																																																																																																	_0: 'Asia/Ust-Nera',
																																																																																																	_1: {
																																																																																																		ctor: '::',
																																																																																																		_0: 'Asia/Vientiane',
																																																																																																		_1: {
																																																																																																			ctor: '::',
																																																																																																			_0: 'Asia/Vladivostok',
																																																																																																			_1: {
																																																																																																				ctor: '::',
																																																																																																				_0: 'Asia/Yakutsk',
																																																																																																				_1: {
																																																																																																					ctor: '::',
																																																																																																					_0: 'Asia/Yangon',
																																																																																																					_1: {
																																																																																																						ctor: '::',
																																																																																																						_0: 'Asia/Yekaterinburg',
																																																																																																						_1: {
																																																																																																							ctor: '::',
																																																																																																							_0: 'Asia/Yerevan',
																																																																																																							_1: {ctor: '[]'}
																																																																																																						}
																																																																																																					}
																																																																																																				}
																																																																																																			}
																																																																																																		}
																																																																																																	}
																																																																																																}
																																																																																															}
																																																																																														}
																																																																																													}
																																																																																												}
																																																																																											}
																																																																																										}
																																																																																									}
																																																																																								}
																																																																																							}
																																																																																						}
																																																																																					}
																																																																																				}
																																																																																			}
																																																																																		}
																																																																																	}
																																																																																}
																																																																															}
																																																																														}
																																																																													}
																																																																												}
																																																																											}
																																																																										}
																																																																									}
																																																																								}
																																																																							}
																																																																						}
																																																																					}
																																																																				}
																																																																			}
																																																																		}
																																																																	}
																																																																}
																																																															}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '::',
									_0: 'Atlantic/Azores',
									_1: {
										ctor: '::',
										_0: 'Atlantic/Bermuda',
										_1: {
											ctor: '::',
											_0: 'Atlantic/Canary',
											_1: {
												ctor: '::',
												_0: 'Atlantic/Cape_Verde',
												_1: {
													ctor: '::',
													_0: 'Atlantic/Faeroe',
													_1: {
														ctor: '::',
														_0: 'Atlantic/Faroe',
														_1: {
															ctor: '::',
															_0: 'Atlantic/Jan_Mayen',
															_1: {
																ctor: '::',
																_0: 'Atlantic/Madeira',
																_1: {
																	ctor: '::',
																	_0: 'Atlantic/Reykjavik',
																	_1: {
																		ctor: '::',
																		_0: 'Atlantic/South_Georgia',
																		_1: {
																			ctor: '::',
																			_0: 'Atlantic/St_Helena',
																			_1: {
																				ctor: '::',
																				_0: 'Atlantic/Stanley',
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '::',
										_0: 'Australia/ACT',
										_1: {
											ctor: '::',
											_0: 'Australia/Adelaide',
											_1: {
												ctor: '::',
												_0: 'Australia/Brisbane',
												_1: {
													ctor: '::',
													_0: 'Australia/Broken_Hill',
													_1: {
														ctor: '::',
														_0: 'Australia/Canberra',
														_1: {
															ctor: '::',
															_0: 'Australia/Currie',
															_1: {
																ctor: '::',
																_0: 'Australia/Darwin',
																_1: {
																	ctor: '::',
																	_0: 'Australia/Eucla',
																	_1: {
																		ctor: '::',
																		_0: 'Australia/Hobart',
																		_1: {
																			ctor: '::',
																			_0: 'Australia/LHI',
																			_1: {
																				ctor: '::',
																				_0: 'Australia/Lindeman',
																				_1: {
																					ctor: '::',
																					_0: 'Australia/Lord_Howe',
																					_1: {
																						ctor: '::',
																						_0: 'Australia/Melbourne',
																						_1: {
																							ctor: '::',
																							_0: 'Australia/NSW',
																							_1: {
																								ctor: '::',
																								_0: 'Australia/North',
																								_1: {
																									ctor: '::',
																									_0: 'Australia/Perth',
																									_1: {
																										ctor: '::',
																										_0: 'Australia/Queensland',
																										_1: {
																											ctor: '::',
																											_0: 'Australia/South',
																											_1: {
																												ctor: '::',
																												_0: 'Australia/Sydney',
																												_1: {
																													ctor: '::',
																													_0: 'Australia/Tasmania',
																													_1: {
																														ctor: '::',
																														_0: 'Australia/Victoria',
																														_1: {
																															ctor: '::',
																															_0: 'Australia/West',
																															_1: {
																																ctor: '::',
																																_0: 'Australia/Yancowinna',
																																_1: {ctor: '[]'}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '::',
											_0: 'Brazil/Acre',
											_1: {
												ctor: '::',
												_0: 'Brazil/DeNoronha',
												_1: {
													ctor: '::',
													_0: 'Brazil/East',
													_1: {
														ctor: '::',
														_0: 'Brazil/West',
														_1: {ctor: '[]'}
													}
												}
											}
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '::',
												_0: 'CET',
												_1: {
													ctor: '::',
													_0: 'CST6CDT',
													_1: {ctor: '[]'}
												}
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '::',
													_0: 'Canada/Atlantic',
													_1: {
														ctor: '::',
														_0: 'Canada/Central',
														_1: {
															ctor: '::',
															_0: 'Canada/East-Saskatchewan',
															_1: {
																ctor: '::',
																_0: 'Canada/Eastern',
																_1: {
																	ctor: '::',
																	_0: 'Canada/Mountain',
																	_1: {
																		ctor: '::',
																		_0: 'Canada/Newfoundland',
																		_1: {
																			ctor: '::',
																			_0: 'Canada/Pacific',
																			_1: {
																				ctor: '::',
																				_0: 'Canada/Saskatchewan',
																				_1: {
																					ctor: '::',
																					_0: 'Canada/Yukon',
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												},
												_1: {
													ctor: '::',
													_0: {
														ctor: '::',
														_0: 'Chile/Continental',
														_1: {
															ctor: '::',
															_0: 'Chile/EasterIsland',
															_1: {
																ctor: '::',
																_0: 'Cuba',
																_1: {
																	ctor: '::',
																	_0: 'EET',
																	_1: {
																		ctor: '::',
																		_0: 'EST',
																		_1: {
																			ctor: '::',
																			_0: 'EST5EDT',
																			_1: {
																				ctor: '::',
																				_0: 'Egypt',
																				_1: {
																					ctor: '::',
																					_0: 'Eire',
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}
																}
															}
														}
													},
													_1: {
														ctor: '::',
														_0: {
															ctor: '::',
															_0: 'Etc/GMT',
															_1: {
																ctor: '::',
																_0: 'Etc/GMT+0',
																_1: {
																	ctor: '::',
																	_0: 'Etc/GMT+1',
																	_1: {
																		ctor: '::',
																		_0: 'Etc/GMT+10',
																		_1: {
																			ctor: '::',
																			_0: 'Etc/GMT+11',
																			_1: {
																				ctor: '::',
																				_0: 'Etc/GMT+12',
																				_1: {
																					ctor: '::',
																					_0: 'Etc/GMT+2',
																					_1: {
																						ctor: '::',
																						_0: 'Etc/GMT+3',
																						_1: {
																							ctor: '::',
																							_0: 'Etc/GMT+4',
																							_1: {
																								ctor: '::',
																								_0: 'Etc/GMT+5',
																								_1: {
																									ctor: '::',
																									_0: 'Etc/GMT+6',
																									_1: {
																										ctor: '::',
																										_0: 'Etc/GMT+7',
																										_1: {
																											ctor: '::',
																											_0: 'Etc/GMT+8',
																											_1: {
																												ctor: '::',
																												_0: 'Etc/GMT+9',
																												_1: {
																													ctor: '::',
																													_0: 'Etc/GMT-0',
																													_1: {
																														ctor: '::',
																														_0: 'Etc/GMT-1',
																														_1: {
																															ctor: '::',
																															_0: 'Etc/GMT-10',
																															_1: {
																																ctor: '::',
																																_0: 'Etc/GMT-11',
																																_1: {
																																	ctor: '::',
																																	_0: 'Etc/GMT-12',
																																	_1: {
																																		ctor: '::',
																																		_0: 'Etc/GMT-13',
																																		_1: {
																																			ctor: '::',
																																			_0: 'Etc/GMT-14',
																																			_1: {
																																				ctor: '::',
																																				_0: 'Etc/GMT-2',
																																				_1: {
																																					ctor: '::',
																																					_0: 'Etc/GMT-3',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Etc/GMT-4',
																																						_1: {
																																							ctor: '::',
																																							_0: 'Etc/GMT-5',
																																							_1: {
																																								ctor: '::',
																																								_0: 'Etc/GMT-6',
																																								_1: {
																																									ctor: '::',
																																									_0: 'Etc/GMT-7',
																																									_1: {
																																										ctor: '::',
																																										_0: 'Etc/GMT-8',
																																										_1: {
																																											ctor: '::',
																																											_0: 'Etc/GMT-9',
																																											_1: {
																																												ctor: '::',
																																												_0: 'Etc/GMT0',
																																												_1: {
																																													ctor: '::',
																																													_0: 'Etc/Greenwich',
																																													_1: {
																																														ctor: '::',
																																														_0: 'Etc/UCT',
																																														_1: {
																																															ctor: '::',
																																															_0: 'Etc/UTC',
																																															_1: {
																																																ctor: '::',
																																																_0: 'Etc/Universal',
																																																_1: {
																																																	ctor: '::',
																																																	_0: 'Etc/Zulu',
																																																	_1: {ctor: '[]'}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														},
														_1: {
															ctor: '::',
															_0: {
																ctor: '::',
																_0: 'Europe/Amsterdam',
																_1: {
																	ctor: '::',
																	_0: 'Europe/Andorra',
																	_1: {
																		ctor: '::',
																		_0: 'Europe/Astrakhan',
																		_1: {
																			ctor: '::',
																			_0: 'Europe/Athens',
																			_1: {
																				ctor: '::',
																				_0: 'Europe/Belfast',
																				_1: {
																					ctor: '::',
																					_0: 'Europe/Belgrade',
																					_1: {
																						ctor: '::',
																						_0: 'Europe/Berlin',
																						_1: {
																							ctor: '::',
																							_0: 'Europe/Bratislava',
																							_1: {
																								ctor: '::',
																								_0: 'Europe/Brussels',
																								_1: {
																									ctor: '::',
																									_0: 'Europe/Bucharest',
																									_1: {
																										ctor: '::',
																										_0: 'Europe/Budapest',
																										_1: {
																											ctor: '::',
																											_0: 'Europe/Busingen',
																											_1: {
																												ctor: '::',
																												_0: 'Europe/Chisinau',
																												_1: {
																													ctor: '::',
																													_0: 'Europe/Copenhagen',
																													_1: {
																														ctor: '::',
																														_0: 'Europe/Dublin',
																														_1: {
																															ctor: '::',
																															_0: 'Europe/Gibraltar',
																															_1: {
																																ctor: '::',
																																_0: 'Europe/Guernsey',
																																_1: {
																																	ctor: '::',
																																	_0: 'Europe/Helsinki',
																																	_1: {
																																		ctor: '::',
																																		_0: 'Europe/Isle_of_Man',
																																		_1: {
																																			ctor: '::',
																																			_0: 'Europe/Istanbul',
																																			_1: {
																																				ctor: '::',
																																				_0: 'Europe/Jersey',
																																				_1: {
																																					ctor: '::',
																																					_0: 'Europe/Kaliningrad',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Europe/Kiev',
																																						_1: {
																																							ctor: '::',
																																							_0: 'Europe/Kirov',
																																							_1: {
																																								ctor: '::',
																																								_0: 'Europe/Lisbon',
																																								_1: {
																																									ctor: '::',
																																									_0: 'Europe/Ljubljana',
																																									_1: {
																																										ctor: '::',
																																										_0: 'Europe/London',
																																										_1: {
																																											ctor: '::',
																																											_0: 'Europe/Luxembourg',
																																											_1: {
																																												ctor: '::',
																																												_0: 'Europe/Madrid',
																																												_1: {
																																													ctor: '::',
																																													_0: 'Europe/Malta',
																																													_1: {
																																														ctor: '::',
																																														_0: 'Europe/Mariehamn',
																																														_1: {
																																															ctor: '::',
																																															_0: 'Europe/Minsk',
																																															_1: {
																																																ctor: '::',
																																																_0: 'Europe/Monaco',
																																																_1: {
																																																	ctor: '::',
																																																	_0: 'Europe/Moscow',
																																																	_1: {
																																																		ctor: '::',
																																																		_0: 'Europe/Nicosia',
																																																		_1: {
																																																			ctor: '::',
																																																			_0: 'Europe/Oslo',
																																																			_1: {
																																																				ctor: '::',
																																																				_0: 'Europe/Paris',
																																																				_1: {
																																																					ctor: '::',
																																																					_0: 'Europe/Podgorica',
																																																					_1: {
																																																						ctor: '::',
																																																						_0: 'Europe/Prague',
																																																						_1: {
																																																							ctor: '::',
																																																							_0: 'Europe/Riga',
																																																							_1: {
																																																								ctor: '::',
																																																								_0: 'Europe/Rome',
																																																								_1: {
																																																									ctor: '::',
																																																									_0: 'Europe/Samara',
																																																									_1: {
																																																										ctor: '::',
																																																										_0: 'Europe/San_Marino',
																																																										_1: {
																																																											ctor: '::',
																																																											_0: 'Europe/Sarajevo',
																																																											_1: {
																																																												ctor: '::',
																																																												_0: 'Europe/Simferopol',
																																																												_1: {
																																																													ctor: '::',
																																																													_0: 'Europe/Skopje',
																																																													_1: {
																																																														ctor: '::',
																																																														_0: 'Europe/Sofia',
																																																														_1: {
																																																															ctor: '::',
																																																															_0: 'Europe/Stockholm',
																																																															_1: {
																																																																ctor: '::',
																																																																_0: 'Europe/Tallinn',
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: 'Europe/Tirane',
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: 'Europe/Tiraspol',
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: 'Europe/Ulyanovsk',
																																																																			_1: {
																																																																				ctor: '::',
																																																																				_0: 'Europe/Uzhgorod',
																																																																				_1: {
																																																																					ctor: '::',
																																																																					_0: 'Europe/Vaduz',
																																																																					_1: {
																																																																						ctor: '::',
																																																																						_0: 'Europe/Vatican',
																																																																						_1: {
																																																																							ctor: '::',
																																																																							_0: 'Europe/Vienna',
																																																																							_1: {
																																																																								ctor: '::',
																																																																								_0: 'Europe/Vilnius',
																																																																								_1: {
																																																																									ctor: '::',
																																																																									_0: 'Europe/Volgograd',
																																																																									_1: {
																																																																										ctor: '::',
																																																																										_0: 'Europe/Warsaw',
																																																																										_1: {
																																																																											ctor: '::',
																																																																											_0: 'Europe/Zagreb',
																																																																											_1: {
																																																																												ctor: '::',
																																																																												_0: 'Europe/Zaporozhye',
																																																																												_1: {
																																																																													ctor: '::',
																																																																													_0: 'Europe/Zurich',
																																																																													_1: {ctor: '[]'}
																																																																												}
																																																																											}
																																																																										}
																																																																									}
																																																																								}
																																																																							}
																																																																						}
																																																																					}
																																																																				}
																																																																			}
																																																																		}
																																																																	}
																																																																}
																																																															}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															},
															_1: {
																ctor: '::',
																_0: {
																	ctor: '::',
																	_0: 'GB',
																	_1: {
																		ctor: '::',
																		_0: 'GB-Eire',
																		_1: {
																			ctor: '::',
																			_0: 'GMT',
																			_1: {
																				ctor: '::',
																				_0: 'GMT+0',
																				_1: {
																					ctor: '::',
																					_0: 'GMT-0',
																					_1: {
																						ctor: '::',
																						_0: 'GMT0',
																						_1: {
																							ctor: '::',
																							_0: 'Greenwich',
																							_1: {
																								ctor: '::',
																								_0: 'HST',
																								_1: {
																									ctor: '::',
																									_0: 'Hongkong',
																									_1: {
																										ctor: '::',
																										_0: 'Iceland',
																										_1: {ctor: '[]'}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																},
																_1: {
																	ctor: '::',
																	_0: {
																		ctor: '::',
																		_0: 'Indian/Antananarivo',
																		_1: {
																			ctor: '::',
																			_0: 'Indian/Chagos',
																			_1: {
																				ctor: '::',
																				_0: 'Indian/Christmas',
																				_1: {
																					ctor: '::',
																					_0: 'Indian/Cocos',
																					_1: {
																						ctor: '::',
																						_0: 'Indian/Comoro',
																						_1: {
																							ctor: '::',
																							_0: 'Indian/Kerguelen',
																							_1: {
																								ctor: '::',
																								_0: 'Indian/Mahe',
																								_1: {
																									ctor: '::',
																									_0: 'Indian/Maldives',
																									_1: {
																										ctor: '::',
																										_0: 'Indian/Mauritius',
																										_1: {
																											ctor: '::',
																											_0: 'Indian/Mayotte',
																											_1: {
																												ctor: '::',
																												_0: 'Indian/Reunion',
																												_1: {
																													ctor: '::',
																													_0: 'Iran',
																													_1: {
																														ctor: '::',
																														_0: 'Israel',
																														_1: {
																															ctor: '::',
																															_0: 'Jamaica',
																															_1: {
																																ctor: '::',
																																_0: 'Japan',
																																_1: {
																																	ctor: '::',
																																	_0: 'Kwajalein',
																																	_1: {
																																		ctor: '::',
																																		_0: 'Libya',
																																		_1: {
																																			ctor: '::',
																																			_0: 'MET',
																																			_1: {
																																				ctor: '::',
																																				_0: 'MST',
																																				_1: {
																																					ctor: '::',
																																					_0: 'MST7MDT',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Mexico/BajaNorte',
																																						_1: {
																																							ctor: '::',
																																							_0: 'Mexico/BajaSur',
																																							_1: {
																																								ctor: '::',
																																								_0: 'Mexico/General',
																																								_1: {
																																									ctor: '::',
																																									_0: 'NZ',
																																									_1: {
																																										ctor: '::',
																																										_0: 'NZ-CHAT',
																																										_1: {
																																											ctor: '::',
																																											_0: 'Navajo',
																																											_1: {
																																												ctor: '::',
																																												_0: 'PRC',
																																												_1: {
																																													ctor: '::',
																																													_0: 'PST8PDT',
																																													_1: {ctor: '[]'}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	},
																	_1: {
																		ctor: '::',
																		_0: {
																			ctor: '::',
																			_0: 'Pacific/Apia',
																			_1: {
																				ctor: '::',
																				_0: 'Pacific/Auckland',
																				_1: {
																					ctor: '::',
																					_0: 'Pacific/Bougainville',
																					_1: {
																						ctor: '::',
																						_0: 'Pacific/Chatham',
																						_1: {
																							ctor: '::',
																							_0: 'Pacific/Chuuk',
																							_1: {
																								ctor: '::',
																								_0: 'Pacific/Easter',
																								_1: {
																									ctor: '::',
																									_0: 'Pacific/Efate',
																									_1: {
																										ctor: '::',
																										_0: 'Pacific/Enderbury',
																										_1: {
																											ctor: '::',
																											_0: 'Pacific/Fakaofo',
																											_1: {
																												ctor: '::',
																												_0: 'Pacific/Fiji',
																												_1: {
																													ctor: '::',
																													_0: 'Pacific/Funafuti',
																													_1: {
																														ctor: '::',
																														_0: 'Pacific/Galapagos',
																														_1: {
																															ctor: '::',
																															_0: 'Pacific/Gambier',
																															_1: {
																																ctor: '::',
																																_0: 'Pacific/Guadalcanal',
																																_1: {
																																	ctor: '::',
																																	_0: 'Pacific/Guam',
																																	_1: {
																																		ctor: '::',
																																		_0: 'Pacific/Johnston',
																																		_1: {
																																			ctor: '::',
																																			_0: 'Pacific/Kiritimati',
																																			_1: {
																																				ctor: '::',
																																				_0: 'Pacific/Kosrae',
																																				_1: {
																																					ctor: '::',
																																					_0: 'Pacific/Kwajalein',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Pacific/Majuro',
																																						_1: {
																																							ctor: '::',
																																							_0: 'Pacific/Marquesas',
																																							_1: {
																																								ctor: '::',
																																								_0: 'Pacific/Midway',
																																								_1: {
																																									ctor: '::',
																																									_0: 'Pacific/Nauru',
																																									_1: {
																																										ctor: '::',
																																										_0: 'Pacific/Niue',
																																										_1: {
																																											ctor: '::',
																																											_0: 'Pacific/Norfolk',
																																											_1: {
																																												ctor: '::',
																																												_0: 'Pacific/Noumea',
																																												_1: {
																																													ctor: '::',
																																													_0: 'Pacific/Pago_Pago',
																																													_1: {
																																														ctor: '::',
																																														_0: 'Pacific/Palau',
																																														_1: {
																																															ctor: '::',
																																															_0: 'Pacific/Pitcairn',
																																															_1: {
																																																ctor: '::',
																																																_0: 'Pacific/Pohnpei',
																																																_1: {
																																																	ctor: '::',
																																																	_0: 'Pacific/Ponape',
																																																	_1: {
																																																		ctor: '::',
																																																		_0: 'Pacific/Port_Moresby',
																																																		_1: {
																																																			ctor: '::',
																																																			_0: 'Pacific/Rarotonga',
																																																			_1: {
																																																				ctor: '::',
																																																				_0: 'Pacific/Saipan',
																																																				_1: {
																																																					ctor: '::',
																																																					_0: 'Pacific/Samoa',
																																																					_1: {
																																																						ctor: '::',
																																																						_0: 'Pacific/Tahiti',
																																																						_1: {
																																																							ctor: '::',
																																																							_0: 'Pacific/Tarawa',
																																																							_1: {
																																																								ctor: '::',
																																																								_0: 'Pacific/Tongatapu',
																																																								_1: {
																																																									ctor: '::',
																																																									_0: 'Pacific/Truk',
																																																									_1: {
																																																										ctor: '::',
																																																										_0: 'Pacific/Wake',
																																																										_1: {
																																																											ctor: '::',
																																																											_0: 'Pacific/Wallis',
																																																											_1: {
																																																												ctor: '::',
																																																												_0: 'Pacific/Yap',
																																																												_1: {ctor: '[]'}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		},
																		_1: {
																			ctor: '::',
																			_0: {
																				ctor: '::',
																				_0: 'Poland',
																				_1: {
																					ctor: '::',
																					_0: 'Portugal',
																					_1: {
																						ctor: '::',
																						_0: 'ROC',
																						_1: {
																							ctor: '::',
																							_0: 'ROK',
																							_1: {
																								ctor: '::',
																								_0: 'Singapore',
																								_1: {
																									ctor: '::',
																									_0: 'SystemV/AST4',
																									_1: {
																										ctor: '::',
																										_0: 'SystemV/AST4ADT',
																										_1: {
																											ctor: '::',
																											_0: 'SystemV/CST6',
																											_1: {
																												ctor: '::',
																												_0: 'SystemV/CST6CDT',
																												_1: {
																													ctor: '::',
																													_0: 'SystemV/EST5',
																													_1: {
																														ctor: '::',
																														_0: 'SystemV/EST5EDT',
																														_1: {
																															ctor: '::',
																															_0: 'SystemV/HST10',
																															_1: {
																																ctor: '::',
																																_0: 'SystemV/MST7',
																																_1: {
																																	ctor: '::',
																																	_0: 'SystemV/MST7MDT',
																																	_1: {
																																		ctor: '::',
																																		_0: 'SystemV/PST8',
																																		_1: {
																																			ctor: '::',
																																			_0: 'SystemV/PST8PDT',
																																			_1: {
																																				ctor: '::',
																																				_0: 'SystemV/YST9',
																																				_1: {
																																					ctor: '::',
																																					_0: 'SystemV/YST9YDT',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Turkey',
																																						_1: {
																																							ctor: '::',
																																							_0: 'UCT',
																																							_1: {ctor: '[]'}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			},
																			_1: {
																				ctor: '::',
																				_0: {
																					ctor: '::',
																					_0: 'US/Alaska',
																					_1: {
																						ctor: '::',
																						_0: 'US/Aleutian',
																						_1: {
																							ctor: '::',
																							_0: 'US/Arizona',
																							_1: {
																								ctor: '::',
																								_0: 'US/Central',
																								_1: {
																									ctor: '::',
																									_0: 'US/East-Indiana',
																									_1: {
																										ctor: '::',
																										_0: 'US/Eastern',
																										_1: {
																											ctor: '::',
																											_0: 'US/Hawaii',
																											_1: {
																												ctor: '::',
																												_0: 'US/Indiana-Starke',
																												_1: {
																													ctor: '::',
																													_0: 'US/Michigan',
																													_1: {
																														ctor: '::',
																														_0: 'US/Mountain',
																														_1: {
																															ctor: '::',
																															_0: 'US/Pacific',
																															_1: {
																																ctor: '::',
																																_0: 'US/Pacific-New',
																																_1: {
																																	ctor: '::',
																																	_0: 'US/Samoa',
																																	_1: {
																																		ctor: '::',
																																		_0: 'UTC',
																																		_1: {
																																			ctor: '::',
																																			_0: 'Universal',
																																			_1: {
																																				ctor: '::',
																																				_0: 'W-SU',
																																				_1: {
																																					ctor: '::',
																																					_0: 'WET',
																																					_1: {
																																						ctor: '::',
																																						_0: 'Zulu',
																																						_1: {ctor: '[]'}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				},
																				_1: {ctor: '[]'}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var _CareerPlug$ats$Models_Timezone$underscoreRegex = _elm_lang$core$Regex$regex('_');
var _CareerPlug$ats$Models_Timezone$tzName = A3(
	_elm_lang$core$Regex$replace,
	_elm_lang$core$Regex$All,
	_CareerPlug$ats$Models_Timezone$underscoreRegex,
	function (_p0) {
		return ' ';
	});

var _CareerPlug$ats$Library_BootstrapForm$dateField = F2(
	function (form, name) {
		var hireDateF = A2(_etaque$elm_form$Form$getFieldAsString, name, form);
		var _p0 = hireDateF.value;
		if (_p0.ctor === 'Just') {
			return _elm_lang$core$Result$toMaybe(
				_elm_lang$core$Date$fromString(_p0._0));
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _CareerPlug$ats$Library_BootstrapForm$boolField = F2(
	function (form, name) {
		var field = A2(_etaque$elm_form$Form$getFieldAsBool, name, form);
		return A2(_elm_lang$core$Maybe$withDefault, false, field.value);
	});
var _CareerPlug$ats$Library_BootstrapForm$stringField = F2(
	function (form, name) {
		var field = A2(_etaque$elm_form$Form$getFieldAsString, name, form);
		return A2(_elm_lang$core$Maybe$withDefault, '', field.value);
	});
var _CareerPlug$ats$Library_BootstrapForm$errorString = function (error) {
	var _p1 = error;
	switch (_p1.ctor) {
		case 'Empty':
			return 'cannot be blank';
		case 'InvalidString':
			return 'cannot be blank';
		case 'InvalidEmail':
			return 'should look like an email address';
		case 'InvalidUrl':
			return 'should look like a web address';
		case 'InvalidFormat':
			return 'invalid format';
		case 'InvalidInt':
			return 'should be an integer';
		case 'InvalidFloat':
			return 'should be a number';
		case 'InvalidBool':
			return 'should be true or false';
		case 'InvalidDate':
			return 'should look like a date';
		case 'SmallerIntThan':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'must be less than ',
				_elm_lang$core$Basics$toString(_p1._0));
		case 'GreaterIntThan':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'must be greater than ',
				_elm_lang$core$Basics$toString(_p1._0));
		case 'SmallerFloatThan':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'must be less than ',
				_elm_lang$core$Basics$toString(_p1._0));
		case 'GreaterFloatThan':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'must be greater than ',
				_elm_lang$core$Basics$toString(_p1._0));
		case 'ShorterStringThan':
			return _elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'must be at least ',
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(_p1._0),
						_1: {
							ctor: '::',
							_0: ' characters',
							_1: {ctor: '[]'}
						}
					}
				});
		case 'LongerStringThan':
			return _elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: 'may not be longer than ',
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Basics$toString(_p1._0),
						_1: {
							ctor: '::',
							_0: ' characters',
							_1: {ctor: '[]'}
						}
					}
				});
		case 'NotIncludedIn':
			return 'must be one of the given options';
		default:
			return _p1._0;
	}
};
var _CareerPlug$ats$Library_BootstrapForm$errorMessage = F2(
	function (maybeError, hint) {
		var _p2 = maybeError;
		if (_p2.ctor === 'Just') {
			return A2(
				_elm_lang$html$Html$p,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('help-block'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						_CareerPlug$ats$Library_BootstrapForm$errorString(_p2._0)),
					_1: {ctor: '[]'}
				});
		} else {
			return (_elm_lang$core$Native_Utils.cmp(
				_elm_lang$core$String$length(hint),
				0) > 0) ? A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('help-block'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A3(
						_evancz$elm_markdown$Markdown$toHtmlWith,
						_elm_lang$core$Native_Utils.update(
							_evancz$elm_markdown$Markdown$defaultOptions,
							{sanitize: true}),
						{ctor: '[]'},
						hint),
					_1: {ctor: '[]'}
				}) : A2(
				_elm_lang$html$Html$span,
				{ctor: '[]'},
				{ctor: '[]'});
		}
	});
var _CareerPlug$ats$Library_BootstrapForm$errorClass = function (maybeError) {
	return A2(
		_elm_lang$core$Maybe$withDefault,
		'',
		A2(
			_elm_lang$core$Maybe$map,
			function (_p3) {
				return 'has-error';
			},
			maybeError));
};
var _CareerPlug$ats$Library_BootstrapForm$formActions = function (content) {
	return A2(
		_elm_lang$html$Html$fieldset,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('actions'),
			_1: {ctor: '[]'}
		},
		content);
};
var _CareerPlug$ats$Library_BootstrapForm$controlLabel = F2(
	function (content, required) {
		var requiredContent = required ? {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$small,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('*'),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		return A2(
			_elm_lang$html$Html$label,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('control-label'),
				_1: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$Basics_ops['++'],
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$span,
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html_Attributes$property,
								'innerHTML',
								_elm_lang$core$Json_Encode$string(content)),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				},
				requiredContent));
	});
var _CareerPlug$ats$Library_BootstrapForm$formGroup = F5(
	function (label_, maybeError, inputs, hint, required) {
		var labelContent = (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(label_),
			0) > 0) ? {
			ctor: '::',
			_0: A2(_CareerPlug$ats$Library_BootstrapForm$controlLabel, label_, required),
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var divContent = _elm_lang$core$List$concat(
			{
				ctor: '::',
				_0: labelContent,
				_1: {
					ctor: '::',
					_0: inputs,
					_1: {
						ctor: '::',
						_0: {
							ctor: '::',
							_0: A2(_CareerPlug$ats$Library_BootstrapForm$errorMessage, maybeError, hint),
							_1: {ctor: '[]'}
						},
						_1: {ctor: '[]'}
					}
				}
			});
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'form-group ',
						_CareerPlug$ats$Library_BootstrapForm$errorClass(maybeError))),
				_1: {ctor: '[]'}
			},
			divContent);
	});
var _CareerPlug$ats$Library_BootstrapForm$textGroup = F5(
	function (attrs, label_, state, hint, required) {
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			label_,
			state.liveError,
			{
				ctor: '::',
				_0: A2(
					_etaque$elm_form$Form_Input$textInput,
					state,
					A2(
						_elm_lang$core$Basics_ops['++'],
						attrs,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(state.path),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-control'),
								_1: {ctor: '[]'}
							}
						})),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});
var _CareerPlug$ats$Library_BootstrapForm$textAreaGroup = F5(
	function (attrs, label_, state, hint, required) {
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			label_,
			state.liveError,
			{
				ctor: '::',
				_0: A2(
					_etaque$elm_form$Form_Input$textArea,
					state,
					A2(
						_elm_lang$core$Basics_ops['++'],
						attrs,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(state.path),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-control'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$rows(8),
									_1: {ctor: '[]'}
								}
							}
						})),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});
var _CareerPlug$ats$Library_BootstrapForm$checkboxGroup = F5(
	function (attrs, label_, state, hint, required) {
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			'',
			state.liveError,
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('checkbox'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$label,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: A2(
									_etaque$elm_form$Form_Input$checkboxInput,
									state,
									A2(
										_elm_lang$core$Basics_ops['++'],
										attrs,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$id(state.path),
											_1: {ctor: '[]'}
										})),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html$text(' '),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html_Attributes$property,
													'innerHTML',
													_elm_lang$core$Json_Encode$string(label_)),
												_1: {ctor: '[]'}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});
var _CareerPlug$ats$Library_BootstrapForm$selectGroup = F6(
	function (options, attrs, label_, state, hint, required) {
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			label_,
			state.liveError,
			{
				ctor: '::',
				_0: A3(
					_etaque$elm_form$Form_Input$selectInput,
					options,
					state,
					A2(
						_elm_lang$core$Basics_ops['++'],
						attrs,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(state.path),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-control'),
								_1: {ctor: '[]'}
							}
						})),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});
var _CareerPlug$ats$Library_BootstrapForm$radioGroup = F6(
	function (options, attrs, label_, state, hint, required) {
		var item = function (_p4) {
			var _p5 = _p4;
			var _p6 = _p5._0;
			return A2(
				_elm_lang$html$Html$label,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('radio-inline'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A3(
						_etaque$elm_form$Form_Input$radioInput,
						_p6,
						state,
						A2(
							_elm_lang$core$Basics_ops['++'],
							attrs,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id(
									A2(
										_elm_lang$core$Basics_ops['++'],
										state.path,
										A2(_elm_lang$core$Basics_ops['++'], '_', _p6))),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$value(_p6),
									_1: {ctor: '[]'}
								}
							})),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p5._1),
						_1: {ctor: '[]'}
					}
				});
		};
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			label_,
			state.liveError,
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$id(state.path),
						_1: {ctor: '[]'}
					},
					A2(_elm_lang$core$List$map, item, options)),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});
var _CareerPlug$ats$Library_BootstrapForm$dateTimeGroup = F7(
	function (ftype, icon, attrs, label_, state, hint, required) {
		var iclass = A2(_elm_lang$core$Basics_ops['++'], 'fa fa-', icon);
		var igclass = A2(_elm_lang$core$Basics_ops['++'], 'input-group ', ftype);
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			label_,
			state.liveError,
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class(igclass),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_etaque$elm_form$Form_Input$textInput,
									state,
									A2(
										_elm_lang$core$Basics_ops['++'],
										attrs,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$id(state.path),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('form-control'),
												_1: {ctor: '[]'}
											}
										})),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('input-group-addon'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$span,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class(iclass),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});
var _CareerPlug$ats$Library_BootstrapForm$dateGroup = A2(_CareerPlug$ats$Library_BootstrapForm$dateTimeGroup, 'date', 'calendar');
var _CareerPlug$ats$Library_BootstrapForm$timeGroup = A2(_CareerPlug$ats$Library_BootstrapForm$dateTimeGroup, 'time', 'clock-o');
var _CareerPlug$ats$Library_BootstrapForm$timezoneGroup = F5(
	function (attrs, label_, state, hint, required) {
		var options = A2(
			_elm_lang$core$List$map,
			function (tz) {
				return {
					ctor: '_Tuple2',
					_0: tz,
					_1: _CareerPlug$ats$Models_Timezone$tzName(tz)
				};
			},
			_CareerPlug$ats$Models_Timezone$zones);
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$formGroup,
			label_,
			state.liveError,
			{
				ctor: '::',
				_0: A3(
					_etaque$elm_form$Form_Input$selectInput,
					options,
					state,
					A2(
						_elm_lang$core$Basics_ops['++'],
						attrs,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$id(state.path),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-control'),
								_1: {ctor: '[]'}
							}
						})),
				_1: {ctor: '[]'}
			},
			hint,
			required);
	});

var _CareerPlug$ats$Library_Fullscreen$pageHeader = F2(
	function (modalTitle, backMsg) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('panel-heading'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$button,
					{
						ctor: '::',
						_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-hidden', 'true'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('close'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(backMsg),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$type_('button'),
									_1: {ctor: '[]'}
								}
							}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('fa fa-times'),
								_1: {ctor: '[]'}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$h3,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('panel-title'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(modalTitle),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _CareerPlug$ats$Library_Fullscreen$page = F4(
	function (divId, title, backMsg, content) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('fullscreen'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$id(divId),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$style(
							{
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'display', _1: 'block'},
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('panel panel-default'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(_CareerPlug$ats$Library_Fullscreen$pageHeader, title, backMsg),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('panel-body'),
									_1: {ctor: '[]'}
								},
								content),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});

var _CareerPlug$ats$Library_Modal$contentArea = F2(
	function (areaClass, content) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(areaClass),
				_1: {ctor: '[]'}
			},
			content);
	});
var _CareerPlug$ats$Library_Modal$modalHeader = F2(
	function (attrs, title) {
		return {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$button,
				A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-hidden', 'true'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('close'),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-dismiss', 'modal'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$type_('button'),
									_1: {ctor: '[]'}
								}
							}
						}
					},
					attrs),
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('×'),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$h4,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('modal-title'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(title),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		};
	});
var _CareerPlug$ats$Library_Modal$modalDialog_ = F3(
	function (headerContent, modalContent, footerContent) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('modal-dialog'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('modal-content'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(_CareerPlug$ats$Library_Modal$contentArea, 'modal-header', headerContent),
						_1: {
							ctor: '::',
							_0: A2(_CareerPlug$ats$Library_Modal$contentArea, 'modal-body', modalContent),
							_1: {
								ctor: '::',
								_0: A2(_CareerPlug$ats$Library_Modal$contentArea, 'modal-footer', footerContent),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$Library_Modal$modalDialog = F3(
	function (modalTitle, modalContent, footerContent) {
		var headerContent = A2(
			_CareerPlug$ats$Library_Modal$modalHeader,
			{ctor: '[]'},
			modalTitle);
		return A3(_CareerPlug$ats$Library_Modal$modalDialog_, headerContent, modalContent, footerContent);
	});
var _CareerPlug$ats$Library_Modal$elmModal = F5(
	function (modalId, modalTitle, onModalClose, modalContent, footerContent) {
		var headerContent = A2(
			_CareerPlug$ats$Library_Modal$modalHeader,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onClick(onModalClose),
				_1: {ctor: '[]'}
			},
			modalTitle);
		var content = A3(_CareerPlug$ats$Library_Modal$modalDialog_, headerContent, modalContent, footerContent);
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('elm-modal modal'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$id(modalId),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: content,
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$Library_Modal$modal = F4(
	function (modalId, modalTitle, modalContent, footerContent) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('modal'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$id(modalId),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A3(_CareerPlug$ats$Library_Modal$modalDialog, modalTitle, modalContent, footerContent),
				_1: {ctor: '[]'}
			});
	});

var _CareerPlug$ats$Email_View$failureView = A2(
	_elm_lang$html$Html$div,
	{ctor: '[]'},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$h3,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('There has been an error'),
				_1: {ctor: '[]'}
			}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$p,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('This email cannot be sent at this time. Please try again later.'),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		}
	});
var _CareerPlug$ats$Email_View$loadingView = A2(
	_elm_lang$html$Html$div,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('lazy-loading'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$i,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('fa fa-refresh fa-spin'),
				_1: {ctor: '[]'}
			},
			{ctor: '[]'}),
		_1: {ctor: '[]'}
	});
var _CareerPlug$ats$Email_View$timezoneModal = function (model) {
	var content = function () {
		var tzPart = function () {
			var _p0 = model.emailForm;
			if (_p0.ctor === 'Just') {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					' to ',
					_CareerPlug$ats$Models_Timezone$tzName(_p0._0.timezone));
			} else {
				return '';
			}
		}();
		return {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$p,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						_elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: 'You scheduled a meeting in a different time zone. ',
								_1: {
									ctor: '::',
									_0: 'Would you like to change your default time zone',
									_1: {
										ctor: '::',
										_0: tzPart,
										_1: {
											ctor: '::',
											_0: '?',
											_1: {ctor: '[]'}
										}
									}
								}
							})),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		};
	}();
	var footer = {
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$button,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$type_('button'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('btn btn-primary'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_CareerPlug$ats$Email_Message$CloseTimezoneDialog(true)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('Yes'),
				_1: {ctor: '[]'}
			}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$button,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$type_('button'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('btn btn-default'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onClick(
								_CareerPlug$ats$Email_Message$CloseTimezoneDialog(false)),
							_1: {ctor: '[]'}
						}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('No'),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		}
	};
	return A4(_CareerPlug$ats$Library_Modal$modal, 'user-change-default-timezone', 'Default Timezone', content, footer);
};
var _CareerPlug$ats$Email_View$datetimeField = F5(
	function (_p1, ftype, icon, fid, lbl) {
		var _p2 = _p1;
		var iclass = A2(_elm_lang$core$Basics_ops['++'], 'fa fa-', icon);
		var igclass = A2(_elm_lang$core$Basics_ops['++'], 'input-group ', ftype);
		var cLabel = (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(lbl),
			0) > 0) ? A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('form-label'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('control-label'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$for(fid),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(lbl),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}) : A2(
			_elm_lang$html$Html$span,
			{ctor: '[]'},
			{ctor: '[]'});
		var fgclass = A2(
			_elm_lang$core$String$join,
			' ',
			{
				ctor: '::',
				_0: ftype,
				_1: {
					ctor: '::',
					_0: _p2._0,
					_1: {
						ctor: '::',
						_0: 'input optional stringish form-group',
						_1: {ctor: '[]'}
					}
				}
			});
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(fgclass),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: cLabel,
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$span,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class(igclass),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$id(fid),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$input,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('form-control'),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$type_('text'),
												_1: {ctor: '[]'}
											}
										},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('input-group-addon'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$span,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class(iclass),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: _p2._1,
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _CareerPlug$ats$Email_View$timeField = F3(
	function (err, fid, lbl) {
		return A5(_CareerPlug$ats$Email_View$datetimeField, err, 'time', 'clock-o', fid, lbl);
	});
var _CareerPlug$ats$Email_View$dateField = F3(
	function (err, fid, lbl) {
		return A5(_CareerPlug$ats$Email_View$datetimeField, err, 'date', 'calendar', fid, lbl);
	});
var _CareerPlug$ats$Email_View$scheduleArea = F6(
	function (scheduling, msg, dateId, timeId, dateValid, timeValid) {
		var schedButton = F2(
			function (lbl, btn) {
				return A2(
					_elm_lang$html$Html$button,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('btn btn-default btn-xs'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onClick(
								msg(btn)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$type_('button'),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(lbl),
						_1: {ctor: '[]'}
					});
			});
		return scheduling ? A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('schedule'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('btn-group'),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'group'),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A2(schedButton, 'In 1 Hour', 'hour'),
						_1: {
							ctor: '::',
							_0: A2(schedButton, 'Tomorrow', 'day'),
							_1: {
								ctor: '::',
								_0: A2(schedButton, 'Monday', 'week'),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$fieldset,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: A3(_CareerPlug$ats$Email_View$dateField, dateValid, dateId, ''),
							_1: {
								ctor: '::',
								_0: A3(_CareerPlug$ats$Email_View$timeField, timeValid, timeId, ''),
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			}) : _elm_lang$html$Html$text('');
	});
var _CareerPlug$ats$Email_View$fileIcon = function (name) {
	var fileFilter = function (item) {
		return A2(
			_elm_lang$core$List$any,
			function (ext) {
				return A2(_elm_lang$core$String$endsWith, ext, name);
			},
			_elm_lang$core$Tuple$first(item)) ? _elm_lang$core$Maybe$Just(
			_elm_lang$core$Tuple$second(item)) : _elm_lang$core$Maybe$Nothing;
	};
	var fileMap = {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: {
				ctor: '::',
				_0: '.zip',
				_1: {
					ctor: '::',
					_0: '.gz',
					_1: {ctor: '[]'}
				}
			},
			_1: 'file-archive-o'
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: {
					ctor: '::',
					_0: '.mp3',
					_1: {ctor: '[]'}
				},
				_1: 'file-audio-o'
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: {
						ctor: '::',
						_0: '.htm',
						_1: {
							ctor: '::',
							_0: '.html',
							_1: {ctor: '[]'}
						}
					},
					_1: 'file-code-o'
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: {
							ctor: '::',
							_0: '.xls',
							_1: {
								ctor: '::',
								_0: '.xlsx',
								_1: {
									ctor: '::',
									_0: '.csv',
									_1: {
										ctor: '::',
										_0: '.ods',
										_1: {ctor: '[]'}
									}
								}
							}
						},
						_1: 'file-excel-o'
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: {
								ctor: '::',
								_0: '.png',
								_1: {
									ctor: '::',
									_0: '.jpg',
									_1: {
										ctor: '::',
										_0: '.jpeg',
										_1: {
											ctor: '::',
											_0: '.gif',
											_1: {
												ctor: '::',
												_0: '.webp',
												_1: {
													ctor: '::',
													_0: '.odg',
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							},
							_1: 'file-image-o'
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: {
									ctor: '::',
									_0: '.pdf',
									_1: {ctor: '[]'}
								},
								_1: 'file-pdf-o'
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: {
										ctor: '::',
										_0: '.ppt',
										_1: {
											ctor: '::',
											_0: '.pptx',
											_1: {
												ctor: '::',
												_0: '.odp',
												_1: {ctor: '[]'}
											}
										}
									},
									_1: 'file-powerpoint-o'
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: {
											ctor: '::',
											_0: '.rtf',
											_1: {
												ctor: '::',
												_0: '.text',
												_1: {
													ctor: '::',
													_0: '.txt',
													_1: {ctor: '[]'}
												}
											}
										},
										_1: 'file-text-o'
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: {
												ctor: '::',
												_0: '.doc',
												_1: {
													ctor: '::',
													_0: '.docx',
													_1: {
														ctor: '::',
														_0: '.odt',
														_1: {ctor: '[]'}
													}
												}
											},
											_1: 'file-word-o'
										},
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			}
		}
	};
	var iconClass = function () {
		var _p3 = _elm_lang$core$List$head(
			A2(_elm_lang$core$List$filterMap, fileFilter, fileMap));
		if (_p3.ctor === 'Just') {
			return _p3._0;
		} else {
			return 'file-o';
		}
	}();
	return A2(
		_elm_lang$html$Html$i,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class(
				A2(_elm_lang$core$Basics_ops['++'], 'fa fa-', iconClass)),
			_1: {ctor: '[]'}
		},
		{ctor: '[]'});
};
var _CareerPlug$ats$Email_View$singleFile = function (att) {
	var attContent = function (content) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('nested-fields email-attachments'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$fieldset,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('inline'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: content,
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$a,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('remove'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(
											_CareerPlug$ats$Email_Message$RemoveAttachment(att.id)),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('remove'),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	};
	var uploadedFile = attContent(
		A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: _CareerPlug$ats$Email_View$fileIcon(att.name),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						A2(_elm_lang$core$Basics_ops['++'], ' ', att.name)),
					_1: {ctor: '[]'}
				}
			}));
	var uploadFile = attContent(
		A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('file input optional form-group'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('form-label'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$label,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('control-label'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('Upload File'),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$span,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$input,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$id(
										A2(
											_elm_lang$core$Basics_ops['++'],
											_CareerPlug$ats$Email_Model$attDomName,
											_elm_lang$core$Basics$toString(att.id))),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$type_('file'),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html_Events$on,
												'change',
												_elm_lang$core$Json_Decode$succeed(
													_CareerPlug$ats$Email_Message$UploadAttachment(att.id))),
											_1: {ctor: '[]'}
										}
									}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			}));
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(att.attachment),
		0) > 0) ? uploadedFile : uploadFile;
};
var _CareerPlug$ats$Email_View$fileArea = function (model) {
	return A2(
		_elm_lang$html$Html$fieldset,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('inputs file-area'),
			_1: {ctor: '[]'}
		},
		A2(
			_elm_lang$core$Basics_ops['++'],
			A2(
				_elm_lang$core$List$map,
				_CareerPlug$ats$Email_View$singleFile,
				A2(
					_elm_lang$core$List$filter,
					function (a) {
						return !a.destroy;
					},
					model.attachments)),
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('links'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$a,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('btn btn-action btn-xs'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$Email_Message$AddAttachment),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$i,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('fa fa-paperclip'),
										_1: {ctor: '[]'}
									},
									{ctor: '[]'}),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html$text(' Attach'),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}));
};
var _CareerPlug$ats$Email_View$carbonList = F3(
	function (field, idx, tuple) {
		return A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('autocomplete-selected-item'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('name'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							_elm_lang$core$Tuple$second(tuple)),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$button,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('remove'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$type_('button'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(
										A2(_CareerPlug$ats$Email_Message$RemoveCarbonItem, field, idx)),
									_1: {ctor: '[]'}
								}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('×'),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _CareerPlug$ats$Email_View$noError = {
	ctor: '_Tuple2',
	_0: '',
	_1: _elm_lang$html$Html$text('')
};
var _CareerPlug$ats$Email_View$extValid = F2(
	function (model, val) {
		var _p4 = {
			ctor: '_Tuple2',
			_0: model.emailForm,
			_1: _CareerPlug$ats$Email_Models_ExternalForm$fieldValid(val)
		};
		if (((_p4.ctor === '_Tuple2') && (_p4._0.ctor === 'Just')) && (_p4._1 === false)) {
			var hint = A2(
				_elm_lang$html$Html$p,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('help-block'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('cannot be blank'),
					_1: {ctor: '[]'}
				});
			return {ctor: '_Tuple2', _0: 'has-error', _1: hint};
		} else {
			return _CareerPlug$ats$Email_View$noError;
		}
	});
var _CareerPlug$ats$Email_View$smsBodyField = function (model) {
	var _p5 = A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.body);
	var errClass = _p5._0;
	var hint = _p5._1;
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class(
				A2(_elm_lang$core$Basics_ops['++'], errClass, ' text input required form-group')),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$textarea,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('form-control tinymce'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id('email_component_body'),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-tmcesettingskey', 'sms'),
									_1: {ctor: '[]'}
								}
							}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: hint,
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Email_View$bodyField = function (model) {
	var _p6 = A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.body);
	var errClass = _p6._0;
	var hint = _p6._1;
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class(
				A2(_elm_lang$core$Basics_ops['++'], errClass, ' text input required form-group')),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$textarea,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('form-control tinymce'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id('email_component_body'),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-settings', model.config.tinymce),
									_1: {
										ctor: '::',
										_0: A2(_elm_lang$html$Html_Attributes$attribute, 'data-tmcesettingskey', 'email'),
										_1: {ctor: '[]'}
									}
								}
							}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: hint,
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Email_View$inviteFields = function (model) {
	return A2(
		_elm_lang$html$Html$fieldset,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('inline event-time'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A3(
				_CareerPlug$ats$Email_View$dateField,
				A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.date),
				'email_date_input',
				'Date'),
			_1: {
				ctor: '::',
				_0: A3(
					_CareerPlug$ats$Email_View$timeField,
					A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.startTime),
					'email_start_time_input',
					'Start Time'),
				_1: {
					ctor: '::',
					_0: A3(
						_CareerPlug$ats$Email_View$timeField,
						A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.endTime),
						'email_end_time_input',
						'End Time'),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$Email_View$fromField = function (email) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('from-field'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('sender'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						_elm_lang$core$String$concat(
							{
								ctor: '::',
								_0: 'Sending email as ',
								_1: {
									ctor: '::',
									_0: email,
									_1: {ctor: '[]'}
								}
							})),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('change-sender'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Not you? '),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$a,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$href('/user/sign_out'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('Sign out'),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html$text(' and sign back in with your email address.'),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Email_View$footerArea = function (model) {
	var fromField_ = function () {
		var _p7 = model.status;
		if (_p7.ctor === 'SmsMessage') {
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
		} else {
			return _CareerPlug$ats$Email_View$fromField(model.config.userEmail);
		}
	}();
	var submitButtons = function () {
		if (model.sending) {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$button,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('btn btn-default'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$type_('button'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$disabled(true),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Sending...'),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			};
		} else {
			var discardButton = A2(
				_elm_lang$html$Html$button,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('pull-left btn btn-default'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$Email_Message$Discard),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$type_('button'),
							_1: {ctor: '[]'}
						}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$i,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('fa fa-trash'),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html$text(' Discard'),
						_1: {ctor: '[]'}
					}
				});
			var _p8 = model.scheduling ? {ctor: '_Tuple3', _0: 'primary', _1: 'Schedule', _2: 'default'} : {ctor: '_Tuple3', _0: 'default', _1: 'Send Later', _2: 'primary'};
			var schedClass = _p8._0;
			var schedLabel = _p8._1;
			var sendClass = _p8._2;
			var scheduleButton = function () {
				var _p9 = model.status;
				if (_p9.ctor === 'SmsMessage') {
					return A2(
						_elm_lang$html$Html$div,
						{ctor: '[]'},
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$html$Html$button,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(
								A2(_elm_lang$core$Basics_ops['++'], 'btn btn-', schedClass)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$type_('button'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$Email_Message$ScheduleEmail),
									_1: {ctor: '[]'}
								}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(schedLabel),
							_1: {ctor: '[]'}
						});
				}
			}();
			var sendButton = function () {
				var message = function () {
					var _p10 = model.status;
					if (_p10.ctor === 'SmsMessage') {
						return _CareerPlug$ats$Email_Message$SendEmail;
					} else {
						return _CareerPlug$ats$Email_Message$SendEmail;
					}
				}();
				return A2(
					_elm_lang$html$Html$button,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'btn btn-', sendClass)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$type_('button'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(message),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Send'),
						_1: {ctor: '[]'}
					});
			}();
			return {
				ctor: '::',
				_0: discardButton,
				_1: {
					ctor: '::',
					_0: scheduleButton,
					_1: {
						ctor: '::',
						_0: sendButton,
						_1: {ctor: '[]'}
					}
				}
			};
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('email-footer'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A6(
				_CareerPlug$ats$Email_View$scheduleArea,
				model.scheduling,
				_CareerPlug$ats$Email_Message$ScheduleButton,
				'email_schedule_date_input',
				'email_schedule_time_input',
				A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.scheduleDate),
				A2(_CareerPlug$ats$Email_View$extValid, model, model.externalForm.scheduleTime)),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('actions'),
						_1: {ctor: '[]'}
					},
					submitButtons),
				_1: {
					ctor: '::',
					_0: fromField_,
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$Email_View$checkboxField = F4(
	function (model, label, name, hint) {
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$checkboxGroup,
			{ctor: '[]'},
			label,
			A2(_etaque$elm_form$Form$getFieldAsBool, name, model.form),
			hint,
			false);
	});
var _CareerPlug$ats$Email_View$signatureField = function (model) {
	return model.config.signature ? A2(
		_elm_lang$html$Html$map,
		_CareerPlug$ats$Email_Message$FormMsg,
		A4(_CareerPlug$ats$Email_View$checkboxField, model, 'Include your email signature', 'signature', '')) : A2(
		_elm_lang$html$Html$p,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text('Create a custom email signature on the '),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$a,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$href(
							_elm_lang$core$String$concat(
								{
									ctor: '::',
									_0: '/manage/users/',
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Basics$toString(model.config.userId),
										_1: {
											ctor: '::',
											_0: '/edit#email_settings',
											_1: {ctor: '[]'}
										}
									}
								})),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$target('_blank'),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('My Account'),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html$text(' page and automatically add it to your outgoing emails.'),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$Email_View$textField = F4(
	function (model, label, name, hint) {
		return A5(
			_CareerPlug$ats$Library_BootstrapForm$textGroup,
			{ctor: '[]'},
			label,
			A2(_etaque$elm_form$Form$getFieldAsString, name, model.form),
			hint,
			false);
	});
var _CareerPlug$ats$Email_View$interviewFutureField = function (model) {
	var label = function (d) {
		return (_elm_lang$core$Native_Utils.cmp(d, 1) > 0) ? A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(d),
			' Days') : A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(d),
			' Day');
	};
	var pair = function (d) {
		return {
			ctor: '_Tuple2',
			_0: _elm_lang$core$Basics$toString(d),
			_1: label(d)
		};
	};
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('select input optional form-group'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A6(
							_CareerPlug$ats$Library_BootstrapForm$selectGroup,
							A2(
								_elm_lang$core$List$map,
								pair,
								A2(_elm_lang$core$List$range, 1, 14)),
							{ctor: '[]'},
							'Days in the future to allow applicants to schedule an interview',
							A2(_etaque$elm_form$Form$getFieldAsString, 'interview_future_days', model.form),
							'',
							false)),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Email_View$interviewDurationField = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('select input optional form-group'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A6(
							_CareerPlug$ats$Library_BootstrapForm$selectGroup,
							A2(
								_elm_lang$core$List$map,
								function (_p11) {
									var _p12 = _p11;
									return {
										ctor: '_Tuple2',
										_0: _elm_lang$core$Basics$toString(_p12._0),
										_1: _p12._1
									};
								},
								model.interview_duration),
							{ctor: '[]'},
							'Interview Duration',
							A2(_etaque$elm_form$Form$getFieldAsString, 'interview_duration', model.form),
							'',
							false)),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Email_View$expireOptsField = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('select input optional form-group'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A6(
							_CareerPlug$ats$Library_BootstrapForm$selectGroup,
							A2(
								_elm_lang$core$List$map,
								function (_p13) {
									var _p14 = _p13;
									return {
										ctor: '_Tuple2',
										_0: _elm_lang$core$Basics$toString(_p14._0),
										_1: _p14._1
									};
								},
								model.invite_expires_in),
							{ctor: '[]'},
							'Expires In',
							A2(_etaque$elm_form$Form$getFieldAsString, 'invite_expires_in', model.form),
							'',
							false)),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Email_View$interviewerField = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('select input optional form-group'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A6(
							_CareerPlug$ats$Library_BootstrapForm$selectGroup,
							_CareerPlug$ats$Models_Common$optionsFromIdPairs(
								_CareerPlug$ats$Email_Model$userInterviewerFirst(model)),
							{ctor: '[]'},
							'Interviewer',
							A2(_etaque$elm_form$Form$getFieldAsString, 'interviewer', model.form),
							'',
							false)),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Email_View$templateField = function (model) {
	var isSelected = function (mtid) {
		var _p15 = model.template;
		if (_p15.ctor === 'Nothing') {
			return false;
		} else {
			return _elm_lang$core$Native_Utils.eq(
				_elm_lang$core$Basics$toString(_p15._0.id),
				mtid);
		}
	};
	var hide = function () {
		var _p16 = model.templates;
		if (_p16.ctor === 'Success') {
			return _elm_lang$core$Native_Utils.cmp(
				_elm_lang$core$Dict$size(_p16._0),
				2) < 0;
		} else {
			return true;
		}
	}();
	if (hide) {
		return A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{ctor: '[]'});
	} else {
		var mtOption = function (_p17) {
			var _p18 = _p17;
			var _p20 = _p18._0;
			var _p19 = _p18._1;
			var name = _p19.invite_schedule ? A2(_elm_lang$core$Basics_ops['++'], _p19.name, ' (Invitation Scheduling)') : _p19.name;
			return A2(
				_elm_lang$html$Html$option,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(_p20),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$selected(
							isSelected(_p20)),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(name),
					_1: {ctor: '[]'}
				});
		};
		var templateOptions = function () {
			var _p21 = model.templates;
			if (_p21.ctor === 'Success') {
				return A2(
					_elm_lang$core$List$map,
					mtOption,
					_CareerPlug$ats$Email_Model$templatesInOrder(_p21._0));
			} else {
				return {ctor: '[]'};
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('select input optional form-group'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$select,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-control'),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html_Events$on,
										'change',
										A2(_elm_lang$core$Json_Decode$map, _CareerPlug$ats$Email_Message$SelectTemplate, _elm_lang$html$Html_Events$targetValue)),
									_1: {ctor: '[]'}
								}
							},
							templateOptions),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			});
	}
};
var _CareerPlug$ats$Email_View$fieldLabels = _elm_lang$core$Dict$fromList(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'to', _1: 'To'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'cc', _1: 'Cc'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'bcc', _1: 'Bcc'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'subject', _1: 'Subject'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'body', _1: 'Body'},
						_1: {ctor: '[]'}
					}
				}
			}
		}
	});
var _CareerPlug$ats$Email_View$fieldLabel = function (name) {
	var _p22 = A2(_elm_lang$core$Dict$get, name, _CareerPlug$ats$Email_View$fieldLabels);
	if (_p22.ctor === 'Just') {
		return _p22._0;
	} else {
		return '';
	}
};
var _CareerPlug$ats$Email_View$viewErrors = F2(
	function (model, errors) {
		var errItem = function (item) {
			var fLabel = _CareerPlug$ats$Email_View$fieldLabel(
				_elm_lang$core$Tuple$first(item));
			var fName = (_elm_lang$core$Native_Utils.cmp(
				_elm_lang$core$String$length(fLabel),
				0) > 0) ? A2(_elm_lang$core$Basics_ops['++'], fLabel, ': ') : '';
			return A2(
				_elm_lang$html$Html$li,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('error'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						A2(
							_elm_lang$core$Basics_ops['++'],
							fName,
							A2(
								_elm_lang$core$String$join,
								', ',
								_elm_lang$core$Tuple$second(item)))),
					_1: {ctor: '[]'}
				});
		};
		var messageType = function () {
			var _p23 = model.status;
			if (_p23.ctor === 'SmsMessage') {
				return 'text message';
			} else {
				return 'email';
			}
		}();
		return _elm_lang$core$Dict$isEmpty(errors) ? A2(
			_elm_lang$html$Html$span,
			{ctor: '[]'},
			{ctor: '[]'}) : A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('alert alert-danger'),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'alert'),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							A2(
								_elm_lang$core$Basics_ops['++'],
								'The following errors occurred while sending the ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									messageType,
									A2(_elm_lang$core$Basics_ops['++'], '. ', 'Please correct the issues and try again.')))),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$ul,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('error-list'),
							_1: {ctor: '[]'}
						},
						A2(
							_elm_lang$core$List$map,
							errItem,
							_elm_lang$core$Dict$toList(errors))),
					_1: {ctor: '[]'}
				}
			});
	});
var _CareerPlug$ats$Email_View$addresseeArea = function (model) {
	var carbonItem = F4(
		function (lbl, name, trans, fModel) {
			var defWrapperClass = 'autocomplete input optional form-group';
			var wrapperClass = fModel.error ? A2(_elm_lang$core$Basics_ops['++'], defWrapperClass, ' has-error') : defWrapperClass;
			var field = _elm_lang$core$Native_Utils.eq(name, 'bcc') ? _CareerPlug$ats$Email_Message$Bcc : _CareerPlug$ats$Email_Message$Cc;
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(wrapperClass),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$label,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('control-label'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(lbl),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('form-value'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('autocomplete-values'),
										_1: {ctor: '[]'}
									},
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Array$toList(
											A2(
												_elm_lang$core$Array$indexedMap,
												_CareerPlug$ats$Email_View$carbonList(field),
												fModel.list)),
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$map,
												trans,
												A2(
													_CareerPlug$ats$Features_Autocomplete_View$view,
													A2(_CareerPlug$ats$Email_Model$acConfig, model.config, name),
													fModel.acModel)),
											_1: {ctor: '[]'}
										})),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				});
		});
	var carbon = model.showCarbon ? A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('carbon-area'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A4(
				carbonItem,
				_CareerPlug$ats$Email_View$fieldLabel('cc'),
				'copy',
				_CareerPlug$ats$Email_Message$acCopyTranslator,
				model.copyField),
			_1: {
				ctor: '::',
				_0: A4(
					carbonItem,
					_CareerPlug$ats$Email_View$fieldLabel('bcc'),
					'bcc',
					_CareerPlug$ats$Email_Message$acBccTranslator,
					model.bccField),
				_1: {ctor: '[]'}
			}
		}) : A2(
		_elm_lang$html$Html$span,
		{ctor: '[]'},
		{ctor: '[]'});
	var addresseeField = function () {
		var carbonButton = model.showCarbon ? A2(
			_elm_lang$html$Html$span,
			{ctor: '[]'},
			{ctor: '[]'}) : A2(
			_elm_lang$html$Html$a,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('show-carbon'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$Email_Message$ShowCarbon),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('Cc/Bcc'),
				_1: {ctor: '[]'}
			});
		var field = A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('form-group '),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$label,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('control-label'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							_CareerPlug$ats$Email_View$fieldLabel('to')),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('form-value'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$map,
								_CareerPlug$ats$Email_Message$FormMsg,
								A2(
									_etaque$elm_form$Form_Input$textInput,
									A2(_etaque$elm_form$Form$getFieldAsString, 'addressee', model.form),
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('form-control'),
										_1: {ctor: '[]'}
									})),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: carbonButton,
						_1: {ctor: '[]'}
					}
				}
			});
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('addressee-field'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: field,
				_1: {ctor: '[]'}
			});
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('addressee-area'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: addresseeField,
			_1: {
				ctor: '::',
				_0: carbon,
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Email_View$scheduleForm = function (model) {
	var bottom = {
		ctor: '::',
		_0: _CareerPlug$ats$Email_View$footerArea(model),
		_1: {ctor: '[]'}
	};
	var top = {
		ctor: '::',
		_0: A2(_CareerPlug$ats$Email_View$viewErrors, model, model.serverErrors),
		_1: {
			ctor: '::',
			_0: _CareerPlug$ats$Email_View$templateField(model),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$Email_View$addresseeArea(model),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A4(_CareerPlug$ats$Email_View$textField, model, '', 'subject', '')),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Email_View$inviteFields(model),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$map,
								_CareerPlug$ats$Email_Message$FormMsg,
								A5(
									_CareerPlug$ats$Library_BootstrapForm$timezoneGroup,
									{ctor: '[]'},
									'Timezone',
									A2(_etaque$elm_form$Form$getFieldAsString, 'timezone', model.form),
									'',
									false)),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$map,
									_CareerPlug$ats$Email_Message$FormMsg,
									A4(_CareerPlug$ats$Email_View$textField, model, 'Location', 'location', '')),
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Email_View$bodyField(model),
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Email_View$signatureField(model),
										_1: {
											ctor: '::',
											_0: _CareerPlug$ats$Email_View$fileArea(model),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$map,
													_CareerPlug$ats$Email_Message$FormMsg,
													A4(_CareerPlug$ats$Email_View$checkboxField, model, 'Send to my calendar', 'copy', '')),
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
	var _p24 = {ctor: '_Tuple2', _0: model.config.shareScorecard, _1: model.emailId};
	if (((_p24.ctor === '_Tuple2') && (_p24._0 === true)) && (_p24._1.ctor === 'Nothing')) {
		var shareVal = A2(_etaque$elm_form$Form$getFieldAsBool, 'share', model.form);
		var share = A2(
			_elm_lang$html$Html$map,
			_CareerPlug$ats$Email_Message$FormMsg,
			A4(_CareerPlug$ats$Email_View$checkboxField, model, 'Send interview package to interviewers', 'share', ''));
		var mid = function () {
			var _p25 = {
				ctor: '_Tuple3',
				_0: _elm_lang$core$Array$isEmpty(model.copyField.list) && _elm_lang$core$Array$isEmpty(model.bccField.list),
				_1: _elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$List$length(model.scorecards),
					0) > 0,
				_2: shareVal.value
			};
			_v16_2:
			do {
				if (_p25.ctor === '_Tuple3') {
					if (_p25._0 === false) {
						if (((_p25._1 === true) && (_p25._2.ctor === 'Just')) && (_p25._2._0 === true)) {
							return {
								ctor: '::',
								_0: share,
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$map,
										_CareerPlug$ats$Email_Message$FormMsg,
										A6(
											_CareerPlug$ats$Library_BootstrapForm$selectGroup,
											_CareerPlug$ats$Models_Common$optionsFromIdPairs(model.scorecards),
											{ctor: '[]'},
											'Interview Scorecard',
											A2(_etaque$elm_form$Form$getFieldAsString, 'scorecard', model.form),
											'',
											false)),
									_1: {ctor: '[]'}
								}
							};
						} else {
							break _v16_2;
						}
					} else {
						return {ctor: '[]'};
					}
				} else {
					break _v16_2;
				}
			} while(false);
			return {
				ctor: '::',
				_0: share,
				_1: {ctor: '[]'}
			};
		}();
		return _elm_lang$core$List$concat(
			{
				ctor: '::',
				_0: top,
				_1: {
					ctor: '::',
					_0: mid,
					_1: {
						ctor: '::',
						_0: bottom,
						_1: {ctor: '[]'}
					}
				}
			});
	} else {
		return _elm_lang$core$List$concat(
			{
				ctor: '::',
				_0: top,
				_1: {
					ctor: '::',
					_0: bottom,
					_1: {ctor: '[]'}
				}
			});
	}
};
var _CareerPlug$ats$Email_View$scheduleSelectForm = function (model) {
	return {
		ctor: '::',
		_0: A2(_CareerPlug$ats$Email_View$viewErrors, model, model.serverErrors),
		_1: {
			ctor: '::',
			_0: _CareerPlug$ats$Email_View$templateField(model),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$Email_View$addresseeArea(model),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A4(_CareerPlug$ats$Email_View$textField, model, '', 'subject', '')),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Email_View$interviewerField(model),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Email_View$expireOptsField(model),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Email_View$interviewDurationField(model),
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Email_View$interviewFutureField(model),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$map,
											_CareerPlug$ats$Email_Message$FormMsg,
											A4(_CareerPlug$ats$Email_View$textField, model, 'Location', 'location', '')),
										_1: {
											ctor: '::',
											_0: _CareerPlug$ats$Email_View$bodyField(model),
											_1: {
												ctor: '::',
												_0: _CareerPlug$ats$Email_View$signatureField(model),
												_1: {
													ctor: '::',
													_0: _CareerPlug$ats$Email_View$fileArea(model),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_lang$html$Html$map,
															_CareerPlug$ats$Email_Message$FormMsg,
															A4(_CareerPlug$ats$Email_View$checkboxField, model, 'Send a copy to me', 'copy', '')),
														_1: {
															ctor: '::',
															_0: _CareerPlug$ats$Email_View$footerArea(model),
															_1: {ctor: '[]'}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
};
var _CareerPlug$ats$Email_View$emailForm = function (model) {
	return {
		ctor: '::',
		_0: A2(_CareerPlug$ats$Email_View$viewErrors, model, model.serverErrors),
		_1: {
			ctor: '::',
			_0: _CareerPlug$ats$Email_View$templateField(model),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$Email_View$addresseeArea(model),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$map,
						_CareerPlug$ats$Email_Message$FormMsg,
						A4(_CareerPlug$ats$Email_View$textField, model, '', 'subject', '')),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Email_View$bodyField(model),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Email_View$signatureField(model),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Email_View$fileArea(model),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$map,
										_CareerPlug$ats$Email_Message$FormMsg,
										A4(_CareerPlug$ats$Email_View$checkboxField, model, 'Send a copy to me', 'copy', '')),
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Email_View$footerArea(model),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			}
		}
	};
};
var _CareerPlug$ats$Email_View$view = function (model) {
	var _p26 = function () {
		var _p27 = model.relatedApp;
		if (_p27.ctor === 'Success') {
			var _p28 = _p27._0;
			return (_elm_lang$core$Native_Utils.cmp(
				_elm_lang$core$String$length(_p28.name),
				0) > 0) ? {
				ctor: '_Tuple2',
				_0: 'has-related-app',
				_1: A2(
					_elm_lang$html$Html$h3,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'related-app ', _p28.score)),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(_p28.name),
						_1: {ctor: '[]'}
					})
			} : {
				ctor: '_Tuple2',
				_0: '',
				_1: _elm_lang$html$Html$text('')
			};
		} else {
			return {
				ctor: '_Tuple2',
				_0: '',
				_1: _elm_lang$html$Html$text('')
			};
		}
	}();
	var topClass = _p26._0;
	var relatedApp = _p26._1;
	var content_ = function (formContent) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$id('email_form_wrapper'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(topClass),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: relatedApp,
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('formtastic'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$fieldset,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('inputs'),
									_1: {ctor: '[]'}
								},
								formContent),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	};
	var mainView = function (formContent) {
		var realContent = function () {
			var _p29 = model.templates;
			switch (_p29.ctor) {
				case 'Loading':
					return {
						ctor: '::',
						_0: _CareerPlug$ats$Email_View$loadingView,
						_1: {ctor: '[]'}
					};
				case 'Failure':
					return {
						ctor: '::',
						_0: _CareerPlug$ats$Email_View$failureView,
						_1: {ctor: '[]'}
					};
				default:
					return formContent;
			}
		}();
		return model.config.embedded ? content_(realContent) : A4(
			_CareerPlug$ats$Library_Fullscreen$page,
			'email_form',
			model.title,
			_CareerPlug$ats$Email_Message$Cancel,
			{
				ctor: '::',
				_0: content_(realContent),
				_1: {ctor: '[]'}
			});
	};
	var _p30 = model.status;
	switch (_p30.ctor) {
		case 'NormalEmail':
			return mainView(
				_CareerPlug$ats$Email_View$emailForm(model));
		case 'ICalEmail':
			return mainView(
				_CareerPlug$ats$Email_View$scheduleForm(model));
		case 'AppointmentEmail':
			return mainView(
				_CareerPlug$ats$Email_View$scheduleSelectForm(model));
		case 'DefaultTimezone':
			return _CareerPlug$ats$Email_View$timezoneModal(model);
		case 'SmsMessage':
			var scheduleInviteContent = function () {
				var _p31 = model.template;
				if (_p31.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return _p31._0.invite_schedule ? {
						ctor: '::',
						_0: _CareerPlug$ats$Email_View$interviewerField(model),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Email_View$expireOptsField(model),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Email_View$interviewDurationField(model),
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Email_View$interviewFutureField(model),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$map,
											_CareerPlug$ats$Email_Message$FormMsg,
											A4(_CareerPlug$ats$Email_View$textField, model, 'Location', 'location', '')),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					} : {ctor: '[]'};
				}
			}();
			var content = model.config.userCanSmsChat ? {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{ctor: '[]'},
					A2(
						_elm_lang$core$Basics_ops['++'],
						{
							ctor: '::',
							_0: A2(_CareerPlug$ats$Email_View$viewErrors, model, model.serverErrors),
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Email_View$templateField(model),
								_1: {ctor: '[]'}
							}
						},
						A2(
							_elm_lang$core$Basics_ops['++'],
							scheduleInviteContent,
							{
								ctor: '::',
								_0: _CareerPlug$ats$Email_View$smsBodyField(model),
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Email_View$footerArea(model),
									_1: {ctor: '[]'}
								}
							}))),
				_1: {ctor: '[]'}
			} : {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: A2(_CareerPlug$ats$Email_View$viewErrors, model, model.serverErrors),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Email_View$templateField(model),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$map,
									_CareerPlug$ats$Email_Message$PhoneNumberSelectMsg,
									_CareerPlug$ats$PhoneNumberSelect_Main$view(model.phoneNumberSelect)),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			};
			return mainView(content);
		default:
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
	}
};

var _CareerPlug$ats$EmailMain$main = _elm_lang$html$Html$programWithFlags(
	{init: _CareerPlug$ats$Email_Model$init, update: _CareerPlug$ats$Email_Update$update, view: _CareerPlug$ats$Email_View$view, subscriptions: _CareerPlug$ats$Email_Ports$subscriptions})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (accountCanSmsChat) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (accountId) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (authParam) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (authToken) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (brandName) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (calendarUsers) {
													return A2(
														_elm_lang$core$Json_Decode$andThen,
														function (copyDefault) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (embedded) {
																	return A2(
																		_elm_lang$core$Json_Decode$andThen,
																		function (interviewDurationOpts) {
																			return A2(
																				_elm_lang$core$Json_Decode$andThen,
																				function (interviewFutureDays) {
																					return A2(
																						_elm_lang$core$Json_Decode$andThen,
																						function (inviteExpireOpts) {
																							return A2(
																								_elm_lang$core$Json_Decode$andThen,
																								function (level) {
																									return A2(
																										_elm_lang$core$Json_Decode$andThen,
																										function (recipients) {
																											return A2(
																												_elm_lang$core$Json_Decode$andThen,
																												function (shareScorecard) {
																													return A2(
																														_elm_lang$core$Json_Decode$andThen,
																														function (signature) {
																															return A2(
																																_elm_lang$core$Json_Decode$andThen,
																																function (timezone) {
																																	return A2(
																																		_elm_lang$core$Json_Decode$andThen,
																																		function (tinymce) {
																																			return A2(
																																				_elm_lang$core$Json_Decode$andThen,
																																				function (userCanSmsChat) {
																																					return A2(
																																						_elm_lang$core$Json_Decode$andThen,
																																						function (userEmail) {
																																							return A2(
																																								_elm_lang$core$Json_Decode$andThen,
																																								function (userId) {
																																									return A2(
																																										_elm_lang$core$Json_Decode$andThen,
																																										function (userName) {
																																											return _elm_lang$core$Json_Decode$succeed(
																																												{accountCanSmsChat: accountCanSmsChat, accountId: accountId, authParam: authParam, authToken: authToken, brandName: brandName, calendarUsers: calendarUsers, copyDefault: copyDefault, embedded: embedded, interviewDurationOpts: interviewDurationOpts, interviewFutureDays: interviewFutureDays, inviteExpireOpts: inviteExpireOpts, level: level, recipients: recipients, shareScorecard: shareScorecard, signature: signature, timezone: timezone, tinymce: tinymce, userCanSmsChat: userCanSmsChat, userEmail: userEmail, userId: userId, userName: userName});
																																										},
																																										A2(_elm_lang$core$Json_Decode$field, 'userName', _elm_lang$core$Json_Decode$string));
																																								},
																																								A2(_elm_lang$core$Json_Decode$field, 'userId', _elm_lang$core$Json_Decode$int));
																																						},
																																						A2(_elm_lang$core$Json_Decode$field, 'userEmail', _elm_lang$core$Json_Decode$string));
																																				},
																																				A2(_elm_lang$core$Json_Decode$field, 'userCanSmsChat', _elm_lang$core$Json_Decode$bool));
																																		},
																																		A2(_elm_lang$core$Json_Decode$field, 'tinymce', _elm_lang$core$Json_Decode$string));
																																},
																																A2(_elm_lang$core$Json_Decode$field, 'timezone', _elm_lang$core$Json_Decode$string));
																														},
																														A2(_elm_lang$core$Json_Decode$field, 'signature', _elm_lang$core$Json_Decode$bool));
																												},
																												A2(_elm_lang$core$Json_Decode$field, 'shareScorecard', _elm_lang$core$Json_Decode$bool));
																										},
																										A2(
																											_elm_lang$core$Json_Decode$field,
																											'recipients',
																											_elm_lang$core$Json_Decode$list(
																												A2(
																													_elm_lang$core$Json_Decode$andThen,
																													function (x0) {
																														return A2(
																															_elm_lang$core$Json_Decode$andThen,
																															function (x1) {
																																return _elm_lang$core$Json_Decode$succeed(
																																	{ctor: '_Tuple2', _0: x0, _1: x1});
																															},
																															A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																													},
																													A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$int)))));
																								},
																								A2(_elm_lang$core$Json_Decode$field, 'level', _elm_lang$core$Json_Decode$string));
																						},
																						A2(
																							_elm_lang$core$Json_Decode$field,
																							'inviteExpireOpts',
																							_elm_lang$core$Json_Decode$list(
																								A2(
																									_elm_lang$core$Json_Decode$andThen,
																									function (x0) {
																										return A2(
																											_elm_lang$core$Json_Decode$andThen,
																											function (x1) {
																												return _elm_lang$core$Json_Decode$succeed(
																													{ctor: '_Tuple2', _0: x0, _1: x1});
																											},
																											A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																									},
																									A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$int)))));
																				},
																				A2(_elm_lang$core$Json_Decode$field, 'interviewFutureDays', _elm_lang$core$Json_Decode$int));
																		},
																		A2(
																			_elm_lang$core$Json_Decode$field,
																			'interviewDurationOpts',
																			_elm_lang$core$Json_Decode$list(
																				A2(
																					_elm_lang$core$Json_Decode$andThen,
																					function (x0) {
																						return A2(
																							_elm_lang$core$Json_Decode$andThen,
																							function (x1) {
																								return _elm_lang$core$Json_Decode$succeed(
																									{ctor: '_Tuple2', _0: x0, _1: x1});
																							},
																							A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																					},
																					A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$int)))));
																},
																A2(_elm_lang$core$Json_Decode$field, 'embedded', _elm_lang$core$Json_Decode$bool));
														},
														A2(_elm_lang$core$Json_Decode$field, 'copyDefault', _elm_lang$core$Json_Decode$bool));
												},
												A2(
													_elm_lang$core$Json_Decode$field,
													'calendarUsers',
													_elm_lang$core$Json_Decode$list(
														A2(
															_elm_lang$core$Json_Decode$andThen,
															function (id) {
																return A2(
																	_elm_lang$core$Json_Decode$andThen,
																	function (name) {
																		return _elm_lang$core$Json_Decode$succeed(
																			{id: id, name: name});
																	},
																	A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string));
															},
															A2(_elm_lang$core$Json_Decode$field, 'id', _elm_lang$core$Json_Decode$int)))));
										},
										A2(_elm_lang$core$Json_Decode$field, 'brandName', _elm_lang$core$Json_Decode$string));
								},
								A2(_elm_lang$core$Json_Decode$field, 'authToken', _elm_lang$core$Json_Decode$string));
						},
						A2(_elm_lang$core$Json_Decode$field, 'authParam', _elm_lang$core$Json_Decode$string));
				},
				A2(_elm_lang$core$Json_Decode$field, 'accountId', _elm_lang$core$Json_Decode$int));
		},
		A2(_elm_lang$core$Json_Decode$field, 'accountCanSmsChat', _elm_lang$core$Json_Decode$bool)));

var _athanclark$elm_debouncer$Debounce$performLog = _elm_lang$core$Task$perform(_elm_lang$core$Basics$identity);
var _athanclark$elm_debouncer$Debounce$mkCmd = function (_p0) {
	return _athanclark$elm_debouncer$Debounce$performLog(
		_elm_lang$core$Task$succeed(_p0));
};
var _athanclark$elm_debouncer$Debounce$init = {elapsed: _elm_lang$core$Maybe$Nothing};
var _athanclark$elm_debouncer$Debounce$Elapsed = F2(
	function (a, b) {
		return {since: a, cont: b};
	});
var _athanclark$elm_debouncer$Debounce$Model = function (a) {
	return {elapsed: a};
};
var _athanclark$elm_debouncer$Debounce$Finish = function (a) {
	return {ctor: 'Finish', _0: a};
};
var _athanclark$elm_debouncer$Debounce$Assign = F2(
	function (a, b) {
		return {ctor: 'Assign', _0: a, _1: b};
	});
var _athanclark$elm_debouncer$Debounce$update = F3(
	function (delay, action, model) {
		var _p1 = action;
		switch (_p1.ctor) {
			case 'Bounce':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (_p2) {
								return _elm_lang$core$Result$Err(
									A2(_athanclark$elm_debouncer$Debounce$Assign, _p1._0, _p2));
							},
							_athanclark$elm_debouncer$Debounce$performLog(_elm_lang$core$Time$now)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Platform_Cmd$map,
								function (_p3) {
									return _elm_lang$core$Result$Err(
										_athanclark$elm_debouncer$Debounce$Finish(_p3));
								},
								_athanclark$elm_debouncer$Debounce$performLog(
									A2(
										_elm_lang$core$Task$andThen,
										function (_p4) {
											return _elm_lang$core$Time$now;
										},
										_elm_lang$core$Process$sleep(delay)))),
							_1: {ctor: '[]'}
						}
					});
			case 'Assign':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							elapsed: _elm_lang$core$Maybe$Just(
								{since: _p1._1, cont: _p1._0})
						}),
					{ctor: '[]'});
			default:
				var _p5 = model.elapsed;
				if (_p5.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var _p6 = _p5._0;
					var elapsed = _p1._0 - _p6.since;
					return (_elm_lang$core$Native_Utils.cmp(elapsed, delay) < 0) ? A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'}) : A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_athanclark$elm_debouncer$Debounce$init,
						{
							ctor: '::',
							_0: A2(_elm_lang$core$Platform_Cmd$map, _elm_lang$core$Result$Ok, _p6.cont),
							_1: {ctor: '[]'}
						});
				}
		}
	});
var _athanclark$elm_debouncer$Debounce$Bounce = function (a) {
	return {ctor: 'Bounce', _0: a};
};

var _elm_lang$navigation$Native_Navigation = function() {


// FAKE NAVIGATION

function go(n)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		if (n !== 0)
		{
			history.go(n);
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function pushState(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		history.pushState({}, '', url);
		callback(_elm_lang$core$Native_Scheduler.succeed(getLocation()));
	});
}

function replaceState(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		history.replaceState({}, '', url);
		callback(_elm_lang$core$Native_Scheduler.succeed(getLocation()));
	});
}


// REAL NAVIGATION

function reloadPage(skipCache)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		document.location.reload(skipCache);
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}

function setLocation(url)
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		try
		{
			window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			document.location.reload(false);
		}
		callback(_elm_lang$core$Native_Scheduler.succeed(_elm_lang$core$Native_Utils.Tuple0));
	});
}


// GET LOCATION

function getLocation()
{
	var location = document.location;

	return {
		href: location.href,
		host: location.host,
		hostname: location.hostname,
		protocol: location.protocol,
		origin: location.origin,
		port_: location.port,
		pathname: location.pathname,
		search: location.search,
		hash: location.hash,
		username: location.username,
		password: location.password
	};
}


// DETECT IE11 PROBLEMS

function isInternetExplorer11()
{
	return window.navigator.userAgent.indexOf('Trident') !== -1;
}


return {
	go: go,
	setLocation: setLocation,
	reloadPage: reloadPage,
	pushState: pushState,
	replaceState: replaceState,
	getLocation: getLocation,
	isInternetExplorer11: isInternetExplorer11
};

}();

var _elm_lang$navigation$Navigation$replaceState = _elm_lang$navigation$Native_Navigation.replaceState;
var _elm_lang$navigation$Navigation$pushState = _elm_lang$navigation$Native_Navigation.pushState;
var _elm_lang$navigation$Navigation$go = _elm_lang$navigation$Native_Navigation.go;
var _elm_lang$navigation$Navigation$reloadPage = _elm_lang$navigation$Native_Navigation.reloadPage;
var _elm_lang$navigation$Navigation$setLocation = _elm_lang$navigation$Native_Navigation.setLocation;
var _elm_lang$navigation$Navigation_ops = _elm_lang$navigation$Navigation_ops || {};
_elm_lang$navigation$Navigation_ops['&>'] = F2(
	function (task1, task2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p0) {
				return task2;
			},
			task1);
	});
var _elm_lang$navigation$Navigation$notify = F3(
	function (router, subs, location) {
		var send = function (_p1) {
			var _p2 = _p1;
			return A2(
				_elm_lang$core$Platform$sendToApp,
				router,
				_p2._0(location));
		};
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Task$sequence(
				A2(_elm_lang$core$List$map, send, subs)),
			_elm_lang$core$Task$succeed(
				{ctor: '_Tuple0'}));
	});
var _elm_lang$navigation$Navigation$cmdHelp = F3(
	function (router, subs, cmd) {
		var _p3 = cmd;
		switch (_p3.ctor) {
			case 'Jump':
				return _elm_lang$navigation$Navigation$go(_p3._0);
			case 'New':
				return A2(
					_elm_lang$core$Task$andThen,
					A2(_elm_lang$navigation$Navigation$notify, router, subs),
					_elm_lang$navigation$Navigation$pushState(_p3._0));
			case 'Modify':
				return A2(
					_elm_lang$core$Task$andThen,
					A2(_elm_lang$navigation$Navigation$notify, router, subs),
					_elm_lang$navigation$Navigation$replaceState(_p3._0));
			case 'Visit':
				return _elm_lang$navigation$Navigation$setLocation(_p3._0);
			default:
				return _elm_lang$navigation$Navigation$reloadPage(_p3._0);
		}
	});
var _elm_lang$navigation$Navigation$killPopWatcher = function (popWatcher) {
	var _p4 = popWatcher;
	if (_p4.ctor === 'Normal') {
		return _elm_lang$core$Process$kill(_p4._0);
	} else {
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Process$kill(_p4._0),
			_elm_lang$core$Process$kill(_p4._1));
	}
};
var _elm_lang$navigation$Navigation$onSelfMsg = F3(
	function (router, location, state) {
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			A3(_elm_lang$navigation$Navigation$notify, router, state.subs, location),
			_elm_lang$core$Task$succeed(state));
	});
var _elm_lang$navigation$Navigation$subscription = _elm_lang$core$Native_Platform.leaf('Navigation');
var _elm_lang$navigation$Navigation$command = _elm_lang$core$Native_Platform.leaf('Navigation');
var _elm_lang$navigation$Navigation$Location = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return {href: a, host: b, hostname: c, protocol: d, origin: e, port_: f, pathname: g, search: h, hash: i, username: j, password: k};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _elm_lang$navigation$Navigation$State = F2(
	function (a, b) {
		return {subs: a, popWatcher: b};
	});
var _elm_lang$navigation$Navigation$init = _elm_lang$core$Task$succeed(
	A2(
		_elm_lang$navigation$Navigation$State,
		{ctor: '[]'},
		_elm_lang$core$Maybe$Nothing));
var _elm_lang$navigation$Navigation$Reload = function (a) {
	return {ctor: 'Reload', _0: a};
};
var _elm_lang$navigation$Navigation$reload = _elm_lang$navigation$Navigation$command(
	_elm_lang$navigation$Navigation$Reload(false));
var _elm_lang$navigation$Navigation$reloadAndSkipCache = _elm_lang$navigation$Navigation$command(
	_elm_lang$navigation$Navigation$Reload(true));
var _elm_lang$navigation$Navigation$Visit = function (a) {
	return {ctor: 'Visit', _0: a};
};
var _elm_lang$navigation$Navigation$load = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Visit(url));
};
var _elm_lang$navigation$Navigation$Modify = function (a) {
	return {ctor: 'Modify', _0: a};
};
var _elm_lang$navigation$Navigation$modifyUrl = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Modify(url));
};
var _elm_lang$navigation$Navigation$New = function (a) {
	return {ctor: 'New', _0: a};
};
var _elm_lang$navigation$Navigation$newUrl = function (url) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$New(url));
};
var _elm_lang$navigation$Navigation$Jump = function (a) {
	return {ctor: 'Jump', _0: a};
};
var _elm_lang$navigation$Navigation$back = function (n) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Jump(0 - n));
};
var _elm_lang$navigation$Navigation$forward = function (n) {
	return _elm_lang$navigation$Navigation$command(
		_elm_lang$navigation$Navigation$Jump(n));
};
var _elm_lang$navigation$Navigation$cmdMap = F2(
	function (_p5, myCmd) {
		var _p6 = myCmd;
		switch (_p6.ctor) {
			case 'Jump':
				return _elm_lang$navigation$Navigation$Jump(_p6._0);
			case 'New':
				return _elm_lang$navigation$Navigation$New(_p6._0);
			case 'Modify':
				return _elm_lang$navigation$Navigation$Modify(_p6._0);
			case 'Visit':
				return _elm_lang$navigation$Navigation$Visit(_p6._0);
			default:
				return _elm_lang$navigation$Navigation$Reload(_p6._0);
		}
	});
var _elm_lang$navigation$Navigation$Monitor = function (a) {
	return {ctor: 'Monitor', _0: a};
};
var _elm_lang$navigation$Navigation$program = F2(
	function (locationToMessage, stuff) {
		var init = stuff.init(
			_elm_lang$navigation$Native_Navigation.getLocation(
				{ctor: '_Tuple0'}));
		var subs = function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: _elm_lang$navigation$Navigation$subscription(
						_elm_lang$navigation$Navigation$Monitor(locationToMessage)),
					_1: {
						ctor: '::',
						_0: stuff.subscriptions(model),
						_1: {ctor: '[]'}
					}
				});
		};
		return _elm_lang$html$Html$program(
			{init: init, view: stuff.view, update: stuff.update, subscriptions: subs});
	});
var _elm_lang$navigation$Navigation$programWithFlags = F2(
	function (locationToMessage, stuff) {
		var init = function (flags) {
			return A2(
				stuff.init,
				flags,
				_elm_lang$navigation$Native_Navigation.getLocation(
					{ctor: '_Tuple0'}));
		};
		var subs = function (model) {
			return _elm_lang$core$Platform_Sub$batch(
				{
					ctor: '::',
					_0: _elm_lang$navigation$Navigation$subscription(
						_elm_lang$navigation$Navigation$Monitor(locationToMessage)),
					_1: {
						ctor: '::',
						_0: stuff.subscriptions(model),
						_1: {ctor: '[]'}
					}
				});
		};
		return _elm_lang$html$Html$programWithFlags(
			{init: init, view: stuff.view, update: stuff.update, subscriptions: subs});
	});
var _elm_lang$navigation$Navigation$subMap = F2(
	function (func, _p7) {
		var _p8 = _p7;
		return _elm_lang$navigation$Navigation$Monitor(
			function (_p9) {
				return func(
					_p8._0(_p9));
			});
	});
var _elm_lang$navigation$Navigation$InternetExplorer = F2(
	function (a, b) {
		return {ctor: 'InternetExplorer', _0: a, _1: b};
	});
var _elm_lang$navigation$Navigation$Normal = function (a) {
	return {ctor: 'Normal', _0: a};
};
var _elm_lang$navigation$Navigation$spawnPopWatcher = function (router) {
	var reportLocation = function (_p10) {
		return A2(
			_elm_lang$core$Platform$sendToSelf,
			router,
			_elm_lang$navigation$Native_Navigation.getLocation(
				{ctor: '_Tuple0'}));
	};
	return _elm_lang$navigation$Native_Navigation.isInternetExplorer11(
		{ctor: '_Tuple0'}) ? A3(
		_elm_lang$core$Task$map2,
		_elm_lang$navigation$Navigation$InternetExplorer,
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'popstate', _elm_lang$core$Json_Decode$value, reportLocation)),
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'hashchange', _elm_lang$core$Json_Decode$value, reportLocation))) : A2(
		_elm_lang$core$Task$map,
		_elm_lang$navigation$Navigation$Normal,
		_elm_lang$core$Process$spawn(
			A3(_elm_lang$dom$Dom_LowLevel$onWindow, 'popstate', _elm_lang$core$Json_Decode$value, reportLocation)));
};
var _elm_lang$navigation$Navigation$onEffects = F4(
	function (router, cmds, subs, _p11) {
		var _p12 = _p11;
		var _p15 = _p12.popWatcher;
		var stepState = function () {
			var _p13 = {ctor: '_Tuple2', _0: subs, _1: _p15};
			_v6_2:
			do {
				if (_p13._0.ctor === '[]') {
					if (_p13._1.ctor === 'Just') {
						return A2(
							_elm_lang$navigation$Navigation_ops['&>'],
							_elm_lang$navigation$Navigation$killPopWatcher(_p13._1._0),
							_elm_lang$core$Task$succeed(
								A2(_elm_lang$navigation$Navigation$State, subs, _elm_lang$core$Maybe$Nothing)));
					} else {
						break _v6_2;
					}
				} else {
					if (_p13._1.ctor === 'Nothing') {
						return A2(
							_elm_lang$core$Task$map,
							function (_p14) {
								return A2(
									_elm_lang$navigation$Navigation$State,
									subs,
									_elm_lang$core$Maybe$Just(_p14));
							},
							_elm_lang$navigation$Navigation$spawnPopWatcher(router));
					} else {
						break _v6_2;
					}
				}
			} while(false);
			return _elm_lang$core$Task$succeed(
				A2(_elm_lang$navigation$Navigation$State, subs, _p15));
		}();
		return A2(
			_elm_lang$navigation$Navigation_ops['&>'],
			_elm_lang$core$Task$sequence(
				A2(
					_elm_lang$core$List$map,
					A2(_elm_lang$navigation$Navigation$cmdHelp, router, subs),
					cmds)),
			stepState);
	});
_elm_lang$core$Native_Platform.effectManagers['Navigation'] = {pkg: 'elm-lang/navigation', init: _elm_lang$navigation$Navigation$init, onEffects: _elm_lang$navigation$Navigation$onEffects, onSelfMsg: _elm_lang$navigation$Navigation$onSelfMsg, tag: 'fx', cmdMap: _elm_lang$navigation$Navigation$cmdMap, subMap: _elm_lang$navigation$Navigation$subMap};

var _CareerPlug$ats$GlobalSearch$onKeyDown = function (tagger) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'keydown',
		A2(_elm_lang$core$Json_Decode$map, tagger, _elm_lang$html$Html_Events$keyCode));
};
var _CareerPlug$ats$GlobalSearch$mkCmd = function (a) {
	return A2(
		_elm_lang$core$Task$perform,
		_elm_lang$core$Basics$identity,
		_elm_lang$core$Task$succeed(a));
};
var _CareerPlug$ats$GlobalSearch$placeholderItem = function (_p0) {
	return A2(
		_elm_lang$html$Html$li,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('global-search-app__result-item'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$classList(
						{
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'global-search-app__result-item-placeholder', _1: true},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'global-search-app__result-item-placeholder--short', _1: true},
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('global-search-app__result-item-placeholder'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$GlobalSearch$errorResultsView = A2(
	_elm_lang$html$Html$div,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('global-search-app__error-results'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$i,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('fa fa-exclamation-circle'),
				_1: {ctor: '[]'}
			},
			{ctor: '[]'}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('Something went wrong.'),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		}
	});
var _CareerPlug$ats$GlobalSearch$noResultsView = A2(
	_elm_lang$html$Html$div,
	{
		ctor: '::',
		_0: _elm_lang$html$Html_Attributes$class('global-search-app__no-results'),
		_1: {ctor: '[]'}
	},
	{
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$i,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('fa fa-search'),
				_1: {ctor: '[]'}
			},
			{ctor: '[]'}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('Press `Enter` to search for more results.'),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		}
	});
var _CareerPlug$ats$GlobalSearch$fullSearchPath = function (model) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		model.searchPath,
		(_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(model.term),
			0) > 0) ? A2(_elm_lang$core$Basics_ops['++'], '?global_search_full%5Bterm%5D=', model.term) : '');
};
var _CareerPlug$ats$GlobalSearch$resultCountView = F2(
	function (model, result) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(result.results),
			5) > -1) ? {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$li,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('global-search-app__results-list-count'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$a,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$href(
								_CareerPlug$ats$GlobalSearch$fullSearchPath(model)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('global-search-app__results-list-count-link'),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								A2(
									_elm_lang$core$Basics_ops['++'],
									'Showing ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(
											_elm_lang$core$List$length(result.results)),
										A2(
											_elm_lang$core$Basics_ops['++'],
											' of ',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(result.totalResultsCount),
												' Results'))))),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		} : {
			ctor: '::',
			_0: _elm_lang$html$Html$text(''),
			_1: {ctor: '[]'}
		};
	});
var _CareerPlug$ats$GlobalSearch$resultsList = function (model) {
	var _p1 = model.result;
	if (_p1.ctor === 'Success') {
		return _p1._0.results;
	} else {
		return {ctor: '[]'};
	}
};
var _CareerPlug$ats$GlobalSearch$calculateUpSelected = function (model) {
	if (_elm_lang$core$Native_Utils.eq(
		_elm_lang$core$List$length(
			_CareerPlug$ats$GlobalSearch$resultsList(model)),
		0)) {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		var _p2 = model.selected;
		if (_p2.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Just(
				_elm_lang$core$List$length(
					_CareerPlug$ats$GlobalSearch$resultsList(model)) - 1);
		} else {
			var _p3 = _p2._0;
			return (_elm_lang$core$Native_Utils.cmp(_p3 - 1, 0) < 0) ? _elm_lang$core$Maybe$Just(
				_elm_lang$core$List$length(
					_CareerPlug$ats$GlobalSearch$resultsList(model)) - 1) : _elm_lang$core$Maybe$Just(_p3 - 1);
		}
	}
};
var _CareerPlug$ats$GlobalSearch$calculateDownSelected = function (model) {
	if (_elm_lang$core$Native_Utils.eq(
		_elm_lang$core$List$length(
			_CareerPlug$ats$GlobalSearch$resultsList(model)),
		0)) {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		var _p4 = model.selected;
		if (_p4.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Just(0);
		} else {
			var _p5 = _p4._0;
			return (_elm_lang$core$Native_Utils.cmp(
				_p5 + 1,
				_elm_lang$core$List$length(
					_CareerPlug$ats$GlobalSearch$resultsList(model))) < 0) ? _elm_lang$core$Maybe$Just(_p5 + 1) : _elm_lang$core$Maybe$Just(0);
		}
	}
};
var _CareerPlug$ats$GlobalSearch$handleEnterPress = function (model) {
	var _p6 = model.selected;
	if (_p6.ctor === 'Nothing') {
		return _elm_lang$navigation$Navigation$load(
			_CareerPlug$ats$GlobalSearch$fullSearchPath(model));
	} else {
		return _elm_lang$navigation$Navigation$load(
			A2(
				_elm_lang$core$Maybe$withDefault,
				_CareerPlug$ats$GlobalSearch$fullSearchPath(model),
				A2(
					_elm_lang$core$Maybe$andThen,
					function (r) {
						return _elm_lang$core$Maybe$Just(r.resourcePath);
					},
					_elm_lang$core$List$head(
						_elm_lang$core$List$reverse(
							A2(
								_elm_lang$core$List$take,
								_p6._0 + 1,
								_CareerPlug$ats$GlobalSearch$resultsList(model)))))));
	}
};
var _CareerPlug$ats$GlobalSearch$Result = F4(
	function (a, b, c, d) {
		return {headline: a, subHeadline: b, resourcePath: c, resourceType: d};
	});
var _CareerPlug$ats$GlobalSearch$Config = function (a) {
	return {inline: a};
};
var _CareerPlug$ats$GlobalSearch$initialModel = function (flags) {
	var initialTerm = A2(_elm_lang$core$Maybe$withDefault, '', flags.initialTerm);
	var config = _CareerPlug$ats$GlobalSearch$Config(
		A2(_elm_lang$core$Maybe$withDefault, false, flags.inline));
	return {result: _krisajenkins$remotedata$RemoteData$NotAsked, term: initialTerm, debouncer: _athanclark$elm_debouncer$Debounce$init, selected: _elm_lang$core$Maybe$Nothing, focused: true, searchPath: '/manage/apps', config: config};
};
var _CareerPlug$ats$GlobalSearch$Model = F7(
	function (a, b, c, d, e, f, g) {
		return {result: a, term: b, debouncer: c, selected: d, focused: e, searchPath: f, config: g};
	});
var _CareerPlug$ats$GlobalSearch$SearchResponseData = F2(
	function (a, b) {
		return {totalResultsCount: a, results: b};
	});
var _CareerPlug$ats$GlobalSearch$Flags = F2(
	function (a, b) {
		return {inline: a, initialTerm: b};
	});
var _CareerPlug$ats$GlobalSearch$flagsDecoder = A3(
	_elm_lang$core$Json_Decode$map2,
	_CareerPlug$ats$GlobalSearch$Flags,
	_elm_lang$core$Json_Decode$maybe(
		A2(_elm_lang$core$Json_Decode$field, 'inline', _elm_lang$core$Json_Decode$bool)),
	_elm_lang$core$Json_Decode$maybe(
		A2(_elm_lang$core$Json_Decode$field, 'initial_term', _elm_lang$core$Json_Decode$string)));
var _CareerPlug$ats$GlobalSearch$init = function (flags) {
	var flags_ = function () {
		var _p7 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$GlobalSearch$flagsDecoder, flags);
		if (_p7.ctor === 'Ok') {
			return _p7._0;
		} else {
			return _elm_lang$core$Native_Utils.crashCase(
				'GlobalSearch',
				{
					start: {line: 426, column: 13},
					end: {line: 431, column: 36}
				},
				_p7)(_p7._0);
		}
	}();
	return {
		ctor: '_Tuple2',
		_0: _CareerPlug$ats$GlobalSearch$initialModel(flags_),
		_1: _elm_lang$core$Platform_Cmd$none
	};
};
var _CareerPlug$ats$GlobalSearch$App = {ctor: 'App'};
var _CareerPlug$ats$GlobalSearch$resourceTypeDecoder = function (str) {
	var _p9 = str;
	if (_p9 === 'App') {
		return _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$GlobalSearch$App);
	} else {
		return _elm_lang$core$Json_Decode$fail('could not decode resource_type');
	}
};
var _CareerPlug$ats$GlobalSearch$responseDecoder = A5(
	_elm_lang$core$Json_Decode$map4,
	_CareerPlug$ats$GlobalSearch$Result,
	A2(_elm_lang$core$Json_Decode$field, 'headline', _elm_lang$core$Json_Decode$string),
	A2(_elm_lang$core$Json_Decode$field, 'sub_headline', _elm_lang$core$Json_Decode$string),
	A2(_elm_lang$core$Json_Decode$field, 'resource_path', _elm_lang$core$Json_Decode$string),
	A2(
		_elm_lang$core$Json_Decode$andThen,
		_CareerPlug$ats$GlobalSearch$resourceTypeDecoder,
		A2(_elm_lang$core$Json_Decode$field, 'resource_type', _elm_lang$core$Json_Decode$string)));
var _CareerPlug$ats$GlobalSearch$responsesDecoder = A3(
	_elm_lang$core$Json_Decode$map2,
	_CareerPlug$ats$GlobalSearch$SearchResponseData,
	A2(_elm_lang$core$Json_Decode$field, 'total_results_count', _elm_lang$core$Json_Decode$int),
	A2(
		_elm_lang$core$Json_Decode$field,
		'results',
		_elm_lang$core$Json_Decode$list(_CareerPlug$ats$GlobalSearch$responseDecoder)));
var _CareerPlug$ats$GlobalSearch$HandleKeyDown = function (a) {
	return {ctor: 'HandleKeyDown', _0: a};
};
var _CareerPlug$ats$GlobalSearch$SetFocused = function (a) {
	return {ctor: 'SetFocused', _0: a};
};
var _CareerPlug$ats$GlobalSearch$SetSelected = function (a) {
	return {ctor: 'SetSelected', _0: a};
};
var _CareerPlug$ats$GlobalSearch$resultItem = F3(
	function (model, idx, result) {
		var highlighted = function () {
			var _p10 = model.selected;
			if (_p10.ctor === 'Nothing') {
				return false;
			} else {
				return _elm_lang$core$Native_Utils.eq(_p10._0, idx);
			}
		}();
		return A2(
			_elm_lang$html$Html$li,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$classList(
					{
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'global-search-app__result-item', _1: true},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'global-search-app__result-item--highlighted', _1: highlighted},
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onMouseEnter(
						_CareerPlug$ats$GlobalSearch$SetSelected(
							_elm_lang$core$Maybe$Just(idx))),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$a,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('global-search-app__result-item-link'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$href(result.resourcePath),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('global-search-app__result-item-text global-search-app__result-item-text--big'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(result.headline),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('global-search-app__result-item-text'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(result.subHeadline),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$GlobalSearch$resultsItemsView = F2(
	function (model, result) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(result.results),
			0) > 0) ? A2(
			_elm_lang$core$Basics_ops['++'],
			A2(
				_elm_lang$core$List$indexedMap,
				_CareerPlug$ats$GlobalSearch$resultItem(model),
				result.results),
			A2(_CareerPlug$ats$GlobalSearch$resultCountView, model, result)) : {
			ctor: '::',
			_0: _CareerPlug$ats$GlobalSearch$noResultsView,
			_1: {ctor: '[]'}
		};
	});
var _CareerPlug$ats$GlobalSearch$resultsContent = function (model) {
	var _p11 = model.result;
	switch (_p11.ctor) {
		case 'NotAsked':
			return _elm_lang$html$Html$text('');
		case 'Loading':
			return A2(
				_elm_lang$html$Html$ul,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('global-search-app__results-list'),
					_1: {ctor: '[]'}
				},
				A2(
					_elm_lang$core$List$map,
					_CareerPlug$ats$GlobalSearch$placeholderItem,
					{
						ctor: '::',
						_0: 1,
						_1: {
							ctor: '::',
							_0: 2,
							_1: {
								ctor: '::',
								_0: 3,
								_1: {
									ctor: '::',
									_0: 4,
									_1: {
										ctor: '::',
										_0: 5,
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}));
		case 'Failure':
			return A2(
				_elm_lang$html$Html$ul,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('global-search-app__results-list'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _CareerPlug$ats$GlobalSearch$errorResultsView,
					_1: {ctor: '[]'}
				});
		default:
			return A2(
				_elm_lang$html$Html$ul,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('global-search-app__results-list'),
					_1: {ctor: '[]'}
				},
				A2(_CareerPlug$ats$GlobalSearch$resultsItemsView, model, _p11._0));
	}
};
var _CareerPlug$ats$GlobalSearch$resultsView = function (model) {
	var hidden = function () {
		var _p12 = {ctor: '_Tuple3', _0: model.config.inline, _1: model.focused, _2: model.result};
		if ((_p12._0 === true) && (_p12._1 === false)) {
			return true;
		} else {
			if (_p12._2.ctor === 'NotAsked') {
				return true;
			} else {
				return false;
			}
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$classList(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'global-search-app__container', _1: true},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'global-search-app__container--hidden', _1: hidden},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'global-search-app__container--inline', _1: model.config.inline},
							_1: {ctor: '[]'}
						}
					}
				}),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onMouseLeave(
					_CareerPlug$ats$GlobalSearch$SetSelected(_elm_lang$core$Maybe$Nothing)),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: _CareerPlug$ats$GlobalSearch$resultsContent(model),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$GlobalSearch$DebouncerMsg = function (a) {
	return {ctor: 'DebouncerMsg', _0: a};
};
var _CareerPlug$ats$GlobalSearch$UpdateTerm = function (a) {
	return {ctor: 'UpdateTerm', _0: a};
};
var _CareerPlug$ats$GlobalSearch$view = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$classList(
				{
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'global-search-app', _1: true},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'global-search-app--inline', _1: model.config.inline},
						_1: {ctor: '[]'}
					}
				}),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$input,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$type_('text'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('form-control global-search-app__input'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$placeholder('Search for applicants.'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$value(model.term),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onInput(_CareerPlug$ats$GlobalSearch$UpdateTerm),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onFocus(
											_CareerPlug$ats$GlobalSearch$SetFocused(true)),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Events$onBlur(
												_CareerPlug$ats$GlobalSearch$SetFocused(false)),
											_1: {
												ctor: '::',
												_0: _CareerPlug$ats$GlobalSearch$onKeyDown(_CareerPlug$ats$GlobalSearch$HandleKeyDown),
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				},
				{ctor: '[]'}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$i,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('fa fa-search global-search-app__search-icon'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: _CareerPlug$ats$GlobalSearch$resultsView(model),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$GlobalSearch$Search = {ctor: 'Search'};
var _CareerPlug$ats$GlobalSearch$SearchResponse = function (a) {
	return {ctor: 'SearchResponse', _0: a};
};
var _CareerPlug$ats$GlobalSearch$search = function (term) {
	return A2(
		_elm_lang$core$Platform_Cmd$map,
		_CareerPlug$ats$GlobalSearch$SearchResponse,
		_krisajenkins$remotedata$RemoteData$sendRequest(
			A2(
				_elm_lang$http$Http$get,
				A2(_elm_lang$core$Basics_ops['++'], '/manage/search.json?term=', term),
				_CareerPlug$ats$GlobalSearch$responsesDecoder)));
};
var _CareerPlug$ats$GlobalSearch$update = F2(
	function (msg, model) {
		var _p13 = msg;
		switch (_p13.ctor) {
			case 'SearchResponse':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{result: _p13._0}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SetSelected':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{selected: _p13._0}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'SetFocused':
				var _p14 = _p13._0;
				var selected = _p14 ? model.selected : _elm_lang$core$Maybe$Nothing;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{focused: _p14, selected: selected}),
					_1: _elm_lang$core$Platform_Cmd$none
				};
			case 'HandleKeyDown':
				var _p15 = _p13._0;
				switch (_p15) {
					case 38:
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									selected: _CareerPlug$ats$GlobalSearch$calculateUpSelected(model)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					case 40:
						return {
							ctor: '_Tuple2',
							_0: _elm_lang$core$Native_Utils.update(
								model,
								{
									selected: _CareerPlug$ats$GlobalSearch$calculateDownSelected(model)
								}),
							_1: _elm_lang$core$Platform_Cmd$none
						};
					case 13:
						return {
							ctor: '_Tuple2',
							_0: model,
							_1: _CareerPlug$ats$GlobalSearch$handleEnterPress(model)
						};
					default:
						return {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none};
				}
			case 'UpdateTerm':
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{term: _p13._0}),
					_1: _CareerPlug$ats$GlobalSearch$mkCmd(
						_CareerPlug$ats$GlobalSearch$DebouncerMsg(
							_athanclark$elm_debouncer$Debounce$Bounce(
								_CareerPlug$ats$GlobalSearch$mkCmd(_CareerPlug$ats$GlobalSearch$Search))))
				};
			case 'Search':
				return _elm_lang$core$Native_Utils.eq(
					_elm_lang$core$String$length(model.term),
					0) ? {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{result: _krisajenkins$remotedata$RemoteData$NotAsked, selected: _elm_lang$core$Maybe$Nothing}),
					_1: _elm_lang$core$Platform_Cmd$none
				} : {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{result: _krisajenkins$remotedata$RemoteData$Loading}),
					_1: _CareerPlug$ats$GlobalSearch$search(model.term)
				};
			default:
				var _p16 = A3(_athanclark$elm_debouncer$Debounce$update, 500 * _elm_lang$core$Time$millisecond, _p13._0, model.debouncer);
				var newDebouncer = _p16._0;
				var eff = _p16._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{debouncer: newDebouncer}),
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (r) {
								var _p17 = r;
								if (_p17.ctor === 'Err') {
									return _CareerPlug$ats$GlobalSearch$DebouncerMsg(_p17._0);
								} else {
									return _p17._0;
								}
							},
							eff),
						_1: {ctor: '[]'}
					});
		}
	});
var _CareerPlug$ats$GlobalSearch$main = _elm_lang$html$Html$programWithFlags(
	{
		init: _CareerPlug$ats$GlobalSearch$init,
		update: _CareerPlug$ats$GlobalSearch$update,
		view: _CareerPlug$ats$GlobalSearch$view,
		subscriptions: function (_p18) {
			return _elm_lang$core$Platform_Sub$none;
		}
	})(_elm_lang$core$Json_Decode$value);

var _CareerPlug$ats$IconPickerWidget_Ports$portSelectIcon = _elm_lang$core$Native_Platform.outgoingPort(
	'portSelectIcon',
	function (v) {
		return v;
	});

var _NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$isJust = function (maybeThing) {
	var _p0 = maybeThing;
	if (_p0.ctor === 'Just') {
		return true;
	} else {
		return false;
	}
};
var _NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$searchHelper = F2(
	function (letter, restOfWord) {
		var _p1 = restOfWord;
		if (_p1.ctor === 'Just') {
			var _p3 = _p1._0;
			var _p2 = A2(
				_elm_lang$core$String$indexes,
				_elm_lang$core$String$fromChar(letter),
				_p3);
			if (_p2.ctor === '[]') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					A2(_elm_lang$core$String$dropLeft, _p2._0 + 1, _p3));
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$root = function (string) {
	return A2(
		_elm_lang$core$String$filter,
		function (c) {
			return _elm_lang$core$Char$isLower(c) || _elm_lang$core$Char$isDigit(c);
		},
		_elm_lang$core$String$toLower(string));
};
var _NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$match = F2(
	function (needle, haystack) {
		return _NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$isJust(
			A3(
				_elm_lang$core$String$foldl,
				_NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$searchHelper,
				_elm_lang$core$Maybe$Just(
					_NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$root(haystack)),
				_NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$root(needle)));
	});
var _NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$filter = F3(
	function (map, needle, records) {
		return A2(
			_elm_lang$core$List$filter,
			function (_p4) {
				return A2(
					_NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$match,
					needle,
					map(_p4));
			},
			records);
	});

var _CareerPlug$ats$IconPickerWidget$mkCmd = function (a) {
	return A2(
		_elm_lang$core$Task$perform,
		_elm_lang$core$Basics$identity,
		_elm_lang$core$Task$succeed(a));
};
var _CareerPlug$ats$IconPickerWidget$onKeyUp = function (handler) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'keyup',
		A2(
			_elm_lang$core$Json_Decode$map,
			handler,
			A2(
				_elm_lang$core$Json_Decode$at,
				{
					ctor: '::',
					_0: 'target',
					_1: {
						ctor: '::',
						_0: 'value',
						_1: {ctor: '[]'}
					}
				},
				_elm_lang$core$Json_Decode$string)));
};
var _CareerPlug$ats$IconPickerWidget$selectedIcon = function (model) {
	var selected = function () {
		var _p0 = model.selected;
		if (_p0.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			return _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filter,
					function (i) {
						return _elm_lang$core$Native_Utils.eq(i.$class, _p0._0);
					},
					model.icons));
		}
	}();
	var _p1 = selected;
	if (_p1.ctor === 'Nothing') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(_p1._0);
	}
};
var _CareerPlug$ats$IconPickerWidget$Icon = F2(
	function (a, b) {
		return {displayName: a, $class: b};
	});
var _CareerPlug$ats$IconPickerWidget$Model = F5(
	function (a, b, c, d, e) {
		return {selected: a, viewState: b, icons: c, searchState: d, debouncer: e};
	});
var _CareerPlug$ats$IconPickerWidget$Flags = F2(
	function (a, b) {
		return {icons: a, selected: b};
	});
var _CareerPlug$ats$IconPickerWidget$Closed = {ctor: 'Closed'};
var _CareerPlug$ats$IconPickerWidget$initialModel = {
	selected: _elm_lang$core$Maybe$Nothing,
	viewState: _CareerPlug$ats$IconPickerWidget$Closed,
	icons: {ctor: '[]'},
	searchState: '',
	debouncer: _athanclark$elm_debouncer$Debounce$init
};
var _CareerPlug$ats$IconPickerWidget$init = function (flags) {
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$IconPickerWidget$initialModel,
			{icons: flags.icons, selected: flags.selected}),
		{ctor: '[]'});
};
var _CareerPlug$ats$IconPickerWidget$Open = {ctor: 'Open'};
var _CareerPlug$ats$IconPickerWidget$DebouncerMsg = function (a) {
	return {ctor: 'DebouncerMsg', _0: a};
};
var _CareerPlug$ats$IconPickerWidget$UpdateSearchState = function (a) {
	return {ctor: 'UpdateSearchState', _0: a};
};
var _CareerPlug$ats$IconPickerWidget$update = F2(
	function (msg, model) {
		var _p2 = msg;
		switch (_p2.ctor) {
			case 'SelectIcon':
				var _p4 = _p2._0;
				var cmd = function () {
					var _p3 = _p4;
					if (_p3.ctor === 'Nothing') {
						return {
							ctor: '::',
							_0: _CareerPlug$ats$IconPickerWidget_Ports$portSelectIcon(''),
							_1: {ctor: '[]'}
						};
					} else {
						return {
							ctor: '::',
							_0: _CareerPlug$ats$IconPickerWidget_Ports$portSelectIcon(_p3._0),
							_1: {ctor: '[]'}
						};
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{selected: _p4, viewState: _CareerPlug$ats$IconPickerWidget$Closed}),
					cmd);
			case 'UpdateViewState':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{viewState: _p2._0}),
					{ctor: '[]'});
			case 'UpdateSearchStateRequest':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$IconPickerWidget$mkCmd(
							_CareerPlug$ats$IconPickerWidget$DebouncerMsg(
								_athanclark$elm_debouncer$Debounce$Bounce(
									_CareerPlug$ats$IconPickerWidget$mkCmd(
										_CareerPlug$ats$IconPickerWidget$UpdateSearchState(_p2._0))))),
						_1: {ctor: '[]'}
					});
			case 'UpdateSearchState':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{searchState: _p2._0}),
					{ctor: '[]'});
			default:
				var _p5 = A3(_athanclark$elm_debouncer$Debounce$update, 500 * _elm_lang$core$Time$millisecond, _p2._0, model.debouncer);
				var newDebouncer = _p5._0;
				var eff = _p5._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{debouncer: newDebouncer}),
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Platform_Cmd$map,
							function (r) {
								var _p6 = r;
								if (_p6.ctor === 'Err') {
									return _CareerPlug$ats$IconPickerWidget$DebouncerMsg(_p6._0);
								} else {
									return _p6._0;
								}
							},
							eff),
						_1: {ctor: '[]'}
					});
		}
	});
var _CareerPlug$ats$IconPickerWidget$searchBarView = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('search-bar-container'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$input,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(model.searchState),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$IconPickerWidget$onKeyUp(_CareerPlug$ats$IconPickerWidget$UpdateSearchState),
						_1: {ctor: '[]'}
					}
				},
				{ctor: '[]'}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$IconPickerWidget$UpdateSearchStateRequest = function (a) {
	return {ctor: 'UpdateSearchStateRequest', _0: a};
};
var _CareerPlug$ats$IconPickerWidget$UpdateViewState = function (a) {
	return {ctor: 'UpdateViewState', _0: a};
};
var _CareerPlug$ats$IconPickerWidget$selectBoxView = function (model) {
	var content = function () {
		var _p7 = _CareerPlug$ats$IconPickerWidget$selectedIcon(model);
		if (_p7.ctor === 'Nothing') {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Select An Icon...'),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$i,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('fa fa-caret-down caret-icon'),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}
			};
		} else {
			var _p8 = _p7._0;
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$i,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'fa ', _p8.$class)),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$span,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(_p8.displayName),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('fa fa-caret-down caret-icon'),
								_1: {ctor: '[]'}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}
				}
			};
		}
	}();
	var updateMsg = function () {
		var _p9 = model.viewState;
		if (_p9.ctor === 'Closed') {
			return _CareerPlug$ats$IconPickerWidget$Open;
		} else {
			return _CareerPlug$ats$IconPickerWidget$Closed;
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('select-box-view'),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Events$onClick(
					_CareerPlug$ats$IconPickerWidget$UpdateViewState(updateMsg)),
				_1: {ctor: '[]'}
			}
		},
		content);
};
var _CareerPlug$ats$IconPickerWidget$SelectIcon = function (a) {
	return {ctor: 'SelectIcon', _0: a};
};
var _CareerPlug$ats$IconPickerWidget$iconSelectView = function (model) {
	var icons = A3(
		_NoRedInk$elm_simple_fuzzy$Simple_Fuzzy$filter,
		function (_) {
			return _.displayName;
		},
		model.searchState,
		model.icons);
	var selectIcon = function (_p10) {
		var _p11 = _p10;
		var _p12 = _p11.$class;
		return _elm_lang$core$Native_Utils.eq(_p12, '') ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(_p12);
	};
	var displayName = function (name) {
		return _elm_lang$core$Native_Utils.eq(name, '') ? 'no-icon' : name;
	};
	var isSelected = function (_p13) {
		var _p14 = _p13;
		var _p15 = model.selected;
		if (_p15.ctor === 'Nothing') {
			return false;
		} else {
			return _elm_lang$core$Native_Utils.eq(_p15._0, _p14.$class);
		}
	};
	var iconClass = function (icon) {
		return isSelected(icon) ? ' selected' : '';
	};
	var iconSelect = function (icon) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'icon-container',
						iconClass(icon))),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onClick(
						_CareerPlug$ats$IconPickerWidget$SelectIcon(
							selectIcon(icon))),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$i,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class(
							A2(_elm_lang$core$Basics_ops['++'], 'fa ', icon.$class)),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$span,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								displayName(icon.displayName)),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	};
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('icon-select-list'),
			_1: {ctor: '[]'}
		},
		A2(_elm_lang$core$List$map, iconSelect, icons));
};
var _CareerPlug$ats$IconPickerWidget$view = function (model) {
	var viewClass = function () {
		var _p16 = model.viewState;
		if (_p16.ctor === 'Closed') {
			return '';
		} else {
			return 'open';
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class(
				A2(
					_elm_lang$core$String$join,
					' ',
					{
						ctor: '::',
						_0: 'icon-picker-widget',
						_1: {
							ctor: '::',
							_0: viewClass,
							_1: {ctor: '[]'}
						}
					})),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _CareerPlug$ats$IconPickerWidget$selectBoxView(model),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('list-container'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _CareerPlug$ats$IconPickerWidget$searchBarView(model),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$IconPickerWidget$iconSelectView(model),
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$IconPickerWidget$main = _elm_lang$html$Html$programWithFlags(
	{
		init: _CareerPlug$ats$IconPickerWidget$init,
		update: _CareerPlug$ats$IconPickerWidget$update,
		view: _CareerPlug$ats$IconPickerWidget$view,
		subscriptions: function (_p17) {
			return _elm_lang$core$Platform_Sub$none;
		}
	})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (icons) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (selected) {
					return _elm_lang$core$Json_Decode$succeed(
						{icons: icons, selected: selected});
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'selected',
					_elm_lang$core$Json_Decode$oneOf(
						{
							ctor: '::',
							_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
								_1: {ctor: '[]'}
							}
						})));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'icons',
			_elm_lang$core$Json_Decode$list(
				A2(
					_elm_lang$core$Json_Decode$andThen,
					function ($class) {
						return A2(
							_elm_lang$core$Json_Decode$andThen,
							function (displayName) {
								return _elm_lang$core$Json_Decode$succeed(
									{$class: $class, displayName: displayName});
							},
							A2(_elm_lang$core$Json_Decode$field, 'displayName', _elm_lang$core$Json_Decode$string));
					},
					A2(_elm_lang$core$Json_Decode$field, 'class', _elm_lang$core$Json_Decode$string))))));

var _elm_tools$parser_primitives$Native_ParserPrimitives = function() {


// STRINGS

function isSubString(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var bigLength = bigString.length - offset;

	if (bigLength < smallLength)
	{
		return tuple3(-1, row, col);
	}

	for (var i = 0; i < smallLength; i++)
	{
		var char = smallString[i];

		if (char !== bigString[offset + i])
		{
			return tuple3(-1, row, col);
		}

		// if it is a two word character
		if ((bigString.charCodeAt(offset) & 0xF800) === 0xD800)
		{
			i++
			if (smallString[i] !== bigString[offset + i])
			{
				return tuple3(-1, row, col);
			}
			col++;
			continue;
		}

		// if it is a newline
		if (char === '\n')
		{
			row++;
			col = 1;
			continue;
		}

		// if it is a one word character
		col++
	}

	return tuple3(offset + smallLength, row, col);
}

function tuple3(a, b, c)
{
	return { ctor: '_Tuple3', _0: a, _1: b, _2: c };
}


// CHARS

var mkChar = _elm_lang$core$Native_Utils.chr;

function isSubChar(predicate, offset, string)
{
	if (offset >= string.length)
	{
		return -1;
	}

	if ((string.charCodeAt(offset) & 0xF800) === 0xD800)
	{
		return predicate(mkChar(string.substr(offset, 2)))
			? offset + 2
			: -1;
	}

	var char = string[offset];

	return predicate(mkChar(char))
		? ((char === '\n') ? -2 : (offset + 1))
		: -1;
}


// FIND STRING

function findSubString(before, smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);

	if (newOffset === -1)
	{
		return tuple3(-1, row, col);
	}

	var scanTarget = before ? newOffset	: newOffset + smallString.length;

	while (offset < scanTarget)
	{
		var char = bigString[offset];

		if (char === '\n')
		{
			offset++;
			row++;
			col = 1;
			continue;
		}

		if ((bigString.charCodeAt(offset) & 0xF800) === 0xD800)
		{
			offset += 2;
			col++;
			continue;
		}

		offset++;
		col++;
	}

	return tuple3(offset, row, col);
}


return {
	isSubString: F5(isSubString),
	isSubChar: F3(isSubChar),
	findSubString: F6(findSubString)
};

}();

var _elm_tools$parser_primitives$ParserPrimitives$findSubString = _elm_tools$parser_primitives$Native_ParserPrimitives.findSubString;
var _elm_tools$parser_primitives$ParserPrimitives$isSubChar = _elm_tools$parser_primitives$Native_ParserPrimitives.isSubChar;
var _elm_tools$parser_primitives$ParserPrimitives$isSubString = _elm_tools$parser_primitives$Native_ParserPrimitives.isSubString;

var _elm_tools$parser$Parser_Internal$isPlusOrMinus = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('+')) || _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('-'));
};
var _elm_tools$parser$Parser_Internal$isZero = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('0'));
};
var _elm_tools$parser$Parser_Internal$isE = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('e')) || _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('E'));
};
var _elm_tools$parser$Parser_Internal$isDot = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('.'));
};
var _elm_tools$parser$Parser_Internal$isBadIntEnd = function ($char) {
	return _elm_lang$core$Char$isDigit($char) || (_elm_lang$core$Char$isUpper($char) || (_elm_lang$core$Char$isLower($char) || _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('.'))));
};
var _elm_tools$parser$Parser_Internal$chomp = F3(
	function (isGood, offset, source) {
		chomp:
		while (true) {
			var newOffset = A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, isGood, offset, source);
			if (_elm_lang$core$Native_Utils.cmp(newOffset, 0) < 0) {
				return offset;
			} else {
				var _v0 = isGood,
					_v1 = newOffset,
					_v2 = source;
				isGood = _v0;
				offset = _v1;
				source = _v2;
				continue chomp;
			}
		}
	});
var _elm_tools$parser$Parser_Internal$chompDigits = F3(
	function (isValidDigit, offset, source) {
		var newOffset = A3(_elm_tools$parser$Parser_Internal$chomp, isValidDigit, offset, source);
		return _elm_lang$core$Native_Utils.eq(newOffset, offset) ? _elm_lang$core$Result$Err(newOffset) : ((!_elm_lang$core$Native_Utils.eq(
			A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser_Internal$isBadIntEnd, newOffset, source),
			-1)) ? _elm_lang$core$Result$Err(newOffset) : _elm_lang$core$Result$Ok(newOffset));
	});
var _elm_tools$parser$Parser_Internal$chompExp = F2(
	function (offset, source) {
		var eOffset = A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser_Internal$isE, offset, source);
		if (_elm_lang$core$Native_Utils.eq(eOffset, -1)) {
			return _elm_lang$core$Result$Ok(offset);
		} else {
			var opOffset = A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser_Internal$isPlusOrMinus, eOffset, source);
			var expOffset = _elm_lang$core$Native_Utils.eq(opOffset, -1) ? eOffset : opOffset;
			return (!_elm_lang$core$Native_Utils.eq(
				A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser_Internal$isZero, expOffset, source),
				-1)) ? _elm_lang$core$Result$Err(expOffset) : (_elm_lang$core$Native_Utils.eq(
				A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_lang$core$Char$isDigit, expOffset, source),
				-1) ? _elm_lang$core$Result$Err(expOffset) : A3(_elm_tools$parser$Parser_Internal$chompDigits, _elm_lang$core$Char$isDigit, expOffset, source));
		}
	});
var _elm_tools$parser$Parser_Internal$chompDotAndExp = F2(
	function (offset, source) {
		var dotOffset = A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser_Internal$isDot, offset, source);
		return _elm_lang$core$Native_Utils.eq(dotOffset, -1) ? A2(_elm_tools$parser$Parser_Internal$chompExp, offset, source) : A2(
			_elm_tools$parser$Parser_Internal$chompExp,
			A3(_elm_tools$parser$Parser_Internal$chomp, _elm_lang$core$Char$isDigit, dotOffset, source),
			source);
	});
var _elm_tools$parser$Parser_Internal$State = F6(
	function (a, b, c, d, e, f) {
		return {source: a, offset: b, indent: c, context: d, row: e, col: f};
	});
var _elm_tools$parser$Parser_Internal$Parser = function (a) {
	return {ctor: 'Parser', _0: a};
};
var _elm_tools$parser$Parser_Internal$Bad = F2(
	function (a, b) {
		return {ctor: 'Bad', _0: a, _1: b};
	});
var _elm_tools$parser$Parser_Internal$Good = F2(
	function (a, b) {
		return {ctor: 'Good', _0: a, _1: b};
	});

var _elm_tools$parser$Parser$changeContext = F2(
	function (newContext, _p0) {
		var _p1 = _p0;
		return {source: _p1.source, offset: _p1.offset, indent: _p1.indent, context: newContext, row: _p1.row, col: _p1.col};
	});
var _elm_tools$parser$Parser$sourceMap = F2(
	function (func, _p2) {
		var _p3 = _p2;
		return _elm_tools$parser$Parser_Internal$Parser(
			function (_p4) {
				var _p5 = _p4;
				var _p6 = _p3._0(_p5);
				if (_p6.ctor === 'Bad') {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _p6._0, _p6._1);
				} else {
					var _p7 = _p6._1;
					var subString = A3(_elm_lang$core$String$slice, _p5.offset, _p7.offset, _p5.source);
					return A2(
						_elm_tools$parser$Parser_Internal$Good,
						A2(func, subString, _p6._0),
						_p7);
				}
			});
	});
var _elm_tools$parser$Parser$source = function (parser) {
	return A2(_elm_tools$parser$Parser$sourceMap, _elm_lang$core$Basics$always, parser);
};
var _elm_tools$parser$Parser$badFloatMsg = 'The `Parser.float` parser seems to have a bug.\nPlease report an SSCCE to <https://github.com/elm-tools/parser/issues>.';
var _elm_tools$parser$Parser$floatHelp = F3(
	function (offset, zeroOffset, source) {
		if (_elm_lang$core$Native_Utils.cmp(zeroOffset, 0) > -1) {
			return A2(_elm_tools$parser$Parser_Internal$chompDotAndExp, zeroOffset, source);
		} else {
			var dotOffset = A3(_elm_tools$parser$Parser_Internal$chomp, _elm_lang$core$Char$isDigit, offset, source);
			var result = A2(_elm_tools$parser$Parser_Internal$chompDotAndExp, dotOffset, source);
			var _p8 = result;
			if (_p8.ctor === 'Err') {
				return result;
			} else {
				var _p9 = _p8._0;
				return _elm_lang$core$Native_Utils.eq(_p9, offset) ? _elm_lang$core$Result$Err(_p9) : result;
			}
		}
	});
var _elm_tools$parser$Parser$badIntMsg = 'The `Parser.int` parser seems to have a bug.\nPlease report an SSCCE to <https://github.com/elm-tools/parser/issues>.';
var _elm_tools$parser$Parser$isX = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('x'));
};
var _elm_tools$parser$Parser$isO = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('o'));
};
var _elm_tools$parser$Parser$isZero = function ($char) {
	return _elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('0'));
};
var _elm_tools$parser$Parser$intHelp = F3(
	function (offset, zeroOffset, source) {
		return _elm_lang$core$Native_Utils.eq(zeroOffset, -1) ? A3(_elm_tools$parser$Parser_Internal$chompDigits, _elm_lang$core$Char$isDigit, offset, source) : ((!_elm_lang$core$Native_Utils.eq(
			A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser$isX, zeroOffset, source),
			-1)) ? A3(_elm_tools$parser$Parser_Internal$chompDigits, _elm_lang$core$Char$isHexDigit, offset + 2, source) : (_elm_lang$core$Native_Utils.eq(
			A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser_Internal$isBadIntEnd, zeroOffset, source),
			-1) ? _elm_lang$core$Result$Ok(zeroOffset) : _elm_lang$core$Result$Err(zeroOffset)));
	});
var _elm_tools$parser$Parser$token = F2(
	function (makeProblem, str) {
		return _elm_tools$parser$Parser_Internal$Parser(
			function (_p10) {
				var _p11 = _p10;
				var _p13 = _p11.source;
				var _p12 = A5(_elm_tools$parser_primitives$ParserPrimitives$isSubString, str, _p11.offset, _p11.row, _p11.col, _p13);
				var newOffset = _p12._0;
				var newRow = _p12._1;
				var newCol = _p12._2;
				return _elm_lang$core$Native_Utils.eq(newOffset, -1) ? A2(
					_elm_tools$parser$Parser_Internal$Bad,
					makeProblem(str),
					_p11) : A2(
					_elm_tools$parser$Parser_Internal$Good,
					{ctor: '_Tuple0'},
					{source: _p13, offset: newOffset, indent: _p11.indent, context: _p11.context, row: newRow, col: newCol});
			});
	});
var _elm_tools$parser$Parser$delayedCommitMap = F3(
	function (func, _p15, _p14) {
		var _p16 = _p15;
		var _p17 = _p14;
		return _elm_tools$parser$Parser_Internal$Parser(
			function (state1) {
				var _p18 = _p16._0(state1);
				if (_p18.ctor === 'Bad') {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _p18._0, state1);
				} else {
					var _p22 = _p18._1;
					var _p19 = _p17._0(_p22);
					if (_p19.ctor === 'Good') {
						return A2(
							_elm_tools$parser$Parser_Internal$Good,
							A2(func, _p18._0, _p19._0),
							_p19._1);
					} else {
						var _p21 = _p19._0;
						var _p20 = _p19._1;
						return (_elm_lang$core$Native_Utils.eq(_p22.row, _p20.row) && _elm_lang$core$Native_Utils.eq(_p22.col, _p20.col)) ? A2(_elm_tools$parser$Parser_Internal$Bad, _p21, state1) : A2(_elm_tools$parser$Parser_Internal$Bad, _p21, _p20);
					}
				}
			});
	});
var _elm_tools$parser$Parser$delayedCommit = F2(
	function (filler, realStuff) {
		return A3(
			_elm_tools$parser$Parser$delayedCommitMap,
			F2(
				function (_p23, v) {
					return v;
				}),
			filler,
			realStuff);
	});
var _elm_tools$parser$Parser$lazy = function (thunk) {
	return _elm_tools$parser$Parser_Internal$Parser(
		function (state) {
			var _p24 = thunk(
				{ctor: '_Tuple0'});
			var parse = _p24._0;
			return parse(state);
		});
};
var _elm_tools$parser$Parser$andThen = F2(
	function (callback, _p25) {
		var _p26 = _p25;
		return _elm_tools$parser$Parser_Internal$Parser(
			function (state1) {
				var _p27 = _p26._0(state1);
				if (_p27.ctor === 'Bad') {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _p27._0, _p27._1);
				} else {
					var _p28 = callback(_p27._0);
					var parseB = _p28._0;
					return parseB(_p27._1);
				}
			});
	});
var _elm_tools$parser$Parser$apply = F2(
	function (f, a) {
		return f(a);
	});
var _elm_tools$parser$Parser$map2 = F3(
	function (func, _p30, _p29) {
		var _p31 = _p30;
		var _p32 = _p29;
		return _elm_tools$parser$Parser_Internal$Parser(
			function (state1) {
				var _p33 = _p31._0(state1);
				if (_p33.ctor === 'Bad') {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _p33._0, _p33._1);
				} else {
					var _p34 = _p32._0(_p33._1);
					if (_p34.ctor === 'Bad') {
						return A2(_elm_tools$parser$Parser_Internal$Bad, _p34._0, _p34._1);
					} else {
						return A2(
							_elm_tools$parser$Parser_Internal$Good,
							A2(func, _p33._0, _p34._0),
							_p34._1);
					}
				}
			});
	});
var _elm_tools$parser$Parser_ops = _elm_tools$parser$Parser_ops || {};
_elm_tools$parser$Parser_ops['|='] = F2(
	function (parseFunc, parseArg) {
		return A3(_elm_tools$parser$Parser$map2, _elm_tools$parser$Parser$apply, parseFunc, parseArg);
	});
var _elm_tools$parser$Parser_ops = _elm_tools$parser$Parser_ops || {};
_elm_tools$parser$Parser_ops['|.'] = F2(
	function (keepParser, ignoreParser) {
		return A3(_elm_tools$parser$Parser$map2, _elm_lang$core$Basics$always, keepParser, ignoreParser);
	});
var _elm_tools$parser$Parser$map = F2(
	function (func, _p35) {
		var _p36 = _p35;
		return _elm_tools$parser$Parser_Internal$Parser(
			function (state1) {
				var _p37 = _p36._0(state1);
				if (_p37.ctor === 'Good') {
					return A2(
						_elm_tools$parser$Parser_Internal$Good,
						func(_p37._0),
						_p37._1);
				} else {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _p37._0, _p37._1);
				}
			});
	});
var _elm_tools$parser$Parser$succeed = function (a) {
	return _elm_tools$parser$Parser_Internal$Parser(
		function (state) {
			return A2(_elm_tools$parser$Parser_Internal$Good, a, state);
		});
};
var _elm_tools$parser$Parser$run = F2(
	function (_p38, source) {
		var _p39 = _p38;
		var initialState = {
			source: source,
			offset: 0,
			indent: 1,
			context: {ctor: '[]'},
			row: 1,
			col: 1
		};
		var _p40 = _p39._0(initialState);
		if (_p40.ctor === 'Good') {
			return _elm_lang$core$Result$Ok(_p40._0);
		} else {
			return _elm_lang$core$Result$Err(
				{row: _p40._1.row, col: _p40._1.col, source: source, problem: _p40._0, context: _p40._1.context});
		}
	});
var _elm_tools$parser$Parser$Error = F5(
	function (a, b, c, d, e) {
		return {row: a, col: b, source: c, problem: d, context: e};
	});
var _elm_tools$parser$Parser$Context = F3(
	function (a, b, c) {
		return {row: a, col: b, description: c};
	});
var _elm_tools$parser$Parser$inContext = F2(
	function (ctx, _p41) {
		var _p42 = _p41;
		return _elm_tools$parser$Parser_Internal$Parser(
			function (_p43) {
				var _p44 = _p43;
				var _p46 = _p44.context;
				var state1 = A2(
					_elm_tools$parser$Parser$changeContext,
					{
						ctor: '::',
						_0: A3(_elm_tools$parser$Parser$Context, _p44.row, _p44.col, ctx),
						_1: _p46
					},
					_p44);
				var _p45 = _p42._0(state1);
				if (_p45.ctor === 'Good') {
					return A2(
						_elm_tools$parser$Parser_Internal$Good,
						_p45._0,
						A2(_elm_tools$parser$Parser$changeContext, _p46, _p45._1));
				} else {
					return _p45;
				}
			});
	});
var _elm_tools$parser$Parser$Fail = function (a) {
	return {ctor: 'Fail', _0: a};
};
var _elm_tools$parser$Parser$fail = function (message) {
	return _elm_tools$parser$Parser_Internal$Parser(
		function (state) {
			return A2(
				_elm_tools$parser$Parser_Internal$Bad,
				_elm_tools$parser$Parser$Fail(message),
				state);
		});
};
var _elm_tools$parser$Parser$ExpectingClosing = function (a) {
	return {ctor: 'ExpectingClosing', _0: a};
};
var _elm_tools$parser$Parser$ignoreUntil = function (str) {
	return _elm_tools$parser$Parser_Internal$Parser(
		function (_p47) {
			var _p48 = _p47;
			var _p50 = _p48.source;
			var _p49 = A6(_elm_tools$parser_primitives$ParserPrimitives$findSubString, false, str, _p48.offset, _p48.row, _p48.col, _p50);
			var newOffset = _p49._0;
			var newRow = _p49._1;
			var newCol = _p49._2;
			return _elm_lang$core$Native_Utils.eq(newOffset, -1) ? A2(
				_elm_tools$parser$Parser_Internal$Bad,
				_elm_tools$parser$Parser$ExpectingClosing(str),
				_p48) : A2(
				_elm_tools$parser$Parser_Internal$Good,
				{ctor: '_Tuple0'},
				{source: _p50, offset: newOffset, indent: _p48.indent, context: _p48.context, row: newRow, col: newCol});
		});
};
var _elm_tools$parser$Parser$ExpectingVariable = {ctor: 'ExpectingVariable'};
var _elm_tools$parser$Parser$ExpectingKeyword = function (a) {
	return {ctor: 'ExpectingKeyword', _0: a};
};
var _elm_tools$parser$Parser$keyword = function (str) {
	return A2(_elm_tools$parser$Parser$token, _elm_tools$parser$Parser$ExpectingKeyword, str);
};
var _elm_tools$parser$Parser$ExpectingSymbol = function (a) {
	return {ctor: 'ExpectingSymbol', _0: a};
};
var _elm_tools$parser$Parser$symbol = function (str) {
	return A2(_elm_tools$parser$Parser$token, _elm_tools$parser$Parser$ExpectingSymbol, str);
};
var _elm_tools$parser$Parser$ExpectingEnd = {ctor: 'ExpectingEnd'};
var _elm_tools$parser$Parser$end = _elm_tools$parser$Parser_Internal$Parser(
	function (state) {
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$length(state.source),
			state.offset) ? A2(
			_elm_tools$parser$Parser_Internal$Good,
			{ctor: '_Tuple0'},
			state) : A2(_elm_tools$parser$Parser_Internal$Bad, _elm_tools$parser$Parser$ExpectingEnd, state);
	});
var _elm_tools$parser$Parser$BadRepeat = {ctor: 'BadRepeat'};
var _elm_tools$parser$Parser$repeatExactly = F4(
	function (n, parse, revList, state1) {
		repeatExactly:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return A2(
					_elm_tools$parser$Parser_Internal$Good,
					_elm_lang$core$List$reverse(revList),
					state1);
			} else {
				var _p51 = parse(state1);
				if (_p51.ctor === 'Good') {
					var _p52 = _p51._1;
					if (_elm_lang$core$Native_Utils.eq(state1.row, _p52.row) && _elm_lang$core$Native_Utils.eq(state1.col, _p52.col)) {
						return A2(_elm_tools$parser$Parser_Internal$Bad, _elm_tools$parser$Parser$BadRepeat, _p52);
					} else {
						var _v25 = n - 1,
							_v26 = parse,
							_v27 = {ctor: '::', _0: _p51._0, _1: revList},
							_v28 = _p52;
						n = _v25;
						parse = _v26;
						revList = _v27;
						state1 = _v28;
						continue repeatExactly;
					}
				} else {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _p51._0, _p51._1);
				}
			}
		}
	});
var _elm_tools$parser$Parser$repeatAtLeast = F4(
	function (n, parse, revList, state1) {
		repeatAtLeast:
		while (true) {
			var _p53 = parse(state1);
			if (_p53.ctor === 'Good') {
				var _p54 = _p53._1;
				if (_elm_lang$core$Native_Utils.eq(state1.row, _p54.row) && _elm_lang$core$Native_Utils.eq(state1.col, _p54.col)) {
					return A2(_elm_tools$parser$Parser_Internal$Bad, _elm_tools$parser$Parser$BadRepeat, _p54);
				} else {
					var _v30 = n - 1,
						_v31 = parse,
						_v32 = {ctor: '::', _0: _p53._0, _1: revList},
						_v33 = _p54;
					n = _v30;
					parse = _v31;
					revList = _v32;
					state1 = _v33;
					continue repeatAtLeast;
				}
			} else {
				var _p55 = _p53._1;
				return (_elm_lang$core$Native_Utils.eq(state1.row, _p55.row) && (_elm_lang$core$Native_Utils.eq(state1.col, _p55.col) && (_elm_lang$core$Native_Utils.cmp(n, 0) < 1))) ? A2(
					_elm_tools$parser$Parser_Internal$Good,
					_elm_lang$core$List$reverse(revList),
					state1) : A2(_elm_tools$parser$Parser_Internal$Bad, _p53._0, _p55);
			}
		}
	});
var _elm_tools$parser$Parser$repeat = F2(
	function (count, _p56) {
		var _p57 = _p56;
		var _p59 = _p57._0;
		var _p58 = count;
		if (_p58.ctor === 'Exactly') {
			return _elm_tools$parser$Parser_Internal$Parser(
				function (state) {
					return A4(
						_elm_tools$parser$Parser$repeatExactly,
						_p58._0,
						_p59,
						{ctor: '[]'},
						state);
				});
		} else {
			return _elm_tools$parser$Parser_Internal$Parser(
				function (state) {
					return A4(
						_elm_tools$parser$Parser$repeatAtLeast,
						_p58._0,
						_p59,
						{ctor: '[]'},
						state);
				});
		}
	});
var _elm_tools$parser$Parser$ignoreExactly = F8(
	function (n, predicate, source, offset, indent, context, row, col) {
		ignoreExactly:
		while (true) {
			if (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) {
				return A2(
					_elm_tools$parser$Parser_Internal$Good,
					{ctor: '_Tuple0'},
					{source: source, offset: offset, indent: indent, context: context, row: row, col: col});
			} else {
				var newOffset = A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, predicate, offset, source);
				if (_elm_lang$core$Native_Utils.eq(newOffset, -1)) {
					return A2(
						_elm_tools$parser$Parser_Internal$Bad,
						_elm_tools$parser$Parser$BadRepeat,
						{source: source, offset: offset, indent: indent, context: context, row: row, col: col});
				} else {
					if (_elm_lang$core$Native_Utils.eq(newOffset, -2)) {
						var _v36 = n - 1,
							_v37 = predicate,
							_v38 = source,
							_v39 = offset + 1,
							_v40 = indent,
							_v41 = context,
							_v42 = row + 1,
							_v43 = 1;
						n = _v36;
						predicate = _v37;
						source = _v38;
						offset = _v39;
						indent = _v40;
						context = _v41;
						row = _v42;
						col = _v43;
						continue ignoreExactly;
					} else {
						var _v44 = n - 1,
							_v45 = predicate,
							_v46 = source,
							_v47 = newOffset,
							_v48 = indent,
							_v49 = context,
							_v50 = row,
							_v51 = col + 1;
						n = _v44;
						predicate = _v45;
						source = _v46;
						offset = _v47;
						indent = _v48;
						context = _v49;
						row = _v50;
						col = _v51;
						continue ignoreExactly;
					}
				}
			}
		}
	});
var _elm_tools$parser$Parser$ignoreAtLeast = F8(
	function (n, predicate, source, offset, indent, context, row, col) {
		ignoreAtLeast:
		while (true) {
			var newOffset = A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, predicate, offset, source);
			if (_elm_lang$core$Native_Utils.eq(newOffset, -1)) {
				var state = {source: source, offset: offset, indent: indent, context: context, row: row, col: col};
				return (_elm_lang$core$Native_Utils.cmp(n, 0) < 1) ? A2(
					_elm_tools$parser$Parser_Internal$Good,
					{ctor: '_Tuple0'},
					state) : A2(_elm_tools$parser$Parser_Internal$Bad, _elm_tools$parser$Parser$BadRepeat, state);
			} else {
				if (_elm_lang$core$Native_Utils.eq(newOffset, -2)) {
					var _v52 = n - 1,
						_v53 = predicate,
						_v54 = source,
						_v55 = offset + 1,
						_v56 = indent,
						_v57 = context,
						_v58 = row + 1,
						_v59 = 1;
					n = _v52;
					predicate = _v53;
					source = _v54;
					offset = _v55;
					indent = _v56;
					context = _v57;
					row = _v58;
					col = _v59;
					continue ignoreAtLeast;
				} else {
					var _v60 = n - 1,
						_v61 = predicate,
						_v62 = source,
						_v63 = newOffset,
						_v64 = indent,
						_v65 = context,
						_v66 = row,
						_v67 = col + 1;
					n = _v60;
					predicate = _v61;
					source = _v62;
					offset = _v63;
					indent = _v64;
					context = _v65;
					row = _v66;
					col = _v67;
					continue ignoreAtLeast;
				}
			}
		}
	});
var _elm_tools$parser$Parser$ignore = F2(
	function (count, predicate) {
		var _p60 = count;
		if (_p60.ctor === 'Exactly') {
			return _elm_tools$parser$Parser_Internal$Parser(
				function (_p61) {
					var _p62 = _p61;
					return A8(_elm_tools$parser$Parser$ignoreExactly, _p60._0, predicate, _p62.source, _p62.offset, _p62.indent, _p62.context, _p62.row, _p62.col);
				});
		} else {
			return _elm_tools$parser$Parser_Internal$Parser(
				function (_p63) {
					var _p64 = _p63;
					return A8(_elm_tools$parser$Parser$ignoreAtLeast, _p60._0, predicate, _p64.source, _p64.offset, _p64.indent, _p64.context, _p64.row, _p64.col);
				});
		}
	});
var _elm_tools$parser$Parser$keep = F2(
	function (count, predicate) {
		return _elm_tools$parser$Parser$source(
			A2(_elm_tools$parser$Parser$ignore, count, predicate));
	});
var _elm_tools$parser$Parser$BadFloat = {ctor: 'BadFloat'};
var _elm_tools$parser$Parser$float = _elm_tools$parser$Parser_Internal$Parser(
	function (_p65) {
		var _p66 = _p65;
		var _p77 = _p66.source;
		var _p76 = _p66.row;
		var _p75 = _p66.offset;
		var _p74 = _p66.indent;
		var _p73 = _p66.context;
		var _p72 = _p66.col;
		var _p67 = A3(
			_elm_tools$parser$Parser$floatHelp,
			_p75,
			A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser$isZero, _p75, _p77),
			_p77);
		if (_p67.ctor === 'Err') {
			var _p68 = _p67._0;
			return A2(
				_elm_tools$parser$Parser_Internal$Bad,
				_elm_tools$parser$Parser$BadFloat,
				{source: _p77, offset: _p68, indent: _p74, context: _p73, row: _p76, col: _p72 + (_p68 - _p75)});
		} else {
			var _p71 = _p67._0;
			var _p69 = _elm_lang$core$String$toFloat(
				A3(_elm_lang$core$String$slice, _p75, _p71, _p77));
			if (_p69.ctor === 'Err') {
				return _elm_lang$core$Native_Utils.crashCase(
					'Parser',
					{
						start: {line: 733, column: 9},
						end: {line: 745, column: 16}
					},
					_p69)(_elm_tools$parser$Parser$badFloatMsg);
			} else {
				return A2(
					_elm_tools$parser$Parser_Internal$Good,
					_p69._0,
					{source: _p77, offset: _p71, indent: _p74, context: _p73, row: _p76, col: _p72 + (_p71 - _p75)});
			}
		}
	});
var _elm_tools$parser$Parser$BadInt = {ctor: 'BadInt'};
var _elm_tools$parser$Parser$int = _elm_tools$parser$Parser_Internal$Parser(
	function (_p78) {
		var _p79 = _p78;
		var _p90 = _p79.source;
		var _p89 = _p79.row;
		var _p88 = _p79.offset;
		var _p87 = _p79.indent;
		var _p86 = _p79.context;
		var _p85 = _p79.col;
		var _p80 = A3(
			_elm_tools$parser$Parser$intHelp,
			_p88,
			A3(_elm_tools$parser_primitives$ParserPrimitives$isSubChar, _elm_tools$parser$Parser$isZero, _p88, _p90),
			_p90);
		if (_p80.ctor === 'Err') {
			var _p81 = _p80._0;
			return A2(
				_elm_tools$parser$Parser_Internal$Bad,
				_elm_tools$parser$Parser$BadInt,
				{source: _p90, offset: _p81, indent: _p87, context: _p86, row: _p89, col: _p85 + (_p81 - _p88)});
		} else {
			var _p84 = _p80._0;
			var _p82 = _elm_lang$core$String$toInt(
				A3(_elm_lang$core$String$slice, _p88, _p84, _p90));
			if (_p82.ctor === 'Err') {
				return _elm_lang$core$Native_Utils.crashCase(
					'Parser',
					{
						start: {line: 638, column: 9},
						end: {line: 650, column: 16}
					},
					_p82)(_elm_tools$parser$Parser$badIntMsg);
			} else {
				return A2(
					_elm_tools$parser$Parser_Internal$Good,
					_p82._0,
					{source: _p90, offset: _p84, indent: _p87, context: _p86, row: _p89, col: _p85 + (_p84 - _p88)});
			}
		}
	});
var _elm_tools$parser$Parser$BadOneOf = function (a) {
	return {ctor: 'BadOneOf', _0: a};
};
var _elm_tools$parser$Parser$oneOfHelp = F3(
	function (state, problems, parsers) {
		oneOfHelp:
		while (true) {
			var _p91 = parsers;
			if (_p91.ctor === '[]') {
				return A2(
					_elm_tools$parser$Parser_Internal$Bad,
					_elm_tools$parser$Parser$BadOneOf(
						_elm_lang$core$List$reverse(problems)),
					state);
			} else {
				var _p92 = _p91._0._0(state);
				if (_p92.ctor === 'Good') {
					return _p92;
				} else {
					if (_elm_lang$core$Native_Utils.eq(state.row, _p92._1.row) && _elm_lang$core$Native_Utils.eq(state.col, _p92._1.col)) {
						var _v79 = state,
							_v80 = {ctor: '::', _0: _p92._0, _1: problems},
							_v81 = _p91._1;
						state = _v79;
						problems = _v80;
						parsers = _v81;
						continue oneOfHelp;
					} else {
						return _p92;
					}
				}
			}
		}
	});
var _elm_tools$parser$Parser$oneOf = function (parsers) {
	return _elm_tools$parser$Parser_Internal$Parser(
		function (state) {
			return A3(
				_elm_tools$parser$Parser$oneOfHelp,
				state,
				{ctor: '[]'},
				parsers);
		});
};
var _elm_tools$parser$Parser$Exactly = function (a) {
	return {ctor: 'Exactly', _0: a};
};
var _elm_tools$parser$Parser$AtLeast = function (a) {
	return {ctor: 'AtLeast', _0: a};
};
var _elm_tools$parser$Parser$zeroOrMore = _elm_tools$parser$Parser$AtLeast(0);
var _elm_tools$parser$Parser$oneOrMore = _elm_tools$parser$Parser$AtLeast(1);

var _abadi199$dateparser$Error$DateError = function (a) {
	return {ctor: 'DateError', _0: a};
};
var _abadi199$dateparser$Error$ParsingError = function (a) {
	return {ctor: 'ParsingError', _0: a};
};
var _abadi199$dateparser$Error$PatternError = function (a) {
	return {ctor: 'PatternError', _0: a};
};

var _abadi199$dateparser$InternalDate_Type$emptyDate = {date: 1, month: 1, year: 1900, hour: 0, minute: 0, second: 0, millisecond: 0, ampm: _elm_lang$core$Maybe$Nothing, timeZoneOffset: 0};
var _abadi199$dateparser$InternalDate_Type$InternalDate = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {date: a, month: b, year: c, hour: d, minute: e, second: f, millisecond: g, ampm: h, timeZoneOffset: i};
	});
var _abadi199$dateparser$InternalDate_Type$PM = {ctor: 'PM'};
var _abadi199$dateparser$InternalDate_Type$AM = {ctor: 'AM'};

var _abadi199$dateparser$Pattern$isNotSymbolOrSpace = function ($char) {
	return (!_elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr('%'))) && (!_elm_lang$core$Native_Utils.eq(
		$char,
		_elm_lang$core$Native_Utils.chr(' ')));
};
var _abadi199$dateparser$Pattern$Other = function (a) {
	return {ctor: 'Other', _0: a};
};
var _abadi199$dateparser$Pattern$other = function () {
	var toPattern = function (str) {
		return _elm_lang$core$Native_Utils.eq(str, '') ? _elm_tools$parser$Parser$fail('empty character') : _elm_tools$parser$Parser$succeed(
			_abadi199$dateparser$Pattern$Other(str));
	};
	return A2(
		_elm_tools$parser$Parser$andThen,
		toPattern,
		A2(
			_elm_tools$parser$Parser$sourceMap,
			_elm_lang$core$Basics$always,
			A2(_elm_tools$parser$Parser$ignore, _elm_tools$parser$Parser$zeroOrMore, _abadi199$dateparser$Pattern$isNotSymbolOrSpace)));
}();
var _abadi199$dateparser$Pattern$Whitespace = {ctor: 'Whitespace'};
var _abadi199$dateparser$Pattern$TimeZoneOffsetColon = {ctor: 'TimeZoneOffsetColon'};
var _abadi199$dateparser$Pattern$TimeZoneOffset = {ctor: 'TimeZoneOffset'};
var _abadi199$dateparser$Pattern$Millisecond = {ctor: 'Millisecond'};
var _abadi199$dateparser$Pattern$SecondZeroPadded = {ctor: 'SecondZeroPadded'};
var _abadi199$dateparser$Pattern$MinuteZeroPadded = {ctor: 'MinuteZeroPadded'};
var _abadi199$dateparser$Pattern$Ampm = {ctor: 'Ampm'};
var _abadi199$dateparser$Pattern$AMPM = {ctor: 'AMPM'};
var _abadi199$dateparser$Pattern$Hour12 = {ctor: 'Hour12'};
var _abadi199$dateparser$Pattern$Hour12SpacePadded = {ctor: 'Hour12SpacePadded'};
var _abadi199$dateparser$Pattern$Hour12ZeroPadded = {ctor: 'Hour12ZeroPadded'};
var _abadi199$dateparser$Pattern$Hour24 = {ctor: 'Hour24'};
var _abadi199$dateparser$Pattern$Hour24SpacePadded = {ctor: 'Hour24SpacePadded'};
var _abadi199$dateparser$Pattern$Hour24ZeroPadded = {ctor: 'Hour24ZeroPadded'};
var _abadi199$dateparser$Pattern$DayOfWeekUpperAbbrvName = {ctor: 'DayOfWeekUpperAbbrvName'};
var _abadi199$dateparser$Pattern$DayOfWeekAbbrvName = {ctor: 'DayOfWeekAbbrvName'};
var _abadi199$dateparser$Pattern$DayOfWeekUpperFullName = {ctor: 'DayOfWeekUpperFullName'};
var _abadi199$dateparser$Pattern$DayOfWeekFullName = {ctor: 'DayOfWeekFullName'};
var _abadi199$dateparser$Pattern$DateSpacePaddedSuffix = {ctor: 'DateSpacePaddedSuffix'};
var _abadi199$dateparser$Pattern$DateSuffix = {ctor: 'DateSuffix'};
var _abadi199$dateparser$Pattern$Date = {ctor: 'Date'};
var _abadi199$dateparser$Pattern$DateSpacePadded = {ctor: 'DateSpacePadded'};
var _abadi199$dateparser$Pattern$DateZeroPadded = {ctor: 'DateZeroPadded'};
var _abadi199$dateparser$Pattern$MonthUpperAbbrvName = {ctor: 'MonthUpperAbbrvName'};
var _abadi199$dateparser$Pattern$MonthAbbrvName = {ctor: 'MonthAbbrvName'};
var _abadi199$dateparser$Pattern$MonthUpperFullName = {ctor: 'MonthUpperFullName'};
var _abadi199$dateparser$Pattern$MonthFullName = {ctor: 'MonthFullName'};
var _abadi199$dateparser$Pattern$Month = {ctor: 'Month'};
var _abadi199$dateparser$Pattern$MonthSpacePadded = {ctor: 'MonthSpacePadded'};
var _abadi199$dateparser$Pattern$MonthZeroPadded = {ctor: 'MonthZeroPadded'};
var _abadi199$dateparser$Pattern$Year = {ctor: 'Year'};
var _abadi199$dateparser$Pattern$nextPattern = A2(
	_elm_tools$parser$Parser$inContext,
	'pattern',
	A2(
		_elm_tools$parser$Parser$delayedCommit,
		_elm_tools$parser$Parser$symbol('%'),
		_elm_tools$parser$Parser$oneOf(
			{
				ctor: '::',
				_0: A2(
					_elm_tools$parser$Parser$andThen,
					_elm_lang$core$Basics$always(
						_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Year)),
					_elm_tools$parser$Parser$symbol('Y')),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_tools$parser$Parser$andThen,
						_elm_lang$core$Basics$always(
							_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MonthZeroPadded)),
						_elm_tools$parser$Parser$symbol('m')),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_tools$parser$Parser$andThen,
							_elm_lang$core$Basics$always(
								_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MonthSpacePadded)),
							_elm_tools$parser$Parser$symbol('_m')),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_tools$parser$Parser$andThen,
								_elm_lang$core$Basics$always(
									_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Month)),
								_elm_tools$parser$Parser$symbol('-m')),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_tools$parser$Parser$andThen,
									_elm_lang$core$Basics$always(
										_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MonthFullName)),
									_elm_tools$parser$Parser$symbol('B')),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_tools$parser$Parser$andThen,
										_elm_lang$core$Basics$always(
											_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MonthUpperFullName)),
										_elm_tools$parser$Parser$symbol('^B')),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_tools$parser$Parser$andThen,
											_elm_lang$core$Basics$always(
												_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MonthAbbrvName)),
											_elm_tools$parser$Parser$symbol('b')),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_tools$parser$Parser$andThen,
												_elm_lang$core$Basics$always(
													_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MonthUpperAbbrvName)),
												_elm_tools$parser$Parser$symbol('^b')),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_tools$parser$Parser$andThen,
													_elm_lang$core$Basics$always(
														_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DateZeroPadded)),
													_elm_tools$parser$Parser$symbol('d')),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_tools$parser$Parser$andThen,
														_elm_lang$core$Basics$always(
															_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Date)),
														_elm_tools$parser$Parser$symbol('-d')),
													_1: {
														ctor: '::',
														_0: A2(
															_elm_tools$parser$Parser$andThen,
															_elm_lang$core$Basics$always(
																_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DateSuffix)),
															_elm_tools$parser$Parser$symbol('-@d')),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_tools$parser$Parser$andThen,
																_elm_lang$core$Basics$always(
																	_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DateSpacePadded)),
																_elm_tools$parser$Parser$symbol('e')),
															_1: {
																ctor: '::',
																_0: A2(
																	_elm_tools$parser$Parser$andThen,
																	_elm_lang$core$Basics$always(
																		_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DateSpacePaddedSuffix)),
																	_elm_tools$parser$Parser$symbol('@e')),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_tools$parser$Parser$andThen,
																		_elm_lang$core$Basics$always(
																			_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DayOfWeekFullName)),
																		_elm_tools$parser$Parser$symbol('A')),
																	_1: {
																		ctor: '::',
																		_0: A2(
																			_elm_tools$parser$Parser$andThen,
																			_elm_lang$core$Basics$always(
																				_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DayOfWeekUpperFullName)),
																			_elm_tools$parser$Parser$symbol('^A')),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_elm_tools$parser$Parser$andThen,
																				_elm_lang$core$Basics$always(
																					_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DayOfWeekAbbrvName)),
																				_elm_tools$parser$Parser$symbol('a')),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_elm_tools$parser$Parser$andThen,
																					_elm_lang$core$Basics$always(
																						_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$DayOfWeekUpperAbbrvName)),
																					_elm_tools$parser$Parser$symbol('^a')),
																				_1: {
																					ctor: '::',
																					_0: A2(
																						_elm_tools$parser$Parser$andThen,
																						_elm_lang$core$Basics$always(
																							_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Hour24ZeroPadded)),
																						_elm_tools$parser$Parser$symbol('H')),
																					_1: {
																						ctor: '::',
																						_0: A2(
																							_elm_tools$parser$Parser$andThen,
																							_elm_lang$core$Basics$always(
																								_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Hour24)),
																							_elm_tools$parser$Parser$symbol('-H')),
																						_1: {
																							ctor: '::',
																							_0: A2(
																								_elm_tools$parser$Parser$andThen,
																								_elm_lang$core$Basics$always(
																									_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Hour24SpacePadded)),
																								_elm_tools$parser$Parser$symbol('k')),
																							_1: {
																								ctor: '::',
																								_0: A2(
																									_elm_tools$parser$Parser$andThen,
																									_elm_lang$core$Basics$always(
																										_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Hour12ZeroPadded)),
																									_elm_tools$parser$Parser$symbol('I')),
																								_1: {
																									ctor: '::',
																									_0: A2(
																										_elm_tools$parser$Parser$andThen,
																										_elm_lang$core$Basics$always(
																											_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Hour12)),
																										_elm_tools$parser$Parser$symbol('-I')),
																									_1: {
																										ctor: '::',
																										_0: A2(
																											_elm_tools$parser$Parser$andThen,
																											_elm_lang$core$Basics$always(
																												_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Hour12SpacePadded)),
																											_elm_tools$parser$Parser$symbol('l')),
																										_1: {
																											ctor: '::',
																											_0: A2(
																												_elm_tools$parser$Parser$andThen,
																												_elm_lang$core$Basics$always(
																													_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$AMPM)),
																												_elm_tools$parser$Parser$symbol('p')),
																											_1: {
																												ctor: '::',
																												_0: A2(
																													_elm_tools$parser$Parser$andThen,
																													_elm_lang$core$Basics$always(
																														_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Ampm)),
																													_elm_tools$parser$Parser$symbol('P')),
																												_1: {
																													ctor: '::',
																													_0: A2(
																														_elm_tools$parser$Parser$andThen,
																														_elm_lang$core$Basics$always(
																															_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$MinuteZeroPadded)),
																														_elm_tools$parser$Parser$symbol('M')),
																													_1: {
																														ctor: '::',
																														_0: A2(
																															_elm_tools$parser$Parser$andThen,
																															_elm_lang$core$Basics$always(
																																_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$SecondZeroPadded)),
																															_elm_tools$parser$Parser$symbol('S')),
																														_1: {
																															ctor: '::',
																															_0: A2(
																																_elm_tools$parser$Parser$andThen,
																																_elm_lang$core$Basics$always(
																																	_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$Millisecond)),
																																_elm_tools$parser$Parser$symbol('L')),
																															_1: {
																																ctor: '::',
																																_0: A2(
																																	_elm_tools$parser$Parser$andThen,
																																	_elm_lang$core$Basics$always(
																																		_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$TimeZoneOffset)),
																																	_elm_tools$parser$Parser$symbol('z')),
																																_1: {
																																	ctor: '::',
																																	_0: A2(
																																		_elm_tools$parser$Parser$andThen,
																																		_elm_lang$core$Basics$always(
																																			_elm_tools$parser$Parser$succeed(_abadi199$dateparser$Pattern$TimeZoneOffsetColon)),
																																		_elm_tools$parser$Parser$symbol(':z')),
																																	_1: {
																																		ctor: '::',
																																		_0: A2(
																																			_elm_tools$parser$Parser$andThen,
																																			_elm_lang$core$Basics$always(
																																				_elm_tools$parser$Parser$succeed(
																																					_abadi199$dateparser$Pattern$Other('%'))),
																																			_elm_tools$parser$Parser$symbol('%')),
																																		_1: {ctor: '[]'}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			})));
var _abadi199$dateparser$Pattern$patternListHelper = function (patterns) {
	return _elm_tools$parser$Parser$oneOf(
		{
			ctor: '::',
			_0: A2(
				_elm_tools$parser$Parser$andThen,
				function (pattern) {
					return _abadi199$dateparser$Pattern$patternListHelper(
						{ctor: '::', _0: pattern, _1: patterns});
				},
				_abadi199$dateparser$Pattern$nextPattern),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_tools$parser$Parser$andThen,
					function (_p0) {
						return _abadi199$dateparser$Pattern$patternListHelper(
							{ctor: '::', _0: _abadi199$dateparser$Pattern$Whitespace, _1: patterns});
					},
					A2(
						_elm_tools$parser$Parser$repeat,
						_elm_tools$parser$Parser$oneOrMore,
						_elm_tools$parser$Parser$symbol(' '))),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_tools$parser$Parser$andThen,
						function (pattern) {
							return _abadi199$dateparser$Pattern$patternListHelper(
								{ctor: '::', _0: pattern, _1: patterns});
						},
						_abadi199$dateparser$Pattern$other),
					_1: {
						ctor: '::',
						_0: _elm_tools$parser$Parser$succeed(
							_elm_lang$core$List$reverse(patterns)),
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _abadi199$dateparser$Pattern$patternList = A2(
	_elm_tools$parser$Parser$inContext,
	'patternList',
	A2(
		_elm_tools$parser$Parser_ops['|='],
		_elm_tools$parser$Parser$succeed(_elm_lang$core$Basics$identity),
		_abadi199$dateparser$Pattern$patternListHelper(
			{ctor: '[]'})));
var _abadi199$dateparser$Pattern$parse = function (pattern) {
	return A2(
		_elm_lang$core$Result$mapError,
		function (_p1) {
			return _abadi199$dateparser$Error$PatternError(
				_elm_lang$core$Basics$toString(_p1));
		},
		A2(_elm_tools$parser$Parser$run, _abadi199$dateparser$Pattern$patternList, pattern));
};

var _abadi199$dateparser$Utilities$monthFromInt = function (month) {
	var _p0 = month;
	switch (_p0) {
		case 1:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Jan);
		case 2:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Feb);
		case 3:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Mar);
		case 4:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Apr);
		case 5:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$May);
		case 6:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Jun);
		case 7:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Jul);
		case 8:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Aug);
		case 9:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Sep);
		case 10:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Oct);
		case 11:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Nov);
		case 12:
			return _elm_lang$core$Result$Ok(_elm_lang$core$Date$Dec);
		default:
			return _elm_lang$core$Result$Err(
				A2(
					_elm_lang$core$Basics_ops['++'],
					'Invalid month: ',
					_elm_lang$core$Basics$toString(month)));
	}
};
var _abadi199$dateparser$Utilities$monthToInt = function (month) {
	var _p1 = month;
	switch (_p1.ctor) {
		case 'Jan':
			return 1;
		case 'Feb':
			return 2;
		case 'Mar':
			return 3;
		case 'Apr':
			return 4;
		case 'May':
			return 5;
		case 'Jun':
			return 6;
		case 'Jul':
			return 7;
		case 'Aug':
			return 8;
		case 'Sep':
			return 9;
		case 'Oct':
			return 10;
		case 'Nov':
			return 11;
		default:
			return 12;
	}
};
var _abadi199$dateparser$Utilities$toUpper = function (upper) {
	return upper ? _elm_lang$core$String$toUpper : _elm_lang$core$Basics$identity;
};

var _abadi199$dateparser$InternalDate_Parser$other = F2(
	function (symbol, internalDate) {
		return A2(
			_elm_tools$parser$Parser$andThen,
			function (_p0) {
				return _elm_tools$parser$Parser$succeed(internalDate);
			},
			A2(
				_elm_tools$parser$Parser$inContext,
				'Other',
				A2(
					_elm_tools$parser$Parser_ops['|.'],
					_elm_tools$parser$Parser$succeed(_elm_lang$core$Basics$identity),
					_elm_tools$parser$Parser$symbol(symbol))));
	});
var _abadi199$dateparser$InternalDate_Parser$whitespace = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$andThen,
		function (_p1) {
			return _elm_tools$parser$Parser$succeed(internalDate);
		},
		A2(
			_elm_tools$parser$Parser$inContext,
			'Whitespace',
			A2(
				_elm_tools$parser$Parser_ops['|.'],
				_elm_tools$parser$Parser$succeed(_elm_lang$core$Basics$identity),
				A2(
					_elm_tools$parser$Parser$repeat,
					_elm_tools$parser$Parser$oneOrMore,
					_elm_tools$parser$Parser$symbol(' ')))));
};
var _abadi199$dateparser$InternalDate_Parser$timeZoneOffsetColon = function (internalDate) {
	return _elm_lang$core$Native_Utils.crash(
		'InternalDate.Parser',
		{
			start: {line: 432, column: 5},
			end: {line: 432, column: 16}
		})('timeZoneOffsetColon');
};
var _abadi199$dateparser$InternalDate_Parser$paddedInts = function (numbers) {
	var pad = function (number) {
		return (_elm_lang$core$Native_Utils.cmp(number, 10) < 0) ? A2(
			_elm_lang$core$Basics_ops['++'],
			'0',
			_elm_lang$core$Basics$toString(number)) : _elm_lang$core$Basics$toString(number);
	};
	var parser = function (number) {
		return A2(
			_elm_tools$parser$Parser$andThen,
			_elm_lang$core$Basics$always(
				_elm_tools$parser$Parser$succeed(number)),
			_elm_tools$parser$Parser$symbol(
				pad(number)));
	};
	return _elm_tools$parser$Parser$oneOf(
		A2(_elm_lang$core$List$map, parser, numbers));
};
var _abadi199$dateparser$InternalDate_Parser$paddedHour = _abadi199$dateparser$InternalDate_Parser$paddedInts(
	A2(_elm_lang$core$List$range, 0, 12));
var _abadi199$dateparser$InternalDate_Parser$paddedMinute = _abadi199$dateparser$InternalDate_Parser$paddedInts(
	A2(_elm_lang$core$List$range, 0, 59));
var _abadi199$dateparser$InternalDate_Parser$timeZoneOffset = F2(
	function (useColon, internalDate) {
		var updateInternalDate = F2(
			function (sign, _p2) {
				var _p3 = _p2;
				return _elm_tools$parser$Parser$succeed(
					_elm_lang$core$Native_Utils.update(
						internalDate,
						{timeZoneOffset: sign * ((_p3._0 * 60) + _p3._1)}));
			});
		var parser = useColon ? A2(
			_elm_tools$parser$Parser_ops['|='],
			A2(
				_elm_tools$parser$Parser_ops['|.'],
				A2(
					_elm_tools$parser$Parser_ops['|='],
					_elm_tools$parser$Parser$succeed(
						F2(
							function (v0, v1) {
								return {ctor: '_Tuple2', _0: v0, _1: v1};
							})),
					_abadi199$dateparser$InternalDate_Parser$paddedHour),
				_elm_tools$parser$Parser$symbol(':')),
			_abadi199$dateparser$InternalDate_Parser$paddedMinute) : A2(
			_elm_tools$parser$Parser_ops['|='],
			A2(
				_elm_tools$parser$Parser_ops['|='],
				_elm_tools$parser$Parser$succeed(
					F2(
						function (v0, v1) {
							return {ctor: '_Tuple2', _0: v0, _1: v1};
						})),
				_abadi199$dateparser$InternalDate_Parser$paddedHour),
			_abadi199$dateparser$InternalDate_Parser$paddedMinute);
		return _elm_tools$parser$Parser$oneOf(
			{
				ctor: '::',
				_0: A2(
					_elm_tools$parser$Parser$andThen,
					updateInternalDate(-1),
					A2(
						_elm_tools$parser$Parser$delayedCommit,
						_elm_tools$parser$Parser$symbol('+'),
						parser)),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_tools$parser$Parser$andThen,
						updateInternalDate(1),
						A2(
							_elm_tools$parser$Parser$delayedCommit,
							_elm_tools$parser$Parser$symbol('-'),
							parser)),
					_1: {ctor: '[]'}
				}
			});
	});
var _abadi199$dateparser$InternalDate_Parser$millisecond = function (internalDate) {
	var firstDigit = function (ms) {
		return (_elm_lang$core$Native_Utils.cmp(ms, 1000) < 0) ? _elm_tools$parser$Parser$succeed(
			_elm_lang$core$Native_Utils.update(
				internalDate,
				{millisecond: ms})) : _elm_tools$parser$Parser$fail('not millisecond');
	};
	var secondDigit = function (ms) {
		return (_elm_lang$core$Native_Utils.cmp(ms, 100) < 0) ? _elm_tools$parser$Parser$succeed(
			_elm_lang$core$Native_Utils.update(
				internalDate,
				{millisecond: ms})) : _elm_tools$parser$Parser$fail('not millisecond');
	};
	var thirdDigit = function (ms) {
		return (_elm_lang$core$Native_Utils.cmp(ms, 10) < 0) ? _elm_tools$parser$Parser$succeed(
			_elm_lang$core$Native_Utils.update(
				internalDate,
				{millisecond: ms})) : _elm_tools$parser$Parser$fail('not millisecond');
	};
	return _elm_tools$parser$Parser$oneOf(
		{
			ctor: '::',
			_0: A2(
				_elm_tools$parser$Parser$andThen,
				thirdDigit,
				A2(
					_elm_tools$parser$Parser$delayedCommit,
					_elm_tools$parser$Parser$symbol('00'),
					_elm_tools$parser$Parser$int)),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_tools$parser$Parser$andThen,
					secondDigit,
					A2(
						_elm_tools$parser$Parser$delayedCommit,
						_elm_tools$parser$Parser$symbol('0'),
						_elm_tools$parser$Parser$int)),
				_1: {
					ctor: '::',
					_0: A2(_elm_tools$parser$Parser$andThen, firstDigit, _elm_tools$parser$Parser$int),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _abadi199$dateparser$InternalDate_Parser$paddedInt = F3(
	function (pad, f, number) {
		var numberStr = _elm_lang$core$Basics$toString(number);
		var paddedNumber = _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$length(numberStr),
			1) ? A2(_elm_lang$core$Basics_ops['++'], pad, numberStr) : numberStr;
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(numberStr),
			2) > 0) ? _elm_tools$parser$Parser$fail('Number is more than 2 digit') : A2(
			_elm_tools$parser$Parser$andThen,
			_elm_lang$core$Basics$always(
				_elm_tools$parser$Parser$succeed(
					f(number))),
			_elm_tools$parser$Parser$symbol(paddedNumber));
	});
var _abadi199$dateparser$InternalDate_Parser$number = F2(
	function (f, number) {
		return A2(
			_elm_tools$parser$Parser$andThen,
			_elm_lang$core$Basics$always(
				_elm_tools$parser$Parser$succeed(
					f(number))),
			_elm_tools$parser$Parser$symbol(
				_elm_lang$core$Basics$toString(number)));
	});
var _abadi199$dateparser$InternalDate_Parser$dateSuffix = F3(
	function (usePadding, config, internalDate) {
		var parser = function (date) {
			return A2(
				_elm_tools$parser$Parser$andThen,
				function (_p4) {
					return _elm_tools$parser$Parser$succeed(
						_elm_lang$core$Native_Utils.update(
							internalDate,
							{date: date}));
				},
				_elm_tools$parser$Parser$symbol(
					A2(config.i18n.dayOfMonthWithSuffix, usePadding, date)));
		};
		return _elm_tools$parser$Parser$oneOf(
			A2(
				_elm_lang$core$List$map,
				parser,
				A2(_elm_lang$core$List$range, 1, 31)));
	});
var _abadi199$dateparser$InternalDate_Parser$datePadded = F2(
	function (pad, internalDate) {
		return A2(
			_elm_tools$parser$Parser$inContext,
			'DateZeroPadded',
			_elm_tools$parser$Parser$oneOf(
				A2(
					_elm_lang$core$List$map,
					A2(
						_abadi199$dateparser$InternalDate_Parser$paddedInt,
						pad,
						function (number) {
							return _elm_lang$core$Native_Utils.update(
								internalDate,
								{date: number});
						}),
					A2(_elm_lang$core$List$range, 1, 31))));
	});
var _abadi199$dateparser$InternalDate_Parser$date = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'date',
		A2(
			_elm_tools$parser$Parser$andThen,
			function (number) {
				return (_elm_lang$core$Native_Utils.cmp(number, 31) < 1) ? _elm_tools$parser$Parser$succeed(
					_elm_lang$core$Native_Utils.update(
						internalDate,
						{date: number})) : _elm_tools$parser$Parser$fail('not a valid date');
			},
			_elm_tools$parser$Parser$int));
};
var _abadi199$dateparser$InternalDate_Parser$dateSpacePadded = _abadi199$dateparser$InternalDate_Parser$datePadded(' ');
var _abadi199$dateparser$InternalDate_Parser$dateZeroPadded = _abadi199$dateparser$InternalDate_Parser$datePadded('0');
var _abadi199$dateparser$InternalDate_Parser$dayNameParser = F3(
	function (config, internalDate, day) {
		var getDayName = config.isFullName ? config.dateConfig.i18n.dayName : config.dateConfig.i18n.dayShort;
		return A2(
			_elm_tools$parser$Parser$andThen,
			_elm_lang$core$Basics$always(
				_elm_tools$parser$Parser$succeed(internalDate)),
			_elm_tools$parser$Parser$symbol(
				A2(
					_abadi199$dateparser$Utilities$toUpper,
					config.isUpper,
					getDayName(day))));
	});
var _abadi199$dateparser$InternalDate_Parser$dayOfWeek = F2(
	function (config, internalDate) {
		return A2(
			_elm_tools$parser$Parser$inContext,
			'DayOfWeek',
			_elm_tools$parser$Parser$oneOf(
				A2(
					_elm_lang$core$List$map,
					A2(_abadi199$dateparser$InternalDate_Parser$dayNameParser, config, internalDate),
					{
						ctor: '::',
						_0: _elm_lang$core$Date$Sun,
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Date$Mon,
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Date$Tue,
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Date$Wed,
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Date$Thu,
										_1: {
											ctor: '::',
											_0: _elm_lang$core$Date$Fri,
											_1: {
												ctor: '::',
												_0: _elm_lang$core$Date$Sat,
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					})));
	});
var _abadi199$dateparser$InternalDate_Parser$monthNameParser = F3(
	function (config, internalDate, month) {
		var getMonthName = config.isFullName ? config.dateConfig.i18n.monthName : config.dateConfig.i18n.monthShort;
		return A2(
			_elm_tools$parser$Parser$andThen,
			_elm_lang$core$Basics$always(
				_elm_tools$parser$Parser$succeed(
					_elm_lang$core$Native_Utils.update(
						internalDate,
						{
							month: _abadi199$dateparser$Utilities$monthToInt(month)
						}))),
			_elm_tools$parser$Parser$symbol(
				A2(
					_abadi199$dateparser$Utilities$toUpper,
					config.isUpper,
					getMonthName(month))));
	});
var _abadi199$dateparser$InternalDate_Parser$monthName = F2(
	function (config, internalDate) {
		return A2(
			_elm_tools$parser$Parser$inContext,
			'MonthName',
			_elm_tools$parser$Parser$oneOf(
				A2(
					_elm_lang$core$List$map,
					A2(_abadi199$dateparser$InternalDate_Parser$monthNameParser, config, internalDate),
					{
						ctor: '::',
						_0: _elm_lang$core$Date$Jan,
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Date$Feb,
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Date$Mar,
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Date$Apr,
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Date$May,
										_1: {
											ctor: '::',
											_0: _elm_lang$core$Date$Jun,
											_1: {
												ctor: '::',
												_0: _elm_lang$core$Date$Jul,
												_1: {
													ctor: '::',
													_0: _elm_lang$core$Date$Aug,
													_1: {
														ctor: '::',
														_0: _elm_lang$core$Date$Sep,
														_1: {
															ctor: '::',
															_0: _elm_lang$core$Date$Oct,
															_1: {
																ctor: '::',
																_0: _elm_lang$core$Date$Nov,
																_1: {
																	ctor: '::',
																	_0: _elm_lang$core$Date$Dec,
																	_1: {ctor: '[]'}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					})));
	});
var _abadi199$dateparser$InternalDate_Parser$monthPadded = F2(
	function (pad, internalDate) {
		return _elm_tools$parser$Parser$oneOf(
			A2(
				_elm_lang$core$List$map,
				A2(
					_abadi199$dateparser$InternalDate_Parser$paddedInt,
					pad,
					function (number) {
						return _elm_lang$core$Native_Utils.update(
							internalDate,
							{month: number});
					}),
				A2(_elm_lang$core$List$range, 1, 12)));
	});
var _abadi199$dateparser$InternalDate_Parser$month = function (internalDate) {
	return _elm_tools$parser$Parser$oneOf(
		A2(
			_elm_lang$core$List$map,
			_abadi199$dateparser$InternalDate_Parser$number(
				function ($int) {
					return _elm_lang$core$Native_Utils.update(
						internalDate,
						{month: $int});
				}),
			A2(_elm_lang$core$List$range, 1, 12)));
};
var _abadi199$dateparser$InternalDate_Parser$monthSpacePadded = function (_p5) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'MonthSpacePadded',
		A2(_abadi199$dateparser$InternalDate_Parser$monthPadded, ' ', _p5));
};
var _abadi199$dateparser$InternalDate_Parser$monthZeroPadded = function (_p6) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'MonthZeroPadded',
		A2(_abadi199$dateparser$InternalDate_Parser$monthPadded, '0', _p6));
};
var _abadi199$dateparser$InternalDate_Parser$hour24Padded = F2(
	function (pad, internalDate) {
		return _elm_tools$parser$Parser$oneOf(
			A2(
				_elm_lang$core$List$map,
				A2(
					_abadi199$dateparser$InternalDate_Parser$paddedInt,
					pad,
					function (number) {
						return _elm_lang$core$Native_Utils.update(
							internalDate,
							{hour: number});
					}),
				A2(_elm_lang$core$List$range, 0, 23)));
	});
var _abadi199$dateparser$InternalDate_Parser$hour24 = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'Hour24',
		A2(
			_elm_tools$parser$Parser$andThen,
			function (hour) {
				return (_elm_lang$core$Native_Utils.cmp(hour, 25) < 0) ? _elm_tools$parser$Parser$succeed(
					_elm_lang$core$Native_Utils.update(
						internalDate,
						{hour: hour})) : _elm_tools$parser$Parser$fail('not a valid 24 hour');
			},
			_elm_tools$parser$Parser$int));
};
var _abadi199$dateparser$InternalDate_Parser$hour24SpacePadded = function (_p7) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'Hour24SpacePadded',
		A2(_abadi199$dateparser$InternalDate_Parser$hour24Padded, ' ', _p7));
};
var _abadi199$dateparser$InternalDate_Parser$hour24ZeroPadded = function (_p8) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'Hour24ZeroPadded',
		A2(_abadi199$dateparser$InternalDate_Parser$hour24Padded, '0', _p8));
};
var _abadi199$dateparser$InternalDate_Parser$hour12Padded = F2(
	function (pad, internalDate) {
		return _elm_tools$parser$Parser$oneOf(
			A2(
				_elm_lang$core$List$map,
				A2(
					_abadi199$dateparser$InternalDate_Parser$paddedInt,
					pad,
					function (number) {
						return _elm_lang$core$Native_Utils.update(
							internalDate,
							{hour: number});
					}),
				A2(_elm_lang$core$List$range, 1, 12)));
	});
var _abadi199$dateparser$InternalDate_Parser$hour12SpacePadded = function (_p9) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'Hour12SpacePadded',
		A2(_abadi199$dateparser$InternalDate_Parser$hour12Padded, ' ', _p9));
};
var _abadi199$dateparser$InternalDate_Parser$hour12ZeroPadded = function (_p10) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'Hour12ZeroPadded',
		A2(_abadi199$dateparser$InternalDate_Parser$hour12Padded, '0', _p10));
};
var _abadi199$dateparser$InternalDate_Parser$hour12 = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'Hour12',
		A2(
			_elm_tools$parser$Parser$andThen,
			function (hour) {
				return (_elm_lang$core$Native_Utils.cmp(hour, 13) < 0) ? _elm_tools$parser$Parser$succeed(
					_elm_lang$core$Native_Utils.update(
						internalDate,
						{hour: hour})) : _elm_tools$parser$Parser$fail('not a valid 12 hour');
			},
			_elm_tools$parser$Parser$int));
};
var _abadi199$dateparser$InternalDate_Parser$minutePadded = F2(
	function (pad, internalDate) {
		return _elm_tools$parser$Parser$oneOf(
			A2(
				_elm_lang$core$List$map,
				A2(
					_abadi199$dateparser$InternalDate_Parser$paddedInt,
					pad,
					function (number) {
						return _elm_lang$core$Native_Utils.update(
							internalDate,
							{minute: number});
					}),
				A2(_elm_lang$core$List$range, 0, 59)));
	});
var _abadi199$dateparser$InternalDate_Parser$minuteZeroPadded = function (_p11) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'MinuteZeroPadded',
		A2(_abadi199$dateparser$InternalDate_Parser$minutePadded, '0', _p11));
};
var _abadi199$dateparser$InternalDate_Parser$secondPadded = F2(
	function (pad, internalDate) {
		return _elm_tools$parser$Parser$oneOf(
			A2(
				_elm_lang$core$List$map,
				A2(
					_abadi199$dateparser$InternalDate_Parser$paddedInt,
					pad,
					function (number) {
						return _elm_lang$core$Native_Utils.update(
							internalDate,
							{second: number});
					}),
				A2(_elm_lang$core$List$range, 0, 59)));
	});
var _abadi199$dateparser$InternalDate_Parser$secondZeroPadded = function (_p12) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'SecondZeroPadded',
		A2(_abadi199$dateparser$InternalDate_Parser$secondPadded, '0', _p12));
};
var _abadi199$dateparser$InternalDate_Parser$year = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$andThen,
		function (year) {
			return _elm_tools$parser$Parser$succeed(
				_elm_lang$core$Native_Utils.update(
					internalDate,
					{year: year}));
		},
		A2(
			_elm_tools$parser$Parser$inContext,
			'Year',
			A2(
				_elm_tools$parser$Parser_ops['|='],
				_elm_tools$parser$Parser$succeed(_elm_lang$core$Basics$identity),
				_elm_tools$parser$Parser$int)));
};
var _abadi199$dateparser$InternalDate_Parser$ampm = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'ampm',
		_elm_tools$parser$Parser$oneOf(
			{
				ctor: '::',
				_0: A2(
					_elm_tools$parser$Parser$andThen,
					function (_p13) {
						return _elm_tools$parser$Parser$succeed(
							_elm_lang$core$Native_Utils.update(
								internalDate,
								{
									ampm: _elm_lang$core$Maybe$Just(_abadi199$dateparser$InternalDate_Type$AM)
								}));
					},
					_elm_tools$parser$Parser$symbol('am')),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_tools$parser$Parser$andThen,
						function (_p14) {
							return _elm_tools$parser$Parser$succeed(
								_elm_lang$core$Native_Utils.update(
									internalDate,
									{
										ampm: _elm_lang$core$Maybe$Just(_abadi199$dateparser$InternalDate_Type$PM)
									}));
						},
						_elm_tools$parser$Parser$symbol('pm')),
					_1: {ctor: '[]'}
				}
			}));
};
var _abadi199$dateparser$InternalDate_Parser$aMPM = function (internalDate) {
	return A2(
		_elm_tools$parser$Parser$inContext,
		'AMPM',
		_elm_tools$parser$Parser$oneOf(
			{
				ctor: '::',
				_0: A2(
					_elm_tools$parser$Parser$andThen,
					function (_p15) {
						return _elm_tools$parser$Parser$succeed(
							_elm_lang$core$Native_Utils.update(
								internalDate,
								{
									ampm: _elm_lang$core$Maybe$Just(_abadi199$dateparser$InternalDate_Type$AM)
								}));
					},
					_elm_tools$parser$Parser$symbol('AM')),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_tools$parser$Parser$andThen,
						function (_p16) {
							return _elm_tools$parser$Parser$succeed(
								_elm_lang$core$Native_Utils.update(
									internalDate,
									{
										ampm: _elm_lang$core$Maybe$Just(_abadi199$dateparser$InternalDate_Type$PM)
									}));
						},
						_elm_tools$parser$Parser$symbol('PM')),
					_1: {ctor: '[]'}
				}
			}));
};
var _abadi199$dateparser$InternalDate_Parser$fromPattern = F2(
	function (config, pattern) {
		var _p17 = pattern;
		switch (_p17.ctor) {
			case 'Year':
				return _abadi199$dateparser$InternalDate_Parser$year;
			case 'MonthZeroPadded':
				return _abadi199$dateparser$InternalDate_Parser$monthZeroPadded;
			case 'MonthSpacePadded':
				return _abadi199$dateparser$InternalDate_Parser$monthSpacePadded;
			case 'Month':
				return _abadi199$dateparser$InternalDate_Parser$month;
			case 'MonthFullName':
				return _abadi199$dateparser$InternalDate_Parser$monthName(
					{isFullName: true, isUpper: false, dateConfig: config});
			case 'MonthUpperFullName':
				return _abadi199$dateparser$InternalDate_Parser$monthName(
					{isFullName: true, isUpper: true, dateConfig: config});
			case 'MonthAbbrvName':
				return _abadi199$dateparser$InternalDate_Parser$monthName(
					{isFullName: false, isUpper: false, dateConfig: config});
			case 'MonthUpperAbbrvName':
				return _abadi199$dateparser$InternalDate_Parser$monthName(
					{isFullName: false, isUpper: true, dateConfig: config});
			case 'DateZeroPadded':
				return _abadi199$dateparser$InternalDate_Parser$dateZeroPadded;
			case 'DateSpacePadded':
				return _abadi199$dateparser$InternalDate_Parser$dateSpacePadded;
			case 'Date':
				return _abadi199$dateparser$InternalDate_Parser$date;
			case 'DateSuffix':
				return A2(_abadi199$dateparser$InternalDate_Parser$dateSuffix, false, config);
			case 'DateSpacePaddedSuffix':
				return A2(_abadi199$dateparser$InternalDate_Parser$dateSuffix, true, config);
			case 'DayOfWeekFullName':
				return _abadi199$dateparser$InternalDate_Parser$dayOfWeek(
					{isFullName: true, isUpper: false, dateConfig: config});
			case 'DayOfWeekUpperFullName':
				return _abadi199$dateparser$InternalDate_Parser$dayOfWeek(
					{isFullName: true, isUpper: true, dateConfig: config});
			case 'DayOfWeekAbbrvName':
				return _abadi199$dateparser$InternalDate_Parser$dayOfWeek(
					{isFullName: false, isUpper: false, dateConfig: config});
			case 'DayOfWeekUpperAbbrvName':
				return _abadi199$dateparser$InternalDate_Parser$dayOfWeek(
					{isFullName: false, isUpper: true, dateConfig: config});
			case 'Hour24ZeroPadded':
				return _abadi199$dateparser$InternalDate_Parser$hour24ZeroPadded;
			case 'Hour24SpacePadded':
				return _abadi199$dateparser$InternalDate_Parser$hour24SpacePadded;
			case 'Hour24':
				return _abadi199$dateparser$InternalDate_Parser$hour24;
			case 'Hour12ZeroPadded':
				return _abadi199$dateparser$InternalDate_Parser$hour12ZeroPadded;
			case 'Hour12SpacePadded':
				return _abadi199$dateparser$InternalDate_Parser$hour12SpacePadded;
			case 'Hour12':
				return _abadi199$dateparser$InternalDate_Parser$hour12;
			case 'AMPM':
				return _abadi199$dateparser$InternalDate_Parser$aMPM;
			case 'Ampm':
				return _abadi199$dateparser$InternalDate_Parser$ampm;
			case 'MinuteZeroPadded':
				return _abadi199$dateparser$InternalDate_Parser$minuteZeroPadded;
			case 'SecondZeroPadded':
				return _abadi199$dateparser$InternalDate_Parser$secondZeroPadded;
			case 'Millisecond':
				return _abadi199$dateparser$InternalDate_Parser$millisecond;
			case 'TimeZoneOffset':
				return _abadi199$dateparser$InternalDate_Parser$timeZoneOffset(false);
			case 'TimeZoneOffsetColon':
				return _abadi199$dateparser$InternalDate_Parser$timeZoneOffset(true);
			case 'Whitespace':
				return _abadi199$dateparser$InternalDate_Parser$whitespace;
			default:
				return _abadi199$dateparser$InternalDate_Parser$other(_p17._0);
		}
	});
var _abadi199$dateparser$InternalDate_Parser$ParserConfig = F3(
	function (a, b, c) {
		return {isUpper: a, isFullName: b, dateConfig: c};
	});

var _abadi199$dateparser$InternalDate$toHour = F2(
	function (ampm, hour) {
		var _p0 = {ctor: '_Tuple2', _0: ampm, _1: hour};
		if (_p0._0.ctor === 'AM') {
			if (_p0._1 === 12) {
				return 0;
			} else {
				return hour;
			}
		} else {
			if (_p0._1 === 12) {
				return 12;
			} else {
				return hour + 12;
			}
		}
	});
var _abadi199$dateparser$InternalDate$toHour24 = function (internalDate) {
	var hour = internalDate.hour;
	var _p1 = internalDate.ampm;
	if (_p1.ctor === 'Nothing') {
		return _elm_lang$core$Result$Ok(hour);
	} else {
		return ((_elm_lang$core$Native_Utils.cmp(hour, 0) > 0) && (_elm_lang$core$Native_Utils.cmp(hour, 12) < 1)) ? _elm_lang$core$Result$Ok(
			A2(_abadi199$dateparser$InternalDate$toHour, _p1._0, hour)) : _elm_lang$core$Result$Err('Invalid hour');
	}
};
var _abadi199$dateparser$InternalDate$toDate = function (internalDate) {
	var hourResult = _abadi199$dateparser$InternalDate$toHour24(internalDate);
	var monthResult = _abadi199$dateparser$Utilities$monthFromInt(internalDate.month);
	return A2(
		_elm_lang$core$Result$mapError,
		_abadi199$dateparser$Error$DateError,
		A3(
			_elm_lang$core$Result$map2,
			F2(
				function (month, hour) {
					return A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, internalDate.year, month, internalDate.date, hour, internalDate.minute, internalDate.second, internalDate.millisecond);
				}),
			monthResult,
			hourResult));
};
var _abadi199$dateparser$InternalDate$parse = F3(
	function (str, config, patterns) {
		var parser = A3(
			_elm_lang$core$List$foldl,
			F2(
				function (a, b) {
					return A2(_elm_tools$parser$Parser$andThen, a, b);
				}),
			_elm_tools$parser$Parser$succeed(_abadi199$dateparser$InternalDate_Type$emptyDate),
			A2(
				_elm_lang$core$List$map,
				_abadi199$dateparser$InternalDate_Parser$fromPattern(config),
				patterns));
		return A2(
			_elm_lang$core$Result$mapError,
			_abadi199$dateparser$Error$ParsingError,
			A2(_elm_tools$parser$Parser$run, parser, str));
	});

var _abadi199$dateparser$DateParser$parse = F3(
	function (config, pattern, date) {
		return A2(
			_elm_lang$core$Result$andThen,
			_abadi199$dateparser$InternalDate$toDate,
			A2(
				_elm_lang$core$Result$andThen,
				A2(_abadi199$dateparser$InternalDate$parse, date, config),
				_abadi199$dateparser$Pattern$parse(pattern)));
	});

var _abadi199$datetimepicker$DateTimePicker_Formatter$timePattern = '%I:%M %p';
var _abadi199$datetimepicker$DateTimePicker_Formatter$timeFormatter = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$timePattern);
var _abadi199$datetimepicker$DateTimePicker_Formatter$dateTimePattern = '%m/%d/%Y %I:%M %p';
var _abadi199$datetimepicker$DateTimePicker_Formatter$dateTimeFormatter = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$dateTimePattern);
var _abadi199$datetimepicker$DateTimePicker_Formatter$footerPattern = '%A, %B %d, %Y';
var _abadi199$datetimepicker$DateTimePicker_Formatter$footerFormatter = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$footerPattern);
var _abadi199$datetimepicker$DateTimePicker_Formatter$datePattern = '%m/%d/%Y';
var _abadi199$datetimepicker$DateTimePicker_Formatter$dateFormatter = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$datePattern);
var _abadi199$datetimepicker$DateTimePicker_Formatter$titlePattern = '%B %Y';
var _abadi199$datetimepicker$DateTimePicker_Formatter$titleFormatter = A2(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$titlePattern);

var _abadi199$datetimepicker$DateTimePicker_Internal$Time = F3(
	function (a, b, c) {
		return {hour: a, minute: b, amPm: c};
	});
var _abadi199$datetimepicker$DateTimePicker_Internal$InternalState = function (a) {
	return {ctor: 'InternalState', _0: a};
};
var _abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator = {ctor: 'AMPMIndicator'};
var _abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator = {ctor: 'MinuteIndicator'};
var _abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator = {ctor: 'HourIndicator'};
var _abadi199$datetimepicker$DateTimePicker_Internal$initialState = _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
	{
		inputFocused: false,
		forceClose: false,
		event: '',
		today: _elm_lang$core$Maybe$Nothing,
		titleDate: _elm_lang$core$Maybe$Nothing,
		date: _elm_lang$core$Maybe$Nothing,
		time: A3(_abadi199$datetimepicker$DateTimePicker_Internal$Time, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing),
		hourPickerStart: 1,
		minutePickerStart: 0,
		currentAngle: _elm_lang$core$Maybe$Nothing,
		activeTimeIndicator: _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator)
	});
var _abadi199$datetimepicker$DateTimePicker_Internal$initialStateWithToday = function (today) {
	return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
		{
			inputFocused: false,
			forceClose: false,
			event: '',
			today: _elm_lang$core$Maybe$Just(today),
			titleDate: _elm_lang$core$Maybe$Just(
				_rluiten$elm_date_extra$Date_Extra_Core$toFirstOfMonth(today)),
			date: _elm_lang$core$Maybe$Nothing,
			time: A3(_abadi199$datetimepicker$DateTimePicker_Internal$Time, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing),
			hourPickerStart: 1,
			minutePickerStart: 0,
			currentAngle: _elm_lang$core$Maybe$Nothing,
			activeTimeIndicator: _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator)
		});
};

var _abadi199$datetimepicker$DateTimePicker_Config$defaultNamespace = 'elm-input-datepicker';
var _abadi199$datetimepicker$DateTimePicker_Config$defaultClass = function (classes) {
	return _elm_lang$html$Html_Attributes$classList(
		A2(
			_elm_lang$core$List$map,
			function ($class) {
				return {
					ctor: '_Tuple2',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						_abadi199$datetimepicker$DateTimePicker_Config$defaultNamespace,
						_elm_lang$core$Basics$toString($class)),
					_1: true
				};
			},
			classes));
};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultNameOfDays = {sunday: 'Su', monday: 'Mo', tuesday: 'Tu', wednesday: 'We', thursday: 'Th', friday: 'Fr', saturday: 'Sa'};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultTimeInputFormat = {
	inputFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$timeFormatter,
	inputParser: function (input) {
		return _elm_lang$core$Result$toMaybe(
			A3(_abadi199$dateparser$DateParser$parse, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$timePattern, input));
	}
};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultDateTimeInputFormat = {
	inputFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$dateTimeFormatter,
	inputParser: function (input) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_elm_lang$core$Result$toMaybe(
				_elm_lang$core$Date$fromString(input)),
			A2(
				_elm_lang$core$Maybe$map,
				_elm_lang$core$Maybe$Just,
				_elm_lang$core$Result$toMaybe(
					A3(_abadi199$dateparser$DateParser$parse, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$dateTimePattern, input))));
	}
};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultDateInputFormat = {
	inputFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$dateFormatter,
	inputParser: function (input) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_elm_lang$core$Result$toMaybe(
				_elm_lang$core$Date$fromString(input)),
			A2(
				_elm_lang$core$Maybe$map,
				_elm_lang$core$Maybe$Just,
				_elm_lang$core$Result$toMaybe(
					A3(_abadi199$dateparser$DateParser$parse, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, _abadi199$datetimepicker$DateTimePicker_Formatter$datePattern, input))));
	}
};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultDateTimeI18n = {titleFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$titleFormatter, footerFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$footerFormatter, timeTitleFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$timeFormatter, inputFormat: _abadi199$datetimepicker$DateTimePicker_Config$defaultDateTimeInputFormat};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultTimeI18n = {titleFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$titleFormatter, footerFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$footerFormatter, timeTitleFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$timeFormatter, inputFormat: _abadi199$datetimepicker$DateTimePicker_Config$defaultTimeInputFormat};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultDateI18n = {titleFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$titleFormatter, footerFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$footerFormatter, timeTitleFormatter: _abadi199$datetimepicker$DateTimePicker_Formatter$timeFormatter, inputFormat: _abadi199$datetimepicker$DateTimePicker_Config$defaultDateInputFormat};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultDatePickerConfig = function (onChange) {
	return {
		onChange: onChange,
		autoClose: true,
		nameOfDays: _abadi199$datetimepicker$DateTimePicker_Config$defaultNameOfDays,
		firstDayOfWeek: _elm_lang$core$Date$Sun,
		allowYearNavigation: true,
		i18n: _abadi199$datetimepicker$DateTimePicker_Config$defaultDateI18n,
		usePicker: true,
		attributes: {ctor: '[]'},
		$class: _abadi199$datetimepicker$DateTimePicker_Config$defaultClass
	};
};
var _abadi199$datetimepicker$DateTimePicker_Config$I18n = F4(
	function (a, b, c, d) {
		return {titleFormatter: a, footerFormatter: b, timeTitleFormatter: c, inputFormat: d};
	});
var _abadi199$datetimepicker$DateTimePicker_Config$InputFormat = F2(
	function (a, b) {
		return {inputFormatter: a, inputParser: b};
	});
var _abadi199$datetimepicker$DateTimePicker_Config$TimePickerConfig = function (a) {
	return {timePickerType: a};
};
var _abadi199$datetimepicker$DateTimePicker_Config$NameOfDays = F7(
	function (a, b, c, d, e, f, g) {
		return {sunday: a, monday: b, tuesday: c, wednesday: d, thursday: e, friday: f, saturday: g};
	});
var _abadi199$datetimepicker$DateTimePicker_Config$TimeType = function (a) {
	return {ctor: 'TimeType', _0: a};
};
var _abadi199$datetimepicker$DateTimePicker_Config$DateTimeType = function (a) {
	return {ctor: 'DateTimeType', _0: a};
};
var _abadi199$datetimepicker$DateTimePicker_Config$DateType = function (a) {
	return {ctor: 'DateType', _0: a};
};
var _abadi199$datetimepicker$DateTimePicker_Config$Analog = {ctor: 'Analog'};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultTimePickerConfig = function (onChange) {
	return {
		onChange: onChange,
		autoClose: false,
		timePickerType: _abadi199$datetimepicker$DateTimePicker_Config$Analog,
		i18n: _abadi199$datetimepicker$DateTimePicker_Config$defaultTimeI18n,
		usePicker: true,
		attributes: {ctor: '[]'},
		$class: _abadi199$datetimepicker$DateTimePicker_Config$defaultClass
	};
};
var _abadi199$datetimepicker$DateTimePicker_Config$defaultDateTimePickerConfig = function (onChange) {
	return {
		onChange: onChange,
		autoClose: false,
		nameOfDays: _abadi199$datetimepicker$DateTimePicker_Config$defaultNameOfDays,
		firstDayOfWeek: _elm_lang$core$Date$Sun,
		timePickerType: _abadi199$datetimepicker$DateTimePicker_Config$Analog,
		allowYearNavigation: true,
		i18n: _abadi199$datetimepicker$DateTimePicker_Config$defaultDateTimeI18n,
		usePicker: true,
		attributes: {ctor: '[]'},
		$class: _abadi199$datetimepicker$DateTimePicker_Config$defaultClass
	};
};
var _abadi199$datetimepicker$DateTimePicker_Config$Digital = {ctor: 'Digital'};

var _CareerPlug$ats$Library_Date$withCoreParser = function (orig) {
	var i18n = orig.i18n;
	var format = i18n.inputFormat;
	var parser = function (str) {
		return _elm_lang$core$Result$toMaybe(
			_elm_lang$core$Date$fromString(str));
	};
	var format_ = _elm_lang$core$Native_Utils.update(
		format,
		{inputParser: parser});
	var i18n_ = _elm_lang$core$Native_Utils.update(
		i18n,
		{inputFormat: format_});
	return _elm_lang$core$Native_Utils.update(
		orig,
		{i18n: i18n_});
};

var _elm_lang$mouse$Mouse_ops = _elm_lang$mouse$Mouse_ops || {};
_elm_lang$mouse$Mouse_ops['&>'] = F2(
	function (t1, t2) {
		return A2(
			_elm_lang$core$Task$andThen,
			function (_p0) {
				return t2;
			},
			t1);
	});
var _elm_lang$mouse$Mouse$onSelfMsg = F3(
	function (router, _p1, state) {
		var _p2 = _p1;
		var _p3 = A2(_elm_lang$core$Dict$get, _p2.category, state);
		if (_p3.ctor === 'Nothing') {
			return _elm_lang$core$Task$succeed(state);
		} else {
			var send = function (tagger) {
				return A2(
					_elm_lang$core$Platform$sendToApp,
					router,
					tagger(_p2.position));
			};
			return A2(
				_elm_lang$mouse$Mouse_ops['&>'],
				_elm_lang$core$Task$sequence(
					A2(_elm_lang$core$List$map, send, _p3._0.taggers)),
				_elm_lang$core$Task$succeed(state));
		}
	});
var _elm_lang$mouse$Mouse$init = _elm_lang$core$Task$succeed(_elm_lang$core$Dict$empty);
var _elm_lang$mouse$Mouse$categorizeHelpHelp = F2(
	function (value, maybeValues) {
		var _p4 = maybeValues;
		if (_p4.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Just(
				{
					ctor: '::',
					_0: value,
					_1: {ctor: '[]'}
				});
		} else {
			return _elm_lang$core$Maybe$Just(
				{ctor: '::', _0: value, _1: _p4._0});
		}
	});
var _elm_lang$mouse$Mouse$categorizeHelp = F2(
	function (subs, subDict) {
		categorizeHelp:
		while (true) {
			var _p5 = subs;
			if (_p5.ctor === '[]') {
				return subDict;
			} else {
				var _v4 = _p5._1,
					_v5 = A3(
					_elm_lang$core$Dict$update,
					_p5._0._0,
					_elm_lang$mouse$Mouse$categorizeHelpHelp(_p5._0._1),
					subDict);
				subs = _v4;
				subDict = _v5;
				continue categorizeHelp;
			}
		}
	});
var _elm_lang$mouse$Mouse$categorize = function (subs) {
	return A2(_elm_lang$mouse$Mouse$categorizeHelp, subs, _elm_lang$core$Dict$empty);
};
var _elm_lang$mouse$Mouse$subscription = _elm_lang$core$Native_Platform.leaf('Mouse');
var _elm_lang$mouse$Mouse$Position = F2(
	function (a, b) {
		return {x: a, y: b};
	});
var _elm_lang$mouse$Mouse$position = A3(
	_elm_lang$core$Json_Decode$map2,
	_elm_lang$mouse$Mouse$Position,
	A2(_elm_lang$core$Json_Decode$field, 'pageX', _elm_lang$core$Json_Decode$int),
	A2(_elm_lang$core$Json_Decode$field, 'pageY', _elm_lang$core$Json_Decode$int));
var _elm_lang$mouse$Mouse$Watcher = F2(
	function (a, b) {
		return {taggers: a, pid: b};
	});
var _elm_lang$mouse$Mouse$Msg = F2(
	function (a, b) {
		return {category: a, position: b};
	});
var _elm_lang$mouse$Mouse$onEffects = F3(
	function (router, newSubs, oldState) {
		var rightStep = F3(
			function (category, taggers, task) {
				var tracker = A3(
					_elm_lang$dom$Dom_LowLevel$onDocument,
					category,
					_elm_lang$mouse$Mouse$position,
					function (_p6) {
						return A2(
							_elm_lang$core$Platform$sendToSelf,
							router,
							A2(_elm_lang$mouse$Mouse$Msg, category, _p6));
					});
				return A2(
					_elm_lang$core$Task$andThen,
					function (state) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (pid) {
								return _elm_lang$core$Task$succeed(
									A3(
										_elm_lang$core$Dict$insert,
										category,
										A2(_elm_lang$mouse$Mouse$Watcher, taggers, pid),
										state));
							},
							_elm_lang$core$Process$spawn(tracker));
					},
					task);
			});
		var bothStep = F4(
			function (category, _p7, taggers, task) {
				var _p8 = _p7;
				return A2(
					_elm_lang$core$Task$andThen,
					function (state) {
						return _elm_lang$core$Task$succeed(
							A3(
								_elm_lang$core$Dict$insert,
								category,
								A2(_elm_lang$mouse$Mouse$Watcher, taggers, _p8.pid),
								state));
					},
					task);
			});
		var leftStep = F3(
			function (category, _p9, task) {
				var _p10 = _p9;
				return A2(
					_elm_lang$mouse$Mouse_ops['&>'],
					_elm_lang$core$Process$kill(_p10.pid),
					task);
			});
		return A6(
			_elm_lang$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			oldState,
			_elm_lang$mouse$Mouse$categorize(newSubs),
			_elm_lang$core$Task$succeed(_elm_lang$core$Dict$empty));
	});
var _elm_lang$mouse$Mouse$MySub = F2(
	function (a, b) {
		return {ctor: 'MySub', _0: a, _1: b};
	});
var _elm_lang$mouse$Mouse$clicks = function (tagger) {
	return _elm_lang$mouse$Mouse$subscription(
		A2(_elm_lang$mouse$Mouse$MySub, 'click', tagger));
};
var _elm_lang$mouse$Mouse$moves = function (tagger) {
	return _elm_lang$mouse$Mouse$subscription(
		A2(_elm_lang$mouse$Mouse$MySub, 'mousemove', tagger));
};
var _elm_lang$mouse$Mouse$downs = function (tagger) {
	return _elm_lang$mouse$Mouse$subscription(
		A2(_elm_lang$mouse$Mouse$MySub, 'mousedown', tagger));
};
var _elm_lang$mouse$Mouse$ups = function (tagger) {
	return _elm_lang$mouse$Mouse$subscription(
		A2(_elm_lang$mouse$Mouse$MySub, 'mouseup', tagger));
};
var _elm_lang$mouse$Mouse$subMap = F2(
	function (func, _p11) {
		var _p12 = _p11;
		return A2(
			_elm_lang$mouse$Mouse$MySub,
			_p12._0,
			function (_p13) {
				return func(
					_p12._1(_p13));
			});
	});
_elm_lang$core$Native_Platform.effectManagers['Mouse'] = {pkg: 'elm-lang/mouse', init: _elm_lang$mouse$Mouse$init, onEffects: _elm_lang$mouse$Mouse$onEffects, onSelfMsg: _elm_lang$mouse$Mouse$onSelfMsg, tag: 'sub', subMap: _elm_lang$mouse$Mouse$subMap};

var _CareerPlug$ats$Library_Html$onChange = function (handler) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'change',
		A2(
			_elm_lang$core$Json_Decode$map,
			handler,
			A2(
				_elm_lang$core$Json_Decode$at,
				{
					ctor: '::',
					_0: 'target',
					_1: {
						ctor: '::',
						_0: 'value',
						_1: {ctor: '[]'}
					}
				},
				_elm_lang$core$Json_Decode$string)));
};
var _CareerPlug$ats$Library_Html$onKeyUp = function (handler) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'keyup',
		A2(
			_elm_lang$core$Json_Decode$map,
			handler,
			A2(
				_elm_lang$core$Json_Decode$at,
				{
					ctor: '::',
					_0: 'target',
					_1: {
						ctor: '::',
						_0: 'value',
						_1: {ctor: '[]'}
					}
				},
				_elm_lang$core$Json_Decode$string)));
};
var _CareerPlug$ats$Library_Html$onMouseDown = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'mousedown',
		A2(_elm_lang$core$Json_Decode$map, msg, _elm_lang$mouse$Mouse$position));
};
var _CareerPlug$ats$Library_Html$onClickPreventDefault = function (message) {
	var config = {stopPropagation: false, preventDefault: true};
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'click',
		config,
		_elm_lang$core$Json_Decode$succeed(message));
};

var _elm_lang$svg$Svg$map = _elm_lang$virtual_dom$VirtualDom$map;
var _elm_lang$svg$Svg$text = _elm_lang$virtual_dom$VirtualDom$text;
var _elm_lang$svg$Svg$svgNamespace = A2(
	_elm_lang$virtual_dom$VirtualDom$property,
	'namespace',
	_elm_lang$core$Json_Encode$string('http://www.w3.org/2000/svg'));
var _elm_lang$svg$Svg$node = F3(
	function (name, attributes, children) {
		return A3(
			_elm_lang$virtual_dom$VirtualDom$node,
			name,
			{ctor: '::', _0: _elm_lang$svg$Svg$svgNamespace, _1: attributes},
			children);
	});
var _elm_lang$svg$Svg$svg = _elm_lang$svg$Svg$node('svg');
var _elm_lang$svg$Svg$foreignObject = _elm_lang$svg$Svg$node('foreignObject');
var _elm_lang$svg$Svg$animate = _elm_lang$svg$Svg$node('animate');
var _elm_lang$svg$Svg$animateColor = _elm_lang$svg$Svg$node('animateColor');
var _elm_lang$svg$Svg$animateMotion = _elm_lang$svg$Svg$node('animateMotion');
var _elm_lang$svg$Svg$animateTransform = _elm_lang$svg$Svg$node('animateTransform');
var _elm_lang$svg$Svg$mpath = _elm_lang$svg$Svg$node('mpath');
var _elm_lang$svg$Svg$set = _elm_lang$svg$Svg$node('set');
var _elm_lang$svg$Svg$a = _elm_lang$svg$Svg$node('a');
var _elm_lang$svg$Svg$defs = _elm_lang$svg$Svg$node('defs');
var _elm_lang$svg$Svg$g = _elm_lang$svg$Svg$node('g');
var _elm_lang$svg$Svg$marker = _elm_lang$svg$Svg$node('marker');
var _elm_lang$svg$Svg$mask = _elm_lang$svg$Svg$node('mask');
var _elm_lang$svg$Svg$pattern = _elm_lang$svg$Svg$node('pattern');
var _elm_lang$svg$Svg$switch = _elm_lang$svg$Svg$node('switch');
var _elm_lang$svg$Svg$symbol = _elm_lang$svg$Svg$node('symbol');
var _elm_lang$svg$Svg$desc = _elm_lang$svg$Svg$node('desc');
var _elm_lang$svg$Svg$metadata = _elm_lang$svg$Svg$node('metadata');
var _elm_lang$svg$Svg$title = _elm_lang$svg$Svg$node('title');
var _elm_lang$svg$Svg$feBlend = _elm_lang$svg$Svg$node('feBlend');
var _elm_lang$svg$Svg$feColorMatrix = _elm_lang$svg$Svg$node('feColorMatrix');
var _elm_lang$svg$Svg$feComponentTransfer = _elm_lang$svg$Svg$node('feComponentTransfer');
var _elm_lang$svg$Svg$feComposite = _elm_lang$svg$Svg$node('feComposite');
var _elm_lang$svg$Svg$feConvolveMatrix = _elm_lang$svg$Svg$node('feConvolveMatrix');
var _elm_lang$svg$Svg$feDiffuseLighting = _elm_lang$svg$Svg$node('feDiffuseLighting');
var _elm_lang$svg$Svg$feDisplacementMap = _elm_lang$svg$Svg$node('feDisplacementMap');
var _elm_lang$svg$Svg$feFlood = _elm_lang$svg$Svg$node('feFlood');
var _elm_lang$svg$Svg$feFuncA = _elm_lang$svg$Svg$node('feFuncA');
var _elm_lang$svg$Svg$feFuncB = _elm_lang$svg$Svg$node('feFuncB');
var _elm_lang$svg$Svg$feFuncG = _elm_lang$svg$Svg$node('feFuncG');
var _elm_lang$svg$Svg$feFuncR = _elm_lang$svg$Svg$node('feFuncR');
var _elm_lang$svg$Svg$feGaussianBlur = _elm_lang$svg$Svg$node('feGaussianBlur');
var _elm_lang$svg$Svg$feImage = _elm_lang$svg$Svg$node('feImage');
var _elm_lang$svg$Svg$feMerge = _elm_lang$svg$Svg$node('feMerge');
var _elm_lang$svg$Svg$feMergeNode = _elm_lang$svg$Svg$node('feMergeNode');
var _elm_lang$svg$Svg$feMorphology = _elm_lang$svg$Svg$node('feMorphology');
var _elm_lang$svg$Svg$feOffset = _elm_lang$svg$Svg$node('feOffset');
var _elm_lang$svg$Svg$feSpecularLighting = _elm_lang$svg$Svg$node('feSpecularLighting');
var _elm_lang$svg$Svg$feTile = _elm_lang$svg$Svg$node('feTile');
var _elm_lang$svg$Svg$feTurbulence = _elm_lang$svg$Svg$node('feTurbulence');
var _elm_lang$svg$Svg$font = _elm_lang$svg$Svg$node('font');
var _elm_lang$svg$Svg$linearGradient = _elm_lang$svg$Svg$node('linearGradient');
var _elm_lang$svg$Svg$radialGradient = _elm_lang$svg$Svg$node('radialGradient');
var _elm_lang$svg$Svg$stop = _elm_lang$svg$Svg$node('stop');
var _elm_lang$svg$Svg$circle = _elm_lang$svg$Svg$node('circle');
var _elm_lang$svg$Svg$ellipse = _elm_lang$svg$Svg$node('ellipse');
var _elm_lang$svg$Svg$image = _elm_lang$svg$Svg$node('image');
var _elm_lang$svg$Svg$line = _elm_lang$svg$Svg$node('line');
var _elm_lang$svg$Svg$path = _elm_lang$svg$Svg$node('path');
var _elm_lang$svg$Svg$polygon = _elm_lang$svg$Svg$node('polygon');
var _elm_lang$svg$Svg$polyline = _elm_lang$svg$Svg$node('polyline');
var _elm_lang$svg$Svg$rect = _elm_lang$svg$Svg$node('rect');
var _elm_lang$svg$Svg$use = _elm_lang$svg$Svg$node('use');
var _elm_lang$svg$Svg$feDistantLight = _elm_lang$svg$Svg$node('feDistantLight');
var _elm_lang$svg$Svg$fePointLight = _elm_lang$svg$Svg$node('fePointLight');
var _elm_lang$svg$Svg$feSpotLight = _elm_lang$svg$Svg$node('feSpotLight');
var _elm_lang$svg$Svg$altGlyph = _elm_lang$svg$Svg$node('altGlyph');
var _elm_lang$svg$Svg$altGlyphDef = _elm_lang$svg$Svg$node('altGlyphDef');
var _elm_lang$svg$Svg$altGlyphItem = _elm_lang$svg$Svg$node('altGlyphItem');
var _elm_lang$svg$Svg$glyph = _elm_lang$svg$Svg$node('glyph');
var _elm_lang$svg$Svg$glyphRef = _elm_lang$svg$Svg$node('glyphRef');
var _elm_lang$svg$Svg$textPath = _elm_lang$svg$Svg$node('textPath');
var _elm_lang$svg$Svg$text_ = _elm_lang$svg$Svg$node('text');
var _elm_lang$svg$Svg$tref = _elm_lang$svg$Svg$node('tref');
var _elm_lang$svg$Svg$tspan = _elm_lang$svg$Svg$node('tspan');
var _elm_lang$svg$Svg$clipPath = _elm_lang$svg$Svg$node('clipPath');
var _elm_lang$svg$Svg$colorProfile = _elm_lang$svg$Svg$node('colorProfile');
var _elm_lang$svg$Svg$cursor = _elm_lang$svg$Svg$node('cursor');
var _elm_lang$svg$Svg$filter = _elm_lang$svg$Svg$node('filter');
var _elm_lang$svg$Svg$script = _elm_lang$svg$Svg$node('script');
var _elm_lang$svg$Svg$style = _elm_lang$svg$Svg$node('style');
var _elm_lang$svg$Svg$view = _elm_lang$svg$Svg$node('view');

var _elm_lang$svg$Svg_Attributes$writingMode = _elm_lang$virtual_dom$VirtualDom$attribute('writing-mode');
var _elm_lang$svg$Svg_Attributes$wordSpacing = _elm_lang$virtual_dom$VirtualDom$attribute('word-spacing');
var _elm_lang$svg$Svg_Attributes$visibility = _elm_lang$virtual_dom$VirtualDom$attribute('visibility');
var _elm_lang$svg$Svg_Attributes$unicodeBidi = _elm_lang$virtual_dom$VirtualDom$attribute('unicode-bidi');
var _elm_lang$svg$Svg_Attributes$textRendering = _elm_lang$virtual_dom$VirtualDom$attribute('text-rendering');
var _elm_lang$svg$Svg_Attributes$textDecoration = _elm_lang$virtual_dom$VirtualDom$attribute('text-decoration');
var _elm_lang$svg$Svg_Attributes$textAnchor = _elm_lang$virtual_dom$VirtualDom$attribute('text-anchor');
var _elm_lang$svg$Svg_Attributes$stroke = _elm_lang$virtual_dom$VirtualDom$attribute('stroke');
var _elm_lang$svg$Svg_Attributes$strokeWidth = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-width');
var _elm_lang$svg$Svg_Attributes$strokeOpacity = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-opacity');
var _elm_lang$svg$Svg_Attributes$strokeMiterlimit = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-miterlimit');
var _elm_lang$svg$Svg_Attributes$strokeLinejoin = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-linejoin');
var _elm_lang$svg$Svg_Attributes$strokeLinecap = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-linecap');
var _elm_lang$svg$Svg_Attributes$strokeDashoffset = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-dashoffset');
var _elm_lang$svg$Svg_Attributes$strokeDasharray = _elm_lang$virtual_dom$VirtualDom$attribute('stroke-dasharray');
var _elm_lang$svg$Svg_Attributes$stopOpacity = _elm_lang$virtual_dom$VirtualDom$attribute('stop-opacity');
var _elm_lang$svg$Svg_Attributes$stopColor = _elm_lang$virtual_dom$VirtualDom$attribute('stop-color');
var _elm_lang$svg$Svg_Attributes$shapeRendering = _elm_lang$virtual_dom$VirtualDom$attribute('shape-rendering');
var _elm_lang$svg$Svg_Attributes$pointerEvents = _elm_lang$virtual_dom$VirtualDom$attribute('pointer-events');
var _elm_lang$svg$Svg_Attributes$overflow = _elm_lang$virtual_dom$VirtualDom$attribute('overflow');
var _elm_lang$svg$Svg_Attributes$opacity = _elm_lang$virtual_dom$VirtualDom$attribute('opacity');
var _elm_lang$svg$Svg_Attributes$mask = _elm_lang$virtual_dom$VirtualDom$attribute('mask');
var _elm_lang$svg$Svg_Attributes$markerStart = _elm_lang$virtual_dom$VirtualDom$attribute('marker-start');
var _elm_lang$svg$Svg_Attributes$markerMid = _elm_lang$virtual_dom$VirtualDom$attribute('marker-mid');
var _elm_lang$svg$Svg_Attributes$markerEnd = _elm_lang$virtual_dom$VirtualDom$attribute('marker-end');
var _elm_lang$svg$Svg_Attributes$lightingColor = _elm_lang$virtual_dom$VirtualDom$attribute('lighting-color');
var _elm_lang$svg$Svg_Attributes$letterSpacing = _elm_lang$virtual_dom$VirtualDom$attribute('letter-spacing');
var _elm_lang$svg$Svg_Attributes$kerning = _elm_lang$virtual_dom$VirtualDom$attribute('kerning');
var _elm_lang$svg$Svg_Attributes$imageRendering = _elm_lang$virtual_dom$VirtualDom$attribute('image-rendering');
var _elm_lang$svg$Svg_Attributes$glyphOrientationVertical = _elm_lang$virtual_dom$VirtualDom$attribute('glyph-orientation-vertical');
var _elm_lang$svg$Svg_Attributes$glyphOrientationHorizontal = _elm_lang$virtual_dom$VirtualDom$attribute('glyph-orientation-horizontal');
var _elm_lang$svg$Svg_Attributes$fontWeight = _elm_lang$virtual_dom$VirtualDom$attribute('font-weight');
var _elm_lang$svg$Svg_Attributes$fontVariant = _elm_lang$virtual_dom$VirtualDom$attribute('font-variant');
var _elm_lang$svg$Svg_Attributes$fontStyle = _elm_lang$virtual_dom$VirtualDom$attribute('font-style');
var _elm_lang$svg$Svg_Attributes$fontStretch = _elm_lang$virtual_dom$VirtualDom$attribute('font-stretch');
var _elm_lang$svg$Svg_Attributes$fontSize = _elm_lang$virtual_dom$VirtualDom$attribute('font-size');
var _elm_lang$svg$Svg_Attributes$fontSizeAdjust = _elm_lang$virtual_dom$VirtualDom$attribute('font-size-adjust');
var _elm_lang$svg$Svg_Attributes$fontFamily = _elm_lang$virtual_dom$VirtualDom$attribute('font-family');
var _elm_lang$svg$Svg_Attributes$floodOpacity = _elm_lang$virtual_dom$VirtualDom$attribute('flood-opacity');
var _elm_lang$svg$Svg_Attributes$floodColor = _elm_lang$virtual_dom$VirtualDom$attribute('flood-color');
var _elm_lang$svg$Svg_Attributes$filter = _elm_lang$virtual_dom$VirtualDom$attribute('filter');
var _elm_lang$svg$Svg_Attributes$fill = _elm_lang$virtual_dom$VirtualDom$attribute('fill');
var _elm_lang$svg$Svg_Attributes$fillRule = _elm_lang$virtual_dom$VirtualDom$attribute('fill-rule');
var _elm_lang$svg$Svg_Attributes$fillOpacity = _elm_lang$virtual_dom$VirtualDom$attribute('fill-opacity');
var _elm_lang$svg$Svg_Attributes$enableBackground = _elm_lang$virtual_dom$VirtualDom$attribute('enable-background');
var _elm_lang$svg$Svg_Attributes$dominantBaseline = _elm_lang$virtual_dom$VirtualDom$attribute('dominant-baseline');
var _elm_lang$svg$Svg_Attributes$display = _elm_lang$virtual_dom$VirtualDom$attribute('display');
var _elm_lang$svg$Svg_Attributes$direction = _elm_lang$virtual_dom$VirtualDom$attribute('direction');
var _elm_lang$svg$Svg_Attributes$cursor = _elm_lang$virtual_dom$VirtualDom$attribute('cursor');
var _elm_lang$svg$Svg_Attributes$color = _elm_lang$virtual_dom$VirtualDom$attribute('color');
var _elm_lang$svg$Svg_Attributes$colorRendering = _elm_lang$virtual_dom$VirtualDom$attribute('color-rendering');
var _elm_lang$svg$Svg_Attributes$colorProfile = _elm_lang$virtual_dom$VirtualDom$attribute('color-profile');
var _elm_lang$svg$Svg_Attributes$colorInterpolation = _elm_lang$virtual_dom$VirtualDom$attribute('color-interpolation');
var _elm_lang$svg$Svg_Attributes$colorInterpolationFilters = _elm_lang$virtual_dom$VirtualDom$attribute('color-interpolation-filters');
var _elm_lang$svg$Svg_Attributes$clip = _elm_lang$virtual_dom$VirtualDom$attribute('clip');
var _elm_lang$svg$Svg_Attributes$clipRule = _elm_lang$virtual_dom$VirtualDom$attribute('clip-rule');
var _elm_lang$svg$Svg_Attributes$clipPath = _elm_lang$virtual_dom$VirtualDom$attribute('clip-path');
var _elm_lang$svg$Svg_Attributes$baselineShift = _elm_lang$virtual_dom$VirtualDom$attribute('baseline-shift');
var _elm_lang$svg$Svg_Attributes$alignmentBaseline = _elm_lang$virtual_dom$VirtualDom$attribute('alignment-baseline');
var _elm_lang$svg$Svg_Attributes$zoomAndPan = _elm_lang$virtual_dom$VirtualDom$attribute('zoomAndPan');
var _elm_lang$svg$Svg_Attributes$z = _elm_lang$virtual_dom$VirtualDom$attribute('z');
var _elm_lang$svg$Svg_Attributes$yChannelSelector = _elm_lang$virtual_dom$VirtualDom$attribute('yChannelSelector');
var _elm_lang$svg$Svg_Attributes$y2 = _elm_lang$virtual_dom$VirtualDom$attribute('y2');
var _elm_lang$svg$Svg_Attributes$y1 = _elm_lang$virtual_dom$VirtualDom$attribute('y1');
var _elm_lang$svg$Svg_Attributes$y = _elm_lang$virtual_dom$VirtualDom$attribute('y');
var _elm_lang$svg$Svg_Attributes$xmlSpace = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/XML/1998/namespace', 'xml:space');
var _elm_lang$svg$Svg_Attributes$xmlLang = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/XML/1998/namespace', 'xml:lang');
var _elm_lang$svg$Svg_Attributes$xmlBase = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/XML/1998/namespace', 'xml:base');
var _elm_lang$svg$Svg_Attributes$xlinkType = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:type');
var _elm_lang$svg$Svg_Attributes$xlinkTitle = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:title');
var _elm_lang$svg$Svg_Attributes$xlinkShow = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:show');
var _elm_lang$svg$Svg_Attributes$xlinkRole = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:role');
var _elm_lang$svg$Svg_Attributes$xlinkHref = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:href');
var _elm_lang$svg$Svg_Attributes$xlinkArcrole = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:arcrole');
var _elm_lang$svg$Svg_Attributes$xlinkActuate = A2(_elm_lang$virtual_dom$VirtualDom$attributeNS, 'http://www.w3.org/1999/xlink', 'xlink:actuate');
var _elm_lang$svg$Svg_Attributes$xChannelSelector = _elm_lang$virtual_dom$VirtualDom$attribute('xChannelSelector');
var _elm_lang$svg$Svg_Attributes$x2 = _elm_lang$virtual_dom$VirtualDom$attribute('x2');
var _elm_lang$svg$Svg_Attributes$x1 = _elm_lang$virtual_dom$VirtualDom$attribute('x1');
var _elm_lang$svg$Svg_Attributes$xHeight = _elm_lang$virtual_dom$VirtualDom$attribute('x-height');
var _elm_lang$svg$Svg_Attributes$x = _elm_lang$virtual_dom$VirtualDom$attribute('x');
var _elm_lang$svg$Svg_Attributes$widths = _elm_lang$virtual_dom$VirtualDom$attribute('widths');
var _elm_lang$svg$Svg_Attributes$width = _elm_lang$virtual_dom$VirtualDom$attribute('width');
var _elm_lang$svg$Svg_Attributes$viewTarget = _elm_lang$virtual_dom$VirtualDom$attribute('viewTarget');
var _elm_lang$svg$Svg_Attributes$viewBox = _elm_lang$virtual_dom$VirtualDom$attribute('viewBox');
var _elm_lang$svg$Svg_Attributes$vertOriginY = _elm_lang$virtual_dom$VirtualDom$attribute('vert-origin-y');
var _elm_lang$svg$Svg_Attributes$vertOriginX = _elm_lang$virtual_dom$VirtualDom$attribute('vert-origin-x');
var _elm_lang$svg$Svg_Attributes$vertAdvY = _elm_lang$virtual_dom$VirtualDom$attribute('vert-adv-y');
var _elm_lang$svg$Svg_Attributes$version = _elm_lang$virtual_dom$VirtualDom$attribute('version');
var _elm_lang$svg$Svg_Attributes$values = _elm_lang$virtual_dom$VirtualDom$attribute('values');
var _elm_lang$svg$Svg_Attributes$vMathematical = _elm_lang$virtual_dom$VirtualDom$attribute('v-mathematical');
var _elm_lang$svg$Svg_Attributes$vIdeographic = _elm_lang$virtual_dom$VirtualDom$attribute('v-ideographic');
var _elm_lang$svg$Svg_Attributes$vHanging = _elm_lang$virtual_dom$VirtualDom$attribute('v-hanging');
var _elm_lang$svg$Svg_Attributes$vAlphabetic = _elm_lang$virtual_dom$VirtualDom$attribute('v-alphabetic');
var _elm_lang$svg$Svg_Attributes$unitsPerEm = _elm_lang$virtual_dom$VirtualDom$attribute('units-per-em');
var _elm_lang$svg$Svg_Attributes$unicodeRange = _elm_lang$virtual_dom$VirtualDom$attribute('unicode-range');
var _elm_lang$svg$Svg_Attributes$unicode = _elm_lang$virtual_dom$VirtualDom$attribute('unicode');
var _elm_lang$svg$Svg_Attributes$underlineThickness = _elm_lang$virtual_dom$VirtualDom$attribute('underline-thickness');
var _elm_lang$svg$Svg_Attributes$underlinePosition = _elm_lang$virtual_dom$VirtualDom$attribute('underline-position');
var _elm_lang$svg$Svg_Attributes$u2 = _elm_lang$virtual_dom$VirtualDom$attribute('u2');
var _elm_lang$svg$Svg_Attributes$u1 = _elm_lang$virtual_dom$VirtualDom$attribute('u1');
var _elm_lang$svg$Svg_Attributes$type_ = _elm_lang$virtual_dom$VirtualDom$attribute('type');
var _elm_lang$svg$Svg_Attributes$transform = _elm_lang$virtual_dom$VirtualDom$attribute('transform');
var _elm_lang$svg$Svg_Attributes$to = _elm_lang$virtual_dom$VirtualDom$attribute('to');
var _elm_lang$svg$Svg_Attributes$title = _elm_lang$virtual_dom$VirtualDom$attribute('title');
var _elm_lang$svg$Svg_Attributes$textLength = _elm_lang$virtual_dom$VirtualDom$attribute('textLength');
var _elm_lang$svg$Svg_Attributes$targetY = _elm_lang$virtual_dom$VirtualDom$attribute('targetY');
var _elm_lang$svg$Svg_Attributes$targetX = _elm_lang$virtual_dom$VirtualDom$attribute('targetX');
var _elm_lang$svg$Svg_Attributes$target = _elm_lang$virtual_dom$VirtualDom$attribute('target');
var _elm_lang$svg$Svg_Attributes$tableValues = _elm_lang$virtual_dom$VirtualDom$attribute('tableValues');
var _elm_lang$svg$Svg_Attributes$systemLanguage = _elm_lang$virtual_dom$VirtualDom$attribute('systemLanguage');
var _elm_lang$svg$Svg_Attributes$surfaceScale = _elm_lang$virtual_dom$VirtualDom$attribute('surfaceScale');
var _elm_lang$svg$Svg_Attributes$style = _elm_lang$virtual_dom$VirtualDom$attribute('style');
var _elm_lang$svg$Svg_Attributes$string = _elm_lang$virtual_dom$VirtualDom$attribute('string');
var _elm_lang$svg$Svg_Attributes$strikethroughThickness = _elm_lang$virtual_dom$VirtualDom$attribute('strikethrough-thickness');
var _elm_lang$svg$Svg_Attributes$strikethroughPosition = _elm_lang$virtual_dom$VirtualDom$attribute('strikethrough-position');
var _elm_lang$svg$Svg_Attributes$stitchTiles = _elm_lang$virtual_dom$VirtualDom$attribute('stitchTiles');
var _elm_lang$svg$Svg_Attributes$stemv = _elm_lang$virtual_dom$VirtualDom$attribute('stemv');
var _elm_lang$svg$Svg_Attributes$stemh = _elm_lang$virtual_dom$VirtualDom$attribute('stemh');
var _elm_lang$svg$Svg_Attributes$stdDeviation = _elm_lang$virtual_dom$VirtualDom$attribute('stdDeviation');
var _elm_lang$svg$Svg_Attributes$startOffset = _elm_lang$virtual_dom$VirtualDom$attribute('startOffset');
var _elm_lang$svg$Svg_Attributes$spreadMethod = _elm_lang$virtual_dom$VirtualDom$attribute('spreadMethod');
var _elm_lang$svg$Svg_Attributes$speed = _elm_lang$virtual_dom$VirtualDom$attribute('speed');
var _elm_lang$svg$Svg_Attributes$specularExponent = _elm_lang$virtual_dom$VirtualDom$attribute('specularExponent');
var _elm_lang$svg$Svg_Attributes$specularConstant = _elm_lang$virtual_dom$VirtualDom$attribute('specularConstant');
var _elm_lang$svg$Svg_Attributes$spacing = _elm_lang$virtual_dom$VirtualDom$attribute('spacing');
var _elm_lang$svg$Svg_Attributes$slope = _elm_lang$virtual_dom$VirtualDom$attribute('slope');
var _elm_lang$svg$Svg_Attributes$seed = _elm_lang$virtual_dom$VirtualDom$attribute('seed');
var _elm_lang$svg$Svg_Attributes$scale = _elm_lang$virtual_dom$VirtualDom$attribute('scale');
var _elm_lang$svg$Svg_Attributes$ry = _elm_lang$virtual_dom$VirtualDom$attribute('ry');
var _elm_lang$svg$Svg_Attributes$rx = _elm_lang$virtual_dom$VirtualDom$attribute('rx');
var _elm_lang$svg$Svg_Attributes$rotate = _elm_lang$virtual_dom$VirtualDom$attribute('rotate');
var _elm_lang$svg$Svg_Attributes$result = _elm_lang$virtual_dom$VirtualDom$attribute('result');
var _elm_lang$svg$Svg_Attributes$restart = _elm_lang$virtual_dom$VirtualDom$attribute('restart');
var _elm_lang$svg$Svg_Attributes$requiredFeatures = _elm_lang$virtual_dom$VirtualDom$attribute('requiredFeatures');
var _elm_lang$svg$Svg_Attributes$requiredExtensions = _elm_lang$virtual_dom$VirtualDom$attribute('requiredExtensions');
var _elm_lang$svg$Svg_Attributes$repeatDur = _elm_lang$virtual_dom$VirtualDom$attribute('repeatDur');
var _elm_lang$svg$Svg_Attributes$repeatCount = _elm_lang$virtual_dom$VirtualDom$attribute('repeatCount');
var _elm_lang$svg$Svg_Attributes$renderingIntent = _elm_lang$virtual_dom$VirtualDom$attribute('rendering-intent');
var _elm_lang$svg$Svg_Attributes$refY = _elm_lang$virtual_dom$VirtualDom$attribute('refY');
var _elm_lang$svg$Svg_Attributes$refX = _elm_lang$virtual_dom$VirtualDom$attribute('refX');
var _elm_lang$svg$Svg_Attributes$radius = _elm_lang$virtual_dom$VirtualDom$attribute('radius');
var _elm_lang$svg$Svg_Attributes$r = _elm_lang$virtual_dom$VirtualDom$attribute('r');
var _elm_lang$svg$Svg_Attributes$primitiveUnits = _elm_lang$virtual_dom$VirtualDom$attribute('primitiveUnits');
var _elm_lang$svg$Svg_Attributes$preserveAspectRatio = _elm_lang$virtual_dom$VirtualDom$attribute('preserveAspectRatio');
var _elm_lang$svg$Svg_Attributes$preserveAlpha = _elm_lang$virtual_dom$VirtualDom$attribute('preserveAlpha');
var _elm_lang$svg$Svg_Attributes$pointsAtZ = _elm_lang$virtual_dom$VirtualDom$attribute('pointsAtZ');
var _elm_lang$svg$Svg_Attributes$pointsAtY = _elm_lang$virtual_dom$VirtualDom$attribute('pointsAtY');
var _elm_lang$svg$Svg_Attributes$pointsAtX = _elm_lang$virtual_dom$VirtualDom$attribute('pointsAtX');
var _elm_lang$svg$Svg_Attributes$points = _elm_lang$virtual_dom$VirtualDom$attribute('points');
var _elm_lang$svg$Svg_Attributes$pointOrder = _elm_lang$virtual_dom$VirtualDom$attribute('point-order');
var _elm_lang$svg$Svg_Attributes$patternUnits = _elm_lang$virtual_dom$VirtualDom$attribute('patternUnits');
var _elm_lang$svg$Svg_Attributes$patternTransform = _elm_lang$virtual_dom$VirtualDom$attribute('patternTransform');
var _elm_lang$svg$Svg_Attributes$patternContentUnits = _elm_lang$virtual_dom$VirtualDom$attribute('patternContentUnits');
var _elm_lang$svg$Svg_Attributes$pathLength = _elm_lang$virtual_dom$VirtualDom$attribute('pathLength');
var _elm_lang$svg$Svg_Attributes$path = _elm_lang$virtual_dom$VirtualDom$attribute('path');
var _elm_lang$svg$Svg_Attributes$panose1 = _elm_lang$virtual_dom$VirtualDom$attribute('panose-1');
var _elm_lang$svg$Svg_Attributes$overlineThickness = _elm_lang$virtual_dom$VirtualDom$attribute('overline-thickness');
var _elm_lang$svg$Svg_Attributes$overlinePosition = _elm_lang$virtual_dom$VirtualDom$attribute('overline-position');
var _elm_lang$svg$Svg_Attributes$origin = _elm_lang$virtual_dom$VirtualDom$attribute('origin');
var _elm_lang$svg$Svg_Attributes$orientation = _elm_lang$virtual_dom$VirtualDom$attribute('orientation');
var _elm_lang$svg$Svg_Attributes$orient = _elm_lang$virtual_dom$VirtualDom$attribute('orient');
var _elm_lang$svg$Svg_Attributes$order = _elm_lang$virtual_dom$VirtualDom$attribute('order');
var _elm_lang$svg$Svg_Attributes$operator = _elm_lang$virtual_dom$VirtualDom$attribute('operator');
var _elm_lang$svg$Svg_Attributes$offset = _elm_lang$virtual_dom$VirtualDom$attribute('offset');
var _elm_lang$svg$Svg_Attributes$numOctaves = _elm_lang$virtual_dom$VirtualDom$attribute('numOctaves');
var _elm_lang$svg$Svg_Attributes$name = _elm_lang$virtual_dom$VirtualDom$attribute('name');
var _elm_lang$svg$Svg_Attributes$mode = _elm_lang$virtual_dom$VirtualDom$attribute('mode');
var _elm_lang$svg$Svg_Attributes$min = _elm_lang$virtual_dom$VirtualDom$attribute('min');
var _elm_lang$svg$Svg_Attributes$method = _elm_lang$virtual_dom$VirtualDom$attribute('method');
var _elm_lang$svg$Svg_Attributes$media = _elm_lang$virtual_dom$VirtualDom$attribute('media');
var _elm_lang$svg$Svg_Attributes$max = _elm_lang$virtual_dom$VirtualDom$attribute('max');
var _elm_lang$svg$Svg_Attributes$mathematical = _elm_lang$virtual_dom$VirtualDom$attribute('mathematical');
var _elm_lang$svg$Svg_Attributes$maskUnits = _elm_lang$virtual_dom$VirtualDom$attribute('maskUnits');
var _elm_lang$svg$Svg_Attributes$maskContentUnits = _elm_lang$virtual_dom$VirtualDom$attribute('maskContentUnits');
var _elm_lang$svg$Svg_Attributes$markerWidth = _elm_lang$virtual_dom$VirtualDom$attribute('markerWidth');
var _elm_lang$svg$Svg_Attributes$markerUnits = _elm_lang$virtual_dom$VirtualDom$attribute('markerUnits');
var _elm_lang$svg$Svg_Attributes$markerHeight = _elm_lang$virtual_dom$VirtualDom$attribute('markerHeight');
var _elm_lang$svg$Svg_Attributes$local = _elm_lang$virtual_dom$VirtualDom$attribute('local');
var _elm_lang$svg$Svg_Attributes$limitingConeAngle = _elm_lang$virtual_dom$VirtualDom$attribute('limitingConeAngle');
var _elm_lang$svg$Svg_Attributes$lengthAdjust = _elm_lang$virtual_dom$VirtualDom$attribute('lengthAdjust');
var _elm_lang$svg$Svg_Attributes$lang = _elm_lang$virtual_dom$VirtualDom$attribute('lang');
var _elm_lang$svg$Svg_Attributes$keyTimes = _elm_lang$virtual_dom$VirtualDom$attribute('keyTimes');
var _elm_lang$svg$Svg_Attributes$keySplines = _elm_lang$virtual_dom$VirtualDom$attribute('keySplines');
var _elm_lang$svg$Svg_Attributes$keyPoints = _elm_lang$virtual_dom$VirtualDom$attribute('keyPoints');
var _elm_lang$svg$Svg_Attributes$kernelUnitLength = _elm_lang$virtual_dom$VirtualDom$attribute('kernelUnitLength');
var _elm_lang$svg$Svg_Attributes$kernelMatrix = _elm_lang$virtual_dom$VirtualDom$attribute('kernelMatrix');
var _elm_lang$svg$Svg_Attributes$k4 = _elm_lang$virtual_dom$VirtualDom$attribute('k4');
var _elm_lang$svg$Svg_Attributes$k3 = _elm_lang$virtual_dom$VirtualDom$attribute('k3');
var _elm_lang$svg$Svg_Attributes$k2 = _elm_lang$virtual_dom$VirtualDom$attribute('k2');
var _elm_lang$svg$Svg_Attributes$k1 = _elm_lang$virtual_dom$VirtualDom$attribute('k1');
var _elm_lang$svg$Svg_Attributes$k = _elm_lang$virtual_dom$VirtualDom$attribute('k');
var _elm_lang$svg$Svg_Attributes$intercept = _elm_lang$virtual_dom$VirtualDom$attribute('intercept');
var _elm_lang$svg$Svg_Attributes$in2 = _elm_lang$virtual_dom$VirtualDom$attribute('in2');
var _elm_lang$svg$Svg_Attributes$in_ = _elm_lang$virtual_dom$VirtualDom$attribute('in');
var _elm_lang$svg$Svg_Attributes$ideographic = _elm_lang$virtual_dom$VirtualDom$attribute('ideographic');
var _elm_lang$svg$Svg_Attributes$id = _elm_lang$virtual_dom$VirtualDom$attribute('id');
var _elm_lang$svg$Svg_Attributes$horizOriginY = _elm_lang$virtual_dom$VirtualDom$attribute('horiz-origin-y');
var _elm_lang$svg$Svg_Attributes$horizOriginX = _elm_lang$virtual_dom$VirtualDom$attribute('horiz-origin-x');
var _elm_lang$svg$Svg_Attributes$horizAdvX = _elm_lang$virtual_dom$VirtualDom$attribute('horiz-adv-x');
var _elm_lang$svg$Svg_Attributes$height = _elm_lang$virtual_dom$VirtualDom$attribute('height');
var _elm_lang$svg$Svg_Attributes$hanging = _elm_lang$virtual_dom$VirtualDom$attribute('hanging');
var _elm_lang$svg$Svg_Attributes$gradientUnits = _elm_lang$virtual_dom$VirtualDom$attribute('gradientUnits');
var _elm_lang$svg$Svg_Attributes$gradientTransform = _elm_lang$virtual_dom$VirtualDom$attribute('gradientTransform');
var _elm_lang$svg$Svg_Attributes$glyphRef = _elm_lang$virtual_dom$VirtualDom$attribute('glyphRef');
var _elm_lang$svg$Svg_Attributes$glyphName = _elm_lang$virtual_dom$VirtualDom$attribute('glyph-name');
var _elm_lang$svg$Svg_Attributes$g2 = _elm_lang$virtual_dom$VirtualDom$attribute('g2');
var _elm_lang$svg$Svg_Attributes$g1 = _elm_lang$virtual_dom$VirtualDom$attribute('g1');
var _elm_lang$svg$Svg_Attributes$fy = _elm_lang$virtual_dom$VirtualDom$attribute('fy');
var _elm_lang$svg$Svg_Attributes$fx = _elm_lang$virtual_dom$VirtualDom$attribute('fx');
var _elm_lang$svg$Svg_Attributes$from = _elm_lang$virtual_dom$VirtualDom$attribute('from');
var _elm_lang$svg$Svg_Attributes$format = _elm_lang$virtual_dom$VirtualDom$attribute('format');
var _elm_lang$svg$Svg_Attributes$filterUnits = _elm_lang$virtual_dom$VirtualDom$attribute('filterUnits');
var _elm_lang$svg$Svg_Attributes$filterRes = _elm_lang$virtual_dom$VirtualDom$attribute('filterRes');
var _elm_lang$svg$Svg_Attributes$externalResourcesRequired = _elm_lang$virtual_dom$VirtualDom$attribute('externalResourcesRequired');
var _elm_lang$svg$Svg_Attributes$exponent = _elm_lang$virtual_dom$VirtualDom$attribute('exponent');
var _elm_lang$svg$Svg_Attributes$end = _elm_lang$virtual_dom$VirtualDom$attribute('end');
var _elm_lang$svg$Svg_Attributes$elevation = _elm_lang$virtual_dom$VirtualDom$attribute('elevation');
var _elm_lang$svg$Svg_Attributes$edgeMode = _elm_lang$virtual_dom$VirtualDom$attribute('edgeMode');
var _elm_lang$svg$Svg_Attributes$dy = _elm_lang$virtual_dom$VirtualDom$attribute('dy');
var _elm_lang$svg$Svg_Attributes$dx = _elm_lang$virtual_dom$VirtualDom$attribute('dx');
var _elm_lang$svg$Svg_Attributes$dur = _elm_lang$virtual_dom$VirtualDom$attribute('dur');
var _elm_lang$svg$Svg_Attributes$divisor = _elm_lang$virtual_dom$VirtualDom$attribute('divisor');
var _elm_lang$svg$Svg_Attributes$diffuseConstant = _elm_lang$virtual_dom$VirtualDom$attribute('diffuseConstant');
var _elm_lang$svg$Svg_Attributes$descent = _elm_lang$virtual_dom$VirtualDom$attribute('descent');
var _elm_lang$svg$Svg_Attributes$decelerate = _elm_lang$virtual_dom$VirtualDom$attribute('decelerate');
var _elm_lang$svg$Svg_Attributes$d = _elm_lang$virtual_dom$VirtualDom$attribute('d');
var _elm_lang$svg$Svg_Attributes$cy = _elm_lang$virtual_dom$VirtualDom$attribute('cy');
var _elm_lang$svg$Svg_Attributes$cx = _elm_lang$virtual_dom$VirtualDom$attribute('cx');
var _elm_lang$svg$Svg_Attributes$contentStyleType = _elm_lang$virtual_dom$VirtualDom$attribute('contentStyleType');
var _elm_lang$svg$Svg_Attributes$contentScriptType = _elm_lang$virtual_dom$VirtualDom$attribute('contentScriptType');
var _elm_lang$svg$Svg_Attributes$clipPathUnits = _elm_lang$virtual_dom$VirtualDom$attribute('clipPathUnits');
var _elm_lang$svg$Svg_Attributes$class = _elm_lang$virtual_dom$VirtualDom$attribute('class');
var _elm_lang$svg$Svg_Attributes$capHeight = _elm_lang$virtual_dom$VirtualDom$attribute('cap-height');
var _elm_lang$svg$Svg_Attributes$calcMode = _elm_lang$virtual_dom$VirtualDom$attribute('calcMode');
var _elm_lang$svg$Svg_Attributes$by = _elm_lang$virtual_dom$VirtualDom$attribute('by');
var _elm_lang$svg$Svg_Attributes$bias = _elm_lang$virtual_dom$VirtualDom$attribute('bias');
var _elm_lang$svg$Svg_Attributes$begin = _elm_lang$virtual_dom$VirtualDom$attribute('begin');
var _elm_lang$svg$Svg_Attributes$bbox = _elm_lang$virtual_dom$VirtualDom$attribute('bbox');
var _elm_lang$svg$Svg_Attributes$baseProfile = _elm_lang$virtual_dom$VirtualDom$attribute('baseProfile');
var _elm_lang$svg$Svg_Attributes$baseFrequency = _elm_lang$virtual_dom$VirtualDom$attribute('baseFrequency');
var _elm_lang$svg$Svg_Attributes$azimuth = _elm_lang$virtual_dom$VirtualDom$attribute('azimuth');
var _elm_lang$svg$Svg_Attributes$autoReverse = _elm_lang$virtual_dom$VirtualDom$attribute('autoReverse');
var _elm_lang$svg$Svg_Attributes$attributeType = _elm_lang$virtual_dom$VirtualDom$attribute('attributeType');
var _elm_lang$svg$Svg_Attributes$attributeName = _elm_lang$virtual_dom$VirtualDom$attribute('attributeName');
var _elm_lang$svg$Svg_Attributes$ascent = _elm_lang$virtual_dom$VirtualDom$attribute('ascent');
var _elm_lang$svg$Svg_Attributes$arabicForm = _elm_lang$virtual_dom$VirtualDom$attribute('arabic-form');
var _elm_lang$svg$Svg_Attributes$amplitude = _elm_lang$virtual_dom$VirtualDom$attribute('amplitude');
var _elm_lang$svg$Svg_Attributes$allowReorder = _elm_lang$virtual_dom$VirtualDom$attribute('allowReorder');
var _elm_lang$svg$Svg_Attributes$alphabetic = _elm_lang$virtual_dom$VirtualDom$attribute('alphabetic');
var _elm_lang$svg$Svg_Attributes$additive = _elm_lang$virtual_dom$VirtualDom$attribute('additive');
var _elm_lang$svg$Svg_Attributes$accumulate = _elm_lang$virtual_dom$VirtualDom$attribute('accumulate');
var _elm_lang$svg$Svg_Attributes$accelerate = _elm_lang$virtual_dom$VirtualDom$attribute('accelerate');
var _elm_lang$svg$Svg_Attributes$accentHeight = _elm_lang$virtual_dom$VirtualDom$attribute('accent-height');

var _CareerPlug$ats$Library_SignaturePad$sliding = function (list) {
	var firstTuple = function (l) {
		var _p0 = {
			ctor: '_Tuple2',
			_0: _elm_lang$core$List$head(l),
			_1: _elm_lang$core$List$head(
				A2(_elm_lang$core$List$drop, 1, l))
		};
		if (((_p0.ctor === '_Tuple2') && (_p0._0.ctor === 'Just')) && (_p0._1.ctor === 'Just')) {
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: _p0._0._0, _1: _p0._1._0},
				_1: {ctor: '[]'}
			};
		} else {
			return {ctor: '[]'};
		}
	};
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$List$length(list),
		2) > 0) ? A2(
		_elm_lang$core$Basics_ops['++'],
		firstTuple(list),
		_CareerPlug$ats$Library_SignaturePad$sliding(
			A2(_elm_lang$core$List$drop, 1, list))) : ((_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$List$length(list),
		1) > 0) ? firstTuple(list) : {ctor: '[]'});
};
var _CareerPlug$ats$Library_SignaturePad$signatureAsData = function (signature) {
	var point = F2(
		function (_p1, list) {
			var _p2 = _p1;
			var _p4 = _p2._1;
			var _p3 = _p2._0;
			return {
				ctor: '::',
				_0: {
					lx: _elm_lang$core$Basics$round(_p3.x),
					ly: _elm_lang$core$Basics$round(_p3.y),
					mx: _elm_lang$core$Basics$round(_p4.x),
					my: _elm_lang$core$Basics$round(_p4.y)
				},
				_1: list
			};
		});
	return _elm_lang$core$List$reverse(
		A3(
			_elm_lang$core$List$foldl,
			point,
			{ctor: '[]'},
			_elm_lang$core$List$concat(
				A2(_elm_lang$core$List$map, _CareerPlug$ats$Library_SignaturePad$sliding, signature))));
};
var _CareerPlug$ats$Library_SignaturePad$lmPathJson = function (list) {
	var lmJson = function (lm) {
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'lx',
					_1: _elm_lang$core$Json_Encode$int(lm.lx)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'ly',
						_1: _elm_lang$core$Json_Encode$int(lm.ly)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'mx',
							_1: _elm_lang$core$Json_Encode$int(lm.mx)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'my',
								_1: _elm_lang$core$Json_Encode$int(lm.my)
							},
							_1: {ctor: '[]'}
						}
					}
				}
			});
	};
	return _elm_lang$core$Json_Encode$list(
		A2(_elm_lang$core$List$map, lmJson, list));
};
var _CareerPlug$ats$Library_SignaturePad$serializeSignature = function (model) {
	return _elm_lang$core$Json_Encode$object(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'name',
				_1: _elm_lang$core$Json_Encode$string(model.name)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'signature',
					_1: _CareerPlug$ats$Library_SignaturePad$lmPathJson(
						_CareerPlug$ats$Library_SignaturePad$signatureAsData(model.signature))
				},
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$Library_SignaturePad$signature = function (model) {
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$String$length(model.name),
		0) > 0) ? _elm_lang$core$Maybe$Just(
		{
			signed_by: model.name,
			signature: A2(
				_elm_lang$core$Json_Encode$encode,
				0,
				_CareerPlug$ats$Library_SignaturePad$lmPathJson(
					_CareerPlug$ats$Library_SignaturePad$signatureAsData(model.signature)))
		}) : _elm_lang$core$Maybe$Nothing;
};
var _CareerPlug$ats$Library_SignaturePad$pathRegex = _elm_lang$core$Regex$regex('^M L');
var _CareerPlug$ats$Library_SignaturePad$signatureAsPath = function (signature) {
	var point = F2(
		function (pnt, list) {
			return _elm_lang$core$String$concat(
				{
					ctor: '::',
					_0: list,
					_1: {
						ctor: '::',
						_0: ' L',
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Basics$toString(pnt.x),
							_1: {
								ctor: '::',
								_0: ',',
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Basics$toString(pnt.y),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				});
		});
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$List$length(signature),
		0) > 0) ? A4(
		_elm_lang$core$Regex$replace,
		_elm_lang$core$Regex$AtMost(1),
		_CareerPlug$ats$Library_SignaturePad$pathRegex,
		function (_p5) {
			return 'M';
		},
		A3(_elm_lang$core$List$foldr, point, 'M', signature)) : '';
};
var _CareerPlug$ats$Library_SignaturePad$signaturePaths = function (signature) {
	var singlePath = function (sig) {
		return A2(
			_elm_lang$svg$Svg$path,
			{
				ctor: '::',
				_0: _elm_lang$svg$Svg_Attributes$stroke('#000'),
				_1: {
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$strokeWidth('2'),
					_1: {
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$fill('none'),
						_1: {
							ctor: '::',
							_0: _elm_lang$svg$Svg_Attributes$pointerEvents('none'),
							_1: {
								ctor: '::',
								_0: _elm_lang$svg$Svg_Attributes$d(
									_CareerPlug$ats$Library_SignaturePad$signatureAsPath(sig)),
								_1: {ctor: '[]'}
							}
						}
					}
				}
			},
			{ctor: '[]'});
	};
	return A2(_elm_lang$core$List$map, singlePath, signature);
};
var _CareerPlug$ats$Library_SignaturePad$stopOptions = {stopPropagation: true, preventDefault: true};
var _CareerPlug$ats$Library_SignaturePad$canvasHeight = 150;
var _CareerPlug$ats$Library_SignaturePad$canvasHeightStr = _elm_lang$core$Basics$toString(_CareerPlug$ats$Library_SignaturePad$canvasHeight);
var _CareerPlug$ats$Library_SignaturePad$baseLineHeightStr = _elm_lang$core$Basics$toString(
	_elm_lang$core$Basics$round(
		_elm_lang$core$Basics$toFloat(_CareerPlug$ats$Library_SignaturePad$canvasHeight) * 0.8));
var _CareerPlug$ats$Library_SignaturePad$canvasWidth = 750;
var _CareerPlug$ats$Library_SignaturePad$canvasWidthStr = _elm_lang$core$Basics$toString(_CareerPlug$ats$Library_SignaturePad$canvasWidth);
var _CareerPlug$ats$Library_SignaturePad$signatureView = function (model) {
	return (_elm_lang$core$Native_Utils.cmp(
		_elm_lang$core$List$length(model.signature),
		0) > 0) ? A2(
		_elm_lang$svg$Svg$svg,
		{
			ctor: '::',
			_0: _elm_lang$svg$Svg_Attributes$width('100%'),
			_1: {
				ctor: '::',
				_0: _elm_lang$svg$Svg_Attributes$height('100%'),
				_1: {
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$viewBox(
						A2(
							_elm_lang$core$String$join,
							' ',
							{
								ctor: '::',
								_0: '0 0',
								_1: {
									ctor: '::',
									_0: _CareerPlug$ats$Library_SignaturePad$canvasWidthStr,
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Library_SignaturePad$canvasHeightStr,
										_1: {ctor: '[]'}
									}
								}
							})),
					_1: {
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$preserveAspectRatio('none'),
						_1: {
							ctor: '::',
							_0: _elm_lang$svg$Svg_Attributes$pointerEvents('none'),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		},
		_CareerPlug$ats$Library_SignaturePad$signaturePaths(model.signature)) : A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('text-signature'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _elm_lang$html$Html$text(model.name),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$Library_SignaturePad$pointDecoder = function (msgGen) {
	var atLeast0 = function (val) {
		return (_elm_lang$core$Native_Utils.cmp(val, 0) > 0) ? _elm_lang$core$Json_Decode$succeed(val) : _elm_lang$core$Json_Decode$fail('must be greater than 0');
	};
	var tryDim = function (name) {
		return _elm_lang$core$Json_Decode$oneOf(
			{
				ctor: '::',
				_0: A2(
					_elm_lang$core$Json_Decode$andThen,
					atLeast0,
					A2(
						_elm_lang$core$Json_Decode$at,
						{
							ctor: '::',
							_0: 'target',
							_1: {
								ctor: '::',
								_0: name,
								_1: {ctor: '[]'}
							}
						},
						_elm_lang$core$Json_Decode$float)),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Json_Decode$at,
						{
							ctor: '::',
							_0: 'target',
							_1: {
								ctor: '::',
								_0: 'parentNode',
								_1: {
									ctor: '::',
									_0: name,
									_1: {ctor: '[]'}
								}
							}
						},
						_elm_lang$core$Json_Decode$float),
					_1: {ctor: '[]'}
				}
			});
	};
	var point = F4(
		function (w, h, x, y) {
			var y_ = (_elm_lang$core$Basics$toFloat(_CareerPlug$ats$Library_SignaturePad$canvasHeight) / h) * y;
			var x_ = (_elm_lang$core$Basics$toFloat(_CareerPlug$ats$Library_SignaturePad$canvasWidth) / w) * x;
			return msgGen(
				{x: x_, y: y_});
		});
	return A5(
		_elm_lang$core$Json_Decode$map4,
		point,
		tryDim('clientWidth'),
		tryDim('clientHeight'),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'offsetX',
				_1: {ctor: '[]'}
			},
			_elm_lang$core$Json_Decode$float),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'offsetY',
				_1: {ctor: '[]'}
			},
			_elm_lang$core$Json_Decode$float));
};
var _CareerPlug$ats$Library_SignaturePad$touchDecoder = function (msgGen) {
	var point = F6(
		function (w, h, l, t, x, y) {
			var y_ = (_elm_lang$core$Basics$toFloat(_CareerPlug$ats$Library_SignaturePad$canvasHeight) / _elm_lang$core$Basics$toFloat(h)) * (_elm_lang$core$Basics$toFloat(y) - _elm_lang$core$Basics$toFloat(t));
			var x_ = (_elm_lang$core$Basics$toFloat(_CareerPlug$ats$Library_SignaturePad$canvasWidth) / _elm_lang$core$Basics$toFloat(w)) * (_elm_lang$core$Basics$toFloat(x) - _elm_lang$core$Basics$toFloat(l));
			return msgGen(
				{x: x_, y: y_});
		});
	return A7(
		_elm_lang$core$Json_Decode$map6,
		point,
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'changedTouches',
				_1: {
					ctor: '::',
					_0: '0',
					_1: {
						ctor: '::',
						_0: 'target',
						_1: {
							ctor: '::',
							_0: 'offsetWidth',
							_1: {ctor: '[]'}
						}
					}
				}
			},
			_elm_lang$core$Json_Decode$int),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'changedTouches',
				_1: {
					ctor: '::',
					_0: '0',
					_1: {
						ctor: '::',
						_0: 'target',
						_1: {
							ctor: '::',
							_0: 'offsetHeight',
							_1: {ctor: '[]'}
						}
					}
				}
			},
			_elm_lang$core$Json_Decode$int),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'changedTouches',
				_1: {
					ctor: '::',
					_0: '0',
					_1: {
						ctor: '::',
						_0: 'target',
						_1: {
							ctor: '::',
							_0: 'offsetLeft',
							_1: {ctor: '[]'}
						}
					}
				}
			},
			_elm_lang$core$Json_Decode$int),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'changedTouches',
				_1: {
					ctor: '::',
					_0: '0',
					_1: {
						ctor: '::',
						_0: 'target',
						_1: {
							ctor: '::',
							_0: 'offsetTop',
							_1: {ctor: '[]'}
						}
					}
				}
			},
			_elm_lang$core$Json_Decode$int),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'changedTouches',
				_1: {
					ctor: '::',
					_0: '0',
					_1: {
						ctor: '::',
						_0: 'clientX',
						_1: {ctor: '[]'}
					}
				}
			},
			_elm_lang$core$Json_Decode$int),
		A2(
			_elm_lang$core$Json_Decode$at,
			{
				ctor: '::',
				_0: 'changedTouches',
				_1: {
					ctor: '::',
					_0: '0',
					_1: {
						ctor: '::',
						_0: 'clientY',
						_1: {ctor: '[]'}
					}
				}
			},
			_elm_lang$core$Json_Decode$int));
};
var _CareerPlug$ats$Library_SignaturePad$appendPointToSignature = F2(
	function (pos, signature) {
		var revSig = _elm_lang$core$List$reverse(signature);
		var signature_ = function () {
			var _p6 = _elm_lang$core$List$head(revSig);
			if (_p6.ctor === 'Just') {
				return {
					ctor: '::',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						_p6._0,
						{
							ctor: '::',
							_0: pos,
							_1: {ctor: '[]'}
						}),
					_1: A2(_elm_lang$core$List$drop, 1, revSig)
				};
			} else {
				return {
					ctor: '::',
					_0: {
						ctor: '::',
						_0: pos,
						_1: {ctor: '[]'}
					},
					_1: {ctor: '[]'}
				};
			}
		}();
		return _elm_lang$core$List$reverse(signature_);
	});
var _CareerPlug$ats$Library_SignaturePad$lmPathToPoints = function (list) {
	var lastPoint = function (xs) {
		return A2(
			_elm_lang$core$Maybe$andThen,
			_elm_lang$core$List$head,
			A2(
				_elm_lang$core$Maybe$map,
				_elm_lang$core$List$reverse,
				_elm_lang$core$List$head(
					_elm_lang$core$List$reverse(xs))));
	};
	var point = F2(
		function (_p7, xs) {
			var _p8 = _p7;
			var _p12 = _p8._1;
			var _p11 = _p8._0;
			var _p9 = lastPoint(xs);
			if (_p9.ctor === 'Just') {
				var _p10 = _p9._0;
				return (_elm_lang$core$Native_Utils.eq(_p10.x, _p11.x) && _elm_lang$core$Native_Utils.eq(_p10.y, _p11.y)) ? A2(_CareerPlug$ats$Library_SignaturePad$appendPointToSignature, _p12, xs) : A2(
					_elm_lang$core$Basics_ops['++'],
					xs,
					{
						ctor: '::',
						_0: {
							ctor: '::',
							_0: _p11,
							_1: {
								ctor: '::',
								_0: _p12,
								_1: {ctor: '[]'}
							}
						},
						_1: {ctor: '[]'}
					});
			} else {
				return {
					ctor: '::',
					_0: {
						ctor: '::',
						_0: _p11,
						_1: {
							ctor: '::',
							_0: _p12,
							_1: {ctor: '[]'}
						}
					},
					_1: {ctor: '[]'}
				};
			}
		});
	var toPairs = function (lm) {
		return {
			ctor: '_Tuple2',
			_0: {
				x: _elm_lang$core$Basics$toFloat(lm.lx),
				y: _elm_lang$core$Basics$toFloat(lm.ly)
			},
			_1: {
				x: _elm_lang$core$Basics$toFloat(lm.mx),
				y: _elm_lang$core$Basics$toFloat(lm.my)
			}
		};
	};
	return A3(
		_elm_lang$core$List$foldl,
		point,
		{ctor: '[]'},
		A2(_elm_lang$core$List$map, toPairs, list));
};
var _CareerPlug$ats$Library_SignaturePad$signature_pad_command = _elm_lang$core$Native_Platform.outgoingPort(
	'signature_pad_command',
	function (v) {
		return [v._0, v._1];
	});
var _CareerPlug$ats$Library_SignaturePad$valueUpdated = _elm_lang$core$Native_Platform.outgoingPort(
	'valueUpdated',
	function (v) {
		return v;
	});
var _CareerPlug$ats$Library_SignaturePad$withUpdatedSignature = F2(
	function (model, cmds) {
		return {
			ctor: '_Tuple2',
			_0: model,
			_1: _elm_lang$core$Platform_Cmd$batch(
				function (cmd) {
					return {ctor: '::', _0: cmd, _1: cmds};
				}(
					_CareerPlug$ats$Library_SignaturePad$valueUpdated(
						_CareerPlug$ats$Library_SignaturePad$serializeSignature(model))))
		};
	});
var _CareerPlug$ats$Library_SignaturePad$updateValue = _elm_lang$core$Native_Platform.incomingPort('updateValue', _elm_lang$core$Json_Decode$value);
var _CareerPlug$ats$Library_SignaturePad$Model = F4(
	function (a, b, c, d) {
		return {mode: a, drawing: b, name: c, signature: d};
	});
var _CareerPlug$ats$Library_SignaturePad$Point = F2(
	function (a, b) {
		return {x: a, y: b};
	});
var _CareerPlug$ats$Library_SignaturePad$LMPath = F4(
	function (a, b, c, d) {
		return {lx: a, ly: b, mx: c, my: d};
	});
var _CareerPlug$ats$Library_SignaturePad$jsonSignature = function () {
	var jsonLMPath = A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'my',
		_elm_lang$core$Json_Decode$int,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'mx',
			_elm_lang$core$Json_Decode$int,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'ly',
				_elm_lang$core$Json_Decode$int,
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'lx',
					_elm_lang$core$Json_Decode$int,
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Library_SignaturePad$LMPath)))));
	return _elm_lang$core$Json_Decode$list(jsonLMPath);
}();
var _CareerPlug$ats$Library_SignaturePad$SerializedSignature = F2(
	function (a, b) {
		return {name: a, signature: b};
	});
var _CareerPlug$ats$Library_SignaturePad$deserializeSignature = A3(
	_elm_lang$core$Json_Decode$map2,
	_CareerPlug$ats$Library_SignaturePad$SerializedSignature,
	A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string),
	A2(
		_elm_lang$core$Json_Decode$field,
		'signature',
		A2(_elm_lang$core$Json_Decode$map, _CareerPlug$ats$Library_SignaturePad$lmPathToPoints, _CareerPlug$ats$Library_SignaturePad$jsonSignature)));
var _CareerPlug$ats$Library_SignaturePad$SignatureData = F2(
	function (a, b) {
		return {signed_by: a, signature: b};
	});
var _CareerPlug$ats$Library_SignaturePad$Drawing = {ctor: 'Drawing'};
var _CareerPlug$ats$Library_SignaturePad$Typing = {ctor: 'Typing'};
var _CareerPlug$ats$Library_SignaturePad$blankModel = function (val) {
	var sig = function () {
		var _p13 = A2(
			_elm_lang$core$Json_Decode$decodeString,
			A2(_elm_lang$core$Json_Decode$field, 'signature', _CareerPlug$ats$Library_SignaturePad$jsonSignature),
			val);
		if (_p13.ctor === 'Ok') {
			return _CareerPlug$ats$Library_SignaturePad$lmPathToPoints(_p13._0);
		} else {
			var _p14 = A2(
				_elm_lang$core$Debug$log,
				'Decoding Signature',
				{ctor: '_Tuple2', _0: val, _1: _p13._0});
			return {ctor: '[]'};
		}
	}();
	var name = function () {
		var _p15 = A2(
			_elm_lang$core$Json_Decode$decodeString,
			A2(_elm_lang$core$Json_Decode$field, 'signed_by', _elm_lang$core$Json_Decode$string),
			val);
		if (_p15.ctor === 'Ok') {
			return _p15._0;
		} else {
			var _p16 = A2(_elm_lang$core$Debug$log, 'Decoding Signed-By', _p15._0);
			return '';
		}
	}();
	return {mode: _CareerPlug$ats$Library_SignaturePad$Typing, drawing: false, name: name, signature: sig};
};
var _CareerPlug$ats$Library_SignaturePad$toggleMode = function (mode) {
	var _p17 = mode;
	if (_p17.ctor === 'Typing') {
		return _CareerPlug$ats$Library_SignaturePad$Drawing;
	} else {
		return _CareerPlug$ats$Library_SignaturePad$Typing;
	}
};
var _CareerPlug$ats$Library_SignaturePad$UpdateValue = function (a) {
	return {ctor: 'UpdateValue', _0: a};
};
var _CareerPlug$ats$Library_SignaturePad$subscriptions = function (outMsg) {
	return _CareerPlug$ats$Library_SignaturePad$updateValue(
		function (json) {
			return outMsg(
				_CareerPlug$ats$Library_SignaturePad$UpdateValue(json));
		});
};
var _CareerPlug$ats$Library_SignaturePad$DragMove = function (a) {
	return {ctor: 'DragMove', _0: a};
};
var _CareerPlug$ats$Library_SignaturePad$DragStop = function (a) {
	return {ctor: 'DragStop', _0: a};
};
var _CareerPlug$ats$Library_SignaturePad$DragStart = function (a) {
	return {ctor: 'DragStart', _0: a};
};
var _CareerPlug$ats$Library_SignaturePad$ClearSignature = {ctor: 'ClearSignature'};
var _CareerPlug$ats$Library_SignaturePad$TypedName = function (a) {
	return {ctor: 'TypedName', _0: a};
};
var _CareerPlug$ats$Library_SignaturePad$ToggleDrawing = {ctor: 'ToggleDrawing'};
var _CareerPlug$ats$Library_SignaturePad$Blur = {ctor: 'Blur'};
var _CareerPlug$ats$Library_SignaturePad$update = F3(
	function (outMsg, msg, model) {
		var _p18 = msg;
		switch (_p18.ctor) {
			case 'Focus':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'Blur':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'ToggleDrawing':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							mode: _CareerPlug$ats$Library_SignaturePad$toggleMode(model.mode)
						}),
					{
						ctor: '::',
						_0: _CareerPlug$ats$Library_Update$msgEffect(
							outMsg(_CareerPlug$ats$Library_SignaturePad$Blur)),
						_1: {ctor: '[]'}
					});
			case 'TypedName':
				var _p20 = _p18._0;
				var formValidityChanged = A2(
					_elm_lang$core$Basics$xor,
					_elm_lang$core$String$isEmpty(model.name),
					_elm_lang$core$String$isEmpty(_p20));
				var formValidCmd = function () {
					var _p19 = formValidityChanged;
					if (_p19 === true) {
						return _elm_lang$core$String$isEmpty(_p20) ? {
							ctor: '::',
							_0: _CareerPlug$ats$Library_SignaturePad$signature_pad_command(
								{ctor: '_Tuple2', _0: 'form-ready', _1: 'false'}),
							_1: {ctor: '[]'}
						} : {
							ctor: '::',
							_0: _CareerPlug$ats$Library_SignaturePad$signature_pad_command(
								{ctor: '_Tuple2', _0: 'form-ready', _1: 'true'}),
							_1: {ctor: '[]'}
						};
					} else {
						return {ctor: '[]'};
					}
				}();
				return A2(
					_CareerPlug$ats$Library_SignaturePad$withUpdatedSignature,
					_elm_lang$core$Native_Utils.update(
						model,
						{name: _p20}),
					formValidCmd);
			case 'ClearSignature':
				return A2(
					_CareerPlug$ats$Library_SignaturePad$withUpdatedSignature,
					_elm_lang$core$Native_Utils.update(
						model,
						{
							signature: {ctor: '[]'},
							mode: _CareerPlug$ats$Library_SignaturePad$toggleMode(model.mode)
						}),
					{ctor: '[]'});
			case 'DragStart':
				return A2(
					_CareerPlug$ats$Library_SignaturePad$withUpdatedSignature,
					_elm_lang$core$Native_Utils.update(
						model,
						{
							drawing: true,
							signature: A2(
								_elm_lang$core$Basics_ops['++'],
								model.signature,
								{
									ctor: '::',
									_0: {
										ctor: '::',
										_0: _p18._0,
										_1: {ctor: '[]'}
									},
									_1: {ctor: '[]'}
								})
						}),
					{ctor: '[]'});
			case 'DragStop':
				return A2(
					_CareerPlug$ats$Library_SignaturePad$withUpdatedSignature,
					_elm_lang$core$Native_Utils.update(
						model,
						{
							drawing: false,
							signature: A2(_CareerPlug$ats$Library_SignaturePad$appendPointToSignature, _p18._0, model.signature)
						}),
					{ctor: '[]'});
			case 'DragMove':
				return A2(
					_CareerPlug$ats$Library_SignaturePad$withUpdatedSignature,
					_elm_lang$core$Native_Utils.update(
						model,
						{
							signature: A2(_CareerPlug$ats$Library_SignaturePad$appendPointToSignature, _p18._0, model.signature)
						}),
					{ctor: '[]'});
			default:
				var _p21 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$Library_SignaturePad$deserializeSignature, _p18._0);
				if (_p21.ctor === 'Ok') {
					var _p22 = _p21._0;
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{name: _p22.name, signature: _p22.signature}),
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
		}
	});
var _CareerPlug$ats$Library_SignaturePad$Focus = {ctor: 'Focus'};
var _CareerPlug$ats$Library_SignaturePad$view = F8(
	function (outMsg, formMsg, pointerEvent, allowSignature, fieldName, focusId, maybeError, model) {
		var signatureArea = function () {
			var _p23 = model.mode;
			if (_p23.ctor === 'Typing') {
				return allowSignature ? A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('form-group'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$a,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(
									outMsg(_CareerPlug$ats$Library_SignaturePad$ToggleDrawing)),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('btn btn-default btn-sm'),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('Draw Signature'),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}) : _elm_lang$html$Html$text('');
			} else {
				var mouseEvents = pointerEvent ? (model.drawing ? {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html_Events$on,
						'pointermove',
						_CareerPlug$ats$Library_SignaturePad$pointDecoder(
							function (ev) {
								return outMsg(
									_CareerPlug$ats$Library_SignaturePad$DragMove(ev));
							})),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html_Events$on,
							'pointerup',
							_CareerPlug$ats$Library_SignaturePad$pointDecoder(
								function (ev) {
									return outMsg(
										_CareerPlug$ats$Library_SignaturePad$DragStop(ev));
								})),
						_1: {ctor: '[]'}
					}
				} : {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html_Events$on,
						'pointerdown',
						_CareerPlug$ats$Library_SignaturePad$pointDecoder(
							function (ev) {
								return outMsg(
									_CareerPlug$ats$Library_SignaturePad$DragStart(ev));
							})),
					_1: {ctor: '[]'}
				}) : (model.drawing ? {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html_Events$on,
						'mousemove',
						_CareerPlug$ats$Library_SignaturePad$pointDecoder(
							function (ev) {
								return outMsg(
									_CareerPlug$ats$Library_SignaturePad$DragMove(ev));
							})),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html_Events$on,
							'mouseup',
							_CareerPlug$ats$Library_SignaturePad$pointDecoder(
								function (ev) {
									return outMsg(
										_CareerPlug$ats$Library_SignaturePad$DragStop(ev));
								})),
						_1: {
							ctor: '::',
							_0: A3(
								_elm_lang$html$Html_Events$onWithOptions,
								'touchmove',
								_CareerPlug$ats$Library_SignaturePad$stopOptions,
								_CareerPlug$ats$Library_SignaturePad$touchDecoder(
									function (ev) {
										return outMsg(
											_CareerPlug$ats$Library_SignaturePad$DragMove(ev));
									})),
							_1: {
								ctor: '::',
								_0: A3(
									_elm_lang$html$Html_Events$onWithOptions,
									'touchend',
									_CareerPlug$ats$Library_SignaturePad$stopOptions,
									_CareerPlug$ats$Library_SignaturePad$touchDecoder(
										function (ev) {
											return outMsg(
												_CareerPlug$ats$Library_SignaturePad$DragStop(ev));
										})),
								_1: {
									ctor: '::',
									_0: A3(
										_elm_lang$html$Html_Events$onWithOptions,
										'touchcancel',
										_CareerPlug$ats$Library_SignaturePad$stopOptions,
										_CareerPlug$ats$Library_SignaturePad$touchDecoder(
											function (ev) {
												return outMsg(
													_CareerPlug$ats$Library_SignaturePad$DragStop(ev));
											})),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				} : {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html_Events$on,
						'mousedown',
						_CareerPlug$ats$Library_SignaturePad$pointDecoder(
							function (ev) {
								return outMsg(
									_CareerPlug$ats$Library_SignaturePad$DragStart(ev));
							})),
					_1: {
						ctor: '::',
						_0: A3(
							_elm_lang$html$Html_Events$onWithOptions,
							'touchstart',
							_CareerPlug$ats$Library_SignaturePad$stopOptions,
							_CareerPlug$ats$Library_SignaturePad$touchDecoder(
								function (ev) {
									return outMsg(
										_CareerPlug$ats$Library_SignaturePad$DragStart(ev));
								})),
						_1: {ctor: '[]'}
					}
				});
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('signature-area'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('svg-holder'),
								_1: mouseEvents
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$svg$Svg$svg,
									{
										ctor: '::',
										_0: _elm_lang$svg$Svg_Attributes$width('100%'),
										_1: {
											ctor: '::',
											_0: _elm_lang$svg$Svg_Attributes$height('100%'),
											_1: {
												ctor: '::',
												_0: _elm_lang$svg$Svg_Attributes$viewBox(
													A2(
														_elm_lang$core$String$join,
														' ',
														{
															ctor: '::',
															_0: '0 0',
															_1: {
																ctor: '::',
																_0: _CareerPlug$ats$Library_SignaturePad$canvasWidthStr,
																_1: {
																	ctor: '::',
																	_0: _CareerPlug$ats$Library_SignaturePad$canvasHeightStr,
																	_1: {ctor: '[]'}
																}
															}
														})),
												_1: {
													ctor: '::',
													_0: _elm_lang$svg$Svg_Attributes$preserveAspectRatio('xMidYMid meet'),
													_1: {
														ctor: '::',
														_0: _elm_lang$svg$Svg_Attributes$pointerEvents('none'),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									},
									A2(
										_elm_lang$core$Basics_ops['++'],
										{
											ctor: '::',
											_0: A2(
												_elm_lang$svg$Svg$rect,
												{
													ctor: '::',
													_0: _elm_lang$svg$Svg_Attributes$width(_CareerPlug$ats$Library_SignaturePad$canvasWidthStr),
													_1: {
														ctor: '::',
														_0: _elm_lang$svg$Svg_Attributes$height(_CareerPlug$ats$Library_SignaturePad$canvasHeightStr),
														_1: {
															ctor: '::',
															_0: _elm_lang$svg$Svg_Attributes$stroke('#666'),
															_1: {
																ctor: '::',
																_0: _elm_lang$svg$Svg_Attributes$strokeWidth('1'),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$svg$Svg_Attributes$fill('none'),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$svg$Svg_Attributes$pointerEvents('none'),
																		_1: {ctor: '[]'}
																	}
																}
															}
														}
													}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$svg$Svg$line,
													{
														ctor: '::',
														_0: _elm_lang$svg$Svg_Attributes$x1('0'),
														_1: {
															ctor: '::',
															_0: _elm_lang$svg$Svg_Attributes$y1(_CareerPlug$ats$Library_SignaturePad$baseLineHeightStr),
															_1: {
																ctor: '::',
																_0: _elm_lang$svg$Svg_Attributes$x2(_CareerPlug$ats$Library_SignaturePad$canvasWidthStr),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$svg$Svg_Attributes$y2(_CareerPlug$ats$Library_SignaturePad$baseLineHeightStr),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$svg$Svg_Attributes$stroke('#aaa'),
																		_1: {
																			ctor: '::',
																			_0: _elm_lang$svg$Svg_Attributes$strokeWidth('1'),
																			_1: {
																				ctor: '::',
																				_0: _elm_lang$svg$Svg_Attributes$shapeRendering('crispEdges'),
																				_1: {
																					ctor: '::',
																					_0: _elm_lang$svg$Svg_Attributes$pointerEvents('none'),
																					_1: {ctor: '[]'}
																				}
																			}
																		}
																	}
																}
															}
														}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}
										},
										_CareerPlug$ats$Library_SignaturePad$signaturePaths(model.signature))),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$p,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('mobile-disclaimer'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('This works best in landscape mode.'),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('btn-area form-group'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$a,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Events$onClick(
													outMsg(_CareerPlug$ats$Library_SignaturePad$ClearSignature)),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('btn btn-default btn-sm'),
													_1: {ctor: '[]'}
												}
											},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text('Cancel'),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$a,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Events$onClick(
														outMsg(_CareerPlug$ats$Library_SignaturePad$ToggleDrawing)),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('btn btn-primary btn-sm'),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text('Accept Signature'),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}),
								_1: {ctor: '[]'}
							}
						}
					});
			}
		}();
		return A2(
			_elm_lang$html$Html$fieldset,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('signature-pad inputs'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$p,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('\n                    By signing this document electronically, you agree that your\n                    electronic signature is the legal equivalent of you signing\n                    this document in writing.\n                    '),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(
								A2(
									_elm_lang$core$Basics_ops['++'],
									'string input optional stringish form-group signed-by ',
									_CareerPlug$ats$Library_BootstrapForm$errorClass(maybeError))),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$label,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('control-label'),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html_Attributes$property,
											'innerHTML',
											_elm_lang$core$Json_Encode$string(fieldName)),
										_1: {ctor: '[]'}
									}
								},
								{ctor: '[]'}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$span,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('form-wrapper'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$input,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('form-control name'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$id(focusId),
													_1: {
														ctor: '::',
														_0: A2(_elm_lang$html$Html_Attributes$attribute, 'maxlength', '255'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$value(model.name),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Events$onInput(
																	function (ev) {
																		return outMsg(
																			_CareerPlug$ats$Library_SignaturePad$TypedName(ev));
																	}),
																_1: {
																	ctor: '::',
																	_0: _elm_lang$html$Html_Events$onFocus(
																		outMsg(_CareerPlug$ats$Library_SignaturePad$Focus)),
																	_1: {
																		ctor: '::',
																		_0: _elm_lang$html$Html_Events$onBlur(
																			outMsg(_CareerPlug$ats$Library_SignaturePad$Blur)),
																		_1: {ctor: '[]'}
																	}
																}
															}
														}
													}
												}
											},
											{ctor: '[]'}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$map,
												formMsg,
												A2(_CareerPlug$ats$Library_BootstrapForm$errorMessage, maybeError, '')),
											_1: {ctor: '[]'}
										}
									}),
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: signatureArea,
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _CareerPlug$ats$Models_Country$optionList = {
	ctor: '::',
	_0: {ctor: '_Tuple2', _0: 'AFG', _1: 'Afghanistan'},
	_1: {
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: 'ALB', _1: 'Albania'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'DZA', _1: 'Algeria'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'ASM', _1: 'American Samoa'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'AND', _1: 'Andorra'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'AGO', _1: 'Angola'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'AIA', _1: 'Anguilla'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'ATA', _1: 'Antarctica'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'ATG', _1: 'Antigua And Barbuda'},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'ARG', _1: 'Argentina'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'ARM', _1: 'Armenia'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: 'ABW', _1: 'Aruba'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: 'AUS', _1: 'Australia'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: 'AUT', _1: 'Austria'},
														_1: {
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: 'AZE', _1: 'Azerbaijan'},
															_1: {
																ctor: '::',
																_0: {ctor: '_Tuple2', _0: 'BHS', _1: 'Bahamas'},
																_1: {
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'BHR', _1: 'Bahrain'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'BGD', _1: 'Bangladesh'},
																		_1: {
																			ctor: '::',
																			_0: {ctor: '_Tuple2', _0: 'BRB', _1: 'Barbados'},
																			_1: {
																				ctor: '::',
																				_0: {ctor: '_Tuple2', _0: 'BLR', _1: 'Belarus'},
																				_1: {
																					ctor: '::',
																					_0: {ctor: '_Tuple2', _0: 'BEL', _1: 'Belgium'},
																					_1: {
																						ctor: '::',
																						_0: {ctor: '_Tuple2', _0: 'BLZ', _1: 'Belize'},
																						_1: {
																							ctor: '::',
																							_0: {ctor: '_Tuple2', _0: 'BEN', _1: 'Benin'},
																							_1: {
																								ctor: '::',
																								_0: {ctor: '_Tuple2', _0: 'BMU', _1: 'Bermuda'},
																								_1: {
																									ctor: '::',
																									_0: {ctor: '_Tuple2', _0: 'BTN', _1: 'Bhutan'},
																									_1: {
																										ctor: '::',
																										_0: {ctor: '_Tuple2', _0: 'BOL', _1: 'Bolivia, Plurinational State Of'},
																										_1: {
																											ctor: '::',
																											_0: {ctor: '_Tuple2', _0: 'BIH', _1: 'Bosnia And Herzegovina'},
																											_1: {
																												ctor: '::',
																												_0: {ctor: '_Tuple2', _0: 'BWA', _1: 'Botswana'},
																												_1: {
																													ctor: '::',
																													_0: {ctor: '_Tuple2', _0: 'BVT', _1: 'Bouvet Island'},
																													_1: {
																														ctor: '::',
																														_0: {ctor: '_Tuple2', _0: 'BRA', _1: 'Brazil'},
																														_1: {
																															ctor: '::',
																															_0: {ctor: '_Tuple2', _0: 'IOT', _1: 'British Indian Ocean Territory'},
																															_1: {
																																ctor: '::',
																																_0: {ctor: '_Tuple2', _0: 'BRN', _1: 'Brunei Darussalam'},
																																_1: {
																																	ctor: '::',
																																	_0: {ctor: '_Tuple2', _0: 'BGR', _1: 'Bulgaria'},
																																	_1: {
																																		ctor: '::',
																																		_0: {ctor: '_Tuple2', _0: 'BFA', _1: 'Burkina Faso'},
																																		_1: {
																																			ctor: '::',
																																			_0: {ctor: '_Tuple2', _0: 'BDI', _1: 'Burundi'},
																																			_1: {
																																				ctor: '::',
																																				_0: {ctor: '_Tuple2', _0: 'KHM', _1: 'Cambodia'},
																																				_1: {
																																					ctor: '::',
																																					_0: {ctor: '_Tuple2', _0: 'CMR', _1: 'Cameroon'},
																																					_1: {
																																						ctor: '::',
																																						_0: {ctor: '_Tuple2', _0: 'CAN', _1: 'Canada'},
																																						_1: {
																																							ctor: '::',
																																							_0: {ctor: '_Tuple2', _0: 'CPV', _1: 'Cape Verde'},
																																							_1: {
																																								ctor: '::',
																																								_0: {ctor: '_Tuple2', _0: 'CYM', _1: 'Cayman Islands'},
																																								_1: {
																																									ctor: '::',
																																									_0: {ctor: '_Tuple2', _0: 'CAF', _1: 'Central African Republic'},
																																									_1: {
																																										ctor: '::',
																																										_0: {ctor: '_Tuple2', _0: 'TCD', _1: 'Chad'},
																																										_1: {
																																											ctor: '::',
																																											_0: {ctor: '_Tuple2', _0: 'CHL', _1: 'Chile'},
																																											_1: {
																																												ctor: '::',
																																												_0: {ctor: '_Tuple2', _0: 'CHN', _1: 'China'},
																																												_1: {
																																													ctor: '::',
																																													_0: {ctor: '_Tuple2', _0: 'CXR', _1: 'Christmas Island'},
																																													_1: {
																																														ctor: '::',
																																														_0: {ctor: '_Tuple2', _0: 'CCK', _1: 'Cocos (Keeling) Islands'},
																																														_1: {
																																															ctor: '::',
																																															_0: {ctor: '_Tuple2', _0: 'COL', _1: 'Colombia'},
																																															_1: {
																																																ctor: '::',
																																																_0: {ctor: '_Tuple2', _0: 'COM', _1: 'Comoros'},
																																																_1: {
																																																	ctor: '::',
																																																	_0: {ctor: '_Tuple2', _0: 'COG', _1: 'Congo'},
																																																	_1: {
																																																		ctor: '::',
																																																		_0: {ctor: '_Tuple2', _0: 'COD', _1: 'Congo, Democratic Republic Of The'},
																																																		_1: {
																																																			ctor: '::',
																																																			_0: {ctor: '_Tuple2', _0: 'COK', _1: 'Cook Islands'},
																																																			_1: {
																																																				ctor: '::',
																																																				_0: {ctor: '_Tuple2', _0: 'CRI', _1: 'Costa Rica'},
																																																				_1: {
																																																					ctor: '::',
																																																					_0: {ctor: '_Tuple2', _0: 'HRV', _1: 'Croatia'},
																																																					_1: {
																																																						ctor: '::',
																																																						_0: {ctor: '_Tuple2', _0: 'CUB', _1: 'Cuba'},
																																																						_1: {
																																																							ctor: '::',
																																																							_0: {ctor: '_Tuple2', _0: 'CYP', _1: 'Cyprus'},
																																																							_1: {
																																																								ctor: '::',
																																																								_0: {ctor: '_Tuple2', _0: 'CZE', _1: 'Czech Republic'},
																																																								_1: {
																																																									ctor: '::',
																																																									_0: {ctor: '_Tuple2', _0: 'CIV', _1: 'Côte D\'Ivoire'},
																																																									_1: {
																																																										ctor: '::',
																																																										_0: {ctor: '_Tuple2', _0: 'DNK', _1: 'Denmark'},
																																																										_1: {
																																																											ctor: '::',
																																																											_0: {ctor: '_Tuple2', _0: 'DJI', _1: 'Djibouti'},
																																																											_1: {
																																																												ctor: '::',
																																																												_0: {ctor: '_Tuple2', _0: 'DMA', _1: 'Dominica'},
																																																												_1: {
																																																													ctor: '::',
																																																													_0: {ctor: '_Tuple2', _0: 'DOM', _1: 'Dominican Republic'},
																																																													_1: {
																																																														ctor: '::',
																																																														_0: {ctor: '_Tuple2', _0: 'ECU', _1: 'Ecuador'},
																																																														_1: {
																																																															ctor: '::',
																																																															_0: {ctor: '_Tuple2', _0: 'EGY', _1: 'Egypt'},
																																																															_1: {
																																																																ctor: '::',
																																																																_0: {ctor: '_Tuple2', _0: 'SLV', _1: 'El Salvador'},
																																																																_1: {
																																																																	ctor: '::',
																																																																	_0: {ctor: '_Tuple2', _0: 'GNQ', _1: 'Equatorial Guinea'},
																																																																	_1: {
																																																																		ctor: '::',
																																																																		_0: {ctor: '_Tuple2', _0: 'ERI', _1: 'Eritrea'},
																																																																		_1: {
																																																																			ctor: '::',
																																																																			_0: {ctor: '_Tuple2', _0: 'EST', _1: 'Estonia'},
																																																																			_1: {
																																																																				ctor: '::',
																																																																				_0: {ctor: '_Tuple2', _0: 'ETH', _1: 'Ethiopia'},
																																																																				_1: {
																																																																					ctor: '::',
																																																																					_0: {ctor: '_Tuple2', _0: 'FLK', _1: 'Falkland Islands (Malvinas)'},
																																																																					_1: {
																																																																						ctor: '::',
																																																																						_0: {ctor: '_Tuple2', _0: 'FRO', _1: 'Faroe Islands'},
																																																																						_1: {
																																																																							ctor: '::',
																																																																							_0: {ctor: '_Tuple2', _0: 'FJI', _1: 'Fiji'},
																																																																							_1: {
																																																																								ctor: '::',
																																																																								_0: {ctor: '_Tuple2', _0: 'FIN', _1: 'Finland'},
																																																																								_1: {
																																																																									ctor: '::',
																																																																									_0: {ctor: '_Tuple2', _0: 'FRA', _1: 'France'},
																																																																									_1: {
																																																																										ctor: '::',
																																																																										_0: {ctor: '_Tuple2', _0: 'GUF', _1: 'French Guiana'},
																																																																										_1: {
																																																																											ctor: '::',
																																																																											_0: {ctor: '_Tuple2', _0: 'PYF', _1: 'French Polynesia'},
																																																																											_1: {
																																																																												ctor: '::',
																																																																												_0: {ctor: '_Tuple2', _0: 'ATF', _1: 'French Southern Territories'},
																																																																												_1: {
																																																																													ctor: '::',
																																																																													_0: {ctor: '_Tuple2', _0: 'GAB', _1: 'Gabon'},
																																																																													_1: {
																																																																														ctor: '::',
																																																																														_0: {ctor: '_Tuple2', _0: 'GMB', _1: 'Gambia'},
																																																																														_1: {
																																																																															ctor: '::',
																																																																															_0: {ctor: '_Tuple2', _0: 'GEO', _1: 'Georgia'},
																																																																															_1: {
																																																																																ctor: '::',
																																																																																_0: {ctor: '_Tuple2', _0: 'DEU', _1: 'Germany'},
																																																																																_1: {
																																																																																	ctor: '::',
																																																																																	_0: {ctor: '_Tuple2', _0: 'GHA', _1: 'Ghana'},
																																																																																	_1: {
																																																																																		ctor: '::',
																																																																																		_0: {ctor: '_Tuple2', _0: 'GIB', _1: 'Gibraltar'},
																																																																																		_1: {
																																																																																			ctor: '::',
																																																																																			_0: {ctor: '_Tuple2', _0: 'GRC', _1: 'Greece'},
																																																																																			_1: {
																																																																																				ctor: '::',
																																																																																				_0: {ctor: '_Tuple2', _0: 'GRL', _1: 'Greenland'},
																																																																																				_1: {
																																																																																					ctor: '::',
																																																																																					_0: {ctor: '_Tuple2', _0: 'GRD', _1: 'Grenada'},
																																																																																					_1: {
																																																																																						ctor: '::',
																																																																																						_0: {ctor: '_Tuple2', _0: 'GLP', _1: 'Guadeloupe'},
																																																																																						_1: {
																																																																																							ctor: '::',
																																																																																							_0: {ctor: '_Tuple2', _0: 'GUM', _1: 'Guam'},
																																																																																							_1: {
																																																																																								ctor: '::',
																																																																																								_0: {ctor: '_Tuple2', _0: 'GTM', _1: 'Guatemala'},
																																																																																								_1: {
																																																																																									ctor: '::',
																																																																																									_0: {ctor: '_Tuple2', _0: 'GGY', _1: 'Guernsey'},
																																																																																									_1: {
																																																																																										ctor: '::',
																																																																																										_0: {ctor: '_Tuple2', _0: 'GIN', _1: 'Guinea'},
																																																																																										_1: {
																																																																																											ctor: '::',
																																																																																											_0: {ctor: '_Tuple2', _0: 'GNB', _1: 'Guinea-Bissau'},
																																																																																											_1: {
																																																																																												ctor: '::',
																																																																																												_0: {ctor: '_Tuple2', _0: 'GUY', _1: 'Guyana'},
																																																																																												_1: {
																																																																																													ctor: '::',
																																																																																													_0: {ctor: '_Tuple2', _0: 'HTI', _1: 'Haiti'},
																																																																																													_1: {
																																																																																														ctor: '::',
																																																																																														_0: {ctor: '_Tuple2', _0: 'HMD', _1: 'Heard Island And Mcdonald Islands'},
																																																																																														_1: {
																																																																																															ctor: '::',
																																																																																															_0: {ctor: '_Tuple2', _0: 'VAT', _1: 'Holy See(Vatican City State)'},
																																																																																															_1: {
																																																																																																ctor: '::',
																																																																																																_0: {ctor: '_Tuple2', _0: 'HND', _1: 'Honduras'},
																																																																																																_1: {
																																																																																																	ctor: '::',
																																																																																																	_0: {ctor: '_Tuple2', _0: 'HKG', _1: 'Hong Kong'},
																																																																																																	_1: {
																																																																																																		ctor: '::',
																																																																																																		_0: {ctor: '_Tuple2', _0: 'HUN', _1: 'Hungary'},
																																																																																																		_1: {
																																																																																																			ctor: '::',
																																																																																																			_0: {ctor: '_Tuple2', _0: 'ISL', _1: 'Iceland'},
																																																																																																			_1: {
																																																																																																				ctor: '::',
																																																																																																				_0: {ctor: '_Tuple2', _0: 'IND', _1: 'India'},
																																																																																																				_1: {
																																																																																																					ctor: '::',
																																																																																																					_0: {ctor: '_Tuple2', _0: 'IDN', _1: 'Indonesia'},
																																																																																																					_1: {
																																																																																																						ctor: '::',
																																																																																																						_0: {ctor: '_Tuple2', _0: 'IRN', _1: 'Iran, Islamic Republic Of'},
																																																																																																						_1: {
																																																																																																							ctor: '::',
																																																																																																							_0: {ctor: '_Tuple2', _0: 'IRQ', _1: 'Iraq'},
																																																																																																							_1: {
																																																																																																								ctor: '::',
																																																																																																								_0: {ctor: '_Tuple2', _0: 'IRL', _1: 'Ireland'},
																																																																																																								_1: {
																																																																																																									ctor: '::',
																																																																																																									_0: {ctor: '_Tuple2', _0: 'IMN', _1: 'Isle Of Man'},
																																																																																																									_1: {
																																																																																																										ctor: '::',
																																																																																																										_0: {ctor: '_Tuple2', _0: 'ISR', _1: 'Israel'},
																																																																																																										_1: {
																																																																																																											ctor: '::',
																																																																																																											_0: {ctor: '_Tuple2', _0: 'ITA', _1: 'Italy'},
																																																																																																											_1: {
																																																																																																												ctor: '::',
																																																																																																												_0: {ctor: '_Tuple2', _0: 'JAM', _1: 'Jamaica'},
																																																																																																												_1: {
																																																																																																													ctor: '::',
																																																																																																													_0: {ctor: '_Tuple2', _0: 'JPN', _1: 'Japan'},
																																																																																																													_1: {
																																																																																																														ctor: '::',
																																																																																																														_0: {ctor: '_Tuple2', _0: 'JEY', _1: 'Jersey'},
																																																																																																														_1: {
																																																																																																															ctor: '::',
																																																																																																															_0: {ctor: '_Tuple2', _0: 'JOR', _1: 'Jordan'},
																																																																																																															_1: {
																																																																																																																ctor: '::',
																																																																																																																_0: {ctor: '_Tuple2', _0: 'KAZ', _1: 'Kazakhstan'},
																																																																																																																_1: {
																																																																																																																	ctor: '::',
																																																																																																																	_0: {ctor: '_Tuple2', _0: 'KEN', _1: 'Kenya'},
																																																																																																																	_1: {
																																																																																																																		ctor: '::',
																																																																																																																		_0: {ctor: '_Tuple2', _0: 'KIR', _1: 'Kiribati'},
																																																																																																																		_1: {
																																																																																																																			ctor: '::',
																																																																																																																			_0: {ctor: '_Tuple2', _0: 'PRK', _1: 'Korea, Democratic People\'s Republic Of'},
																																																																																																																			_1: {
																																																																																																																				ctor: '::',
																																																																																																																				_0: {ctor: '_Tuple2', _0: 'KOR', _1: 'Korea, Republic Of'},
																																																																																																																				_1: {
																																																																																																																					ctor: '::',
																																																																																																																					_0: {ctor: '_Tuple2', _0: 'KVO', _1: 'Kosovo'},
																																																																																																																					_1: {
																																																																																																																						ctor: '::',
																																																																																																																						_0: {ctor: '_Tuple2', _0: 'KWT', _1: 'Kuwait'},
																																																																																																																						_1: {
																																																																																																																							ctor: '::',
																																																																																																																							_0: {ctor: '_Tuple2', _0: 'KGZ', _1: 'Kyrgyzstan'},
																																																																																																																							_1: {
																																																																																																																								ctor: '::',
																																																																																																																								_0: {ctor: '_Tuple2', _0: 'LAO', _1: 'Lao People\'s Democratic Republic'},
																																																																																																																								_1: {
																																																																																																																									ctor: '::',
																																																																																																																									_0: {ctor: '_Tuple2', _0: 'LVA', _1: 'Latvia'},
																																																																																																																									_1: {
																																																																																																																										ctor: '::',
																																																																																																																										_0: {ctor: '_Tuple2', _0: 'LBN', _1: 'Lebanon'},
																																																																																																																										_1: {
																																																																																																																											ctor: '::',
																																																																																																																											_0: {ctor: '_Tuple2', _0: 'LSO', _1: 'Lesotho'},
																																																																																																																											_1: {
																																																																																																																												ctor: '::',
																																																																																																																												_0: {ctor: '_Tuple2', _0: 'LBR', _1: 'Liberia'},
																																																																																																																												_1: {
																																																																																																																													ctor: '::',
																																																																																																																													_0: {ctor: '_Tuple2', _0: 'LBY', _1: 'Libyan Arab Jamahiriya'},
																																																																																																																													_1: {
																																																																																																																														ctor: '::',
																																																																																																																														_0: {ctor: '_Tuple2', _0: 'LIE', _1: 'Liechtenstein'},
																																																																																																																														_1: {
																																																																																																																															ctor: '::',
																																																																																																																															_0: {ctor: '_Tuple2', _0: 'LTU', _1: 'Lithuania'},
																																																																																																																															_1: {
																																																																																																																																ctor: '::',
																																																																																																																																_0: {ctor: '_Tuple2', _0: 'LUX', _1: 'Luxembourg'},
																																																																																																																																_1: {
																																																																																																																																	ctor: '::',
																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'MAC', _1: 'Macao'},
																																																																																																																																	_1: {
																																																																																																																																		ctor: '::',
																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'MKD', _1: 'Macedonia, The Former Yugoslav Republic Of'},
																																																																																																																																		_1: {
																																																																																																																																			ctor: '::',
																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'MDG', _1: 'Madagascar'},
																																																																																																																																			_1: {
																																																																																																																																				ctor: '::',
																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'MWI', _1: 'Malawi'},
																																																																																																																																				_1: {
																																																																																																																																					ctor: '::',
																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'MYS', _1: 'Malaysia'},
																																																																																																																																					_1: {
																																																																																																																																						ctor: '::',
																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'MDV', _1: 'Maldives'},
																																																																																																																																						_1: {
																																																																																																																																							ctor: '::',
																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'MLI', _1: 'Mali'},
																																																																																																																																							_1: {
																																																																																																																																								ctor: '::',
																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'MLT', _1: 'Malta'},
																																																																																																																																								_1: {
																																																																																																																																									ctor: '::',
																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'MHL', _1: 'Marshall Islands'},
																																																																																																																																									_1: {
																																																																																																																																										ctor: '::',
																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'MTQ', _1: 'Martinique'},
																																																																																																																																										_1: {
																																																																																																																																											ctor: '::',
																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'MRT', _1: 'Mauritania'},
																																																																																																																																											_1: {
																																																																																																																																												ctor: '::',
																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'MUS', _1: 'Mauritius'},
																																																																																																																																												_1: {
																																																																																																																																													ctor: '::',
																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'MYT', _1: 'Mayotte'},
																																																																																																																																													_1: {
																																																																																																																																														ctor: '::',
																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'MEX', _1: 'Mexico'},
																																																																																																																																														_1: {
																																																																																																																																															ctor: '::',
																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'FSM', _1: 'Micronesia, Federated States Of'},
																																																																																																																																															_1: {
																																																																																																																																																ctor: '::',
																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'MDA', _1: 'Moldova, Republic Of'},
																																																																																																																																																_1: {
																																																																																																																																																	ctor: '::',
																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'MCO', _1: 'Monaco'},
																																																																																																																																																	_1: {
																																																																																																																																																		ctor: '::',
																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'MNG', _1: 'Mongolia'},
																																																																																																																																																		_1: {
																																																																																																																																																			ctor: '::',
																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'MNE', _1: 'Montenegro'},
																																																																																																																																																			_1: {
																																																																																																																																																				ctor: '::',
																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'MSR', _1: 'Montserrat'},
																																																																																																																																																				_1: {
																																																																																																																																																					ctor: '::',
																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'MAR', _1: 'Morocco'},
																																																																																																																																																					_1: {
																																																																																																																																																						ctor: '::',
																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'MOZ', _1: 'Mozambique'},
																																																																																																																																																						_1: {
																																																																																																																																																							ctor: '::',
																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'MMR', _1: 'Myanmar'},
																																																																																																																																																							_1: {
																																																																																																																																																								ctor: '::',
																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'NAM', _1: 'Namibia'},
																																																																																																																																																								_1: {
																																																																																																																																																									ctor: '::',
																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'NRU', _1: 'Nauru'},
																																																																																																																																																									_1: {
																																																																																																																																																										ctor: '::',
																																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'NPL', _1: 'Nepal'},
																																																																																																																																																										_1: {
																																																																																																																																																											ctor: '::',
																																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'NLD', _1: 'Netherlands'},
																																																																																																																																																											_1: {
																																																																																																																																																												ctor: '::',
																																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'ANT', _1: 'Netherlands Antilles'},
																																																																																																																																																												_1: {
																																																																																																																																																													ctor: '::',
																																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'NCL', _1: 'New Caledonia'},
																																																																																																																																																													_1: {
																																																																																																																																																														ctor: '::',
																																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'NZL', _1: 'New Zealand'},
																																																																																																																																																														_1: {
																																																																																																																																																															ctor: '::',
																																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'NIC', _1: 'Nicaragua'},
																																																																																																																																																															_1: {
																																																																																																																																																																ctor: '::',
																																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'NER', _1: 'Niger'},
																																																																																																																																																																_1: {
																																																																																																																																																																	ctor: '::',
																																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'NGA', _1: 'Nigeria'},
																																																																																																																																																																	_1: {
																																																																																																																																																																		ctor: '::',
																																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'NIU', _1: 'Niue'},
																																																																																																																																																																		_1: {
																																																																																																																																																																			ctor: '::',
																																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'NFK', _1: 'Norfolk Island'},
																																																																																																																																																																			_1: {
																																																																																																																																																																				ctor: '::',
																																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'MNP', _1: 'Northern Mariana Islands'},
																																																																																																																																																																				_1: {
																																																																																																																																																																					ctor: '::',
																																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'NOR', _1: 'Norway'},
																																																																																																																																																																					_1: {
																																																																																																																																																																						ctor: '::',
																																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'OMN', _1: 'Oman'},
																																																																																																																																																																						_1: {
																																																																																																																																																																							ctor: '::',
																																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'PAK', _1: 'Pakistan'},
																																																																																																																																																																							_1: {
																																																																																																																																																																								ctor: '::',
																																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'PLW', _1: 'Palau'},
																																																																																																																																																																								_1: {
																																																																																																																																																																									ctor: '::',
																																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'PSE', _1: 'Palestinian Territory, Occupied'},
																																																																																																																																																																									_1: {
																																																																																																																																																																										ctor: '::',
																																																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'PAN', _1: 'Panama'},
																																																																																																																																																																										_1: {
																																																																																																																																																																											ctor: '::',
																																																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'PNG', _1: 'Papua New Guinea'},
																																																																																																																																																																											_1: {
																																																																																																																																																																												ctor: '::',
																																																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'PRY', _1: 'Paraguay'},
																																																																																																																																																																												_1: {
																																																																																																																																																																													ctor: '::',
																																																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'PER', _1: 'Peru'},
																																																																																																																																																																													_1: {
																																																																																																																																																																														ctor: '::',
																																																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'PHL', _1: 'Philippines'},
																																																																																																																																																																														_1: {
																																																																																																																																																																															ctor: '::',
																																																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'PCN', _1: 'Pitcairn'},
																																																																																																																																																																															_1: {
																																																																																																																																																																																ctor: '::',
																																																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'POL', _1: 'Poland'},
																																																																																																																																																																																_1: {
																																																																																																																																																																																	ctor: '::',
																																																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'PRT', _1: 'Portugal'},
																																																																																																																																																																																	_1: {
																																																																																																																																																																																		ctor: '::',
																																																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'PRI', _1: 'Puerto Rico'},
																																																																																																																																																																																		_1: {
																																																																																																																																																																																			ctor: '::',
																																																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'QAT', _1: 'Qatar'},
																																																																																																																																																																																			_1: {
																																																																																																																																																																																				ctor: '::',
																																																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'ROU', _1: 'Romania'},
																																																																																																																																																																																				_1: {
																																																																																																																																																																																					ctor: '::',
																																																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'RUS', _1: 'Russian Federation'},
																																																																																																																																																																																					_1: {
																																																																																																																																																																																						ctor: '::',
																																																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'RWA', _1: 'Rwanda'},
																																																																																																																																																																																						_1: {
																																																																																																																																																																																							ctor: '::',
																																																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'REU', _1: 'Réunion'},
																																																																																																																																																																																							_1: {
																																																																																																																																																																																								ctor: '::',
																																																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'BLM', _1: 'Saint Barthélemy'},
																																																																																																																																																																																								_1: {
																																																																																																																																																																																									ctor: '::',
																																																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'SHN', _1: 'Saint Helena, Ascension And Tristan Da Cunha'},
																																																																																																																																																																																									_1: {
																																																																																																																																																																																										ctor: '::',
																																																																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'KNA', _1: 'Saint Kitts And Nevis'},
																																																																																																																																																																																										_1: {
																																																																																																																																																																																											ctor: '::',
																																																																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'LCA', _1: 'Saint Lucia'},
																																																																																																																																																																																											_1: {
																																																																																																																																																																																												ctor: '::',
																																																																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'MAF', _1: 'Saint Martin (French Part)'},
																																																																																																																																																																																												_1: {
																																																																																																																																																																																													ctor: '::',
																																																																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'SPM', _1: 'Saint Pierre And Miquelon'},
																																																																																																																																																																																													_1: {
																																																																																																																																																																																														ctor: '::',
																																																																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'VCT', _1: 'Saint Vincent And The Grenadines'},
																																																																																																																																																																																														_1: {
																																																																																																																																																																																															ctor: '::',
																																																																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'WSM', _1: 'Samoa'},
																																																																																																																																																																																															_1: {
																																																																																																																																																																																																ctor: '::',
																																																																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'SMR', _1: 'San Marino'},
																																																																																																																																																																																																_1: {
																																																																																																																																																																																																	ctor: '::',
																																																																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'STP', _1: 'Sao Tome And Principe'},
																																																																																																																																																																																																	_1: {
																																																																																																																																																																																																		ctor: '::',
																																																																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'SAU', _1: 'Saudi Arabia'},
																																																																																																																																																																																																		_1: {
																																																																																																																																																																																																			ctor: '::',
																																																																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'SEN', _1: 'Senegal'},
																																																																																																																																																																																																			_1: {
																																																																																																																																																																																																				ctor: '::',
																																																																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'SRB', _1: 'Serbia'},
																																																																																																																																																																																																				_1: {
																																																																																																																																																																																																					ctor: '::',
																																																																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'SYC', _1: 'Seychelles'},
																																																																																																																																																																																																					_1: {
																																																																																																																																																																																																						ctor: '::',
																																																																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'SLE', _1: 'Sierra Leone'},
																																																																																																																																																																																																						_1: {
																																																																																																																																																																																																							ctor: '::',
																																																																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'SGP', _1: 'Singapore'},
																																																																																																																																																																																																							_1: {
																																																																																																																																																																																																								ctor: '::',
																																																																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'SVK', _1: 'Slovakia'},
																																																																																																																																																																																																								_1: {
																																																																																																																																																																																																									ctor: '::',
																																																																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'SVN', _1: 'Slovenia'},
																																																																																																																																																																																																									_1: {
																																																																																																																																																																																																										ctor: '::',
																																																																																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'SLB', _1: 'Solomon Islands'},
																																																																																																																																																																																																										_1: {
																																																																																																																																																																																																											ctor: '::',
																																																																																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'SOM', _1: 'Somalia'},
																																																																																																																																																																																																											_1: {
																																																																																																																																																																																																												ctor: '::',
																																																																																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'ZAF', _1: 'South Africa'},
																																																																																																																																																																																																												_1: {
																																																																																																																																																																																																													ctor: '::',
																																																																																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'SGS', _1: 'South Georgia And The South Sandwich Islands'},
																																																																																																																																																																																																													_1: {
																																																																																																																																																																																																														ctor: '::',
																																																																																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'ESP', _1: 'Spain'},
																																																																																																																																																																																																														_1: {
																																																																																																																																																																																																															ctor: '::',
																																																																																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'LKA', _1: 'Sri Lanka'},
																																																																																																																																																																																																															_1: {
																																																																																																																																																																																																																ctor: '::',
																																																																																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'STL', _1: 'Stateless'},
																																																																																																																																																																																																																_1: {
																																																																																																																																																																																																																	ctor: '::',
																																																																																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'SDN', _1: 'Sudan'},
																																																																																																																																																																																																																	_1: {
																																																																																																																																																																																																																		ctor: '::',
																																																																																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'SUR', _1: 'Suriname'},
																																																																																																																																																																																																																		_1: {
																																																																																																																																																																																																																			ctor: '::',
																																																																																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'SJM', _1: 'Svalbard And Jan Mayen'},
																																																																																																																																																																																																																			_1: {
																																																																																																																																																																																																																				ctor: '::',
																																																																																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'SWZ', _1: 'Swaziland'},
																																																																																																																																																																																																																				_1: {
																																																																																																																																																																																																																					ctor: '::',
																																																																																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'SWE', _1: 'Sweden'},
																																																																																																																																																																																																																					_1: {
																																																																																																																																																																																																																						ctor: '::',
																																																																																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'CHE', _1: 'Switzerland'},
																																																																																																																																																																																																																						_1: {
																																																																																																																																																																																																																							ctor: '::',
																																																																																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'SYR', _1: 'Syrian Arab Republic'},
																																																																																																																																																																																																																							_1: {
																																																																																																																																																																																																																								ctor: '::',
																																																																																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'TWN', _1: 'Taiwan, Province Of China'},
																																																																																																																																																																																																																								_1: {
																																																																																																																																																																																																																									ctor: '::',
																																																																																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'TJK', _1: 'Tajikistan'},
																																																																																																																																																																																																																									_1: {
																																																																																																																																																																																																																										ctor: '::',
																																																																																																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'TZA', _1: 'Tanzania, United Republic Of'},
																																																																																																																																																																																																																										_1: {
																																																																																																																																																																																																																											ctor: '::',
																																																																																																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'THA', _1: 'Thailand'},
																																																																																																																																																																																																																											_1: {
																																																																																																																																																																																																																												ctor: '::',
																																																																																																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'TLS', _1: 'Timor-Leste'},
																																																																																																																																																																																																																												_1: {
																																																																																																																																																																																																																													ctor: '::',
																																																																																																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'TGO', _1: 'Togo'},
																																																																																																																																																																																																																													_1: {
																																																																																																																																																																																																																														ctor: '::',
																																																																																																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'TKL', _1: 'Tokelau'},
																																																																																																																																																																																																																														_1: {
																																																																																																																																																																																																																															ctor: '::',
																																																																																																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'TON', _1: 'Tonga'},
																																																																																																																																																																																																																															_1: {
																																																																																																																																																																																																																																ctor: '::',
																																																																																																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'TTO', _1: 'Trinidad And Tobago'},
																																																																																																																																																																																																																																_1: {
																																																																																																																																																																																																																																	ctor: '::',
																																																																																																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'TUN', _1: 'Tunisia'},
																																																																																																																																																																																																																																	_1: {
																																																																																																																																																																																																																																		ctor: '::',
																																																																																																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'TUR', _1: 'Turkey'},
																																																																																																																																																																																																																																		_1: {
																																																																																																																																																																																																																																			ctor: '::',
																																																																																																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'TKM', _1: 'Turkmenistan'},
																																																																																																																																																																																																																																			_1: {
																																																																																																																																																																																																																																				ctor: '::',
																																																																																																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'TCA', _1: 'Turks And Caicos Islands'},
																																																																																																																																																																																																																																				_1: {
																																																																																																																																																																																																																																					ctor: '::',
																																																																																																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'TUV', _1: 'Tuvalu'},
																																																																																																																																																																																																																																					_1: {
																																																																																																																																																																																																																																						ctor: '::',
																																																																																																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'UGA', _1: 'Uganda'},
																																																																																																																																																																																																																																						_1: {
																																																																																																																																																																																																																																							ctor: '::',
																																																																																																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'UKR', _1: 'Ukraine'},
																																																																																																																																																																																																																																							_1: {
																																																																																																																																																																																																																																								ctor: '::',
																																																																																																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'ARE', _1: 'United Arab Emirates'},
																																																																																																																																																																																																																																								_1: {
																																																																																																																																																																																																																																									ctor: '::',
																																																																																																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'GBR', _1: 'United Kingdom'},
																																																																																																																																																																																																																																									_1: {
																																																																																																																																																																																																																																										ctor: '::',
																																																																																																																																																																																																																																										_0: {ctor: '_Tuple2', _0: 'USA', _1: 'United States'},
																																																																																																																																																																																																																																										_1: {
																																																																																																																																																																																																																																											ctor: '::',
																																																																																																																																																																																																																																											_0: {ctor: '_Tuple2', _0: 'UMI', _1: 'United States Minor Outlying Islands'},
																																																																																																																																																																																																																																											_1: {
																																																																																																																																																																																																																																												ctor: '::',
																																																																																																																																																																																																																																												_0: {ctor: '_Tuple2', _0: 'ABC', _1: 'Unknown'},
																																																																																																																																																																																																																																												_1: {
																																																																																																																																																																																																																																													ctor: '::',
																																																																																																																																																																																																																																													_0: {ctor: '_Tuple2', _0: 'URY', _1: 'Uruguay'},
																																																																																																																																																																																																																																													_1: {
																																																																																																																																																																																																																																														ctor: '::',
																																																																																																																																																																																																																																														_0: {ctor: '_Tuple2', _0: 'UZB', _1: 'Uzbekistan'},
																																																																																																																																																																																																																																														_1: {
																																																																																																																																																																																																																																															ctor: '::',
																																																																																																																																																																																																																																															_0: {ctor: '_Tuple2', _0: 'VUT', _1: 'Vanuatu'},
																																																																																																																																																																																																																																															_1: {
																																																																																																																																																																																																																																																ctor: '::',
																																																																																																																																																																																																																																																_0: {ctor: '_Tuple2', _0: 'VEN', _1: 'Venezuela, Bolivarian Republic Of'},
																																																																																																																																																																																																																																																_1: {
																																																																																																																																																																																																																																																	ctor: '::',
																																																																																																																																																																																																																																																	_0: {ctor: '_Tuple2', _0: 'VNM', _1: 'Viet Nam'},
																																																																																																																																																																																																																																																	_1: {
																																																																																																																																																																																																																																																		ctor: '::',
																																																																																																																																																																																																																																																		_0: {ctor: '_Tuple2', _0: 'VGB', _1: 'Virgin Islands (British)'},
																																																																																																																																																																																																																																																		_1: {
																																																																																																																																																																																																																																																			ctor: '::',
																																																																																																																																																																																																																																																			_0: {ctor: '_Tuple2', _0: 'VIR', _1: 'Virgin Islands (U.S.)'},
																																																																																																																																																																																																																																																			_1: {
																																																																																																																																																																																																																																																				ctor: '::',
																																																																																																																																																																																																																																																				_0: {ctor: '_Tuple2', _0: 'WLF', _1: 'Wallis And Futuna'},
																																																																																																																																																																																																																																																				_1: {
																																																																																																																																																																																																																																																					ctor: '::',
																																																																																																																																																																																																																																																					_0: {ctor: '_Tuple2', _0: 'ESH', _1: 'Western Sahara'},
																																																																																																																																																																																																																																																					_1: {
																																																																																																																																																																																																																																																						ctor: '::',
																																																																																																																																																																																																																																																						_0: {ctor: '_Tuple2', _0: 'YEM', _1: 'Yemen'},
																																																																																																																																																																																																																																																						_1: {
																																																																																																																																																																																																																																																							ctor: '::',
																																																																																																																																																																																																																																																							_0: {ctor: '_Tuple2', _0: 'ZMB', _1: 'Zambia'},
																																																																																																																																																																																																																																																							_1: {
																																																																																																																																																																																																																																																								ctor: '::',
																																																																																																																																																																																																																																																								_0: {ctor: '_Tuple2', _0: 'ZWE', _1: 'Zimbabwe'},
																																																																																																																																																																																																																																																								_1: {
																																																																																																																																																																																																																																																									ctor: '::',
																																																																																																																																																																																																																																																									_0: {ctor: '_Tuple2', _0: 'ALA', _1: 'Åland Islands'},
																																																																																																																																																																																																																																																									_1: {ctor: '[]'}
																																																																																																																																																																																																																																																								}
																																																																																																																																																																																																																																																							}
																																																																																																																																																																																																																																																						}
																																																																																																																																																																																																																																																					}
																																																																																																																																																																																																																																																				}
																																																																																																																																																																																																																																																			}
																																																																																																																																																																																																																																																		}
																																																																																																																																																																																																																																																	}
																																																																																																																																																																																																																																																}
																																																																																																																																																																																																																																															}
																																																																																																																																																																																																																																														}
																																																																																																																																																																																																																																													}
																																																																																																																																																																																																																																												}
																																																																																																																																																																																																																																											}
																																																																																																																																																																																																																																										}
																																																																																																																																																																																																																																									}
																																																																																																																																																																																																																																								}
																																																																																																																																																																																																																																							}
																																																																																																																																																																																																																																						}
																																																																																																																																																																																																																																					}
																																																																																																																																																																																																																																				}
																																																																																																																																																																																																																																			}
																																																																																																																																																																																																																																		}
																																																																																																																																																																																																																																	}
																																																																																																																																																																																																																																}
																																																																																																																																																																																																																															}
																																																																																																																																																																																																																														}
																																																																																																																																																																																																																													}
																																																																																																																																																																																																																												}
																																																																																																																																																																																																																											}
																																																																																																																																																																																																																										}
																																																																																																																																																																																																																									}
																																																																																																																																																																																																																								}
																																																																																																																																																																																																																							}
																																																																																																																																																																																																																						}
																																																																																																																																																																																																																					}
																																																																																																																																																																																																																				}
																																																																																																																																																																																																																			}
																																																																																																																																																																																																																		}
																																																																																																																																																																																																																	}
																																																																																																																																																																																																																}
																																																																																																																																																																																																															}
																																																																																																																																																																																																														}
																																																																																																																																																																																																													}
																																																																																																																																																																																																												}
																																																																																																																																																																																																											}
																																																																																																																																																																																																										}
																																																																																																																																																																																																									}
																																																																																																																																																																																																								}
																																																																																																																																																																																																							}
																																																																																																																																																																																																						}
																																																																																																																																																																																																					}
																																																																																																																																																																																																				}
																																																																																																																																																																																																			}
																																																																																																																																																																																																		}
																																																																																																																																																																																																	}
																																																																																																																																																																																																}
																																																																																																																																																																																															}
																																																																																																																																																																																														}
																																																																																																																																																																																													}
																																																																																																																																																																																												}
																																																																																																																																																																																											}
																																																																																																																																																																																										}
																																																																																																																																																																																									}
																																																																																																																																																																																								}
																																																																																																																																																																																							}
																																																																																																																																																																																						}
																																																																																																																																																																																					}
																																																																																																																																																																																				}
																																																																																																																																																																																			}
																																																																																																																																																																																		}
																																																																																																																																																																																	}
																																																																																																																																																																																}
																																																																																																																																																																															}
																																																																																																																																																																														}
																																																																																																																																																																													}
																																																																																																																																																																												}
																																																																																																																																																																											}
																																																																																																																																																																										}
																																																																																																																																																																									}
																																																																																																																																																																								}
																																																																																																																																																																							}
																																																																																																																																																																						}
																																																																																																																																																																					}
																																																																																																																																																																				}
																																																																																																																																																																			}
																																																																																																																																																																		}
																																																																																																																																																																	}
																																																																																																																																																																}
																																																																																																																																																															}
																																																																																																																																																														}
																																																																																																																																																													}
																																																																																																																																																												}
																																																																																																																																																											}
																																																																																																																																																										}
																																																																																																																																																									}
																																																																																																																																																								}
																																																																																																																																																							}
																																																																																																																																																						}
																																																																																																																																																					}
																																																																																																																																																				}
																																																																																																																																																			}
																																																																																																																																																		}
																																																																																																																																																	}
																																																																																																																																																}
																																																																																																																																															}
																																																																																																																																														}
																																																																																																																																													}
																																																																																																																																												}
																																																																																																																																											}
																																																																																																																																										}
																																																																																																																																									}
																																																																																																																																								}
																																																																																																																																							}
																																																																																																																																						}
																																																																																																																																					}
																																																																																																																																				}
																																																																																																																																			}
																																																																																																																																		}
																																																																																																																																	}
																																																																																																																																}
																																																																																																																															}
																																																																																																																														}
																																																																																																																													}
																																																																																																																												}
																																																																																																																											}
																																																																																																																										}
																																																																																																																									}
																																																																																																																								}
																																																																																																																							}
																																																																																																																						}
																																																																																																																					}
																																																																																																																				}
																																																																																																																			}
																																																																																																																		}
																																																																																																																	}
																																																																																																																}
																																																																																																															}
																																																																																																														}
																																																																																																													}
																																																																																																												}
																																																																																																											}
																																																																																																										}
																																																																																																									}
																																																																																																								}
																																																																																																							}
																																																																																																						}
																																																																																																					}
																																																																																																				}
																																																																																																			}
																																																																																																		}
																																																																																																	}
																																																																																																}
																																																																																															}
																																																																																														}
																																																																																													}
																																																																																												}
																																																																																											}
																																																																																										}
																																																																																									}
																																																																																								}
																																																																																							}
																																																																																						}
																																																																																					}
																																																																																				}
																																																																																			}
																																																																																		}
																																																																																	}
																																																																																}
																																																																															}
																																																																														}
																																																																													}
																																																																												}
																																																																											}
																																																																										}
																																																																									}
																																																																								}
																																																																							}
																																																																						}
																																																																					}
																																																																				}
																																																																			}
																																																																		}
																																																																	}
																																																																}
																																																															}
																																																														}
																																																													}
																																																												}
																																																											}
																																																										}
																																																									}
																																																								}
																																																							}
																																																						}
																																																					}
																																																				}
																																																			}
																																																		}
																																																	}
																																																}
																																															}
																																														}
																																													}
																																												}
																																											}
																																										}
																																									}
																																								}
																																							}
																																						}
																																					}
																																				}
																																			}
																																		}
																																	}
																																}
																															}
																														}
																													}
																												}
																											}
																										}
																									}
																								}
																							}
																						}
																					}
																				}
																			}
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
};

var _CareerPlug$ats$Models_Question$questionFromInternal = F2(
	function (search, questions) {
		var find = function (q) {
			var _p0 = q.internalName;
			if (_p0.ctor === 'Just') {
				return _elm_lang$core$Native_Utils.eq(_p0._0, search);
			} else {
				return false;
			}
		};
		return _elm_lang$core$List$head(
			A2(_elm_lang$core$List$filter, find, questions));
	});
var _CareerPlug$ats$Models_Question$findAnswer = F2(
	function (question, strId) {
		var ansByText = function (t) {
			return _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filter,
					function (a) {
						return _elm_lang$core$Native_Utils.eq(a.name, t);
					},
					question.answers));
		};
		var ansById = function (i) {
			return _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filter,
					function (a) {
						return _elm_lang$core$Native_Utils.eq(a.id, i);
					},
					question.answers));
		};
		var _p1 = _elm_lang$core$String$toInt(strId);
		if (_p1.ctor === 'Ok') {
			return ansById(_p1._0);
		} else {
			return ansByText(strId);
		}
	});
var _CareerPlug$ats$Models_Question$jsonSize = function () {
	var stringInt = function (s) {
		var _p2 = _elm_lang$core$String$toInt(s);
		if (_p2.ctor === 'Ok') {
			return _p2._0;
		} else {
			return 12;
		}
	};
	return A2(_elm_lang$core$Json_Decode$map, stringInt, _elm_lang$core$Json_Decode$string);
}();
var _CareerPlug$ats$Models_Question$questionNamePrefix = 'question_';
var _CareerPlug$ats$Models_Question$questionNameR = _elm_lang$core$Regex$regex(_CareerPlug$ats$Models_Question$questionNamePrefix);
var _CareerPlug$ats$Models_Question$questionFromName = F2(
	function (questions, name) {
		return A2(
			_elm_lang$core$Maybe$andThen,
			function (i) {
				return _elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$filter,
						function (q) {
							return _elm_lang$core$Native_Utils.eq(q.id, i);
						},
						questions));
			},
			_elm_lang$core$Result$toMaybe(
				_elm_lang$core$String$toInt(
					A4(
						_elm_lang$core$Regex$replace,
						_elm_lang$core$Regex$All,
						_CareerPlug$ats$Models_Question$questionNameR,
						function (_p3) {
							return '';
						},
						name))));
	});
var _CareerPlug$ats$Models_Question$questionName = function (q) {
	return A2(
		_elm_lang$core$Basics_ops['++'],
		_CareerPlug$ats$Models_Question$questionNamePrefix,
		_elm_lang$core$Basics$toString(q.id));
};
var _CareerPlug$ats$Models_Question$Question = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return {id: a, name: b, questionType: c, prefill: d, order: e, visibility: f, answers: g, required: h, description: i, page: j, position: k, serverError: l, size: m, overflow: n, align: o, opaque: p, spacing: q, internalName: r};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$Models_Question$Answer = F4(
	function (a, b, c, d) {
		return {id: a, name: b, order: c, position: d};
	});
var _CareerPlug$ats$Models_Question$Position = F4(
	function (a, b, c, d) {
		return {left: a, top: b, width: c, height: d};
	});
var _CareerPlug$ats$Models_Question$jsonPosition = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'pos',
	A2(_elm_lang$core$Json_Decode$index, 3, _elm_lang$core$Json_Decode$float),
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'pos',
		A2(_elm_lang$core$Json_Decode$index, 2, _elm_lang$core$Json_Decode$float),
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'pos',
			A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$float),
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'pos',
				A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$float),
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_Question$Position)))));
var _CareerPlug$ats$Models_Question$jsonAnswer = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'data',
	_CareerPlug$ats$Models_Question$jsonPosition,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'position',
		_elm_lang$core$Json_Decode$int,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'name',
			_elm_lang$core$Json_Decode$string,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'id',
				_elm_lang$core$Json_Decode$int,
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_Question$Answer)))));
var _CareerPlug$ats$Models_Question$ZipField = {ctor: 'ZipField'};
var _CareerPlug$ats$Models_Question$YesNoField = {ctor: 'YesNoField'};
var _CareerPlug$ats$Models_Question$UrlField = {ctor: 'UrlField'};
var _CareerPlug$ats$Models_Question$TextAreaField = {ctor: 'TextAreaField'};
var _CareerPlug$ats$Models_Question$TextField = {ctor: 'TextField'};
var _CareerPlug$ats$Models_Question$StateField = {ctor: 'StateField'};
var _CareerPlug$ats$Models_Question$SignatureField = {ctor: 'SignatureField'};
var _CareerPlug$ats$Models_Question$SelectField = {ctor: 'SelectField'};
var _CareerPlug$ats$Models_Question$RadioField = {ctor: 'RadioField'};
var _CareerPlug$ats$Models_Question$PhoneField = {ctor: 'PhoneField'};
var _CareerPlug$ats$Models_Question$PercentageField = {ctor: 'PercentageField'};
var _CareerPlug$ats$Models_Question$MultiSelectField = {ctor: 'MultiSelectField'};
var _CareerPlug$ats$Models_Question$MoneyField = {ctor: 'MoneyField'};
var _CareerPlug$ats$Models_Question$IntegerField = {ctor: 'IntegerField'};
var _CareerPlug$ats$Models_Question$EmailField = {ctor: 'EmailField'};
var _CareerPlug$ats$Models_Question$DecimalField = {ctor: 'DecimalField'};
var _CareerPlug$ats$Models_Question$DateField = {ctor: 'DateField'};
var _CareerPlug$ats$Models_Question$CountryField = {ctor: 'CountryField'};
var _CareerPlug$ats$Models_Question$CheckboxField = {ctor: 'CheckboxField'};
var _CareerPlug$ats$Models_Question$strQuestionType = function (s) {
	var _p4 = s;
	switch (_p4) {
		case 'checkbox_field':
			return _CareerPlug$ats$Models_Question$CheckboxField;
		case 'country_field':
			return _CareerPlug$ats$Models_Question$CountryField;
		case 'date_field':
			return _CareerPlug$ats$Models_Question$DateField;
		case 'decimal_field':
			return _CareerPlug$ats$Models_Question$DecimalField;
		case 'email_field':
			return _CareerPlug$ats$Models_Question$EmailField;
		case 'integer_field':
			return _CareerPlug$ats$Models_Question$IntegerField;
		case 'money_field':
			return _CareerPlug$ats$Models_Question$MoneyField;
		case 'multiselect_field':
			return _CareerPlug$ats$Models_Question$MultiSelectField;
		case 'percentage_field':
			return _CareerPlug$ats$Models_Question$PercentageField;
		case 'phone_field':
			return _CareerPlug$ats$Models_Question$PhoneField;
		case 'radio_field':
			return _CareerPlug$ats$Models_Question$RadioField;
		case 'select_field':
			return _CareerPlug$ats$Models_Question$SelectField;
		case 'signature_field':
			return _CareerPlug$ats$Models_Question$SignatureField;
		case 'state_field':
			return _CareerPlug$ats$Models_Question$StateField;
		case 'textarea_field':
			return _CareerPlug$ats$Models_Question$TextAreaField;
		case 'url_field':
			return _CareerPlug$ats$Models_Question$UrlField;
		case 'yes_no_field':
			return _CareerPlug$ats$Models_Question$YesNoField;
		case 'zip_field':
			return _CareerPlug$ats$Models_Question$ZipField;
		default:
			return _CareerPlug$ats$Models_Question$TextField;
	}
};
var _CareerPlug$ats$Models_Question$Manager = {ctor: 'Manager'};
var _CareerPlug$ats$Models_Question$Employee = {ctor: 'Employee'};
var _CareerPlug$ats$Models_Question$jsonTaker = function () {
	var taker = function (s) {
		return _elm_lang$core$Native_Utils.eq(s, 'manager') ? _CareerPlug$ats$Models_Question$Manager : _CareerPlug$ats$Models_Question$Employee;
	};
	return A2(_elm_lang$core$Json_Decode$map, taker, _elm_lang$core$Json_Decode$string);
}();
var _CareerPlug$ats$Models_Question$Truncate = {ctor: 'Truncate'};
var _CareerPlug$ats$Models_Question$Expand = {ctor: 'Expand'};
var _CareerPlug$ats$Models_Question$Shrink = {ctor: 'Shrink'};
var _CareerPlug$ats$Models_Question$jsonOverflow = function () {
	var stringOverflow = function (s) {
		var _p5 = s;
		switch (_p5) {
			case 'expand':
				return _CareerPlug$ats$Models_Question$Expand;
			case 'truncate':
				return _CareerPlug$ats$Models_Question$Truncate;
			default:
				return _CareerPlug$ats$Models_Question$Shrink;
		}
	};
	return A2(_elm_lang$core$Json_Decode$map, stringOverflow, _elm_lang$core$Json_Decode$string);
}();
var _CareerPlug$ats$Models_Question$Justify = {ctor: 'Justify'};
var _CareerPlug$ats$Models_Question$Right = {ctor: 'Right'};
var _CareerPlug$ats$Models_Question$Center = {ctor: 'Center'};
var _CareerPlug$ats$Models_Question$Left = {ctor: 'Left'};
var _CareerPlug$ats$Models_Question$jsonAlign = function () {
	var stringAlign = function (s) {
		var _p6 = s;
		switch (_p6) {
			case 'center':
				return _CareerPlug$ats$Models_Question$Center;
			case 'right':
				return _CareerPlug$ats$Models_Question$Right;
			case 'justify':
				return _CareerPlug$ats$Models_Question$Justify;
			default:
				return _CareerPlug$ats$Models_Question$Left;
		}
	};
	return A2(_elm_lang$core$Json_Decode$map, stringAlign, _elm_lang$core$Json_Decode$string);
}();
var _CareerPlug$ats$Models_Question$jsonQuestion = function (qtTranslator) {
	return A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'data',
		_elm_lang$core$Json_Decode$oneOf(
			{
				ctor: '::',
				_0: A2(
					_elm_lang$core$Json_Decode$field,
					'internal',
					A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string)),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Maybe$Nothing),
					_1: {ctor: '[]'}
				}
			}),
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'data',
			_elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: A2(_elm_lang$core$Json_Decode$field, 'character_spacing', _elm_lang$core$Json_Decode$string),
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$succeed('0'),
						_1: {ctor: '[]'}
					}
				}),
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'data',
				_elm_lang$core$Json_Decode$oneOf(
					{
						ctor: '::',
						_0: A2(_elm_lang$core$Json_Decode$field, 'opaque', _elm_lang$core$Json_Decode$bool),
						_1: {
							ctor: '::',
							_0: _elm_lang$core$Json_Decode$succeed(false),
							_1: {ctor: '[]'}
						}
					}),
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'data',
					_elm_lang$core$Json_Decode$oneOf(
						{
							ctor: '::',
							_0: A2(_elm_lang$core$Json_Decode$field, 'align', _CareerPlug$ats$Models_Question$jsonAlign),
							_1: {
								ctor: '::',
								_0: _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$Models_Question$Left),
								_1: {ctor: '[]'}
							}
						}),
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'data',
						_elm_lang$core$Json_Decode$oneOf(
							{
								ctor: '::',
								_0: A2(_elm_lang$core$Json_Decode$field, 'overflow', _CareerPlug$ats$Models_Question$jsonOverflow),
								_1: {
									ctor: '::',
									_0: _elm_lang$core$Json_Decode$succeed(_CareerPlug$ats$Models_Question$Shrink),
									_1: {ctor: '[]'}
								}
							}),
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'data',
							_elm_lang$core$Json_Decode$oneOf(
								{
									ctor: '::',
									_0: A2(_elm_lang$core$Json_Decode$field, 'size', _CareerPlug$ats$Models_Question$jsonSize),
									_1: {
										ctor: '::',
										_0: _elm_lang$core$Json_Decode$succeed(12),
										_1: {ctor: '[]'}
									}
								}),
							A2(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$hardcoded,
								_elm_lang$core$Maybe$Nothing,
								A3(
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
									'data',
									_CareerPlug$ats$Models_Question$jsonPosition,
									A3(
										_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
										'data',
										A2(_elm_lang$core$Json_Decode$field, 'page', _elm_lang$core$Json_Decode$int),
										A4(
											_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
											'description',
											_elm_lang$core$Json_Decode$string,
											'',
											A3(
												_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
												'required',
												_elm_lang$core$Json_Decode$bool,
												A3(
													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
													'answers_attributes',
													_elm_lang$core$Json_Decode$list(_CareerPlug$ats$Models_Question$jsonAnswer),
													A4(
														_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
														'visibility',
														_CareerPlug$ats$Models_Question$jsonTaker,
														_CareerPlug$ats$Models_Question$Employee,
														A3(
															_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
															'position',
															_elm_lang$core$Json_Decode$float,
															A4(
																_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
																'prefill',
																_elm_lang$core$Json_Decode$string,
																'',
																A3(
																	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
																	'question_type',
																	_elm_lang$core$Json_Decode$oneOf(
																		{
																			ctor: '::',
																			_0: A2(_elm_lang$core$Json_Decode$map, qtTranslator, _elm_lang$core$Json_Decode$string),
																			_1: {
																				ctor: '::',
																				_0: A2(
																					_elm_lang$core$Json_Decode$map,
																					function (i) {
																						return qtTranslator(
																							_elm_lang$core$Basics$toString(i));
																					},
																					_elm_lang$core$Json_Decode$int),
																				_1: {ctor: '[]'}
																			}
																		}),
																	A3(
																		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
																		'name',
																		_elm_lang$core$Json_Decode$string,
																		A3(
																			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
																			'id',
																			_elm_lang$core$Json_Decode$int,
																			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Models_Question$Question)))))))))))))))))));
};

var _CareerPlug$ats$Models_Response$responseString = function (resp) {
	var _p0 = resp;
	switch (_p0.ctor) {
		case 'Empty':
			return '';
		case 'Typed':
			return _p0._0;
		case 'Chosen':
			return _elm_lang$core$Basics$toString(_p0._0);
		default:
			return _p0._0 ? '1' : '0';
	}
};
var _CareerPlug$ats$Models_Response$moneyRegex = _elm_lang$core$Regex$regex('^\\$?\\d+\\.?\\d?\\d?$');
var _CareerPlug$ats$Models_Response$urlRegex = _elm_lang$core$Regex$regex('^((http[s]?):\\/)?\\/?([^:\\/\\s]+)((\\/\\w+)*\\/)([\\w\\-\\.]+[^#?\\s]+)(.*)?(#[\\w\\-]+)?$');
var _CareerPlug$ats$Models_Response$phoneRegex = _elm_lang$core$Regex$regex('^[2-9]\\d{2}-?\\d{3}-?\\d{4}$');
var _CareerPlug$ats$Models_Response$Checked = function (a) {
	return {ctor: 'Checked', _0: a};
};
var _CareerPlug$ats$Models_Response$Chosen = function (a) {
	return {ctor: 'Chosen', _0: a};
};
var _CareerPlug$ats$Models_Response$Typed = function (a) {
	return {ctor: 'Typed', _0: a};
};
var _CareerPlug$ats$Models_Response$Empty = {ctor: 'Empty'};
var _CareerPlug$ats$Models_Response$validateResponse = function (q) {
	var specific = function () {
		var optional = function (def) {
			return _etaque$elm_form$Form_Validate$oneOf(
				{
					ctor: '::',
					_0: A2(
						_etaque$elm_form$Form_Validate$map,
						function (_p1) {
							return _CareerPlug$ats$Models_Response$Empty;
						},
						_etaque$elm_form$Form_Validate$emptyString),
					_1: {
						ctor: '::',
						_0: def,
						_1: {ctor: '[]'}
					}
				});
		};
		var required = function (fn) {
			return A2(_etaque$elm_form$Form_Validate$map, _CareerPlug$ats$Models_Response$Typed, fn);
		};
		var basic = function (fn) {
			return q.required ? required(fn) : optional(
				required(fn));
		};
		var str = basic(
			A2(_etaque$elm_form$Form_Validate$andThen, _etaque$elm_form$Form_Validate$nonEmpty, _etaque$elm_form$Form_Validate$string));
		var _p2 = q.questionType;
		switch (_p2.ctor) {
			case 'CheckboxField':
				return A2(_etaque$elm_form$Form_Validate$map, _CareerPlug$ats$Models_Response$Checked, _etaque$elm_form$Form_Validate$bool);
			case 'CountryField':
				return str;
			case 'DateField':
				return basic(
					A2(
						_etaque$elm_form$Form_Validate$map,
						function (d) {
							return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%m/%d/%Y', d);
						},
						_etaque$elm_form$Form_Validate$date));
			case 'DecimalField':
				return basic(
					A2(_etaque$elm_form$Form_Validate$map, _elm_lang$core$Basics$toString, _etaque$elm_form$Form_Validate$float));
			case 'EmailField':
				return basic(_etaque$elm_form$Form_Validate$email);
			case 'IntegerField':
				return basic(
					A2(_etaque$elm_form$Form_Validate$map, _elm_lang$core$Basics$toString, _etaque$elm_form$Form_Validate$int));
			case 'MoneyField':
				return basic(
					A2(
						_etaque$elm_form$Form_Validate$withCustomError,
						'should be an amount of money: $55.55',
						A2(
							_etaque$elm_form$Form_Validate$andThen,
							_etaque$elm_form$Form_Validate$format(_CareerPlug$ats$Models_Response$moneyRegex),
							_etaque$elm_form$Form_Validate$string)));
			case 'MultiSelectField':
				return str;
			case 'PercentageField':
				return basic(
					A2(_etaque$elm_form$Form_Validate$map, _elm_lang$core$Basics$toString, _etaque$elm_form$Form_Validate$float));
			case 'PhoneField':
				return basic(
					A2(
						_etaque$elm_form$Form_Validate$withCustomError,
						'should use format: 555-555-5555',
						A2(
							_etaque$elm_form$Form_Validate$andThen,
							_etaque$elm_form$Form_Validate$format(_CareerPlug$ats$Models_Response$phoneRegex),
							_etaque$elm_form$Form_Validate$string)));
			case 'RadioField':
				return str;
			case 'SelectField':
				return str;
			case 'SignatureField':
				return str;
			case 'StateField':
				return str;
			case 'TextAreaField':
				return str;
			case 'UrlField':
				return basic(
					A2(
						_etaque$elm_form$Form_Validate$withCustomError,
						'should be a URL',
						A2(
							_etaque$elm_form$Form_Validate$andThen,
							_etaque$elm_form$Form_Validate$format(_CareerPlug$ats$Models_Response$urlRegex),
							_etaque$elm_form$Form_Validate$string)));
			case 'YesNoField':
				return str;
			case 'ZipField':
				return str;
			default:
				return str;
		}
	}();
	var common = function (a) {
		var _p3 = q.serverError;
		if (_p3.ctor === 'Just') {
			return _etaque$elm_form$Form_Validate$fail(
				_etaque$elm_form$Form_Error$value(
					_etaque$elm_form$Form_Error$CustomError(_p3._0)));
		} else {
			return _etaque$elm_form$Form_Validate$succeed(a);
		}
	};
	return A2(
		_etaque$elm_form$Form_Validate$field,
		_CareerPlug$ats$Models_Question$questionName(q),
		A2(_etaque$elm_form$Form_Validate$andThen, common, specific));
};

var _elm_lang$core$Color$fmod = F2(
	function (f, n) {
		var integer = _elm_lang$core$Basics$floor(f);
		return (_elm_lang$core$Basics$toFloat(
			A2(_elm_lang$core$Basics_ops['%'], integer, n)) + f) - _elm_lang$core$Basics$toFloat(integer);
	});
var _elm_lang$core$Color$rgbToHsl = F3(
	function (red, green, blue) {
		var b = _elm_lang$core$Basics$toFloat(blue) / 255;
		var g = _elm_lang$core$Basics$toFloat(green) / 255;
		var r = _elm_lang$core$Basics$toFloat(red) / 255;
		var cMax = A2(
			_elm_lang$core$Basics$max,
			A2(_elm_lang$core$Basics$max, r, g),
			b);
		var cMin = A2(
			_elm_lang$core$Basics$min,
			A2(_elm_lang$core$Basics$min, r, g),
			b);
		var c = cMax - cMin;
		var lightness = (cMax + cMin) / 2;
		var saturation = _elm_lang$core$Native_Utils.eq(lightness, 0) ? 0 : (c / (1 - _elm_lang$core$Basics$abs((2 * lightness) - 1)));
		var hue = _elm_lang$core$Basics$degrees(60) * (_elm_lang$core$Native_Utils.eq(cMax, r) ? A2(_elm_lang$core$Color$fmod, (g - b) / c, 6) : (_elm_lang$core$Native_Utils.eq(cMax, g) ? (((b - r) / c) + 2) : (((r - g) / c) + 4)));
		return {ctor: '_Tuple3', _0: hue, _1: saturation, _2: lightness};
	});
var _elm_lang$core$Color$hslToRgb = F3(
	function (hue, saturation, lightness) {
		var normHue = hue / _elm_lang$core$Basics$degrees(60);
		var chroma = (1 - _elm_lang$core$Basics$abs((2 * lightness) - 1)) * saturation;
		var x = chroma * (1 - _elm_lang$core$Basics$abs(
			A2(_elm_lang$core$Color$fmod, normHue, 2) - 1));
		var _p0 = (_elm_lang$core$Native_Utils.cmp(normHue, 0) < 0) ? {ctor: '_Tuple3', _0: 0, _1: 0, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 1) < 0) ? {ctor: '_Tuple3', _0: chroma, _1: x, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 2) < 0) ? {ctor: '_Tuple3', _0: x, _1: chroma, _2: 0} : ((_elm_lang$core$Native_Utils.cmp(normHue, 3) < 0) ? {ctor: '_Tuple3', _0: 0, _1: chroma, _2: x} : ((_elm_lang$core$Native_Utils.cmp(normHue, 4) < 0) ? {ctor: '_Tuple3', _0: 0, _1: x, _2: chroma} : ((_elm_lang$core$Native_Utils.cmp(normHue, 5) < 0) ? {ctor: '_Tuple3', _0: x, _1: 0, _2: chroma} : ((_elm_lang$core$Native_Utils.cmp(normHue, 6) < 0) ? {ctor: '_Tuple3', _0: chroma, _1: 0, _2: x} : {ctor: '_Tuple3', _0: 0, _1: 0, _2: 0}))))));
		var r = _p0._0;
		var g = _p0._1;
		var b = _p0._2;
		var m = lightness - (chroma / 2);
		return {ctor: '_Tuple3', _0: r + m, _1: g + m, _2: b + m};
	});
var _elm_lang$core$Color$toRgb = function (color) {
	var _p1 = color;
	if (_p1.ctor === 'RGBA') {
		return {red: _p1._0, green: _p1._1, blue: _p1._2, alpha: _p1._3};
	} else {
		var _p2 = A3(_elm_lang$core$Color$hslToRgb, _p1._0, _p1._1, _p1._2);
		var r = _p2._0;
		var g = _p2._1;
		var b = _p2._2;
		return {
			red: _elm_lang$core$Basics$round(255 * r),
			green: _elm_lang$core$Basics$round(255 * g),
			blue: _elm_lang$core$Basics$round(255 * b),
			alpha: _p1._3
		};
	}
};
var _elm_lang$core$Color$toHsl = function (color) {
	var _p3 = color;
	if (_p3.ctor === 'HSLA') {
		return {hue: _p3._0, saturation: _p3._1, lightness: _p3._2, alpha: _p3._3};
	} else {
		var _p4 = A3(_elm_lang$core$Color$rgbToHsl, _p3._0, _p3._1, _p3._2);
		var h = _p4._0;
		var s = _p4._1;
		var l = _p4._2;
		return {hue: h, saturation: s, lightness: l, alpha: _p3._3};
	}
};
var _elm_lang$core$Color$HSLA = F4(
	function (a, b, c, d) {
		return {ctor: 'HSLA', _0: a, _1: b, _2: c, _3: d};
	});
var _elm_lang$core$Color$hsla = F4(
	function (hue, saturation, lightness, alpha) {
		return A4(
			_elm_lang$core$Color$HSLA,
			hue - _elm_lang$core$Basics$turns(
				_elm_lang$core$Basics$toFloat(
					_elm_lang$core$Basics$floor(hue / (2 * _elm_lang$core$Basics$pi)))),
			saturation,
			lightness,
			alpha);
	});
var _elm_lang$core$Color$hsl = F3(
	function (hue, saturation, lightness) {
		return A4(_elm_lang$core$Color$hsla, hue, saturation, lightness, 1);
	});
var _elm_lang$core$Color$complement = function (color) {
	var _p5 = color;
	if (_p5.ctor === 'HSLA') {
		return A4(
			_elm_lang$core$Color$hsla,
			_p5._0 + _elm_lang$core$Basics$degrees(180),
			_p5._1,
			_p5._2,
			_p5._3);
	} else {
		var _p6 = A3(_elm_lang$core$Color$rgbToHsl, _p5._0, _p5._1, _p5._2);
		var h = _p6._0;
		var s = _p6._1;
		var l = _p6._2;
		return A4(
			_elm_lang$core$Color$hsla,
			h + _elm_lang$core$Basics$degrees(180),
			s,
			l,
			_p5._3);
	}
};
var _elm_lang$core$Color$grayscale = function (p) {
	return A4(_elm_lang$core$Color$HSLA, 0, 0, 1 - p, 1);
};
var _elm_lang$core$Color$greyscale = function (p) {
	return A4(_elm_lang$core$Color$HSLA, 0, 0, 1 - p, 1);
};
var _elm_lang$core$Color$RGBA = F4(
	function (a, b, c, d) {
		return {ctor: 'RGBA', _0: a, _1: b, _2: c, _3: d};
	});
var _elm_lang$core$Color$rgba = _elm_lang$core$Color$RGBA;
var _elm_lang$core$Color$rgb = F3(
	function (r, g, b) {
		return A4(_elm_lang$core$Color$RGBA, r, g, b, 1);
	});
var _elm_lang$core$Color$lightRed = A4(_elm_lang$core$Color$RGBA, 239, 41, 41, 1);
var _elm_lang$core$Color$red = A4(_elm_lang$core$Color$RGBA, 204, 0, 0, 1);
var _elm_lang$core$Color$darkRed = A4(_elm_lang$core$Color$RGBA, 164, 0, 0, 1);
var _elm_lang$core$Color$lightOrange = A4(_elm_lang$core$Color$RGBA, 252, 175, 62, 1);
var _elm_lang$core$Color$orange = A4(_elm_lang$core$Color$RGBA, 245, 121, 0, 1);
var _elm_lang$core$Color$darkOrange = A4(_elm_lang$core$Color$RGBA, 206, 92, 0, 1);
var _elm_lang$core$Color$lightYellow = A4(_elm_lang$core$Color$RGBA, 255, 233, 79, 1);
var _elm_lang$core$Color$yellow = A4(_elm_lang$core$Color$RGBA, 237, 212, 0, 1);
var _elm_lang$core$Color$darkYellow = A4(_elm_lang$core$Color$RGBA, 196, 160, 0, 1);
var _elm_lang$core$Color$lightGreen = A4(_elm_lang$core$Color$RGBA, 138, 226, 52, 1);
var _elm_lang$core$Color$green = A4(_elm_lang$core$Color$RGBA, 115, 210, 22, 1);
var _elm_lang$core$Color$darkGreen = A4(_elm_lang$core$Color$RGBA, 78, 154, 6, 1);
var _elm_lang$core$Color$lightBlue = A4(_elm_lang$core$Color$RGBA, 114, 159, 207, 1);
var _elm_lang$core$Color$blue = A4(_elm_lang$core$Color$RGBA, 52, 101, 164, 1);
var _elm_lang$core$Color$darkBlue = A4(_elm_lang$core$Color$RGBA, 32, 74, 135, 1);
var _elm_lang$core$Color$lightPurple = A4(_elm_lang$core$Color$RGBA, 173, 127, 168, 1);
var _elm_lang$core$Color$purple = A4(_elm_lang$core$Color$RGBA, 117, 80, 123, 1);
var _elm_lang$core$Color$darkPurple = A4(_elm_lang$core$Color$RGBA, 92, 53, 102, 1);
var _elm_lang$core$Color$lightBrown = A4(_elm_lang$core$Color$RGBA, 233, 185, 110, 1);
var _elm_lang$core$Color$brown = A4(_elm_lang$core$Color$RGBA, 193, 125, 17, 1);
var _elm_lang$core$Color$darkBrown = A4(_elm_lang$core$Color$RGBA, 143, 89, 2, 1);
var _elm_lang$core$Color$black = A4(_elm_lang$core$Color$RGBA, 0, 0, 0, 1);
var _elm_lang$core$Color$white = A4(_elm_lang$core$Color$RGBA, 255, 255, 255, 1);
var _elm_lang$core$Color$lightGrey = A4(_elm_lang$core$Color$RGBA, 238, 238, 236, 1);
var _elm_lang$core$Color$grey = A4(_elm_lang$core$Color$RGBA, 211, 215, 207, 1);
var _elm_lang$core$Color$darkGrey = A4(_elm_lang$core$Color$RGBA, 186, 189, 182, 1);
var _elm_lang$core$Color$lightGray = A4(_elm_lang$core$Color$RGBA, 238, 238, 236, 1);
var _elm_lang$core$Color$gray = A4(_elm_lang$core$Color$RGBA, 211, 215, 207, 1);
var _elm_lang$core$Color$darkGray = A4(_elm_lang$core$Color$RGBA, 186, 189, 182, 1);
var _elm_lang$core$Color$lightCharcoal = A4(_elm_lang$core$Color$RGBA, 136, 138, 133, 1);
var _elm_lang$core$Color$charcoal = A4(_elm_lang$core$Color$RGBA, 85, 87, 83, 1);
var _elm_lang$core$Color$darkCharcoal = A4(_elm_lang$core$Color$RGBA, 46, 52, 54, 1);
var _elm_lang$core$Color$Radial = F5(
	function (a, b, c, d, e) {
		return {ctor: 'Radial', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _elm_lang$core$Color$radial = _elm_lang$core$Color$Radial;
var _elm_lang$core$Color$Linear = F3(
	function (a, b, c) {
		return {ctor: 'Linear', _0: a, _1: b, _2: c};
	});
var _elm_lang$core$Color$linear = _elm_lang$core$Color$Linear;

var _elm_lang$animation_frame$Native_AnimationFrame = function()
{

function create()
{
	return _elm_lang$core$Native_Scheduler.nativeBinding(function(callback)
	{
		var id = requestAnimationFrame(function() {
			callback(_elm_lang$core$Native_Scheduler.succeed(Date.now()));
		});

		return function() {
			cancelAnimationFrame(id);
		};
	});
}

return {
	create: create
};

}();

var _elm_lang$animation_frame$AnimationFrame$rAF = _elm_lang$animation_frame$Native_AnimationFrame.create(
	{ctor: '_Tuple0'});
var _elm_lang$animation_frame$AnimationFrame$subscription = _elm_lang$core$Native_Platform.leaf('AnimationFrame');
var _elm_lang$animation_frame$AnimationFrame$State = F3(
	function (a, b, c) {
		return {subs: a, request: b, oldTime: c};
	});
var _elm_lang$animation_frame$AnimationFrame$init = _elm_lang$core$Task$succeed(
	A3(
		_elm_lang$animation_frame$AnimationFrame$State,
		{ctor: '[]'},
		_elm_lang$core$Maybe$Nothing,
		0));
var _elm_lang$animation_frame$AnimationFrame$onEffects = F3(
	function (router, subs, _p0) {
		var _p1 = _p0;
		var _p5 = _p1.request;
		var _p4 = _p1.oldTime;
		var _p2 = {ctor: '_Tuple2', _0: _p5, _1: subs};
		if (_p2._0.ctor === 'Nothing') {
			if (_p2._1.ctor === '[]') {
				return _elm_lang$core$Task$succeed(
					A3(
						_elm_lang$animation_frame$AnimationFrame$State,
						{ctor: '[]'},
						_elm_lang$core$Maybe$Nothing,
						_p4));
			} else {
				return A2(
					_elm_lang$core$Task$andThen,
					function (pid) {
						return A2(
							_elm_lang$core$Task$andThen,
							function (time) {
								return _elm_lang$core$Task$succeed(
									A3(
										_elm_lang$animation_frame$AnimationFrame$State,
										subs,
										_elm_lang$core$Maybe$Just(pid),
										time));
							},
							_elm_lang$core$Time$now);
					},
					_elm_lang$core$Process$spawn(
						A2(
							_elm_lang$core$Task$andThen,
							_elm_lang$core$Platform$sendToSelf(router),
							_elm_lang$animation_frame$AnimationFrame$rAF)));
			}
		} else {
			if (_p2._1.ctor === '[]') {
				return A2(
					_elm_lang$core$Task$andThen,
					function (_p3) {
						return _elm_lang$core$Task$succeed(
							A3(
								_elm_lang$animation_frame$AnimationFrame$State,
								{ctor: '[]'},
								_elm_lang$core$Maybe$Nothing,
								_p4));
					},
					_elm_lang$core$Process$kill(_p2._0._0));
			} else {
				return _elm_lang$core$Task$succeed(
					A3(_elm_lang$animation_frame$AnimationFrame$State, subs, _p5, _p4));
			}
		}
	});
var _elm_lang$animation_frame$AnimationFrame$onSelfMsg = F3(
	function (router, newTime, _p6) {
		var _p7 = _p6;
		var _p10 = _p7.subs;
		var diff = newTime - _p7.oldTime;
		var send = function (sub) {
			var _p8 = sub;
			if (_p8.ctor === 'Time') {
				return A2(
					_elm_lang$core$Platform$sendToApp,
					router,
					_p8._0(newTime));
			} else {
				return A2(
					_elm_lang$core$Platform$sendToApp,
					router,
					_p8._0(diff));
			}
		};
		return A2(
			_elm_lang$core$Task$andThen,
			function (pid) {
				return A2(
					_elm_lang$core$Task$andThen,
					function (_p9) {
						return _elm_lang$core$Task$succeed(
							A3(
								_elm_lang$animation_frame$AnimationFrame$State,
								_p10,
								_elm_lang$core$Maybe$Just(pid),
								newTime));
					},
					_elm_lang$core$Task$sequence(
						A2(_elm_lang$core$List$map, send, _p10)));
			},
			_elm_lang$core$Process$spawn(
				A2(
					_elm_lang$core$Task$andThen,
					_elm_lang$core$Platform$sendToSelf(router),
					_elm_lang$animation_frame$AnimationFrame$rAF)));
	});
var _elm_lang$animation_frame$AnimationFrame$Diff = function (a) {
	return {ctor: 'Diff', _0: a};
};
var _elm_lang$animation_frame$AnimationFrame$diffs = function (tagger) {
	return _elm_lang$animation_frame$AnimationFrame$subscription(
		_elm_lang$animation_frame$AnimationFrame$Diff(tagger));
};
var _elm_lang$animation_frame$AnimationFrame$Time = function (a) {
	return {ctor: 'Time', _0: a};
};
var _elm_lang$animation_frame$AnimationFrame$times = function (tagger) {
	return _elm_lang$animation_frame$AnimationFrame$subscription(
		_elm_lang$animation_frame$AnimationFrame$Time(tagger));
};
var _elm_lang$animation_frame$AnimationFrame$subMap = F2(
	function (func, sub) {
		var _p11 = sub;
		if (_p11.ctor === 'Time') {
			return _elm_lang$animation_frame$AnimationFrame$Time(
				function (_p12) {
					return func(
						_p11._0(_p12));
				});
		} else {
			return _elm_lang$animation_frame$AnimationFrame$Diff(
				function (_p13) {
					return func(
						_p11._0(_p13));
				});
		}
	});
_elm_lang$core$Native_Platform.effectManagers['AnimationFrame'] = {pkg: 'elm-lang/animation-frame', init: _elm_lang$animation_frame$AnimationFrame$init, onEffects: _elm_lang$animation_frame$AnimationFrame$onEffects, onSelfMsg: _elm_lang$animation_frame$AnimationFrame$onSelfMsg, tag: 'sub', subMap: _elm_lang$animation_frame$AnimationFrame$subMap};

var _mdgriffith$elm_style_animation$Animation_Model$matchPoints = F2(
	function (points1, points2) {
		var diff = _elm_lang$core$List$length(points1) - _elm_lang$core$List$length(points2);
		if (_elm_lang$core$Native_Utils.cmp(diff, 0) > 0) {
			var _p0 = _elm_lang$core$List$head(
				_elm_lang$core$List$reverse(points2));
			if (_p0.ctor === 'Nothing') {
				return {ctor: '_Tuple2', _0: points1, _1: points2};
			} else {
				return {
					ctor: '_Tuple2',
					_0: points1,
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						points2,
						A2(
							_elm_lang$core$List$repeat,
							_elm_lang$core$Basics$abs(diff),
							_p0._0))
				};
			}
		} else {
			if (_elm_lang$core$Native_Utils.cmp(diff, 0) < 0) {
				var _p1 = _elm_lang$core$List$head(
					_elm_lang$core$List$reverse(points1));
				if (_p1.ctor === 'Nothing') {
					return {ctor: '_Tuple2', _0: points1, _1: points2};
				} else {
					return {
						ctor: '_Tuple2',
						_0: A2(
							_elm_lang$core$Basics_ops['++'],
							points1,
							A2(
								_elm_lang$core$List$repeat,
								_elm_lang$core$Basics$abs(diff),
								_p1._0)),
						_1: points2
					};
				}
			} else {
				return {ctor: '_Tuple2', _0: points1, _1: points2};
			}
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$vTolerance = 0.1;
var _mdgriffith$elm_style_animation$Animation_Model$tolerance = 1.0e-2;
var _mdgriffith$elm_style_animation$Animation_Model$isCmdDone = function (cmd) {
	var motionDone = function (motion) {
		return _elm_lang$core$Native_Utils.eq(motion.velocity, 0) && _elm_lang$core$Native_Utils.eq(motion.position, motion.target);
	};
	var _p2 = cmd;
	switch (_p2.ctor) {
		case 'Move':
			return motionDone(_p2._0) && motionDone(_p2._1);
		case 'MoveTo':
			return motionDone(_p2._0) && motionDone(_p2._1);
		case 'Line':
			return motionDone(_p2._0) && motionDone(_p2._1);
		case 'LineTo':
			return motionDone(_p2._0) && motionDone(_p2._1);
		case 'Horizontal':
			return motionDone(_p2._0);
		case 'HorizontalTo':
			return motionDone(_p2._0);
		case 'Vertical':
			return motionDone(_p2._0);
		case 'VerticalTo':
			return motionDone(_p2._0);
		case 'Curve':
			var _p5 = _p2._0.point;
			var _p4 = _p2._0.control2;
			var _p3 = _p2._0.control1;
			return motionDone(
				_elm_lang$core$Tuple$first(_p3)) && (motionDone(
				_elm_lang$core$Tuple$second(_p3)) && (motionDone(
				_elm_lang$core$Tuple$first(_p4)) && (motionDone(
				_elm_lang$core$Tuple$second(_p4)) && (motionDone(
				_elm_lang$core$Tuple$first(_p5)) && motionDone(
				_elm_lang$core$Tuple$second(_p5))))));
		case 'CurveTo':
			var _p8 = _p2._0.point;
			var _p7 = _p2._0.control2;
			var _p6 = _p2._0.control1;
			return motionDone(
				_elm_lang$core$Tuple$first(_p6)) && (motionDone(
				_elm_lang$core$Tuple$second(_p6)) && (motionDone(
				_elm_lang$core$Tuple$first(_p7)) && (motionDone(
				_elm_lang$core$Tuple$second(_p7)) && (motionDone(
				_elm_lang$core$Tuple$first(_p8)) && motionDone(
				_elm_lang$core$Tuple$second(_p8))))));
		case 'Quadratic':
			var _p10 = _p2._0.point;
			var _p9 = _p2._0.control;
			return motionDone(
				_elm_lang$core$Tuple$first(_p9)) && (motionDone(
				_elm_lang$core$Tuple$second(_p9)) && (motionDone(
				_elm_lang$core$Tuple$first(_p10)) && motionDone(
				_elm_lang$core$Tuple$second(_p10))));
		case 'QuadraticTo':
			var _p12 = _p2._0.point;
			var _p11 = _p2._0.control;
			return motionDone(
				_elm_lang$core$Tuple$first(_p11)) && (motionDone(
				_elm_lang$core$Tuple$second(_p11)) && (motionDone(
				_elm_lang$core$Tuple$first(_p12)) && motionDone(
				_elm_lang$core$Tuple$second(_p12))));
		case 'SmoothQuadratic':
			return A2(
				_elm_lang$core$List$all,
				function (_p13) {
					var _p14 = _p13;
					return motionDone(_p14._0) && motionDone(_p14._1);
				},
				_p2._0);
		case 'SmoothQuadraticTo':
			return A2(
				_elm_lang$core$List$all,
				function (_p15) {
					var _p16 = _p15;
					return motionDone(_p16._0) && motionDone(_p16._1);
				},
				_p2._0);
		case 'Smooth':
			return A2(
				_elm_lang$core$List$all,
				function (_p17) {
					var _p18 = _p17;
					return motionDone(_p18._0) && motionDone(_p18._1);
				},
				_p2._0);
		case 'SmoothTo':
			return A2(
				_elm_lang$core$List$all,
				function (_p19) {
					var _p20 = _p19;
					return motionDone(_p20._0) && motionDone(_p20._1);
				},
				_p2._0);
		case 'ClockwiseArc':
			var _p21 = _p2._0;
			return motionDone(_p21.x) && (motionDone(_p21.y) && (motionDone(_p21.radius) && (motionDone(_p21.startAngle) && motionDone(_p21.endAngle))));
		case 'AntiClockwiseArc':
			var _p22 = _p2._0;
			return motionDone(_p22.x) && (motionDone(_p22.y) && (motionDone(_p22.radius) && (motionDone(_p22.startAngle) && motionDone(_p22.endAngle))));
		default:
			return true;
	}
};
var _mdgriffith$elm_style_animation$Animation_Model$isDone = function (property) {
	var motionDone = function (motion) {
		var runningInterpolation = A2(_elm_lang$core$Maybe$withDefault, motion.interpolation, motion.interpolationOverride);
		var _p23 = runningInterpolation;
		switch (_p23.ctor) {
			case 'Spring':
				return _elm_lang$core$Native_Utils.eq(motion.velocity, 0) && _elm_lang$core$Native_Utils.eq(motion.position, motion.target);
			case 'Easing':
				var _p24 = _p23._0;
				return _elm_lang$core$Native_Utils.eq(_p24.progress, 1) || (_elm_lang$core$Native_Utils.eq(_p24.progress, 0) && _elm_lang$core$Native_Utils.eq(motion.position, motion.target));
			default:
				return _elm_lang$core$Native_Utils.eq(motion.position, motion.target);
		}
	};
	var _p25 = property;
	switch (_p25.ctor) {
		case 'ExactProperty':
			return true;
		case 'ColorProperty':
			return A2(
				_elm_lang$core$List$all,
				motionDone,
				{
					ctor: '::',
					_0: _p25._1,
					_1: {
						ctor: '::',
						_0: _p25._2,
						_1: {
							ctor: '::',
							_0: _p25._3,
							_1: {
								ctor: '::',
								_0: _p25._4,
								_1: {ctor: '[]'}
							}
						}
					}
				});
		case 'ShadowProperty':
			var _p26 = _p25._2;
			return A2(
				_elm_lang$core$List$all,
				motionDone,
				{
					ctor: '::',
					_0: _p26.offsetX,
					_1: {
						ctor: '::',
						_0: _p26.offsetY,
						_1: {
							ctor: '::',
							_0: _p26.size,
							_1: {
								ctor: '::',
								_0: _p26.blur,
								_1: {
									ctor: '::',
									_0: _p26.red,
									_1: {
										ctor: '::',
										_0: _p26.green,
										_1: {
											ctor: '::',
											_0: _p26.blue,
											_1: {
												ctor: '::',
												_0: _p26.alpha,
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				});
		case 'Property':
			return motionDone(_p25._1);
		case 'Property2':
			return motionDone(_p25._1) && motionDone(_p25._2);
		case 'Property3':
			return A2(
				_elm_lang$core$List$all,
				motionDone,
				{
					ctor: '::',
					_0: _p25._1,
					_1: {
						ctor: '::',
						_0: _p25._2,
						_1: {
							ctor: '::',
							_0: _p25._3,
							_1: {ctor: '[]'}
						}
					}
				});
		case 'Property4':
			return A2(
				_elm_lang$core$List$all,
				motionDone,
				{
					ctor: '::',
					_0: _p25._1,
					_1: {
						ctor: '::',
						_0: _p25._2,
						_1: {
							ctor: '::',
							_0: _p25._3,
							_1: {
								ctor: '::',
								_0: _p25._4,
								_1: {ctor: '[]'}
							}
						}
					}
				});
		case 'AngleProperty':
			return motionDone(_p25._1);
		case 'Points':
			return A2(
				_elm_lang$core$List$all,
				function (_p27) {
					var _p28 = _p27;
					return motionDone(_p28._0) && motionDone(_p28._1);
				},
				_p25._0);
		default:
			return A2(_elm_lang$core$List$all, _mdgriffith$elm_style_animation$Animation_Model$isCmdDone, _p25._0);
	}
};
var _mdgriffith$elm_style_animation$Animation_Model$refreshTiming = F2(
	function (now, timing) {
		var dt = now - timing.current;
		return {
			current: now,
			dt: ((_elm_lang$core$Native_Utils.cmp(dt, 34) > 0) || _elm_lang$core$Native_Utils.eq(timing.current, 0)) ? 16.666 : dt
		};
	});
var _mdgriffith$elm_style_animation$Animation_Model$propertyName = function (prop) {
	var _p29 = prop;
	switch (_p29.ctor) {
		case 'ExactProperty':
			return _p29._0;
		case 'ColorProperty':
			return _p29._0;
		case 'ShadowProperty':
			return _p29._0;
		case 'Property':
			return _p29._0;
		case 'Property2':
			return _p29._0;
		case 'Property3':
			return _p29._0;
		case 'Property4':
			return _p29._0;
		case 'AngleProperty':
			return _p29._0;
		case 'Points':
			return 'points';
		default:
			return 'path';
	}
};
var _mdgriffith$elm_style_animation$Animation_Model$replaceProps = F2(
	function (props, replacements) {
		var replacementNames = A2(_elm_lang$core$List$map, _mdgriffith$elm_style_animation$Animation_Model$propertyName, replacements);
		var removed = A2(
			_elm_lang$core$List$filter,
			function (prop) {
				return !A2(
					_elm_lang$core$List$member,
					_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
					replacementNames);
			},
			props);
		return A2(_elm_lang$core$Basics_ops['++'], removed, replacements);
	});
var _mdgriffith$elm_style_animation$Animation_Model$zipPropertiesGreedy = F2(
	function (initialProps, newTargetProps) {
		var propertyMatch = F2(
			function (prop1, prop2) {
				return _elm_lang$core$Native_Utils.eq(
					_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop1),
					_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop2));
			});
		var _p30 = A3(
			_elm_lang$core$List$foldl,
			F2(
				function (_p32, _p31) {
					var _p33 = _p31;
					var _p40 = _p33._1;
					var _p39 = _p33._0;
					var _p38 = _p33._2;
					var _p34 = _elm_lang$core$List$head(_p39);
					if (_p34.ctor === 'Nothing') {
						return {ctor: '_Tuple3', _0: _p39, _1: _p40, _2: _p38};
					} else {
						var _p37 = _p34._0;
						var _p35 = A2(
							_elm_lang$core$List$partition,
							propertyMatch(_p37),
							_p40);
						var matchingBs = _p35._0;
						var nonMatchingBs = _p35._1;
						return {
							ctor: '_Tuple3',
							_0: A2(_elm_lang$core$List$drop, 1, _p39),
							_1: function () {
								var _p36 = matchingBs;
								if (_p36.ctor === '[]') {
									return nonMatchingBs;
								} else {
									return A2(_elm_lang$core$Basics_ops['++'], _p36._1, nonMatchingBs);
								}
							}(),
							_2: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: _p37,
									_1: _elm_lang$core$List$head(matchingBs)
								},
								_1: _p38
							}
						};
					}
				}),
			{
				ctor: '_Tuple3',
				_0: initialProps,
				_1: newTargetProps,
				_2: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$List$repeat,
				_elm_lang$core$List$length(initialProps),
				0));
		var warnings = _p30._1;
		var props = _p30._2;
		var _p41 = A2(
			_elm_lang$core$List$map,
			function (b) {
				return A2(
					_elm_lang$core$Debug$log,
					'elm-style-animation',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_mdgriffith$elm_style_animation$Animation_Model$propertyName(b),
						' has no initial value and therefore will not be animated.'));
			},
			warnings);
		return _elm_lang$core$List$reverse(props);
	});
var _mdgriffith$elm_style_animation$Animation_Model$Timing = F2(
	function (a, b) {
		return {current: a, dt: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Motion = F6(
	function (a, b, c, d, e, f) {
		return {position: a, velocity: b, target: c, interpolation: d, unit: e, interpolationOverride: f};
	});
var _mdgriffith$elm_style_animation$Animation_Model$ShadowMotion = F8(
	function (a, b, c, d, e, f, g, h) {
		return {offsetX: a, offsetY: b, size: c, blur: d, red: e, green: f, blue: g, alpha: h};
	});
var _mdgriffith$elm_style_animation$Animation_Model$CubicCurveMotion = F3(
	function (a, b, c) {
		return {control1: a, control2: b, point: c};
	});
var _mdgriffith$elm_style_animation$Animation_Model$QuadraticCurveMotion = F2(
	function (a, b) {
		return {control: a, point: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$ArcMotion = F5(
	function (a, b, c, d, e) {
		return {x: a, y: b, radius: c, startAngle: d, endAngle: e};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Animation = function (a) {
	return {ctor: 'Animation', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Tick = function (a) {
	return {ctor: 'Tick', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Loop = function (a) {
	return {ctor: 'Loop', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Repeat = F2(
	function (a, b) {
		return {ctor: 'Repeat', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Send = function (a) {
	return {ctor: 'Send', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Wait = function (a) {
	return {ctor: 'Wait', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Set = function (a) {
	return {ctor: 'Set', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$ToWith = function (a) {
	return {ctor: 'ToWith', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$To = function (a) {
	return {ctor: 'To', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Step = {ctor: 'Step'};
var _mdgriffith$elm_style_animation$Animation_Model$AtSpeed = function (a) {
	return {ctor: 'AtSpeed', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Easing = function (a) {
	return {ctor: 'Easing', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$stepInterpolation = F2(
	function (dtms, motion) {
		var interpolationToUse = A2(_elm_lang$core$Maybe$withDefault, motion.interpolation, motion.interpolationOverride);
		var _p42 = interpolationToUse;
		switch (_p42.ctor) {
			case 'AtSpeed':
				var _p44 = _p42._0.perSecond;
				var _p43 = function () {
					if (_elm_lang$core$Native_Utils.cmp(motion.position, motion.target) < 0) {
						var $new = motion.position + (_p44 * (dtms / 1000));
						return {
							ctor: '_Tuple2',
							_0: $new,
							_1: _elm_lang$core$Native_Utils.cmp($new, motion.target) > -1
						};
					} else {
						var $new = motion.position - (_p44 * (dtms / 1000));
						return {
							ctor: '_Tuple2',
							_0: $new,
							_1: _elm_lang$core$Native_Utils.cmp($new, motion.target) < 1
						};
					}
				}();
				var newPos = _p43._0;
				var finished = _p43._1;
				return finished ? _elm_lang$core$Native_Utils.update(
					motion,
					{position: motion.target, velocity: 0.0}) : _elm_lang$core$Native_Utils.update(
					motion,
					{position: newPos, velocity: _p44 * 1000});
			case 'Spring':
				var fdamper = (-1 * _p42._0.damping) * motion.velocity;
				var fspring = _p42._0.stiffness * (motion.target - motion.position);
				var a = fspring + fdamper;
				var dt = dtms / 1000;
				var newVelocity = motion.velocity + (a * dt);
				var newPos = motion.position + (newVelocity * dt);
				var dx = _elm_lang$core$Basics$abs(motion.target - newPos);
				return ((_elm_lang$core$Native_Utils.cmp(dx, _mdgriffith$elm_style_animation$Animation_Model$tolerance) < 0) && (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$Basics$abs(newVelocity),
					_mdgriffith$elm_style_animation$Animation_Model$vTolerance) < 0)) ? _elm_lang$core$Native_Utils.update(
					motion,
					{position: motion.target, velocity: 0.0}) : _elm_lang$core$Native_Utils.update(
					motion,
					{position: newPos, velocity: newVelocity});
			default:
				var _p49 = _p42._0.start;
				var _p48 = _p42._0.progress;
				var _p47 = _p42._0.ease;
				var _p46 = _p42._0.duration;
				var distance = motion.target - _p49;
				var newProgress = (_elm_lang$core$Native_Utils.cmp((dtms / _p46) + _p48, 1) < 0) ? ((dtms / _p46) + _p48) : 1;
				var eased = _p47(newProgress);
				var newPos = _elm_lang$core$Basics$toFloat(
					_elm_lang$core$Basics$truncate(((eased * distance) + _p49) * 10000)) / 10000;
				var newVelocity = _elm_lang$core$Native_Utils.eq(newProgress, 1) ? 0 : ((newPos - motion.position) / dtms);
				var _p45 = motion.interpolationOverride;
				if (_p45.ctor === 'Nothing') {
					return _elm_lang$core$Native_Utils.update(
						motion,
						{
							position: newPos,
							velocity: newVelocity,
							interpolation: _mdgriffith$elm_style_animation$Animation_Model$Easing(
								{progress: newProgress, duration: _p46, ease: _p47, start: _p49})
						});
				} else {
					return _elm_lang$core$Native_Utils.update(
						motion,
						{
							position: newPos,
							velocity: newVelocity,
							interpolationOverride: _elm_lang$core$Maybe$Just(
								_mdgriffith$elm_style_animation$Animation_Model$Easing(
									{progress: newProgress, duration: _p46, ease: _p47, start: _p49}))
						});
				}
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$Spring = function (a) {
	return {ctor: 'Spring', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Path = function (a) {
	return {ctor: 'Path', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Points = function (a) {
	return {ctor: 'Points', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$AngleProperty = F2(
	function (a, b) {
		return {ctor: 'AngleProperty', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Property4 = F5(
	function (a, b, c, d, e) {
		return {ctor: 'Property4', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Property3 = F4(
	function (a, b, c, d) {
		return {ctor: 'Property3', _0: a, _1: b, _2: c, _3: d};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Property2 = F3(
	function (a, b, c) {
		return {ctor: 'Property2', _0: a, _1: b, _2: c};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Property = F2(
	function (a, b) {
		return {ctor: 'Property', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$ShadowProperty = F3(
	function (a, b, c) {
		return {ctor: 'ShadowProperty', _0: a, _1: b, _2: c};
	});
var _mdgriffith$elm_style_animation$Animation_Model$ColorProperty = F5(
	function (a, b, c, d, e) {
		return {ctor: 'ColorProperty', _0: a, _1: b, _2: c, _3: d, _4: e};
	});
var _mdgriffith$elm_style_animation$Animation_Model$ExactProperty = F2(
	function (a, b) {
		return {ctor: 'ExactProperty', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Close = {ctor: 'Close'};
var _mdgriffith$elm_style_animation$Animation_Model$AntiClockwiseArc = function (a) {
	return {ctor: 'AntiClockwiseArc', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$ClockwiseArc = function (a) {
	return {ctor: 'ClockwiseArc', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$SmoothTo = function (a) {
	return {ctor: 'SmoothTo', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Smooth = function (a) {
	return {ctor: 'Smooth', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadraticTo = function (a) {
	return {ctor: 'SmoothQuadraticTo', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadratic = function (a) {
	return {ctor: 'SmoothQuadratic', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$QuadraticTo = function (a) {
	return {ctor: 'QuadraticTo', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Quadratic = function (a) {
	return {ctor: 'Quadratic', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$CurveTo = function (a) {
	return {ctor: 'CurveTo', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Curve = function (a) {
	return {ctor: 'Curve', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$VerticalTo = function (a) {
	return {ctor: 'VerticalTo', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Vertical = function (a) {
	return {ctor: 'Vertical', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$HorizontalTo = function (a) {
	return {ctor: 'HorizontalTo', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$Horizontal = function (a) {
	return {ctor: 'Horizontal', _0: a};
};
var _mdgriffith$elm_style_animation$Animation_Model$LineTo = F2(
	function (a, b) {
		return {ctor: 'LineTo', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Line = F2(
	function (a, b) {
		return {ctor: 'Line', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$MoveTo = F2(
	function (a, b) {
		return {ctor: 'MoveTo', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$Move = F2(
	function (a, b) {
		return {ctor: 'Move', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation_Model$mapPathMotion = F2(
	function (fn, cmd) {
		var mapCoords = function (coords) {
			return A2(
				_elm_lang$core$List$map,
				function (_p50) {
					var _p51 = _p50;
					return {
						ctor: '_Tuple2',
						_0: fn(_p51._0),
						_1: fn(_p51._1)
					};
				},
				coords);
		};
		var _p52 = cmd;
		switch (_p52.ctor) {
			case 'Move':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$Move,
					fn(_p52._0),
					fn(_p52._1));
			case 'MoveTo':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$MoveTo,
					fn(_p52._0),
					fn(_p52._1));
			case 'Line':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$Line,
					fn(_p52._0),
					fn(_p52._1));
			case 'LineTo':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$LineTo,
					fn(_p52._0),
					fn(_p52._1));
			case 'Horizontal':
				return _mdgriffith$elm_style_animation$Animation_Model$Horizontal(
					fn(_p52._0));
			case 'HorizontalTo':
				return _mdgriffith$elm_style_animation$Animation_Model$HorizontalTo(
					fn(_p52._0));
			case 'Vertical':
				return _mdgriffith$elm_style_animation$Animation_Model$Vertical(
					fn(_p52._0));
			case 'VerticalTo':
				return _mdgriffith$elm_style_animation$Animation_Model$VerticalTo(
					fn(_p52._0));
			case 'Curve':
				var _p55 = _p52._0.point;
				var _p54 = _p52._0.control2;
				var _p53 = _p52._0.control1;
				return _mdgriffith$elm_style_animation$Animation_Model$Curve(
					{
						control1: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p53)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p53))
						},
						control2: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p54)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p54))
						},
						point: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p55)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p55))
						}
					});
			case 'CurveTo':
				var _p58 = _p52._0.point;
				var _p57 = _p52._0.control2;
				var _p56 = _p52._0.control1;
				return _mdgriffith$elm_style_animation$Animation_Model$CurveTo(
					{
						control1: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p56)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p56))
						},
						control2: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p57)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p57))
						},
						point: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p58)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p58))
						}
					});
			case 'Quadratic':
				var _p60 = _p52._0.point;
				var _p59 = _p52._0.control;
				return _mdgriffith$elm_style_animation$Animation_Model$Quadratic(
					{
						control: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p59)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p59))
						},
						point: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p60)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p60))
						}
					});
			case 'QuadraticTo':
				var _p62 = _p52._0.point;
				var _p61 = _p52._0.control;
				return _mdgriffith$elm_style_animation$Animation_Model$QuadraticTo(
					{
						control: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p61)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p61))
						},
						point: {
							ctor: '_Tuple2',
							_0: fn(
								_elm_lang$core$Tuple$first(_p62)),
							_1: fn(
								_elm_lang$core$Tuple$second(_p62))
						}
					});
			case 'SmoothQuadratic':
				return _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadratic(
					mapCoords(_p52._0));
			case 'SmoothQuadraticTo':
				return _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadraticTo(
					mapCoords(_p52._0));
			case 'Smooth':
				return _mdgriffith$elm_style_animation$Animation_Model$Smooth(
					mapCoords(_p52._0));
			case 'SmoothTo':
				return _mdgriffith$elm_style_animation$Animation_Model$SmoothTo(
					mapCoords(_p52._0));
			case 'ClockwiseArc':
				var _p63 = _p52._0;
				return _mdgriffith$elm_style_animation$Animation_Model$ClockwiseArc(
					function () {
						var endAngle = _p63.endAngle;
						var startAngle = _p63.startAngle;
						var radius = _p63.radius;
						var y = _p63.y;
						var x = _p63.x;
						return _elm_lang$core$Native_Utils.update(
							_p63,
							{
								x: fn(x),
								y: fn(y),
								radius: fn(radius),
								startAngle: fn(startAngle),
								endAngle: fn(endAngle)
							});
					}());
			case 'AntiClockwiseArc':
				var _p64 = _p52._0;
				return _mdgriffith$elm_style_animation$Animation_Model$AntiClockwiseArc(
					function () {
						var endAngle = _p64.endAngle;
						var startAngle = _p64.startAngle;
						var radius = _p64.radius;
						var y = _p64.y;
						var x = _p64.x;
						return _elm_lang$core$Native_Utils.update(
							_p64,
							{
								x: fn(x),
								y: fn(y),
								radius: fn(radius),
								startAngle: fn(startAngle),
								endAngle: fn(endAngle)
							});
					}());
			default:
				return _mdgriffith$elm_style_animation$Animation_Model$Close;
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$mapToMotion = F2(
	function (fn, prop) {
		var _p65 = prop;
		switch (_p65.ctor) {
			case 'ExactProperty':
				return A2(_mdgriffith$elm_style_animation$Animation_Model$ExactProperty, _p65._0, _p65._1);
			case 'ColorProperty':
				return A5(
					_mdgriffith$elm_style_animation$Animation_Model$ColorProperty,
					_p65._0,
					fn(_p65._1),
					fn(_p65._2),
					fn(_p65._3),
					fn(_p65._4));
			case 'ShadowProperty':
				var _p66 = _p65._2;
				var alpha = _p66.alpha;
				var blue = _p66.blue;
				var green = _p66.green;
				var red = _p66.red;
				var blur = _p66.blur;
				var size = _p66.size;
				var offsetY = _p66.offsetY;
				var offsetX = _p66.offsetX;
				return A3(
					_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
					_p65._0,
					_p65._1,
					{
						offsetX: fn(offsetX),
						offsetY: fn(offsetY),
						size: fn(size),
						blur: fn(blur),
						red: fn(red),
						green: fn(green),
						blue: fn(blue),
						alpha: fn(alpha)
					});
			case 'Property':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$Property,
					_p65._0,
					fn(_p65._1));
			case 'Property2':
				return A3(
					_mdgriffith$elm_style_animation$Animation_Model$Property2,
					_p65._0,
					fn(_p65._1),
					fn(_p65._2));
			case 'Property3':
				return A4(
					_mdgriffith$elm_style_animation$Animation_Model$Property3,
					_p65._0,
					fn(_p65._1),
					fn(_p65._2),
					fn(_p65._3));
			case 'Property4':
				return A5(
					_mdgriffith$elm_style_animation$Animation_Model$Property4,
					_p65._0,
					fn(_p65._1),
					fn(_p65._2),
					fn(_p65._3),
					fn(_p65._4));
			case 'AngleProperty':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$AngleProperty,
					_p65._0,
					fn(_p65._1));
			case 'Points':
				return _mdgriffith$elm_style_animation$Animation_Model$Points(
					A2(
						_elm_lang$core$List$map,
						function (_p67) {
							var _p68 = _p67;
							return {
								ctor: '_Tuple2',
								_0: fn(_p68._0),
								_1: fn(_p68._1)
							};
						},
						_p65._0));
			default:
				return _mdgriffith$elm_style_animation$Animation_Model$Path(
					A2(
						_elm_lang$core$List$map,
						_mdgriffith$elm_style_animation$Animation_Model$mapPathMotion(fn),
						_p65._0));
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$setPathTarget = F2(
	function (cmd, targetCmd) {
		var setMotionTarget = F2(
			function (motion, targetMotion) {
				var _p69 = motion.interpolation;
				if (_p69.ctor === 'Easing') {
					return _elm_lang$core$Native_Utils.update(
						motion,
						{
							target: targetMotion.position,
							interpolation: _mdgriffith$elm_style_animation$Animation_Model$Easing(
								_elm_lang$core$Native_Utils.update(
									_p69._0,
									{start: motion.position}))
						});
				} else {
					return _elm_lang$core$Native_Utils.update(
						motion,
						{target: targetMotion.position});
				}
			});
		var _p70 = cmd;
		switch (_p70.ctor) {
			case 'Move':
				var _p71 = targetCmd;
				if (_p71.ctor === 'Move') {
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$Move,
						A2(setMotionTarget, _p70._0, _p71._0),
						A2(setMotionTarget, _p70._1, _p71._1));
				} else {
					return cmd;
				}
			case 'MoveTo':
				var _p72 = targetCmd;
				if (_p72.ctor === 'MoveTo') {
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$MoveTo,
						A2(setMotionTarget, _p70._0, _p72._0),
						A2(setMotionTarget, _p70._1, _p72._1));
				} else {
					return cmd;
				}
			case 'Line':
				var _p73 = targetCmd;
				if (_p73.ctor === 'Line') {
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$Line,
						A2(setMotionTarget, _p70._0, _p73._0),
						A2(setMotionTarget, _p70._1, _p73._1));
				} else {
					return cmd;
				}
			case 'LineTo':
				var _p74 = targetCmd;
				if (_p74.ctor === 'LineTo') {
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$LineTo,
						A2(setMotionTarget, _p70._0, _p74._0),
						A2(setMotionTarget, _p70._1, _p74._1));
				} else {
					return cmd;
				}
			case 'Horizontal':
				var _p75 = targetCmd;
				if (_p75.ctor === 'Horizontal') {
					return _mdgriffith$elm_style_animation$Animation_Model$Horizontal(
						A2(setMotionTarget, _p70._0, _p75._0));
				} else {
					return cmd;
				}
			case 'HorizontalTo':
				var _p76 = targetCmd;
				if (_p76.ctor === 'HorizontalTo') {
					return _mdgriffith$elm_style_animation$Animation_Model$HorizontalTo(
						A2(setMotionTarget, _p70._0, _p76._0));
				} else {
					return cmd;
				}
			case 'Vertical':
				var _p77 = targetCmd;
				if (_p77.ctor === 'Vertical') {
					return _mdgriffith$elm_style_animation$Animation_Model$Vertical(
						A2(setMotionTarget, _p70._0, _p77._0));
				} else {
					return cmd;
				}
			case 'VerticalTo':
				var _p78 = targetCmd;
				if (_p78.ctor === 'VerticalTo') {
					return _mdgriffith$elm_style_animation$Animation_Model$VerticalTo(
						A2(setMotionTarget, _p70._0, _p78._0));
				} else {
					return cmd;
				}
			case 'Curve':
				var _p81 = _p70._0;
				var _p79 = targetCmd;
				if (_p79.ctor === 'Curve') {
					var _p80 = _p79._0;
					return _mdgriffith$elm_style_animation$Animation_Model$Curve(
						{
							control1: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p81.control1),
									_elm_lang$core$Tuple$first(_p80.control1)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p81.control1),
									_elm_lang$core$Tuple$second(_p80.control1))
							},
							control2: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p81.control2),
									_elm_lang$core$Tuple$first(_p80.control2)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p81.control2),
									_elm_lang$core$Tuple$second(_p80.control2))
							},
							point: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p81.point),
									_elm_lang$core$Tuple$first(_p80.point)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p81.point),
									_elm_lang$core$Tuple$second(_p80.point))
							}
						});
				} else {
					return cmd;
				}
			case 'CurveTo':
				var _p84 = _p70._0;
				var _p82 = targetCmd;
				if (_p82.ctor === 'CurveTo') {
					var _p83 = _p82._0;
					return _mdgriffith$elm_style_animation$Animation_Model$CurveTo(
						{
							control1: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p84.control1),
									_elm_lang$core$Tuple$first(_p83.control1)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p84.control1),
									_elm_lang$core$Tuple$second(_p83.control1))
							},
							control2: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p84.control2),
									_elm_lang$core$Tuple$first(_p83.control2)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p84.control2),
									_elm_lang$core$Tuple$second(_p83.control2))
							},
							point: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p84.point),
									_elm_lang$core$Tuple$first(_p83.point)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p84.point),
									_elm_lang$core$Tuple$second(_p83.point))
							}
						});
				} else {
					return cmd;
				}
			case 'Quadratic':
				var _p87 = _p70._0;
				var _p85 = targetCmd;
				if (_p85.ctor === 'Quadratic') {
					var _p86 = _p85._0;
					return _mdgriffith$elm_style_animation$Animation_Model$Quadratic(
						{
							control: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p87.control),
									_elm_lang$core$Tuple$first(_p86.control)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p87.control),
									_elm_lang$core$Tuple$second(_p86.control))
							},
							point: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p87.point),
									_elm_lang$core$Tuple$first(_p86.point)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p87.point),
									_elm_lang$core$Tuple$second(_p86.point))
							}
						});
				} else {
					return cmd;
				}
			case 'QuadraticTo':
				var _p90 = _p70._0;
				var _p88 = targetCmd;
				if (_p88.ctor === 'QuadraticTo') {
					var _p89 = _p88._0;
					return _mdgriffith$elm_style_animation$Animation_Model$QuadraticTo(
						{
							control: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p90.control),
									_elm_lang$core$Tuple$first(_p89.control)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p90.control),
									_elm_lang$core$Tuple$second(_p89.control))
							},
							point: {
								ctor: '_Tuple2',
								_0: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$first(_p90.point),
									_elm_lang$core$Tuple$first(_p89.point)),
								_1: A2(
									setMotionTarget,
									_elm_lang$core$Tuple$second(_p90.point),
									_elm_lang$core$Tuple$second(_p89.point))
							}
						});
				} else {
					return cmd;
				}
			case 'SmoothQuadratic':
				var _p91 = targetCmd;
				if (_p91.ctor === 'SmoothQuadratic') {
					return _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadratic(
						A3(
							_elm_lang$core$List$map2,
							F2(
								function (_p93, _p92) {
									var _p94 = _p93;
									var _p95 = _p92;
									return {
										ctor: '_Tuple2',
										_0: A2(setMotionTarget, _p94._0, _p95._0),
										_1: A2(setMotionTarget, _p94._1, _p95._1)
									};
								}),
							_p70._0,
							_p91._0));
				} else {
					return cmd;
				}
			case 'SmoothQuadraticTo':
				var _p96 = targetCmd;
				if (_p96.ctor === 'SmoothQuadraticTo') {
					return _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadraticTo(
						A3(
							_elm_lang$core$List$map2,
							F2(
								function (_p98, _p97) {
									var _p99 = _p98;
									var _p100 = _p97;
									return {
										ctor: '_Tuple2',
										_0: A2(setMotionTarget, _p99._0, _p100._0),
										_1: A2(setMotionTarget, _p99._1, _p100._1)
									};
								}),
							_p70._0,
							_p96._0));
				} else {
					return cmd;
				}
			case 'Smooth':
				var _p101 = targetCmd;
				if (_p101.ctor === 'Smooth') {
					return _mdgriffith$elm_style_animation$Animation_Model$Smooth(
						A3(
							_elm_lang$core$List$map2,
							F2(
								function (_p103, _p102) {
									var _p104 = _p103;
									var _p105 = _p102;
									return {
										ctor: '_Tuple2',
										_0: A2(setMotionTarget, _p104._0, _p105._0),
										_1: A2(setMotionTarget, _p104._1, _p105._1)
									};
								}),
							_p70._0,
							_p101._0));
				} else {
					return cmd;
				}
			case 'SmoothTo':
				var _p106 = targetCmd;
				if (_p106.ctor === 'SmoothTo') {
					return _mdgriffith$elm_style_animation$Animation_Model$SmoothTo(
						A3(
							_elm_lang$core$List$map2,
							F2(
								function (_p108, _p107) {
									var _p109 = _p108;
									var _p110 = _p107;
									return {
										ctor: '_Tuple2',
										_0: A2(setMotionTarget, _p109._0, _p110._0),
										_1: A2(setMotionTarget, _p109._1, _p110._1)
									};
								}),
							_p70._0,
							_p106._0));
				} else {
					return cmd;
				}
			case 'ClockwiseArc':
				var _p113 = _p70._0;
				var _p111 = targetCmd;
				if (_p111.ctor === 'ClockwiseArc') {
					var _p112 = _p111._0;
					return _mdgriffith$elm_style_animation$Animation_Model$ClockwiseArc(
						function () {
							var endAngle = _p113.endAngle;
							var startAngle = _p113.startAngle;
							var radius = _p113.radius;
							var y = _p113.y;
							var x = _p113.x;
							return _elm_lang$core$Native_Utils.update(
								_p113,
								{
									x: A2(setMotionTarget, x, _p112.x),
									y: A2(setMotionTarget, y, _p112.y),
									radius: A2(setMotionTarget, radius, _p112.radius),
									startAngle: A2(setMotionTarget, startAngle, _p112.startAngle),
									endAngle: A2(setMotionTarget, endAngle, _p112.endAngle)
								});
						}());
				} else {
					return cmd;
				}
			case 'AntiClockwiseArc':
				var _p116 = _p70._0;
				var _p114 = targetCmd;
				if (_p114.ctor === 'AntiClockwiseArc') {
					var _p115 = _p114._0;
					return _mdgriffith$elm_style_animation$Animation_Model$AntiClockwiseArc(
						function () {
							var endAngle = _p116.endAngle;
							var startAngle = _p116.startAngle;
							var radius = _p116.radius;
							var y = _p116.y;
							var x = _p116.x;
							return _elm_lang$core$Native_Utils.update(
								_p116,
								{
									x: A2(setMotionTarget, x, _p115.x),
									y: A2(setMotionTarget, y, _p115.y),
									radius: A2(setMotionTarget, radius, _p115.radius),
									startAngle: A2(setMotionTarget, startAngle, _p115.startAngle),
									endAngle: A2(setMotionTarget, endAngle, _p115.endAngle)
								});
						}());
				} else {
					return cmd;
				}
			default:
				return _mdgriffith$elm_style_animation$Animation_Model$Close;
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$setTarget = F3(
	function (overrideInterpolation, current, newTarget) {
		var setMotionTarget = F2(
			function (motion, targetMotion) {
				var newMotion = overrideInterpolation ? _elm_lang$core$Native_Utils.update(
					motion,
					{
						interpolationOverride: _elm_lang$core$Maybe$Just(targetMotion.interpolation)
					}) : motion;
				var _p117 = newMotion.interpolationOverride;
				if (_p117.ctor === 'Nothing') {
					var _p118 = newMotion.interpolation;
					if (_p118.ctor === 'Easing') {
						return _elm_lang$core$Native_Utils.update(
							newMotion,
							{
								target: targetMotion.position,
								interpolation: _mdgriffith$elm_style_animation$Animation_Model$Easing(
									_elm_lang$core$Native_Utils.update(
										_p118._0,
										{start: motion.position, progress: 0}))
							});
					} else {
						return _elm_lang$core$Native_Utils.update(
							newMotion,
							{target: targetMotion.position});
					}
				} else {
					var _p119 = _p117._0;
					if (_p119.ctor === 'Easing') {
						return _elm_lang$core$Native_Utils.update(
							newMotion,
							{
								target: targetMotion.position,
								interpolationOverride: _elm_lang$core$Maybe$Just(
									_mdgriffith$elm_style_animation$Animation_Model$Easing(
										_elm_lang$core$Native_Utils.update(
											_p119._0,
											{start: motion.position, progress: 0})))
							});
					} else {
						return _elm_lang$core$Native_Utils.update(
							newMotion,
							{target: targetMotion.position});
					}
				}
			});
		var _p120 = current;
		switch (_p120.ctor) {
			case 'ExactProperty':
				return A2(_mdgriffith$elm_style_animation$Animation_Model$ExactProperty, _p120._0, _p120._1);
			case 'ColorProperty':
				var _p121 = newTarget;
				if (_p121.ctor === 'ColorProperty') {
					return A5(
						_mdgriffith$elm_style_animation$Animation_Model$ColorProperty,
						_p120._0,
						A2(setMotionTarget, _p120._1, _p121._1),
						A2(setMotionTarget, _p120._2, _p121._2),
						A2(setMotionTarget, _p120._3, _p121._3),
						A2(setMotionTarget, _p120._4, _p121._4));
				} else {
					return current;
				}
			case 'ShadowProperty':
				var _p124 = _p120._2;
				var _p122 = newTarget;
				if (_p122.ctor === 'ShadowProperty') {
					var _p123 = _p122._2;
					return A3(
						_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
						_p120._0,
						_p120._1,
						{
							offsetX: A2(setMotionTarget, _p124.offsetX, _p123.offsetX),
							offsetY: A2(setMotionTarget, _p124.offsetY, _p123.offsetY),
							size: A2(setMotionTarget, _p124.size, _p123.size),
							blur: A2(setMotionTarget, _p124.blur, _p123.blur),
							red: A2(setMotionTarget, _p124.red, _p123.red),
							green: A2(setMotionTarget, _p124.green, _p123.green),
							blue: A2(setMotionTarget, _p124.blue, _p123.blue),
							alpha: A2(setMotionTarget, _p124.alpha, _p123.alpha)
						});
				} else {
					return current;
				}
			case 'Property':
				var _p125 = newTarget;
				if (_p125.ctor === 'Property') {
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$Property,
						_p120._0,
						A2(setMotionTarget, _p120._1, _p125._1));
				} else {
					return current;
				}
			case 'Property2':
				var _p126 = newTarget;
				if (_p126.ctor === 'Property2') {
					return A3(
						_mdgriffith$elm_style_animation$Animation_Model$Property2,
						_p120._0,
						A2(setMotionTarget, _p120._1, _p126._1),
						A2(setMotionTarget, _p120._2, _p126._2));
				} else {
					return current;
				}
			case 'Property3':
				var _p127 = newTarget;
				if (_p127.ctor === 'Property3') {
					return A4(
						_mdgriffith$elm_style_animation$Animation_Model$Property3,
						_p120._0,
						A2(setMotionTarget, _p120._1, _p127._1),
						A2(setMotionTarget, _p120._2, _p127._2),
						A2(setMotionTarget, _p120._3, _p127._3));
				} else {
					return current;
				}
			case 'Property4':
				var _p128 = newTarget;
				if (_p128.ctor === 'Property4') {
					return A5(
						_mdgriffith$elm_style_animation$Animation_Model$Property4,
						_p120._0,
						A2(setMotionTarget, _p120._1, _p128._1),
						A2(setMotionTarget, _p120._2, _p128._2),
						A2(setMotionTarget, _p120._3, _p128._3),
						A2(setMotionTarget, _p120._4, _p128._4));
				} else {
					return current;
				}
			case 'AngleProperty':
				var _p129 = newTarget;
				if (_p129.ctor === 'AngleProperty') {
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$AngleProperty,
						_p120._0,
						A2(setMotionTarget, _p120._1, _p129._1));
				} else {
					return current;
				}
			case 'Points':
				var _p130 = newTarget;
				if (_p130.ctor === 'Points') {
					var _p131 = A2(_mdgriffith$elm_style_animation$Animation_Model$matchPoints, _p120._0, _p130._0);
					var m1s = _p131._0;
					var m2s = _p131._1;
					return _mdgriffith$elm_style_animation$Animation_Model$Points(
						A3(
							_elm_lang$core$List$map2,
							F2(
								function (_p133, _p132) {
									var _p134 = _p133;
									var _p135 = _p132;
									return {
										ctor: '_Tuple2',
										_0: A2(setMotionTarget, _p134._0, _p135._0),
										_1: A2(setMotionTarget, _p134._1, _p135._1)
									};
								}),
							m1s,
							m2s));
				} else {
					return current;
				}
			default:
				var _p136 = newTarget;
				if (_p136.ctor === 'Path') {
					return _mdgriffith$elm_style_animation$Animation_Model$Path(
						A3(_elm_lang$core$List$map2, _mdgriffith$elm_style_animation$Animation_Model$setPathTarget, _p120._0, _p136._0));
				} else {
					return current;
				}
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$startTowards = F3(
	function (overrideInterpolation, current, target) {
		return A2(
			_elm_lang$core$List$filterMap,
			function (propPair) {
				var _p137 = propPair;
				if (_p137._1.ctor === 'Just') {
					return _elm_lang$core$Maybe$Just(
						A3(_mdgriffith$elm_style_animation$Animation_Model$setTarget, overrideInterpolation, _p137._0, _p137._1._0));
				} else {
					return _elm_lang$core$Maybe$Just(_p137._0);
				}
			},
			A2(_mdgriffith$elm_style_animation$Animation_Model$zipPropertiesGreedy, current, target));
	});
var _mdgriffith$elm_style_animation$Animation_Model$stepPath = F2(
	function (dt, cmd) {
		var stepCoords = function (coords) {
			return A2(
				_elm_lang$core$List$map,
				function (_p138) {
					var _p139 = _p138;
					return {
						ctor: '_Tuple2',
						_0: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p139._0),
						_1: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p139._1)
					};
				},
				coords);
		};
		var _p140 = cmd;
		switch (_p140.ctor) {
			case 'Move':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$Move,
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0),
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._1));
			case 'MoveTo':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$MoveTo,
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0),
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._1));
			case 'Line':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$Line,
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0),
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._1));
			case 'LineTo':
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$LineTo,
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0),
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._1));
			case 'Horizontal':
				return _mdgriffith$elm_style_animation$Animation_Model$Horizontal(
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0));
			case 'HorizontalTo':
				return _mdgriffith$elm_style_animation$Animation_Model$HorizontalTo(
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0));
			case 'Vertical':
				return _mdgriffith$elm_style_animation$Animation_Model$Vertical(
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0));
			case 'VerticalTo':
				return _mdgriffith$elm_style_animation$Animation_Model$VerticalTo(
					A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p140._0));
			case 'Curve':
				var _p143 = _p140._0.point;
				var _p142 = _p140._0.control2;
				var _p141 = _p140._0.control1;
				return _mdgriffith$elm_style_animation$Animation_Model$Curve(
					{
						control1: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p141)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p141))
						},
						control2: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p142)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p142))
						},
						point: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p143)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p143))
						}
					});
			case 'CurveTo':
				var _p146 = _p140._0.point;
				var _p145 = _p140._0.control2;
				var _p144 = _p140._0.control1;
				return _mdgriffith$elm_style_animation$Animation_Model$CurveTo(
					{
						control1: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p144)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p144))
						},
						control2: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p145)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p145))
						},
						point: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p146)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p146))
						}
					});
			case 'Quadratic':
				var _p148 = _p140._0.point;
				var _p147 = _p140._0.control;
				return _mdgriffith$elm_style_animation$Animation_Model$Quadratic(
					{
						control: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p147)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p147))
						},
						point: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p148)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p148))
						}
					});
			case 'QuadraticTo':
				var _p150 = _p140._0.point;
				var _p149 = _p140._0.control;
				return _mdgriffith$elm_style_animation$Animation_Model$QuadraticTo(
					{
						control: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p149)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p149))
						},
						point: {
							ctor: '_Tuple2',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$first(_p150)),
							_1: A2(
								_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation,
								dt,
								_elm_lang$core$Tuple$second(_p150))
						}
					});
			case 'SmoothQuadratic':
				return _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadratic(
					stepCoords(_p140._0));
			case 'SmoothQuadraticTo':
				return _mdgriffith$elm_style_animation$Animation_Model$SmoothQuadraticTo(
					stepCoords(_p140._0));
			case 'Smooth':
				return _mdgriffith$elm_style_animation$Animation_Model$Smooth(
					stepCoords(_p140._0));
			case 'SmoothTo':
				return _mdgriffith$elm_style_animation$Animation_Model$SmoothTo(
					stepCoords(_p140._0));
			case 'ClockwiseArc':
				var _p151 = _p140._0;
				return _mdgriffith$elm_style_animation$Animation_Model$ClockwiseArc(
					_elm_lang$core$Native_Utils.update(
						_p151,
						{
							x: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p151.x),
							y: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p151.y),
							radius: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p151.radius),
							startAngle: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p151.startAngle),
							endAngle: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p151.endAngle)
						}));
			case 'AntiClockwiseArc':
				var _p152 = _p140._0;
				return _mdgriffith$elm_style_animation$Animation_Model$AntiClockwiseArc(
					_elm_lang$core$Native_Utils.update(
						_p152,
						{
							x: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p152.x),
							y: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p152.y),
							radius: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p152.radius),
							startAngle: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p152.startAngle),
							endAngle: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p152.endAngle)
						}));
			default:
				return _mdgriffith$elm_style_animation$Animation_Model$Close;
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$step = F2(
	function (dt, props) {
		var stepProp = function (property) {
			var _p153 = property;
			switch (_p153.ctor) {
				case 'ExactProperty':
					return A2(_mdgriffith$elm_style_animation$Animation_Model$ExactProperty, _p153._0, _p153._1);
				case 'Property':
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$Property,
						_p153._0,
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._1));
				case 'Property2':
					return A3(
						_mdgriffith$elm_style_animation$Animation_Model$Property2,
						_p153._0,
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._1),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._2));
				case 'Property3':
					return A4(
						_mdgriffith$elm_style_animation$Animation_Model$Property3,
						_p153._0,
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._1),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._2),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._3));
				case 'Property4':
					return A5(
						_mdgriffith$elm_style_animation$Animation_Model$Property4,
						_p153._0,
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._1),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._2),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._3),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._4));
				case 'AngleProperty':
					return A2(
						_mdgriffith$elm_style_animation$Animation_Model$AngleProperty,
						_p153._0,
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._1));
				case 'ColorProperty':
					return A5(
						_mdgriffith$elm_style_animation$Animation_Model$ColorProperty,
						_p153._0,
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._1),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._2),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._3),
						A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p153._4));
				case 'ShadowProperty':
					var _p154 = _p153._2;
					return A3(
						_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
						_p153._0,
						_p153._1,
						{
							offsetX: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.offsetX),
							offsetY: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.offsetY),
							size: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.size),
							blur: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.blur),
							red: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.red),
							green: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.green),
							blue: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.blue),
							alpha: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p154.alpha)
						});
				case 'Points':
					return _mdgriffith$elm_style_animation$Animation_Model$Points(
						A2(
							_elm_lang$core$List$map,
							function (_p155) {
								var _p156 = _p155;
								return {
									ctor: '_Tuple2',
									_0: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p156._0),
									_1: A2(_mdgriffith$elm_style_animation$Animation_Model$stepInterpolation, dt, _p156._1)
								};
							},
							_p153._0));
				default:
					return _mdgriffith$elm_style_animation$Animation_Model$Path(
						A2(
							_elm_lang$core$List$map,
							_mdgriffith$elm_style_animation$Animation_Model$stepPath(dt),
							_p153._0));
			}
		};
		return A2(_elm_lang$core$List$map, stepProp, props);
	});
var _mdgriffith$elm_style_animation$Animation_Model$alreadyThere = F2(
	function (current, target) {
		return A2(
			_elm_lang$core$List$all,
			_mdgriffith$elm_style_animation$Animation_Model$isDone,
			A2(
				_mdgriffith$elm_style_animation$Animation_Model$step,
				0,
				A3(_mdgriffith$elm_style_animation$Animation_Model$startTowards, false, current, target)));
	});
var _mdgriffith$elm_style_animation$Animation_Model$resolveSteps = F3(
	function (currentStyle, steps, dt) {
		resolveSteps:
		while (true) {
			var _p157 = _elm_lang$core$List$head(steps);
			if (_p157.ctor === 'Nothing') {
				return {
					ctor: '_Tuple3',
					_0: currentStyle,
					_1: {ctor: '[]'},
					_2: {ctor: '[]'}
				};
			} else {
				var _p158 = _p157._0;
				switch (_p158.ctor) {
					case 'Wait':
						var _p159 = _p158._0;
						if (_elm_lang$core$Native_Utils.cmp(_p159, 0) < 1) {
							var _v70 = currentStyle,
								_v71 = A2(_elm_lang$core$List$drop, 1, steps),
								_v72 = dt;
							currentStyle = _v70;
							steps = _v71;
							dt = _v72;
							continue resolveSteps;
						} else {
							return {
								ctor: '_Tuple3',
								_0: currentStyle,
								_1: {ctor: '[]'},
								_2: {
									ctor: '::',
									_0: _mdgriffith$elm_style_animation$Animation_Model$Wait(_p159 - dt),
									_1: A2(_elm_lang$core$List$drop, 1, steps)
								}
							};
						}
					case 'Send':
						var _p160 = A3(
							_mdgriffith$elm_style_animation$Animation_Model$resolveSteps,
							currentStyle,
							A2(_elm_lang$core$List$drop, 1, steps),
							dt);
						var newStyle = _p160._0;
						var msgs = _p160._1;
						var remainingSteps = _p160._2;
						return {
							ctor: '_Tuple3',
							_0: newStyle,
							_1: {ctor: '::', _0: _p158._0, _1: msgs},
							_2: remainingSteps
						};
					case 'To':
						var _p161 = _p158._0;
						if (A2(_mdgriffith$elm_style_animation$Animation_Model$alreadyThere, currentStyle, _p161)) {
							return {
								ctor: '_Tuple3',
								_0: currentStyle,
								_1: {ctor: '[]'},
								_2: A2(_elm_lang$core$List$drop, 1, steps)
							};
						} else {
							var _v73 = A3(_mdgriffith$elm_style_animation$Animation_Model$startTowards, false, currentStyle, _p161),
								_v74 = {
								ctor: '::',
								_0: _mdgriffith$elm_style_animation$Animation_Model$Step,
								_1: A2(_elm_lang$core$List$drop, 1, steps)
							},
								_v75 = dt;
							currentStyle = _v73;
							steps = _v74;
							dt = _v75;
							continue resolveSteps;
						}
					case 'ToWith':
						var _p162 = _p158._0;
						if (A2(_mdgriffith$elm_style_animation$Animation_Model$alreadyThere, currentStyle, _p162)) {
							return {
								ctor: '_Tuple3',
								_0: currentStyle,
								_1: {ctor: '[]'},
								_2: A2(_elm_lang$core$List$drop, 1, steps)
							};
						} else {
							var _v76 = A3(_mdgriffith$elm_style_animation$Animation_Model$startTowards, true, currentStyle, _p162),
								_v77 = {
								ctor: '::',
								_0: _mdgriffith$elm_style_animation$Animation_Model$Step,
								_1: A2(_elm_lang$core$List$drop, 1, steps)
							},
								_v78 = dt;
							currentStyle = _v76;
							steps = _v77;
							dt = _v78;
							continue resolveSteps;
						}
					case 'Set':
						var _v79 = A2(_mdgriffith$elm_style_animation$Animation_Model$replaceProps, currentStyle, _p158._0),
							_v80 = A2(_elm_lang$core$List$drop, 1, steps),
							_v81 = dt;
						currentStyle = _v79;
						steps = _v80;
						dt = _v81;
						continue resolveSteps;
					case 'Step':
						var stepped = A2(_mdgriffith$elm_style_animation$Animation_Model$step, dt, currentStyle);
						return A2(_elm_lang$core$List$all, _mdgriffith$elm_style_animation$Animation_Model$isDone, stepped) ? {
							ctor: '_Tuple3',
							_0: A2(
								_elm_lang$core$List$map,
								_mdgriffith$elm_style_animation$Animation_Model$mapToMotion(
									function (m) {
										return _elm_lang$core$Native_Utils.update(
											m,
											{interpolationOverride: _elm_lang$core$Maybe$Nothing});
									}),
								stepped),
							_1: {ctor: '[]'},
							_2: A2(_elm_lang$core$List$drop, 1, steps)
						} : {
							ctor: '_Tuple3',
							_0: stepped,
							_1: {ctor: '[]'},
							_2: steps
						};
					case 'Loop':
						var _p163 = _p158._0;
						var _v82 = currentStyle,
							_v83 = A2(
							_elm_lang$core$Basics_ops['++'],
							_p163,
							{
								ctor: '::',
								_0: _mdgriffith$elm_style_animation$Animation_Model$Loop(_p163),
								_1: {ctor: '[]'}
							}),
							_v84 = dt;
						currentStyle = _v82;
						steps = _v83;
						dt = _v84;
						continue resolveSteps;
					default:
						var _p165 = _p158._1;
						var _p164 = _p158._0;
						if (_elm_lang$core$Native_Utils.cmp(_p164, 0) < 1) {
							var _v85 = currentStyle,
								_v86 = A2(_elm_lang$core$List$drop, 1, steps),
								_v87 = dt;
							currentStyle = _v85;
							steps = _v86;
							dt = _v87;
							continue resolveSteps;
						} else {
							var _v88 = currentStyle,
								_v89 = A2(
								_elm_lang$core$Basics_ops['++'],
								_p165,
								A2(
									_elm_lang$core$Basics_ops['++'],
									{
										ctor: '::',
										_0: A2(_mdgriffith$elm_style_animation$Animation_Model$Repeat, _p164 - 1, _p165),
										_1: {ctor: '[]'}
									},
									A2(_elm_lang$core$List$drop, 1, steps))),
								_v90 = dt;
							currentStyle = _v88;
							steps = _v89;
							dt = _v90;
							continue resolveSteps;
						}
				}
			}
		}
	});
var _mdgriffith$elm_style_animation$Animation_Model$updateAnimation = F2(
	function (_p167, _p166) {
		var _p168 = _p167;
		var _p169 = _p166;
		var _p178 = _p169._0;
		var timing = A2(_mdgriffith$elm_style_animation$Animation_Model$refreshTiming, _p168._0, _p178.timing);
		var _p170 = A2(
			_elm_lang$core$List$partition,
			function (_p171) {
				var _p172 = _p171;
				return _elm_lang$core$Native_Utils.cmp(_p172._0, 0) < 1;
			},
			A2(
				_elm_lang$core$List$map,
				function (_p173) {
					var _p174 = _p173;
					return {ctor: '_Tuple2', _0: _p174._0 - timing.dt, _1: _p174._1};
				},
				_p178.interruption));
		var readyInterruption = _p170._0;
		var queuedInterruptions = _p170._1;
		var _p175 = function () {
			var _p176 = _elm_lang$core$List$head(readyInterruption);
			if (_p176.ctor === 'Just') {
				return {
					ctor: '_Tuple2',
					_0: _p176._0._1,
					_1: A2(
						_elm_lang$core$List$map,
						_mdgriffith$elm_style_animation$Animation_Model$mapToMotion(
							function (m) {
								return _elm_lang$core$Native_Utils.update(
									m,
									{interpolationOverride: _elm_lang$core$Maybe$Nothing});
							}),
						_p178.style)
				};
			} else {
				return {ctor: '_Tuple2', _0: _p178.steps, _1: _p178.style};
			}
		}();
		var steps = _p175._0;
		var style = _p175._1;
		var _p177 = A3(_mdgriffith$elm_style_animation$Animation_Model$resolveSteps, style, steps, timing.dt);
		var revisedStyle = _p177._0;
		var sentMessages = _p177._1;
		var revisedSteps = _p177._2;
		return {
			ctor: '_Tuple2',
			_0: _mdgriffith$elm_style_animation$Animation_Model$Animation(
				_elm_lang$core$Native_Utils.update(
					_p178,
					{
						timing: timing,
						interruption: queuedInterruptions,
						running: (!_elm_lang$core$Native_Utils.eq(
							_elm_lang$core$List$length(revisedSteps),
							0)) || (!_elm_lang$core$Native_Utils.eq(
							_elm_lang$core$List$length(queuedInterruptions),
							0)),
						steps: revisedSteps,
						style: revisedStyle
					})),
			_1: _elm_lang$core$Platform_Cmd$batch(
				A2(
					_elm_lang$core$List$map,
					function (m) {
						return A2(
							_elm_lang$core$Task$perform,
							_elm_lang$core$Basics$identity,
							_elm_lang$core$Task$succeed(m));
					},
					sentMessages))
		};
	});

var _mdgriffith$elm_style_animation$Animation_Render$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			var _p0 = list;
			if (_p0.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				if (predicate(_p0._0)) {
					var _v1 = predicate,
						_v2 = _p0._1;
					predicate = _v1;
					list = _v2;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var _mdgriffith$elm_style_animation$Animation_Render$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				var _p1 = list;
				if (_p1.ctor === '[]') {
					return _elm_lang$core$List$reverse(memo);
				} else {
					var _p2 = _p1._0;
					if (predicate(_p2)) {
						var _v4 = {ctor: '::', _0: _p2, _1: memo},
							_v5 = _p1._1;
						memo = _v4;
						list = _v5;
						continue takeWhileMemo;
					} else {
						return _elm_lang$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(
		{ctor: '[]'});
};
var _mdgriffith$elm_style_animation$Animation_Render$span = F2(
	function (p, xs) {
		return {
			ctor: '_Tuple2',
			_0: A2(_mdgriffith$elm_style_animation$Animation_Render$takeWhile, p, xs),
			_1: A2(_mdgriffith$elm_style_animation$Animation_Render$dropWhile, p, xs)
		};
	});
var _mdgriffith$elm_style_animation$Animation_Render$groupWhile = F2(
	function (eq, xs_) {
		var _p3 = xs_;
		if (_p3.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var _p5 = _p3._0;
			var _p4 = A2(
				_mdgriffith$elm_style_animation$Animation_Render$span,
				eq(_p5),
				_p3._1);
			var ys = _p4._0;
			var zs = _p4._1;
			return {
				ctor: '::',
				_0: {ctor: '::', _0: _p5, _1: ys},
				_1: A2(_mdgriffith$elm_style_animation$Animation_Render$groupWhile, eq, zs)
			};
		}
	});
var _mdgriffith$elm_style_animation$Animation_Render$pathCmdValue = function (cmd) {
	var renderPoints = function (coords) {
		return A2(
			_elm_lang$core$String$join,
			' ',
			A2(
				_elm_lang$core$List$map,
				function (_p6) {
					var _p7 = _p6;
					return A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p7._0.position),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							_elm_lang$core$Basics$toString(_p7._1.position)));
				},
				coords));
	};
	var _p8 = cmd;
	switch (_p8.ctor) {
		case 'Move':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'm ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p8._0.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						',',
						_elm_lang$core$Basics$toString(_p8._1.position))));
		case 'MoveTo':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'M ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p8._0.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						',',
						_elm_lang$core$Basics$toString(_p8._1.position))));
		case 'Line':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'l ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p8._0.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						',',
						_elm_lang$core$Basics$toString(_p8._1.position))));
		case 'LineTo':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'L ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p8._0.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						',',
						_elm_lang$core$Basics$toString(_p8._1.position))));
		case 'Horizontal':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'h ',
				_elm_lang$core$Basics$toString(_p8._0.position));
		case 'HorizontalTo':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'H ',
				_elm_lang$core$Basics$toString(_p8._0.position));
		case 'Vertical':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'v ',
				_elm_lang$core$Basics$toString(_p8._0.position));
		case 'VerticalTo':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'V ',
				_elm_lang$core$Basics$toString(_p8._0.position));
		case 'Curve':
			var _p9 = _p8._0.point;
			var p1x = _p9._0;
			var p1y = _p9._1;
			var _p10 = _p8._0.control2;
			var c2x = _p10._0;
			var c2y = _p10._1;
			var _p11 = _p8._0.control1;
			var c1x = _p11._0;
			var c1y = _p11._1;
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'c ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(c1x.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(c1y.position),
							A2(
								_elm_lang$core$Basics_ops['++'],
								', ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(c2x.position),
									A2(
										_elm_lang$core$Basics_ops['++'],
										' ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(c2y.position),
											A2(
												_elm_lang$core$Basics_ops['++'],
												', ',
												A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(p1x.position),
													A2(
														_elm_lang$core$Basics_ops['++'],
														' ',
														_elm_lang$core$Basics$toString(p1y.position))))))))))));
		case 'CurveTo':
			var _p12 = _p8._0.point;
			var p1x = _p12._0;
			var p1y = _p12._1;
			var _p13 = _p8._0.control2;
			var c2x = _p13._0;
			var c2y = _p13._1;
			var _p14 = _p8._0.control1;
			var c1x = _p14._0;
			var c1y = _p14._1;
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'C ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(c1x.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(c1y.position),
							A2(
								_elm_lang$core$Basics_ops['++'],
								', ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(c2x.position),
									A2(
										_elm_lang$core$Basics_ops['++'],
										' ',
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(c2y.position),
											A2(
												_elm_lang$core$Basics_ops['++'],
												', ',
												A2(
													_elm_lang$core$Basics_ops['++'],
													_elm_lang$core$Basics$toString(p1x.position),
													A2(
														_elm_lang$core$Basics_ops['++'],
														' ',
														_elm_lang$core$Basics$toString(p1y.position))))))))))));
		case 'Quadratic':
			var _p15 = _p8._0.point;
			var p1x = _p15._0;
			var p1y = _p15._1;
			var _p16 = _p8._0.control;
			var c1x = _p16._0;
			var c1y = _p16._1;
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'q ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(c1x.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(c1y.position),
							A2(
								_elm_lang$core$Basics_ops['++'],
								', ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(p1x.position),
									A2(
										_elm_lang$core$Basics_ops['++'],
										' ',
										_elm_lang$core$Basics$toString(p1y.position))))))));
		case 'QuadraticTo':
			var _p17 = _p8._0.point;
			var p1x = _p17._0;
			var p1y = _p17._1;
			var _p18 = _p8._0.control;
			var c1x = _p18._0;
			var c1y = _p18._1;
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'Q ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(c1x.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(c1y.position),
							A2(
								_elm_lang$core$Basics_ops['++'],
								', ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(p1x.position),
									A2(
										_elm_lang$core$Basics_ops['++'],
										' ',
										_elm_lang$core$Basics$toString(p1y.position))))))));
		case 'SmoothQuadratic':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				't ',
				renderPoints(_p8._0));
		case 'SmoothQuadraticTo':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'T ',
				renderPoints(_p8._0));
		case 'Smooth':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				's ',
				renderPoints(_p8._0));
		case 'SmoothTo':
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'S ',
				renderPoints(_p8._0));
		case 'ClockwiseArc':
			var _p19 = _p8._0;
			var deltaAngle = _p19.endAngle.position - _p19.startAngle.position;
			if (_elm_lang$core$Native_Utils.cmp(deltaAngle, 360 - 1.0e-6) > 0) {
				var dy = _p19.radius.position * _elm_lang$core$Basics$sin(
					_elm_lang$core$Basics$degrees(_p19.startAngle.position));
				var dx = _p19.radius.position * _elm_lang$core$Basics$cos(
					_elm_lang$core$Basics$degrees(_p19.startAngle.position));
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'A ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p19.radius.position),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p19.radius.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									',0,1,1,',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p19.x.position - dx),
										A2(
											_elm_lang$core$Basics_ops['++'],
											',',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p19.y.position - dy),
												A2(
													_elm_lang$core$Basics_ops['++'],
													' A ',
													A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(_p19.radius.position),
														A2(
															_elm_lang$core$Basics_ops['++'],
															',',
															A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString(_p19.radius.position),
																A2(
																	_elm_lang$core$Basics_ops['++'],
																	',0,1,1,',
																	A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(_p19.x.position + dx),
																		A2(
																			_elm_lang$core$Basics_ops['++'],
																			',',
																			_elm_lang$core$Basics$toString(_p19.y.position + dy))))))))))))))));
			} else {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'A ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p19.radius.position),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p19.radius.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									' 0 ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										(_elm_lang$core$Native_Utils.cmp(deltaAngle, 180) > -1) ? '1' : '0',
										A2(
											_elm_lang$core$Basics_ops['++'],
											' ',
											A2(
												_elm_lang$core$Basics_ops['++'],
												'1',
												A2(
													_elm_lang$core$Basics_ops['++'],
													' ',
													A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(
															_p19.x.position + (_p19.radius.position * _elm_lang$core$Basics$cos(
																_elm_lang$core$Basics$degrees(_p19.endAngle.position)))),
														A2(
															_elm_lang$core$Basics_ops['++'],
															',',
															_elm_lang$core$Basics$toString(
																_p19.y.position + (_p19.radius.position * _elm_lang$core$Basics$sin(
																	_elm_lang$core$Basics$degrees(_p19.endAngle.position)))))))))))))));
			}
		case 'AntiClockwiseArc':
			var _p20 = _p8._0;
			var deltaAngle = _p20.endAngle.position - _p20.startAngle.position;
			if (_elm_lang$core$Native_Utils.cmp(deltaAngle, 360 - 1.0e-6) > 0) {
				var dy = _p20.radius.position * _elm_lang$core$Basics$sin(
					_elm_lang$core$Basics$degrees(_p20.startAngle.position));
				var dx = _p20.radius.position * _elm_lang$core$Basics$cos(
					_elm_lang$core$Basics$degrees(_p20.startAngle.position));
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'A ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p20.radius.position),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p20.radius.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									',0,1,0,',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p20.x.position - dx),
										A2(
											_elm_lang$core$Basics_ops['++'],
											',',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p20.y.position - dy),
												A2(
													_elm_lang$core$Basics_ops['++'],
													' A ',
													A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(_p20.radius.position),
														A2(
															_elm_lang$core$Basics_ops['++'],
															',',
															A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString(_p20.radius.position),
																A2(
																	_elm_lang$core$Basics_ops['++'],
																	',0,1,1,',
																	A2(
																		_elm_lang$core$Basics_ops['++'],
																		_elm_lang$core$Basics$toString(_p20.x.position + dx),
																		A2(
																			_elm_lang$core$Basics_ops['++'],
																			',',
																			_elm_lang$core$Basics$toString(_p20.y.position + dy))))))))))))))));
			} else {
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'A ',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p20.radius.position),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p20.radius.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									' 0 ',
									A2(
										_elm_lang$core$Basics_ops['++'],
										(_elm_lang$core$Native_Utils.cmp(_p20.startAngle.position - _p20.endAngle.position, 180) > -1) ? '1' : '0',
										A2(
											_elm_lang$core$Basics_ops['++'],
											' ',
											A2(
												_elm_lang$core$Basics_ops['++'],
												'0',
												A2(
													_elm_lang$core$Basics_ops['++'],
													' ',
													A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(
															_p20.x.position + (_p20.radius.position * _elm_lang$core$Basics$cos(_p20.endAngle.position))),
														A2(
															_elm_lang$core$Basics_ops['++'],
															',',
															_elm_lang$core$Basics$toString(
																_p20.y.position + (_p20.radius.position * _elm_lang$core$Basics$sin(_p20.endAngle.position))))))))))))));
			}
		default:
			return 'z';
	}
};
var _mdgriffith$elm_style_animation$Animation_Render$propertyValue = F2(
	function (prop, delim) {
		var _p21 = prop;
		switch (_p21.ctor) {
			case 'ExactProperty':
				return _p21._1;
			case 'ColorProperty':
				return A2(
					_elm_lang$core$Basics_ops['++'],
					'rgba(',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(
							_elm_lang$core$Basics$round(_p21._1.position)),
						A2(
							_elm_lang$core$Basics_ops['++'],
							',',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(
									_elm_lang$core$Basics$round(_p21._2.position)),
								A2(
									_elm_lang$core$Basics_ops['++'],
									',',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(
											_elm_lang$core$Basics$round(_p21._3.position)),
										A2(
											_elm_lang$core$Basics_ops['++'],
											',',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p21._4.position),
												')'))))))));
			case 'ShadowProperty':
				var _p23 = _p21._2;
				var _p22 = _p21._0;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_p21._1 ? 'inset ' : '',
					A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(_p23.offsetX.position),
						A2(
							_elm_lang$core$Basics_ops['++'],
							'px',
							A2(
								_elm_lang$core$Basics_ops['++'],
								' ',
								A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p23.offsetY.position),
									A2(
										_elm_lang$core$Basics_ops['++'],
										'px',
										A2(
											_elm_lang$core$Basics_ops['++'],
											' ',
											A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(_p23.blur.position),
												A2(
													_elm_lang$core$Basics_ops['++'],
													'px',
													A2(
														_elm_lang$core$Basics_ops['++'],
														' ',
														A2(
															_elm_lang$core$Basics_ops['++'],
															(_elm_lang$core$Native_Utils.eq(_p22, 'text-shadow') || _elm_lang$core$Native_Utils.eq(_p22, 'drop-shadow')) ? '' : A2(
																_elm_lang$core$Basics_ops['++'],
																_elm_lang$core$Basics$toString(_p23.size.position),
																A2(_elm_lang$core$Basics_ops['++'], 'px', ' ')),
															A2(
																_elm_lang$core$Basics_ops['++'],
																'rgba(',
																A2(
																	_elm_lang$core$Basics_ops['++'],
																	_elm_lang$core$Basics$toString(
																		_elm_lang$core$Basics$round(_p23.red.position)),
																	A2(
																		_elm_lang$core$Basics_ops['++'],
																		', ',
																		A2(
																			_elm_lang$core$Basics_ops['++'],
																			_elm_lang$core$Basics$toString(
																				_elm_lang$core$Basics$round(_p23.green.position)),
																			A2(
																				_elm_lang$core$Basics_ops['++'],
																				', ',
																				A2(
																					_elm_lang$core$Basics_ops['++'],
																					_elm_lang$core$Basics$toString(
																						_elm_lang$core$Basics$round(_p23.blue.position)),
																					A2(
																						_elm_lang$core$Basics_ops['++'],
																						', ',
																						A2(
																							_elm_lang$core$Basics_ops['++'],
																							_elm_lang$core$Basics$toString(_p23.alpha.position),
																							')')))))))))))))))))));
			case 'Property':
				var _p24 = _p21._1;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p24.position),
					_p24.unit);
			case 'Property2':
				var _p26 = _p21._2;
				var _p25 = _p21._1;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p25.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p25.unit,
						A2(
							_elm_lang$core$Basics_ops['++'],
							delim,
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p26.position),
								_p26.unit))));
			case 'Property3':
				var _p29 = _p21._3;
				var _p28 = _p21._2;
				var _p27 = _p21._1;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p27.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p27.unit,
						A2(
							_elm_lang$core$Basics_ops['++'],
							delim,
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p28.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p28.unit,
									A2(
										_elm_lang$core$Basics_ops['++'],
										delim,
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(_p29.position),
											_p29.unit)))))));
			case 'Property4':
				var _p33 = _p21._4;
				var _p32 = _p21._3;
				var _p31 = _p21._2;
				var _p30 = _p21._1;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p30.position),
					A2(
						_elm_lang$core$Basics_ops['++'],
						_p30.unit,
						A2(
							_elm_lang$core$Basics_ops['++'],
							delim,
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p31.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									_p31.unit,
									A2(
										_elm_lang$core$Basics_ops['++'],
										delim,
										A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(_p32.position),
											A2(
												_elm_lang$core$Basics_ops['++'],
												_p32.unit,
												A2(
													_elm_lang$core$Basics_ops['++'],
													delim,
													A2(
														_elm_lang$core$Basics_ops['++'],
														_elm_lang$core$Basics$toString(_p33.position),
														_p33.unit))))))))));
			case 'AngleProperty':
				var _p34 = _p21._1;
				return A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p34.position),
					_p34.unit);
			case 'Points':
				return A2(
					_elm_lang$core$String$join,
					' ',
					A2(
						_elm_lang$core$List$map,
						function (_p35) {
							var _p36 = _p35;
							return A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p36._0.position),
								A2(
									_elm_lang$core$Basics_ops['++'],
									',',
									_elm_lang$core$Basics$toString(_p36._1.position)));
						},
						_p21._0));
			default:
				return A2(
					_elm_lang$core$String$join,
					' ',
					A2(_elm_lang$core$List$map, _mdgriffith$elm_style_animation$Animation_Render$pathCmdValue, _p21._0));
		}
	});
var _mdgriffith$elm_style_animation$Animation_Render$isAttr = function (prop) {
	return A2(
		_elm_lang$core$String$startsWith,
		'attr:',
		_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop)) || function () {
		var _p37 = prop;
		switch (_p37.ctor) {
			case 'Points':
				return true;
			case 'Path':
				return true;
			case 'Property':
				var _p38 = _p37._0;
				return _elm_lang$core$Native_Utils.eq(_p38, 'cx') || (_elm_lang$core$Native_Utils.eq(_p38, 'cy') || (_elm_lang$core$Native_Utils.eq(_p38, 'x') || (_elm_lang$core$Native_Utils.eq(_p38, 'y') || (_elm_lang$core$Native_Utils.eq(_p38, 'rx') || (_elm_lang$core$Native_Utils.eq(_p38, 'ry') || (_elm_lang$core$Native_Utils.eq(_p38, 'r') || _elm_lang$core$Native_Utils.eq(_p38, 'offset')))))));
			case 'Property4':
				return _elm_lang$core$Native_Utils.eq(_p37._0, 'viewBox');
			default:
				return false;
		}
	}();
};
var _mdgriffith$elm_style_animation$Animation_Render$webkitPrefix = '-webkit-';
var _mdgriffith$elm_style_animation$Animation_Render$iePrefix = '-ms-';
var _mdgriffith$elm_style_animation$Animation_Render$prefix = function (stylePair) {
	var propValue = _elm_lang$core$Tuple$second(stylePair);
	var propName = _elm_lang$core$Tuple$first(stylePair);
	var _p39 = propName;
	switch (_p39) {
		case 'transform':
			return {
				ctor: '::',
				_0: stylePair,
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], _mdgriffith$elm_style_animation$Animation_Render$iePrefix, propName),
						_1: propValue
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: A2(_elm_lang$core$Basics_ops['++'], _mdgriffith$elm_style_animation$Animation_Render$webkitPrefix, propName),
							_1: propValue
						},
						_1: {ctor: '[]'}
					}
				}
			};
		case 'transform-origin':
			return {
				ctor: '::',
				_0: stylePair,
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], _mdgriffith$elm_style_animation$Animation_Render$iePrefix, propName),
						_1: propValue
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: A2(_elm_lang$core$Basics_ops['++'], _mdgriffith$elm_style_animation$Animation_Render$webkitPrefix, propName),
							_1: propValue
						},
						_1: {ctor: '[]'}
					}
				}
			};
		case 'filter':
			return {
				ctor: '::',
				_0: stylePair,
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: A2(_elm_lang$core$Basics_ops['++'], _mdgriffith$elm_style_animation$Animation_Render$iePrefix, propName),
						_1: propValue
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: A2(_elm_lang$core$Basics_ops['++'], _mdgriffith$elm_style_animation$Animation_Render$webkitPrefix, propName),
							_1: propValue
						},
						_1: {ctor: '[]'}
					}
				}
			};
		default:
			return {
				ctor: '::',
				_0: stylePair,
				_1: {ctor: '[]'}
			};
	}
};
var _mdgriffith$elm_style_animation$Animation_Render$isFilter = function (prop) {
	return A2(
		_elm_lang$core$List$member,
		_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
		{
			ctor: '::',
			_0: 'filter-url',
			_1: {
				ctor: '::',
				_0: 'blur',
				_1: {
					ctor: '::',
					_0: 'brightness',
					_1: {
						ctor: '::',
						_0: 'contrast',
						_1: {
							ctor: '::',
							_0: 'grayscale',
							_1: {
								ctor: '::',
								_0: 'hue-rotate',
								_1: {
									ctor: '::',
									_0: 'invert',
									_1: {
										ctor: '::',
										_0: 'saturate',
										_1: {
											ctor: '::',
											_0: 'sepia',
											_1: {
												ctor: '::',
												_0: 'drop-shadow',
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		});
};
var _mdgriffith$elm_style_animation$Animation_Render$render3dRotation = function (prop) {
	var _p40 = prop;
	if (_p40.ctor === 'Property3') {
		var _p43 = _p40._3;
		var _p42 = _p40._2;
		var _p41 = _p40._1;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			'rotateX(',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(_p41.position),
				A2(
					_elm_lang$core$Basics_ops['++'],
					_p41.unit,
					A2(
						_elm_lang$core$Basics_ops['++'],
						') rotateY(',
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p42.position),
							A2(
								_elm_lang$core$Basics_ops['++'],
								_p42.unit,
								A2(
									_elm_lang$core$Basics_ops['++'],
									') rotateZ(',
									A2(
										_elm_lang$core$Basics_ops['++'],
										_elm_lang$core$Basics$toString(_p43.position),
										A2(_elm_lang$core$Basics_ops['++'], _p43.unit, ')')))))))));
	} else {
		return '';
	}
};
var _mdgriffith$elm_style_animation$Animation_Render$isTransformation = function (prop) {
	return A2(
		_elm_lang$core$List$member,
		_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
		{
			ctor: '::',
			_0: 'rotate',
			_1: {
				ctor: '::',
				_0: 'rotateX',
				_1: {
					ctor: '::',
					_0: 'rotateY',
					_1: {
						ctor: '::',
						_0: 'rotateZ',
						_1: {
							ctor: '::',
							_0: 'rotate3d',
							_1: {
								ctor: '::',
								_0: 'translate',
								_1: {
									ctor: '::',
									_0: 'translate3d',
									_1: {
										ctor: '::',
										_0: 'scale',
										_1: {
											ctor: '::',
											_0: 'scale3d',
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				}
			}
		});
};
var _mdgriffith$elm_style_animation$Animation_Render$warnForDoubleListedProperties = function (props) {
	var _p44 = A2(
		_elm_lang$core$List$map,
		function (propGroup) {
			var _p45 = _elm_lang$core$List$head(propGroup);
			if (_p45.ctor === 'Nothing') {
				return '';
			} else {
				return (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$List$length(propGroup),
					1) > 0) ? A2(
					_elm_lang$core$Debug$log,
					'elm-style-animation',
					A2(
						_elm_lang$core$Basics_ops['++'],
						'The \"',
						A2(_elm_lang$core$Basics_ops['++'], _p45._0, '\" css property is listed more than once.  Only the last instance will be used.'))) : '';
			}
		},
		A2(
			_mdgriffith$elm_style_animation$Animation_Render$groupWhile,
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.eq(x, y);
				}),
			_elm_lang$core$List$sort(
				A2(
					_elm_lang$core$List$map,
					_mdgriffith$elm_style_animation$Animation_Model$propertyName,
					A2(
						_elm_lang$core$List$filter,
						function (prop) {
							return !_mdgriffith$elm_style_animation$Animation_Render$isTransformation(prop);
						},
						props)))));
	return props;
};
var _mdgriffith$elm_style_animation$Animation_Render$renderAttrs = function (prop) {
	if (A2(
		_elm_lang$core$String$startsWith,
		'attr:',
		_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop))) {
		return _elm_lang$core$Maybe$Just(
			A2(
				_elm_lang$html$Html_Attributes$attribute,
				A2(
					_elm_lang$core$String$dropLeft,
					5,
					_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop)),
				A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
	} else {
		var _p46 = prop;
		switch (_p46.ctor) {
			case 'Points':
				return _elm_lang$core$Maybe$Just(
					_elm_lang$svg$Svg_Attributes$points(
						A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
			case 'Path':
				return _elm_lang$core$Maybe$Just(
					_elm_lang$svg$Svg_Attributes$d(
						A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
			case 'Property':
				var _p47 = _p46._0;
				switch (_p47) {
					case 'x':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$x(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'y':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$y(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'cx':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$cx(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'cy':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$cy(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'rx':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$rx(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'ry':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$ry(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'r':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$r(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					case 'offset':
						return _elm_lang$core$Maybe$Just(
							_elm_lang$svg$Svg_Attributes$offset(
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')));
					default:
						return _elm_lang$core$Maybe$Nothing;
				}
			case 'Property4':
				return _elm_lang$core$Native_Utils.eq(_p46._0, 'viewBox') ? _elm_lang$core$Maybe$Just(
					_elm_lang$svg$Svg_Attributes$viewBox(
						A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' '))) : _elm_lang$core$Maybe$Nothing;
			default:
				return _elm_lang$core$Maybe$Nothing;
		}
	}
};
var _mdgriffith$elm_style_animation$Animation_Render$renderValues = function (_p48) {
	var _p49 = _p48;
	var _p50 = A2(_elm_lang$core$List$partition, _mdgriffith$elm_style_animation$Animation_Render$isAttr, _p49._0.style);
	var attrProps = _p50._0;
	var styleProps = _p50._1;
	var _p51 = A3(
		_elm_lang$core$List$foldl,
		F2(
			function (prop, _p52) {
				var _p53 = _p52;
				var _p56 = _p53._1;
				var _p55 = _p53._0;
				var _p54 = _p53._2;
				return _mdgriffith$elm_style_animation$Animation_Render$isTransformation(prop) ? {
					ctor: '_Tuple3',
					_0: _p55,
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_p56,
						{
							ctor: '::',
							_0: prop,
							_1: {ctor: '[]'}
						}),
					_2: _p54
				} : (_mdgriffith$elm_style_animation$Animation_Render$isFilter(prop) ? {
					ctor: '_Tuple3',
					_0: _p55,
					_1: _p56,
					_2: A2(
						_elm_lang$core$Basics_ops['++'],
						_p54,
						{
							ctor: '::',
							_0: prop,
							_1: {ctor: '[]'}
						})
				} : {
					ctor: '_Tuple3',
					_0: A2(
						_elm_lang$core$Basics_ops['++'],
						_p55,
						{
							ctor: '::',
							_0: prop,
							_1: {ctor: '[]'}
						}),
					_1: _p56,
					_2: _p54
				});
			}),
		{
			ctor: '_Tuple3',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'},
			_2: {ctor: '[]'}
		},
		styleProps);
	var style = _p51._0;
	var transforms = _p51._1;
	var filters = _p51._2;
	var renderedStyle = A2(
		_elm_lang$core$List$map,
		function (prop) {
			return {
				ctor: '_Tuple2',
				_0: _mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
				_1: A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ' ')
			};
		},
		style);
	var renderedTransforms = _elm_lang$core$List$isEmpty(transforms) ? {ctor: '[]'} : {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'transform',
			_1: A2(
				_elm_lang$core$String$join,
				' ',
				A2(
					_elm_lang$core$List$map,
					function (prop) {
						return _elm_lang$core$Native_Utils.eq(
							_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
							'rotate3d') ? _mdgriffith$elm_style_animation$Animation_Render$render3dRotation(prop) : A2(
							_elm_lang$core$Basics_ops['++'],
							_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
							A2(
								_elm_lang$core$Basics_ops['++'],
								'(',
								A2(
									_elm_lang$core$Basics_ops['++'],
									A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ', '),
									')')));
					},
					transforms))
		},
		_1: {ctor: '[]'}
	};
	var renderedFilters = _elm_lang$core$List$isEmpty(filters) ? {ctor: '[]'} : {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'filter',
			_1: A2(
				_elm_lang$core$String$join,
				' ',
				A2(
					_elm_lang$core$List$map,
					function (prop) {
						var name = _mdgriffith$elm_style_animation$Animation_Model$propertyName(prop);
						return _elm_lang$core$Native_Utils.eq(name, 'filter-url') ? A2(
							_elm_lang$core$Basics_ops['++'],
							'url(\"',
							A2(
								_elm_lang$core$Basics_ops['++'],
								A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ', '),
								'\")')) : A2(
							_elm_lang$core$Basics_ops['++'],
							_mdgriffith$elm_style_animation$Animation_Model$propertyName(prop),
							A2(
								_elm_lang$core$Basics_ops['++'],
								'(',
								A2(
									_elm_lang$core$Basics_ops['++'],
									A2(_mdgriffith$elm_style_animation$Animation_Render$propertyValue, prop, ', '),
									')')));
					},
					filters))
		},
		_1: {ctor: '[]'}
	};
	return {
		ctor: '_Tuple2',
		_0: A2(
			_elm_lang$core$Basics_ops['++'],
			renderedTransforms,
			A2(_elm_lang$core$Basics_ops['++'], renderedFilters, renderedStyle)),
		_1: attrProps
	};
};
var _mdgriffith$elm_style_animation$Animation_Render$render = function (animation) {
	var _p57 = _mdgriffith$elm_style_animation$Animation_Render$renderValues(animation);
	var style = _p57._0;
	var attrProps = _p57._1;
	var styleAttr = _elm_lang$html$Html_Attributes$style(
		A2(_elm_lang$core$List$concatMap, _mdgriffith$elm_style_animation$Animation_Render$prefix, style));
	var otherAttrs = A2(_elm_lang$core$List$filterMap, _mdgriffith$elm_style_animation$Animation_Render$renderAttrs, attrProps);
	return {ctor: '::', _0: styleAttr, _1: otherAttrs};
};

var _mdgriffith$elm_style_animation$Animation$render = _mdgriffith$elm_style_animation$Animation_Render$render;
var _mdgriffith$elm_style_animation$Animation$alignStartingPoint = function (points) {
	var sums = A2(
		_elm_lang$core$List$map,
		function (_p0) {
			var _p1 = _p0;
			return _p1._0 + _p1._1;
		},
		points);
	var maybeMin = _elm_lang$core$List$minimum(sums);
	var indexOfLowestPoint = function () {
		var _p2 = maybeMin;
		if (_p2.ctor === 'Nothing') {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			return _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filterMap,
					_elm_lang$core$Basics$identity,
					A2(
						_elm_lang$core$List$indexedMap,
						F2(
							function (i, val) {
								return _elm_lang$core$Native_Utils.eq(val, _p2._0) ? _elm_lang$core$Maybe$Just(i) : _elm_lang$core$Maybe$Nothing;
							}),
						sums)));
		}
	}();
	var _p3 = indexOfLowestPoint;
	if (_p3.ctor === 'Nothing') {
		return points;
	} else {
		var _p4 = _p3._0;
		return A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$List$drop, _p4, points),
			A2(_elm_lang$core$List$take, _p4, points));
	}
};
var _mdgriffith$elm_style_animation$Animation$close = _mdgriffith$elm_style_animation$Animation_Model$Close;
var _mdgriffith$elm_style_animation$Animation$path = function (commands) {
	return _mdgriffith$elm_style_animation$Animation_Model$Path(commands);
};
var _mdgriffith$elm_style_animation$Animation$displayModeName = function (mode) {
	var _p5 = mode;
	switch (_p5.ctor) {
		case 'None':
			return 'none';
		case 'Inline':
			return 'inline';
		case 'InlineBlock':
			return 'inline-block';
		case 'Block':
			return 'block';
		case 'Flex':
			return 'flex';
		case 'InlineFlex':
			return 'inline-flex';
		default:
			return 'list-item';
	}
};
var _mdgriffith$elm_style_animation$Animation$display = function (mode) {
	return A2(
		_mdgriffith$elm_style_animation$Animation_Model$ExactProperty,
		'display',
		_mdgriffith$elm_style_animation$Animation$displayModeName(mode));
};
var _mdgriffith$elm_style_animation$Animation$exactly = F2(
	function (name, value) {
		return A2(_mdgriffith$elm_style_animation$Animation_Model$ExactProperty, name, value);
	});
var _mdgriffith$elm_style_animation$Animation$filterUrl = function (url) {
	return A2(_mdgriffith$elm_style_animation$Animation$exactly, 'filter-url', url);
};
var _mdgriffith$elm_style_animation$Animation$initMotion = F2(
	function (position, unit) {
		return {
			position: position,
			velocity: 0,
			target: position,
			unit: unit,
			interpolation: _mdgriffith$elm_style_animation$Animation_Model$Spring(
				{stiffness: 170, damping: 26}),
			interpolationOverride: _elm_lang$core$Maybe$Nothing
		};
	});
var _mdgriffith$elm_style_animation$Animation$length = F3(
	function (name, x, unit) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$Property,
			name,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, unit));
	});
var _mdgriffith$elm_style_animation$Animation$strokeWidth = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$length, 'stroke-width', x, '');
};
var _mdgriffith$elm_style_animation$Animation$length2 = F3(
	function (name, _p7, _p6) {
		var _p8 = _p7;
		var _p9 = _p6;
		return A3(
			_mdgriffith$elm_style_animation$Animation_Model$Property2,
			name,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p8._0, _p8._1),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p9._0, _p9._1));
	});
var _mdgriffith$elm_style_animation$Animation$attr2 = F3(
	function (name, value1, value2) {
		return A3(
			_mdgriffith$elm_style_animation$Animation$length2,
			A2(_elm_lang$core$Basics_ops['++'], 'attr:', name),
			value1,
			value2);
	});
var _mdgriffith$elm_style_animation$Animation$custom2 = F3(
	function (name, value, unit) {
		return A3(_mdgriffith$elm_style_animation$Animation$length2, name, value, unit);
	});
var _mdgriffith$elm_style_animation$Animation$length3 = F4(
	function (name, _p12, _p11, _p10) {
		var _p13 = _p12;
		var _p14 = _p11;
		var _p15 = _p10;
		return A4(
			_mdgriffith$elm_style_animation$Animation_Model$Property3,
			name,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p13._0, _p13._1),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p14._0, _p14._1),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p15._0, _p15._1));
	});
var _mdgriffith$elm_style_animation$Animation$attr3 = F4(
	function (name, value1, value2, value3) {
		return A4(
			_mdgriffith$elm_style_animation$Animation$length3,
			A2(_elm_lang$core$Basics_ops['++'], 'attr:', name),
			value1,
			value2,
			value3);
	});
var _mdgriffith$elm_style_animation$Animation$rotate3d = F3(
	function (_p18, _p17, _p16) {
		var _p19 = _p18;
		var _p20 = _p17;
		var _p21 = _p16;
		return A4(
			_mdgriffith$elm_style_animation$Animation$length3,
			'rotate3d',
			{ctor: '_Tuple2', _0: _p19._0, _1: 'rad'},
			{ctor: '_Tuple2', _0: _p20._0, _1: 'rad'},
			{ctor: '_Tuple2', _0: _p21._0, _1: 'rad'});
	});
var _mdgriffith$elm_style_animation$Animation$length4 = F5(
	function (name, _p25, _p24, _p23, _p22) {
		var _p26 = _p25;
		var _p27 = _p24;
		var _p28 = _p23;
		var _p29 = _p22;
		return A5(
			_mdgriffith$elm_style_animation$Animation_Model$Property4,
			name,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p26._0, _p26._1),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p27._0, _p27._1),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p28._0, _p28._1),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p29._0, _p29._1));
	});
var _mdgriffith$elm_style_animation$Animation$attr4 = F5(
	function (name, value1, value2, value3, value4) {
		return A5(
			_mdgriffith$elm_style_animation$Animation$length4,
			A2(_elm_lang$core$Basics_ops['++'], 'attr:', name),
			value1,
			value2,
			value3,
			value4);
	});
var _mdgriffith$elm_style_animation$Animation$viewBox = F4(
	function (w, x, y, z) {
		return A5(
			_mdgriffith$elm_style_animation$Animation$length4,
			'viewBox',
			{ctor: '_Tuple2', _0: w, _1: ''},
			{ctor: '_Tuple2', _0: x, _1: ''},
			{ctor: '_Tuple2', _0: y, _1: ''},
			{ctor: '_Tuple2', _0: z, _1: ''});
	});
var _mdgriffith$elm_style_animation$Animation$attr = F3(
	function (name, value, unit) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$Property,
			A2(_elm_lang$core$Basics_ops['++'], 'attr:', name),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, value, unit));
	});
var _mdgriffith$elm_style_animation$Animation$attrColor = F2(
	function (name, color) {
		var _p30 = _elm_lang$core$Color$toRgb(color);
		var red = _p30.red;
		var green = _p30.green;
		var blue = _p30.blue;
		var alpha = _p30.alpha;
		return A5(
			_mdgriffith$elm_style_animation$Animation_Model$ColorProperty,
			A2(_elm_lang$core$Basics_ops['++'], 'attr:', name),
			A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(red),
				''),
			A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(green),
				''),
			A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(blue),
				''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, alpha, ''));
	});
var _mdgriffith$elm_style_animation$Animation$custom = F3(
	function (name, value, unit) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$Property,
			name,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, value, unit));
	});
var _mdgriffith$elm_style_animation$Animation$opacity = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'opacity', x, '');
};
var _mdgriffith$elm_style_animation$Animation$scale = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'scale', x, '');
};
var _mdgriffith$elm_style_animation$Animation$x = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'x', x, '');
};
var _mdgriffith$elm_style_animation$Animation$y = function (y) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'y', y, '');
};
var _mdgriffith$elm_style_animation$Animation$cx = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'cx', x, '');
};
var _mdgriffith$elm_style_animation$Animation$cy = function (y) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'cy', y, '');
};
var _mdgriffith$elm_style_animation$Animation$radius = function (r) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'r', r, '');
};
var _mdgriffith$elm_style_animation$Animation$radiusX = function (rx) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'rx', rx, '');
};
var _mdgriffith$elm_style_animation$Animation$radiusY = function (ry) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'ry', ry, '');
};
var _mdgriffith$elm_style_animation$Animation$brightness = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'brightness', x, '%');
};
var _mdgriffith$elm_style_animation$Animation$contrast = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'contrast', x, '%');
};
var _mdgriffith$elm_style_animation$Animation$grayscale = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'grayscale', x, '%');
};
var _mdgriffith$elm_style_animation$Animation$greyscale = function (x) {
	return _mdgriffith$elm_style_animation$Animation$grayscale(x);
};
var _mdgriffith$elm_style_animation$Animation$invert = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'invert', x, '%');
};
var _mdgriffith$elm_style_animation$Animation$saturate = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'saturate', x, '%');
};
var _mdgriffith$elm_style_animation$Animation$sepia = function (x) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'sepia', x, '%');
};
var _mdgriffith$elm_style_animation$Animation$offset = function (value) {
	return A3(_mdgriffith$elm_style_animation$Animation$custom, 'offset', value, '');
};
var _mdgriffith$elm_style_animation$Animation$customColor = F2(
	function (name, color) {
		var _p31 = _elm_lang$core$Color$toRgb(color);
		var red = _p31.red;
		var green = _p31.green;
		var blue = _p31.blue;
		var alpha = _p31.alpha;
		return A5(
			_mdgriffith$elm_style_animation$Animation_Model$ColorProperty,
			name,
			A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(red),
				''),
			A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(green),
				''),
			A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(blue),
				''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, alpha, ''));
	});
var _mdgriffith$elm_style_animation$Animation$color = function (c) {
	return A2(_mdgriffith$elm_style_animation$Animation$customColor, 'color', c);
};
var _mdgriffith$elm_style_animation$Animation$backgroundColor = function (c) {
	return A2(_mdgriffith$elm_style_animation$Animation$customColor, 'background-color', c);
};
var _mdgriffith$elm_style_animation$Animation$borderColor = function (c) {
	return A2(_mdgriffith$elm_style_animation$Animation$customColor, 'border-color', c);
};
var _mdgriffith$elm_style_animation$Animation$fill = function (color) {
	return A2(_mdgriffith$elm_style_animation$Animation$customColor, 'fill', color);
};
var _mdgriffith$elm_style_animation$Animation$stroke = function (color) {
	return A2(_mdgriffith$elm_style_animation$Animation$customColor, 'stroke', color);
};
var _mdgriffith$elm_style_animation$Animation$stopColor = function (color) {
	return A2(_mdgriffith$elm_style_animation$Animation$customColor, 'stop-color', color);
};
var _mdgriffith$elm_style_animation$Animation$scale3d = F3(
	function (x, y, z) {
		return A4(
			_mdgriffith$elm_style_animation$Animation_Model$Property3,
			'scale3d',
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, y, ''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, z, ''));
	});
var _mdgriffith$elm_style_animation$Animation$rotate = function (_p32) {
	var _p33 = _p32;
	return A2(
		_mdgriffith$elm_style_animation$Animation_Model$AngleProperty,
		'rotate',
		A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p33._0, 'rad'));
};
var _mdgriffith$elm_style_animation$Animation$textShadow = function (shade) {
	var _p34 = _elm_lang$core$Color$toRgb(shade.color);
	var red = _p34.red;
	var green = _p34.green;
	var blue = _p34.blue;
	var alpha = _p34.alpha;
	return A3(
		_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
		'text-shadow',
		false,
		{
			offsetX: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetX, 'px'),
			offsetY: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetY, 'px'),
			size: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.size, 'px'),
			blur: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.blur, 'px'),
			red: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(red),
				'px'),
			green: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(green),
				'px'),
			blue: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(blue),
				'px'),
			alpha: A2(_mdgriffith$elm_style_animation$Animation$initMotion, alpha, 'px')
		});
};
var _mdgriffith$elm_style_animation$Animation$shadow = function (shade) {
	var _p35 = _elm_lang$core$Color$toRgb(shade.color);
	var red = _p35.red;
	var green = _p35.green;
	var blue = _p35.blue;
	var alpha = _p35.alpha;
	return A3(
		_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
		'box-shadow',
		false,
		{
			offsetX: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetX, 'px'),
			offsetY: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetY, 'px'),
			size: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.size, 'px'),
			blur: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.blur, 'px'),
			red: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(red),
				'px'),
			green: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(green),
				'px'),
			blue: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(blue),
				'px'),
			alpha: A2(_mdgriffith$elm_style_animation$Animation$initMotion, alpha, 'px')
		});
};
var _mdgriffith$elm_style_animation$Animation$insetShadow = function (shade) {
	var _p36 = _elm_lang$core$Color$toRgb(shade.color);
	var red = _p36.red;
	var green = _p36.green;
	var blue = _p36.blue;
	var alpha = _p36.alpha;
	return A3(
		_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
		'box-shadow',
		true,
		{
			offsetX: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetX, 'px'),
			offsetY: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetY, 'px'),
			size: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.size, 'px'),
			blur: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.blur, 'px'),
			red: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(red),
				'px'),
			green: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(green),
				'px'),
			blue: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(blue),
				'px'),
			alpha: A2(_mdgriffith$elm_style_animation$Animation$initMotion, alpha, 'px')
		});
};
var _mdgriffith$elm_style_animation$Animation$move = F2(
	function (x, y) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$Move,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, y, ''));
	});
var _mdgriffith$elm_style_animation$Animation$moveTo = F2(
	function (x, y) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$MoveTo,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, y, ''));
	});
var _mdgriffith$elm_style_animation$Animation$line = F2(
	function (x, y) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$Line,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, y, ''));
	});
var _mdgriffith$elm_style_animation$Animation$lineTo = F2(
	function (x, y) {
		return A2(
			_mdgriffith$elm_style_animation$Animation_Model$LineTo,
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''),
			A2(_mdgriffith$elm_style_animation$Animation$initMotion, y, ''));
	});
var _mdgriffith$elm_style_animation$Animation$horizontal = function (x) {
	return _mdgriffith$elm_style_animation$Animation_Model$Horizontal(
		A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''));
};
var _mdgriffith$elm_style_animation$Animation$horizontalTo = function (x) {
	return _mdgriffith$elm_style_animation$Animation_Model$HorizontalTo(
		A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''));
};
var _mdgriffith$elm_style_animation$Animation$vertical = function (x) {
	return _mdgriffith$elm_style_animation$Animation_Model$Vertical(
		A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''));
};
var _mdgriffith$elm_style_animation$Animation$verticalTo = function (x) {
	return _mdgriffith$elm_style_animation$Animation_Model$VerticalTo(
		A2(_mdgriffith$elm_style_animation$Animation$initMotion, x, ''));
};
var _mdgriffith$elm_style_animation$Animation$curve2 = function (_p37) {
	var _p38 = _p37;
	var _p41 = _p38.point;
	var _p40 = _p38.control2;
	var _p39 = _p38.control1;
	return _mdgriffith$elm_style_animation$Animation_Model$Curve(
		{
			control1: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p39),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p39),
					'')
			},
			control2: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p40),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p40),
					'')
			},
			point: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p41),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p41),
					'')
			}
		});
};
var _mdgriffith$elm_style_animation$Animation$curve2To = function (_p42) {
	var _p43 = _p42;
	var _p46 = _p43.point;
	var _p45 = _p43.control2;
	var _p44 = _p43.control1;
	return _mdgriffith$elm_style_animation$Animation_Model$CurveTo(
		{
			control1: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p44),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p44),
					'')
			},
			control2: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p45),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p45),
					'')
			},
			point: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p46),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p46),
					'')
			}
		});
};
var _mdgriffith$elm_style_animation$Animation$curve = function (_p47) {
	var _p48 = _p47;
	var _p50 = _p48.point;
	var _p49 = _p48.control;
	return _mdgriffith$elm_style_animation$Animation_Model$Quadratic(
		{
			control: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p49),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p49),
					'')
			},
			point: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p50),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p50),
					'')
			}
		});
};
var _mdgriffith$elm_style_animation$Animation$curveTo = function (_p51) {
	var _p52 = _p51;
	var _p54 = _p52.point;
	var _p53 = _p52.control;
	return _mdgriffith$elm_style_animation$Animation_Model$QuadraticTo(
		{
			control: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p53),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p53),
					'')
			},
			point: {
				ctor: '_Tuple2',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$first(_p54),
					''),
				_1: A2(
					_mdgriffith$elm_style_animation$Animation$initMotion,
					_elm_lang$core$Tuple$second(_p54),
					'')
			}
		});
};
var _mdgriffith$elm_style_animation$Animation$arc = function (arc) {
	return arc.clockwise ? _mdgriffith$elm_style_animation$Animation_Model$ClockwiseArc(
		{
			x: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.x, ''),
			y: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.y, ''),
			radius: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.radius, ''),
			startAngle: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.startAngle, ''),
			endAngle: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.endAngle, '')
		}) : _mdgriffith$elm_style_animation$Animation_Model$AntiClockwiseArc(
		{
			x: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.x, ''),
			y: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.y, ''),
			radius: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.radius, ''),
			startAngle: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.startAngle, ''),
			endAngle: A2(_mdgriffith$elm_style_animation$Animation$initMotion, arc.endAngle, '')
		});
};
var _mdgriffith$elm_style_animation$Animation$hueRotate = function (_p55) {
	var _p56 = _p55;
	return A2(
		_mdgriffith$elm_style_animation$Animation_Model$AngleProperty,
		'hue-rotate',
		A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p56._0, 'rad'));
};
var _mdgriffith$elm_style_animation$Animation$dropShadow = function (shade) {
	var _p57 = _elm_lang$core$Color$toRgb(shade.color);
	var red = _p57.red;
	var green = _p57.green;
	var blue = _p57.blue;
	var alpha = _p57.alpha;
	return A3(
		_mdgriffith$elm_style_animation$Animation_Model$ShadowProperty,
		'drop-shadow',
		false,
		{
			offsetX: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetX, 'px'),
			offsetY: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.offsetY, 'px'),
			size: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.size, 'px'),
			blur: A2(_mdgriffith$elm_style_animation$Animation$initMotion, shade.blur, 'px'),
			red: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(red),
				'px'),
			green: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(green),
				'px'),
			blue: A2(
				_mdgriffith$elm_style_animation$Animation$initMotion,
				_elm_lang$core$Basics$toFloat(blue),
				'px'),
			alpha: A2(_mdgriffith$elm_style_animation$Animation$initMotion, alpha, 'px')
		});
};
var _mdgriffith$elm_style_animation$Animation$points = function (pnts) {
	return _mdgriffith$elm_style_animation$Animation_Model$Points(
		A2(
			_elm_lang$core$List$map,
			function (_p58) {
				var _p59 = _p58;
				return {
					ctor: '_Tuple2',
					_0: A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p59._0, ''),
					_1: A2(_mdgriffith$elm_style_animation$Animation$initMotion, _p59._1, '')
				};
			},
			_mdgriffith$elm_style_animation$Animation$alignStartingPoint(pnts)));
};
var _mdgriffith$elm_style_animation$Animation$lengthUnitName = function (unit) {
	var _p60 = unit;
	switch (_p60.ctor) {
		case 'NoUnit':
			return '';
		case 'Px':
			return 'px';
		case 'Percent':
			return '%';
		case 'Rem':
			return 'rem';
		case 'Em':
			return 'em';
		case 'Ex':
			return 'ex';
		case 'Ch':
			return 'ch';
		case 'Vh':
			return 'vh';
		case 'Vw':
			return 'vw';
		case 'Vmin':
			return 'vmin';
		case 'Vmax':
			return 'vmax';
		case 'Mm':
			return 'mm';
		case 'Cm':
			return 'cm';
		case 'In':
			return 'in';
		case 'Pt':
			return 'pt';
		default:
			return 'pc';
	}
};
var _mdgriffith$elm_style_animation$Animation$height = function (_p61) {
	var _p62 = _p61;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'height',
		_p62._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p62._1));
};
var _mdgriffith$elm_style_animation$Animation$width = function (_p63) {
	var _p64 = _p63;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'width',
		_p64._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p64._1));
};
var _mdgriffith$elm_style_animation$Animation$left = function (_p65) {
	var _p66 = _p65;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'left',
		_p66._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p66._1));
};
var _mdgriffith$elm_style_animation$Animation$top = function (_p67) {
	var _p68 = _p67;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'top',
		_p68._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p68._1));
};
var _mdgriffith$elm_style_animation$Animation$right = function (_p69) {
	var _p70 = _p69;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'right',
		_p70._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p70._1));
};
var _mdgriffith$elm_style_animation$Animation$bottom = function (_p71) {
	var _p72 = _p71;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'bottom',
		_p72._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p72._1));
};
var _mdgriffith$elm_style_animation$Animation$maxHeight = function (_p73) {
	var _p74 = _p73;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'max-height',
		_p74._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p74._1));
};
var _mdgriffith$elm_style_animation$Animation$maxWidth = function (_p75) {
	var _p76 = _p75;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'max-width',
		_p76._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p76._1));
};
var _mdgriffith$elm_style_animation$Animation$minHeight = function (_p77) {
	var _p78 = _p77;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'min-height',
		_p78._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p78._1));
};
var _mdgriffith$elm_style_animation$Animation$minWidth = function (_p79) {
	var _p80 = _p79;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'min-width',
		_p80._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p80._1));
};
var _mdgriffith$elm_style_animation$Animation$padding = function (_p81) {
	var _p82 = _p81;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'padding',
		_p82._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p82._1));
};
var _mdgriffith$elm_style_animation$Animation$paddingLeft = function (_p83) {
	var _p84 = _p83;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'padding-left',
		_p84._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p84._1));
};
var _mdgriffith$elm_style_animation$Animation$paddingRight = function (_p85) {
	var _p86 = _p85;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'padding-right',
		_p86._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p86._1));
};
var _mdgriffith$elm_style_animation$Animation$paddingTop = function (_p87) {
	var _p88 = _p87;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'padding-top',
		_p88._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p88._1));
};
var _mdgriffith$elm_style_animation$Animation$paddingBottom = function (_p89) {
	var _p90 = _p89;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'padding-bottom',
		_p90._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p90._1));
};
var _mdgriffith$elm_style_animation$Animation$margin = function (_p91) {
	var _p92 = _p91;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'margin',
		_p92._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p92._1));
};
var _mdgriffith$elm_style_animation$Animation$marginLeft = function (_p93) {
	var _p94 = _p93;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'margin-left',
		_p94._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p94._1));
};
var _mdgriffith$elm_style_animation$Animation$marginRight = function (_p95) {
	var _p96 = _p95;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'margin-right',
		_p96._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p96._1));
};
var _mdgriffith$elm_style_animation$Animation$marginTop = function (_p97) {
	var _p98 = _p97;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'margin-top',
		_p98._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p98._1));
};
var _mdgriffith$elm_style_animation$Animation$marginBottom = function (_p99) {
	var _p100 = _p99;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'margin-bottom',
		_p100._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p100._1));
};
var _mdgriffith$elm_style_animation$Animation$borderWidth = function (_p101) {
	var _p102 = _p101;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-width',
		_p102._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p102._1));
};
var _mdgriffith$elm_style_animation$Animation$borderLeftWidth = function (_p103) {
	var _p104 = _p103;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-left-width',
		_p104._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p104._1));
};
var _mdgriffith$elm_style_animation$Animation$borderRightWidth = function (_p105) {
	var _p106 = _p105;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-right-width',
		_p106._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p106._1));
};
var _mdgriffith$elm_style_animation$Animation$borderTopWidth = function (_p107) {
	var _p108 = _p107;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-top-width',
		_p108._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p108._1));
};
var _mdgriffith$elm_style_animation$Animation$borderBottomWidth = function (_p109) {
	var _p110 = _p109;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-bottom-width',
		_p110._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p110._1));
};
var _mdgriffith$elm_style_animation$Animation$borderRadius = function (_p111) {
	var _p112 = _p111;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-radius',
		_p112._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p112._1));
};
var _mdgriffith$elm_style_animation$Animation$borderTopLeftRadius = function (_p113) {
	var _p114 = _p113;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-top-left-radius',
		_p114._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p114._1));
};
var _mdgriffith$elm_style_animation$Animation$borderTopRightRadius = function (_p115) {
	var _p116 = _p115;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-top-right-radius',
		_p116._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p116._1));
};
var _mdgriffith$elm_style_animation$Animation$borderBottomLeftRadius = function (_p117) {
	var _p118 = _p117;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-bottom-left-radius',
		_p118._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p118._1));
};
var _mdgriffith$elm_style_animation$Animation$borderBottomRightRadius = function (_p119) {
	var _p120 = _p119;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'border-bottom-right-radius',
		_p120._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p120._1));
};
var _mdgriffith$elm_style_animation$Animation$letterSpacing = function (_p121) {
	var _p122 = _p121;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'letter-spacing',
		_p122._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p122._1));
};
var _mdgriffith$elm_style_animation$Animation$lineHeight = function (_p123) {
	var _p124 = _p123;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'line-height',
		_p124._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p124._1));
};
var _mdgriffith$elm_style_animation$Animation$backgroundPosition = F2(
	function (_p126, _p125) {
		var _p127 = _p126;
		var _p128 = _p125;
		return A3(
			_mdgriffith$elm_style_animation$Animation$length2,
			'background-position',
			{
				ctor: '_Tuple2',
				_0: _p127._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p127._1)
			},
			{
				ctor: '_Tuple2',
				_0: _p128._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p128._1)
			});
	});
var _mdgriffith$elm_style_animation$Animation$translate = F2(
	function (_p130, _p129) {
		var _p131 = _p130;
		var _p132 = _p129;
		return A3(
			_mdgriffith$elm_style_animation$Animation$length2,
			'translate',
			{
				ctor: '_Tuple2',
				_0: _p131._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p131._1)
			},
			{
				ctor: '_Tuple2',
				_0: _p132._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p132._1)
			});
	});
var _mdgriffith$elm_style_animation$Animation$translate3d = F3(
	function (_p135, _p134, _p133) {
		var _p136 = _p135;
		var _p137 = _p134;
		var _p138 = _p133;
		return A4(
			_mdgriffith$elm_style_animation$Animation$length3,
			'translate3d',
			{
				ctor: '_Tuple2',
				_0: _p136._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p136._1)
			},
			{
				ctor: '_Tuple2',
				_0: _p137._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p137._1)
			},
			{
				ctor: '_Tuple2',
				_0: _p138._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p138._1)
			});
	});
var _mdgriffith$elm_style_animation$Animation$transformOrigin = F3(
	function (_p141, _p140, _p139) {
		var _p142 = _p141;
		var _p143 = _p140;
		var _p144 = _p139;
		return A4(
			_mdgriffith$elm_style_animation$Animation$length3,
			'transform-origin',
			{
				ctor: '_Tuple2',
				_0: _p142._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p142._1)
			},
			{
				ctor: '_Tuple2',
				_0: _p143._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p143._1)
			},
			{
				ctor: '_Tuple2',
				_0: _p144._0,
				_1: _mdgriffith$elm_style_animation$Animation$lengthUnitName(_p144._1)
			});
	});
var _mdgriffith$elm_style_animation$Animation$blur = function (_p145) {
	var _p146 = _p145;
	return A3(
		_mdgriffith$elm_style_animation$Animation$length,
		'blur',
		_p146._0,
		_mdgriffith$elm_style_animation$Animation$lengthUnitName(_p146._1));
};
var _mdgriffith$elm_style_animation$Animation$update = F2(
	function (tick, animation) {
		return _elm_lang$core$Tuple$first(
			A2(_mdgriffith$elm_style_animation$Animation_Model$updateAnimation, tick, animation));
	});
var _mdgriffith$elm_style_animation$Animation$debug = function (_p147) {
	var _p148 = _p147;
	var _p158 = _p148._0;
	var time = _p158.timing.current;
	var getValueTuple = function (prop) {
		var _p149 = prop;
		switch (_p149.ctor) {
			case 'ExactProperty':
				return {ctor: '[]'};
			case 'ColorProperty':
				var _p150 = _p149._0;
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple3',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p150, '-red'),
						_1: _p149._1,
						_2: time
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple3',
							_0: A2(_elm_lang$core$Basics_ops['++'], _p150, '-green'),
							_1: _p149._2,
							_2: time
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple3',
								_0: A2(_elm_lang$core$Basics_ops['++'], _p150, '-blue'),
								_1: _p149._3,
								_2: time
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple3',
									_0: A2(_elm_lang$core$Basics_ops['++'], _p150, '-alpha'),
									_1: _p149._4,
									_2: time
								},
								_1: {ctor: '[]'}
							}
						}
					}
				};
			case 'ShadowProperty':
				var _p152 = _p149._2;
				var _p151 = _p149._0;
				var name = _p149._1 ? A2(_elm_lang$core$Basics_ops['++'], _p151, '-inset') : _p151;
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple3',
						_0: A2(_elm_lang$core$Basics_ops['++'], name, '-offsetX'),
						_1: _p152.offsetX,
						_2: time
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple3',
							_0: A2(_elm_lang$core$Basics_ops['++'], name, '-offsetY'),
							_1: _p152.offsetY,
							_2: time
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple3',
								_0: A2(_elm_lang$core$Basics_ops['++'], name, '-size'),
								_1: _p152.size,
								_2: time
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple3',
									_0: A2(_elm_lang$core$Basics_ops['++'], name, '-blur'),
									_1: _p152.blur,
									_2: time
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple3',
										_0: A2(_elm_lang$core$Basics_ops['++'], name, '-red'),
										_1: _p152.red,
										_2: time
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple3',
											_0: A2(_elm_lang$core$Basics_ops['++'], name, '-green'),
											_1: _p152.green,
											_2: time
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple3',
												_0: A2(_elm_lang$core$Basics_ops['++'], name, '-blue'),
												_1: _p152.blue,
												_2: time
											},
											_1: {
												ctor: '::',
												_0: {
													ctor: '_Tuple3',
													_0: A2(_elm_lang$core$Basics_ops['++'], name, '-alpha'),
													_1: _p152.alpha,
													_2: time
												},
												_1: {ctor: '[]'}
											}
										}
									}
								}
							}
						}
					}
				};
			case 'Property':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple3', _0: _p149._0, _1: _p149._1, _2: time},
					_1: {ctor: '[]'}
				};
			case 'Property2':
				var _p153 = _p149._0;
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple3',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p153, '-x'),
						_1: _p149._1,
						_2: time
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple3',
							_0: A2(_elm_lang$core$Basics_ops['++'], _p153, '-y'),
							_1: _p149._2,
							_2: time
						},
						_1: {ctor: '[]'}
					}
				};
			case 'Property3':
				var _p154 = _p149._0;
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple3',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p154, '-x'),
						_1: _p149._1,
						_2: time
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple3',
							_0: A2(_elm_lang$core$Basics_ops['++'], _p154, '-y'),
							_1: _p149._2,
							_2: time
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple3',
								_0: A2(_elm_lang$core$Basics_ops['++'], _p154, '-z'),
								_1: _p149._3,
								_2: time
							},
							_1: {ctor: '[]'}
						}
					}
				};
			case 'Property4':
				var _p155 = _p149._0;
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple3',
						_0: A2(_elm_lang$core$Basics_ops['++'], _p155, '-w'),
						_1: _p149._1,
						_2: time
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple3',
							_0: A2(_elm_lang$core$Basics_ops['++'], _p155, '-x'),
							_1: _p149._2,
							_2: time
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple3',
								_0: A2(_elm_lang$core$Basics_ops['++'], _p155, '-y'),
								_1: _p149._3,
								_2: time
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple3',
									_0: A2(_elm_lang$core$Basics_ops['++'], _p155, '-z'),
									_1: _p149._4,
									_2: time
								},
								_1: {ctor: '[]'}
							}
						}
					}
				};
			case 'AngleProperty':
				return {
					ctor: '::',
					_0: {ctor: '_Tuple3', _0: _p149._0, _1: _p149._1, _2: time},
					_1: {ctor: '[]'}
				};
			case 'Points':
				var name = 'points';
				return _elm_lang$core$List$concat(
					A2(
						_elm_lang$core$List$indexedMap,
						F2(
							function (i, _p156) {
								var _p157 = _p156;
								return {
									ctor: '::',
									_0: {
										ctor: '_Tuple3',
										_0: A2(
											_elm_lang$core$Basics_ops['++'],
											_elm_lang$core$Basics$toString(i),
											A2(_elm_lang$core$Basics_ops['++'], name, '-x')),
										_1: _p157._0,
										_2: time
									},
									_1: {
										ctor: '::',
										_0: {
											ctor: '_Tuple3',
											_0: A2(
												_elm_lang$core$Basics_ops['++'],
												_elm_lang$core$Basics$toString(i),
												A2(_elm_lang$core$Basics_ops['++'], name, '-y')),
											_1: _p157._1,
											_2: time
										},
										_1: {ctor: '[]'}
									}
								};
							}),
						_p149._0));
			default:
				return {ctor: '[]'};
		}
	};
	return A2(_elm_lang$core$List$concatMap, getValueTuple, _p158.style);
};
var _mdgriffith$elm_style_animation$Animation$isRunning = function (_p159) {
	var _p160 = _p159;
	return _p160._0.running;
};
var _mdgriffith$elm_style_animation$Animation$subscription = F2(
	function (msg, states) {
		return A2(_elm_lang$core$List$any, _mdgriffith$elm_style_animation$Animation$isRunning, states) ? A2(
			_elm_lang$core$Platform_Sub$map,
			msg,
			_elm_lang$animation_frame$AnimationFrame$times(_mdgriffith$elm_style_animation$Animation_Model$Tick)) : _elm_lang$core$Platform_Sub$none;
	});
var _mdgriffith$elm_style_animation$Animation$extractInitialWait = function (steps) {
	var _p161 = _elm_lang$core$List$head(steps);
	if (_p161.ctor === 'Nothing') {
		return {
			ctor: '_Tuple2',
			_0: 0,
			_1: {ctor: '[]'}
		};
	} else {
		var _p162 = _p161._0;
		if (_p162.ctor === 'Wait') {
			var _p163 = _mdgriffith$elm_style_animation$Animation$extractInitialWait(
				A2(_elm_lang$core$List$drop, 1, steps));
			var additionalTime = _p163._0;
			var remainingSteps = _p163._1;
			return {ctor: '_Tuple2', _0: _p162._0 + additionalTime, _1: remainingSteps};
		} else {
			return {ctor: '_Tuple2', _0: 0, _1: steps};
		}
	}
};
var _mdgriffith$elm_style_animation$Animation$interrupt = F2(
	function (steps, _p164) {
		var _p165 = _p164;
		var _p166 = _p165._0;
		return _mdgriffith$elm_style_animation$Animation_Model$Animation(
			_elm_lang$core$Native_Utils.update(
				_p166,
				{
					interruption: {
						ctor: '::',
						_0: _mdgriffith$elm_style_animation$Animation$extractInitialWait(steps),
						_1: _p166.interruption
					},
					running: true
				}));
	});
var _mdgriffith$elm_style_animation$Animation$queue = F2(
	function (steps, _p167) {
		var _p168 = _p167;
		var _p169 = _p168._0;
		return _mdgriffith$elm_style_animation$Animation_Model$Animation(
			_elm_lang$core$Native_Utils.update(
				_p169,
				{
					steps: A2(_elm_lang$core$Basics_ops['++'], _p169.steps, steps),
					running: true
				}));
	});
var _mdgriffith$elm_style_animation$Animation$initialState = function (current) {
	return _mdgriffith$elm_style_animation$Animation_Model$Animation(
		{
			steps: {ctor: '[]'},
			style: current,
			timing: {current: 0, dt: 0},
			running: false,
			interruption: {ctor: '[]'}
		});
};
var _mdgriffith$elm_style_animation$Animation$styleWith = F2(
	function (interp, props) {
		return _mdgriffith$elm_style_animation$Animation$initialState(
			A2(
				_elm_lang$core$List$map,
				_mdgriffith$elm_style_animation$Animation_Model$mapToMotion(
					function (m) {
						return _elm_lang$core$Native_Utils.update(
							m,
							{interpolation: interp});
					}),
				_mdgriffith$elm_style_animation$Animation_Render$warnForDoubleListedProperties(props)));
	});
var _mdgriffith$elm_style_animation$Animation$styleWithEach = function (props) {
	var _p170 = _mdgriffith$elm_style_animation$Animation_Render$warnForDoubleListedProperties(
		A2(_elm_lang$core$List$map, _elm_lang$core$Tuple$second, props));
	return _mdgriffith$elm_style_animation$Animation$initialState(
		A2(
			_elm_lang$core$List$map,
			function (_p171) {
				var _p172 = _p171;
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$mapToMotion,
					function (m) {
						return _elm_lang$core$Native_Utils.update(
							m,
							{interpolation: _p172._0});
					},
					_p172._1);
			},
			props));
};
var _mdgriffith$elm_style_animation$Animation$loop = function (steps) {
	return _mdgriffith$elm_style_animation$Animation_Model$Loop(steps);
};
var _mdgriffith$elm_style_animation$Animation$repeat = F2(
	function (n, steps) {
		return A2(_mdgriffith$elm_style_animation$Animation_Model$Repeat, n, steps);
	});
var _mdgriffith$elm_style_animation$Animation$set = function (props) {
	return _mdgriffith$elm_style_animation$Animation_Model$Set(props);
};
var _mdgriffith$elm_style_animation$Animation$toWithEach = function (interpProps) {
	return _mdgriffith$elm_style_animation$Animation_Model$ToWith(
		A2(
			_elm_lang$core$List$map,
			function (_p173) {
				var _p174 = _p173;
				return A2(
					_mdgriffith$elm_style_animation$Animation_Model$mapToMotion,
					function (m) {
						return _elm_lang$core$Native_Utils.update(
							m,
							{interpolation: _p174._0});
					},
					_p174._1);
			},
			interpProps));
};
var _mdgriffith$elm_style_animation$Animation$toWith = F2(
	function (interp, props) {
		return _mdgriffith$elm_style_animation$Animation_Model$ToWith(
			A2(
				_elm_lang$core$List$map,
				_mdgriffith$elm_style_animation$Animation_Model$mapToMotion(
					function (m) {
						return _elm_lang$core$Native_Utils.update(
							m,
							{interpolation: interp});
					}),
				props));
	});
var _mdgriffith$elm_style_animation$Animation$to = function (props) {
	return _mdgriffith$elm_style_animation$Animation_Model$To(props);
};
var _mdgriffith$elm_style_animation$Animation$wait = function (till) {
	return _mdgriffith$elm_style_animation$Animation_Model$Wait(till);
};
var _mdgriffith$elm_style_animation$Animation$speed = function (speed) {
	return _mdgriffith$elm_style_animation$Animation_Model$AtSpeed(speed);
};
var _mdgriffith$elm_style_animation$Animation$defaultInterpolationByProperty = function (prop) {
	var linear = function (duration) {
		return _mdgriffith$elm_style_animation$Animation_Model$Easing(
			{progress: 1, start: 0, duration: duration, ease: _elm_lang$core$Basics$identity});
	};
	var spring = _mdgriffith$elm_style_animation$Animation_Model$Spring(
		{stiffness: 170, damping: 26});
	var _p175 = prop;
	switch (_p175.ctor) {
		case 'ExactProperty':
			return spring;
		case 'ColorProperty':
			return linear(0.4 * _elm_lang$core$Time$second);
		case 'ShadowProperty':
			return spring;
		case 'Property':
			return spring;
		case 'Property2':
			return spring;
		case 'Property3':
			return _elm_lang$core$Native_Utils.eq(_p175._0, 'rotate3d') ? _mdgriffith$elm_style_animation$Animation$speed(
				{perSecond: _elm_lang$core$Basics$pi}) : spring;
		case 'Property4':
			return spring;
		case 'AngleProperty':
			return _mdgriffith$elm_style_animation$Animation$speed(
				{perSecond: _elm_lang$core$Basics$pi});
		case 'Points':
			return spring;
		default:
			return spring;
	}
};
var _mdgriffith$elm_style_animation$Animation$setDefaultInterpolation = function (prop) {
	var interp = _mdgriffith$elm_style_animation$Animation$defaultInterpolationByProperty(prop);
	return A2(
		_mdgriffith$elm_style_animation$Animation_Model$mapToMotion,
		function (m) {
			return _elm_lang$core$Native_Utils.update(
				m,
				{interpolation: interp});
		},
		prop);
};
var _mdgriffith$elm_style_animation$Animation$style = function (props) {
	return _mdgriffith$elm_style_animation$Animation$initialState(
		A2(
			_elm_lang$core$List$map,
			_mdgriffith$elm_style_animation$Animation$setDefaultInterpolation,
			_mdgriffith$elm_style_animation$Animation_Render$warnForDoubleListedProperties(props)));
};
var _mdgriffith$elm_style_animation$Animation$easing = function (_p176) {
	var _p177 = _p176;
	return _mdgriffith$elm_style_animation$Animation_Model$Easing(
		{progress: 1, duration: _p177.duration, start: 0, ease: _p177.ease});
};
var _mdgriffith$elm_style_animation$Animation$spring = function (settings) {
	return _mdgriffith$elm_style_animation$Animation_Model$Spring(settings);
};
var _mdgriffith$elm_style_animation$Animation$Shadow = F5(
	function (a, b, c, d, e) {
		return {offsetX: a, offsetY: b, size: c, blur: d, color: e};
	});
var _mdgriffith$elm_style_animation$Animation$CubicCurve = F3(
	function (a, b, c) {
		return {control1: a, control2: b, point: c};
	});
var _mdgriffith$elm_style_animation$Animation$QuadraticCurve = F2(
	function (a, b) {
		return {control: a, point: b};
	});
var _mdgriffith$elm_style_animation$Animation$Arc = F6(
	function (a, b, c, d, e, f) {
		return {x: a, y: b, radius: c, startAngle: d, endAngle: e, clockwise: f};
	});
var _mdgriffith$elm_style_animation$Animation$Pc = {ctor: 'Pc'};
var _mdgriffith$elm_style_animation$Animation$Pt = {ctor: 'Pt'};
var _mdgriffith$elm_style_animation$Animation$In = {ctor: 'In'};
var _mdgriffith$elm_style_animation$Animation$Cm = {ctor: 'Cm'};
var _mdgriffith$elm_style_animation$Animation$Mm = {ctor: 'Mm'};
var _mdgriffith$elm_style_animation$Animation$Vmax = {ctor: 'Vmax'};
var _mdgriffith$elm_style_animation$Animation$Vmin = {ctor: 'Vmin'};
var _mdgriffith$elm_style_animation$Animation$Vw = {ctor: 'Vw'};
var _mdgriffith$elm_style_animation$Animation$Vh = {ctor: 'Vh'};
var _mdgriffith$elm_style_animation$Animation$Ch = {ctor: 'Ch'};
var _mdgriffith$elm_style_animation$Animation$Ex = {ctor: 'Ex'};
var _mdgriffith$elm_style_animation$Animation$Em = {ctor: 'Em'};
var _mdgriffith$elm_style_animation$Animation$Rem = {ctor: 'Rem'};
var _mdgriffith$elm_style_animation$Animation$Percent = {ctor: 'Percent'};
var _mdgriffith$elm_style_animation$Animation$Px = {ctor: 'Px'};
var _mdgriffith$elm_style_animation$Animation$NoUnit = {ctor: 'NoUnit'};
var _mdgriffith$elm_style_animation$Animation$Length = F2(
	function (a, b) {
		return {ctor: 'Length', _0: a, _1: b};
	});
var _mdgriffith$elm_style_animation$Animation$px = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Px);
};
var _mdgriffith$elm_style_animation$Animation$percent = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Percent);
};
var _mdgriffith$elm_style_animation$Animation$rem = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Rem);
};
var _mdgriffith$elm_style_animation$Animation$em = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Em);
};
var _mdgriffith$elm_style_animation$Animation$ex = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Ex);
};
var _mdgriffith$elm_style_animation$Animation$ch = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Ch);
};
var _mdgriffith$elm_style_animation$Animation$vh = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Vh);
};
var _mdgriffith$elm_style_animation$Animation$vw = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Vw);
};
var _mdgriffith$elm_style_animation$Animation$vmin = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Vmin);
};
var _mdgriffith$elm_style_animation$Animation$vmax = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Vmax);
};
var _mdgriffith$elm_style_animation$Animation$mm = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Mm);
};
var _mdgriffith$elm_style_animation$Animation$cm = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Cm);
};
var _mdgriffith$elm_style_animation$Animation$inches = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$In);
};
var _mdgriffith$elm_style_animation$Animation$pt = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Pt);
};
var _mdgriffith$elm_style_animation$Animation$pc = function (x) {
	return A2(_mdgriffith$elm_style_animation$Animation$Length, x, _mdgriffith$elm_style_animation$Animation$Pc);
};
var _mdgriffith$elm_style_animation$Animation$Radians = function (a) {
	return {ctor: 'Radians', _0: a};
};
var _mdgriffith$elm_style_animation$Animation$deg = function (a) {
	return _mdgriffith$elm_style_animation$Animation$Radians((a / 360) * (2 * _elm_lang$core$Basics$pi));
};
var _mdgriffith$elm_style_animation$Animation$grad = function (a) {
	return _mdgriffith$elm_style_animation$Animation$Radians((a / 400) * (2 * _elm_lang$core$Basics$pi));
};
var _mdgriffith$elm_style_animation$Animation$rad = function (a) {
	return _mdgriffith$elm_style_animation$Animation$Radians(a);
};
var _mdgriffith$elm_style_animation$Animation$turn = function (a) {
	return _mdgriffith$elm_style_animation$Animation$Radians(a * (2 * _elm_lang$core$Basics$pi));
};
var _mdgriffith$elm_style_animation$Animation$ListItem = {ctor: 'ListItem'};
var _mdgriffith$elm_style_animation$Animation$listItem = _mdgriffith$elm_style_animation$Animation$ListItem;
var _mdgriffith$elm_style_animation$Animation$InlineFlex = {ctor: 'InlineFlex'};
var _mdgriffith$elm_style_animation$Animation$inlineFlex = _mdgriffith$elm_style_animation$Animation$InlineFlex;
var _mdgriffith$elm_style_animation$Animation$Flex = {ctor: 'Flex'};
var _mdgriffith$elm_style_animation$Animation$flex = _mdgriffith$elm_style_animation$Animation$Flex;
var _mdgriffith$elm_style_animation$Animation$Block = {ctor: 'Block'};
var _mdgriffith$elm_style_animation$Animation$block = _mdgriffith$elm_style_animation$Animation$Block;
var _mdgriffith$elm_style_animation$Animation$InlineBlock = {ctor: 'InlineBlock'};
var _mdgriffith$elm_style_animation$Animation$inlineBlock = _mdgriffith$elm_style_animation$Animation$InlineBlock;
var _mdgriffith$elm_style_animation$Animation$Inline = {ctor: 'Inline'};
var _mdgriffith$elm_style_animation$Animation$inline = _mdgriffith$elm_style_animation$Animation$Inline;
var _mdgriffith$elm_style_animation$Animation$None = {ctor: 'None'};
var _mdgriffith$elm_style_animation$Animation$none = _mdgriffith$elm_style_animation$Animation$None;

var _abadi199$datetimepicker$DateTimePicker_ClockUtils$minutes = _elm_lang$core$Dict$fromList(
	A2(
		_elm_lang$core$List$map,
		function (minute) {
			return {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Basics$toString(minute),
				_1: (_elm_lang$core$Basics$pi * _elm_lang$core$Basics$toFloat(
					60 - A2(_elm_lang$core$Basics_ops['%'], 45 + minute, 60))) / 30
			};
		},
		A2(_elm_lang$core$List$range, 0, 59)));
var _abadi199$datetimepicker$DateTimePicker_ClockUtils$minutesPerFive = _elm_lang$core$Dict$fromList(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: '5', _1: (_elm_lang$core$Basics$pi * 2) / 6},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: '10', _1: (_elm_lang$core$Basics$pi * 1) / 6},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: '15', _1: _elm_lang$core$Basics$pi * 2},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: '20', _1: (_elm_lang$core$Basics$pi * 11) / 6},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: '25', _1: (_elm_lang$core$Basics$pi * 10) / 6},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: '30', _1: (_elm_lang$core$Basics$pi * 9) / 6},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: '35', _1: (_elm_lang$core$Basics$pi * 8) / 6},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: '40', _1: (_elm_lang$core$Basics$pi * 7) / 6},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: '45', _1: _elm_lang$core$Basics$pi},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: '50', _1: (_elm_lang$core$Basics$pi * 5) / 6},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: '55', _1: (_elm_lang$core$Basics$pi * 4) / 6},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: '0', _1: _elm_lang$core$Basics$pi / 2},
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var _abadi199$datetimepicker$DateTimePicker_ClockUtils$hours = _elm_lang$core$Dict$fromList(
	{
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: '1', _1: (_elm_lang$core$Basics$pi * 2) / 6},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: '2', _1: (_elm_lang$core$Basics$pi * 1) / 6},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: '3', _1: _elm_lang$core$Basics$pi * 2},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: '4', _1: (_elm_lang$core$Basics$pi * 11) / 6},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: '5', _1: (_elm_lang$core$Basics$pi * 10) / 6},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: '6', _1: (_elm_lang$core$Basics$pi * 9) / 6},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: '7', _1: (_elm_lang$core$Basics$pi * 8) / 6},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: '8', _1: (_elm_lang$core$Basics$pi * 7) / 6},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: '9', _1: _elm_lang$core$Basics$pi},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: '10', _1: (_elm_lang$core$Basics$pi * 5) / 6},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: '11', _1: (_elm_lang$core$Basics$pi * 4) / 6},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: '12', _1: _elm_lang$core$Basics$pi / 2},
													_1: {ctor: '[]'}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	});
var _abadi199$datetimepicker$DateTimePicker_ClockUtils$minuteToAngle = function (minute) {
	return A2(
		_elm_lang$core$Dict$get,
		_elm_lang$core$Basics$toString(minute),
		_abadi199$datetimepicker$DateTimePicker_ClockUtils$minutes);
};
var _abadi199$datetimepicker$DateTimePicker_ClockUtils$hourToAngle = function (hour) {
	return A2(
		_elm_lang$core$Dict$get,
		_elm_lang$core$Basics$toString(hour),
		_abadi199$datetimepicker$DateTimePicker_ClockUtils$hours);
};

var _abadi199$datetimepicker$DateTimePicker_DateUtils$toMillitary = F2(
	function (hour, amPm) {
		var _p0 = {ctor: '_Tuple2', _0: hour, _1: amPm};
		_v0_3:
		do {
			switch (_p0._1) {
				case 'AM':
					if (_p0._0 === 12) {
						return 0;
					} else {
						break _v0_3;
					}
				case 'PM':
					if (_p0._0 === 12) {
						return 12;
					} else {
						return hour + 12;
					}
				default:
					break _v0_3;
			}
		} while(false);
		return hour;
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$fromMillitaryAmPm = function (hour) {
	var _p1 = hour;
	switch (_p1) {
		case 12:
			return 'PM';
		case 0:
			return 'AM';
		default:
			return (_elm_lang$core$Native_Utils.cmp(hour, 12) > -1) ? 'PM' : 'AM';
	}
};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$fromMillitaryHour = function (hour) {
	var _p2 = hour;
	switch (_p2) {
		case 12:
			return 12;
		case 0:
			return 12;
		default:
			return A2(_elm_lang$core$Basics_ops['%'], hour, 12);
	}
};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$padding = function (str) {
	return _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$String$length(str),
		0) ? '00' : (_elm_lang$core$Native_Utils.eq(
		_elm_lang$core$String$length(str),
		1) ? A2(_elm_lang$core$Basics_ops['++'], '0', str) : str);
};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$setTime = F4(
	function (date, hour, minute, amPm) {
		return A7(
			_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields,
			_elm_lang$core$Date$year(date),
			_elm_lang$core$Date$month(date),
			_elm_lang$core$Date$day(date),
			A2(_abadi199$datetimepicker$DateTimePicker_DateUtils$toMillitary, hour, amPm),
			minute,
			0,
			0);
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$toTime = F3(
	function (hour, minute, amPm) {
		return A7(
			_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields,
			0,
			_elm_lang$core$Date$Jan,
			1,
			A2(_abadi199$datetimepicker$DateTimePicker_DateUtils$toMillitary, hour, amPm),
			minute,
			0,
			0);
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$toDateTime = F5(
	function (year, month, day, hour, minute) {
		var _p3 = day.monthType;
		switch (_p3.ctor) {
			case 'Current':
				return A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, year, month, day.day, hour, minute, 0, 0);
			case 'Previous':
				var previousMonth = _rluiten$elm_date_extra$Date_Extra_Core$lastOfPrevMonthDate(
					A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, year, month, day.day, hour, minute, 0, 0));
				return A7(
					_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields,
					_elm_lang$core$Date$year(previousMonth),
					_elm_lang$core$Date$month(previousMonth),
					day.day,
					hour,
					minute,
					0,
					0);
			default:
				var nextMonth = _rluiten$elm_date_extra$Date_Extra_Core$firstOfNextMonthDate(
					A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, year, month, day.day, hour, minute, 0, 0));
				return A7(
					_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields,
					_elm_lang$core$Date$year(nextMonth),
					_elm_lang$core$Date$month(nextMonth),
					day.day,
					hour,
					minute,
					0,
					0);
		}
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$toDate = F3(
	function (year, month, day) {
		return A5(_abadi199$datetimepicker$DateTimePicker_DateUtils$toDateTime, year, month, day, 0, 0);
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$calculateNumberOfDaysForPreviousMonth = function (firstDayInInt) {
	return _elm_lang$core$Native_Utils.eq(firstDayInInt, 0) ? 7 : firstDayInInt;
};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$dayToInt = F2(
	function (startOfWeek, day) {
		var base = function () {
			var _p4 = day;
			switch (_p4.ctor) {
				case 'Sun':
					return 0;
				case 'Mon':
					return 1;
				case 'Tue':
					return 2;
				case 'Wed':
					return 3;
				case 'Thu':
					return 4;
				case 'Fri':
					return 5;
				default:
					return 6;
			}
		}();
		var _p5 = startOfWeek;
		switch (_p5.ctor) {
			case 'Sun':
				return base;
			case 'Mon':
				return A2(_elm_lang$core$Basics_ops['%'], base - 1, 7);
			case 'Tue':
				return A2(_elm_lang$core$Basics_ops['%'], base - 2, 7);
			case 'Wed':
				return A2(_elm_lang$core$Basics_ops['%'], base - 3, 7);
			case 'Thu':
				return A2(_elm_lang$core$Basics_ops['%'], base - 4, 7);
			case 'Fri':
				return A2(_elm_lang$core$Basics_ops['%'], base - 5, 7);
			default:
				return A2(_elm_lang$core$Basics_ops['%'], base - 6, 7);
		}
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$Day = F2(
	function (a, b) {
		return {monthType: a, day: b};
	});
var _abadi199$datetimepicker$DateTimePicker_DateUtils$Next = {ctor: 'Next'};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$Current = {ctor: 'Current'};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$Previous = {ctor: 'Previous'};
var _abadi199$datetimepicker$DateTimePicker_DateUtils$generateCalendar = F3(
	function (firstDayOfWeek, month, year) {
		var nextMonth = A2(
			_elm_lang$core$List$map,
			_abadi199$datetimepicker$DateTimePicker_DateUtils$Day(_abadi199$datetimepicker$DateTimePicker_DateUtils$Next),
			A2(_elm_lang$core$List$range, 1, 14));
		var firstDateOfMonth = A7(_rluiten$elm_date_extra$Date_Extra_Create$dateFromFields, year, month, 1, 0, 0, 0, 0);
		var firstDayOfMonth = A2(
			_abadi199$datetimepicker$DateTimePicker_DateUtils$dayToInt,
			firstDayOfWeek,
			_elm_lang$core$Date$dayOfWeek(firstDateOfMonth));
		var numberOfDaysForPreviousMonth = _abadi199$datetimepicker$DateTimePicker_DateUtils$calculateNumberOfDaysForPreviousMonth(firstDayOfMonth);
		var daysInMonth = _rluiten$elm_date_extra$Date_Extra_Core$daysInMonthDate(firstDateOfMonth);
		var currentMonth = A2(
			_elm_lang$core$List$map,
			_abadi199$datetimepicker$DateTimePicker_DateUtils$Day(_abadi199$datetimepicker$DateTimePicker_DateUtils$Current),
			A2(_elm_lang$core$List$range, 1, daysInMonth));
		var daysInPreviousMonth = _rluiten$elm_date_extra$Date_Extra_Core$daysInPrevMonth(firstDateOfMonth);
		var previousMonth = A2(
			_elm_lang$core$List$map,
			_abadi199$datetimepicker$DateTimePicker_DateUtils$Day(_abadi199$datetimepicker$DateTimePicker_DateUtils$Previous),
			A2(_elm_lang$core$List$range, (daysInPreviousMonth - numberOfDaysForPreviousMonth) + 1, daysInPreviousMonth));
		return A2(
			_elm_lang$core$List$take,
			42,
			A2(
				_elm_lang$core$Basics_ops['++'],
				previousMonth,
				A2(_elm_lang$core$Basics_ops['++'], currentMonth, nextMonth)));
	});

var _elm_lang$svg$Svg_Events$on = _elm_lang$virtual_dom$VirtualDom$on;
var _elm_lang$svg$Svg_Events$simpleOn = F2(
	function (name, msg) {
		return A2(
			_elm_lang$svg$Svg_Events$on,
			name,
			_elm_lang$core$Json_Decode$succeed(msg));
	});
var _elm_lang$svg$Svg_Events$onBegin = _elm_lang$svg$Svg_Events$simpleOn('begin');
var _elm_lang$svg$Svg_Events$onEnd = _elm_lang$svg$Svg_Events$simpleOn('end');
var _elm_lang$svg$Svg_Events$onRepeat = _elm_lang$svg$Svg_Events$simpleOn('repeat');
var _elm_lang$svg$Svg_Events$onAbort = _elm_lang$svg$Svg_Events$simpleOn('abort');
var _elm_lang$svg$Svg_Events$onError = _elm_lang$svg$Svg_Events$simpleOn('error');
var _elm_lang$svg$Svg_Events$onResize = _elm_lang$svg$Svg_Events$simpleOn('resize');
var _elm_lang$svg$Svg_Events$onScroll = _elm_lang$svg$Svg_Events$simpleOn('scroll');
var _elm_lang$svg$Svg_Events$onLoad = _elm_lang$svg$Svg_Events$simpleOn('load');
var _elm_lang$svg$Svg_Events$onUnload = _elm_lang$svg$Svg_Events$simpleOn('unload');
var _elm_lang$svg$Svg_Events$onZoom = _elm_lang$svg$Svg_Events$simpleOn('zoom');
var _elm_lang$svg$Svg_Events$onActivate = _elm_lang$svg$Svg_Events$simpleOn('activate');
var _elm_lang$svg$Svg_Events$onClick = _elm_lang$svg$Svg_Events$simpleOn('click');
var _elm_lang$svg$Svg_Events$onFocusIn = _elm_lang$svg$Svg_Events$simpleOn('focusin');
var _elm_lang$svg$Svg_Events$onFocusOut = _elm_lang$svg$Svg_Events$simpleOn('focusout');
var _elm_lang$svg$Svg_Events$onMouseDown = _elm_lang$svg$Svg_Events$simpleOn('mousedown');
var _elm_lang$svg$Svg_Events$onMouseMove = _elm_lang$svg$Svg_Events$simpleOn('mousemove');
var _elm_lang$svg$Svg_Events$onMouseOut = _elm_lang$svg$Svg_Events$simpleOn('mouseout');
var _elm_lang$svg$Svg_Events$onMouseOver = _elm_lang$svg$Svg_Events$simpleOn('mouseover');
var _elm_lang$svg$Svg_Events$onMouseUp = _elm_lang$svg$Svg_Events$simpleOn('mouseup');

var _abadi199$datetimepicker$DateTimePicker_Events$touches = function (decoder) {
	var loop = F2(
		function (idx, xs) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (_p0) {
					return A2(
						_elm_lang$core$Maybe$withDefault,
						_elm_lang$core$Json_Decode$succeed(xs),
						A2(
							_elm_lang$core$Maybe$map,
							function (x) {
								return A2(
									loop,
									idx + 1,
									{ctor: '::', _0: x, _1: xs});
							},
							_p0));
				},
				_elm_lang$core$Json_Decode$maybe(
					A2(
						_elm_lang$core$Json_Decode$field,
						_elm_lang$core$Basics$toString(idx),
						decoder)));
		});
	return A2(
		_elm_lang$core$Json_Decode$at,
		{
			ctor: '::',
			_0: 'touches',
			_1: {
				ctor: '::',
				_0: '0',
				_1: {ctor: '[]'}
			}
		},
		A2(
			loop,
			0,
			{ctor: '[]'}));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onTouchMovePreventDefault = function (msg) {
	var eventOptions = {preventDefault: true, stopPropagation: true};
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'touchstart',
		eventOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onPointerUp = function (msg) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'pointerup',
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onTouchEndPreventDefault = function (msg) {
	var eventOptions = {preventDefault: true, stopPropagation: true};
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'touchend',
		eventOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onMouseUpPreventDefault = function (msg) {
	var eventOptions = {preventDefault: true, stopPropagation: true};
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'mouseup',
		eventOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault = function (msg) {
	var eventOptions = {preventDefault: true, stopPropagation: true};
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'touchstart',
		eventOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault = function (msg) {
	var eventOptions = {preventDefault: true, stopPropagation: true};
	return A3(
		_elm_lang$html$Html_Events$onWithOptions,
		'mousedown',
		eventOptions,
		_elm_lang$core$Json_Decode$succeed(msg));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onBlurWithChange = F2(
	function (parser, tagger) {
		return A2(
			_elm_lang$html$Html_Events$on,
			'blur',
			A2(
				_elm_lang$core$Json_Decode$map,
				function (_p1) {
					return tagger(
						parser(_p1));
				},
				_elm_lang$html$Html_Events$targetValue));
	});
var _abadi199$datetimepicker$DateTimePicker_Events$MoveData = F2(
	function (a, b) {
		return {offsetX: a, offsetY: b};
	});
var _abadi199$datetimepicker$DateTimePicker_Events$mouseMoveDecoder = A3(
	_elm_lang$core$Json_Decode$map2,
	_abadi199$datetimepicker$DateTimePicker_Events$MoveData,
	A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Basics$round,
		A2(_elm_lang$core$Json_Decode$field, 'offsetX', _elm_lang$core$Json_Decode$float)),
	A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$Basics$round,
		A2(_elm_lang$core$Json_Decode$field, 'offsetY', _elm_lang$core$Json_Decode$float)));
var _abadi199$datetimepicker$DateTimePicker_Events$onMouseMoveWithPosition = function (decoder) {
	return A2(
		_elm_lang$svg$Svg_Events$on,
		'mousemove',
		A2(_elm_lang$core$Json_Decode$andThen, decoder, _abadi199$datetimepicker$DateTimePicker_Events$mouseMoveDecoder));
};
var _abadi199$datetimepicker$DateTimePicker_Events$onPointerMoveWithPosition = function (decoder) {
	return A2(
		_elm_lang$html$Html_Events$on,
		'pointermove',
		A2(_elm_lang$core$Json_Decode$andThen, decoder, _abadi199$datetimepicker$DateTimePicker_Events$mouseMoveDecoder));
};

var _abadi199$datetimepicker$DateTimePicker_Geometry$calculateArrowPoint = F3(
	function (origin, length, radians) {
		var y = _elm_lang$core$Basics$round(
			_elm_lang$core$Basics$toFloat(length) * _elm_lang$core$Basics$sin(radians));
		var x = _elm_lang$core$Basics$round(
			_elm_lang$core$Basics$toFloat(length) * _elm_lang$core$Basics$cos(radians));
		return {x: origin.x + x, y: origin.y - y};
	});
var _abadi199$datetimepicker$DateTimePicker_Geometry$Point = F2(
	function (a, b) {
		return {x: a, y: b};
	});
var _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant4 = {ctor: 'Quadrant4'};
var _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant3 = {ctor: 'Quadrant3'};
var _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant2 = {ctor: 'Quadrant2'};
var _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant1 = {ctor: 'Quadrant1'};
var _abadi199$datetimepicker$DateTimePicker_Geometry$calculateAngle = F3(
	function (p1, p2, p3) {
		var p23 = _elm_lang$core$Basics$sqrt(
			_elm_lang$core$Basics$toFloat(
				Math.pow(p2.x - p3.x, 2) + Math.pow(p2.y - p3.y, 2)));
		var p13 = _elm_lang$core$Basics$sqrt(
			_elm_lang$core$Basics$toFloat(
				Math.pow(p1.x - p3.x, 2) + Math.pow(p1.y - p3.y, 2)));
		var p12 = _elm_lang$core$Basics$sqrt(
			_elm_lang$core$Basics$toFloat(
				Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2)));
		var angle = _elm_lang$core$Basics$acos(
			((Math.pow(p12, 2) + Math.pow(p13, 2)) - Math.pow(p23, 2)) / ((2 * p12) * p13));
		var quadrant = ((_elm_lang$core$Native_Utils.cmp(p3.x, p1.x) > -1) && (_elm_lang$core$Native_Utils.cmp(p3.y, p1.y) > -1)) ? _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant1 : (((_elm_lang$core$Native_Utils.cmp(p3.x, p1.x) < 0) && (_elm_lang$core$Native_Utils.cmp(p3.y, p1.y) > -1)) ? _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant2 : (((_elm_lang$core$Native_Utils.cmp(p3.x, p1.x) < 0) && (_elm_lang$core$Native_Utils.cmp(p3.y, p1.y) < 0)) ? _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant3 : _abadi199$datetimepicker$DateTimePicker_Geometry$Quadrant4));
		var _p0 = quadrant;
		switch (_p0.ctor) {
			case 'Quadrant3':
				return angle;
			case 'Quadrant4':
				return angle;
			case 'Quadrant1':
				return (2 * _elm_lang$core$Basics$pi) - angle;
			default:
				return (2 * _elm_lang$core$Basics$pi) - angle;
		}
	});

var _abadi199$datetimepicker$DateTimePicker_SharedStyles$EmptyCell = {ctor: 'EmptyCell'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$PM = {ctor: 'PM'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$AM = {ctor: 'AM'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$AMPMPicker = {ctor: 'AMPMPicker'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Separator = {ctor: 'Separator'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$AMPM = {ctor: 'AMPM'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Minute = {ctor: 'Minute'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Hour = {ctor: 'Hour'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Active = {ctor: 'Active'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$AnalogClock = {ctor: 'AnalogClock'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$AnalogTime = {ctor: 'AnalogTime'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$DigitalTime = {ctor: 'DigitalTime'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Today = {ctor: 'Today'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedAmPm = {ctor: 'SelectedAmPm'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedMinute = {ctor: 'SelectedMinute'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedHour = {ctor: 'SelectedHour'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedDate = {ctor: 'SelectedDate'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Footer = {ctor: 'Footer'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$TimePicker = {ctor: 'TimePicker'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$DatePicker = {ctor: 'DatePicker'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$TimePickerDialog = {ctor: 'TimePickerDialog'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$DatePickerDialog = {ctor: 'DatePickerDialog'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Dialog = {ctor: 'Dialog'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowDown = {ctor: 'ArrowDown'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowUp = {ctor: 'ArrowUp'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$DoubleArrowRight = {ctor: 'DoubleArrowRight'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$DoubleArrowLeft = {ctor: 'DoubleArrowLeft'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowRight = {ctor: 'ArrowRight'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowLeft = {ctor: 'ArrowLeft'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$NoYearNavigation = {ctor: 'NoYearNavigation'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Title = {ctor: 'Title'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Days = {ctor: 'Days'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$NextMonth = {ctor: 'NextMonth'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Body = {ctor: 'Body'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Header = {ctor: 'Header'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$CurrentMonth = {ctor: 'CurrentMonth'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$PreviousMonth = {ctor: 'PreviousMonth'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$DaysOfWeek = {ctor: 'DaysOfWeek'};
var _abadi199$datetimepicker$DateTimePicker_SharedStyles$Calendar = {ctor: 'Calendar'};

var _abadi199$datetimepicker$AnalogTimePickerPanel$updateTimeIndicator = F2(
	function (activeIndicator, time) {
		var _p0 = {ctor: '_Tuple4', _0: activeIndicator, _1: time.hour, _2: time.minute, _3: time.amPm};
		if (_p0._0.ctor === 'Just') {
			switch (_p0._0._0.ctor) {
				case 'HourIndicator':
					if (_p0._2.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator);
					} else {
						if (_p0._3.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator);
						} else {
							return _elm_lang$core$Maybe$Nothing;
						}
					}
				case 'MinuteIndicator':
					if (_p0._3.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator);
					} else {
						if (_p0._1.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator);
						} else {
							return _elm_lang$core$Maybe$Nothing;
						}
					}
				default:
					if (_p0._1.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator);
					} else {
						if (_p0._2.ctor === 'Nothing') {
							return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator);
						} else {
							return _elm_lang$core$Maybe$Nothing;
						}
					}
			}
		} else {
			if (_p0._1.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator);
			} else {
				if (_p0._2.ctor === 'Nothing') {
					return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator);
				} else {
					if (_p0._3.ctor === 'Nothing') {
						return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator);
					} else {
						return _elm_lang$core$Maybe$Nothing;
					}
				}
			}
		}
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$updateCurrentDate = function (_p1) {
	var _p2 = _p1;
	var _p4 = _p2._0;
	var _p3 = {ctor: '_Tuple3', _0: _p4.time.hour, _1: _p4.time.minute, _2: _p4.time.amPm};
	if ((((_p3.ctor === '_Tuple3') && (_p3._0.ctor === 'Just')) && (_p3._1.ctor === 'Just')) && (_p3._2.ctor === 'Just')) {
		return _elm_lang$core$Maybe$Just(
			A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$toTime, _p3._0._0, _p3._1._0, _p3._2._0));
	} else {
		return _elm_lang$core$Maybe$Nothing;
	}
};
var _abadi199$datetimepicker$AnalogTimePickerPanel$amPmPickerHandler = F4(
	function (config, _p5, currentDate, amPm) {
		var _p6 = _p5;
		var _p7 = _p6._0;
		var time = _p7.time;
		var updatedTime = _elm_lang$core$Native_Utils.update(
			time,
			{
				amPm: _elm_lang$core$Maybe$Just(amPm)
			});
		var updatedState = _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
			_elm_lang$core$Native_Utils.update(
				_p7,
				{
					time: updatedTime,
					activeTimeIndicator: A2(_abadi199$datetimepicker$AnalogTimePickerPanel$updateTimeIndicator, _p7.activeTimeIndicator, updatedTime)
				}));
		return A2(
			config.onChange,
			updatedState,
			_abadi199$datetimepicker$AnalogTimePickerPanel$updateCurrentDate(updatedState));
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler = F4(
	function (config, _p8, currentDate, timeIndicator) {
		var _p9 = _p8;
		var _p11 = _p9._0;
		var currentAngle = function () {
			var _p10 = {ctor: '_Tuple3', _0: timeIndicator, _1: _p11.time.hour, _2: _p11.time.minute};
			_v5_2:
			do {
				switch (_p10._0.ctor) {
					case 'HourIndicator':
						if (_p10._1.ctor === 'Just') {
							return _abadi199$datetimepicker$DateTimePicker_ClockUtils$hourToAngle(_p10._1._0);
						} else {
							break _v5_2;
						}
					case 'MinuteIndicator':
						if (_p10._2.ctor === 'Just') {
							return _abadi199$datetimepicker$DateTimePicker_ClockUtils$minuteToAngle(_p10._2._0);
						} else {
							break _v5_2;
						}
					default:
						break _v5_2;
				}
			} while(false);
			return _elm_lang$core$Maybe$Nothing;
		}();
		var updatedActiveTimeIndicator = _elm_lang$core$Native_Utils.eq(
			_p11.activeTimeIndicator,
			_elm_lang$core$Maybe$Just(timeIndicator)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(timeIndicator);
		var updatedState = _elm_lang$core$Native_Utils.update(
			_p11,
			{activeTimeIndicator: updatedActiveTimeIndicator, currentAngle: currentAngle});
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedState),
			currentDate);
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler = F3(
	function (_p12, date, onChange) {
		var _p13 = _p12;
		var _p14 = _p13._0;
		var updatedState = _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
			_elm_lang$core$Native_Utils.update(
				_p14,
				{
					activeTimeIndicator: A2(_abadi199$datetimepicker$AnalogTimePickerPanel$updateTimeIndicator, _p14.activeTimeIndicator, _p14.time)
				}));
		var updatedDate = _abadi199$datetimepicker$AnalogTimePickerPanel$updateCurrentDate(
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p14));
		return A2(onChange, updatedState, updatedDate);
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$drawArrow = F4(
	function (onChange, state, date, point) {
		return A2(
			_elm_lang$svg$Svg$line,
			{
				ctor: '::',
				_0: _elm_lang$svg$Svg_Attributes$x1('100'),
				_1: {
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$y1('100'),
					_1: {
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$x2(
							_elm_lang$core$Basics$toString(point.x)),
						_1: {
							ctor: '::',
							_0: _elm_lang$svg$Svg_Attributes$y2(
								_elm_lang$core$Basics$toString(point.y)),
							_1: {
								ctor: '::',
								_0: _elm_lang$svg$Svg_Attributes$strokeWidth('2px'),
								_1: {
									ctor: '::',
									_0: _elm_lang$svg$Svg_Attributes$stroke('#aaa'),
									_1: {
										ctor: '::',
										_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
											A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler, state, date, onChange)),
										_1: {
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_Events$onPointerUp(
												A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler, state, date, onChange)),
											_1: {ctor: '[]'}
										}
									}
								}
							}
						}
					}
				}
			},
			{ctor: '[]'});
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$axisPoint = A2(_abadi199$datetimepicker$DateTimePicker_Geometry$Point, 200, 100);
var _abadi199$datetimepicker$AnalogTimePickerPanel$originPoint = A2(_abadi199$datetimepicker$DateTimePicker_Geometry$Point, 100, 100);
var _abadi199$datetimepicker$AnalogTimePickerPanel$updateHourState = F3(
	function (_p15, date, moveData) {
		var _p16 = _p15;
		var _p21 = _p16._0;
		var updateTime = F2(
			function (time, hour) {
				return _elm_lang$core$Native_Utils.update(
					time,
					{
						hour: A2(
							_elm_lang$core$Maybe$andThen,
							function (_p17) {
								return _elm_lang$core$Result$toMaybe(
									_elm_lang$core$String$toInt(_p17));
							},
							hour)
					});
			});
		var currentAngle = A3(
			_abadi199$datetimepicker$DateTimePicker_Geometry$calculateAngle,
			_abadi199$datetimepicker$AnalogTimePickerPanel$originPoint,
			_abadi199$datetimepicker$AnalogTimePickerPanel$axisPoint,
			A2(_abadi199$datetimepicker$DateTimePicker_Geometry$Point, moveData.offsetX, moveData.offsetY));
		var closestHour = A2(
			_elm_lang$core$Maybe$map,
			_elm_lang$core$Tuple$first,
			_elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$sortBy,
					_elm_lang$core$Tuple$second,
					A2(
						_elm_lang$core$List$map,
						function (_p18) {
							var _p19 = _p18;
							var _p20 = _p19._1;
							return {
								ctor: '_Tuple2',
								_0: {ctor: '_Tuple2', _0: _p19._0, _1: _p20},
								_1: _elm_lang$core$Basics$abs(_p20 - currentAngle)
							};
						},
						_elm_lang$core$Dict$toList(_abadi199$datetimepicker$DateTimePicker_ClockUtils$hours)))));
		return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
			_elm_lang$core$Native_Utils.update(
				_p21,
				{
					currentAngle: A2(_elm_lang$core$Maybe$map, _elm_lang$core$Tuple$second, closestHour),
					time: A2(
						updateTime,
						_p21.time,
						A2(_elm_lang$core$Maybe$map, _elm_lang$core$Tuple$first, closestHour))
				}));
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$updateMinuteState = F3(
	function (_p22, date, moveData) {
		var _p23 = _p22;
		var _p28 = _p23._0;
		var updateTime = F2(
			function (time, minute) {
				return _elm_lang$core$Native_Utils.update(
					time,
					{
						minute: A2(
							_elm_lang$core$Maybe$andThen,
							function (_p24) {
								return _elm_lang$core$Result$toMaybe(
									_elm_lang$core$String$toInt(_p24));
							},
							minute)
					});
			});
		var currentAngle = A3(
			_abadi199$datetimepicker$DateTimePicker_Geometry$calculateAngle,
			_abadi199$datetimepicker$AnalogTimePickerPanel$originPoint,
			_abadi199$datetimepicker$AnalogTimePickerPanel$axisPoint,
			A2(_abadi199$datetimepicker$DateTimePicker_Geometry$Point, moveData.offsetX, moveData.offsetY));
		var closestMinute = A2(
			_elm_lang$core$Maybe$map,
			_elm_lang$core$Tuple$first,
			_elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$sortBy,
					_elm_lang$core$Tuple$second,
					A2(
						_elm_lang$core$List$map,
						function (_p25) {
							var _p26 = _p25;
							var _p27 = _p26._1;
							return {
								ctor: '_Tuple2',
								_0: {ctor: '_Tuple2', _0: _p26._0, _1: _p27},
								_1: _elm_lang$core$Basics$abs(_p27 - currentAngle)
							};
						},
						_elm_lang$core$Dict$toList(_abadi199$datetimepicker$DateTimePicker_ClockUtils$minutes)))));
		return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
			_elm_lang$core$Native_Utils.update(
				_p28,
				{
					currentAngle: A2(_elm_lang$core$Maybe$map, _elm_lang$core$Tuple$second, closestMinute),
					time: A2(
						updateTime,
						_p28.time,
						A2(_elm_lang$core$Maybe$map, _elm_lang$core$Tuple$first, closestMinute))
				}));
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$mouseOverHandler = F4(
	function (_p29, date, onChange, moveData) {
		var _p30 = _p29;
		var _p32 = _p30._0;
		var decoder = function (updatedState) {
			return _elm_lang$core$Json_Decode$succeed(
				A2(onChange, updatedState, date));
		};
		var _p31 = _p32.activeTimeIndicator;
		_v12_2:
		do {
			if (_p31.ctor === 'Just') {
				switch (_p31._0.ctor) {
					case 'HourIndicator':
						return decoder(
							A3(
								_abadi199$datetimepicker$AnalogTimePickerPanel$updateHourState,
								_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p32),
								date,
								moveData));
					case 'MinuteIndicator':
						return decoder(
							A3(
								_abadi199$datetimepicker$AnalogTimePickerPanel$updateMinuteState,
								_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p32),
								date,
								moveData));
					default:
						break _v12_2;
				}
			} else {
				break _v12_2;
			}
		} while(false);
		return decoder(
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p32));
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$clockFace = F4(
	function (onChange, state, date, _p33) {
		var _p34 = _p33;
		var point = A3(_abadi199$datetimepicker$DateTimePicker_Geometry$calculateArrowPoint, _abadi199$datetimepicker$AnalogTimePickerPanel$originPoint, 85, _p34._1);
		return A2(
			_elm_lang$svg$Svg$text_,
			{
				ctor: '::',
				_0: _elm_lang$svg$Svg_Attributes$x(
					_elm_lang$core$Basics$toString(point.x)),
				_1: {
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$y(
						_elm_lang$core$Basics$toString(point.y)),
					_1: {
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$textAnchor('middle'),
						_1: {
							ctor: '::',
							_0: _elm_lang$svg$Svg_Attributes$dominantBaseline('central'),
							_1: {
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
									A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler, state, date, onChange)),
								_1: {
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onPointerUp(
										A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler, state, date, onChange)),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(_p34._0),
				_1: {ctor: '[]'}
			});
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$minuteArrowLength = 70;
var _abadi199$datetimepicker$AnalogTimePickerPanel$currentTime = F3(
	function (onChange, _p35, date) {
		var _p36 = _p35;
		var _p41 = _p36._0;
		var drawMinute = function (minute) {
			return A2(
				_elm_lang$core$Maybe$withDefault,
				_elm_lang$html$Html$text(''),
				A2(
					_elm_lang$core$Maybe$map,
					function (_p37) {
						return A4(
							_abadi199$datetimepicker$AnalogTimePickerPanel$drawArrow,
							onChange,
							_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p41),
							date,
							A3(_abadi199$datetimepicker$DateTimePicker_Geometry$calculateArrowPoint, _abadi199$datetimepicker$AnalogTimePickerPanel$originPoint, _abadi199$datetimepicker$AnalogTimePickerPanel$minuteArrowLength, _p37));
					},
					A2(
						_elm_lang$core$Dict$get,
						_elm_lang$core$Basics$toString(minute),
						_abadi199$datetimepicker$DateTimePicker_ClockUtils$minutes)));
		};
		var hourArrowLength = 50;
		var drawHour = F2(
			function (hour, minute) {
				return A2(
					_elm_lang$core$Maybe$withDefault,
					_elm_lang$html$Html$text(''),
					A2(
						_elm_lang$core$Maybe$map,
						function (_p38) {
							return A4(
								_abadi199$datetimepicker$AnalogTimePickerPanel$drawArrow,
								onChange,
								_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p41),
								date,
								A3(_abadi199$datetimepicker$DateTimePicker_Geometry$calculateArrowPoint, _abadi199$datetimepicker$AnalogTimePickerPanel$originPoint, hourArrowLength, _p38));
						},
						A2(
							_elm_lang$core$Maybe$map,
							A2(
								_elm_lang$core$Basics$flip,
								F2(
									function (x, y) {
										return x - y;
									}),
								(_elm_lang$core$Basics$toFloat(minute) * _elm_lang$core$Basics$pi) / 360),
							A2(
								_elm_lang$core$Dict$get,
								_elm_lang$core$Basics$toString(hour),
								_abadi199$datetimepicker$DateTimePicker_ClockUtils$hours))));
			});
		var time = _p41.time;
		var _p39 = {ctor: '_Tuple4', _0: _p41.activeTimeIndicator, _1: time.hour, _2: time.minute, _3: time.amPm};
		if (((((_p39.ctor === '_Tuple4') && (_p39._0.ctor === 'Nothing')) && (_p39._1.ctor === 'Just')) && (_p39._2.ctor === 'Just')) && (_p39._3.ctor === 'Just')) {
			var _p40 = _p39._2._0;
			return A2(
				_elm_lang$svg$Svg$g,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: A2(drawHour, _p39._1._0, _p40),
					_1: {
						ctor: '::',
						_0: drawMinute(_p40),
						_1: {ctor: '[]'}
					}
				});
		} else {
			return _elm_lang$html$Html$text('');
		}
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$hourArrowLength = 50;
var _abadi199$datetimepicker$AnalogTimePickerPanel$arrow = F3(
	function (onChange, _p42, date) {
		var _p43 = _p42;
		var _p48 = _p43._0;
		var isJust = function (maybe) {
			var _p44 = maybe;
			if (_p44.ctor === 'Just') {
				return true;
			} else {
				return false;
			}
		};
		var shouldDrawArrow = function () {
			var _p45 = _p48.activeTimeIndicator;
			_v18_2:
			do {
				if (_p45.ctor === 'Just') {
					switch (_p45._0.ctor) {
						case 'HourIndicator':
							return isJust(_p48.time.hour);
						case 'MinuteIndicator':
							return isJust(_p48.time.minute);
						default:
							break _v18_2;
					}
				} else {
					break _v18_2;
				}
			} while(false);
			return false;
		}();
		var length = function () {
			var _p46 = _p48.activeTimeIndicator;
			_v19_2:
			do {
				if (_p46.ctor === 'Just') {
					switch (_p46._0.ctor) {
						case 'HourIndicator':
							return _abadi199$datetimepicker$AnalogTimePickerPanel$hourArrowLength;
						case 'MinuteIndicator':
							return _abadi199$datetimepicker$AnalogTimePickerPanel$minuteArrowLength;
						default:
							break _v19_2;
					}
				} else {
					break _v19_2;
				}
			} while(false);
			return 0;
		}();
		var arrowPoint = function (angle) {
			return A3(_abadi199$datetimepicker$DateTimePicker_Geometry$calculateArrowPoint, _abadi199$datetimepicker$AnalogTimePickerPanel$originPoint, length, angle);
		};
		var _p47 = _p48.currentAngle;
		if (_p47.ctor === 'Nothing') {
			return _elm_lang$html$Html$text('');
		} else {
			return shouldDrawArrow ? A4(
				_abadi199$datetimepicker$AnalogTimePickerPanel$drawArrow,
				onChange,
				_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p48),
				date,
				arrowPoint(_p47._0)) : _elm_lang$html$Html$text('');
		}
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$clock = F4(
	function (config, onChange, _p49, date) {
		var _p50 = _p49;
		var _p52 = _p50;
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$AnalogClock,
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$svg$Svg$svg,
					{
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$width('200'),
						_1: {
							ctor: '::',
							_0: _elm_lang$svg$Svg_Attributes$height('200'),
							_1: {
								ctor: '::',
								_0: _elm_lang$svg$Svg_Attributes$viewBox('0 0 200 200'),
								_1: {ctor: '[]'}
							}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$svg$Svg$circle,
							{
								ctor: '::',
								_0: _elm_lang$svg$Svg_Attributes$cx('100'),
								_1: {
									ctor: '::',
									_0: _elm_lang$svg$Svg_Attributes$cy('100'),
									_1: {
										ctor: '::',
										_0: _elm_lang$svg$Svg_Attributes$r('100'),
										_1: {
											ctor: '::',
											_0: _elm_lang$svg$Svg_Attributes$fill('#eee'),
											_1: {
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
													A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler, _p52, date, onChange)),
												_1: {
													ctor: '::',
													_0: _abadi199$datetimepicker$DateTimePicker_Events$onPointerUp(
														A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseDownHandler, _p52, date, onChange)),
													_1: {
														ctor: '::',
														_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseMoveWithPosition(
															A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseOverHandler, _p52, date, onChange)),
														_1: {
															ctor: '::',
															_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchMovePreventDefault(
																A2(onChange, _p52, date)),
															_1: {
																ctor: '::',
																_0: _abadi199$datetimepicker$DateTimePicker_Events$onPointerMoveWithPosition(
																	A3(_abadi199$datetimepicker$AnalogTimePickerPanel$mouseOverHandler, _p52, date, onChange)),
																_1: {ctor: '[]'}
															}
														}
													}
												}
											}
										}
									}
								}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: function () {
								var _p51 = _p50._0.activeTimeIndicator;
								if ((_p51.ctor === 'Just') && (_p51._0.ctor === 'MinuteIndicator')) {
									return A2(
										_elm_lang$svg$Svg$g,
										{ctor: '[]'},
										A2(
											_elm_lang$core$List$map,
											A3(_abadi199$datetimepicker$AnalogTimePickerPanel$clockFace, onChange, _p52, date),
											_elm_lang$core$Dict$toList(_abadi199$datetimepicker$DateTimePicker_ClockUtils$minutesPerFive)));
								} else {
									return A2(
										_elm_lang$svg$Svg$g,
										{ctor: '[]'},
										A2(
											_elm_lang$core$List$map,
											A3(_abadi199$datetimepicker$AnalogTimePickerPanel$clockFace, onChange, _p52, date),
											_elm_lang$core$Dict$toList(_abadi199$datetimepicker$DateTimePicker_ClockUtils$hours)));
								}
							}(),
							_1: {
								ctor: '::',
								_0: A3(_abadi199$datetimepicker$AnalogTimePickerPanel$arrow, onChange, _p52, date),
								_1: {
									ctor: '::',
									_0: A3(_abadi199$datetimepicker$AnalogTimePickerPanel$currentTime, onChange, _p52, date),
									_1: {ctor: '[]'}
								}
							}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _abadi199$datetimepicker$AnalogTimePickerPanel$view = F3(
	function (config, _p53, currentDate) {
		var _p54 = _p53;
		var _p61 = _p54._0;
		var _p60 = _p54;
		var amPmPicker = function (config) {
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: config.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$AMPMPicker,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
								A4(_abadi199$datetimepicker$AnalogTimePickerPanel$amPmPickerHandler, config, _p60, currentDate, 'AM')),
							_1: {
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
									A4(_abadi199$datetimepicker$AnalogTimePickerPanel$amPmPickerHandler, config, _p60, currentDate, 'AM')),
								_1: {
									ctor: '::',
									_0: function () {
										var _p55 = _p61.time.amPm;
										if ((_p55.ctor === 'Just') && (_p55._0 === 'AM')) {
											return config.$class(
												{
													ctor: '::',
													_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$AM,
													_1: {
														ctor: '::',
														_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedAmPm,
														_1: {ctor: '[]'}
													}
												});
										} else {
											return config.$class(
												{
													ctor: '::',
													_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$AM,
													_1: {ctor: '[]'}
												});
										}
									}(),
									_1: {ctor: '[]'}
								}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('AM'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
									A4(_abadi199$datetimepicker$AnalogTimePickerPanel$amPmPickerHandler, config, _p60, currentDate, 'PM')),
								_1: {
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
										A4(_abadi199$datetimepicker$AnalogTimePickerPanel$amPmPickerHandler, config, _p60, currentDate, 'PM')),
									_1: {
										ctor: '::',
										_0: function () {
											var _p56 = _p61.time.amPm;
											if ((_p56.ctor === 'Just') && (_p56._0 === 'PM')) {
												return config.$class(
													{
														ctor: '::',
														_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$PM,
														_1: {
															ctor: '::',
															_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedAmPm,
															_1: {ctor: '[]'}
														}
													});
											} else {
												return config.$class(
													{
														ctor: '::',
														_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$PM,
														_1: {ctor: '[]'}
													});
											}
										}(),
										_1: {ctor: '[]'}
									}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('PM'),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				});
		};
		var isActive = function (timeIndicator) {
			return _elm_lang$core$Native_Utils.eq(
				_p61.activeTimeIndicator,
				_elm_lang$core$Maybe$Just(timeIndicator)) ? {
				ctor: '::',
				_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Active,
				_1: {ctor: '[]'}
			} : {ctor: '[]'};
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$TimePickerDialog,
						_1: {
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$AnalogTime,
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: config.$class(
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Header,
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
									A4(_abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler, config, _p60, currentDate, _abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator)),
								_1: {
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
										A4(_abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler, config, _p60, currentDate, _abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator)),
									_1: {
										ctor: '::',
										_0: config.$class(
											{
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Hour,
												_1: isActive(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator)
											}),
										_1: {ctor: '[]'}
									}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									A2(
										_elm_lang$core$Maybe$withDefault,
										'--',
										A2(
											_elm_lang$core$Maybe$map,
											function (_p57) {
												return _abadi199$datetimepicker$DateTimePicker_DateUtils$padding(
													_elm_lang$core$Basics$toString(_p57));
											},
											_p61.time.hour))),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: config.$class(
										{
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Separator,
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(' : '),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$span,
									{
										ctor: '::',
										_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
											A4(_abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler, config, _p60, currentDate, _abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator)),
										_1: {
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
												A4(_abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler, config, _p60, currentDate, _abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator)),
											_1: {
												ctor: '::',
												_0: config.$class(
													{
														ctor: '::',
														_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Minute,
														_1: isActive(_abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator)
													}),
												_1: {ctor: '[]'}
											}
										}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(
											A2(
												_elm_lang$core$Maybe$withDefault,
												'--',
												A2(
													_elm_lang$core$Maybe$map,
													function (_p58) {
														return _abadi199$datetimepicker$DateTimePicker_DateUtils$padding(
															_elm_lang$core$Basics$toString(_p58));
													},
													_p61.time.minute))),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
												A4(_abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler, config, _p60, currentDate, _abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator)),
											_1: {
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
													A4(_abadi199$datetimepicker$AnalogTimePickerPanel$timeIndicatorHandler, config, _p60, currentDate, _abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator)),
												_1: {
													ctor: '::',
													_0: config.$class(
														{
															ctor: '::',
															_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$AMPM,
															_1: isActive(_abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator)
														}),
													_1: {ctor: '[]'}
												}
											}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												A2(_elm_lang$core$Maybe$withDefault, '--', _p61.time.amPm)),
											_1: {ctor: '[]'}
										}),
									_1: {ctor: '[]'}
								}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: config.$class(
								{
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Body,
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: function () {
								var _p59 = _p61.activeTimeIndicator;
								if ((_p59.ctor === 'Just') && (_p59._0.ctor === 'AMPMIndicator')) {
									return amPmPicker(config);
								} else {
									return A4(_abadi199$datetimepicker$AnalogTimePickerPanel$clock, config, config.onChange, _p60, currentDate);
								}
							}(),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});

var _abadi199$datetimepicker$DateTimePicker_Svg$doubleArrow = function (orientation) {
	var rotation = function () {
		var _p0 = orientation;
		if (_p0.ctor === 'DoubleRight') {
			return '0';
		} else {
			return '180';
		}
	}();
	return A2(
		_elm_lang$svg$Svg$svg,
		{
			ctor: '::',
			_0: _elm_lang$svg$Svg_Attributes$width('16'),
			_1: {
				ctor: '::',
				_0: _elm_lang$svg$Svg_Attributes$height('12'),
				_1: {
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$viewBox('0 0 32 16'),
					_1: {
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$style(
							A2(
								_elm_lang$core$Basics_ops['++'],
								'transform: rotate(',
								A2(_elm_lang$core$Basics_ops['++'], rotation, 'deg);'))),
						_1: {ctor: '[]'}
					}
				}
			}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$svg$Svg$polygon,
				{
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$points('0 0, 0 20, 16 10'),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$svg$Svg$polygon,
					{
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$points('16 0, 16 20, 32 10'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}
		});
};
var _abadi199$datetimepicker$DateTimePicker_Svg$arrow = function (orientation) {
	var rotation = function () {
		var _p1 = orientation;
		switch (_p1.ctor) {
			case 'Right':
				return '0';
			case 'Left':
				return '180';
			case 'Down':
				return '90';
			default:
				return '270';
		}
	}();
	return A2(
		_elm_lang$svg$Svg$svg,
		{
			ctor: '::',
			_0: _elm_lang$svg$Svg_Attributes$width('8'),
			_1: {
				ctor: '::',
				_0: _elm_lang$svg$Svg_Attributes$height('12'),
				_1: {
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$viewBox('0 0 16 16'),
					_1: {
						ctor: '::',
						_0: _elm_lang$svg$Svg_Attributes$style(
							A2(
								_elm_lang$core$Basics_ops['++'],
								'transform: rotate(',
								A2(_elm_lang$core$Basics_ops['++'], rotation, 'deg);'))),
						_1: {ctor: '[]'}
					}
				}
			}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$svg$Svg$polygon,
				{
					ctor: '::',
					_0: _elm_lang$svg$Svg_Attributes$points('0 0, 0 20, 16 10'),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'}),
			_1: {ctor: '[]'}
		});
};
var _abadi199$datetimepicker$DateTimePicker_Svg$Right = {ctor: 'Right'};
var _abadi199$datetimepicker$DateTimePicker_Svg$rightArrow = _abadi199$datetimepicker$DateTimePicker_Svg$arrow(_abadi199$datetimepicker$DateTimePicker_Svg$Right);
var _abadi199$datetimepicker$DateTimePicker_Svg$Left = {ctor: 'Left'};
var _abadi199$datetimepicker$DateTimePicker_Svg$leftArrow = _abadi199$datetimepicker$DateTimePicker_Svg$arrow(_abadi199$datetimepicker$DateTimePicker_Svg$Left);
var _abadi199$datetimepicker$DateTimePicker_Svg$Down = {ctor: 'Down'};
var _abadi199$datetimepicker$DateTimePicker_Svg$downArrow = _abadi199$datetimepicker$DateTimePicker_Svg$arrow(_abadi199$datetimepicker$DateTimePicker_Svg$Down);
var _abadi199$datetimepicker$DateTimePicker_Svg$Up = {ctor: 'Up'};
var _abadi199$datetimepicker$DateTimePicker_Svg$upArrow = _abadi199$datetimepicker$DateTimePicker_Svg$arrow(_abadi199$datetimepicker$DateTimePicker_Svg$Up);
var _abadi199$datetimepicker$DateTimePicker_Svg$DoubleRight = {ctor: 'DoubleRight'};
var _abadi199$datetimepicker$DateTimePicker_Svg$doubleRightArrow = _abadi199$datetimepicker$DateTimePicker_Svg$doubleArrow(_abadi199$datetimepicker$DateTimePicker_Svg$DoubleRight);
var _abadi199$datetimepicker$DateTimePicker_Svg$DoubleLeft = {ctor: 'DoubleLeft'};
var _abadi199$datetimepicker$DateTimePicker_Svg$doubleLeftArrow = _abadi199$datetimepicker$DateTimePicker_Svg$doubleArrow(_abadi199$datetimepicker$DateTimePicker_Svg$DoubleLeft);

var _elm_community$list_extra$List_Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var okayXs = _elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$List$length(xs),
			0) > 0;
		var okayArgs = (_elm_lang$core$Native_Utils.cmp(size, 0) > 0) && (_elm_lang$core$Native_Utils.cmp(step, 0) > 0);
		var xs_ = A2(_elm_lang$core$List$drop, step, xs);
		var group = A2(_elm_lang$core$List$take, size, xs);
		return (okayArgs && okayXs) ? {
			ctor: '::',
			_0: group,
			_1: A3(_elm_community$list_extra$List_Extra$greedyGroupsOfWithStep, size, step, xs_)
		} : {ctor: '[]'};
	});
var _elm_community$list_extra$List_Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3(_elm_community$list_extra$List_Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var _elm_community$list_extra$List_Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var okayArgs = (_elm_lang$core$Native_Utils.cmp(size, 0) > 0) && (_elm_lang$core$Native_Utils.cmp(step, 0) > 0);
		var xs_ = A2(_elm_lang$core$List$drop, step, xs);
		var group = A2(_elm_lang$core$List$take, size, xs);
		var okayLength = _elm_lang$core$Native_Utils.eq(
			size,
			_elm_lang$core$List$length(group));
		return (okayArgs && okayLength) ? {
			ctor: '::',
			_0: group,
			_1: A3(_elm_community$list_extra$List_Extra$groupsOfWithStep, size, step, xs_)
		} : {ctor: '[]'};
	});
var _elm_community$list_extra$List_Extra$groupsOf = F2(
	function (size, xs) {
		return A3(_elm_community$list_extra$List_Extra$groupsOfWithStep, size, size, xs);
	});
var _elm_community$list_extra$List_Extra$zip5 = _elm_lang$core$List$map5(
	F5(
		function (v0, v1, v2, v3, v4) {
			return {ctor: '_Tuple5', _0: v0, _1: v1, _2: v2, _3: v3, _4: v4};
		}));
var _elm_community$list_extra$List_Extra$zip4 = _elm_lang$core$List$map4(
	F4(
		function (v0, v1, v2, v3) {
			return {ctor: '_Tuple4', _0: v0, _1: v1, _2: v2, _3: v3};
		}));
var _elm_community$list_extra$List_Extra$zip3 = _elm_lang$core$List$map3(
	F3(
		function (v0, v1, v2) {
			return {ctor: '_Tuple3', _0: v0, _1: v1, _2: v2};
		}));
var _elm_community$list_extra$List_Extra$zip = _elm_lang$core$List$map2(
	F2(
		function (v0, v1) {
			return {ctor: '_Tuple2', _0: v0, _1: v1};
		}));
var _elm_community$list_extra$List_Extra$isPrefixOf = F2(
	function (prefix, xs) {
		var _p0 = {ctor: '_Tuple2', _0: prefix, _1: xs};
		if (_p0._0.ctor === '[]') {
			return true;
		} else {
			if (_p0._1.ctor === '[]') {
				return false;
			} else {
				return _elm_lang$core$Native_Utils.eq(_p0._0._0, _p0._1._0) && A2(_elm_community$list_extra$List_Extra$isPrefixOf, _p0._0._1, _p0._1._1);
			}
		}
	});
var _elm_community$list_extra$List_Extra$isSuffixOf = F2(
	function (suffix, xs) {
		return A2(
			_elm_community$list_extra$List_Extra$isPrefixOf,
			_elm_lang$core$List$reverse(suffix),
			_elm_lang$core$List$reverse(xs));
	});
var _elm_community$list_extra$List_Extra$selectSplit = function (xs) {
	var _p1 = xs;
	if (_p1.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		var _p5 = _p1._1;
		var _p4 = _p1._0;
		return {
			ctor: '::',
			_0: {
				ctor: '_Tuple3',
				_0: {ctor: '[]'},
				_1: _p4,
				_2: _p5
			},
			_1: A2(
				_elm_lang$core$List$map,
				function (_p2) {
					var _p3 = _p2;
					return {
						ctor: '_Tuple3',
						_0: {ctor: '::', _0: _p4, _1: _p3._0},
						_1: _p3._1,
						_2: _p3._2
					};
				},
				_elm_community$list_extra$List_Extra$selectSplit(_p5))
		};
	}
};
var _elm_community$list_extra$List_Extra$select = function (xs) {
	var _p6 = xs;
	if (_p6.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		var _p10 = _p6._1;
		var _p9 = _p6._0;
		return {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: _p9, _1: _p10},
			_1: A2(
				_elm_lang$core$List$map,
				function (_p7) {
					var _p8 = _p7;
					return {
						ctor: '_Tuple2',
						_0: _p8._0,
						_1: {ctor: '::', _0: _p9, _1: _p8._1}
					};
				},
				_elm_community$list_extra$List_Extra$select(_p10))
		};
	}
};
var _elm_community$list_extra$List_Extra$tailsHelp = F2(
	function (e, list) {
		var _p11 = list;
		if (_p11.ctor === '::') {
			var _p12 = _p11._0;
			return {
				ctor: '::',
				_0: {ctor: '::', _0: e, _1: _p12},
				_1: {ctor: '::', _0: _p12, _1: _p11._1}
			};
		} else {
			return {ctor: '[]'};
		}
	});
var _elm_community$list_extra$List_Extra$tails = A2(
	_elm_lang$core$List$foldr,
	_elm_community$list_extra$List_Extra$tailsHelp,
	{
		ctor: '::',
		_0: {ctor: '[]'},
		_1: {ctor: '[]'}
	});
var _elm_community$list_extra$List_Extra$isInfixOf = F2(
	function (infix, xs) {
		return A2(
			_elm_lang$core$List$any,
			_elm_community$list_extra$List_Extra$isPrefixOf(infix),
			_elm_community$list_extra$List_Extra$tails(xs));
	});
var _elm_community$list_extra$List_Extra$inits = A2(
	_elm_lang$core$List$foldr,
	F2(
		function (e, acc) {
			return {
				ctor: '::',
				_0: {ctor: '[]'},
				_1: A2(
					_elm_lang$core$List$map,
					F2(
						function (x, y) {
							return {ctor: '::', _0: x, _1: y};
						})(e),
					acc)
			};
		}),
	{
		ctor: '::',
		_0: {ctor: '[]'},
		_1: {ctor: '[]'}
	});
var _elm_community$list_extra$List_Extra$groupWhileTransitively = F2(
	function (cmp, xs_) {
		var _p13 = xs_;
		if (_p13.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if (_p13._1.ctor === '[]') {
				return {
					ctor: '::',
					_0: {
						ctor: '::',
						_0: _p13._0,
						_1: {ctor: '[]'}
					},
					_1: {ctor: '[]'}
				};
			} else {
				var _p15 = _p13._0;
				var _p14 = A2(_elm_community$list_extra$List_Extra$groupWhileTransitively, cmp, _p13._1);
				if (_p14.ctor === '::') {
					return A2(cmp, _p15, _p13._1._0) ? {
						ctor: '::',
						_0: {ctor: '::', _0: _p15, _1: _p14._0},
						_1: _p14._1
					} : {
						ctor: '::',
						_0: {
							ctor: '::',
							_0: _p15,
							_1: {ctor: '[]'}
						},
						_1: _p14
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$stripPrefix = F2(
	function (prefix, xs) {
		var step = F2(
			function (e, m) {
				var _p16 = m;
				if (_p16.ctor === 'Nothing') {
					return _elm_lang$core$Maybe$Nothing;
				} else {
					if (_p16._0.ctor === '[]') {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						return _elm_lang$core$Native_Utils.eq(e, _p16._0._0) ? _elm_lang$core$Maybe$Just(_p16._0._1) : _elm_lang$core$Maybe$Nothing;
					}
				}
			});
		return A3(
			_elm_lang$core$List$foldl,
			step,
			_elm_lang$core$Maybe$Just(xs),
			prefix);
	});
var _elm_community$list_extra$List_Extra$dropWhileRight = function (p) {
	return A2(
		_elm_lang$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && _elm_lang$core$List$isEmpty(xs)) ? {ctor: '[]'} : {ctor: '::', _0: x, _1: xs};
			}),
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$takeWhileRight = function (p) {
	var step = F2(
		function (x, _p17) {
			var _p18 = _p17;
			var _p19 = _p18._0;
			return (p(x) && _p18._1) ? {
				ctor: '_Tuple2',
				_0: {ctor: '::', _0: x, _1: _p19},
				_1: true
			} : {ctor: '_Tuple2', _0: _p19, _1: false};
		});
	return function (_p20) {
		return _elm_lang$core$Tuple$first(
			A3(
				_elm_lang$core$List$foldr,
				step,
				{
					ctor: '_Tuple2',
					_0: {ctor: '[]'},
					_1: true
				},
				_p20));
	};
};
var _elm_community$list_extra$List_Extra$splitAt = F2(
	function (n, xs) {
		return {
			ctor: '_Tuple2',
			_0: A2(_elm_lang$core$List$take, n, xs),
			_1: A2(_elm_lang$core$List$drop, n, xs)
		};
	});
var _elm_community$list_extra$List_Extra$groupsOfVarying_ = F3(
	function (listOflengths, list, accu) {
		groupsOfVarying_:
		while (true) {
			var _p21 = {ctor: '_Tuple2', _0: listOflengths, _1: list};
			if (((_p21.ctor === '_Tuple2') && (_p21._0.ctor === '::')) && (_p21._1.ctor === '::')) {
				var _p22 = A2(_elm_community$list_extra$List_Extra$splitAt, _p21._0._0, list);
				var head = _p22._0;
				var tail = _p22._1;
				var _v11 = _p21._0._1,
					_v12 = tail,
					_v13 = {ctor: '::', _0: head, _1: accu};
				listOflengths = _v11;
				list = _v12;
				accu = _v13;
				continue groupsOfVarying_;
			} else {
				return _elm_lang$core$List$reverse(accu);
			}
		}
	});
var _elm_community$list_extra$List_Extra$groupsOfVarying = F2(
	function (listOflengths, list) {
		return A3(
			_elm_community$list_extra$List_Extra$groupsOfVarying_,
			listOflengths,
			list,
			{ctor: '[]'});
	});
var _elm_community$list_extra$List_Extra$unfoldr = F2(
	function (f, seed) {
		var _p23 = f(seed);
		if (_p23.ctor === 'Nothing') {
			return {ctor: '[]'};
		} else {
			return {
				ctor: '::',
				_0: _p23._0._0,
				_1: A2(_elm_community$list_extra$List_Extra$unfoldr, f, _p23._0._1)
			};
		}
	});
var _elm_community$list_extra$List_Extra$scanr1 = F2(
	function (f, xs_) {
		var _p24 = xs_;
		if (_p24.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if (_p24._1.ctor === '[]') {
				return {
					ctor: '::',
					_0: _p24._0,
					_1: {ctor: '[]'}
				};
			} else {
				var _p25 = A2(_elm_community$list_extra$List_Extra$scanr1, f, _p24._1);
				if (_p25.ctor === '::') {
					return {
						ctor: '::',
						_0: A2(f, _p24._0, _p25._0),
						_1: _p25
					};
				} else {
					return {ctor: '[]'};
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$scanr = F3(
	function (f, acc, xs_) {
		var _p26 = xs_;
		if (_p26.ctor === '[]') {
			return {
				ctor: '::',
				_0: acc,
				_1: {ctor: '[]'}
			};
		} else {
			var _p27 = A3(_elm_community$list_extra$List_Extra$scanr, f, acc, _p26._1);
			if (_p27.ctor === '::') {
				return {
					ctor: '::',
					_0: A2(f, _p26._0, _p27._0),
					_1: _p27
				};
			} else {
				return {ctor: '[]'};
			}
		}
	});
var _elm_community$list_extra$List_Extra$scanl1 = F2(
	function (f, xs_) {
		var _p28 = xs_;
		if (_p28.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			return A3(_elm_lang$core$List$scanl, f, _p28._0, _p28._1);
		}
	});
var _elm_community$list_extra$List_Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _p29) {
				var _p30 = _p29;
				var _p31 = _p30._0;
				return {
					ctor: '_Tuple2',
					_0: _p31 - 1,
					_1: A3(func, _p31, x, _p30._1)
				};
			});
		return _elm_lang$core$Tuple$second(
			A3(
				_elm_lang$core$List$foldr,
				step,
				{
					ctor: '_Tuple2',
					_0: _elm_lang$core$List$length(list) - 1,
					_1: acc
				},
				list));
	});
var _elm_community$list_extra$List_Extra$indexedFoldl = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _p32) {
				var _p33 = _p32;
				var _p34 = _p33._0;
				return {
					ctor: '_Tuple2',
					_0: _p34 + 1,
					_1: A3(func, _p34, x, _p33._1)
				};
			});
		return _elm_lang$core$Tuple$second(
			A3(
				_elm_lang$core$List$foldl,
				step,
				{ctor: '_Tuple2', _0: 0, _1: acc},
				list));
	});
var _elm_community$list_extra$List_Extra$foldr1 = F2(
	function (f, xs) {
		var mf = F2(
			function (x, m) {
				return _elm_lang$core$Maybe$Just(
					function () {
						var _p35 = m;
						if (_p35.ctor === 'Nothing') {
							return x;
						} else {
							return A2(f, x, _p35._0);
						}
					}());
			});
		return A3(_elm_lang$core$List$foldr, mf, _elm_lang$core$Maybe$Nothing, xs);
	});
var _elm_community$list_extra$List_Extra$foldl1 = F2(
	function (f, xs) {
		var mf = F2(
			function (x, m) {
				return _elm_lang$core$Maybe$Just(
					function () {
						var _p36 = m;
						if (_p36.ctor === 'Nothing') {
							return x;
						} else {
							return A2(f, _p36._0, x);
						}
					}());
			});
		return A3(_elm_lang$core$List$foldl, mf, _elm_lang$core$Maybe$Nothing, xs);
	});
var _elm_community$list_extra$List_Extra$interweaveHelp = F3(
	function (l1, l2, acc) {
		interweaveHelp:
		while (true) {
			var _p37 = {ctor: '_Tuple2', _0: l1, _1: l2};
			_v24_1:
			do {
				if (_p37._0.ctor === '::') {
					if (_p37._1.ctor === '::') {
						var _v25 = _p37._0._1,
							_v26 = _p37._1._1,
							_v27 = A2(
							_elm_lang$core$Basics_ops['++'],
							acc,
							{
								ctor: '::',
								_0: _p37._0._0,
								_1: {
									ctor: '::',
									_0: _p37._1._0,
									_1: {ctor: '[]'}
								}
							});
						l1 = _v25;
						l2 = _v26;
						acc = _v27;
						continue interweaveHelp;
					} else {
						break _v24_1;
					}
				} else {
					if (_p37._1.ctor === '[]') {
						break _v24_1;
					} else {
						return A2(_elm_lang$core$Basics_ops['++'], acc, _p37._1);
					}
				}
			} while(false);
			return A2(_elm_lang$core$Basics_ops['++'], acc, _p37._0);
		}
	});
var _elm_community$list_extra$List_Extra$interweave = F2(
	function (l1, l2) {
		return A3(
			_elm_community$list_extra$List_Extra$interweaveHelp,
			l1,
			l2,
			{ctor: '[]'});
	});
var _elm_community$list_extra$List_Extra$permutations = function (xs_) {
	var _p38 = xs_;
	if (_p38.ctor === '[]') {
		return {
			ctor: '::',
			_0: {ctor: '[]'},
			_1: {ctor: '[]'}
		};
	} else {
		var f = function (_p39) {
			var _p40 = _p39;
			return A2(
				_elm_lang$core$List$map,
				F2(
					function (x, y) {
						return {ctor: '::', _0: x, _1: y};
					})(_p40._0),
				_elm_community$list_extra$List_Extra$permutations(_p40._1));
		};
		return A2(
			_elm_lang$core$List$concatMap,
			f,
			_elm_community$list_extra$List_Extra$select(_p38));
	}
};
var _elm_community$list_extra$List_Extra$isPermutationOf = F2(
	function (permut, xs) {
		return A2(
			_elm_lang$core$List$member,
			permut,
			_elm_community$list_extra$List_Extra$permutations(xs));
	});
var _elm_community$list_extra$List_Extra$subsequencesNonEmpty = function (xs) {
	var _p41 = xs;
	if (_p41.ctor === '[]') {
		return {ctor: '[]'};
	} else {
		var _p42 = _p41._0;
		var f = F2(
			function (ys, r) {
				return {
					ctor: '::',
					_0: ys,
					_1: {
						ctor: '::',
						_0: {ctor: '::', _0: _p42, _1: ys},
						_1: r
					}
				};
			});
		return {
			ctor: '::',
			_0: {
				ctor: '::',
				_0: _p42,
				_1: {ctor: '[]'}
			},
			_1: A3(
				_elm_lang$core$List$foldr,
				f,
				{ctor: '[]'},
				_elm_community$list_extra$List_Extra$subsequencesNonEmpty(_p41._1))
		};
	}
};
var _elm_community$list_extra$List_Extra$subsequences = function (xs) {
	return {
		ctor: '::',
		_0: {ctor: '[]'},
		_1: _elm_community$list_extra$List_Extra$subsequencesNonEmpty(xs)
	};
};
var _elm_community$list_extra$List_Extra$isSubsequenceOf = F2(
	function (subseq, xs) {
		return A2(
			_elm_lang$core$List$member,
			subseq,
			_elm_community$list_extra$List_Extra$subsequences(xs));
	});
var _elm_community$list_extra$List_Extra$transpose = function (ll) {
	transpose:
	while (true) {
		var _p43 = ll;
		if (_p43.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			if (_p43._0.ctor === '[]') {
				var _v32 = _p43._1;
				ll = _v32;
				continue transpose;
			} else {
				var _p44 = _p43._1;
				var tails = A2(_elm_lang$core$List$filterMap, _elm_lang$core$List$tail, _p44);
				var heads = A2(_elm_lang$core$List$filterMap, _elm_lang$core$List$head, _p44);
				return {
					ctor: '::',
					_0: {ctor: '::', _0: _p43._0._0, _1: heads},
					_1: _elm_community$list_extra$List_Extra$transpose(
						{ctor: '::', _0: _p43._0._1, _1: tails})
				};
			}
		}
	}
};
var _elm_community$list_extra$List_Extra$intercalate = function (xs) {
	return function (_p45) {
		return _elm_lang$core$List$concat(
			A2(_elm_lang$core$List$intersperse, xs, _p45));
	};
};
var _elm_community$list_extra$List_Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			_elm_lang$core$List$filter,
			function (_p46) {
				return !pred(_p46);
			},
			list);
	});
var _elm_community$list_extra$List_Extra$removeAt = F2(
	function (index, l) {
		if (_elm_lang$core$Native_Utils.cmp(index, 0) < 0) {
			return l;
		} else {
			var tail = _elm_lang$core$List$tail(
				A2(_elm_lang$core$List$drop, index, l));
			var head = A2(_elm_lang$core$List$take, index, l);
			var _p47 = tail;
			if (_p47.ctor === 'Nothing') {
				return l;
			} else {
				return A2(_elm_lang$core$List$append, head, _p47._0);
			}
		}
	});
var _elm_community$list_extra$List_Extra$stableSortWith = F2(
	function (pred, list) {
		var predWithIndex = F2(
			function (_p49, _p48) {
				var _p50 = _p49;
				var _p51 = _p48;
				var result = A2(pred, _p50._0, _p51._0);
				var _p52 = result;
				if (_p52.ctor === 'EQ') {
					return A2(_elm_lang$core$Basics$compare, _p50._1, _p51._1);
				} else {
					return result;
				}
			});
		var listWithIndex = A2(
			_elm_lang$core$List$indexedMap,
			F2(
				function (i, a) {
					return {ctor: '_Tuple2', _0: a, _1: i};
				}),
			list);
		return A2(
			_elm_lang$core$List$map,
			_elm_lang$core$Tuple$first,
			A2(_elm_lang$core$List$sortWith, predWithIndex, listWithIndex));
	});
var _elm_community$list_extra$List_Extra$setAt = F3(
	function (index, value, l) {
		if (_elm_lang$core$Native_Utils.cmp(index, 0) < 0) {
			return _elm_lang$core$Maybe$Nothing;
		} else {
			var tail = _elm_lang$core$List$tail(
				A2(_elm_lang$core$List$drop, index, l));
			var head = A2(_elm_lang$core$List$take, index, l);
			var _p53 = tail;
			if (_p53.ctor === 'Nothing') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				return _elm_lang$core$Maybe$Just(
					A2(
						_elm_lang$core$List$append,
						head,
						{ctor: '::', _0: value, _1: _p53._0}));
			}
		}
	});
var _elm_community$list_extra$List_Extra$remove = F2(
	function (x, xs) {
		var _p54 = xs;
		if (_p54.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var _p56 = _p54._1;
			var _p55 = _p54._0;
			return _elm_lang$core$Native_Utils.eq(x, _p55) ? _p56 : {
				ctor: '::',
				_0: _p55,
				_1: A2(_elm_community$list_extra$List_Extra$remove, x, _p56)
			};
		}
	});
var _elm_community$list_extra$List_Extra$updateIfIndex = F3(
	function (predicate, update, list) {
		return A2(
			_elm_lang$core$List$indexedMap,
			F2(
				function (i, x) {
					return predicate(i) ? update(x) : x;
				}),
			list);
	});
var _elm_community$list_extra$List_Extra$updateAt = F3(
	function (index, update, list) {
		return ((_elm_lang$core$Native_Utils.cmp(index, 0) < 0) || (_elm_lang$core$Native_Utils.cmp(
			index,
			_elm_lang$core$List$length(list)) > -1)) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(
			A3(
				_elm_community$list_extra$List_Extra$updateIfIndex,
				F2(
					function (x, y) {
						return _elm_lang$core$Native_Utils.eq(x, y);
					})(index),
				update,
				list));
	});
var _elm_community$list_extra$List_Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			_elm_lang$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var _elm_community$list_extra$List_Extra$replaceIf = F3(
	function (predicate, replacement, list) {
		return A3(
			_elm_community$list_extra$List_Extra$updateIf,
			predicate,
			_elm_lang$core$Basics$always(replacement),
			list);
	});
var _elm_community$list_extra$List_Extra$findIndices = function (p) {
	return function (_p57) {
		return A2(
			_elm_lang$core$List$map,
			_elm_lang$core$Tuple$first,
			A2(
				_elm_lang$core$List$filter,
				function (_p58) {
					var _p59 = _p58;
					return p(_p59._1);
				},
				A2(
					_elm_lang$core$List$indexedMap,
					F2(
						function (v0, v1) {
							return {ctor: '_Tuple2', _0: v0, _1: v1};
						}),
					_p57)));
	};
};
var _elm_community$list_extra$List_Extra$findIndex = function (p) {
	return function (_p60) {
		return _elm_lang$core$List$head(
			A2(_elm_community$list_extra$List_Extra$findIndices, p, _p60));
	};
};
var _elm_community$list_extra$List_Extra$splitWhen = F2(
	function (predicate, list) {
		return A2(
			_elm_lang$core$Maybe$map,
			function (i) {
				return A2(_elm_community$list_extra$List_Extra$splitAt, i, list);
			},
			A2(_elm_community$list_extra$List_Extra$findIndex, predicate, list));
	});
var _elm_community$list_extra$List_Extra$elemIndices = function (x) {
	return _elm_community$list_extra$List_Extra$findIndices(
		F2(
			function (x, y) {
				return _elm_lang$core$Native_Utils.eq(x, y);
			})(x));
};
var _elm_community$list_extra$List_Extra$elemIndex = function (x) {
	return _elm_community$list_extra$List_Extra$findIndex(
		F2(
			function (x, y) {
				return _elm_lang$core$Native_Utils.eq(x, y);
			})(x));
};
var _elm_community$list_extra$List_Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			var _p61 = list;
			if (_p61.ctor === '[]') {
				return _elm_lang$core$Maybe$Nothing;
			} else {
				var _p62 = _p61._0;
				if (predicate(_p62)) {
					return _elm_lang$core$Maybe$Just(_p62);
				} else {
					var _v41 = predicate,
						_v42 = _p61._1;
					predicate = _v41;
					list = _v42;
					continue find;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$notMember = function (x) {
	return function (_p63) {
		return !A2(_elm_lang$core$List$member, x, _p63);
	};
};
var _elm_community$list_extra$List_Extra$andThen = _elm_lang$core$List$concatMap;
var _elm_community$list_extra$List_Extra$lift2 = F3(
	function (f, la, lb) {
		return A2(
			_elm_community$list_extra$List_Extra$andThen,
			function (a) {
				return A2(
					_elm_community$list_extra$List_Extra$andThen,
					function (b) {
						return {
							ctor: '::',
							_0: A2(f, a, b),
							_1: {ctor: '[]'}
						};
					},
					lb);
			},
			la);
	});
var _elm_community$list_extra$List_Extra$lift3 = F4(
	function (f, la, lb, lc) {
		return A2(
			_elm_community$list_extra$List_Extra$andThen,
			function (a) {
				return A2(
					_elm_community$list_extra$List_Extra$andThen,
					function (b) {
						return A2(
							_elm_community$list_extra$List_Extra$andThen,
							function (c) {
								return {
									ctor: '::',
									_0: A3(f, a, b, c),
									_1: {ctor: '[]'}
								};
							},
							lc);
					},
					lb);
			},
			la);
	});
var _elm_community$list_extra$List_Extra$lift4 = F5(
	function (f, la, lb, lc, ld) {
		return A2(
			_elm_community$list_extra$List_Extra$andThen,
			function (a) {
				return A2(
					_elm_community$list_extra$List_Extra$andThen,
					function (b) {
						return A2(
							_elm_community$list_extra$List_Extra$andThen,
							function (c) {
								return A2(
									_elm_community$list_extra$List_Extra$andThen,
									function (d) {
										return {
											ctor: '::',
											_0: A4(f, a, b, c, d),
											_1: {ctor: '[]'}
										};
									},
									ld);
							},
							lc);
					},
					lb);
			},
			la);
	});
var _elm_community$list_extra$List_Extra$andMap = F2(
	function (l, fl) {
		return A3(
			_elm_lang$core$List$map2,
			F2(
				function (x, y) {
					return x(y);
				}),
			fl,
			l);
	});
var _elm_community$list_extra$List_Extra$uniqueHelp = F3(
	function (f, existing, remaining) {
		uniqueHelp:
		while (true) {
			var _p64 = remaining;
			if (_p64.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				var _p66 = _p64._1;
				var _p65 = _p64._0;
				var computedFirst = f(_p65);
				if (A2(_elm_lang$core$Set$member, computedFirst, existing)) {
					var _v44 = f,
						_v45 = existing,
						_v46 = _p66;
					f = _v44;
					existing = _v45;
					remaining = _v46;
					continue uniqueHelp;
				} else {
					return {
						ctor: '::',
						_0: _p65,
						_1: A3(
							_elm_community$list_extra$List_Extra$uniqueHelp,
							f,
							A2(_elm_lang$core$Set$insert, computedFirst, existing),
							_p66)
					};
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$uniqueBy = F2(
	function (f, list) {
		return A3(_elm_community$list_extra$List_Extra$uniqueHelp, f, _elm_lang$core$Set$empty, list);
	});
var _elm_community$list_extra$List_Extra$allDifferentBy = F2(
	function (f, list) {
		return _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$List$length(list),
			_elm_lang$core$List$length(
				A2(_elm_community$list_extra$List_Extra$uniqueBy, f, list)));
	});
var _elm_community$list_extra$List_Extra$allDifferent = function (list) {
	return A2(_elm_community$list_extra$List_Extra$allDifferentBy, _elm_lang$core$Basics$identity, list);
};
var _elm_community$list_extra$List_Extra$unique = function (list) {
	return A3(_elm_community$list_extra$List_Extra$uniqueHelp, _elm_lang$core$Basics$identity, _elm_lang$core$Set$empty, list);
};
var _elm_community$list_extra$List_Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			var _p67 = list;
			if (_p67.ctor === '[]') {
				return {ctor: '[]'};
			} else {
				if (predicate(_p67._0)) {
					var _v48 = predicate,
						_v49 = _p67._1;
					predicate = _v48;
					list = _v49;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				var _p68 = list;
				if (_p68.ctor === '[]') {
					return _elm_lang$core$List$reverse(memo);
				} else {
					var _p69 = _p68._0;
					if (predicate(_p69)) {
						var _v51 = {ctor: '::', _0: _p69, _1: memo},
							_v52 = _p68._1;
						memo = _v51;
						list = _v52;
						continue takeWhileMemo;
					} else {
						return _elm_lang$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(
		{ctor: '[]'});
};
var _elm_community$list_extra$List_Extra$span = F2(
	function (p, xs) {
		return {
			ctor: '_Tuple2',
			_0: A2(_elm_community$list_extra$List_Extra$takeWhile, p, xs),
			_1: A2(_elm_community$list_extra$List_Extra$dropWhile, p, xs)
		};
	});
var _elm_community$list_extra$List_Extra$break = function (p) {
	return _elm_community$list_extra$List_Extra$span(
		function (_p70) {
			return !p(_p70);
		});
};
var _elm_community$list_extra$List_Extra$groupWhile = F2(
	function (eq, xs_) {
		var _p71 = xs_;
		if (_p71.ctor === '[]') {
			return {ctor: '[]'};
		} else {
			var _p73 = _p71._0;
			var _p72 = A2(
				_elm_community$list_extra$List_Extra$span,
				eq(_p73),
				_p71._1);
			var ys = _p72._0;
			var zs = _p72._1;
			return {
				ctor: '::',
				_0: {ctor: '::', _0: _p73, _1: ys},
				_1: A2(_elm_community$list_extra$List_Extra$groupWhile, eq, zs)
			};
		}
	});
var _elm_community$list_extra$List_Extra$group = _elm_community$list_extra$List_Extra$groupWhile(
	F2(
		function (x, y) {
			return _elm_lang$core$Native_Utils.eq(x, y);
		}));
var _elm_community$list_extra$List_Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, _p74) {
				var _p75 = _p74;
				var _p76 = _p75._1;
				var fx = f(x);
				return (_elm_lang$core$Native_Utils.cmp(fx, _p76) < 0) ? {ctor: '_Tuple2', _0: x, _1: fx} : {ctor: '_Tuple2', _0: _p75._0, _1: _p76};
			});
		var _p77 = ls;
		if (_p77.ctor === '::') {
			if (_p77._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p77._0);
			} else {
				var _p78 = _p77._0;
				return _elm_lang$core$Maybe$Just(
					_elm_lang$core$Tuple$first(
						A3(
							_elm_lang$core$List$foldl,
							minBy,
							{
								ctor: '_Tuple2',
								_0: _p78,
								_1: f(_p78)
							},
							_p77._1)));
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_community$list_extra$List_Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _p79) {
				var _p80 = _p79;
				var _p81 = _p80._1;
				var fx = f(x);
				return (_elm_lang$core$Native_Utils.cmp(fx, _p81) > 0) ? {ctor: '_Tuple2', _0: x, _1: fx} : {ctor: '_Tuple2', _0: _p80._0, _1: _p81};
			});
		var _p82 = ls;
		if (_p82.ctor === '::') {
			if (_p82._1.ctor === '[]') {
				return _elm_lang$core$Maybe$Just(_p82._0);
			} else {
				var _p83 = _p82._0;
				return _elm_lang$core$Maybe$Just(
					_elm_lang$core$Tuple$first(
						A3(
							_elm_lang$core$List$foldl,
							maxBy,
							{
								ctor: '_Tuple2',
								_0: _p83,
								_1: f(_p83)
							},
							_p82._1)));
			}
		} else {
			return _elm_lang$core$Maybe$Nothing;
		}
	});
var _elm_community$list_extra$List_Extra$uncons = function (xs) {
	var _p84 = xs;
	if (_p84.ctor === '[]') {
		return _elm_lang$core$Maybe$Nothing;
	} else {
		return _elm_lang$core$Maybe$Just(
			{ctor: '_Tuple2', _0: _p84._0, _1: _p84._1});
	}
};
var _elm_community$list_extra$List_Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_elm_lang$core$Native_Utils.eq(index1, index2)) {
				return _elm_lang$core$Maybe$Just(l);
			} else {
				if (_elm_lang$core$Native_Utils.cmp(index1, index2) > 0) {
					var _v59 = index2,
						_v60 = index1,
						_v61 = l;
					index1 = _v59;
					index2 = _v60;
					l = _v61;
					continue swapAt;
				} else {
					if (_elm_lang$core$Native_Utils.cmp(index1, 0) < 0) {
						return _elm_lang$core$Maybe$Nothing;
					} else {
						var _p85 = A2(_elm_community$list_extra$List_Extra$splitAt, index1, l);
						var part1 = _p85._0;
						var tail1 = _p85._1;
						var _p86 = A2(_elm_community$list_extra$List_Extra$splitAt, index2 - index1, tail1);
						var head2 = _p86._0;
						var tail2 = _p86._1;
						return A3(
							_elm_lang$core$Maybe$map2,
							F2(
								function (_p88, _p87) {
									var _p89 = _p88;
									var _p90 = _p87;
									return _elm_lang$core$List$concat(
										{
											ctor: '::',
											_0: part1,
											_1: {
												ctor: '::',
												_0: {ctor: '::', _0: _p90._0, _1: _p89._1},
												_1: {
													ctor: '::',
													_0: {ctor: '::', _0: _p89._0, _1: _p90._1},
													_1: {ctor: '[]'}
												}
											}
										});
								}),
							_elm_community$list_extra$List_Extra$uncons(head2),
							_elm_community$list_extra$List_Extra$uncons(tail2));
					}
				}
			}
		}
	});
var _elm_community$list_extra$List_Extra$iterate = F2(
	function (f, x) {
		var _p91 = f(x);
		if (_p91.ctor === 'Just') {
			return {
				ctor: '::',
				_0: x,
				_1: A2(_elm_community$list_extra$List_Extra$iterate, f, _p91._0)
			};
		} else {
			return {
				ctor: '::',
				_0: x,
				_1: {ctor: '[]'}
			};
		}
	});
var _elm_community$list_extra$List_Extra$getAt = F2(
	function (idx, xs) {
		return (_elm_lang$core$Native_Utils.cmp(idx, 0) < 0) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$List$head(
			A2(_elm_lang$core$List$drop, idx, xs));
	});
var _elm_community$list_extra$List_Extra_ops = _elm_community$list_extra$List_Extra_ops || {};
_elm_community$list_extra$List_Extra_ops['!!'] = _elm_lang$core$Basics$flip(_elm_community$list_extra$List_Extra$getAt);
var _elm_community$list_extra$List_Extra$init = function () {
	var maybe = F2(
		function (d, f) {
			return function (_p92) {
				return A2(
					_elm_lang$core$Maybe$withDefault,
					d,
					A2(_elm_lang$core$Maybe$map, f, _p92));
			};
		});
	return A2(
		_elm_lang$core$List$foldr,
		function (x) {
			return function (_p93) {
				return _elm_lang$core$Maybe$Just(
					A3(
						maybe,
						{ctor: '[]'},
						F2(
							function (x, y) {
								return {ctor: '::', _0: x, _1: y};
							})(x),
						_p93));
			};
		},
		_elm_lang$core$Maybe$Nothing);
}();
var _elm_community$list_extra$List_Extra$last = _elm_community$list_extra$List_Extra$foldl1(
	_elm_lang$core$Basics$flip(_elm_lang$core$Basics$always));

var _abadi199$datetimepicker$DatePickerPanel$dayNames = function (config) {
	var shiftAmount = A2(_abadi199$datetimepicker$DateTimePicker_DateUtils$dayToInt, _elm_lang$core$Date$Sun, config.firstDayOfWeek);
	var days = {
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$th,
			{ctor: '[]'},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(config.nameOfDays.sunday),
				_1: {ctor: '[]'}
			}),
		_1: {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$th,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(config.nameOfDays.monday),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$th,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(config.nameOfDays.tuesday),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$th,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(config.nameOfDays.wednesday),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$th,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(config.nameOfDays.thursday),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$th,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(config.nameOfDays.friday),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$th,
									{ctor: '[]'},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text(config.nameOfDays.saturday),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}
				}
			}
		}
	};
	return function (_p0) {
		var _p1 = _p0;
		return A2(_elm_lang$core$Basics_ops['++'], _p1._1, _p1._0);
	}(
		A2(_elm_community$list_extra$List_Extra$splitAt, shiftAmount, days));
};
var _abadi199$datetimepicker$DatePickerPanel$noYearNavigationClass = function (config) {
	return config.allowYearNavigation ? {ctor: '[]'} : {
		ctor: '::',
		_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$NoYearNavigation,
		_1: {ctor: '[]'}
	};
};
var _abadi199$datetimepicker$DatePickerPanel$gotoPreviousYear = function (_p2) {
	var _p3 = _p2;
	var _p4 = _p3._0;
	var updatedTitleDate = A2(
		_elm_lang$core$Maybe$map,
		A2(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Year, -1),
		_p4.titleDate);
	return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
		_elm_lang$core$Native_Utils.update(
			_p4,
			{event: 'previousYear', titleDate: updatedTitleDate}));
};
var _abadi199$datetimepicker$DatePickerPanel$previousYearButton = F3(
	function (config, state, currentDate) {
		return config.allowYearNavigation ? A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DoubleArrowLeft,
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A2(
							config.onChange,
							_abadi199$datetimepicker$DatePickerPanel$gotoPreviousYear(state),
							currentDate)),
					_1: {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
							A2(
								config.onChange,
								_abadi199$datetimepicker$DatePickerPanel$gotoPreviousYear(state),
								currentDate)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _abadi199$datetimepicker$DateTimePicker_Svg$doubleLeftArrow,
				_1: {ctor: '[]'}
			}) : _elm_lang$html$Html$text('');
	});
var _abadi199$datetimepicker$DatePickerPanel$gotoPreviousMonth = function (_p5) {
	var _p6 = _p5;
	var _p7 = _p6._0;
	var updatedTitleDate = A2(
		_elm_lang$core$Maybe$map,
		A2(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Month, -1),
		_p7.titleDate);
	return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
		_elm_lang$core$Native_Utils.update(
			_p7,
			{event: 'previous', titleDate: updatedTitleDate}));
};
var _abadi199$datetimepicker$DatePickerPanel$previousButton = F3(
	function (config, state, currentDate) {
		return A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowLeft,
						_1: _abadi199$datetimepicker$DatePickerPanel$noYearNavigationClass(config)
					}),
				_1: {
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A2(
							config.onChange,
							_abadi199$datetimepicker$DatePickerPanel$gotoPreviousMonth(state),
							currentDate)),
					_1: {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
							A2(
								config.onChange,
								_abadi199$datetimepicker$DatePickerPanel$gotoPreviousMonth(state),
								currentDate)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _abadi199$datetimepicker$DateTimePicker_Svg$leftArrow,
				_1: {ctor: '[]'}
			});
	});
var _abadi199$datetimepicker$DatePickerPanel$gotoNextYear = function (_p8) {
	var _p9 = _p8;
	var _p10 = _p9._0;
	var updatedTitleDate = A2(
		_elm_lang$core$Maybe$map,
		A2(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Year, 1),
		_p10.titleDate);
	return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
		_elm_lang$core$Native_Utils.update(
			_p10,
			{event: 'nextYear', titleDate: updatedTitleDate}));
};
var _abadi199$datetimepicker$DatePickerPanel$nextYearButton = F3(
	function (config, state, currentDate) {
		return config.allowYearNavigation ? A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DoubleArrowRight,
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A2(
							config.onChange,
							_abadi199$datetimepicker$DatePickerPanel$gotoNextYear(state),
							currentDate)),
					_1: {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
							A2(
								config.onChange,
								_abadi199$datetimepicker$DatePickerPanel$gotoNextYear(state),
								currentDate)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _abadi199$datetimepicker$DateTimePicker_Svg$doubleRightArrow,
				_1: {ctor: '[]'}
			}) : _elm_lang$html$Html$text('');
	});
var _abadi199$datetimepicker$DatePickerPanel$gotoNextMonth = function (_p11) {
	var _p12 = _p11;
	var _p13 = _p12._0;
	var updatedTitleDate = A2(
		_elm_lang$core$Maybe$map,
		A2(_rluiten$elm_date_extra$Date_Extra_Duration$add, _rluiten$elm_date_extra$Date_Extra_Duration$Month, 1),
		_p13.titleDate);
	return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
		_elm_lang$core$Native_Utils.update(
			_p13,
			{event: 'next', titleDate: updatedTitleDate}));
};
var _abadi199$datetimepicker$DatePickerPanel$nextButton = F3(
	function (config, state, currentDate) {
		return A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowRight,
						_1: _abadi199$datetimepicker$DatePickerPanel$noYearNavigationClass(config)
					}),
				_1: {
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A2(
							config.onChange,
							_abadi199$datetimepicker$DatePickerPanel$gotoNextMonth(state),
							currentDate)),
					_1: {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
							A2(
								config.onChange,
								_abadi199$datetimepicker$DatePickerPanel$gotoNextMonth(state),
								currentDate)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: _abadi199$datetimepicker$DateTimePicker_Svg$rightArrow,
				_1: {ctor: '[]'}
			});
	});
var _abadi199$datetimepicker$DatePickerPanel$dateClickHandler = F5(
	function (config, _p14, year, month, day) {
		var _p15 = _p14;
		var _p17 = _p15._0;
		var selectedDate = _elm_lang$core$Maybe$Just(
			A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$toDate, year, month, day));
		var updatedState = _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
			_elm_lang$core$Native_Utils.update(
				_p17,
				{
					date: selectedDate,
					forceClose: true,
					activeTimeIndicator: _elm_lang$core$Native_Utils.eq(_p17.time.hour, _elm_lang$core$Maybe$Nothing) ? _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator) : (_elm_lang$core$Native_Utils.eq(_p17.time.minute, _elm_lang$core$Maybe$Nothing) ? _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$MinuteIndicator) : (_elm_lang$core$Native_Utils.eq(_p17.time.amPm, _elm_lang$core$Maybe$Nothing) ? _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$AMPMIndicator) : _elm_lang$core$Maybe$Nothing))
				}));
		var _p16 = day.monthType;
		switch (_p16.ctor) {
			case 'Previous':
				return A2(
					config.onChange,
					_abadi199$datetimepicker$DatePickerPanel$gotoPreviousMonth(updatedState),
					selectedDate);
			case 'Next':
				return A2(
					config.onChange,
					_abadi199$datetimepicker$DatePickerPanel$gotoNextMonth(updatedState),
					selectedDate);
			default:
				return A2(config.onChange, updatedState, selectedDate);
		}
	});
var _abadi199$datetimepicker$DatePickerPanel$calendar = F3(
	function (config, _p18, currentDate) {
		var _p19 = _p18;
		var _p23 = _p19._0;
		var _p20 = _p23.titleDate;
		if (_p20.ctor === 'Nothing') {
			return _elm_lang$html$Html$text('');
		} else {
			var _p22 = _p20._0;
			var header = A2(
				_elm_lang$html$Html$thead,
				{
					ctor: '::',
					_0: config.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DaysOfWeek,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$tr,
						{ctor: '[]'},
						_abadi199$datetimepicker$DatePickerPanel$dayNames(config)),
					_1: {ctor: '[]'}
				});
			var year = _elm_lang$core$Date$year(_p22);
			var month = _elm_lang$core$Date$month(_p22);
			var days = A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$generateCalendar, config.firstDayOfWeek, month, year);
			var isHighlighted = function (day) {
				return A2(
					_elm_lang$core$Maybe$withDefault,
					false,
					A2(
						_elm_lang$core$Maybe$map,
						function (current) {
							return _elm_lang$core$Native_Utils.eq(
								day.day,
								_elm_lang$core$Date$day(current)) && (_elm_lang$core$Native_Utils.eq(
								month,
								_elm_lang$core$Date$month(current)) && _elm_lang$core$Native_Utils.eq(
								year,
								_elm_lang$core$Date$year(current)));
						},
						_p23.date));
			};
			var isToday = function (day) {
				return A2(
					_elm_lang$core$Maybe$withDefault,
					false,
					A2(
						_elm_lang$core$Maybe$map,
						function (today) {
							return _elm_lang$core$Native_Utils.eq(
								day.day,
								_elm_lang$core$Date$day(today)) && (_elm_lang$core$Native_Utils.eq(
								month,
								_elm_lang$core$Date$month(today)) && _elm_lang$core$Native_Utils.eq(
								year,
								_elm_lang$core$Date$year(today)));
						},
						_p23.today));
			};
			var toCell = function (day) {
				var selectedDate = A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$toDate, year, month, day);
				return A2(
					_elm_lang$html$Html$td,
					{
						ctor: '::',
						_0: config.$class(
							function () {
								var _p21 = day.monthType;
								switch (_p21.ctor) {
									case 'Previous':
										return {
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$PreviousMonth,
											_1: {ctor: '[]'}
										};
									case 'Current':
										return {
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$CurrentMonth,
											_1: isHighlighted(day) ? {
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedDate,
												_1: {ctor: '[]'}
											} : (isToday(day) ? {
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Today,
												_1: {ctor: '[]'}
											} : {ctor: '[]'})
										};
									default:
										return {
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$NextMonth,
											_1: {ctor: '[]'}
										};
								}
							}()),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'button'),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html_Attributes$attribute,
									'aria-label',
									A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%e, %A %B %Y', selectedDate)),
								_1: {
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
										A5(
											_abadi199$datetimepicker$DatePickerPanel$dateClickHandler,
											config,
											_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p23),
											year,
											month,
											day)),
									_1: {
										ctor: '::',
										_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
											A5(
												_abadi199$datetimepicker$DatePickerPanel$dateClickHandler,
												config,
												_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p23),
												year,
												month,
												day)),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							_elm_lang$core$Basics$toString(day.day)),
						_1: {ctor: '[]'}
					});
			};
			var toWeekRow = function (week) {
				return A2(
					_elm_lang$html$Html$tr,
					{ctor: '[]'},
					A2(_elm_lang$core$List$map, toCell, week));
			};
			var body = A2(
				_elm_lang$html$Html$tbody,
				{
					ctor: '::',
					_0: config.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Days,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				},
				A2(
					_elm_lang$core$List$map,
					toWeekRow,
					A2(_elm_community$list_extra$List_Extra$groupsOf, 7, days)));
			var firstDay = A2(
				_abadi199$datetimepicker$DateTimePicker_DateUtils$dayToInt,
				config.firstDayOfWeek,
				_elm_lang$core$Date$dayOfWeek(
					_rluiten$elm_date_extra$Date_Extra_Core$toFirstOfMonth(_p22)));
			return A2(
				_elm_lang$html$Html$table,
				{
					ctor: '::',
					_0: config.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Calendar,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: header,
					_1: {
						ctor: '::',
						_0: body,
						_1: {ctor: '[]'}
					}
				});
		}
	});
var _abadi199$datetimepicker$DatePickerPanel$switchMode = function (_p24) {
	var _p25 = _p24;
	return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
		_elm_lang$core$Native_Utils.update(
			_p25._0,
			{event: 'title'}));
};
var _abadi199$datetimepicker$DatePickerPanel$title = F3(
	function (config, _p26, currentDate) {
		var _p27 = _p26;
		var date = _p27._0.titleDate;
		return A2(
			_elm_lang$html$Html$span,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Title,
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A2(
							config.onChange,
							_abadi199$datetimepicker$DatePickerPanel$switchMode(_p27),
							currentDate)),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(
					A2(
						_elm_lang$core$Maybe$withDefault,
						'N/A',
						A2(_elm_lang$core$Maybe$map, config.titleFormatter, date))),
				_1: {ctor: '[]'}
			});
	});
var _abadi199$datetimepicker$DatePickerPanel$navigation = F3(
	function (config, state, currentDate) {
		return {
			ctor: '::',
			_0: A3(_abadi199$datetimepicker$DatePickerPanel$previousYearButton, config, state, currentDate),
			_1: {
				ctor: '::',
				_0: A3(_abadi199$datetimepicker$DatePickerPanel$previousButton, config, state, currentDate),
				_1: {
					ctor: '::',
					_0: A3(_abadi199$datetimepicker$DatePickerPanel$title, config, state, currentDate),
					_1: {
						ctor: '::',
						_0: A3(_abadi199$datetimepicker$DatePickerPanel$nextButton, config, state, currentDate),
						_1: {
							ctor: '::',
							_0: A3(_abadi199$datetimepicker$DatePickerPanel$nextYearButton, config, state, currentDate),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		};
	});
var _abadi199$datetimepicker$DatePickerPanel$view = F3(
	function (config, _p28, currentDate) {
		var _p29 = _p28;
		var _p30 = _p29;
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DatePickerDialog,
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: config.$class(
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Header,
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					},
					A3(_abadi199$datetimepicker$DatePickerPanel$navigation, config, _p30, currentDate)),
				_1: {
					ctor: '::',
					_0: A3(_abadi199$datetimepicker$DatePickerPanel$calendar, config, _p30, currentDate),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: config.$class(
									{
										ctor: '::',
										_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Footer,
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									A2(
										_elm_lang$core$Maybe$withDefault,
										'--',
										A2(_elm_lang$core$Maybe$map, config.footerFormatter, _p29._0.date))),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});

var _abadi199$datetimepicker$DigitalTimePickerPanel$minuteDownHandler = F3(
	function (config, _p0, currentDate) {
		var _p1 = _p0;
		var _p2 = _p1._0;
		var updatedState = (_elm_lang$core$Native_Utils.cmp(_p2.minutePickerStart + 6, 59) < 1) ? _elm_lang$core$Native_Utils.update(
			_p2,
			{minutePickerStart: _p2.minutePickerStart + 6}) : _p2;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedState),
			currentDate);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$minuteUpHandler = F3(
	function (config, _p3, currentDate) {
		var _p4 = _p3;
		var _p5 = _p4._0;
		var updatedState = (_elm_lang$core$Native_Utils.cmp(_p5.minutePickerStart - 6, 0) > -1) ? _elm_lang$core$Native_Utils.update(
			_p5,
			{minutePickerStart: _p5.minutePickerStart - 6}) : _p5;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedState),
			currentDate);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$hourDownHandler = F3(
	function (config, _p6, currentDate) {
		var _p7 = _p6;
		var _p8 = _p7._0;
		var updatedState = (_elm_lang$core$Native_Utils.cmp(_p8.hourPickerStart + 6, 12) < 1) ? _elm_lang$core$Native_Utils.update(
			_p8,
			{hourPickerStart: _p8.hourPickerStart + 6}) : _p8;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedState),
			currentDate);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$hourUpHandler = F3(
	function (config, _p9, currentDate) {
		var _p10 = _p9;
		var _p11 = _p10._0;
		var updatedState = (_elm_lang$core$Native_Utils.cmp(_p11.hourPickerStart - 6, 1) > -1) ? _elm_lang$core$Native_Utils.update(
			_p11,
			{hourPickerStart: _p11.hourPickerStart - 6}) : _p11;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedState),
			currentDate);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$amPmClickHandler = F3(
	function (config, _p12, amPm) {
		var _p13 = _p12;
		var _p16 = _p13._0;
		var time = _p16.time;
		var updatedStateValue = _elm_lang$core$Native_Utils.update(
			_p16,
			{
				time: _elm_lang$core$Native_Utils.update(
					time,
					{
						amPm: _elm_lang$core$String$isEmpty(amPm) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(amPm)
					}),
				event: 'amPmClickHandler'
			});
		var _p14 = function () {
			var _p15 = {ctor: '_Tuple2', _0: updatedStateValue.time.hour, _1: updatedStateValue.time.minute};
			if (((_p15.ctor === '_Tuple2') && (_p15._0.ctor === 'Just')) && (_p15._1.ctor === 'Just')) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Maybe$Just(
						A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$toTime, _p15._0._0, _p15._1._0, amPm)),
					_1: true
				};
			} else {
				return {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: false};
			}
		}();
		var updatedTime = _p14._0;
		var forceClose = _p14._1;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
				_elm_lang$core$Native_Utils.update(
					updatedStateValue,
					{forceClose: forceClose})),
			updatedTime);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$minuteClickHandler = F3(
	function (config, _p17, minute) {
		var _p18 = _p17;
		var _p21 = _p18._0;
		var time = _p21.time;
		var updatedStateValue = _elm_lang$core$Native_Utils.update(
			_p21,
			{
				time: _elm_lang$core$Native_Utils.update(
					time,
					{
						minute: _elm_lang$core$Maybe$Just(minute)
					}),
				event: 'minuteClickHandler'
			});
		var _p19 = function () {
			var _p20 = {ctor: '_Tuple2', _0: updatedStateValue.time.hour, _1: updatedStateValue.time.amPm};
			if (((_p20.ctor === '_Tuple2') && (_p20._0.ctor === 'Just')) && (_p20._1.ctor === 'Just')) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Maybe$Just(
						A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$toTime, _p20._0._0, minute, _p20._1._0)),
					_1: true
				};
			} else {
				return {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: false};
			}
		}();
		var updatedTime = _p19._0;
		var forceClose = _p19._1;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
				_elm_lang$core$Native_Utils.update(
					updatedStateValue,
					{forceClose: forceClose})),
			updatedTime);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$hourClickHandler = F3(
	function (config, _p22, hour) {
		var _p23 = _p22;
		var _p26 = _p23._0;
		var time = _p26.time;
		var updatedStateValue = _elm_lang$core$Native_Utils.update(
			_p26,
			{
				time: _elm_lang$core$Native_Utils.update(
					time,
					{
						hour: _elm_lang$core$Maybe$Just(hour)
					}),
				event: 'hourClickHandler'
			});
		var _p24 = function () {
			var _p25 = {ctor: '_Tuple2', _0: updatedStateValue.time.minute, _1: updatedStateValue.time.amPm};
			if (((_p25.ctor === '_Tuple2') && (_p25._0.ctor === 'Just')) && (_p25._1.ctor === 'Just')) {
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Maybe$Just(
						A3(_abadi199$datetimepicker$DateTimePicker_DateUtils$toTime, hour, _p25._0._0, _p25._1._0)),
					_1: true
				};
			} else {
				return {ctor: '_Tuple2', _0: _elm_lang$core$Maybe$Nothing, _1: false};
			}
		}();
		var updatedTime = _p24._0;
		var forceClose = _p24._1;
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
				_elm_lang$core$Native_Utils.update(
					updatedStateValue,
					{forceClose: forceClose})),
			updatedTime);
	});
var _abadi199$datetimepicker$DigitalTimePickerPanel$view = F3(
	function (config, _p27, currentDate) {
		var _p28 = _p27;
		var _p32 = _p28._0;
		var _p31 = _p28;
		var downArrows = function (config) {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$tr,
					{
						ctor: '::',
						_0: config.$class(
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowDown,
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$td,
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
									A3(_abadi199$datetimepicker$DigitalTimePickerPanel$hourDownHandler, config, _p31, currentDate)),
								_1: {
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
										A3(_abadi199$datetimepicker$DigitalTimePickerPanel$hourDownHandler, config, _p31, currentDate)),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Svg$downArrow,
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$td,
								{
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
										A3(_abadi199$datetimepicker$DigitalTimePickerPanel$minuteDownHandler, config, _p31, currentDate)),
									_1: {
										ctor: '::',
										_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
											A3(_abadi199$datetimepicker$DigitalTimePickerPanel$minuteDownHandler, config, _p31, currentDate)),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Svg$downArrow,
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$td,
									{ctor: '[]'},
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			};
		};
		var upArrows = function (config) {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$tr,
					{
						ctor: '::',
						_0: config.$class(
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$ArrowUp,
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$td,
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
									A3(_abadi199$datetimepicker$DigitalTimePickerPanel$hourUpHandler, config, _p31, currentDate)),
								_1: {
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
										A3(_abadi199$datetimepicker$DigitalTimePickerPanel$hourUpHandler, config, _p31, currentDate)),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_Svg$upArrow,
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$td,
								{
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
										A3(_abadi199$datetimepicker$DigitalTimePickerPanel$minuteUpHandler, config, _p31, currentDate)),
									_1: {
										ctor: '::',
										_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
											A3(_abadi199$datetimepicker$DigitalTimePickerPanel$minuteUpHandler, config, _p31, currentDate)),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_Svg$upArrow,
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$td,
									{ctor: '[]'},
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			};
		};
		var amPmCell = function (ampm) {
			var defaultClasses = config.$class(
				_elm_lang$core$Native_Utils.eq(ampm, '') ? {
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$EmptyCell,
					_1: {ctor: '[]'}
				} : {ctor: '[]'});
			return A2(
				_elm_lang$html$Html$td,
				A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Maybe$withDefault,
							defaultClasses,
							A2(
								_elm_lang$core$Maybe$map,
								function (selected) {
									return selected ? config.$class(
										{
											ctor: '::',
											_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedAmPm,
											_1: {ctor: '[]'}
										}) : defaultClasses;
								},
								A2(
									_elm_lang$core$Maybe$map,
									F2(
										function (x, y) {
											return _elm_lang$core$Native_Utils.eq(x, y);
										})(ampm),
									_p32.time.amPm))),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'button'),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-label', ampm),
								_1: {ctor: '[]'}
							}
						}
					},
					_elm_lang$core$Native_Utils.eq(ampm, '') ? {ctor: '[]'} : {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
							A3(_abadi199$datetimepicker$DigitalTimePickerPanel$amPmClickHandler, config, _p31, ampm)),
						_1: {
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
								A3(_abadi199$datetimepicker$DigitalTimePickerPanel$amPmClickHandler, config, _p31, ampm)),
							_1: {ctor: '[]'}
						}
					}),
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(ampm),
					_1: {ctor: '[]'}
				});
		};
		var minuteCell = function (min) {
			return A2(
				_elm_lang$html$Html$td,
				{
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A3(_abadi199$datetimepicker$DigitalTimePickerPanel$minuteClickHandler, config, _p31, min)),
					_1: {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
							A3(_abadi199$datetimepicker$DigitalTimePickerPanel$minuteClickHandler, config, _p31, min)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Maybe$withDefault,
								config.$class(
									{ctor: '[]'}),
								A2(
									_elm_lang$core$Maybe$map,
									function (selected) {
										return selected ? config.$class(
											{
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedMinute,
												_1: {ctor: '[]'}
											}) : config.$class(
											{ctor: '[]'});
									},
									A2(
										_elm_lang$core$Maybe$map,
										F2(
											function (x, y) {
												return _elm_lang$core$Native_Utils.eq(x, y);
											})(min),
										_p32.time.minute))),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'button'),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html_Attributes$attribute,
										'aria-label',
										A2(
											_elm_lang$core$Basics_ops['++'],
											'minute ',
											_elm_lang$core$Basics$toString(min))),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						function (_p29) {
							return _abadi199$datetimepicker$DateTimePicker_DateUtils$padding(
								_elm_lang$core$Basics$toString(_p29));
						}(min)),
					_1: {ctor: '[]'}
				});
		};
		var hourCell = function (hour) {
			return A2(
				_elm_lang$html$Html$td,
				{
					ctor: '::',
					_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
						A3(_abadi199$datetimepicker$DigitalTimePickerPanel$hourClickHandler, config, _p31, hour)),
					_1: {
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_Events$onTouchStartPreventDefault(
							A3(_abadi199$datetimepicker$DigitalTimePickerPanel$hourClickHandler, config, _p31, hour)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$core$Maybe$withDefault,
								config.$class(
									{ctor: '[]'}),
								A2(
									_elm_lang$core$Maybe$map,
									function (selected) {
										return selected ? config.$class(
											{
												ctor: '::',
												_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$SelectedHour,
												_1: {ctor: '[]'}
											}) : config.$class(
											{ctor: '[]'});
									},
									A2(
										_elm_lang$core$Maybe$map,
										F2(
											function (x, y) {
												return _elm_lang$core$Native_Utils.eq(x, y);
											})(hour),
										_p32.time.hour))),
							_1: {
								ctor: '::',
								_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'button'),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html_Attributes$attribute,
										'aria-label',
										A2(
											_elm_lang$core$Basics_ops['++'],
											'hour ',
											_elm_lang$core$Basics$toString(hour))),
									_1: {ctor: '[]'}
								}
							}
						}
					}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(
						function (_p30) {
							return _abadi199$datetimepicker$DateTimePicker_DateUtils$padding(
								_elm_lang$core$Basics$toString(_p30));
						}(hour)),
					_1: {ctor: '[]'}
				});
		};
		var toRow = F3(
			function (hour, min, ampm) {
				return A2(
					_elm_lang$html$Html$tr,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: hourCell(hour),
						_1: {
							ctor: '::',
							_0: minuteCell(min),
							_1: {
								ctor: '::',
								_0: amPmCell(ampm),
								_1: {ctor: '[]'}
							}
						}
					});
			});
		var ampmList = {
			ctor: '::',
			_0: 'AM',
			_1: {
				ctor: '::',
				_0: 'PM',
				_1: {ctor: '[]'}
			}
		};
		var minutes = A2(_elm_lang$core$List$range, _p32.minutePickerStart, _p32.minutePickerStart + 6);
		var hours = A2(_elm_lang$core$List$range, _p32.hourPickerStart, _p32.hourPickerStart + 6);
		var timeSelector = A4(
			_elm_lang$core$List$map3,
			toRow,
			hours,
			minutes,
			A2(
				_elm_lang$core$Basics_ops['++'],
				ampmList,
				A2(_elm_lang$core$List$repeat, 4, '')));
		var toListItem = function (str) {
			return A2(
				_elm_lang$html$Html$li,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(str),
					_1: {ctor: '[]'}
				});
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: config.$class(
					{
						ctor: '::',
						_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$TimePickerDialog,
						_1: {
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DigitalTime,
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: config.$class(
							{
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Header,
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(
							A2(
								_elm_lang$core$Maybe$withDefault,
								'-- : --',
								A2(_elm_lang$core$Maybe$map, config.titleFormatter, currentDate))),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: config.$class(
								{
									ctor: '::',
									_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Body,
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$table,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$tbody,
										{ctor: '[]'},
										A2(
											_elm_lang$core$Basics_ops['++'],
											upArrows(config),
											A2(
												_elm_lang$core$Basics_ops['++'],
												timeSelector,
												downArrows(config)))),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});

var _abadi199$datetimepicker$MultiPanel$view = F4(
	function (dateConfig, _p0, state, currentDate) {
		var _p1 = _p0;
		var safeOnChange = F2(
			function (_p3, _p2) {
				var _p4 = _p3;
				var _p6 = _p4._0;
				return A2(
					dateConfig.onChange,
					_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p6),
					function () {
						var _p5 = {ctor: '_Tuple4', _0: _p6.date, _1: _p6.time.hour, _2: _p6.time.minute, _3: _p6.time.amPm};
						if (((((_p5.ctor === '_Tuple4') && (_p5._0.ctor === 'Just')) && (_p5._1.ctor === 'Just')) && (_p5._2.ctor === 'Just')) && (_p5._3.ctor === 'Just')) {
							return _elm_lang$core$Maybe$Just(
								A4(_abadi199$datetimepicker$DateTimePicker_DateUtils$setTime, _p5._0._0, _p5._1._0, _p5._2._0, _p5._3._0));
						} else {
							return _elm_lang$core$Maybe$Nothing;
						}
					}());
			});
		var safeDateConfig = _elm_lang$core$Native_Utils.update(
			dateConfig,
			{onChange: safeOnChange});
		var safeTimeConfig = _elm_lang$core$Native_Utils.update(
			_p1._1,
			{onChange: safeOnChange});
		return {
			ctor: '::',
			_0: A3(_abadi199$datetimepicker$DatePickerPanel$view, safeDateConfig, state, currentDate),
			_1: {
				ctor: '::',
				_0: function () {
					var _p7 = _p1._0;
					if (_p7.ctor === 'Digital') {
						return A3(_abadi199$datetimepicker$DigitalTimePickerPanel$view, safeTimeConfig, state, currentDate);
					} else {
						return A3(_abadi199$datetimepicker$AnalogTimePickerPanel$view, safeTimeConfig, state, currentDate);
					}
				}(),
				_1: {ctor: '[]'}
			}
		};
	});

var _abadi199$datetimepicker$DateTimePicker$onChangeHandler = F3(
	function (pickerType, _p0, currentDate) {
		var _p1 = _p0;
		var _p5 = _p1._0;
		var _p4 = _p1;
		var withTimeHandler = function (config) {
			var _p2 = {ctor: '_Tuple4', _0: _p5.date, _1: _p5.time.hour, _2: _p5.time.minute, _3: _p5.time.amPm};
			if (((((_p2.ctor === '_Tuple4') && (_p2._0.ctor === 'Just')) && (_p2._1.ctor === 'Just')) && (_p2._2.ctor === 'Just')) && (_p2._3.ctor === 'Just')) {
				return A2(
					config.onChange,
					_p4,
					_elm_lang$core$Maybe$Just(
						A4(_abadi199$datetimepicker$DateTimePicker_DateUtils$setTime, _p2._0._0, _p2._1._0, _p2._2._0, _p2._3._0)));
			} else {
				return A2(config.onChange, _p4, _elm_lang$core$Maybe$Nothing);
			}
		};
		var justDateHandler = function (config) {
			return A2(config.onChange, _p4, _p5.date);
		};
		var _p3 = pickerType;
		switch (_p3.ctor) {
			case 'DateType':
				return justDateHandler(_p3._0);
			case 'DateTimeType':
				return withTimeHandler(_p3._0);
			default:
				return withTimeHandler(_p3._0);
		}
	});
var _abadi199$datetimepicker$DateTimePicker$datePickerFocused = F4(
	function (pickerType, config, _p6, currentDate) {
		var _p7 = _p6;
		var _p12 = _p7._0;
		var updateTime = function (time) {
			return _elm_lang$core$Native_Utils.update(
				time,
				{
					hour: A2(
						_elm_lang$core$Maybe$map,
						function (_p8) {
							return _abadi199$datetimepicker$DateTimePicker_DateUtils$fromMillitaryHour(
								_elm_lang$core$Date$hour(_p8));
						},
						currentDate),
					minute: A2(_elm_lang$core$Maybe$map, _elm_lang$core$Date$minute, currentDate),
					amPm: A2(
						_elm_lang$core$Maybe$map,
						function (_p9) {
							return _abadi199$datetimepicker$DateTimePicker_DateUtils$fromMillitaryAmPm(
								_elm_lang$core$Date$hour(_p9));
						},
						currentDate)
				});
		};
		var updatedTitleDate = function () {
			var _p10 = currentDate;
			if (_p10.ctor === 'Nothing') {
				return _p12.titleDate;
			} else {
				return currentDate;
			}
		}();
		return A2(
			config.onChange,
			_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
				_elm_lang$core$Native_Utils.update(
					_p12,
					{
						inputFocused: true,
						event: 'onFocus',
						titleDate: updatedTitleDate,
						date: currentDate,
						forceClose: false,
						time: updateTime(_p12.time),
						activeTimeIndicator: function () {
							var _p11 = pickerType;
							if (_p11.ctor === 'TimeType') {
								return _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator);
							} else {
								return _elm_lang$core$Maybe$Nothing;
							}
						}()
					})),
			currentDate);
	});
var _abadi199$datetimepicker$DateTimePicker$dialog = F3(
	function (pickerType, _p13, currentDate) {
		var _p14 = _p13;
		var _p21 = _p14._0;
		var attributes = function (config) {
			return {
				ctor: '::',
				_0: _abadi199$datetimepicker$DateTimePicker_Events$onMouseDownPreventDefault(
					A2(
						config.onChange,
						_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
							_elm_lang$core$Native_Utils.update(
								_p21,
								{event: 'dialog.onMouseDownPreventDefault'})),
						currentDate)),
				_1: {
					ctor: '::',
					_0: config.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$Dialog,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			};
		};
		var withTimeAttributes = F2(
			function (config, timePickerType) {
				var _p15 = timePickerType;
				if (_p15.ctor === 'Analog') {
					return {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							A3(
								_abadi199$datetimepicker$DateTimePicker$onChangeHandler,
								pickerType,
								_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p21),
								currentDate)),
						_1: attributes(config)
					};
				} else {
					return attributes(config);
				}
			});
		var _p16 = pickerType;
		switch (_p16.ctor) {
			case 'DateType':
				var _p17 = _p16._0;
				return A2(
					_elm_lang$html$Html$div,
					attributes(_p17),
					{
						ctor: '::',
						_0: A3(
							_abadi199$datetimepicker$DatePickerPanel$view,
							{onChange: _p17.onChange, nameOfDays: _p17.nameOfDays, firstDayOfWeek: _p17.firstDayOfWeek, allowYearNavigation: _p17.allowYearNavigation, titleFormatter: _p17.i18n.titleFormatter, footerFormatter: _p17.i18n.footerFormatter, $class: _p17.$class},
							_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p21),
							currentDate),
						_1: {ctor: '[]'}
					});
			case 'TimeType':
				var _p19 = _p16._0;
				var dialog = function () {
					var _p18 = _p19.timePickerType;
					if (_p18.ctor === 'Digital') {
						return _abadi199$datetimepicker$DigitalTimePickerPanel$view;
					} else {
						return _abadi199$datetimepicker$AnalogTimePickerPanel$view;
					}
				}();
				return A2(
					_elm_lang$html$Html$div,
					A2(withTimeAttributes, _p19, _p19.timePickerType),
					{
						ctor: '::',
						_0: A3(
							dialog,
							{onChange: _p19.onChange, titleFormatter: _p19.i18n.timeTitleFormatter, $class: _p19.$class},
							_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p21),
							currentDate),
						_1: {ctor: '[]'}
					});
			default:
				var _p20 = _p16._0;
				return A2(
					_elm_lang$html$Html$div,
					A2(withTimeAttributes, _p20, _p20.timePickerType),
					A4(
						_abadi199$datetimepicker$MultiPanel$view,
						{onChange: _p20.onChange, nameOfDays: _p20.nameOfDays, firstDayOfWeek: _p20.firstDayOfWeek, allowYearNavigation: _p20.allowYearNavigation, titleFormatter: _p20.i18n.titleFormatter, footerFormatter: _p20.i18n.footerFormatter, $class: _p20.$class},
						{
							ctor: '_Tuple2',
							_0: _p20.timePickerType,
							_1: {onChange: _p20.onChange, titleFormatter: _p20.i18n.timeTitleFormatter, $class: _p20.$class}
						},
						_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(_p21),
						currentDate));
		}
	});
var _abadi199$datetimepicker$DateTimePicker$initialCmd = F2(
	function (onChange, _p22) {
		var _p23 = _p22;
		var setDate = function (now) {
			return _abadi199$datetimepicker$DateTimePicker_Internal$InternalState(
				_elm_lang$core$Native_Utils.update(
					_p23._0,
					{
						today: _elm_lang$core$Maybe$Just(now),
						titleDate: _elm_lang$core$Maybe$Just(
							_rluiten$elm_date_extra$Date_Extra_Core$toFirstOfMonth(now))
					}));
		};
		return A2(
			_elm_lang$core$Task$perform,
			_elm_lang$core$Basics$flip(
				function (_p24) {
					return onChange(
						setDate(_p24));
				})(_elm_lang$core$Maybe$Nothing),
			_elm_lang$core$Date$now);
	});
var _abadi199$datetimepicker$DateTimePicker$initialStateWithToday = function (today) {
	return _abadi199$datetimepicker$DateTimePicker_Internal$initialStateWithToday(today);
};
var _abadi199$datetimepicker$DateTimePicker$initialState = _abadi199$datetimepicker$DateTimePicker_Internal$initialState;
var _abadi199$datetimepicker$DateTimePicker$inputChangeHandler = F4(
	function (config, _p25, currentDate, maybeDate) {
		var _p26 = _p25;
		var _p32 = _p26._0;
		var _p27 = _abadi199$datetimepicker$DateTimePicker$initialState;
		var initialStateValue = _p27._0;
		var _p28 = maybeDate;
		if (_p28.ctor === 'Just') {
			var _p29 = _p28._0;
			var updateTime = function (time) {
				return _elm_lang$core$Native_Utils.update(
					time,
					{
						hour: _elm_lang$core$Maybe$Just(
							_abadi199$datetimepicker$DateTimePicker_DateUtils$fromMillitaryHour(
								_elm_lang$core$Date$hour(_p29))),
						minute: _elm_lang$core$Maybe$Just(
							_elm_lang$core$Date$minute(_p29)),
						amPm: _elm_lang$core$Maybe$Just(
							_abadi199$datetimepicker$DateTimePicker_DateUtils$fromMillitaryAmPm(
								_elm_lang$core$Date$hour(_p29)))
					});
			};
			var updatedValue = _elm_lang$core$Native_Utils.update(
				_p32,
				{
					date: _elm_lang$core$Maybe$Just(_p29),
					time: updateTime(_p32.time),
					inputFocused: false,
					event: 'inputChangeHandler'
				});
			return A2(
				config.onChange,
				_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedValue),
				maybeDate);
		} else {
			var _p30 = function () {
				var _p31 = currentDate;
				if (_p31.ctor === 'Just') {
					return {
						ctor: '_Tuple3',
						_0: {hour: _elm_lang$core$Maybe$Nothing, minute: _elm_lang$core$Maybe$Nothing, amPm: _elm_lang$core$Maybe$Nothing},
						_1: _elm_lang$core$Maybe$Just(_abadi199$datetimepicker$DateTimePicker_Internal$HourIndicator),
						_2: _elm_lang$core$Maybe$Nothing
					};
				} else {
					return {ctor: '_Tuple3', _0: _p32.time, _1: _p32.activeTimeIndicator, _2: _p32.date};
				}
			}();
			var updatedTime = _p30._0;
			var updatedActiveTimeIndicator = _p30._1;
			var updatedDate = _p30._2;
			var updatedValue = _elm_lang$core$Native_Utils.update(
				_p32,
				{date: updatedDate, time: updatedTime, hourPickerStart: initialStateValue.hourPickerStart, minutePickerStart: initialStateValue.minutePickerStart, inputFocused: false, event: 'inputChangeHandler', activeTimeIndicator: updatedActiveTimeIndicator});
			return A2(
				config.onChange,
				_abadi199$datetimepicker$DateTimePicker_Internal$InternalState(updatedValue),
				maybeDate);
		}
	});
var _abadi199$datetimepicker$DateTimePicker$view = F4(
	function (pickerType, attributes, _p33, currentDate) {
		var _p34 = _p33;
		var _p40 = _p34._0;
		var _p39 = _p34;
		var shouldForceClose = function (config) {
			return config.autoClose && _p40.forceClose;
		};
		var inputAttributes = function (config) {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				attributes,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Events$onFocus(
						A4(_abadi199$datetimepicker$DateTimePicker$datePickerFocused, pickerType, config, _p39, currentDate)),
					_1: {
						ctor: '::',
						_0: A2(
							_abadi199$datetimepicker$DateTimePicker_Events$onBlurWithChange,
							config.i18n.inputFormat.inputParser,
							A3(_abadi199$datetimepicker$DateTimePicker$inputChangeHandler, config, _p39, currentDate)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$value(
								A2(
									_elm_lang$core$Maybe$withDefault,
									'',
									A2(_elm_lang$core$Maybe$map, config.i18n.inputFormat.inputFormatter, currentDate))),
							_1: {ctor: '[]'}
						}
					}
				});
		};
		var html = F2(
			function (config, cssClasses) {
				return A2(
					_elm_lang$html$Html$div,
					{ctor: '::', _0: cssClasses, _1: config.attributes},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$input,
							inputAttributes(config),
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: (config.usePicker && (_p40.inputFocused && (!shouldForceClose(config)))) ? A3(_abadi199$datetimepicker$DateTimePicker$dialog, pickerType, _p39, currentDate) : _elm_lang$html$Html$text(''),
							_1: {ctor: '[]'}
						}
					});
			});
		var timeFormatter = function (dateTimePickerConfig) {
			return dateTimePickerConfig.timeFormatter;
		};
		var _p35 = pickerType;
		switch (_p35.ctor) {
			case 'DateType':
				var _p36 = _p35._0;
				return A2(
					html,
					_p36,
					_p36.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DatePicker,
							_1: {ctor: '[]'}
						}));
			case 'DateTimeType':
				var _p37 = _p35._0;
				return A2(
					html,
					_p37,
					_p37.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$DatePicker,
							_1: {
								ctor: '::',
								_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$TimePicker,
								_1: {ctor: '[]'}
							}
						}));
			default:
				var _p38 = _p35._0;
				return A2(
					html,
					_p38,
					_p38.$class(
						{
							ctor: '::',
							_0: _abadi199$datetimepicker$DateTimePicker_SharedStyles$TimePicker,
							_1: {ctor: '[]'}
						}));
		}
	});
var _abadi199$datetimepicker$DateTimePicker$datePickerWithConfig = function (config) {
	return _abadi199$datetimepicker$DateTimePicker$view(
		_abadi199$datetimepicker$DateTimePicker_Config$DateType(config));
};
var _abadi199$datetimepicker$DateTimePicker$datePicker = function (onChange) {
	return _abadi199$datetimepicker$DateTimePicker$datePickerWithConfig(
		_abadi199$datetimepicker$DateTimePicker_Config$defaultDatePickerConfig(onChange));
};
var _abadi199$datetimepicker$DateTimePicker$dateTimePickerWithConfig = function (config) {
	return _abadi199$datetimepicker$DateTimePicker$view(
		_abadi199$datetimepicker$DateTimePicker_Config$DateTimeType(config));
};
var _abadi199$datetimepicker$DateTimePicker$dateTimePicker = function (onChange) {
	return _abadi199$datetimepicker$DateTimePicker$dateTimePickerWithConfig(
		_abadi199$datetimepicker$DateTimePicker_Config$defaultDateTimePickerConfig(onChange));
};
var _abadi199$datetimepicker$DateTimePicker$timePickerWithConfig = function (config) {
	return _abadi199$datetimepicker$DateTimePicker$view(
		_abadi199$datetimepicker$DateTimePicker_Config$TimeType(config));
};
var _abadi199$datetimepicker$DateTimePicker$timePicker = function (onChange) {
	return _abadi199$datetimepicker$DateTimePicker$timePickerWithConfig(
		_abadi199$datetimepicker$DateTimePicker_Config$defaultTimePickerConfig(onChange));
};

var _CareerPlug$ats$PdfForm_Ports$pdfCmd = _elm_lang$core$Native_Platform.outgoingPort(
	'pdfCmd',
	function (v) {
		return {tag: v.tag, data: v.data};
	});
var _CareerPlug$ats$PdfForm_Ports$sendCmd = function (info) {
	var _p0 = info;
	switch (_p0.ctor) {
		case 'ScrollTop':
			return _CareerPlug$ats$PdfForm_Ports$pdfCmd(
				{
					tag: 'ScrollTop',
					data: _elm_lang$core$Json_Encode$object(
						{
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'name',
								_1: _elm_lang$core$Json_Encode$string(_p0._0)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'scrollY',
									_1: _elm_lang$core$Json_Encode$int(_p0._1)
								},
								_1: {ctor: '[]'}
							}
						})
				});
		case 'ScrollWindowTo':
			return _CareerPlug$ats$PdfForm_Ports$pdfCmd(
				{
					tag: 'ScrollWindowTo',
					data: _elm_lang$core$Json_Encode$object(
						{
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'name',
								_1: _elm_lang$core$Json_Encode$string(_p0._0)
							},
							_1: {ctor: '[]'}
						})
				});
		case 'Measure':
			return _CareerPlug$ats$PdfForm_Ports$pdfCmd(
				{
					tag: 'Measure',
					data: _elm_lang$core$Json_Encode$list(
						A2(_elm_lang$core$List$map, _elm_lang$core$Json_Encode$string, _p0._0))
				});
		case 'Signature':
			return _CareerPlug$ats$PdfForm_Ports$pdfCmd(
				{
					tag: 'Signature',
					data: _elm_lang$core$Json_Encode$string(_p0._0)
				});
		default:
			return _CareerPlug$ats$PdfForm_Ports$pdfCmd(
				{tag: 'SubmitForm', data: _elm_lang$core$Json_Encode$null});
	}
};
var _CareerPlug$ats$PdfForm_Ports$pdfResult = _elm_lang$core$Native_Platform.incomingPort(
	'pdfResult',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (tag) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (data) {
					return _elm_lang$core$Json_Decode$succeed(
						{tag: tag, data: data});
				},
				A2(_elm_lang$core$Json_Decode$field, 'data', _elm_lang$core$Json_Decode$value));
		},
		A2(_elm_lang$core$Json_Decode$field, 'tag', _elm_lang$core$Json_Decode$string)));
var _CareerPlug$ats$PdfForm_Ports$GenericPortData = F2(
	function (a, b) {
		return {tag: a, data: b};
	});
var _CareerPlug$ats$PdfForm_Ports$AppDimensions = F8(
	function (a, b, c, d, e, f, g, h) {
		return {screenWidth: a, scrollTop: b, appTop: c, appMaxHeight: d, appWidth: e, pageTop: f, pageHeight: g, pageWidth: h};
	});
var _CareerPlug$ats$PdfForm_Ports$jsonDimensions = A3(
	_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
	'pageWidth',
	_elm_lang$core$Json_Decode$int,
	A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'pageHeight',
		_elm_lang$core$Json_Decode$int,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'pageTop',
			_elm_lang$core$Json_Decode$int,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'appWidth',
				_elm_lang$core$Json_Decode$int,
				A3(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
					'appMaxHeight',
					_elm_lang$core$Json_Decode$int,
					A3(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
						'appTop',
						_elm_lang$core$Json_Decode$int,
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'scrollTop',
							_elm_lang$core$Json_Decode$int,
							A3(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
								'screenWidth',
								_elm_lang$core$Json_Decode$int,
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$PdfForm_Ports$AppDimensions)))))))));
var _CareerPlug$ats$PdfForm_Ports$SubmitForm = {ctor: 'SubmitForm'};
var _CareerPlug$ats$PdfForm_Ports$Signature = function (a) {
	return {ctor: 'Signature', _0: a};
};
var _CareerPlug$ats$PdfForm_Ports$Measure = function (a) {
	return {ctor: 'Measure', _0: a};
};
var _CareerPlug$ats$PdfForm_Ports$ScrollWindowTo = function (a) {
	return {ctor: 'ScrollWindowTo', _0: a};
};
var _CareerPlug$ats$PdfForm_Ports$ScrollTop = F2(
	function (a, b) {
		return {ctor: 'ScrollTop', _0: a, _1: b};
	});
var _CareerPlug$ats$PdfForm_Ports$Dimensions = function (a) {
	return {ctor: 'Dimensions', _0: a};
};
var _CareerPlug$ats$PdfForm_Ports$handleResult = F2(
	function (tagger, onError) {
		var taggedError = F2(
			function (tag, err) {
				return onError(
					A2(
						_elm_lang$core$String$join,
						': ',
						{
							ctor: '::',
							_0: tag,
							_1: {
								ctor: '::',
								_0: err,
								_1: {ctor: '[]'}
							}
						}));
			});
		return _CareerPlug$ats$PdfForm_Ports$pdfResult(
			function (info) {
				var _p1 = info.tag;
				if (_p1 === 'Measure') {
					var _p2 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$PdfForm_Ports$jsonDimensions, info.data);
					if (_p2.ctor === 'Ok') {
						return tagger(
							_CareerPlug$ats$PdfForm_Ports$Dimensions(_p2._0));
					} else {
						return A2(taggedError, info.tag, _p2._0);
					}
				} else {
					return A2(
						taggedError,
						info.tag,
						A2(
							_elm_lang$core$Basics_ops['++'],
							'Unexpected info from outside: ',
							_elm_lang$core$Basics$toString(info.data)));
				}
			});
	});

var _CareerPlug$ats$PdfForm_Message$Animate = function (a) {
	return {ctor: 'Animate', _0: a};
};
var _CareerPlug$ats$PdfForm_Message$DateMsg = F3(
	function (a, b, c) {
		return {ctor: 'DateMsg', _0: a, _1: b, _2: c};
	});
var _CareerPlug$ats$PdfForm_Message$SPMsg = F2(
	function (a, b) {
		return {ctor: 'SPMsg', _0: a, _1: b};
	});
var _CareerPlug$ats$PdfForm_Message$HandleInboundError = function (a) {
	return {ctor: 'HandleInboundError', _0: a};
};
var _CareerPlug$ats$PdfForm_Message$HandleInboundData = function (a) {
	return {ctor: 'HandleInboundData', _0: a};
};
var _CareerPlug$ats$PdfForm_Message$MobileSwitch = {ctor: 'MobileSwitch'};
var _CareerPlug$ats$PdfForm_Message$SetThumbnails = function (a) {
	return {ctor: 'SetThumbnails', _0: a};
};
var _CareerPlug$ats$PdfForm_Message$SetQuestions = function (a) {
	return {ctor: 'SetQuestions', _0: a};
};
var _CareerPlug$ats$PdfForm_Message$FormMsg = function (a) {
	return {ctor: 'FormMsg', _0: a};
};

var _CareerPlug$ats$PdfForm_Model$validate = function (questions) {
	var vQuestion = F2(
		function (q, d) {
			return A3(
				_etaque$elm_form$Form_Validate$map2,
				F2(
					function (item, dict) {
						return A3(_elm_lang$core$Dict$insert, q.id, item, dict);
					}),
				_CareerPlug$ats$Models_Response$validateResponse(q),
				d);
		});
	return A3(
		_elm_lang$core$List$foldr,
		vQuestion,
		_etaque$elm_form$Form_Validate$succeed(_elm_lang$core$Dict$empty),
		questions);
};
var _CareerPlug$ats$PdfForm_Model$Model = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {config: a, form: b, questions: c, thumbnails: d, viewMode: e, focusedQuestion: f, spModel: g, dateModel: h, animated: i};
	});
var _CareerPlug$ats$PdfForm_Model$Config = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return {formId: a, readonly: b, taker: c, title: d, states: e, formUrl: f, questionUrl: g, startpage: h, fieldTypeConversion: i, errors: j, canDrawSignature: k, submitButton: l, mobilePivot: m, viewMode: n, pointerEvent: o};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$PdfForm_Model$Finished = {ctor: 'Finished'};
var _CareerPlug$ats$PdfForm_Model$MobilePDF = function (a) {
	return {ctor: 'MobilePDF', _0: a};
};
var _CareerPlug$ats$PdfForm_Model$MobileForm = function (a) {
	return {ctor: 'MobileForm', _0: a};
};
var _CareerPlug$ats$PdfForm_Model$Desktop = function (a) {
	return {ctor: 'Desktop', _0: a};
};
var _CareerPlug$ats$PdfForm_Model$initialViewMode = F2(
	function (dim, pivot) {
		return (_elm_lang$core$Native_Utils.cmp(dim.screenWidth, pivot) < 1) ? _CareerPlug$ats$PdfForm_Model$MobileForm(dim) : _CareerPlug$ats$PdfForm_Model$Desktop(dim);
	});
var _CareerPlug$ats$PdfForm_Model$jsonConfig = function () {
	var stringTuples = A3(
		_elm_lang$core$Json_Decode$map2,
		F2(
			function (v0, v1) {
				return {ctor: '_Tuple2', _0: v0, _1: v1};
			}),
		A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string),
		A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string));
	var iViewMode = F2(
		function (w, pos) {
			var dim = {screenWidth: w, scrollTop: 0, appTop: 0, appMaxHeight: 0, appWidth: 0, pageTop: 0, pageHeight: 0, pageWidth: 0};
			return A2(_CareerPlug$ats$PdfForm_Model$initialViewMode, dim, pos);
		});
	var viewMode = A3(
		_elm_lang$core$Json_Decode$map2,
		iViewMode,
		A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$int),
		A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$int));
	var jsonTitle = _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: _elm_lang$core$Json_Decode$string,
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Basics$toString, _elm_lang$core$Json_Decode$int),
				_1: {ctor: '[]'}
			}
		});
	var consolidatedString = A2(
		_elm_lang$core$Json_Decode$map,
		_elm_lang$core$String$join(', '),
		_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string));
	var jsonErrors = _elm_lang$core$Json_Decode$oneOf(
		{
			ctor: '::',
			_0: A2(
				_elm_lang$core$Json_Decode$field,
				'errors',
				_elm_lang$core$Json_Decode$dict(_elm_lang$core$Json_Decode$string)),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$core$Json_Decode$field,
					'errors',
					_elm_lang$core$Json_Decode$dict(consolidatedString)),
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$succeed(_elm_lang$core$Dict$empty),
					_1: {ctor: '[]'}
				}
			}
		});
	var jsonFieldTypeConversion = _elm_lang$core$Json_Decode$dict(
		A2(_elm_lang$core$Json_Decode$map, _CareerPlug$ats$Models_Question$strQuestionType, _elm_lang$core$Json_Decode$string));
	return A3(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
		'pointerEvent',
		_elm_lang$core$Json_Decode$bool,
		A3(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
			'mobilePivot',
			viewMode,
			A3(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
				'mobilePivot',
				A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$int),
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'submitButton',
					_elm_lang$core$Json_Decode$string,
					'Submit',
					A4(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
						'canDrawSignature',
						_elm_lang$core$Json_Decode$bool,
						true,
						A4(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
							'model',
							jsonErrors,
							_elm_lang$core$Dict$empty,
							A4(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
								'invertedFieldTypes',
								jsonFieldTypeConversion,
								_elm_lang$core$Dict$empty,
								A4(
									_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
									'startpage',
									_elm_lang$core$Json_Decode$int,
									0,
									A3(
										_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
										'questionUrl',
										_elm_lang$core$Json_Decode$string,
										A3(
											_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
											'formUrl',
											_elm_lang$core$Json_Decode$string,
											A3(
												_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
												'states',
												_elm_lang$core$Json_Decode$list(stringTuples),
												A3(
													_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
													'title',
													jsonTitle,
													A4(
														_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
														'taker',
														_CareerPlug$ats$Models_Question$jsonTaker,
														_CareerPlug$ats$Models_Question$Employee,
														A4(
															_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
															'readonly',
															_elm_lang$core$Json_Decode$bool,
															false,
															A3(
																_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
																'form',
																_elm_lang$core$Json_Decode$int,
																_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$PdfForm_Model$Config))))))))))))))));
}();
var _CareerPlug$ats$PdfForm_Model$Loading = {ctor: 'Loading'};
var _CareerPlug$ats$PdfForm_Model$blankConfig = {
	formId: 0,
	readonly: false,
	taker: _CareerPlug$ats$Models_Question$Employee,
	title: '',
	states: {ctor: '[]'},
	formUrl: '',
	questionUrl: '',
	startpage: 0,
	fieldTypeConversion: _elm_lang$core$Dict$empty,
	errors: _elm_lang$core$Dict$empty,
	canDrawSignature: true,
	submitButton: '',
	mobilePivot: 0,
	viewMode: _CareerPlug$ats$PdfForm_Model$Loading,
	pointerEvent: false
};
var _CareerPlug$ats$PdfForm_Model$blankModel = {
	config: _CareerPlug$ats$PdfForm_Model$blankConfig,
	form: A2(
		_etaque$elm_form$Form$initial,
		{ctor: '[]'},
		_CareerPlug$ats$PdfForm_Model$validate(
			{ctor: '[]'})),
	questions: {ctor: '[]'},
	thumbnails: _elm_lang$core$Dict$empty,
	viewMode: _CareerPlug$ats$PdfForm_Model$Loading,
	focusedQuestion: _elm_lang$core$Maybe$Nothing,
	spModel: _elm_lang$core$Dict$empty,
	dateModel: _elm_lang$core$Dict$empty,
	animated: _elm_lang$core$Dict$empty
};

var _CareerPlug$ats$PdfForm_FormView$customFormView = F3(
	function (mdim, model, singleFn) {
		var styleList = function () {
			var _p0 = mdim;
			if (_p0.ctor === 'Just') {
				return {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'min-height',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p0._0.appMaxHeight),
							'px')
					},
					_1: {ctor: '[]'}
				};
			} else {
				return {ctor: '[]'};
			}
		}();
		var submitArea = model.config.readonly ? _elm_lang$html$Html$text('') : A2(
			_elm_lang$html$Html$fieldset,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('form-actions'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$input,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_CareerPlug$ats$PdfForm_Message$FormMsg(_etaque$elm_form$Form$Submit)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$type_('button'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$value(model.config.submitButton),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('btn btn-primary'),
									_1: {ctor: '[]'}
								}
							}
						}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			});
		var dateClass = _elm_lang$core$List$isEmpty(
			A2(
				_elm_lang$core$List$filter,
				function (q) {
					return _elm_lang$core$Native_Utils.eq(q.questionType, _CareerPlug$ats$Models_Question$DateField);
				},
				model.questions)) ? '' : ' has-date-field';
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(_elm_lang$core$Basics_ops['++'], 'form-view', dateClass)),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(styleList),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('form-view-wrapper'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$fieldset,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('inputs'),
								_1: {ctor: '[]'}
							},
							A2(
								_elm_lang$core$List$map,
								singleFn(model),
								A2(
									_elm_lang$core$List$sortBy,
									function (_) {
										return _.order;
									},
									A2(
										_elm_lang$core$List$filter,
										function (q) {
											return (!model.config.readonly) && _elm_lang$core$Native_Utils.eq(model.config.taker, q.visibility);
										},
										model.questions)))),
						_1: {
							ctor: '::',
							_0: submitArea,
							_1: {ctor: '[]'}
						}
					}),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$PdfForm_FormView$singleField = F3(
	function (question, form, fn) {
		return A2(
			_elm_lang$html$Html$map,
			_CareerPlug$ats$PdfForm_Message$FormMsg,
			A5(
				fn,
				{ctor: '[]'},
				question.name,
				A2(
					_etaque$elm_form$Form$getFieldAsString,
					_CareerPlug$ats$Models_Question$questionName(question),
					form),
				question.description,
				question.required));
	});
var _CareerPlug$ats$PdfForm_FormView$dateField = F3(
	function (model, question, maybeError) {
		var dpConfig = _CareerPlug$ats$Library_Date$withCoreParser(
			_abadi199$datetimepicker$DateTimePicker_Config$defaultDatePickerConfig(
				_CareerPlug$ats$PdfForm_Message$DateMsg(question.id)));
		var qname = _CareerPlug$ats$Models_Question$questionName(question);
		var maybeDate = A2(
			_elm_lang$core$Maybe$andThen,
			function (d) {
				return _elm_lang$core$Result$toMaybe(
					_elm_lang$core$Date$fromString(d));
			},
			A2(_etaque$elm_form$Form$getFieldAsString, qname, model.form).value);
		var _p1 = A2(_elm_lang$core$Dict$get, question.id, model.dateModel);
		if (_p1.ctor === 'Just') {
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(
						A2(
							_elm_lang$core$Basics_ops['++'],
							'form-group ',
							_CareerPlug$ats$Library_BootstrapForm$errorClass(maybeError))),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(_CareerPlug$ats$Library_BootstrapForm$controlLabel, question.name, question.required),
					_1: {
						ctor: '::',
						_0: A4(
							_abadi199$datetimepicker$DateTimePicker$datePickerWithConfig,
							dpConfig,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id(qname),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('form-control'),
									_1: {ctor: '[]'}
								}
							},
							_p1._0,
							maybeDate),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$map,
								_CareerPlug$ats$PdfForm_Message$FormMsg,
								A2(_CareerPlug$ats$Library_BootstrapForm$errorMessage, maybeError, question.description)),
							_1: {ctor: '[]'}
						}
					}
				});
		} else {
			return _elm_lang$html$Html$text('');
		}
	});
var _CareerPlug$ats$PdfForm_FormView$singleFormQuestion = F2(
	function (model, question) {
		var qname = _CareerPlug$ats$Models_Question$questionName(question);
		var options = function (vals) {
			return {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: '', _1: ''},
				_1: vals
			};
		};
		var opts = function (q) {
			return A2(
				_elm_lang$core$List$map,
				function (ans) {
					return {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Basics$toString(ans.id),
						_1: ans.name
					};
				},
				q.answers);
		};
		var field = function (fn) {
			return A3(_CareerPlug$ats$PdfForm_FormView$singleField, question, model.form, fn);
		};
		var _p2 = question.questionType;
		switch (_p2.ctor) {
			case 'CheckboxField':
				return A2(
					_elm_lang$html$Html$map,
					_CareerPlug$ats$PdfForm_Message$FormMsg,
					A5(
						_CareerPlug$ats$Library_BootstrapForm$checkboxGroup,
						{ctor: '[]'},
						question.name,
						A2(_etaque$elm_form$Form$getFieldAsBool, qname, model.form),
						question.description,
						question.required));
			case 'CountryField':
				return field(
					_CareerPlug$ats$Library_BootstrapForm$selectGroup(
						options(
							A2(
								_elm_lang$core$List$map,
								function (_p3) {
									var _p4 = _p3;
									var _p5 = _p4._1;
									return {ctor: '_Tuple2', _0: _p5, _1: _p5};
								},
								_CareerPlug$ats$Models_Country$optionList))));
			case 'DateField':
				return A3(
					_CareerPlug$ats$PdfForm_FormView$dateField,
					model,
					question,
					A2(_etaque$elm_form$Form$getFieldAsString, qname, model.form).liveError);
			case 'MultiSelectField':
				return field(
					_CareerPlug$ats$Library_BootstrapForm$selectGroup(
						options(
							opts(question))));
			case 'RadioField':
				return field(
					_CareerPlug$ats$Library_BootstrapForm$radioGroup(
						opts(question)));
			case 'SelectField':
				return field(
					_CareerPlug$ats$Library_BootstrapForm$selectGroup(
						options(
							opts(question))));
			case 'SignatureField':
				var _p6 = A2(_elm_lang$core$Dict$get, question.id, model.spModel);
				if (_p6.ctor === 'Just') {
					return A8(
						_CareerPlug$ats$Library_SignaturePad$view,
						_CareerPlug$ats$PdfForm_Message$SPMsg(question.id),
						_CareerPlug$ats$PdfForm_Message$FormMsg,
						model.config.pointerEvent,
						model.config.canDrawSignature,
						question.name,
						qname,
						A2(_etaque$elm_form$Form$getFieldAsString, qname, model.form).liveError,
						_p6._0);
				} else {
					return _elm_lang$html$Html$text('');
				}
			case 'StateField':
				return field(
					_CareerPlug$ats$Library_BootstrapForm$selectGroup(
						options(model.config.states)));
			case 'TextAreaField':
				return field(_CareerPlug$ats$Library_BootstrapForm$textAreaGroup);
			case 'YesNoField':
				return field(
					_CareerPlug$ats$Library_BootstrapForm$selectGroup(
						options(
							opts(question))));
			default:
				return field(_CareerPlug$ats$Library_BootstrapForm$textGroup);
		}
	});
var _CareerPlug$ats$PdfForm_FormView$formView = F2(
	function (mdim, model) {
		return A3(_CareerPlug$ats$PdfForm_FormView$customFormView, mdim, model, _CareerPlug$ats$PdfForm_FormView$singleFormQuestion);
	});

var _CareerPlug$ats$PdfForm_PdfView$renderText = F3(
	function (model, question, value) {
		var spacing = (!_elm_lang$core$Native_Utils.eq(question.spacing, '0')) ? {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'letter-spacing',
				_1: A2(_elm_lang$core$Basics_ops['++'], question.spacing, 'px')
			},
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var opaque = question.opaque ? {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'background', _1: 'white'},
			_1: {ctor: '[]'}
		} : {ctor: '[]'};
		var align = function () {
			var _p0 = question.align;
			switch (_p0.ctor) {
				case 'Center':
					return {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'text-align', _1: 'center'},
						_1: {ctor: '[]'}
					};
				case 'Right':
					return {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'text-align', _1: 'right'},
						_1: {ctor: '[]'}
					};
				case 'Justify':
					return {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'text-align', _1: 'justify'},
						_1: {ctor: '[]'}
					};
				default:
					return {ctor: '[]'};
			}
		}();
		var overflow = function () {
			var _p1 = question.overflow;
			if (_p1.ctor === 'Truncate') {
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'overflow', _1: 'hidden'},
					_1: {ctor: '[]'}
				};
			} else {
				return {ctor: '[]'};
			}
		}();
		var sizeForView = function (dim) {
			var wMult = _elm_lang$core$Basics$toFloat(dim.pageWidth) / _elm_lang$core$Basics$toFloat(dim.screenWidth);
			var defaultSize = (_elm_lang$core$Basics$toFloat(question.size) * wMult) * 0.166666;
			var realSize = function () {
				var _p2 = question.overflow;
				if (_p2.ctor === 'Shrink') {
					var maxLength = (_elm_lang$core$Basics$toFloat(dim.pageWidth) * (question.position.width / 100)) / 8.0;
					var vLen = _elm_lang$core$Basics$toFloat(
						_elm_lang$core$String$length(value));
					var mult = (_elm_lang$core$Native_Utils.cmp(vLen, maxLength) > 0) ? (maxLength / vLen) : 1.0;
					return defaultSize * mult;
				} else {
					return defaultSize;
				}
			}();
			return {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'font-size',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(realSize),
						'vw')
				},
				_1: {ctor: '[]'}
			};
		};
		var size = function () {
			var _p3 = model.viewMode;
			switch (_p3.ctor) {
				case 'Desktop':
					return sizeForView(_p3._0);
				case 'MobileForm':
					return sizeForView(_p3._0);
				case 'MobilePDF':
					return sizeForView(_p3._0);
				default:
					return {ctor: '[]'};
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('text-wrapper'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						_elm_lang$core$List$concat(
							{
								ctor: '::',
								_0: size,
								_1: {
									ctor: '::',
									_0: overflow,
									_1: {
										ctor: '::',
										_0: align,
										_1: {
											ctor: '::',
											_0: opaque,
											_1: {
												ctor: '::',
												_0: spacing,
												_1: {ctor: '[]'}
											}
										}
									}
								}
							})),
					_1: {ctor: '[]'}
				}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text(value),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$PdfForm_PdfView$blankField = function (divId) {
	return A2(
		_elm_lang$html$Html$span,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$id(
				A2(_elm_lang$core$Basics_ops['++'], 'pdf_', divId)),
			_1: {ctor: '[]'}
		},
		{ctor: '[]'});
};
var _CareerPlug$ats$PdfForm_PdfView$withAnswer = F3(
	function (form, question, fn) {
		var mAns = A2(
			_elm_lang$core$Maybe$andThen,
			function (v) {
				return A2(_CareerPlug$ats$Models_Question$findAnswer, question, v);
			},
			A2(
				_etaque$elm_form$Form$getFieldAsString,
				_CareerPlug$ats$Models_Question$questionName(question),
				form).value);
		var _p4 = mAns;
		if (_p4.ctor === 'Just') {
			return fn(_p4._0);
		} else {
			return _CareerPlug$ats$PdfForm_PdfView$blankField(
				_CareerPlug$ats$Models_Question$questionName(question));
		}
	});
var _CareerPlug$ats$PdfForm_PdfView$outlinePos = function (pos) {
	var yMult = 0.5;
	var xMult = 0.7;
	return {left: pos.left - xMult, top: pos.top - yMult, width: pos.width + (xMult * 2), height: pos.height + (yMult * 2)};
};
var _CareerPlug$ats$PdfForm_PdfView$posToStyle = function (pos) {
	return {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'left',
			_1: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(pos.left),
				'%')
		},
		_1: {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'top',
				_1: A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(pos.top),
					'%')
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'width',
					_1: A2(
						_elm_lang$core$Basics_ops['++'],
						_elm_lang$core$Basics$toString(pos.width),
						'%')
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'height',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(pos.height),
							'%')
					},
					_1: {ctor: '[]'}
				}
			}
		}
	};
};
var _CareerPlug$ats$PdfForm_PdfView$renderQuestion = F3(
	function (divId, pos, node) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('question'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$id(
						A2(_elm_lang$core$Basics_ops['++'], 'pdf_', divId)),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$style(
							_CareerPlug$ats$PdfForm_PdfView$posToStyle(pos)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: node,
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$PdfForm_PdfView$filledCheckbox = F2(
	function (qname, pos) {
		return A3(
			_CareerPlug$ats$PdfForm_PdfView$renderQuestion,
			qname,
			pos,
			A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('filled'),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'}));
	});
var _CareerPlug$ats$PdfForm_PdfView$questionBox = F2(
	function (form, question) {
		var _p5 = A2(
			_etaque$elm_form$Form$getFieldAsBool,
			_CareerPlug$ats$Models_Question$questionName(question),
			form).value;
		if (_p5.ctor === 'Just') {
			return _p5._0 ? A2(
				_CareerPlug$ats$PdfForm_PdfView$filledCheckbox,
				_CareerPlug$ats$Models_Question$questionName(question),
				question.position) : _CareerPlug$ats$PdfForm_PdfView$blankField(
				_CareerPlug$ats$Models_Question$questionName(question));
		} else {
			return _CareerPlug$ats$PdfForm_PdfView$blankField(
				_CareerPlug$ats$Models_Question$questionName(question));
		}
	});
var _CareerPlug$ats$PdfForm_PdfView$answerBox = F2(
	function (form, question) {
		return A3(
			_CareerPlug$ats$PdfForm_PdfView$withAnswer,
			form,
			question,
			function (ans) {
				return A2(
					_CareerPlug$ats$PdfForm_PdfView$filledCheckbox,
					_CareerPlug$ats$Models_Question$questionName(question),
					ans.position);
			});
	});
var _CareerPlug$ats$PdfForm_PdfView$answerText = F2(
	function (model, question) {
		var mVal = A2(
			_etaque$elm_form$Form$getFieldAsString,
			_CareerPlug$ats$Models_Question$questionName(question),
			model.form).value;
		var mAns = A2(
			_elm_lang$core$Maybe$andThen,
			function (v) {
				return A2(_CareerPlug$ats$Models_Question$findAnswer, question, v);
			},
			mVal);
		var _p6 = {ctor: '_Tuple2', _0: mVal, _1: mAns};
		if (((_p6.ctor === '_Tuple2') && (_p6._0.ctor === 'Just')) && (_p6._1.ctor === 'Nothing')) {
			return A3(
				_CareerPlug$ats$PdfForm_PdfView$renderQuestion,
				_CareerPlug$ats$Models_Question$questionName(question),
				question.position,
				A3(_CareerPlug$ats$PdfForm_PdfView$renderText, model, question, _p6._0._0));
		} else {
			return A3(
				_CareerPlug$ats$PdfForm_PdfView$withAnswer,
				model.form,
				question,
				function (ans) {
					return A3(
						_CareerPlug$ats$PdfForm_PdfView$renderQuestion,
						_CareerPlug$ats$Models_Question$questionName(question),
						question.position,
						A3(_CareerPlug$ats$PdfForm_PdfView$renderText, model, question, ans.name));
				});
		}
	});
var _CareerPlug$ats$PdfForm_PdfView$questionText = F2(
	function (model, question) {
		var qname = _CareerPlug$ats$Models_Question$questionName(question);
		var _p7 = A2(_etaque$elm_form$Form$getFieldAsString, qname, model.form).value;
		if (_p7.ctor === 'Just') {
			return A3(
				_CareerPlug$ats$PdfForm_PdfView$renderQuestion,
				qname,
				question.position,
				A3(_CareerPlug$ats$PdfForm_PdfView$renderText, model, question, _p7._0));
		} else {
			return _CareerPlug$ats$PdfForm_PdfView$blankField(qname);
		}
	});
var _CareerPlug$ats$PdfForm_PdfView$pageView = F2(
	function (model, _p8) {
		var _p9 = _p8;
		var _p15 = _p9._0;
		var focusedQuestion = function () {
			var _p10 = {
				ctor: '_Tuple3',
				_0: model.focusedQuestion,
				_1: A2(_elm_lang$core$Dict$get, 'focus', model.animated),
				_2: A2(_elm_lang$core$Dict$get, 'shadow', model.animated)
			};
			if ((((_p10.ctor === '_Tuple3') && (_p10._0.ctor === 'Just')) && (_p10._1.ctor === 'Just')) && (_p10._2.ctor === 'Just')) {
				var _p12 = _p10._0._0;
				if (_elm_lang$core$Native_Utils.eq(_p12.page, _p15)) {
					var highlight = function (pos) {
						return A2(
							_elm_lang$html$Html$div,
							A2(
								_elm_lang$core$Basics_ops['++'],
								_mdgriffith$elm_style_animation$Animation$render(_p10._1._0),
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('question focused'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$style(
											_CareerPlug$ats$PdfForm_PdfView$posToStyle(
												_CareerPlug$ats$PdfForm_PdfView$outlinePos(pos))),
										_1: {ctor: '[]'}
									}
								}),
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									A2(
										_elm_lang$core$Basics_ops['++'],
										_mdgriffith$elm_style_animation$Animation$render(_p10._2._0),
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('shadow'),
											_1: {ctor: '[]'}
										}),
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							});
					};
					var _p11 = _p12.questionType;
					if (_p11.ctor === 'RadioField') {
						return A2(
							_elm_lang$html$Html$div,
							{ctor: '[]'},
							A2(
								_elm_lang$core$List$map,
								function (ans) {
									return highlight(ans.position);
								},
								_p12.answers));
					} else {
						return highlight(_p12.position);
					}
				} else {
					return _elm_lang$html$Html$text('');
				}
			} else {
				return _elm_lang$html$Html$text('');
			}
		}();
		var questionView = function (q) {
			var _p13 = q.questionType;
			switch (_p13.ctor) {
				case 'CheckboxField':
					return A2(_CareerPlug$ats$PdfForm_PdfView$questionBox, model.form, q);
				case 'RadioField':
					return A2(_CareerPlug$ats$PdfForm_PdfView$answerBox, model.form, q);
				case 'MultiSelectField':
					return A2(_CareerPlug$ats$PdfForm_PdfView$answerText, model, q);
				case 'SelectField':
					return A2(_CareerPlug$ats$PdfForm_PdfView$answerText, model, q);
				case 'SignatureField':
					var qname = _CareerPlug$ats$Models_Question$questionName(q);
					var _p14 = A2(_elm_lang$core$Dict$get, q.id, model.spModel);
					if (_p14.ctor === 'Just') {
						return A3(
							_CareerPlug$ats$PdfForm_PdfView$renderQuestion,
							qname,
							q.position,
							_CareerPlug$ats$Library_SignaturePad$signatureView(_p14._0));
					} else {
						return _CareerPlug$ats$PdfForm_PdfView$blankField(qname);
					}
				case 'YesNoField':
					return A2(_CareerPlug$ats$PdfForm_PdfView$answerText, model, q);
				default:
					return A2(_CareerPlug$ats$PdfForm_PdfView$questionText, model, q);
			}
		};
		var pageQuestions = A2(
			_elm_lang$core$List$map,
			questionView,
			A2(
				_elm_lang$core$List$filter,
				function (q) {
					return _elm_lang$core$Native_Utils.eq(q.page, _p15);
				},
				model.questions));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(
						_elm_lang$core$Basics_ops['++'],
						'page page-',
						_elm_lang$core$Basics$toString(_p15))),
				_1: {ctor: '[]'}
			},
			A2(
				_elm_lang$core$Basics_ops['++'],
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$img,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$src(_p9._1),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: focusedQuestion,
						_1: {ctor: '[]'}
					}
				},
				pageQuestions));
	});
var _CareerPlug$ats$PdfForm_PdfView$pdfView = F2(
	function (dim, model) {
		var styleList = function () {
			var _p16 = dim;
			if (_p16.ctor === 'Just') {
				var _p18 = _p16._0;
				var pageWidth = function () {
					var mult = function () {
						var _p17 = model.viewMode;
						if (_p17.ctor === 'Desktop') {
							return 0.666666;
						} else {
							return 0.5;
						}
					}();
					return _elm_lang$core$Basics$round(
						_elm_lang$core$Basics$toFloat(_p18.appWidth) * mult);
				}();
				var pos = (_elm_lang$core$Native_Utils.cmp(_p18.scrollTop, _p18.appTop - _p18.pageTop) > 0) ? 'fixed' : 'static';
				var def = {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'max-height',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(
								A2(_elm_lang$core$Basics$min, _p18.appMaxHeight, _p18.pageHeight)),
							'px')
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'width',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(pageWidth),
								'px')
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'top',
								_1: A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_p18.pageTop),
									'px')
							},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'overflow-y', _1: 'scroll'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'position', _1: pos},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				};
				return (_elm_lang$core$Native_Utils.cmp(_p18.pageHeight, 0) > 0) ? def : {ctor: '[]'};
			} else {
				return {ctor: '[]'};
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('pdf-view-container'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(styleList),
					_1: {ctor: '[]'}
				}
			},
			A2(
				_elm_lang$core$List$map,
				_CareerPlug$ats$PdfForm_PdfView$pageView(model),
				_elm_lang$core$Dict$toList(model.thumbnails)));
	});

var _CareerPlug$ats$PdfForm$subscriptions = function (model) {
	return _elm_lang$core$Platform_Sub$batch(
		{
			ctor: '::',
			_0: A2(_CareerPlug$ats$PdfForm_Ports$handleResult, _CareerPlug$ats$PdfForm_Message$HandleInboundData, _CareerPlug$ats$PdfForm_Message$HandleInboundError),
			_1: {
				ctor: '::',
				_0: A2(
					_mdgriffith$elm_style_animation$Animation$subscription,
					_CareerPlug$ats$PdfForm_Message$Animate,
					A2(
						_elm_lang$core$List$map,
						_elm_lang$core$Tuple$second,
						_elm_lang$core$Dict$toList(model.animated))),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$PdfForm$hiddenFields = F2(
	function (model, mFields) {
		var hiddenField = F2(
			function (fields, q) {
				var fname = _elm_lang$core$String$concat(
					{
						ctor: '::',
						_0: 'form_model[',
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Models_Question$questionName(q),
							_1: {
								ctor: '::',
								_0: ']',
								_1: {ctor: '[]'}
							}
						}
					});
				var mAns = A2(_elm_lang$core$Dict$get, q.id, fields);
				var val = function () {
					var _p0 = mAns;
					if (_p0.ctor === 'Just') {
						return _CareerPlug$ats$Models_Response$responseString(_p0._0);
					} else {
						return '';
					}
				}();
				var _p1 = q.questionType;
				if (_p1.ctor === 'SignatureField') {
					var _p2 = A2(_elm_lang$core$Dict$get, q.id, model.spModel);
					if (_p2.ctor === 'Just') {
						var _p3 = _CareerPlug$ats$Library_SignaturePad$signature(_p2._0);
						if (_p3.ctor === 'Just') {
							var _p4 = _p3._0;
							return A2(
								_elm_lang$html$Html$div,
								{ctor: '[]'},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$input,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$name(
												A2(_elm_lang$core$Basics_ops['++'], fname, '[signed_by]')),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$type_('hidden'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$value(_p4.signed_by),
													_1: {ctor: '[]'}
												}
											}
										},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$input,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$name(
													A2(_elm_lang$core$Basics_ops['++'], fname, '[signature]')),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$type_('hidden'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$value(_p4.signature),
														_1: {ctor: '[]'}
													}
												}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								});
						} else {
							return _elm_lang$html$Html$text('');
						}
					} else {
						return _elm_lang$html$Html$text('');
					}
				} else {
					return A2(
						_elm_lang$html$Html$input,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$name(fname),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$type_('hidden'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$value(val),
									_1: {ctor: '[]'}
								}
							}
						},
						{ctor: '[]'});
				}
			});
		var _p5 = mFields;
		if (_p5.ctor === 'Just') {
			return A2(
				_elm_lang$core$List$map,
				hiddenField(_p5._0),
				model.questions);
		} else {
			return {ctor: '[]'};
		}
	});
var _CareerPlug$ats$PdfForm$customView = F3(
	function (model, formViewFn, pdfViewFn) {
		var renderReadOnly = {
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('pdf-form-wrapper full'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('pdf-view'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(pdfViewFn, _elm_lang$core$Maybe$Nothing, model),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		};
		var mobileSwitchView = function () {
			var _p6 = model.viewMode;
			switch (_p6.ctor) {
				case 'MobileForm':
					return A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('mobile-switch-button showing-form'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$a,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$PdfForm_Message$MobileSwitch),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('View PDF'),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$i,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('fa fa-arrow-right'),
												_1: {ctor: '[]'}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						});
				case 'MobilePDF':
					return A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('mobile-switch-button showing-pdf'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$a,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$PdfForm_Message$MobileSwitch),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('fa fa-arrow-left'),
											_1: {ctor: '[]'}
										},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html$text('Back to Form'),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						});
				default:
					return _elm_lang$html$Html$text('');
			}
		}();
		var _p7 = function () {
			var _p8 = model.viewMode;
			switch (_p8.ctor) {
				case 'MobileForm':
					return {ctor: '_Tuple2', _0: 'mobile', _1: '0'};
				case 'MobilePDF':
					return {
						ctor: '_Tuple2',
						_0: 'mobile',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Basics$toString(_p8._0.appWidth * -1),
							'px')
					};
				default:
					return {ctor: '_Tuple2', _0: '', _1: '0'};
			}
		}();
		var mobileClass = _p7._0;
		var wrapperLeft = _p7._1;
		var renderPdfView = function (dim) {
			return {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('pdf-form-wrapper'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$style(
								{
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: 'left', _1: wrapperLeft},
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: mobileSwitchView,
						_1: {
							ctor: '::',
							_0: A2(formViewFn, dim, model),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('pdf-view'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(pdfViewFn, dim, model),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {ctor: '[]'}
			};
		};
		var content = function () {
			if (model.config.readonly) {
				return renderReadOnly;
			} else {
				var _p9 = model.viewMode;
				switch (_p9.ctor) {
					case 'Loading':
						return {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('pdf-form-loading well'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$h1,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('text-center'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text(
												_elm_lang$core$String$concat(
													{
														ctor: '::',
														_0: 'Preparing ',
														_1: {
															ctor: '::',
															_0: model.config.title,
															_1: {
																ctor: '::',
																_0: '…',
																_1: {ctor: '[]'}
															}
														}
													})),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$h1,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('text-center'),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('fa fa-refresh fa-spin'),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$p,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('text-center'),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text('This can take a while, please be patient.'),
													_1: {ctor: '[]'}
												}),
											_1: {ctor: '[]'}
										}
									}
								}),
							_1: {ctor: '[]'}
						};
					case 'Finished':
						return {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('pdf-form-finished well'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('Submitting response… please wait.'),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{ctor: '[]'},
									A2(
										_CareerPlug$ats$PdfForm$hiddenFields,
										model,
										_etaque$elm_form$Form$getOutput(model.form))),
								_1: {ctor: '[]'}
							}
						};
					case 'Desktop':
						return renderPdfView(
							_elm_lang$core$Maybe$Just(_p9._0));
					default:
						return renderPdfView(_elm_lang$core$Maybe$Nothing);
				}
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(
						_elm_lang$core$String$join,
						' ',
						{
							ctor: '::',
							_0: 'pdf-form',
							_1: {
								ctor: '::',
								_0: mobileClass,
								_1: {ctor: '[]'}
							}
						})),
				_1: {ctor: '[]'}
			},
			content);
	});
var _CareerPlug$ats$PdfForm$view = function (model) {
	return A3(_CareerPlug$ats$PdfForm$customView, model, _CareerPlug$ats$PdfForm_FormView$formView, _CareerPlug$ats$PdfForm_PdfView$pdfView);
};
var _CareerPlug$ats$PdfForm$getThumbnails = function (config) {
	var jsonThumbnail = function () {
		var strKeysToInts = function (xs) {
			return A2(
				_elm_lang$core$List$map,
				function (_p10) {
					var _p11 = _p10;
					return {
						ctor: '_Tuple2',
						_0: A2(
							_elm_lang$core$Result$withDefault,
							1,
							_elm_lang$core$String$toInt(_p11._0)),
						_1: _p11._1
					};
				},
				xs);
		};
		return A2(
			_elm_lang$core$Json_Decode$map,
			_elm_lang$core$Dict$fromList,
			A2(
				_elm_lang$core$Json_Decode$map,
				strKeysToInts,
				A2(
					_elm_lang$core$Json_Decode$field,
					'thumbnails',
					_elm_lang$core$Json_Decode$keyValuePairs(_elm_lang$core$Json_Decode$string))));
	}();
	var url = _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: config.formUrl,
			_1: {
				ctor: '::',
				_0: '/',
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(config.formId),
					_1: {ctor: '[]'}
				}
			}
		});
	return A2(_elm_lang$http$Http$get, url, jsonThumbnail);
};
var _CareerPlug$ats$PdfForm$getQuestions = function (config) {
	var ftConv = function (s) {
		var _p12 = A2(_elm_lang$core$Dict$get, s, config.fieldTypeConversion);
		if (_p12.ctor === 'Just') {
			return _p12._0;
		} else {
			return _CareerPlug$ats$Models_Question$strQuestionType(s);
		}
	};
	var url = _elm_lang$core$String$concat(
		{
			ctor: '::',
			_0: config.questionUrl,
			_1: {
				ctor: '::',
				_0: '?owner_id=',
				_1: {
					ctor: '::',
					_0: _elm_lang$core$Basics$toString(config.formId),
					_1: {
						ctor: '::',
						_0: '&owner_type=Form',
						_1: {ctor: '[]'}
					}
				}
			}
		});
	return A2(
		_elm_lang$http$Http$get,
		url,
		_elm_lang$core$Json_Decode$list(
			_CareerPlug$ats$Models_Question$jsonQuestion(ftConv)));
};
var _CareerPlug$ats$PdfForm$clearServerErrors = F2(
	function (model, qname) {
		var clearServerError = function (q) {
			return _elm_lang$core$Native_Utils.eq(
				_CareerPlug$ats$Models_Question$questionName(q),
				qname) ? _elm_lang$core$Native_Utils.update(
				q,
				{serverError: _elm_lang$core$Maybe$Nothing}) : q;
		};
		var questions = A2(_elm_lang$core$List$map, clearServerError, model.questions);
		return A2(
			_elm_lang$core$Platform_Cmd_ops['!'],
			_elm_lang$core$Native_Utils.update(
				model,
				{questions: questions}),
			{
				ctor: '::',
				_0: _CareerPlug$ats$Library_Update$msgEffect(
					_CareerPlug$ats$PdfForm_Message$FormMsg(_etaque$elm_form$Form$Validate)),
				_1: {ctor: '[]'}
			});
	});
var _CareerPlug$ats$PdfForm$focusQuestion = F2(
	function (model, qname) {
		var animated = function () {
			var _p13 = A2(_elm_lang$core$Dict$get, 'focus', model.animated);
			if (_p13.ctor === 'Just') {
				var val = A2(
					_mdgriffith$elm_style_animation$Animation$interrupt,
					{
						ctor: '::',
						_0: _mdgriffith$elm_style_animation$Animation$to(
							{
								ctor: '::',
								_0: _mdgriffith$elm_style_animation$Animation$opacity(1.0),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					},
					_p13._0);
				return A3(_elm_lang$core$Dict$insert, 'focus', val, model.animated);
			} else {
				return model.animated;
			}
		}();
		var animated_ = function () {
			var _p14 = A2(_elm_lang$core$Dict$get, 'shadow', animated);
			if (_p14.ctor === 'Just') {
				var val = A2(
					_mdgriffith$elm_style_animation$Animation$interrupt,
					{
						ctor: '::',
						_0: A2(
							_mdgriffith$elm_style_animation$Animation$toWith,
							_mdgriffith$elm_style_animation$Animation$spring(
								{stiffness: 400, damping: 23}),
							{
								ctor: '::',
								_0: _mdgriffith$elm_style_animation$Animation$opacity(1.0),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_mdgriffith$elm_style_animation$Animation$toWith,
								_mdgriffith$elm_style_animation$Animation$spring(
									{stiffness: 800, damping: 23}),
								{
									ctor: '::',
									_0: _mdgriffith$elm_style_animation$Animation$opacity(0.0),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					},
					_p14._0);
				return A3(_elm_lang$core$Dict$insert, 'shadow', val, animated);
			} else {
				return animated;
			}
		}();
		var focusedQuestion = A2(_CareerPlug$ats$Models_Question$questionFromName, model.questions, qname);
		var effects = function () {
			var _p15 = {ctor: '_Tuple2', _0: model.viewMode, _1: focusedQuestion};
			if (((_p15.ctor === '_Tuple2') && (_p15._0.ctor === 'Desktop')) && (_p15._1.ctor === 'Just')) {
				var _p17 = _p15._1._0;
				var _p16 = _p15._0._0;
				var top = _p17.position.top / 100.0;
				var inPage = _elm_lang$core$Basics$toFloat(_p16.pageHeight) * top;
				var page = _p16.pageHeight * (_p17.page - 1);
				var scroll = A2(
					_elm_lang$core$Basics$max,
					0,
					(page + _elm_lang$core$Basics$round(inPage)) - 50);
				return {
					ctor: '::',
					_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(
						A2(_CareerPlug$ats$PdfForm_Ports$ScrollTop, '.pdf-view-container', scroll)),
					_1: {ctor: '[]'}
				};
			} else {
				return {ctor: '[]'};
			}
		}();
		return A2(
			_elm_lang$core$Platform_Cmd_ops['!'],
			_elm_lang$core$Native_Utils.update(
				model,
				{focusedQuestion: focusedQuestion, animated: animated_}),
			effects);
	});
var _CareerPlug$ats$PdfForm$validQuestions = F2(
	function (model, questions) {
		return A2(
			_elm_lang$core$List$filter,
			function (q) {
				return _elm_lang$core$Native_Utils.eq(model.config.taker, q.visibility);
			},
			questions);
	});
var _CareerPlug$ats$PdfForm$update_ = F3(
	function (msg, model, validator) {
		var _p18 = msg;
		switch (_p18.ctor) {
			case 'FormMsg':
				var _p24 = _p18._0;
				var newForm = A3(_etaque$elm_form$Form$update, validator, _p24, model.form);
				var _p19 = function () {
					var _p20 = _p24;
					switch (_p20.ctor) {
						case 'Submit':
							var _p21 = _etaque$elm_form$Form$getOutput(newForm);
							if (_p21.ctor === 'Just') {
								return A2(
									_elm_lang$core$Platform_Cmd_ops['!'],
									_elm_lang$core$Native_Utils.update(
										model,
										{viewMode: _CareerPlug$ats$PdfForm_Model$Finished}),
									{
										ctor: '::',
										_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(_CareerPlug$ats$PdfForm_Ports$SubmitForm),
										_1: {ctor: '[]'}
									});
							} else {
								var firstError = _elm_lang$core$List$head(
									_etaque$elm_form$Form$getErrors(newForm));
								var effects = function () {
									var _p22 = firstError;
									if (_p22.ctor === 'Just') {
										return {
											ctor: '::',
											_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(
												_CareerPlug$ats$PdfForm_Ports$ScrollWindowTo(
													A2(
														_elm_lang$core$Basics_ops['++'],
														'#',
														_elm_lang$core$Tuple$first(_p22._0)))),
											_1: {ctor: '[]'}
										};
									} else {
										return {ctor: '[]'};
									}
								}();
								var _p23 = A2(
									_elm_lang$core$Debug$log,
									'Failed Form Submission',
									_etaque$elm_form$Form$getErrors(newForm));
								return A2(_elm_lang$core$Platform_Cmd_ops['!'], model, effects);
							}
						case 'Focus':
							return A2(_CareerPlug$ats$PdfForm$focusQuestion, model, _p20._0);
						case 'Blur':
							return A2(_CareerPlug$ats$PdfForm$clearServerErrors, model, _p20._0);
						default:
							return A2(
								_elm_lang$core$Platform_Cmd_ops['!'],
								model,
								{ctor: '[]'});
					}
				}();
				var model_ = _p19._0;
				var effect = _p19._1;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model_,
						{form: newForm}),
					_1: effect
				};
			case 'SetQuestions':
				if (_p18._0.ctor === 'Ok') {
					var _p30 = _p18._0._0;
					var _p25 = _elm_lang$core$Dict$isEmpty(model.thumbnails) ? {
						ctor: '_Tuple2',
						_0: model,
						_1: {ctor: '[]'}
					} : {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{viewMode: model.config.viewMode}),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(
								_CareerPlug$ats$PdfForm_Ports$Measure(
									_elm_lang$core$Dict$values(model.thumbnails))),
							_1: {ctor: '[]'}
						}
					};
					var model_ = _p25._0;
					var effects = _p25._1;
					var dateEffects = A2(
						_elm_lang$core$List$map,
						function (q) {
							return A2(
								_abadi199$datetimepicker$DateTimePicker$initialCmd,
								_CareerPlug$ats$PdfForm_Message$DateMsg(q.id),
								_abadi199$datetimepicker$DateTimePicker$initialState);
						},
						A2(
							_elm_lang$core$List$filter,
							function (q) {
								return _elm_lang$core$Native_Utils.eq(q.questionType, _CareerPlug$ats$Models_Question$DateField);
							},
							A2(_CareerPlug$ats$PdfForm$validQuestions, model, _p30)));
					var sigVal = function (q) {
						var _p26 = A2(
							_etaque$elm_form$Form$getFieldAsString,
							_CareerPlug$ats$Models_Question$questionName(q),
							model.form).value;
						if (_p26.ctor === 'Just') {
							return _p26._0;
						} else {
							return '';
						}
					};
					var spModel = _elm_lang$core$Dict$fromList(
						A2(
							_elm_lang$core$List$map,
							function (q) {
								return {
									ctor: '_Tuple2',
									_0: q.id,
									_1: _CareerPlug$ats$Library_SignaturePad$blankModel(
										sigVal(q))
								};
							},
							A2(
								_elm_lang$core$List$filter,
								function (q) {
									return _elm_lang$core$Native_Utils.eq(q.questionType, _CareerPlug$ats$Models_Question$SignatureField);
								},
								_p30)));
					var mergeQuestion = function (q) {
						var _p27 = A2(
							_elm_lang$core$Dict$get,
							_CareerPlug$ats$Models_Question$questionName(q),
							model.config.errors);
						if (_p27.ctor === 'Nothing') {
							return q;
						} else {
							return _elm_lang$core$Native_Utils.update(
								q,
								{serverError: _p27});
						}
					};
					var questions_ = A2(_elm_lang$core$List$map, mergeQuestion, _p30);
					var form_ = function () {
						var changeField = function (q) {
							var _p28 = q.serverError;
							if (_p28.ctor === 'Just') {
								return true;
							} else {
								return false;
							}
						};
						var hasErrors = function () {
							var _p29 = _elm_lang$core$List$head(
								A2(_elm_lang$core$List$filter, changeField, questions_));
							if (_p29.ctor === 'Just') {
								return true;
							} else {
								return false;
							}
						}();
						var formMsg = hasErrors ? _etaque$elm_form$Form$Submit : _etaque$elm_form$Form$Validate;
						return A3(
							_etaque$elm_form$Form$update,
							_CareerPlug$ats$PdfForm_Model$validate(
								A2(_CareerPlug$ats$PdfForm$validQuestions, model, questions_)),
							formMsg,
							model.form);
					}();
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model_,
							{questions: questions_, spModel: spModel, form: form_}),
						A2(_elm_lang$core$Basics_ops['++'], effects, dateEffects));
				} else {
					var _p31 = A2(_elm_lang$core$Debug$log, 'Failed to Retrieve Questions', _p18._0._0);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			case 'SetThumbnails':
				if (_p18._0.ctor === 'Ok') {
					var _p32 = (_elm_lang$core$Native_Utils.cmp(
						_elm_lang$core$List$length(model.questions),
						0) > 0) ? {
						ctor: '_Tuple2',
						_0: _elm_lang$core$Native_Utils.update(
							model,
							{viewMode: model.config.viewMode}),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(
								_CareerPlug$ats$PdfForm_Ports$Measure(
									_elm_lang$core$Dict$values(model.thumbnails))),
							_1: {ctor: '[]'}
						}
					} : {
						ctor: '_Tuple2',
						_0: model,
						_1: {ctor: '[]'}
					};
					var model_ = _p32._0;
					var effects = _p32._1;
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model_,
							{thumbnails: _p18._0._0}),
						effects);
				} else {
					var _p33 = A2(_elm_lang$core$Debug$log, 'Failed to Retrieve PDF Pages', _p18._0._0);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			case 'MobileSwitch':
				var effects = function () {
					var _p34 = {ctor: '_Tuple2', _0: model.viewMode, _1: model.focusedQuestion};
					_v21_2:
					do {
						if ((_p34.ctor === '_Tuple2') && (_p34._1.ctor === 'Just')) {
							switch (_p34._0.ctor) {
								case 'MobileForm':
									return {
										ctor: '::',
										_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(
											_CareerPlug$ats$PdfForm_Ports$ScrollWindowTo(
												A2(
													_elm_lang$core$Basics_ops['++'],
													'#pdf_',
													_CareerPlug$ats$Models_Question$questionName(_p34._1._0)))),
										_1: {ctor: '[]'}
									};
								case 'MobilePDF':
									return {
										ctor: '::',
										_0: _CareerPlug$ats$PdfForm_Ports$sendCmd(
											_CareerPlug$ats$PdfForm_Ports$ScrollWindowTo(
												A2(
													_elm_lang$core$Basics_ops['++'],
													'#',
													_CareerPlug$ats$Models_Question$questionName(_p34._1._0)))),
										_1: {ctor: '[]'}
									};
								default:
									break _v21_2;
							}
						} else {
							break _v21_2;
						}
					} while(false);
					return {ctor: '[]'};
				}();
				var viewMode_ = function () {
					var _p35 = model.viewMode;
					switch (_p35.ctor) {
						case 'MobileForm':
							return _CareerPlug$ats$PdfForm_Model$MobilePDF(_p35._0);
						case 'MobilePDF':
							return _CareerPlug$ats$PdfForm_Model$MobileForm(_p35._0);
						default:
							return model.viewMode;
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{viewMode: viewMode_}),
					effects);
			case 'HandleInboundData':
				var _p36 = _p18._0;
				var potentialVM = A2(_CareerPlug$ats$PdfForm_Model$initialViewMode, _p36._0, model.config.mobilePivot);
				var viewMode = function () {
					var _p37 = {ctor: '_Tuple2', _0: model.viewMode, _1: potentialVM};
					_v24_3:
					do {
						if (_p37.ctor === '_Tuple2') {
							switch (_p37._0.ctor) {
								case 'MobilePDF':
									if (_p37._1.ctor === 'MobileForm') {
										return _CareerPlug$ats$PdfForm_Model$MobilePDF(_p37._1._0);
									} else {
										break _v24_3;
									}
								case 'Loading':
									return model.viewMode;
								case 'Finished':
									return model.viewMode;
								default:
									break _v24_3;
							}
						} else {
							break _v24_3;
						}
					} while(false);
					return potentialVM;
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{viewMode: viewMode}),
					{ctor: '[]'});
			case 'HandleInboundError':
				var _p38 = A2(_elm_lang$core$Debug$log, 'Failed to handle InboundData', _p18._0);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'SPMsg':
				var _p44 = _p18._1;
				var _p43 = _p18._0;
				var _p39 = {
					ctor: '_Tuple2',
					_0: A2(_elm_lang$core$Dict$get, _p43, model.spModel),
					_1: _elm_lang$core$List$head(
						A2(
							_elm_lang$core$List$filter,
							function (q) {
								return _elm_lang$core$Native_Utils.eq(q.id, _p43);
							},
							model.questions))
				};
				if (((_p39.ctor === '_Tuple2') && (_p39._0.ctor === 'Just')) && (_p39._1.ctor === 'Just')) {
					var _p40 = A3(
						_CareerPlug$ats$Library_SignaturePad$update,
						_CareerPlug$ats$PdfForm_Message$SPMsg(_p43),
						_p44,
						_p39._0._0);
					var model_ = _p40._0;
					var effect = _p40._1;
					var sigVal = function () {
						var _p41 = _CareerPlug$ats$Library_SignaturePad$signature(model_);
						if (_p41.ctor === 'Just') {
							return _p41._0.signed_by;
						} else {
							return '';
						}
					}();
					var qname = _CareerPlug$ats$Models_Question$questionName(_p39._1._0);
					var effects = function () {
						var _p42 = _p44;
						switch (_p42.ctor) {
							case 'Focus':
								return {
									ctor: '::',
									_0: effect,
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Update$msgEffect(
											_CareerPlug$ats$PdfForm_Message$FormMsg(
												_etaque$elm_form$Form$Focus(qname))),
										_1: {ctor: '[]'}
									}
								};
							case 'Blur':
								return {
									ctor: '::',
									_0: effect,
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Update$msgEffect(
											_CareerPlug$ats$PdfForm_Message$FormMsg(
												_etaque$elm_form$Form$Blur(qname))),
										_1: {
											ctor: '::',
											_0: _CareerPlug$ats$Library_Update$msgEffect(
												_CareerPlug$ats$PdfForm_Message$FormMsg(
													A3(
														_etaque$elm_form$Form$Input,
														qname,
														_etaque$elm_form$Form$Text,
														_etaque$elm_form$Form_Field$String(sigVal)))),
											_1: {ctor: '[]'}
										}
									}
								};
							default:
								return {
									ctor: '::',
									_0: effect,
									_1: {ctor: '[]'}
								};
						}
					}();
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								spModel: A3(_elm_lang$core$Dict$insert, _p43, model_, model.spModel)
							}),
						effects);
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			case 'DateMsg':
				var _p50 = _p18._0;
				var _p45 = _elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$filter,
						function (q) {
							return _elm_lang$core$Native_Utils.eq(q.id, _p50);
						},
						model.questions));
				if (_p45.ctor === 'Just') {
					var initial = function () {
						var _p46 = A2(_elm_lang$core$Dict$get, _p50, model.dateModel);
						if (_p46.ctor === 'Just') {
							return false;
						} else {
							return true;
						}
					}();
					var qname = _CareerPlug$ats$Models_Question$questionName(_p45._0);
					var _p47 = initial ? {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none} : A2(_CareerPlug$ats$PdfForm$clearServerErrors, model, qname);
					var model_ = _p47._0;
					var cmd_ = _p47._1;
					var _p48 = initial ? {ctor: '_Tuple2', _0: model, _1: _elm_lang$core$Platform_Cmd$none} : A2(_CareerPlug$ats$PdfForm$focusQuestion, model_, qname);
					var model__ = _p48._0;
					var cmd__ = _p48._1;
					var dateVal = function () {
						var _p49 = _p18._2;
						if (_p49.ctor === 'Just') {
							return A3(_rluiten$elm_date_extra$Date_Extra_Format$format, _rluiten$elm_date_extra$Date_Extra_Config_Config_en_us$config, '%m/%d/%Y', _p49._0);
						} else {
							return '';
						}
					}();
					var cmds = initial ? {ctor: '[]'} : {
						ctor: '::',
						_0: cmd_,
						_1: {
							ctor: '::',
							_0: cmd__,
							_1: {
								ctor: '::',
								_0: _CareerPlug$ats$Library_Update$msgEffect(
									_CareerPlug$ats$PdfForm_Message$FormMsg(
										A3(
											_etaque$elm_form$Form$Input,
											qname,
											_etaque$elm_form$Form$Text,
											_etaque$elm_form$Form_Field$String(dateVal)))),
								_1: {ctor: '[]'}
							}
						}
					};
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model__,
							{
								dateModel: A3(_elm_lang$core$Dict$insert, _p50, _p18._1, model.dateModel)
							}),
						cmds);
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			default:
				var aUpdate = F2(
					function (_p51, state) {
						return A2(_mdgriffith$elm_style_animation$Animation$update, _p18._0, state);
					});
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							animated: A2(_elm_lang$core$Dict$map, aUpdate, model.animated)
						}),
					{ctor: '[]'});
		}
	});
var _CareerPlug$ats$PdfForm$update = F2(
	function (msg, model) {
		return A3(
			_CareerPlug$ats$PdfForm$update_,
			msg,
			model,
			_CareerPlug$ats$PdfForm_Model$validate(
				A2(_CareerPlug$ats$PdfForm$validQuestions, model, model.questions)));
	});
var _CareerPlug$ats$PdfForm$initialFormFields = function (flags) {
	var pairToField = function (_p52) {
		var _p53 = _p52;
		var _p58 = _p53._1;
		var _p57 = _p53._0;
		var rval = A2(
			_elm_lang$core$Json_Decode$decodeValue,
			_elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$string,
					_1: {
						ctor: '::',
						_0: _elm_lang$core$Json_Decode$null(''),
						_1: {ctor: '[]'}
					}
				}),
			_p58);
		var boolVal = A2(_elm_lang$core$Json_Decode$decodeValue, _elm_lang$core$Json_Decode$bool, _p58);
		var _p54 = boolVal;
		if (_p54.ctor === 'Ok') {
			return {
				ctor: '_Tuple2',
				_0: _p57,
				_1: _etaque$elm_form$Form_Field$bool(_p54._0)
			};
		} else {
			var _p55 = rval;
			if (_p55.ctor === 'Ok') {
				return {
					ctor: '_Tuple2',
					_0: _p57,
					_1: _etaque$elm_form$Form_Field$string(_p55._0)
				};
			} else {
				var _p56 = A2(
					_elm_lang$core$Debug$log,
					'Decoding Field Value',
					{ctor: '_Tuple2', _0: _p57, _1: _p55._0});
				return {
					ctor: '_Tuple2',
					_0: _p57,
					_1: _etaque$elm_form$Form_Field$string('')
				};
			}
		}
	};
	var fields = function (f) {
		var _p59 = A2(
			_elm_lang$core$Json_Decode$decodeValue,
			A2(
				_elm_lang$core$Json_Decode$field,
				f,
				_elm_lang$core$Json_Decode$dict(_elm_lang$core$Json_Decode$value)),
			flags);
		if (_p59.ctor === 'Ok') {
			return A2(
				_elm_lang$core$List$map,
				pairToField,
				A2(
					_elm_lang$core$List$filter,
					function (_p60) {
						var _p61 = _p60;
						return A2(_elm_lang$core$String$contains, 'question_', _p61._0);
					},
					_elm_lang$core$Dict$toList(_p59._0)));
		} else {
			var _p62 = A2(_elm_lang$core$Debug$log, 'Failed Model Parsing', _p59._0);
			return {ctor: '[]'};
		}
	};
	return A2(
		_elm_lang$core$Basics_ops['++'],
		fields('model'),
		fields('relatedModel'));
};
var _CareerPlug$ats$PdfForm$init = function (flags) {
	var animated = _elm_lang$core$Dict$fromList(
		{
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'focus',
				_1: _mdgriffith$elm_style_animation$Animation$style(
					{
						ctor: '::',
						_0: _mdgriffith$elm_style_animation$Animation$opacity(0.0),
						_1: {ctor: '[]'}
					})
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'shadow',
					_1: _mdgriffith$elm_style_animation$Animation$style(
						{
							ctor: '::',
							_0: _mdgriffith$elm_style_animation$Animation$opacity(0.0),
							_1: {ctor: '[]'}
						})
				},
				_1: {ctor: '[]'}
			}
		});
	var config = function () {
		var _p63 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$PdfForm_Model$jsonConfig, flags);
		if (_p63.ctor === 'Ok') {
			return _p63._0;
		} else {
			var _p64 = A2(_elm_lang$core$Debug$log, 'Failed Config Parsing', _p63._0);
			return _CareerPlug$ats$PdfForm_Model$blankConfig;
		}
	}();
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$PdfForm_Model$blankModel,
			{
				config: config,
				form: A2(
					_etaque$elm_form$Form$initial,
					_CareerPlug$ats$PdfForm$initialFormFields(flags),
					_CareerPlug$ats$PdfForm_Model$validate(
						{ctor: '[]'})),
				animated: animated
			}),
		{
			ctor: '::',
			_0: A2(
				_elm_lang$http$Http$send,
				_CareerPlug$ats$PdfForm_Message$SetQuestions,
				_CareerPlug$ats$PdfForm$getQuestions(config)),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$http$Http$send,
					_CareerPlug$ats$PdfForm_Message$SetThumbnails,
					_CareerPlug$ats$PdfForm$getThumbnails(config)),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$PdfForm$main = _elm_lang$html$Html$programWithFlags(
	{init: _CareerPlug$ats$PdfForm$init, update: _CareerPlug$ats$PdfForm$update, view: _CareerPlug$ats$PdfForm$view, subscriptions: _CareerPlug$ats$PdfForm$subscriptions})(_elm_lang$core$Json_Decode$value);

var _CareerPlug$ats$ReportBuilder_Model$dateOrDefault = F2(
	function (today, date) {
		var _p0 = _elm_lang$core$Date$fromString(date);
		if (_p0.ctor === 'Ok') {
			return _p0._0;
		} else {
			return _elm_lang$core$Date$fromTime(today);
		}
	});
var _CareerPlug$ats$ReportBuilder_Model$setReportId = function (id) {
	return _elm_lang$core$Native_Utils.eq(id, 0) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(id);
};
var _CareerPlug$ats$ReportBuilder_Model$setInitialSelectedFields = function (flags) {
	var selectFieldIndex = F2(
		function (fields, field) {
			return A2(
				_elm_lang$core$Maybe$withDefault,
				-1,
				_elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$map,
						function (_p1) {
							var _p2 = _p1;
							return _p2._0;
						},
						A2(
							_elm_lang$core$List$filter,
							function (_p3) {
								var _p4 = _p3;
								return _elm_lang$core$Native_Utils.eq(_p4._1, field);
							},
							fields))));
		});
	var fieldsMap = A2(
		_elm_lang$core$List$indexedMap,
		F2(
			function (idx, field) {
				return {ctor: '_Tuple2', _0: idx, _1: field.field_name};
			}),
		flags.fieldChoices);
	return A2(
		_elm_lang$core$List$filter,
		function (idx) {
			return _elm_lang$core$Native_Utils.cmp(idx, 0) > -1;
		},
		A2(
			_elm_lang$core$List$map,
			selectFieldIndex(fieldsMap),
			flags.fieldOrder));
};
var _CareerPlug$ats$ReportBuilder_Model$ColumnDrag = F3(
	function (a, b, c) {
		return {itemIndex: a, startX: b, currentX: c};
	});
var _CareerPlug$ats$ReportBuilder_Model$FilterAreaResize = F2(
	function (a, b) {
		return {startY: a, currentY: b};
	});
var _CareerPlug$ats$ReportBuilder_Model$FieldListResize = F2(
	function (a, b) {
		return {startX: a, currentX: b};
	});
var _CareerPlug$ats$ReportBuilder_Model$ReportField = F8(
	function (a, b, c, d, e, f, g, h) {
		return {field_name: a, filter_type: b, excludes_from_report: c, display_name: d, field_type: e, select_id_type: f, placeholder: g, select_options: h};
	});
var _CareerPlug$ats$ReportBuilder_Model$emptyReportField = A8(
	_CareerPlug$ats$ReportBuilder_Model$ReportField,
	'',
	'',
	false,
	'',
	'',
	'',
	{ctor: '[]'},
	{ctor: '[]'});
var _CareerPlug$ats$ReportBuilder_Model$ReportFilter = F7(
	function (a, b, c, d, e, f, g) {
		return {field_name: a, display_name: b, filter_type: c, string_value: d, date_interval: e, date_range: f, select: g};
	});
var _CareerPlug$ats$ReportBuilder_Model$ReportFilterFlag = F6(
	function (a, b, c, d, e, f) {
		return {field_name: a, filter_type: b, string_value: c, date_interval: d, date_range: e, select: f};
	});
var _CareerPlug$ats$ReportBuilder_Model$FilterDateInterval = F3(
	function (a, b, c) {
		return {inclusive: a, range: b, interval: c};
	});
var _CareerPlug$ats$ReportBuilder_Model$emptyFilterDateInterval = A3(_CareerPlug$ats$ReportBuilder_Model$FilterDateInterval, true, '', '');
var _CareerPlug$ats$ReportBuilder_Model$defaultFilterDateInterval = A3(_CareerPlug$ats$ReportBuilder_Model$FilterDateInterval, true, '1', 'month');
var _CareerPlug$ats$ReportBuilder_Model$FilterSelect = F3(
	function (a, b, c) {
		return {options: a, current_selected: b, select_id_type: c};
	});
var _CareerPlug$ats$ReportBuilder_Model$FilterSelectFlag = function (a) {
	return {current_selected: a};
};
var _CareerPlug$ats$ReportBuilder_Model$FilterDateRange = F4(
	function (a, b, c, d) {
		return {start_date: a, startDatePickerState: b, end_date: c, endDatePickerState: d};
	});
var _CareerPlug$ats$ReportBuilder_Model$defaultFilterDateRange = function (time) {
	var today = _elm_lang$core$Date$fromTime(time);
	var initialState = _abadi199$datetimepicker$DateTimePicker$initialStateWithToday(today);
	return A4(
		_CareerPlug$ats$ReportBuilder_Model$FilterDateRange,
		_elm_lang$core$Maybe$Just(today),
		initialState,
		_elm_lang$core$Maybe$Just(today),
		initialState);
};
var _CareerPlug$ats$ReportBuilder_Model$setInitialFilters = function (flags) {
	var selectedField = function (name) {
		var found = _elm_lang$core$List$head(
			A2(
				_elm_lang$core$List$filter,
				function (field) {
					return _elm_lang$core$Native_Utils.eq(field.field_name, name);
				},
				flags.fieldChoices));
		var _p5 = found;
		if (_p5.ctor === 'Nothing') {
			return _CareerPlug$ats$ReportBuilder_Model$emptyReportField;
		} else {
			return _p5._0;
		}
	};
	var transformFilter = function (filter) {
		var field = selectedField(filter.field_name);
		var baseFilter = A3(_CareerPlug$ats$ReportBuilder_Model$ReportFilter, filter.field_name, field.display_name, filter.filter_type);
		var buildDate = function () {
			var range = function (filterDateRange) {
				var _p6 = filterDateRange;
				if (_p6.ctor === 'Nothing') {
					return _CareerPlug$ats$ReportBuilder_Model$defaultFilterDateRange(flags.todaysDate);
				} else {
					var endDate_ = A2(_CareerPlug$ats$ReportBuilder_Model$dateOrDefault, flags.todaysDate, _p6._0.end_date);
					var startDate_ = A2(_CareerPlug$ats$ReportBuilder_Model$dateOrDefault, flags.todaysDate, _p6._0.start_date);
					return A4(
						_CareerPlug$ats$ReportBuilder_Model$FilterDateRange,
						_elm_lang$core$Maybe$Just(startDate_),
						_abadi199$datetimepicker$DateTimePicker$initialStateWithToday(startDate_),
						_elm_lang$core$Maybe$Just(endDate_),
						_abadi199$datetimepicker$DateTimePicker$initialStateWithToday(endDate_));
				}
			};
			return A4(
				baseFilter,
				_elm_lang$core$Maybe$Nothing,
				filter.date_interval,
				_elm_lang$core$Maybe$Just(
					range(filter.date_range)),
				_elm_lang$core$Maybe$Nothing);
		}();
		var _p7 = filter.filter_type;
		switch (_p7) {
			case 'string':
				return A4(baseFilter, filter.string_value, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing);
			case 'date_interval':
				return buildDate;
			case 'date_range':
				return buildDate;
			case 'multi_select':
				var filterSelect = function (_p8) {
					var _p9 = _p8;
					return _elm_lang$core$Maybe$Just(
						A3(_CareerPlug$ats$ReportBuilder_Model$FilterSelect, field.select_options, _p9.current_selected, field.select_id_type));
				};
				var multiSelect = function () {
					var _p10 = filter.select;
					if (_p10.ctor === 'Nothing') {
						return _CareerPlug$ats$ReportBuilder_Model$FilterSelectFlag(
							{ctor: '[]'});
					} else {
						return _p10._0;
					}
				}();
				return A4(
					baseFilter,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					_elm_lang$core$Maybe$Nothing,
					filterSelect(multiSelect));
			default:
				return A4(baseFilter, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing);
		}
	};
	return A2(_elm_lang$core$List$map, transformFilter, flags.filters);
};
var _CareerPlug$ats$ReportBuilder_Model$FilterDateRangeFlag = F2(
	function (a, b) {
		return {start_date: a, end_date: b};
	});
var _CareerPlug$ats$ReportBuilder_Model$Flags = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return {fieldChoices: a, boundingClient: b, reportType: c, reportName: d, authToken: e, fieldOrder: f, filters: g, reportId: h, todaysDate: i, runDays: j, recipients: k};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var _CareerPlug$ats$ReportBuilder_Model$BoundingClient = F6(
	function (a, b, c, d, e, f) {
		return {top: a, bottom: b, left: c, right: d, height: e, width: f};
	});
var _CareerPlug$ats$ReportBuilder_Model$initialModel = {
	saving: false,
	error: false,
	fieldChoices: {ctor: '[]'},
	selectedFields: {ctor: '[]'},
	selectedFilters: {ctor: '[]'},
	columnDrag: _elm_lang$core$Maybe$Nothing,
	filterAreaResize: _elm_lang$core$Maybe$Nothing,
	fieldListResize: _elm_lang$core$Maybe$Nothing,
	filterAreaHeight: _elm_lang$core$Maybe$Nothing,
	fieldListWidth: _elm_lang$core$Maybe$Nothing,
	boundingClient: A6(_CareerPlug$ats$ReportBuilder_Model$BoundingClient, 0, 0, 0, 0, 0, 0),
	columnBuilderBoundingClient: A6(_CareerPlug$ats$ReportBuilder_Model$BoundingClient, 0, 0, 0, 0, 0, 0),
	currentBuilderScroll: 0,
	startScroll: 0,
	searchBarValue: '',
	reportType: '',
	reportName: '',
	reportId: _elm_lang$core$Maybe$Nothing,
	authToken: '',
	hovering: {ctor: '[]'},
	todaysDate: 0,
	runDays: {ctor: '[]'},
	missingFieldsMessage: _elm_lang$core$Maybe$Nothing,
	missingFields: {ctor: '[]'},
	recipients: {ctor: '[]'}
};
var _CareerPlug$ats$ReportBuilder_Model$init = function (flags) {
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$ReportBuilder_Model$initialModel,
			{
				fieldChoices: flags.fieldChoices,
				boundingClient: flags.boundingClient,
				reportType: flags.reportType,
				reportName: flags.reportName,
				authToken: flags.authToken,
				selectedFields: _CareerPlug$ats$ReportBuilder_Model$setInitialSelectedFields(flags),
				selectedFilters: _CareerPlug$ats$ReportBuilder_Model$setInitialFilters(flags),
				reportId: _CareerPlug$ats$ReportBuilder_Model$setReportId(flags.reportId),
				todaysDate: flags.todaysDate,
				runDays: flags.runDays,
				recipients: flags.recipients
			}),
		{ctor: '[]'});
};
var _CareerPlug$ats$ReportBuilder_Model$Model = function (a) {
	return function (b) {
		return function (c) {
			return function (d) {
				return function (e) {
					return function (f) {
						return function (g) {
							return function (h) {
								return function (i) {
									return function (j) {
										return function (k) {
											return function (l) {
												return function (m) {
													return function (n) {
														return function (o) {
															return function (p) {
																return function (q) {
																	return function (r) {
																		return function (s) {
																			return function (t) {
																				return function (u) {
																					return function (v) {
																						return function (w) {
																							return function (x) {
																								return function (y) {
																									return {saving: a, error: b, fieldChoices: c, selectedFields: d, selectedFilters: e, columnDrag: f, filterAreaResize: g, fieldListResize: h, filterAreaHeight: i, fieldListWidth: j, boundingClient: k, columnBuilderBoundingClient: l, currentBuilderScroll: m, startScroll: n, searchBarValue: o, reportType: p, reportName: q, reportId: r, authToken: s, hovering: t, todaysDate: u, runDays: v, missingFieldsMessage: w, missingFields: x, recipients: y};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};

var _CareerPlug$ats$ReportBuilder_Message$NoOp = {ctor: 'NoOp'};
var _CareerPlug$ats$ReportBuilder_Message$AddMissingFields = function (a) {
	return {ctor: 'AddMissingFields', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$ShowMultiSelect = F4(
	function (a, b, c, d) {
		return {ctor: 'ShowMultiSelect', _0: a, _1: b, _2: c, _3: d};
	});
var _CareerPlug$ats$ReportBuilder_Message$ClearError = {ctor: 'ClearError'};
var _CareerPlug$ats$ReportBuilder_Message$ToggleRunDay = function (a) {
	return {ctor: 'ToggleRunDay', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$SetDateType = F2(
	function (a, b) {
		return {ctor: 'SetDateType', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$DateChanged = F4(
	function (a, b, c, d) {
		return {ctor: 'DateChanged', _0: a, _1: b, _2: c, _3: d};
	});
var _CareerPlug$ats$ReportBuilder_Message$UpdateSelect = function (a) {
	return {ctor: 'UpdateSelect', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$UpdateFilterDateIntervalInterval = F2(
	function (a, b) {
		return {ctor: 'UpdateFilterDateIntervalInterval', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$UpdateFilterDateIntervalRange = F2(
	function (a, b) {
		return {ctor: 'UpdateFilterDateIntervalRange', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$UpdateFilterDateIntervalInclusive = F2(
	function (a, b) {
		return {ctor: 'UpdateFilterDateIntervalInclusive', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$UpdateFilterValue = F2(
	function (a, b) {
		return {ctor: 'UpdateFilterValue', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$UpdateReportRecipients = function (a) {
	return {ctor: 'UpdateReportRecipients', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$UpdateReportName = function (a) {
	return {ctor: 'UpdateReportName', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$ExitHover = function (a) {
	return {ctor: 'ExitHover', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$EnterHover = function (a) {
	return {ctor: 'EnterHover', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$RunReport = F2(
	function (a, b) {
		return {ctor: 'RunReport', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$UpdateSearchBar = function (a) {
	return {ctor: 'UpdateSearchBar', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$RemoveFilter = function (a) {
	return {ctor: 'RemoveFilter', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$AddFilter = function (a) {
	return {ctor: 'AddFilter', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$RemoveField = function (a) {
	return {ctor: 'RemoveField', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$AddField = function (a) {
	return {ctor: 'AddField', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$SetCurrentBuilderScroll = function (a) {
	return {ctor: 'SetCurrentBuilderScroll', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$SetColumnBuilderBoundingClient = function (a) {
	return {ctor: 'SetColumnBuilderBoundingClient', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$SetBoundingClient = function (a) {
	return {ctor: 'SetBoundingClient', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$FieldListResizeEnd = function (a) {
	return {ctor: 'FieldListResizeEnd', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$FieldListResizeAt = function (a) {
	return {ctor: 'FieldListResizeAt', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$FieldListResizeStart = function (a) {
	return {ctor: 'FieldListResizeStart', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$FilterAreaResizeEnd = function (a) {
	return {ctor: 'FilterAreaResizeEnd', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$FilterAreaResizeAt = function (a) {
	return {ctor: 'FilterAreaResizeAt', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$FilterAreaResizeStart = function (a) {
	return {ctor: 'FilterAreaResizeStart', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$ColumnDragEnd = function (a) {
	return {ctor: 'ColumnDragEnd', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$ColumnDragAt = function (a) {
	return {ctor: 'ColumnDragAt', _0: a};
};
var _CareerPlug$ats$ReportBuilder_Message$ColumnDragStart = F2(
	function (a, b) {
		return {ctor: 'ColumnDragStart', _0: a, _1: b};
	});
var _CareerPlug$ats$ReportBuilder_Message$SaveRequestComplete = function (a) {
	return {ctor: 'SaveRequestComplete', _0: a};
};

var _CareerPlug$ats$ReportBuilder_Ports$setBoundingClient = _elm_lang$core$Native_Platform.incomingPort(
	'setBoundingClient',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (top) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (bottom) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (left) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (right) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (height) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (width) {
													return _elm_lang$core$Json_Decode$succeed(
														{top: top, bottom: bottom, left: left, right: right, height: height, width: width});
												},
												A2(_elm_lang$core$Json_Decode$field, 'width', _elm_lang$core$Json_Decode$int));
										},
										A2(_elm_lang$core$Json_Decode$field, 'height', _elm_lang$core$Json_Decode$int));
								},
								A2(_elm_lang$core$Json_Decode$field, 'right', _elm_lang$core$Json_Decode$int));
						},
						A2(_elm_lang$core$Json_Decode$field, 'left', _elm_lang$core$Json_Decode$int));
				},
				A2(_elm_lang$core$Json_Decode$field, 'bottom', _elm_lang$core$Json_Decode$int));
		},
		A2(_elm_lang$core$Json_Decode$field, 'top', _elm_lang$core$Json_Decode$int)));
var _CareerPlug$ats$ReportBuilder_Ports$setColumnBuilderClient = _elm_lang$core$Native_Platform.incomingPort(
	'setColumnBuilderClient',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (top) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (bottom) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (left) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (right) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (height) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (width) {
													return _elm_lang$core$Json_Decode$succeed(
														{top: top, bottom: bottom, left: left, right: right, height: height, width: width});
												},
												A2(_elm_lang$core$Json_Decode$field, 'width', _elm_lang$core$Json_Decode$int));
										},
										A2(_elm_lang$core$Json_Decode$field, 'height', _elm_lang$core$Json_Decode$int));
								},
								A2(_elm_lang$core$Json_Decode$field, 'right', _elm_lang$core$Json_Decode$int));
						},
						A2(_elm_lang$core$Json_Decode$field, 'left', _elm_lang$core$Json_Decode$int));
				},
				A2(_elm_lang$core$Json_Decode$field, 'bottom', _elm_lang$core$Json_Decode$int));
		},
		A2(_elm_lang$core$Json_Decode$field, 'top', _elm_lang$core$Json_Decode$int)));
var _CareerPlug$ats$ReportBuilder_Ports$setCurrentBuilderScroll = _elm_lang$core$Native_Platform.incomingPort('setCurrentBuilderScroll', _elm_lang$core$Json_Decode$int);
var _CareerPlug$ats$ReportBuilder_Ports$updateMultiSelect = _elm_lang$core$Native_Platform.incomingPort(
	'updateMultiSelect',
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (x0) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (x1) {
					return _elm_lang$core$Json_Decode$succeed(
						{ctor: '_Tuple2', _0: x0, _1: x1});
				},
				A2(
					_elm_lang$core$Json_Decode$index,
					1,
					_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)));
		},
		A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string)));
var _CareerPlug$ats$ReportBuilder_Ports$portSubscriptions = {
	ctor: '::',
	_0: _CareerPlug$ats$ReportBuilder_Ports$setBoundingClient(_CareerPlug$ats$ReportBuilder_Message$SetBoundingClient),
	_1: {
		ctor: '::',
		_0: _CareerPlug$ats$ReportBuilder_Ports$setColumnBuilderClient(_CareerPlug$ats$ReportBuilder_Message$SetColumnBuilderBoundingClient),
		_1: {
			ctor: '::',
			_0: _CareerPlug$ats$ReportBuilder_Ports$setCurrentBuilderScroll(_CareerPlug$ats$ReportBuilder_Message$SetCurrentBuilderScroll),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$ReportBuilder_Ports$updateMultiSelect(_CareerPlug$ats$ReportBuilder_Message$UpdateSelect),
				_1: {ctor: '[]'}
			}
		}
	}
};
var _CareerPlug$ats$ReportBuilder_Ports$showMultiSelectModal = _elm_lang$core$Native_Platform.outgoingPort(
	'showMultiSelectModal',
	function (v) {
		return [
			v._0,
			v._1,
			_elm_lang$core$Native_List.toArray(v._2).map(
			function (v) {
				return [v._0, v._1];
			}),
			_elm_lang$core$Native_List.toArray(v._3).map(
			function (v) {
				return v;
			})
		];
	});
var _CareerPlug$ats$ReportBuilder_Ports$redirectToManage = _elm_lang$core$Native_Platform.outgoingPort(
	'redirectToManage',
	function (v) {
		return v;
	});

var _CareerPlug$ats$ReportBuilder_Subscriptions$subscriptions = function (model) {
	var fieldListResizing = function () {
		var _p0 = model.fieldListResize;
		if (_p0.ctor === 'Nothing') {
			return false;
		} else {
			return true;
		}
	}();
	var filterAreaResizing = function () {
		var _p1 = model.filterAreaResize;
		if (_p1.ctor === 'Nothing') {
			return false;
		} else {
			return true;
		}
	}();
	var columnDrag = function () {
		var _p2 = model.columnDrag;
		if (_p2.ctor === 'Nothing') {
			return false;
		} else {
			return true;
		}
	}();
	var subscriptions = columnDrag ? {
		ctor: '::',
		_0: _elm_lang$mouse$Mouse$moves(_CareerPlug$ats$ReportBuilder_Message$ColumnDragAt),
		_1: {
			ctor: '::',
			_0: _elm_lang$mouse$Mouse$ups(_CareerPlug$ats$ReportBuilder_Message$ColumnDragEnd),
			_1: {ctor: '[]'}
		}
	} : (filterAreaResizing ? {
		ctor: '::',
		_0: _elm_lang$mouse$Mouse$moves(_CareerPlug$ats$ReportBuilder_Message$FilterAreaResizeAt),
		_1: {
			ctor: '::',
			_0: _elm_lang$mouse$Mouse$ups(_CareerPlug$ats$ReportBuilder_Message$FilterAreaResizeEnd),
			_1: {ctor: '[]'}
		}
	} : (fieldListResizing ? {
		ctor: '::',
		_0: _elm_lang$mouse$Mouse$moves(_CareerPlug$ats$ReportBuilder_Message$FieldListResizeAt),
		_1: {
			ctor: '::',
			_0: _elm_lang$mouse$Mouse$ups(_CareerPlug$ats$ReportBuilder_Message$FieldListResizeEnd),
			_1: {ctor: '[]'}
		}
	} : {ctor: '[]'}));
	return _elm_lang$core$Platform_Sub$batch(
		A2(_elm_lang$core$Basics_ops['++'], subscriptions, _CareerPlug$ats$ReportBuilder_Ports$portSubscriptions));
};

var _CareerPlug$ats$ReportBuilder_Constants$dragBarWidth = 3;
var _CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth = 125;
var _CareerPlug$ats$ReportBuilder_Constants$initialFilterAreaHeight = 250;
var _CareerPlug$ats$ReportBuilder_Constants$initialFieldListWidth = 250;

var _CareerPlug$ats$ReportBuilder_Service$filterValueEncoder = function (val) {
	var _p0 = val;
	if (_p0.ctor === 'Nothing') {
		return _elm_lang$core$Json_Encode$null;
	} else {
		return _elm_lang$core$Json_Encode$string(_p0._0);
	}
};
var _CareerPlug$ats$ReportBuilder_Service$filterSelectEncoder = function (filterSelect) {
	var _p1 = filterSelect;
	if (_p1.ctor === 'Nothing') {
		return _elm_lang$core$Json_Encode$null;
	} else {
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'options',
					_1: _elm_lang$core$Json_Encode$list(
						A2(
							_elm_lang$core$List$map,
							function (_p2) {
								var _p3 = _p2;
								return _elm_lang$core$Json_Encode$object(
									{
										ctor: '::',
										_0: {
											ctor: '_Tuple2',
											_0: 'id',
											_1: _elm_lang$core$Json_Encode$string(_p3._0)
										},
										_1: {
											ctor: '::',
											_0: {
												ctor: '_Tuple2',
												_0: 'name',
												_1: _elm_lang$core$Json_Encode$string(_p3._1)
											},
											_1: {ctor: '[]'}
										}
									});
							},
							_p1._0.options))
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'current_selected',
						_1: _elm_lang$core$Json_Encode$list(
							A2(
								_elm_lang$core$List$map,
								function (id) {
									return _elm_lang$core$Json_Encode$string(id);
								},
								_p1._0.current_selected))
					},
					_1: {ctor: '[]'}
				}
			});
	}
};
var _CareerPlug$ats$ReportBuilder_Service$filterDateRangeEncoder = function (filterDate) {
	var _p4 = filterDate;
	if (_p4.ctor === 'Nothing') {
		return _elm_lang$core$Json_Encode$null;
	} else {
		var encodeDate = function (date) {
			var _p5 = date;
			if (_p5.ctor === 'Nothing') {
				return _elm_lang$core$Json_Encode$null;
			} else {
				return _elm_lang$core$Json_Encode$string(
					_elm_lang$core$Basics$toString(_p5._0));
			}
		};
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'start_date',
					_1: encodeDate(_p4._0.start_date)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'end_date',
						_1: encodeDate(_p4._0.end_date)
					},
					_1: {ctor: '[]'}
				}
			});
	}
};
var _CareerPlug$ats$ReportBuilder_Service$filterDateIntervalEncoder = function (filterDate) {
	var _p6 = filterDate;
	if (_p6.ctor === 'Nothing') {
		return _elm_lang$core$Json_Encode$null;
	} else {
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'inclusive',
					_1: _elm_lang$core$Json_Encode$bool(_p6._0.inclusive)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'range',
						_1: _elm_lang$core$Json_Encode$string(_p6._0.range)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'interval',
							_1: _elm_lang$core$Json_Encode$string(_p6._0.interval)
						},
						_1: {ctor: '[]'}
					}
				}
			});
	}
};
var _CareerPlug$ats$ReportBuilder_Service$filtersEncoder = function (filters) {
	var encodeFilter = function (filter) {
		return _elm_lang$core$Json_Encode$object(
			{
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'field_name',
					_1: _elm_lang$core$Json_Encode$string(filter.field_name)
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'filter_type',
						_1: _elm_lang$core$Json_Encode$string(filter.filter_type)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'string_value',
							_1: _CareerPlug$ats$ReportBuilder_Service$filterValueEncoder(filter.string_value)
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'date_interval',
								_1: _CareerPlug$ats$ReportBuilder_Service$filterDateIntervalEncoder(filter.date_interval)
							},
							_1: {
								ctor: '::',
								_0: {
									ctor: '_Tuple2',
									_0: 'date_range',
									_1: _CareerPlug$ats$ReportBuilder_Service$filterDateRangeEncoder(filter.date_range)
								},
								_1: {
									ctor: '::',
									_0: {
										ctor: '_Tuple2',
										_0: 'select',
										_1: _CareerPlug$ats$ReportBuilder_Service$filterSelectEncoder(filter.select)
									},
									_1: {ctor: '[]'}
								}
							}
						}
					}
				}
			});
	};
	return A2(_elm_lang$core$List$map, encodeFilter, filters);
};
var _CareerPlug$ats$ReportBuilder_Service$bodyEncoder = F3(
	function (model, fields, run) {
		var orderEncoder = function (fields) {
			return A2(
				_elm_lang$core$List$map,
				function (field) {
					return _elm_lang$core$Json_Encode$string(field.field_name);
				},
				fields);
		};
		var recipientEncoder = function (recipients) {
			return A2(
				_elm_lang$core$List$map,
				function (recipient) {
					return _elm_lang$core$Json_Encode$string(recipient);
				},
				recipients);
		};
		var daysEncoder = function (days) {
			return A2(
				_elm_lang$core$List$map,
				function (day) {
					return _elm_lang$core$Json_Encode$string(day);
				},
				days);
		};
		var commitEncoder = run ? _elm_lang$core$Json_Encode$string('Run') : _elm_lang$core$Json_Encode$null;
		var fieldsEncoder = function (fields) {
			var encodeField = function (field) {
				return {
					ctor: '_Tuple2',
					_0: field.field_name,
					_1: _elm_lang$core$Json_Encode$object(
						{
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'enabled',
								_1: _elm_lang$core$Json_Encode$int(1)
							},
							_1: {ctor: '[]'}
						})
				};
			};
			return A2(_elm_lang$core$List$map, encodeField, fields);
		};
		var paramsEncoder = {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'fields',
				_1: _elm_lang$core$Json_Encode$object(
					fieldsEncoder(fields))
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'filters',
					_1: _elm_lang$core$Json_Encode$list(
						_CareerPlug$ats$ReportBuilder_Service$filtersEncoder(model.selectedFilters))
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'report_type',
						_1: _elm_lang$core$Json_Encode$string(model.reportType)
					},
					_1: {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'order',
							_1: _elm_lang$core$Json_Encode$list(
								orderEncoder(fields))
						},
						_1: {
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'recipients',
								_1: _elm_lang$core$Json_Encode$list(
									recipientEncoder(model.recipients))
							},
							_1: {ctor: '[]'}
						}
					}
				}
			}
		};
		var reportEncoder = {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'params',
				_1: _elm_lang$core$Json_Encode$object(paramsEncoder)
			},
			_1: {
				ctor: '::',
				_0: {
					ctor: '_Tuple2',
					_0: 'days',
					_1: _elm_lang$core$Json_Encode$list(
						daysEncoder(model.runDays))
				},
				_1: {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'name',
						_1: _elm_lang$core$Json_Encode$string(model.reportName)
					},
					_1: {ctor: '[]'}
				}
			}
		};
		var bodyEncoder = {
			ctor: '::',
			_0: {
				ctor: '_Tuple2',
				_0: 'report',
				_1: _elm_lang$core$Json_Encode$object(reportEncoder)
			},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'commit', _1: commitEncoder},
				_1: {ctor: '[]'}
			}
		};
		return _elm_lang$http$Http$jsonBody(
			_elm_lang$core$Json_Encode$object(bodyEncoder));
	});
var _CareerPlug$ats$ReportBuilder_Service$requestUrl = function (model) {
	var baseUrl = '/manage/reports';
	var _p7 = model.reportId;
	if (_p7.ctor === 'Just') {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			baseUrl,
			A2(
				_elm_lang$core$Basics_ops['++'],
				'/',
				A2(
					_elm_lang$core$Basics_ops['++'],
					_elm_lang$core$Basics$toString(_p7._0),
					'.json')));
	} else {
		return A2(_elm_lang$core$Basics_ops['++'], baseUrl, '.json');
	}
};
var _CareerPlug$ats$ReportBuilder_Service$requestMethod = function (model) {
	var _p8 = model.reportId;
	if (_p8.ctor === 'Just') {
		return 'PATCH';
	} else {
		return 'POST';
	}
};
var _CareerPlug$ats$ReportBuilder_Service$saveRequest = F3(
	function (model, fields, run) {
		return A2(
			_elm_lang$http$Http$send,
			_CareerPlug$ats$ReportBuilder_Message$SaveRequestComplete,
			_elm_lang$http$Http$request(
				{
					body: A3(_CareerPlug$ats$ReportBuilder_Service$bodyEncoder, model, fields, run),
					expect: _elm_lang$http$Http$expectString,
					headers: {
						ctor: '::',
						_0: A2(_elm_lang$http$Http$header, 'Content-Type', 'application/json'),
						_1: {
							ctor: '::',
							_0: A2(_elm_lang$http$Http$header, 'X-CSRF-Token', model.authToken),
							_1: {ctor: '[]'}
						}
					},
					method: _CareerPlug$ats$ReportBuilder_Service$requestMethod(model),
					timeout: _elm_lang$core$Maybe$Nothing,
					url: _CareerPlug$ats$ReportBuilder_Service$requestUrl(model),
					withCredentials: false
				}));
	});

var _elm_lang$core$Native_Bitwise = function() {

return {
	and: F2(function and(a, b) { return a & b; }),
	or: F2(function or(a, b) { return a | b; }),
	xor: F2(function xor(a, b) { return a ^ b; }),
	complement: function complement(a) { return ~a; },
	shiftLeftBy: F2(function(offset, a) { return a << offset; }),
	shiftRightBy: F2(function(offset, a) { return a >> offset; }),
	shiftRightZfBy: F2(function(offset, a) { return a >>> offset; })
};

}();

var _elm_lang$core$Bitwise$shiftRightZfBy = _elm_lang$core$Native_Bitwise.shiftRightZfBy;
var _elm_lang$core$Bitwise$shiftRightBy = _elm_lang$core$Native_Bitwise.shiftRightBy;
var _elm_lang$core$Bitwise$shiftLeftBy = _elm_lang$core$Native_Bitwise.shiftLeftBy;
var _elm_lang$core$Bitwise$complement = _elm_lang$core$Native_Bitwise.complement;
var _elm_lang$core$Bitwise$xor = _elm_lang$core$Native_Bitwise.xor;
var _elm_lang$core$Bitwise$or = _elm_lang$core$Native_Bitwise.or;
var _elm_lang$core$Bitwise$and = _elm_lang$core$Native_Bitwise.and;

var _elm_community$string_extra$String_Extra$accentRegex = function () {
	var matches = {
		ctor: '::',
		_0: {ctor: '_Tuple2', _0: '[à-æ]', _1: 'a'},
		_1: {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: '[À-Æ]', _1: 'A'},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: 'ç', _1: 'c'},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'Ç', _1: 'C'},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: '[è-ë]', _1: 'e'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: '[È-Ë]', _1: 'E'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: '[ì-ï]', _1: 'i'},
								_1: {
									ctor: '::',
									_0: {ctor: '_Tuple2', _0: '[Ì-Ï]', _1: 'I'},
									_1: {
										ctor: '::',
										_0: {ctor: '_Tuple2', _0: 'ñ', _1: 'n'},
										_1: {
											ctor: '::',
											_0: {ctor: '_Tuple2', _0: 'Ñ', _1: 'N'},
											_1: {
												ctor: '::',
												_0: {ctor: '_Tuple2', _0: '[ò-ö]', _1: 'o'},
												_1: {
													ctor: '::',
													_0: {ctor: '_Tuple2', _0: '[Ò-Ö]', _1: 'O'},
													_1: {
														ctor: '::',
														_0: {ctor: '_Tuple2', _0: '[ù-ü]', _1: 'u'},
														_1: {
															ctor: '::',
															_0: {ctor: '_Tuple2', _0: '[Ù-Ü]', _1: 'U'},
															_1: {
																ctor: '::',
																_0: {ctor: '_Tuple2', _0: 'ý', _1: 'y'},
																_1: {
																	ctor: '::',
																	_0: {ctor: '_Tuple2', _0: 'ÿ', _1: 'y'},
																	_1: {
																		ctor: '::',
																		_0: {ctor: '_Tuple2', _0: 'Ý', _1: 'Y'},
																		_1: {ctor: '[]'}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};
	return A2(
		_elm_lang$core$List$map,
		function (_p0) {
			var _p1 = _p0;
			return {
				ctor: '_Tuple2',
				_0: _elm_lang$core$Regex$regex(_p1._0),
				_1: _p1._1
			};
		},
		matches);
}();
var _elm_community$string_extra$String_Extra$removeAccents = function (string) {
	if (_elm_lang$core$String$isEmpty(string)) {
		return string;
	} else {
		var do_regex_to_remove_acents = function (_p2) {
			var _p3 = _p2;
			return A3(
				_elm_lang$core$Regex$replace,
				_elm_lang$core$Regex$All,
				_p3._0,
				function (_p4) {
					return _p3._1;
				});
		};
		return A3(_elm_lang$core$List$foldl, do_regex_to_remove_acents, string, _elm_community$string_extra$String_Extra$accentRegex);
	}
};
var _elm_community$string_extra$String_Extra$nonEmpty = function (string) {
	return _elm_lang$core$String$isEmpty(string) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(string);
};
var _elm_community$string_extra$String_Extra$replacementCodePoint = 65533;
var _elm_community$string_extra$String_Extra$toCodePoints = function (string) {
	var allCodeUnits = A2(
		_elm_lang$core$List$map,
		_elm_lang$core$Char$toCode,
		_elm_lang$core$String$toList(string));
	var combineAndReverse = F2(
		function (codeUnits, accumulated) {
			combineAndReverse:
			while (true) {
				var _p5 = codeUnits;
				if (_p5.ctor === '[]') {
					return accumulated;
				} else {
					var _p9 = _p5._0;
					var _p8 = _p5._1;
					if ((_elm_lang$core$Native_Utils.cmp(_p9, 0) > -1) && (_elm_lang$core$Native_Utils.cmp(_p9, 55295) < 1)) {
						var _v3 = _p8,
							_v4 = {ctor: '::', _0: _p9, _1: accumulated};
						codeUnits = _v3;
						accumulated = _v4;
						continue combineAndReverse;
					} else {
						if ((_elm_lang$core$Native_Utils.cmp(_p9, 55296) > -1) && (_elm_lang$core$Native_Utils.cmp(_p9, 56319) < 1)) {
							var _p6 = _p8;
							if (_p6.ctor === '[]') {
								return {ctor: '::', _0: _elm_community$string_extra$String_Extra$replacementCodePoint, _1: accumulated};
							} else {
								var _p7 = _p6._0;
								if ((_elm_lang$core$Native_Utils.cmp(_p7, 56320) > -1) && (_elm_lang$core$Native_Utils.cmp(_p7, 57343) < 1)) {
									var codePoint = (65536 + ((_p9 - 55296) * 1024)) + (_p7 - 56320);
									var _v6 = _p6._1,
										_v7 = {ctor: '::', _0: codePoint, _1: accumulated};
									codeUnits = _v6;
									accumulated = _v7;
									continue combineAndReverse;
								} else {
									var _v8 = _p8,
										_v9 = {ctor: '::', _0: _elm_community$string_extra$String_Extra$replacementCodePoint, _1: accumulated};
									codeUnits = _v8;
									accumulated = _v9;
									continue combineAndReverse;
								}
							}
						} else {
							if ((_elm_lang$core$Native_Utils.cmp(_p9, 57344) > -1) && (_elm_lang$core$Native_Utils.cmp(_p9, 65535) < 1)) {
								var _v10 = _p8,
									_v11 = {ctor: '::', _0: _p9, _1: accumulated};
								codeUnits = _v10;
								accumulated = _v11;
								continue combineAndReverse;
							} else {
								var _v12 = _p8,
									_v13 = {ctor: '::', _0: _elm_community$string_extra$String_Extra$replacementCodePoint, _1: accumulated};
								codeUnits = _v12;
								accumulated = _v13;
								continue combineAndReverse;
							}
						}
					}
				}
			}
		});
	return _elm_lang$core$List$reverse(
		A2(
			combineAndReverse,
			allCodeUnits,
			{ctor: '[]'}));
};
var _elm_community$string_extra$String_Extra$fromCodePoints = function (allCodePoints) {
	var splitAndReverse = F2(
		function (codePoints, accumulated) {
			splitAndReverse:
			while (true) {
				var _p10 = codePoints;
				if (_p10.ctor === '[]') {
					return accumulated;
				} else {
					var _p12 = _p10._1;
					var _p11 = _p10._0;
					if ((_elm_lang$core$Native_Utils.cmp(_p11, 0) > -1) && (_elm_lang$core$Native_Utils.cmp(_p11, 55295) < 1)) {
						var _v15 = _p12,
							_v16 = {ctor: '::', _0: _p11, _1: accumulated};
						codePoints = _v15;
						accumulated = _v16;
						continue splitAndReverse;
					} else {
						if ((_elm_lang$core$Native_Utils.cmp(_p11, 65536) > -1) && (_elm_lang$core$Native_Utils.cmp(_p11, 1114111) < 1)) {
							var subtracted = _p11 - 65536;
							var leading = (subtracted >> 10) + 55296;
							var trailing = (subtracted & 1023) + 56320;
							var _v17 = _p12,
								_v18 = {
								ctor: '::',
								_0: trailing,
								_1: {ctor: '::', _0: leading, _1: accumulated}
							};
							codePoints = _v17;
							accumulated = _v18;
							continue splitAndReverse;
						} else {
							if ((_elm_lang$core$Native_Utils.cmp(_p11, 57344) > -1) && (_elm_lang$core$Native_Utils.cmp(_p11, 65535) < 1)) {
								var _v19 = _p12,
									_v20 = {ctor: '::', _0: _p11, _1: accumulated};
								codePoints = _v19;
								accumulated = _v20;
								continue splitAndReverse;
							} else {
								var _v21 = _p12,
									_v22 = {ctor: '::', _0: _elm_community$string_extra$String_Extra$replacementCodePoint, _1: accumulated};
								codePoints = _v21;
								accumulated = _v22;
								continue splitAndReverse;
							}
						}
					}
				}
			}
		});
	var allCodeUnits = _elm_lang$core$List$reverse(
		A2(
			splitAndReverse,
			allCodePoints,
			{ctor: '[]'}));
	return _elm_lang$core$String$fromList(
		A2(_elm_lang$core$List$map, _elm_lang$core$Char$fromCode, allCodeUnits));
};
var _elm_community$string_extra$String_Extra$fromFloat = _elm_lang$core$Basics$toString;
var _elm_community$string_extra$String_Extra$fromInt = _elm_lang$core$Basics$toString;
var _elm_community$string_extra$String_Extra$leftOfBack = F2(
	function (pattern, string) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			'',
			A2(
				_elm_lang$core$Maybe$map,
				A2(_elm_lang$core$Basics$flip, _elm_lang$core$String$left, string),
				_elm_lang$core$List$head(
					_elm_lang$core$List$reverse(
						A2(_elm_lang$core$String$indexes, pattern, string)))));
	});
var _elm_community$string_extra$String_Extra$rightOfBack = F2(
	function (pattern, string) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			'',
			A2(
				_elm_lang$core$Maybe$map,
				function (_p13) {
					return A3(
						_elm_lang$core$Basics$flip,
						_elm_lang$core$String$dropLeft,
						string,
						A2(
							F2(
								function (x, y) {
									return x + y;
								}),
							_elm_lang$core$String$length(pattern),
							_p13));
				},
				_elm_lang$core$List$head(
					_elm_lang$core$List$reverse(
						A2(_elm_lang$core$String$indexes, pattern, string)))));
	});
var _elm_community$string_extra$String_Extra$firstResultHelp = F2(
	function ($default, list) {
		firstResultHelp:
		while (true) {
			var _p14 = list;
			if (_p14.ctor === '[]') {
				return $default;
			} else {
				if (_p14._0.ctor === 'Just') {
					return _p14._0._0;
				} else {
					var _v24 = $default,
						_v25 = _p14._1;
					$default = _v24;
					list = _v25;
					continue firstResultHelp;
				}
			}
		}
	});
var _elm_community$string_extra$String_Extra$firstResult = function (list) {
	return A2(_elm_community$string_extra$String_Extra$firstResultHelp, '', list);
};
var _elm_community$string_extra$String_Extra$leftOf = F2(
	function (pattern, string) {
		return A2(
			_elm_lang$core$String$join,
			'',
			A2(
				_elm_lang$core$List$map,
				function (_p15) {
					return _elm_community$string_extra$String_Extra$firstResult(
						function (_) {
							return _.submatches;
						}(_p15));
				},
				A3(
					_elm_lang$core$Regex$find,
					_elm_lang$core$Regex$AtMost(1),
					_elm_lang$core$Regex$regex(
						A2(
							_elm_lang$core$Basics_ops['++'],
							'^(.*?)',
							_elm_lang$core$Regex$escape(pattern))),
					string)));
	});
var _elm_community$string_extra$String_Extra$rightOf = F2(
	function (pattern, string) {
		return A2(
			_elm_lang$core$String$join,
			'',
			A2(
				_elm_lang$core$List$map,
				function (_p16) {
					return _elm_community$string_extra$String_Extra$firstResult(
						function (_) {
							return _.submatches;
						}(_p16));
				},
				A3(
					_elm_lang$core$Regex$find,
					_elm_lang$core$Regex$AtMost(1),
					_elm_lang$core$Regex$regex(
						A2(
							_elm_lang$core$Basics_ops['++'],
							_elm_lang$core$Regex$escape(pattern),
							'(.*)$')),
					string)));
	});
var _elm_community$string_extra$String_Extra$pluralize = F3(
	function (singular, plural, count) {
		return _elm_lang$core$Native_Utils.eq(count, 1) ? A2(_elm_lang$core$Basics_ops['++'], '1 ', singular) : A2(
			_elm_lang$core$Basics_ops['++'],
			_elm_lang$core$Basics$toString(count),
			A2(_elm_lang$core$Basics_ops['++'], ' ', plural));
	});
var _elm_community$string_extra$String_Extra$stripTags = function (string) {
	return A4(
		_elm_lang$core$Regex$replace,
		_elm_lang$core$Regex$All,
		_elm_lang$core$Regex$regex('<\\/?[^>]+>'),
		_elm_lang$core$Basics$always(''),
		string);
};
var _elm_community$string_extra$String_Extra$toSentenceHelper = F3(
	function (lastPart, sentence, list) {
		toSentenceHelper:
		while (true) {
			var _p17 = list;
			if (_p17.ctor === '[]') {
				return sentence;
			} else {
				if (_p17._1.ctor === '[]') {
					return A2(
						_elm_lang$core$Basics_ops['++'],
						sentence,
						A2(_elm_lang$core$Basics_ops['++'], lastPart, _p17._0));
				} else {
					var _v27 = lastPart,
						_v28 = A2(
						_elm_lang$core$Basics_ops['++'],
						sentence,
						A2(_elm_lang$core$Basics_ops['++'], ', ', _p17._0)),
						_v29 = _p17._1;
					lastPart = _v27;
					sentence = _v28;
					list = _v29;
					continue toSentenceHelper;
				}
			}
		}
	});
var _elm_community$string_extra$String_Extra$toSentenceBaseCase = function (list) {
	var _p18 = list;
	_v30_2:
	do {
		if (_p18.ctor === '::') {
			if (_p18._1.ctor === '[]') {
				return _p18._0;
			} else {
				if (_p18._1._1.ctor === '[]') {
					return A2(
						_elm_lang$core$Basics_ops['++'],
						_p18._0,
						A2(_elm_lang$core$Basics_ops['++'], ' and ', _p18._1._0));
				} else {
					break _v30_2;
				}
			}
		} else {
			break _v30_2;
		}
	} while(false);
	return '';
};
var _elm_community$string_extra$String_Extra$toSentenceOxford = function (list) {
	var _p19 = list;
	if (((_p19.ctor === '::') && (_p19._1.ctor === '::')) && (_p19._1._1.ctor === '::')) {
		return A3(
			_elm_community$string_extra$String_Extra$toSentenceHelper,
			', and ',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_p19._0,
				A2(_elm_lang$core$Basics_ops['++'], ', ', _p19._1._0)),
			{ctor: '::', _0: _p19._1._1._0, _1: _p19._1._1._1});
	} else {
		return _elm_community$string_extra$String_Extra$toSentenceBaseCase(list);
	}
};
var _elm_community$string_extra$String_Extra$toSentence = function (list) {
	var _p20 = list;
	if (((_p20.ctor === '::') && (_p20._1.ctor === '::')) && (_p20._1._1.ctor === '::')) {
		return A3(
			_elm_community$string_extra$String_Extra$toSentenceHelper,
			' and ',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_p20._0,
				A2(_elm_lang$core$Basics_ops['++'], ', ', _p20._1._0)),
			{ctor: '::', _0: _p20._1._1._0, _1: _p20._1._1._1});
	} else {
		return _elm_community$string_extra$String_Extra$toSentenceBaseCase(list);
	}
};
var _elm_community$string_extra$String_Extra$ellipsisWith = F3(
	function (howLong, append, string) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(string),
			howLong) < 1) ? string : A2(
			_elm_lang$core$Basics_ops['++'],
			A2(
				_elm_lang$core$String$left,
				howLong - _elm_lang$core$String$length(append),
				string),
			append);
	});
var _elm_community$string_extra$String_Extra$ellipsis = F2(
	function (howLong, string) {
		return A3(_elm_community$string_extra$String_Extra$ellipsisWith, howLong, '...', string);
	});
var _elm_community$string_extra$String_Extra$countOccurrences = F2(
	function (needle, haystack) {
		return (_elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$length(needle),
			0) || _elm_lang$core$Native_Utils.eq(
			_elm_lang$core$String$length(haystack),
			0)) ? 0 : _elm_lang$core$List$length(
			A2(_elm_lang$core$String$indexes, needle, haystack));
	});
var _elm_community$string_extra$String_Extra$unindent = function (multilineSting) {
	var isNotWhitespace = function ($char) {
		return (!_elm_lang$core$Native_Utils.eq(
			$char,
			_elm_lang$core$Native_Utils.chr(' '))) && (!_elm_lang$core$Native_Utils.eq(
			$char,
			_elm_lang$core$Native_Utils.chr('\t')));
	};
	var countLeadingWhitespace = F2(
		function (count, line) {
			countLeadingWhitespace:
			while (true) {
				var _p21 = _elm_lang$core$String$uncons(line);
				if (_p21.ctor === 'Nothing') {
					return count;
				} else {
					var _p23 = _p21._0._1;
					var _p22 = _p21._0._0;
					switch (_p22.valueOf()) {
						case ' ':
							var _v35 = count + 1,
								_v36 = _p23;
							count = _v35;
							line = _v36;
							continue countLeadingWhitespace;
						case '\t':
							var _v37 = count + 1,
								_v38 = _p23;
							count = _v37;
							line = _v38;
							continue countLeadingWhitespace;
						default:
							return count;
					}
				}
			}
		});
	var lines = _elm_lang$core$String$lines(multilineSting);
	var minLead = A2(
		_elm_lang$core$Maybe$withDefault,
		0,
		_elm_lang$core$List$minimum(
			A2(
				_elm_lang$core$List$map,
				countLeadingWhitespace(0),
				A2(
					_elm_lang$core$List$filter,
					_elm_lang$core$String$any(isNotWhitespace),
					lines))));
	return A2(
		_elm_lang$core$String$join,
		'\n',
		A2(
			_elm_lang$core$List$map,
			_elm_lang$core$String$dropLeft(minLead),
			lines));
};
var _elm_community$string_extra$String_Extra$dasherize = function (string) {
	return _elm_lang$core$String$toLower(
		A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_elm_lang$core$Regex$regex('[_-\\s]+'),
			_elm_lang$core$Basics$always('-'),
			A4(
				_elm_lang$core$Regex$replace,
				_elm_lang$core$Regex$All,
				_elm_lang$core$Regex$regex('([A-Z])'),
				function (_p24) {
					return A2(
						_elm_lang$core$String$append,
						'-',
						function (_) {
							return _.match;
						}(_p24));
				},
				_elm_lang$core$String$trim(string))));
};
var _elm_community$string_extra$String_Extra$underscored = function (string) {
	return _elm_lang$core$String$toLower(
		A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_elm_lang$core$Regex$regex('[_-\\s]+'),
			_elm_lang$core$Basics$always('_'),
			A4(
				_elm_lang$core$Regex$replace,
				_elm_lang$core$Regex$All,
				_elm_lang$core$Regex$regex('([a-z\\d])([A-Z]+)'),
				function (_p25) {
					return A2(
						_elm_lang$core$String$join,
						'_',
						A2(
							_elm_lang$core$List$filterMap,
							_elm_lang$core$Basics$identity,
							function (_) {
								return _.submatches;
							}(_p25)));
				},
				_elm_lang$core$String$trim(string))));
};
var _elm_community$string_extra$String_Extra$unsurround = F2(
	function (wrap, string) {
		if (A2(_elm_lang$core$String$startsWith, wrap, string) && A2(_elm_lang$core$String$endsWith, wrap, string)) {
			var length = _elm_lang$core$String$length(wrap);
			return A2(
				_elm_lang$core$String$dropRight,
				length,
				A2(_elm_lang$core$String$dropLeft, length, string));
		} else {
			return string;
		}
	});
var _elm_community$string_extra$String_Extra$unquote = function (string) {
	return A2(_elm_community$string_extra$String_Extra$unsurround, '\"', string);
};
var _elm_community$string_extra$String_Extra$surround = F2(
	function (wrap, string) {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			wrap,
			A2(_elm_lang$core$Basics_ops['++'], string, wrap));
	});
var _elm_community$string_extra$String_Extra$quote = function (string) {
	return A2(_elm_community$string_extra$String_Extra$surround, '\"', string);
};
var _elm_community$string_extra$String_Extra$camelize = function (string) {
	return A4(
		_elm_lang$core$Regex$replace,
		_elm_lang$core$Regex$All,
		_elm_lang$core$Regex$regex('[-_\\s]+(.)?'),
		function (_p26) {
			var _p27 = _p26;
			var _p28 = _p27.submatches;
			if ((_p28.ctor === '::') && (_p28._0.ctor === 'Just')) {
				return _elm_lang$core$String$toUpper(_p28._0._0);
			} else {
				return '';
			}
		},
		_elm_lang$core$String$trim(string));
};
var _elm_community$string_extra$String_Extra$isBlank = function (string) {
	return A2(
		_elm_lang$core$Regex$contains,
		_elm_lang$core$Regex$regex('^\\s*$'),
		string);
};
var _elm_community$string_extra$String_Extra$nonBlank = function (string) {
	return _elm_community$string_extra$String_Extra$isBlank(string) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(string);
};
var _elm_community$string_extra$String_Extra$clean = function (string) {
	return _elm_lang$core$String$trim(
		A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_elm_lang$core$Regex$regex('\\s\\s+'),
			_elm_lang$core$Basics$always(' '),
			string));
};
var _elm_community$string_extra$String_Extra$softBreakRegexp = function (width) {
	return _elm_lang$core$Regex$regex(
		A2(
			_elm_lang$core$Basics_ops['++'],
			'.{1,',
			A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(width),
				'}(\\s+|$)|\\S+?(\\s+|$)')));
};
var _elm_community$string_extra$String_Extra$softEllipsis = F2(
	function (howLong, string) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(string),
			howLong) < 1) ? string : A3(
			_elm_lang$core$Basics$flip,
			_elm_lang$core$String$append,
			'...',
			A4(
				_elm_lang$core$Regex$replace,
				_elm_lang$core$Regex$All,
				_elm_lang$core$Regex$regex('([\\.,;:\\s])+$'),
				_elm_lang$core$Basics$always(''),
				A2(
					_elm_lang$core$String$join,
					'',
					A2(
						_elm_lang$core$List$map,
						function (_) {
							return _.match;
						},
						A3(
							_elm_lang$core$Regex$find,
							_elm_lang$core$Regex$AtMost(1),
							_elm_community$string_extra$String_Extra$softBreakRegexp(howLong),
							string)))));
	});
var _elm_community$string_extra$String_Extra$softBreak = F2(
	function (width, string) {
		return (_elm_lang$core$Native_Utils.cmp(width, 0) < 1) ? {ctor: '[]'} : A2(
			_elm_lang$core$List$map,
			function (_) {
				return _.match;
			},
			A3(
				_elm_lang$core$Regex$find,
				_elm_lang$core$Regex$All,
				_elm_community$string_extra$String_Extra$softBreakRegexp(width),
				string));
	});
var _elm_community$string_extra$String_Extra$softWrapWith = F3(
	function (width, separator, string) {
		return A2(
			_elm_lang$core$String$join,
			separator,
			A2(_elm_community$string_extra$String_Extra$softBreak, width, string));
	});
var _elm_community$string_extra$String_Extra$softWrap = F2(
	function (width, string) {
		return A3(_elm_community$string_extra$String_Extra$softWrapWith, width, '\n', string);
	});
var _elm_community$string_extra$String_Extra$breaker = F3(
	function (width, string, acc) {
		breaker:
		while (true) {
			var _p29 = string;
			if (_p29 === '') {
				return _elm_lang$core$List$reverse(acc);
			} else {
				var _v42 = width,
					_v43 = A2(_elm_lang$core$String$dropLeft, width, string),
					_v44 = {
					ctor: '::',
					_0: A3(_elm_lang$core$String$slice, 0, width, string),
					_1: acc
				};
				width = _v42;
				string = _v43;
				acc = _v44;
				continue breaker;
			}
		}
	});
var _elm_community$string_extra$String_Extra$break = F2(
	function (width, string) {
		return (_elm_lang$core$Native_Utils.eq(width, 0) || _elm_lang$core$Native_Utils.eq(string, '')) ? {
			ctor: '::',
			_0: string,
			_1: {ctor: '[]'}
		} : A3(
			_elm_community$string_extra$String_Extra$breaker,
			width,
			string,
			{ctor: '[]'});
	});
var _elm_community$string_extra$String_Extra$wrapWith = F3(
	function (width, separator, string) {
		return A2(
			_elm_lang$core$String$join,
			separator,
			A2(_elm_community$string_extra$String_Extra$break, width, string));
	});
var _elm_community$string_extra$String_Extra$wrap = F2(
	function (width, string) {
		return A3(_elm_community$string_extra$String_Extra$wrapWith, width, '\n', string);
	});
var _elm_community$string_extra$String_Extra$replaceSlice = F4(
	function (substitution, start, end, string) {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			A3(_elm_lang$core$String$slice, 0, start, string),
			A2(
				_elm_lang$core$Basics_ops['++'],
				substitution,
				A3(
					_elm_lang$core$String$slice,
					end,
					_elm_lang$core$String$length(string),
					string)));
	});
var _elm_community$string_extra$String_Extra$insertAt = F3(
	function (insert, pos, string) {
		return A4(_elm_community$string_extra$String_Extra$replaceSlice, insert, pos, pos, string);
	});
var _elm_community$string_extra$String_Extra$replace = F3(
	function (search, substitution, string) {
		return A4(
			_elm_lang$core$Regex$replace,
			_elm_lang$core$Regex$All,
			_elm_lang$core$Regex$regex(
				_elm_lang$core$Regex$escape(search)),
			function (_p30) {
				return substitution;
			},
			string);
	});
var _elm_community$string_extra$String_Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			'',
			A2(
				_elm_lang$core$Maybe$map,
				function (_p31) {
					var _p32 = _p31;
					return A2(
						_elm_lang$core$String$cons,
						mutator(_p32._0),
						_p32._1);
				},
				_elm_lang$core$String$uncons(word)));
	});
var _elm_community$string_extra$String_Extra$toSentenceCase = function (word) {
	return A2(_elm_community$string_extra$String_Extra$changeCase, _elm_lang$core$Char$toUpper, word);
};
var _elm_community$string_extra$String_Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A3(
		_elm_lang$core$Regex$replace,
		_elm_lang$core$Regex$All,
		_elm_lang$core$Regex$regex('\\w+'),
		function (_p33) {
			return _elm_community$string_extra$String_Extra$toSentenceCase(
				function (_) {
					return _.match;
				}(_p33));
		});
	return A4(
		_elm_lang$core$Regex$replace,
		_elm_lang$core$Regex$All,
		_elm_lang$core$Regex$regex('^([a-z])|\\s+([a-z])'),
		function (_p34) {
			return uppercaseMatch(
				function (_) {
					return _.match;
				}(_p34));
		},
		ws);
};
var _elm_community$string_extra$String_Extra$classify = function (string) {
	return _elm_community$string_extra$String_Extra$toSentenceCase(
		A3(
			_elm_community$string_extra$String_Extra$replace,
			' ',
			'',
			_elm_community$string_extra$String_Extra$camelize(
				A4(
					_elm_lang$core$Regex$replace,
					_elm_lang$core$Regex$All,
					_elm_lang$core$Regex$regex('[\\W_]'),
					_elm_lang$core$Basics$always(' '),
					string))));
};
var _elm_community$string_extra$String_Extra$humanize = function (string) {
	return _elm_community$string_extra$String_Extra$toSentenceCase(
		_elm_lang$core$String$toLower(
			_elm_lang$core$String$trim(
				A4(
					_elm_lang$core$Regex$replace,
					_elm_lang$core$Regex$All,
					_elm_lang$core$Regex$regex('_id$|[-_\\s]+'),
					_elm_lang$core$Basics$always(' '),
					A4(
						_elm_lang$core$Regex$replace,
						_elm_lang$core$Regex$All,
						_elm_lang$core$Regex$regex('[A-Z]'),
						function (_p35) {
							return A2(
								_elm_lang$core$String$append,
								'-',
								function (_) {
									return _.match;
								}(_p35));
						},
						string)))));
};
var _elm_community$string_extra$String_Extra$decapitalize = function (word) {
	return A2(_elm_community$string_extra$String_Extra$changeCase, _elm_lang$core$Char$toLower, word);
};

var _CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex = F3(
	function (model, idx, updatedField) {
		return A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$List$take, idx, model.selectedFilters),
			A2(
				_elm_lang$core$Basics_ops['++'],
				{
					ctor: '::',
					_0: updatedField,
					_1: {ctor: '[]'}
				},
				A2(_elm_lang$core$List$drop, idx + 1, model.selectedFilters)));
	});
var _CareerPlug$ats$ReportBuilder_Update$fieldTupleByName = F2(
	function (model, name) {
		var fieldsIndex = A2(
			_elm_lang$core$List$indexedMap,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			model.fieldChoices);
		var fieldTuple = function () {
			var tuple = _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filter,
					function (_p0) {
						var _p1 = _p0;
						return _elm_lang$core$Native_Utils.eq(_p1._1.field_name, name);
					},
					fieldsIndex));
			var _p2 = tuple;
			if (_p2.ctor === 'Just') {
				return _p2._0;
			} else {
				return {ctor: '_Tuple2', _0: 0, _1: _CareerPlug$ats$ReportBuilder_Model$emptyReportField};
			}
		}();
		return fieldTuple;
	});
var _CareerPlug$ats$ReportBuilder_Update$filterTupleByName = F2(
	function (model, name) {
		var filtersIndex = A2(
			_elm_lang$core$List$indexedMap,
			F2(
				function (v0, v1) {
					return {ctor: '_Tuple2', _0: v0, _1: v1};
				}),
			model.selectedFilters);
		var filterTuple = function () {
			var tuple = _elm_lang$core$List$head(
				A2(
					_elm_lang$core$List$filter,
					function (_p3) {
						var _p4 = _p3;
						return _elm_lang$core$Native_Utils.eq(_p4._1.field_name, name);
					},
					filtersIndex));
			var _p5 = tuple;
			if (_p5.ctor === 'Just') {
				return _p5._0;
			} else {
				return {
					ctor: '_Tuple2',
					_0: 0,
					_1: A7(_CareerPlug$ats$ReportBuilder_Model$ReportFilter, '', '', '', _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing)
				};
			}
		}();
		return filterTuple;
	});
var _CareerPlug$ats$ReportBuilder_Update$moveItem = F3(
	function (fromPos, offset, list) {
		var moved = A2(
			_elm_lang$core$List$take,
			1,
			A2(_elm_lang$core$List$drop, fromPos, list));
		var listWithoutMoved = A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$List$take, fromPos, list),
			A2(_elm_lang$core$List$drop, fromPos + 1, list));
		return A2(
			_elm_lang$core$Basics_ops['++'],
			A2(_elm_lang$core$List$take, fromPos + offset, listWithoutMoved),
			A2(
				_elm_lang$core$Basics_ops['++'],
				moved,
				A2(_elm_lang$core$List$drop, fromPos + offset, listWithoutMoved)));
	});
var _CareerPlug$ats$ReportBuilder_Update$update = F2(
	function (msg, model) {
		var _p6 = msg;
		switch (_p6.ctor) {
			case 'NoOp':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			case 'RunReport':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{saving: true}),
					{
						ctor: '::',
						_0: A3(_CareerPlug$ats$ReportBuilder_Service$saveRequest, model, _p6._0, _p6._1),
						_1: {ctor: '[]'}
					});
			case 'SaveRequestComplete':
				var _p7 = _p6._0;
				if (_p7.ctor === 'Ok') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{
							ctor: '::',
							_0: _CareerPlug$ats$ReportBuilder_Ports$redirectToManage(true),
							_1: {ctor: '[]'}
						});
				} else {
					var _p8 = _p7._0;
					if (_p8.ctor === 'BadStatus') {
						var errResp = A2(
							_elm_lang$core$Json_Decode$decodeString,
							_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string),
							_p8._0.body);
						var _p9 = errResp;
						if (_p9.ctor === 'Ok') {
							var fields = A2(
								_elm_lang$core$List$map,
								_CareerPlug$ats$ReportBuilder_Update$fieldTupleByName(model),
								_p9._0);
							var fieldNames = A2(
								_elm_lang$core$String$join,
								', ',
								A2(
									_elm_lang$core$List$map,
									function (_p10) {
										var _p11 = _p10;
										return _p11._1.display_name;
									},
									fields));
							var fieldIndexes = A2(
								_elm_lang$core$List$map,
								function (_p12) {
									var _p13 = _p12;
									return _p13._0;
								},
								fields);
							return A2(
								_elm_lang$core$Platform_Cmd_ops['!'],
								_elm_lang$core$Native_Utils.update(
									model,
									{
										missingFieldsMessage: _elm_lang$core$Maybe$Just(fieldNames),
										missingFields: fieldIndexes,
										saving: false,
										error: false
									}),
								{ctor: '[]'});
						} else {
							return A2(
								_elm_lang$core$Platform_Cmd_ops['!'],
								_elm_lang$core$Native_Utils.update(
									model,
									{saving: false, error: true}),
								{ctor: '[]'});
						}
					} else {
						return A2(
							_elm_lang$core$Platform_Cmd_ops['!'],
							_elm_lang$core$Native_Utils.update(
								model,
								{saving: false, error: true}),
							{ctor: '[]'});
					}
				}
			case 'AddMissingFields':
				var notSelected = function (idx) {
					return A2(
						F2(
							function (x, y) {
								return _elm_lang$core$Native_Utils.eq(x, y);
							}),
						0,
						_elm_lang$core$List$length(
							A2(
								_elm_lang$core$List$filter,
								function (field) {
									return _elm_lang$core$Native_Utils.eq(field, idx);
								},
								model.selectedFields)));
				};
				var fieldsToAdd = A2(_elm_lang$core$List$filter, notSelected, _p6._0);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							missingFieldsMessage: _elm_lang$core$Maybe$Nothing,
							missingFields: {ctor: '[]'},
							selectedFields: A2(_elm_lang$core$Basics_ops['++'], model.selectedFields, fieldsToAdd)
						}),
					{ctor: '[]'});
			case 'ClearError':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{error: false, missingFieldsMessage: _elm_lang$core$Maybe$Nothing}),
					{ctor: '[]'});
			case 'ShowMultiSelect':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: _CareerPlug$ats$ReportBuilder_Ports$showMultiSelectModal(
							{ctor: '_Tuple4', _0: _p6._0, _1: _p6._1, _2: _p6._2, _3: _p6._3}),
						_1: {ctor: '[]'}
					});
			case 'EnterHover':
				var _p14 = model.fieldListResize;
				if (_p14.ctor === 'Just') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								hovering: A2(
									_elm_lang$core$Basics_ops['++'],
									model.hovering,
									{
										ctor: '::',
										_0: _p6._0,
										_1: {ctor: '[]'}
									})
							}),
						{ctor: '[]'});
				}
			case 'ExitHover':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							hovering: A2(
								_elm_lang$core$List$filter,
								function (id) {
									return !_elm_lang$core$Native_Utils.eq(id, _p6._0);
								},
								model.hovering)
						}),
					{ctor: '[]'});
			case 'UpdateSearchBar':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{searchBarValue: _p6._0}),
					{ctor: '[]'});
			case 'UpdateReportName':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{reportName: _p6._0}),
					{ctor: '[]'});
			case 'UpdateReportRecipients':
				var splitRecipients = A2(
					_elm_lang$core$String$split,
					',',
					A3(_elm_community$string_extra$String_Extra$replace, ' ', '', _p6._0));
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{recipients: splitRecipients}),
					{ctor: '[]'});
			case 'UpdateFilterValue':
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0);
				var updatedFilter = function () {
					var filter = _elm_lang$core$Tuple$second(filterTuple);
					return _elm_lang$core$Native_Utils.update(
						filter,
						{
							string_value: _elm_lang$core$Maybe$Just(_p6._1)
						});
				}();
				var updatedFilters = A3(
					_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
					model,
					_elm_lang$core$Tuple$first(filterTuple),
					updatedFilter);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{selectedFilters: updatedFilters}),
					{ctor: '[]'});
			case 'UpdateFilterDateIntervalInclusive':
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0);
				var filter = _elm_lang$core$Tuple$second(filterTuple);
				var _p15 = filter.date_interval;
				if (_p15.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var updatedFilter = function () {
						var inclusive_ = _elm_lang$core$Native_Utils.eq(_p6._1, 'this') ? true : false;
						var updatedFilterDateIntervalRange = _elm_lang$core$Native_Utils.update(
							_p15._0,
							{inclusive: inclusive_});
						return _elm_lang$core$Native_Utils.update(
							filter,
							{
								date_interval: _elm_lang$core$Maybe$Just(updatedFilterDateIntervalRange)
							});
					}();
					var updatedFilters = A3(
						_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
						model,
						_elm_lang$core$Tuple$first(filterTuple),
						updatedFilter);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{selectedFilters: updatedFilters}),
						{ctor: '[]'});
				}
			case 'UpdateFilterDateIntervalRange':
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0);
				var filter = _elm_lang$core$Tuple$second(filterTuple);
				var _p16 = filter.date_interval;
				if (_p16.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var updatedFilter = function () {
						var updatedFilterDateRange = _elm_lang$core$Native_Utils.update(
							_p16._0,
							{range: _p6._1});
						return _elm_lang$core$Native_Utils.update(
							filter,
							{
								date_interval: _elm_lang$core$Maybe$Just(updatedFilterDateRange)
							});
					}();
					var updatedFilters = A3(
						_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
						model,
						_elm_lang$core$Tuple$first(filterTuple),
						updatedFilter);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{selectedFilters: updatedFilters}),
						{ctor: '[]'});
				}
			case 'UpdateFilterDateIntervalInterval':
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0);
				var filter = _elm_lang$core$Tuple$second(filterTuple);
				var _p17 = filter.date_interval;
				if (_p17.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var updatedFilter = function () {
						var updatedFilterDateIntervalRange = _elm_lang$core$Native_Utils.update(
							_p17._0,
							{interval: _p6._1});
						return _elm_lang$core$Native_Utils.update(
							filter,
							{
								date_interval: _elm_lang$core$Maybe$Just(updatedFilterDateIntervalRange)
							});
					}();
					var updatedFilters = A3(
						_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
						model,
						_elm_lang$core$Tuple$first(filterTuple),
						updatedFilter);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{selectedFilters: updatedFilters}),
						{ctor: '[]'});
				}
			case 'DateChanged':
				var _p21 = _p6._3;
				var _p20 = _p6._2;
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0);
				var filter = _elm_lang$core$Tuple$second(filterTuple);
				var _p18 = filter.date_range;
				if (_p18.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var _p19 = _p18._0;
					var updatedFilter = function () {
						var updatedFilterDateRange = _elm_lang$core$Native_Utils.eq(_p6._1, 'start') ? _elm_lang$core$Native_Utils.update(
							_p19,
							{start_date: _p21, startDatePickerState: _p20}) : _elm_lang$core$Native_Utils.update(
							_p19,
							{end_date: _p21, endDatePickerState: _p20});
						return _elm_lang$core$Native_Utils.update(
							filter,
							{
								date_range: _elm_lang$core$Maybe$Just(updatedFilterDateRange)
							});
					}();
					var updatedFilters = A3(
						_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
						model,
						_elm_lang$core$Tuple$first(filterTuple),
						updatedFilter);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{selectedFilters: updatedFilters}),
						{ctor: '[]'});
				}
			case 'SetDateType':
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0);
				var filter = _elm_lang$core$Tuple$second(filterTuple);
				var updatedFilter = _elm_lang$core$Native_Utils.update(
					filter,
					{filter_type: _p6._1});
				var updatedFilters = A3(
					_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
					model,
					_elm_lang$core$Tuple$first(filterTuple),
					updatedFilter);
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{selectedFilters: updatedFilters}),
					{ctor: '[]'});
			case 'UpdateSelect':
				var filterTuple = A2(_CareerPlug$ats$ReportBuilder_Update$filterTupleByName, model, _p6._0._0);
				var filter = _elm_lang$core$Tuple$second(filterTuple);
				var _p22 = filter.select;
				if (_p22.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					var updatedFilter = function () {
						var updatedFilterSelect = _elm_lang$core$Native_Utils.update(
							_p22._0,
							{current_selected: _p6._0._1});
						return _elm_lang$core$Native_Utils.update(
							filter,
							{
								select: _elm_lang$core$Maybe$Just(updatedFilterSelect)
							});
					}();
					var updatedFilters = A3(
						_CareerPlug$ats$ReportBuilder_Update$updateFilterByIndex,
						model,
						_elm_lang$core$Tuple$first(filterTuple),
						updatedFilter);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{selectedFilters: updatedFilters}),
						{ctor: '[]'});
				}
			case 'SetBoundingClient':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{boundingClient: _p6._0}),
					{ctor: '[]'});
			case 'SetColumnBuilderBoundingClient':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{columnBuilderBoundingClient: _p6._0}),
					{ctor: '[]'});
			case 'SetCurrentBuilderScroll':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{currentBuilderScroll: _p6._0}),
					{ctor: '[]'});
			case 'RemoveField':
				var _p23 = _p6._0;
				var newSelectedFields = A2(
					_elm_lang$core$Basics_ops['++'],
					A2(_elm_lang$core$List$take, _p23, model.selectedFields),
					A2(_elm_lang$core$List$drop, _p23 + 1, model.selectedFields));
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{selectedFields: newSelectedFields}),
					{ctor: '[]'});
			case 'AddField':
				var _p24 = _p6._0;
				var alreadySelected = function () {
					var selected = A2(
						_elm_lang$core$List$filter,
						function (field) {
							return _elm_lang$core$Native_Utils.eq(field, _p24);
						},
						model.selectedFields);
					return _elm_lang$core$Native_Utils.eq(
						_elm_lang$core$List$length(selected),
						1);
				}();
				var newSelectedFields = alreadySelected ? model.selectedFields : A2(
					_elm_lang$core$Basics_ops['++'],
					model.selectedFields,
					{
						ctor: '::',
						_0: _p24,
						_1: {ctor: '[]'}
					});
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{selectedFields: newSelectedFields}),
					{ctor: '[]'});
			case 'AddFilter':
				var field = A2(
					_elm_lang$core$Array$get,
					_p6._0,
					_elm_lang$core$Array$fromList(model.fieldChoices));
				var fieldName = function () {
					var _p25 = field;
					if (_p25.ctor === 'Just') {
						return _p25._0.field_name;
					} else {
						return '';
					}
				}();
				var alreadySelected = A2(
					F2(
						function (x, y) {
							return _elm_lang$core$Native_Utils.eq(x, y);
						}),
					1,
					_elm_lang$core$List$length(
						A2(
							_elm_lang$core$List$filter,
							function (filter) {
								return _elm_lang$core$Native_Utils.eq(filter.field_name, fieldName);
							},
							model.selectedFilters)));
				if ((!_elm_lang$core$Native_Utils.eq(fieldName, '')) && _elm_lang$core$Native_Utils.eq(alreadySelected, false)) {
					var field_ = A2(_elm_lang$core$Maybe$withDefault, _CareerPlug$ats$ReportBuilder_Model$emptyReportField, field);
					var baseField = A3(_CareerPlug$ats$ReportBuilder_Model$ReportFilter, field_.field_name, field_.display_name, field_.filter_type);
					var buildDate = A4(
						baseField,
						_elm_lang$core$Maybe$Nothing,
						_elm_lang$core$Maybe$Just(_CareerPlug$ats$ReportBuilder_Model$defaultFilterDateInterval),
						_elm_lang$core$Maybe$Just(
							_CareerPlug$ats$ReportBuilder_Model$defaultFilterDateRange(model.todaysDate)),
						_elm_lang$core$Maybe$Nothing);
					var reportField = function () {
						var _p26 = field_.filter_type;
						switch (_p26) {
							case 'string':
								return A4(
									baseField,
									_elm_lang$core$Maybe$Just(''),
									_elm_lang$core$Maybe$Nothing,
									_elm_lang$core$Maybe$Nothing,
									_elm_lang$core$Maybe$Nothing);
							case 'date_range':
								return buildDate;
							case 'date_interval':
								return buildDate;
							case 'multi_select':
								return A4(
									baseField,
									_elm_lang$core$Maybe$Nothing,
									_elm_lang$core$Maybe$Nothing,
									_elm_lang$core$Maybe$Nothing,
									_elm_lang$core$Maybe$Just(
										A3(
											_CareerPlug$ats$ReportBuilder_Model$FilterSelect,
											field_.select_options,
											{ctor: '[]'},
											field_.select_id_type)));
							default:
								return A4(baseField, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing, _elm_lang$core$Maybe$Nothing);
						}
					}();
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								selectedFilters: A2(
									_elm_lang$core$Basics_ops['++'],
									model.selectedFilters,
									{
										ctor: '::',
										_0: reportField,
										_1: {ctor: '[]'}
									})
							}),
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			case 'RemoveFilter':
				var filterTuple = _elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$filter,
						function (_p27) {
							var _p28 = _p27;
							return _elm_lang$core$Native_Utils.eq(_p28._1.field_name, _p6._0);
						},
						A2(
							_elm_lang$core$List$indexedMap,
							F2(
								function (v0, v1) {
									return {ctor: '_Tuple2', _0: v0, _1: v1};
								}),
							model.selectedFilters)));
				var updatedFilters = function () {
					var _p29 = filterTuple;
					if (_p29.ctor === 'Just') {
						var index = _elm_lang$core$Tuple$first(_p29._0);
						return A2(
							_elm_lang$core$Basics_ops['++'],
							A2(_elm_lang$core$List$take, index, model.selectedFilters),
							A2(_elm_lang$core$List$drop, index + 1, model.selectedFilters));
					} else {
						return model.selectedFilters;
					}
				}();
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{selectedFilters: updatedFilters}),
					{ctor: '[]'});
			case 'ToggleRunDay':
				var _p34 = _p6._0;
				var maybeTuple = _elm_lang$core$List$head(
					A2(
						_elm_lang$core$List$filter,
						function (_p30) {
							var _p31 = _p30;
							return _elm_lang$core$Native_Utils.eq(_p31._1, _p34);
						},
						A2(
							_elm_lang$core$List$indexedMap,
							F2(
								function (v0, v1) {
									return {ctor: '_Tuple2', _0: v0, _1: v1};
								}),
							model.runDays)));
				var _p32 = maybeTuple;
				if (_p32.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								runDays: A2(
									_elm_lang$core$Basics_ops['++'],
									model.runDays,
									{
										ctor: '::',
										_0: _p34,
										_1: {ctor: '[]'}
									})
							}),
						{ctor: '[]'});
				} else {
					var _p33 = _p32._0._0;
					var newRunDays = A2(
						_elm_lang$core$Basics_ops['++'],
						A2(_elm_lang$core$List$take, _p33, model.runDays),
						A2(_elm_lang$core$List$drop, _p33 + 1, model.runDays));
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{runDays: newRunDays}),
						{ctor: '[]'});
				}
			case 'FilterAreaResizeStart':
				var _p35 = _p6._0;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							filterAreaResize: _elm_lang$core$Maybe$Just(
								A2(_CareerPlug$ats$ReportBuilder_Model$FilterAreaResize, _p35.y, _p35.y))
						}),
					{ctor: '[]'});
			case 'FilterAreaResizeAt':
				var _p42 = _p6._0;
				var filterAreaHeight = A2(
					_elm_lang$core$Maybe$map,
					function (_p36) {
						var _p37 = _p36;
						var _p38 = _p37.startY;
						return (_p38 - (model.boundingClient.top - ((_CareerPlug$ats$ReportBuilder_Constants$dragBarWidth / 2) | 0))) + (_p42.y - _p38);
					},
					model.filterAreaResize);
				var filterAreaResize = A2(
					_elm_lang$core$Maybe$map,
					function (_p39) {
						var _p40 = _p39;
						return A2(_CareerPlug$ats$ReportBuilder_Model$FilterAreaResize, _p40.startY, _p42.y);
					},
					model.filterAreaResize);
				var _p41 = filterAreaHeight;
				if (_p41.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								filterAreaResize: filterAreaResize,
								filterAreaHeight: _elm_lang$core$Maybe$Just(_p41._0)
							}),
						{ctor: '[]'});
				}
			case 'FilterAreaResizeEnd':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{filterAreaResize: _elm_lang$core$Maybe$Nothing}),
					{ctor: '[]'});
			case 'FieldListResizeStart':
				var _p43 = _p6._0;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							fieldListResize: _elm_lang$core$Maybe$Just(
								A2(_CareerPlug$ats$ReportBuilder_Model$FieldListResize, _p43.x, _p43.x))
						}),
					{ctor: '[]'});
			case 'FieldListResizeAt':
				var _p50 = _p6._0;
				var fieldListWidth = A2(
					_elm_lang$core$Maybe$map,
					function (_p44) {
						var _p45 = _p44;
						var _p46 = _p45.startX;
						return (_p46 - (model.boundingClient.left - ((_CareerPlug$ats$ReportBuilder_Constants$dragBarWidth / 2) | 0))) + (_p50.x - _p46);
					},
					model.fieldListResize);
				var fieldListResize = A2(
					_elm_lang$core$Maybe$map,
					function (_p47) {
						var _p48 = _p47;
						return A2(_CareerPlug$ats$ReportBuilder_Model$FieldListResize, _p48.startX, _p50.x);
					},
					model.fieldListResize);
				var _p49 = fieldListWidth;
				if (_p49.ctor === 'Nothing') {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{
								fieldListResize: fieldListResize,
								fieldListWidth: _elm_lang$core$Maybe$Just(_p49._0)
							}),
						{ctor: '[]'});
				}
			case 'FieldListResizeEnd':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{fieldListResize: _elm_lang$core$Maybe$Nothing}),
					{ctor: '[]'});
			case 'ColumnDragStart':
				var _p51 = _p6._1;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							columnDrag: _elm_lang$core$Maybe$Just(
								A3(_CareerPlug$ats$ReportBuilder_Model$ColumnDrag, _p6._0, _p51.x, _p51.x)),
							startScroll: model.currentBuilderScroll
						}),
					{ctor: '[]'});
			case 'ColumnDragAt':
				var _p54 = _p6._0;
				var scrollTo = function () {
					var scrollWidth = _elm_lang$core$List$length(model.selectedFields) * _CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth;
					var fieldListWidth = A2(_elm_lang$core$Maybe$withDefault, _CareerPlug$ats$ReportBuilder_Constants$initialFieldListWidth, model.fieldListWidth);
					var widthOffset = fieldListWidth - _CareerPlug$ats$ReportBuilder_Constants$initialFieldListWidth;
					var width = model.columnBuilderBoundingClient.width - widthOffset;
					var maxScroll = scrollWidth - width;
					var currentPos = _p54.x - model.columnBuilderBoundingClient.left;
					return ((_elm_lang$core$Native_Utils.cmp(currentPos - widthOffset, width - 100) > 0) && (_elm_lang$core$Native_Utils.cmp(model.currentBuilderScroll, maxScroll) < 0)) ? (model.currentBuilderScroll + 100) : ((_elm_lang$core$Native_Utils.cmp(currentPos - widthOffset, 100) < 0) ? (model.currentBuilderScroll - 100) : 0);
				}();
				var offset = function () {
					var baseOffset = _elm_lang$core$Native_Utils.eq(scrollTo, 0) ? model.currentBuilderScroll : scrollTo;
					return baseOffset - model.startScroll;
				}();
				var commands = (_elm_lang$core$Native_Utils.cmp(scrollTo, 0) > 0) ? A2(
					_elm_lang$core$Task$attempt,
					_elm_lang$core$Basics$always(_CareerPlug$ats$ReportBuilder_Message$NoOp),
					A2(
						_elm_lang$dom$Dom_Scroll$toX,
						'report-info-fields-container',
						_elm_lang$core$Basics$toFloat(scrollTo))) : _elm_lang$core$Platform_Cmd$none;
				return {
					ctor: '_Tuple2',
					_0: _elm_lang$core$Native_Utils.update(
						model,
						{
							columnDrag: A2(
								_elm_lang$core$Maybe$map,
								function (_p52) {
									var _p53 = _p52;
									return A3(_CareerPlug$ats$ReportBuilder_Model$ColumnDrag, _p53.itemIndex, _p53.startX, _p54.x + offset);
								},
								model.columnDrag)
						}),
					_1: commands
				};
			default:
				var _p55 = model.columnDrag;
				if (_p55.ctor === 'Just') {
					var _p57 = _p55._0.startX;
					var _p56 = _p55._0.currentX;
					var incrementAmount = (_elm_lang$core$Native_Utils.cmp(_p56, _p57) < 0) ? -20 : 20;
					var newSelectedFields = A3(_CareerPlug$ats$ReportBuilder_Update$moveItem, _p55._0.itemIndex, (((_p56 - _p57) + incrementAmount) / _CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth) | 0, model.selectedFields);
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{columnDrag: _elm_lang$core$Maybe$Nothing, selectedFields: newSelectedFields}),
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						_elm_lang$core$Native_Utils.update(
							model,
							{columnDrag: _elm_lang$core$Maybe$Nothing}),
						{ctor: '[]'});
				}
		}
	});

var _CareerPlug$ats$ReportBuilder_View$flexStyles = F3(
	function (grow, shrink, basis) {
		var flexString = A2(
			_elm_lang$core$Basics_ops['++'],
			grow,
			A2(
				_elm_lang$core$Basics_ops['++'],
				' ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					shrink,
					A2(
						_elm_lang$core$Basics_ops['++'],
						' ',
						A2(_elm_lang$core$Basics_ops['++'], basis, 'px')))));
		return {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'flex', _1: flexString},
			_1: {
				ctor: '::',
				_0: {ctor: '_Tuple2', _0: '-ms-flex', _1: flexString},
				_1: {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: '-webkit-flex', _1: flexString},
					_1: {ctor: '[]'}
				}
			}
		};
	});
var _CareerPlug$ats$ReportBuilder_View$reportActionsView = function (model) {
	var runDay = F2(
		function (idx, day) {
			var isSelected = function (index) {
				return A2(
					F2(
						function (x, y) {
							return _elm_lang$core$Native_Utils.cmp(x, y) < 0;
						}),
					0,
					_elm_lang$core$List$length(
						A2(
							_elm_lang$core$List$filter,
							function (day) {
								return _elm_lang$core$Native_Utils.eq(day, index);
							},
							model.runDays)));
			};
			var index = _elm_lang$core$Basics$toString(idx);
			return A2(
				_elm_lang$html$Html$label,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('run-day'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$input,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$type_('checkbox'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$value(index),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$checked(
										isSelected(index)),
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Html$onClickPreventDefault(
											_CareerPlug$ats$ReportBuilder_Message$ToggleRunDay(index)),
										_1: {ctor: '[]'}
									}
								}
							}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$span,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(day),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				});
		});
	var runDays = A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('run-days'),
			_1: {ctor: '[]'}
		},
		A2(
			_elm_lang$core$List$indexedMap,
			runDay,
			{
				ctor: '::',
				_0: 'Sun.',
				_1: {
					ctor: '::',
					_0: 'Mon.',
					_1: {
						ctor: '::',
						_0: 'Tue.',
						_1: {
							ctor: '::',
							_0: 'Wed.',
							_1: {
								ctor: '::',
								_0: 'Thu.',
								_1: {
									ctor: '::',
									_0: 'Fri.',
									_1: {
										ctor: '::',
										_0: 'Sat.',
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				}
			}));
	var selectedField = function (idx) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_CareerPlug$ats$ReportBuilder_Model$emptyReportField,
			A2(
				_elm_lang$core$Array$get,
				idx,
				_elm_lang$core$Array$fromList(model.fieldChoices)));
	};
	var selectedFields = A2(
		_elm_lang$core$List$filter,
		function (f) {
			return !_elm_lang$core$Native_Utils.eq(f.field_name, '');
		},
		A2(_elm_lang$core$List$map, selectedField, model.selectedFields));
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('report-actions-container'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('report-name'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$label,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$for('report-name'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('Report Name'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$input,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$name('report-name'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$placeholder('Example Report '),
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$Library_Html$onKeyUp(_CareerPlug$ats$ReportBuilder_Message$UpdateReportName),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$value(model.reportName),
											_1: {ctor: '[]'}
										}
									}
								}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('run-days-container'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$label,
							{ctor: '[]'},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('Run Weekly On'),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: runDays,
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('change-recipient-container'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('report-recipient has-tooltip'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$title('Separate multiple email addresses with commas.'),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$label,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$for('report-recipient'),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text('Delivery Address(es)'),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$input,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$name('report-recipient'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$placeholder('Email Address(es) '),
													_1: {
														ctor: '::',
														_0: _CareerPlug$ats$Library_Html$onKeyUp(_CareerPlug$ats$ReportBuilder_Message$UpdateReportRecipients),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$value(
																A2(_elm_lang$core$String$join, ',', model.recipients)),
															_1: {ctor: '[]'}
														}
													}
												}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('report-info-footer'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$button,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(
											A2(_CareerPlug$ats$ReportBuilder_Message$RunReport, selectedFields, false)),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$i,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('fa fa-save'),
												_1: {ctor: '[]'}
											},
											{ctor: '[]'}),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html$text('Save Report'),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$button,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Events$onClick(
												A2(_CareerPlug$ats$ReportBuilder_Message$RunReport, selectedFields, true)),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('fa fa-cogs'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: _elm_lang$html$Html$text('Save and Run Report'),
												_1: {ctor: '[]'}
											}
										}),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _CareerPlug$ats$ReportBuilder_View$reportFieldItemView = F3(
	function (model, idx, reportField) {
		var getPlaceHolder = function (idx) {
			return A2(
				_elm_lang$core$Maybe$withDefault,
				'',
				A2(
					_elm_lang$core$Array$get,
					idx,
					_elm_lang$core$Array$fromList(reportField.placeholder)));
		};
		var makingWayStyle = function () {
			var _p0 = model.columnDrag;
			if (_p0.ctor === 'Just') {
				var _p3 = _p0._0.startX;
				var _p2 = _p0._0.itemIndex;
				var _p1 = _p0._0.currentX;
				return ((_elm_lang$core$Native_Utils.cmp(idx, _p2) < 0) && (_elm_lang$core$Native_Utils.cmp(_p1 - _p3, ((idx - _p2) * _CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth) + 20) < 0)) ? {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'transform',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							'translateX(',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth),
								'px)'))
					},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'transition', _1: 'transform 200ms ease-in-out'},
						_1: {ctor: '[]'}
					}
				} : (((_elm_lang$core$Native_Utils.cmp(idx, _p2) > 0) && (_elm_lang$core$Native_Utils.cmp(_p1 - _p3, ((idx - _p2) * _CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth) - 20) > 0)) ? {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'transform',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							'translateX(-',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth),
								'px)'))
					},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'transition', _1: 'transform 200ms ease-in-out'},
						_1: {ctor: '[]'}
					}
				} : ((!_elm_lang$core$Native_Utils.eq(idx, _p2)) ? {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'transition', _1: 'transform 200ms ease-in-out'},
					_1: {ctor: '[]'}
				} : {ctor: '[]'}));
			} else {
				return {ctor: '[]'};
			}
		}();
		var moveStyle = function () {
			var _p4 = model.columnDrag;
			if (_p4.ctor === 'Just') {
				return _elm_lang$core$Native_Utils.eq(_p4._0.itemIndex, idx) ? {
					ctor: '::',
					_0: {
						ctor: '_Tuple2',
						_0: 'transform',
						_1: A2(
							_elm_lang$core$Basics_ops['++'],
							'translateX( ',
							A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_p4._0.currentX - _p4._0.startX),
								'px) translateZ(10px)'))
					},
					_1: {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'z-index', _1: '10'},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'box-shadow', _1: '0 3px 6px rgba(0,0,0,0.24)'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'willChange', _1: 'transform'},
								_1: {ctor: '[]'}
							}
						}
					}
				} : {ctor: '[]'};
			} else {
				return {ctor: '[]'};
			}
		}();
		var baseStyle = A3(
			_CareerPlug$ats$ReportBuilder_View$flexStyles,
			'0',
			'0',
			_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$columnBuilderItemWidth));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('report-info-field-item'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$style(
						A2(
							_elm_lang$core$Basics_ops['++'],
							baseStyle,
							A2(_elm_lang$core$Basics_ops['++'], makingWayStyle, moveStyle))),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Library_Html$onMouseDown(
							_CareerPlug$ats$ReportBuilder_Message$ColumnDragStart(idx)),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('report-info-field-header'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('field-name'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$title(reportField.display_name),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(reportField.display_name),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('remove-field'),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(
											_CareerPlug$ats$ReportBuilder_Message$RemoveField(idx)),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('fa fa-times'),
											_1: {ctor: '[]'}
										},
										{ctor: '[]'}),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('report-info-field-cell'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(
								getPlaceHolder(0)),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('report-info-field-cell'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									getPlaceHolder(1)),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _CareerPlug$ats$ReportBuilder_View$reportFields = function (model) {
	var fieldsArray = _elm_lang$core$Array$fromList(model.fieldChoices);
	var fieldFromIndex = function (idx) {
		var maybeField = A2(_elm_lang$core$Array$get, idx, fieldsArray);
		return A2(_elm_lang$core$Maybe$withDefault, _CareerPlug$ats$ReportBuilder_Model$emptyReportField, maybeField);
	};
	var fields = A2(_elm_lang$core$List$map, fieldFromIndex, model.selectedFields);
	return A2(
		_elm_lang$core$List$indexedMap,
		_CareerPlug$ats$ReportBuilder_View$reportFieldItemView(model),
		fields);
};
var _CareerPlug$ats$ReportBuilder_View$reportInfoArea = function (model) {
	var fieldsContent = _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$List$length(model.selectedFields),
		0) ? {
		ctor: '::',
		_0: A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('placeholder-container'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Add Columns To Your Report'),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$span,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('(Use the field list to the left and click the column icon)'),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			}),
		_1: {ctor: '[]'}
	} : _CareerPlug$ats$ReportBuilder_View$reportFields(model);
	var selectedField = function (idx) {
		return A2(
			_elm_lang$core$Maybe$withDefault,
			_CareerPlug$ats$ReportBuilder_Model$emptyReportField,
			A2(
				_elm_lang$core$Array$get,
				idx,
				_elm_lang$core$Array$fromList(model.fieldChoices)));
	};
	var selectedFields = A2(
		_elm_lang$core$List$filter,
		function (f) {
			return !_elm_lang$core$Native_Utils.eq(f.field_name, '');
		},
		A2(_elm_lang$core$List$map, selectedField, model.selectedFields));
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('report-info-container'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('wrapper'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('report-info-fields-container'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$id('report-info-fields-container'),
								_1: {ctor: '[]'}
							}
						},
						fieldsContent),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$ReportBuilder_View$filterItemContainer = F4(
	function (displayName, fieldName, containerClass, children) {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(_elm_lang$core$Basics_ops['++'], 'filter-item ', containerClass)),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('name'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(displayName),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('content'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: children,
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('remove'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$i,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('fa fa-times'),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Events$onClick(
												_CareerPlug$ats$ReportBuilder_Message$RemoveFilter(fieldName)),
											_1: {ctor: '[]'}
										}
									},
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			});
	});
var _CareerPlug$ats$ReportBuilder_View$filterItemMultiSelectView = F2(
	function (model, filter) {
		var _p5 = filter.select;
		if (_p5.ctor === 'Nothing') {
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
		} else {
			var _p10 = _p5._0;
			var selectedIcon = function (name) {
				return A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('select-wrapper'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(name),
						_1: {ctor: '[]'}
					});
			};
			var isSelected = function (id) {
				return A2(
					F2(
						function (x, y) {
							return _elm_lang$core$Native_Utils.cmp(x, y) < 0;
						}),
					0,
					_elm_lang$core$List$length(
						A2(
							_elm_lang$core$List$filter,
							function (optId) {
								return _elm_lang$core$Native_Utils.eq(id, optId);
							},
							_p10.current_selected)));
			};
			var selected = function () {
				var options = A2(
					_elm_lang$core$List$map,
					function (_p6) {
						var _p7 = _p6;
						return selectedIcon(_p7._1);
					},
					A2(
						_elm_lang$core$List$filter,
						function (_p8) {
							var _p9 = _p8;
							return isSelected(_p9._0);
						},
						_p10.options));
				return (_elm_lang$core$Native_Utils.cmp(
					_elm_lang$core$List$length(options),
					0) > 0) ? options : {
					ctor: '::',
					_0: _elm_lang$html$Html$text('Click here to add options'),
					_1: {ctor: '[]'}
				};
			}();
			var content = A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('select-container'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							A4(_CareerPlug$ats$ReportBuilder_Message$ShowMultiSelect, filter.field_name, filter.display_name, _p10.options, _p10.current_selected)),
						_1: {ctor: '[]'}
					}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('text-container'),
							_1: {ctor: '[]'}
						},
						selected),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('edit'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text('Edit'),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				});
			return A4(_CareerPlug$ats$ReportBuilder_View$filterItemContainer, filter.display_name, filter.field_name, 'multi', content);
		}
	});
var _CareerPlug$ats$ReportBuilder_View$filterDateRangeView = F2(
	function (model, filter) {
		var _p11 = filter.date_range;
		if (_p11.ctor === 'Nothing') {
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
		} else {
			var _p12 = _p11._0;
			var endPickerConfig = _CareerPlug$ats$Library_Date$withCoreParser(
				_abadi199$datetimepicker$DateTimePicker_Config$defaultDatePickerConfig(
					A2(_CareerPlug$ats$ReportBuilder_Message$DateChanged, filter.field_name, 'end')));
			var startPickerConfig = _CareerPlug$ats$Library_Date$withCoreParser(
				_abadi199$datetimepicker$DateTimePicker_Config$defaultDatePickerConfig(
					A2(_CareerPlug$ats$ReportBuilder_Message$DateChanged, filter.field_name, 'start')));
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('date-pickers'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('picker-container'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$span,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('date-label'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text('Start Date:'),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A4(
									_abadi199$datetimepicker$DateTimePicker$datePickerWithConfig,
									_elm_lang$core$Native_Utils.update(
										startPickerConfig,
										{allowYearNavigation: false}),
									{ctor: '[]'},
									_p12.startDatePickerState,
									_p12.start_date),
								_1: {ctor: '[]'}
							}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('picker-container'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$span,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('date-label'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: _elm_lang$html$Html$text('End Date:'),
										_1: {ctor: '[]'}
									}),
								_1: {
									ctor: '::',
									_0: A4(
										_abadi199$datetimepicker$DateTimePicker$datePickerWithConfig,
										_elm_lang$core$Native_Utils.update(
											endPickerConfig,
											{allowYearNavigation: false}),
										{ctor: '[]'},
										_p12.endDatePickerState,
										_p12.end_date),
									_1: {ctor: '[]'}
								}
							}),
						_1: {ctor: '[]'}
					}
				});
		}
	});
var _CareerPlug$ats$ReportBuilder_View$filterDateIntervalView = F2(
	function (model, filter) {
		var _p13 = filter.date_interval;
		if (_p13.ctor === 'Nothing') {
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
		} else {
			var _p14 = _p13._0;
			var intervalSelected = function (val) {
				return _elm_lang$html$Html_Attributes$selected(
					_elm_lang$core$Native_Utils.eq(val, _p14.interval));
			};
			var inclusive = _p14.inclusive;
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('date-interval-sentence'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{ctor: '[]'},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('The last'),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$input,
							{
								ctor: '::',
								_0: _CareerPlug$ats$Library_Html$onKeyUp(
									_CareerPlug$ats$ReportBuilder_Message$UpdateFilterDateIntervalRange(filter.field_name)),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$value(_p14.range),
									_1: {ctor: '[]'}
								}
							},
							{ctor: '[]'}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('select-container'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$select,
										{
											ctor: '::',
											_0: _CareerPlug$ats$Library_Html$onChange(
												_CareerPlug$ats$ReportBuilder_Message$UpdateFilterDateIntervalInterval(filter.field_name)),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$option,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$value('day'),
													_1: {
														ctor: '::',
														_0: intervalSelected('day'),
														_1: {ctor: '[]'}
													}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text('days'),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$option,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$value('week'),
														_1: {
															ctor: '::',
															_0: intervalSelected('week'),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text('weeks'),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$option,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$value('month'),
															_1: {
																ctor: '::',
																_0: intervalSelected('month'),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text('months'),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$i,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('fa fa-sort'),
												_1: {ctor: '[]'}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('select-container'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$select,
											{
												ctor: '::',
												_0: _CareerPlug$ats$Library_Html$onChange(
													_CareerPlug$ats$ReportBuilder_Message$UpdateFilterDateIntervalInclusive(filter.field_name)),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$option,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$value('this'),
														_1: {
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$selected(inclusive),
															_1: {ctor: '[]'}
														}
													},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text('including'),
														_1: {ctor: '[]'}
													}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$option,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$value('previous'),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html_Attributes$selected(
																	_elm_lang$core$Native_Utils.eq(inclusive, false)),
																_1: {ctor: '[]'}
															}
														},
														{
															ctor: '::',
															_0: _elm_lang$html$Html$text('excluding'),
															_1: {ctor: '[]'}
														}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('fa fa-sort'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {ctor: '[]'}
										}
									}),
								_1: {
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$div,
										{ctor: '[]'},
										{
											ctor: '::',
											_0: _elm_lang$html$Html$text('the current'),
											_1: {ctor: '[]'}
										}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text(
													A2(_elm_lang$core$Basics_ops['++'], _p14.interval, '.')),
												_1: {ctor: '[]'}
											}),
										_1: {ctor: '[]'}
									}
								}
							}
						}
					}
				});
		}
	});
var _CareerPlug$ats$ReportBuilder_View$filterItemDateView = F2(
	function (model, filter) {
		var customClass = function (filterType) {
			return _elm_lang$core$Native_Utils.eq(filterType, filter.filter_type) ? 'selected' : '';
		};
		var typeSelector = A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('type-selector'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							A2(_CareerPlug$ats$ReportBuilder_Message$SetDateType, filter.field_name, 'date_interval')),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class(
								customClass('date_interval')),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('Interval'),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onClick(
								A2(_CareerPlug$ats$ReportBuilder_Message$SetDateType, filter.field_name, 'date_range')),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class(
									customClass('date_range')),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text('Custom'),
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
		var body = _elm_lang$core$Native_Utils.eq(filter.filter_type, 'date_range') ? A2(_CareerPlug$ats$ReportBuilder_View$filterDateRangeView, model, filter) : (_elm_lang$core$Native_Utils.eq(filter.filter_type, 'date_interval') ? A2(_CareerPlug$ats$ReportBuilder_View$filterDateIntervalView, model, filter) : A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{ctor: '[]'}));
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class(
					A2(_elm_lang$core$Basics_ops['++'], 'filter-item ', 'date')),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('body'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('name'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(filter.display_name),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('content'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: body,
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$div,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('remove'),
										_1: {ctor: '[]'}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$i,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class('fa fa-times'),
												_1: {
													ctor: '::',
													_0: _elm_lang$html$Html_Events$onClick(
														_CareerPlug$ats$ReportBuilder_Message$RemoveFilter(filter.field_name)),
													_1: {ctor: '[]'}
												}
											},
											{ctor: '[]'}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('extra-content'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: typeSelector,
							_1: {ctor: '[]'}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _CareerPlug$ats$ReportBuilder_View$filterItemTextView = F2(
	function (model, filter) {
		var val = A2(_elm_lang$core$Maybe$withDefault, '', filter.string_value);
		var content = A2(
			_elm_lang$html$Html$input,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$placeholder('filter 1, filter 2, filter 3'),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$value(val),
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$Library_Html$onKeyUp(
							_CareerPlug$ats$ReportBuilder_Message$UpdateFilterValue(filter.field_name)),
						_1: {ctor: '[]'}
					}
				}
			},
			{ctor: '[]'});
		return A4(_CareerPlug$ats$ReportBuilder_View$filterItemContainer, filter.display_name, filter.field_name, 'multi', content);
	});
var _CareerPlug$ats$ReportBuilder_View$filterItemView = F2(
	function (model, filter) {
		var _p15 = filter.filter_type;
		switch (_p15) {
			case 'string':
				return A2(_CareerPlug$ats$ReportBuilder_View$filterItemTextView, model, filter);
			case 'date_interval':
				return A2(_CareerPlug$ats$ReportBuilder_View$filterItemDateView, model, filter);
			case 'date_range':
				return A2(_CareerPlug$ats$ReportBuilder_View$filterItemDateView, model, filter);
			case 'multi_select':
				return A2(_CareerPlug$ats$ReportBuilder_View$filterItemMultiSelectView, model, filter);
			default:
				return A2(
					_elm_lang$html$Html$div,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(filter.display_name),
						_1: {ctor: '[]'}
					});
		}
	});
var _CareerPlug$ats$ReportBuilder_View$filterAreaView = function (model) {
	var empty = _elm_lang$core$Native_Utils.eq(
		_elm_lang$core$List$length(model.selectedFilters),
		0);
	var filtersAreaClassName = function () {
		var baseClass = 'filters-area';
		return empty ? A2(_elm_lang$core$Basics_ops['++'], baseClass, ' empty') : baseClass;
	}();
	var filterContent = empty ? A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('placeholder-container'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{ctor: '[]'},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text('Add Filters To Your Report'),
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$span,
					{ctor: '[]'},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text('(Use the field list to the left and click the filter icon)'),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		}) : A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('filters'),
			_1: {ctor: '[]'}
		},
		A2(
			_elm_lang$core$List$map,
			_CareerPlug$ats$ReportBuilder_View$filterItemView(model),
			_elm_lang$core$List$reverse(model.selectedFilters)));
	var inlineStyle = {
		ctor: '::',
		_0: {
			ctor: '_Tuple2',
			_0: 'max-height',
			_1: A2(
				_elm_lang$core$Basics_ops['++'],
				_elm_lang$core$Basics$toString(model.boundingClient.height),
				'px')
		},
		_1: {ctor: '[]'}
	};
	var resizeBarStyle = A3(
		_CareerPlug$ats$ReportBuilder_View$flexStyles,
		'0',
		'0',
		_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$dragBarWidth));
	var resizeStyle = function () {
		var _p16 = model.filterAreaHeight;
		if (_p16.ctor === 'Just') {
			return A3(
				_CareerPlug$ats$ReportBuilder_View$flexStyles,
				'0',
				'0',
				_elm_lang$core$Basics$toString(_p16._0));
		} else {
			return A3(
				_CareerPlug$ats$ReportBuilder_View$flexStyles,
				'0',
				'0',
				_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$initialFilterAreaHeight));
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$style(
				A2(
					_elm_lang$core$Basics_ops['++'],
					{
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'min-height',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$dragBarWidth),
								'px')
						},
						_1: {ctor: '[]'}
					},
					A2(_elm_lang$core$Basics_ops['++'], resizeStyle, inlineStyle))),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('filter-area-container'),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(filtersAreaClassName),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: filterContent,
					_1: {ctor: '[]'}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('filter-area-container-resize-bar'),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Library_Html$onMouseDown(_CareerPlug$ats$ReportBuilder_Message$FilterAreaResizeStart),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$style(resizeBarStyle),
								_1: {ctor: '[]'}
							}
						}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$ReportBuilder_View$rightColumnView = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('right-column-container'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: _CareerPlug$ats$ReportBuilder_View$filterAreaView(model),
			_1: {
				ctor: '::',
				_0: _CareerPlug$ats$ReportBuilder_View$reportInfoArea(model),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$ReportBuilder_View$fieldItemView = F3(
	function (model, idx, field) {
		var actionButtonClassName = function (check) {
			return A2(
				_elm_lang$core$Basics_ops['++'],
				'fa-stack',
				check ? ' disabled' : '');
		};
		var filterSelected = _elm_lang$core$Native_Utils.eq(field.filter_type, 'none') ? true : A2(
			F2(
				function (x, y) {
					return _elm_lang$core$Native_Utils.cmp(x, y) < 0;
				}),
			0,
			_elm_lang$core$List$length(
				A2(
					_elm_lang$core$List$filter,
					function (reportFilter) {
						return _elm_lang$core$Native_Utils.eq(reportFilter.field_name, field.field_name);
					},
					model.selectedFilters)));
		var columnInReport = function () {
			if (field.excludes_from_report) {
				return true;
			} else {
				var length = _elm_lang$core$List$length(
					A2(
						_elm_lang$core$List$filter,
						function (id) {
							return _elm_lang$core$Native_Utils.eq(id, idx);
						},
						model.selectedFields));
				return _elm_lang$core$Native_Utils.cmp(length, 0) > 0;
			}
		}();
		var isHovering = function () {
			var length = _elm_lang$core$List$length(
				A2(
					_elm_lang$core$List$filter,
					function (id) {
						return _elm_lang$core$Native_Utils.eq(id, idx);
					},
					model.hovering));
			return _elm_lang$core$Native_Utils.cmp(length, 0) > 0;
		}();
		var className = A2(
			_elm_lang$core$Basics_ops['++'],
			'field-choice-item',
			isHovering ? ' hovering' : '');
		var visibilityStyle = (_elm_lang$core$Native_Utils.eq(model.searchBarValue, '') || A2(
			_elm_lang$core$String$contains,
			_elm_lang$core$String$toLower(model.searchBarValue),
			_elm_lang$core$String$toLower(field.display_name))) ? {ctor: '[]'} : {
			ctor: '::',
			_0: {ctor: '_Tuple2', _0: 'display', _1: 'none'},
			_1: {ctor: '[]'}
		};
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(visibilityStyle),
				_1: {
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(className),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$title(field.display_name),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Events$onMouseOver(
								_CareerPlug$ats$ReportBuilder_Message$EnterHover(idx)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onMouseOut(
									_CareerPlug$ats$ReportBuilder_Message$ExitHover(idx)),
								_1: {ctor: '[]'}
							}
						}
					}
				}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('text-container'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: _elm_lang$html$Html$text(field.display_name),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('actions-container'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$button,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(
										_CareerPlug$ats$ReportBuilder_Message$AddField(idx)),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$disabled(columnInReport),
										_1: {ctor: '[]'}
									}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$span,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class(
												actionButtonClassName(columnInReport)),
											_1: {ctor: '[]'}
										},
										{
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$i,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('fa fa-columns fa-stack-2x'),
													_1: {ctor: '[]'}
												},
												{ctor: '[]'}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('fa fa-plus-circle fa-stack-1x'),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {ctor: '[]'}
											}
										}),
									_1: {ctor: '[]'}
								}),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$button,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Events$onClick(
											_CareerPlug$ats$ReportBuilder_Message$AddFilter(idx)),
										_1: {
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$disabled(filterSelected),
											_1: {ctor: '[]'}
										}
									},
									{
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$span,
											{
												ctor: '::',
												_0: _elm_lang$html$Html_Attributes$class(
													actionButtonClassName(filterSelected)),
												_1: {ctor: '[]'}
											},
											{
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$i,
													{
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$class('fa fa-filter fa-stack-2x'),
														_1: {ctor: '[]'}
													},
													{ctor: '[]'}),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html$i,
														{
															ctor: '::',
															_0: _elm_lang$html$Html_Attributes$class('fa fa-plus-circle fa-stack-1x'),
															_1: {ctor: '[]'}
														},
														{ctor: '[]'}),
													_1: {ctor: '[]'}
												}
											}),
										_1: {ctor: '[]'}
									}),
								_1: {ctor: '[]'}
							}
						}),
					_1: {ctor: '[]'}
				}
			});
	});
var _CareerPlug$ats$ReportBuilder_View$fieldListView = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('field-choices-list-container'),
			_1: {ctor: '[]'}
		},
		A2(
			_elm_lang$core$List$indexedMap,
			_CareerPlug$ats$ReportBuilder_View$fieldItemView(model),
			model.fieldChoices));
};
var _CareerPlug$ats$ReportBuilder_View$searchBarView = function (model) {
	return A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$input,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('quick-search'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$placeholder('Quick Search'),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Library_Html$onKeyUp(_CareerPlug$ats$ReportBuilder_Message$UpdateSearchBar),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$value(model.searchBarValue),
								_1: {ctor: '[]'}
							}
						}
					}
				},
				{ctor: '[]'}),
			_1: {ctor: '[]'}
		});
};
var _CareerPlug$ats$ReportBuilder_View$leftColumnView = function (model) {
	var resizeBarStyle = A3(
		_CareerPlug$ats$ReportBuilder_View$flexStyles,
		'0',
		'0',
		_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$dragBarWidth));
	var resizeStyle = function () {
		var _p17 = model.fieldListWidth;
		if (_p17.ctor === 'Just') {
			return A3(
				_CareerPlug$ats$ReportBuilder_View$flexStyles,
				'0',
				'0',
				_elm_lang$core$Basics$toString(_p17._0));
		} else {
			return A3(
				_CareerPlug$ats$ReportBuilder_View$flexStyles,
				'0',
				'0',
				_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$initialFieldListWidth));
		}
	}();
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('left-column-container'),
			_1: {
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$style(
					A2(
						_elm_lang$core$Basics_ops['++'],
						{
							ctor: '::',
							_0: {
								ctor: '_Tuple2',
								_0: 'min-width',
								_1: A2(
									_elm_lang$core$Basics_ops['++'],
									_elm_lang$core$Basics$toString(_CareerPlug$ats$ReportBuilder_Constants$dragBarWidth),
									'px')
							},
							_1: {ctor: '[]'}
						},
						resizeStyle)),
				_1: {ctor: '[]'}
			}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('left-column-content'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _CareerPlug$ats$ReportBuilder_View$searchBarView(model),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('field-choices-list'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _CareerPlug$ats$ReportBuilder_View$fieldListView(model),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('left-column-resize-bar'),
						_1: {
							ctor: '::',
							_0: _CareerPlug$ats$Library_Html$onMouseDown(_CareerPlug$ats$ReportBuilder_Message$FieldListResizeStart),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$style(resizeBarStyle),
								_1: {ctor: '[]'}
							}
						}
					},
					{ctor: '[]'}),
				_1: {ctor: '[]'}
			}
		});
};
var _CareerPlug$ats$ReportBuilder_View$view = function (model) {
	var missingFields = function () {
		var _p18 = model.missingFieldsMessage;
		if (_p18.ctor === 'Nothing') {
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
		} else {
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('overlay-prompt missing-fields'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('overlay'),
							_1: {ctor: '[]'}
						},
						{ctor: '[]'}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('clear-error'),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$ReportBuilder_Message$ClearError),
									_1: {ctor: '[]'}
								}
							},
							{
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html$i,
									{
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$class('fa fa-times'),
										_1: {ctor: '[]'}
									},
									{ctor: '[]'}),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('message-container'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: A2(
										_elm_lang$html$Html$i,
										{
											ctor: '::',
											_0: _elm_lang$html$Html_Attributes$class('fa fa-exclamation-triangle'),
											_1: {ctor: '[]'}
										},
										{ctor: '[]'}),
									_1: {
										ctor: '::',
										_0: A2(
											_elm_lang$html$Html$div,
											{ctor: '[]'},
											{
												ctor: '::',
												_0: _elm_lang$html$Html$text('The following fields are needed to run this report:'),
												_1: {ctor: '[]'}
											}),
										_1: {
											ctor: '::',
											_0: A2(
												_elm_lang$html$Html$div,
												{
													ctor: '::',
													_0: _elm_lang$html$Html_Attributes$class('fields'),
													_1: {ctor: '[]'}
												},
												{
													ctor: '::',
													_0: _elm_lang$html$Html$text(_p18._0),
													_1: {ctor: '[]'}
												}),
											_1: {
												ctor: '::',
												_0: A2(
													_elm_lang$html$Html$div,
													{ctor: '[]'},
													{
														ctor: '::',
														_0: _elm_lang$html$Html$text('Click'),
														_1: {
															ctor: '::',
															_0: A2(
																_elm_lang$html$Html$a,
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html_Events$onClick(
																		_CareerPlug$ats$ReportBuilder_Message$AddMissingFields(model.missingFields)),
																	_1: {ctor: '[]'}
																},
																{
																	ctor: '::',
																	_0: _elm_lang$html$Html$text(' here '),
																	_1: {ctor: '[]'}
																}),
															_1: {
																ctor: '::',
																_0: _elm_lang$html$Html$text('to add the missing fields, or you can add the fields manually.'),
																_1: {ctor: '[]'}
															}
														}
													}),
												_1: {ctor: '[]'}
											}
										}
									}
								}),
							_1: {ctor: '[]'}
						}
					}
				});
		}
	}();
	var error = function () {
		var errorMessage = function () {
			var _p19 = model.recipients;
			if (_p19.ctor === '[]') {
				return 'A report cannot be saved without a delivery address.  Please enter a delivery address and try again.';
			} else {
				return 'We\'re sorry, but there was an issue saving your report. Please try again.';
			}
		}();
		return model.error ? A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('overlay-prompt'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('overlay'),
						_1: {ctor: '[]'}
					},
					{ctor: '[]'}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('clear-error'),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onClick(_CareerPlug$ats$ReportBuilder_Message$ClearError),
								_1: {ctor: '[]'}
							}
						},
						{
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$i,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('fa fa-times'),
									_1: {ctor: '[]'}
								},
								{ctor: '[]'}),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('message-container error'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(errorMessage),
								_1: {ctor: '[]'}
							}),
						_1: {ctor: '[]'}
					}
				}
			}) : A2(
			_elm_lang$html$Html$div,
			{ctor: '[]'},
			{ctor: '[]'});
	}();
	var saving = model.saving ? A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('overlay-prompt'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('overlay'),
					_1: {ctor: '[]'}
				},
				{ctor: '[]'}),
			_1: {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('message-container'),
						_1: {ctor: '[]'}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('fa fa-refresh fa-spin'),
								_1: {ctor: '[]'}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			}
		}) : A2(
		_elm_lang$html$Html$div,
		{ctor: '[]'},
		{ctor: '[]'});
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('report-builder'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: saving,
			_1: {
				ctor: '::',
				_0: error,
				_1: {
					ctor: '::',
					_0: missingFields,
					_1: {
						ctor: '::',
						_0: _CareerPlug$ats$ReportBuilder_View$reportActionsView(model),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('report-builder-body'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _CareerPlug$ats$ReportBuilder_View$leftColumnView(model),
									_1: {
										ctor: '::',
										_0: _CareerPlug$ats$ReportBuilder_View$rightColumnView(model),
										_1: {ctor: '[]'}
									}
								}),
							_1: {ctor: '[]'}
						}
					}
				}
			}
		});
};

var _CareerPlug$ats$ReportBuilder$main = _elm_lang$html$Html$programWithFlags(
	{init: _CareerPlug$ats$ReportBuilder_Model$init, view: _CareerPlug$ats$ReportBuilder_View$view, update: _CareerPlug$ats$ReportBuilder_Update$update, subscriptions: _CareerPlug$ats$ReportBuilder_Subscriptions$subscriptions})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (authToken) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (boundingClient) {
					return A2(
						_elm_lang$core$Json_Decode$andThen,
						function (fieldChoices) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (fieldOrder) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (filters) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (recipients) {
													return A2(
														_elm_lang$core$Json_Decode$andThen,
														function (reportId) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (reportName) {
																	return A2(
																		_elm_lang$core$Json_Decode$andThen,
																		function (reportType) {
																			return A2(
																				_elm_lang$core$Json_Decode$andThen,
																				function (runDays) {
																					return A2(
																						_elm_lang$core$Json_Decode$andThen,
																						function (todaysDate) {
																							return _elm_lang$core$Json_Decode$succeed(
																								{authToken: authToken, boundingClient: boundingClient, fieldChoices: fieldChoices, fieldOrder: fieldOrder, filters: filters, recipients: recipients, reportId: reportId, reportName: reportName, reportType: reportType, runDays: runDays, todaysDate: todaysDate});
																						},
																						A2(_elm_lang$core$Json_Decode$field, 'todaysDate', _elm_lang$core$Json_Decode$float));
																				},
																				A2(
																					_elm_lang$core$Json_Decode$field,
																					'runDays',
																					_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)));
																		},
																		A2(_elm_lang$core$Json_Decode$field, 'reportType', _elm_lang$core$Json_Decode$string));
																},
																A2(_elm_lang$core$Json_Decode$field, 'reportName', _elm_lang$core$Json_Decode$string));
														},
														A2(_elm_lang$core$Json_Decode$field, 'reportId', _elm_lang$core$Json_Decode$int));
												},
												A2(
													_elm_lang$core$Json_Decode$field,
													'recipients',
													_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)));
										},
										A2(
											_elm_lang$core$Json_Decode$field,
											'filters',
											_elm_lang$core$Json_Decode$list(
												A2(
													_elm_lang$core$Json_Decode$andThen,
													function (date_interval) {
														return A2(
															_elm_lang$core$Json_Decode$andThen,
															function (date_range) {
																return A2(
																	_elm_lang$core$Json_Decode$andThen,
																	function (field_name) {
																		return A2(
																			_elm_lang$core$Json_Decode$andThen,
																			function (filter_type) {
																				return A2(
																					_elm_lang$core$Json_Decode$andThen,
																					function (select) {
																						return A2(
																							_elm_lang$core$Json_Decode$andThen,
																							function (string_value) {
																								return _elm_lang$core$Json_Decode$succeed(
																									{date_interval: date_interval, date_range: date_range, field_name: field_name, filter_type: filter_type, select: select, string_value: string_value});
																							},
																							A2(
																								_elm_lang$core$Json_Decode$field,
																								'string_value',
																								_elm_lang$core$Json_Decode$oneOf(
																									{
																										ctor: '::',
																										_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																										_1: {
																											ctor: '::',
																											_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
																											_1: {ctor: '[]'}
																										}
																									})));
																					},
																					A2(
																						_elm_lang$core$Json_Decode$field,
																						'select',
																						_elm_lang$core$Json_Decode$oneOf(
																							{
																								ctor: '::',
																								_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																								_1: {
																									ctor: '::',
																									_0: A2(
																										_elm_lang$core$Json_Decode$map,
																										_elm_lang$core$Maybe$Just,
																										A2(
																											_elm_lang$core$Json_Decode$andThen,
																											function (current_selected) {
																												return _elm_lang$core$Json_Decode$succeed(
																													{current_selected: current_selected});
																											},
																											A2(
																												_elm_lang$core$Json_Decode$field,
																												'current_selected',
																												_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)))),
																									_1: {ctor: '[]'}
																								}
																							})));
																			},
																			A2(_elm_lang$core$Json_Decode$field, 'filter_type', _elm_lang$core$Json_Decode$string));
																	},
																	A2(_elm_lang$core$Json_Decode$field, 'field_name', _elm_lang$core$Json_Decode$string));
															},
															A2(
																_elm_lang$core$Json_Decode$field,
																'date_range',
																_elm_lang$core$Json_Decode$oneOf(
																	{
																		ctor: '::',
																		_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																		_1: {
																			ctor: '::',
																			_0: A2(
																				_elm_lang$core$Json_Decode$map,
																				_elm_lang$core$Maybe$Just,
																				A2(
																					_elm_lang$core$Json_Decode$andThen,
																					function (end_date) {
																						return A2(
																							_elm_lang$core$Json_Decode$andThen,
																							function (start_date) {
																								return _elm_lang$core$Json_Decode$succeed(
																									{end_date: end_date, start_date: start_date});
																							},
																							A2(_elm_lang$core$Json_Decode$field, 'start_date', _elm_lang$core$Json_Decode$string));
																					},
																					A2(_elm_lang$core$Json_Decode$field, 'end_date', _elm_lang$core$Json_Decode$string))),
																			_1: {ctor: '[]'}
																		}
																	})));
													},
													A2(
														_elm_lang$core$Json_Decode$field,
														'date_interval',
														_elm_lang$core$Json_Decode$oneOf(
															{
																ctor: '::',
																_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																_1: {
																	ctor: '::',
																	_0: A2(
																		_elm_lang$core$Json_Decode$map,
																		_elm_lang$core$Maybe$Just,
																		A2(
																			_elm_lang$core$Json_Decode$andThen,
																			function (inclusive) {
																				return A2(
																					_elm_lang$core$Json_Decode$andThen,
																					function (interval) {
																						return A2(
																							_elm_lang$core$Json_Decode$andThen,
																							function (range) {
																								return _elm_lang$core$Json_Decode$succeed(
																									{inclusive: inclusive, interval: interval, range: range});
																							},
																							A2(_elm_lang$core$Json_Decode$field, 'range', _elm_lang$core$Json_Decode$string));
																					},
																					A2(_elm_lang$core$Json_Decode$field, 'interval', _elm_lang$core$Json_Decode$string));
																			},
																			A2(_elm_lang$core$Json_Decode$field, 'inclusive', _elm_lang$core$Json_Decode$bool))),
																	_1: {ctor: '[]'}
																}
															}))))));
								},
								A2(
									_elm_lang$core$Json_Decode$field,
									'fieldOrder',
									_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)));
						},
						A2(
							_elm_lang$core$Json_Decode$field,
							'fieldChoices',
							_elm_lang$core$Json_Decode$list(
								A2(
									_elm_lang$core$Json_Decode$andThen,
									function (display_name) {
										return A2(
											_elm_lang$core$Json_Decode$andThen,
											function (excludes_from_report) {
												return A2(
													_elm_lang$core$Json_Decode$andThen,
													function (field_name) {
														return A2(
															_elm_lang$core$Json_Decode$andThen,
															function (field_type) {
																return A2(
																	_elm_lang$core$Json_Decode$andThen,
																	function (filter_type) {
																		return A2(
																			_elm_lang$core$Json_Decode$andThen,
																			function (placeholder) {
																				return A2(
																					_elm_lang$core$Json_Decode$andThen,
																					function (select_id_type) {
																						return A2(
																							_elm_lang$core$Json_Decode$andThen,
																							function (select_options) {
																								return _elm_lang$core$Json_Decode$succeed(
																									{display_name: display_name, excludes_from_report: excludes_from_report, field_name: field_name, field_type: field_type, filter_type: filter_type, placeholder: placeholder, select_id_type: select_id_type, select_options: select_options});
																							},
																							A2(
																								_elm_lang$core$Json_Decode$field,
																								'select_options',
																								_elm_lang$core$Json_Decode$list(
																									A2(
																										_elm_lang$core$Json_Decode$andThen,
																										function (x0) {
																											return A2(
																												_elm_lang$core$Json_Decode$andThen,
																												function (x1) {
																													return _elm_lang$core$Json_Decode$succeed(
																														{ctor: '_Tuple2', _0: x0, _1: x1});
																												},
																												A2(_elm_lang$core$Json_Decode$index, 1, _elm_lang$core$Json_Decode$string));
																										},
																										A2(_elm_lang$core$Json_Decode$index, 0, _elm_lang$core$Json_Decode$string)))));
																					},
																					A2(_elm_lang$core$Json_Decode$field, 'select_id_type', _elm_lang$core$Json_Decode$string));
																			},
																			A2(
																				_elm_lang$core$Json_Decode$field,
																				'placeholder',
																				_elm_lang$core$Json_Decode$list(_elm_lang$core$Json_Decode$string)));
																	},
																	A2(_elm_lang$core$Json_Decode$field, 'filter_type', _elm_lang$core$Json_Decode$string));
															},
															A2(_elm_lang$core$Json_Decode$field, 'field_type', _elm_lang$core$Json_Decode$string));
													},
													A2(_elm_lang$core$Json_Decode$field, 'field_name', _elm_lang$core$Json_Decode$string));
											},
											A2(_elm_lang$core$Json_Decode$field, 'excludes_from_report', _elm_lang$core$Json_Decode$bool));
									},
									A2(_elm_lang$core$Json_Decode$field, 'display_name', _elm_lang$core$Json_Decode$string)))));
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'boundingClient',
					A2(
						_elm_lang$core$Json_Decode$andThen,
						function (bottom) {
							return A2(
								_elm_lang$core$Json_Decode$andThen,
								function (height) {
									return A2(
										_elm_lang$core$Json_Decode$andThen,
										function (left) {
											return A2(
												_elm_lang$core$Json_Decode$andThen,
												function (right) {
													return A2(
														_elm_lang$core$Json_Decode$andThen,
														function (top) {
															return A2(
																_elm_lang$core$Json_Decode$andThen,
																function (width) {
																	return _elm_lang$core$Json_Decode$succeed(
																		{bottom: bottom, height: height, left: left, right: right, top: top, width: width});
																},
																A2(_elm_lang$core$Json_Decode$field, 'width', _elm_lang$core$Json_Decode$int));
														},
														A2(_elm_lang$core$Json_Decode$field, 'top', _elm_lang$core$Json_Decode$int));
												},
												A2(_elm_lang$core$Json_Decode$field, 'right', _elm_lang$core$Json_Decode$int));
										},
										A2(_elm_lang$core$Json_Decode$field, 'left', _elm_lang$core$Json_Decode$int));
								},
								A2(_elm_lang$core$Json_Decode$field, 'height', _elm_lang$core$Json_Decode$int));
						},
						A2(_elm_lang$core$Json_Decode$field, 'bottom', _elm_lang$core$Json_Decode$int))));
		},
		A2(_elm_lang$core$Json_Decode$field, 'authToken', _elm_lang$core$Json_Decode$string)));

var _CareerPlug$ats$Signature$Model = F7(
	function (a, b, c, d, e, f, g) {
		return {spModel: a, viewMode: b, error: c, fieldName: d, fieldLabel: e, allowSignature: f, pointerEvent: g};
	});
var _CareerPlug$ats$Signature$Draw = {ctor: 'Draw'};
var _CareerPlug$ats$Signature$blankModel = {
	spModel: _CareerPlug$ats$Library_SignaturePad$blankModel('{\"signed_by\":\"\",\"signature\":[]}'),
	viewMode: _CareerPlug$ats$Signature$Draw,
	error: _elm_lang$core$Maybe$Nothing,
	fieldName: '',
	fieldLabel: '',
	allowSignature: false,
	pointerEvent: true
};
var _CareerPlug$ats$Signature$Input = {ctor: 'Input'};
var _CareerPlug$ats$Signature$jsonModel = function () {
	var jsonSignature = A2(
		_elm_lang$core$Json_Decode$map,
		_CareerPlug$ats$Library_SignaturePad$blankModel,
		A2(_elm_lang$core$Json_Decode$field, 'json', _elm_lang$core$Json_Decode$string));
	var err = function (v) {
		return (_elm_lang$core$Native_Utils.cmp(
			_elm_lang$core$String$length(v),
			0) > 0) ? _elm_lang$core$Maybe$Just(v) : _elm_lang$core$Maybe$Nothing;
	};
	var draw = function (v) {
		return v ? _CareerPlug$ats$Signature$Draw : _CareerPlug$ats$Signature$Input;
	};
	return A4(
		_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
		'pointerEvent',
		_elm_lang$core$Json_Decode$bool,
		true,
		A4(
			_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
			'allowSignature',
			_elm_lang$core$Json_Decode$bool,
			true,
			A4(
				_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
				'fieldLabel',
				_elm_lang$core$Json_Decode$string,
				'',
				A4(
					_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
					'fieldName',
					_elm_lang$core$Json_Decode$string,
					'',
					A4(
						_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$optional,
						'error',
						A2(_elm_lang$core$Json_Decode$map, err, _elm_lang$core$Json_Decode$string),
						_elm_lang$core$Maybe$Nothing,
						A3(
							_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
							'draw',
							A2(_elm_lang$core$Json_Decode$map, draw, _elm_lang$core$Json_Decode$bool),
							A3(
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$required,
								'signature',
								jsonSignature,
								_NoRedInk$elm_decode_pipeline$Json_Decode_Pipeline$decode(_CareerPlug$ats$Signature$Model))))))));
}();
var _CareerPlug$ats$Signature$init = function (flags) {
	var model = function () {
		var _p0 = A2(_elm_lang$core$Json_Decode$decodeValue, _CareerPlug$ats$Signature$jsonModel, flags);
		if (_p0.ctor === 'Ok') {
			return _p0._0;
		} else {
			var _p1 = A2(_elm_lang$core$Debug$log, 'Decoding Flags', _p0._0);
			return _CareerPlug$ats$Signature$blankModel;
		}
	}();
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		model,
		{ctor: '[]'});
};
var _CareerPlug$ats$Signature$FMsg = function (a) {
	return {ctor: 'FMsg', _0: a};
};
var _CareerPlug$ats$Signature$SPMsg = function (a) {
	return {ctor: 'SPMsg', _0: a};
};
var _CareerPlug$ats$Signature$update = F2(
	function (msg, model) {
		var _p2 = msg;
		if (_p2.ctor === 'SPMsg') {
			var _p3 = A3(_CareerPlug$ats$Library_SignaturePad$update, _CareerPlug$ats$Signature$SPMsg, _p2._0, model.spModel);
			var model_ = _p3._0;
			var effect = _p3._1;
			return A2(
				_elm_lang$core$Platform_Cmd_ops['!'],
				_elm_lang$core$Native_Utils.update(
					model,
					{spModel: model_}),
				{
					ctor: '::',
					_0: effect,
					_1: {ctor: '[]'}
				});
		} else {
			return A2(
				_elm_lang$core$Platform_Cmd_ops['!'],
				model,
				{ctor: '[]'});
		}
	});
var _CareerPlug$ats$Signature$formView = function (model) {
	var sigData = _CareerPlug$ats$Library_SignaturePad$signature(model.spModel);
	var fName = function (n) {
		return _elm_lang$core$String$concat(
			{
				ctor: '::',
				_0: model.fieldName,
				_1: {
					ctor: '::',
					_0: '[',
					_1: {
						ctor: '::',
						_0: n,
						_1: {
							ctor: '::',
							_0: ']',
							_1: {ctor: '[]'}
						}
					}
				}
			});
	};
	var field = F2(
		function (n, fn) {
			var val = function () {
				var _p4 = sigData;
				if (_p4.ctor === 'Just') {
					return fn(_p4._0);
				} else {
					return '';
				}
			}();
			return A2(
				_elm_lang$html$Html$input,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$type_('hidden'),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$name(
							fName(n)),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$value(val),
							_1: {ctor: '[]'}
						}
					}
				},
				{ctor: '[]'});
		});
	var maybeError = A2(_elm_lang$core$Maybe$map, _etaque$elm_form$Form_Error$CustomError, model.error);
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('signature-form-view'),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A8(_CareerPlug$ats$Library_SignaturePad$view, _CareerPlug$ats$Signature$SPMsg, _CareerPlug$ats$Signature$FMsg, model.pointerEvent, model.allowSignature, model.fieldLabel, 'typed-name', maybeError, model.spModel),
			_1: {
				ctor: '::',
				_0: A2(
					field,
					'signed_by',
					function (_) {
						return _.signed_by;
					}),
				_1: {
					ctor: '::',
					_0: A2(
						field,
						'signature',
						function (_) {
							return _.signature;
						}),
					_1: {ctor: '[]'}
				}
			}
		});
};
var _CareerPlug$ats$Signature$view = function (model) {
	var _p5 = model.viewMode;
	if (_p5.ctor === 'Input') {
		return _CareerPlug$ats$Signature$formView(model);
	} else {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('signature-display-view'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _CareerPlug$ats$Library_SignaturePad$signatureView(model.spModel),
				_1: {ctor: '[]'}
			});
	}
};
var _CareerPlug$ats$Signature$main = _elm_lang$html$Html$programWithFlags(
	{
		init: _CareerPlug$ats$Signature$init,
		view: _CareerPlug$ats$Signature$view,
		update: _CareerPlug$ats$Signature$update,
		subscriptions: function (_p6) {
			return _CareerPlug$ats$Library_SignaturePad$subscriptions(_CareerPlug$ats$Signature$SPMsg);
		}
	})(_elm_lang$core$Json_Decode$value);

var _CareerPlug$ats$Snackbar_Message$Noop = {ctor: 'Noop'};
var _CareerPlug$ats$Snackbar_Message$Tick = function (a) {
	return {ctor: 'Tick', _0: a};
};
var _CareerPlug$ats$Snackbar_Message$FullMessage = function (a) {
	return {ctor: 'FullMessage', _0: a};
};
var _CareerPlug$ats$Snackbar_Message$AddMessage = function (a) {
	return {ctor: 'AddMessage', _0: a};
};

var _CareerPlug$ats$Snackbar_Model$initialModel = {ctor: '[]'};
var _CareerPlug$ats$Snackbar_Model$init = A2(
	_elm_lang$core$Platform_Cmd_ops['!'],
	_CareerPlug$ats$Snackbar_Model$initialModel,
	{ctor: '[]'});

var _CareerPlug$ats$Snackbar_Ports$snackbar = _elm_lang$core$Native_Platform.incomingPort('snackbar', _elm_lang$core$Json_Decode$string);
var _CareerPlug$ats$Snackbar_Ports$subscriptions = function (model) {
	var defSubs = {
		ctor: '::',
		_0: _CareerPlug$ats$Snackbar_Ports$snackbar(_CareerPlug$ats$Snackbar_Message$AddMessage),
		_1: {ctor: '[]'}
	};
	var subs = _elm_lang$core$List$isEmpty(model) ? defSubs : A2(
		_elm_lang$core$Basics_ops['++'],
		defSubs,
		{
			ctor: '::',
			_0: A2(_elm_lang$core$Time$every, _elm_lang$core$Time$second, _CareerPlug$ats$Snackbar_Message$Tick),
			_1: {ctor: '[]'}
		});
	return _elm_lang$core$Platform_Sub$batch(subs);
};

var _CareerPlug$ats$Snackbar_Update$update = F2(
	function (msg, model) {
		var _p0 = msg;
		switch (_p0.ctor) {
			case 'AddMessage':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{
						ctor: '::',
						_0: A2(
							_elm_lang$core$Task$perform,
							function (t) {
								return _CareerPlug$ats$Snackbar_Message$FullMessage(
									{ctor: '_Tuple2', _0: _p0._0, _1: t});
							},
							_elm_lang$core$Time$now),
						_1: {ctor: '[]'}
					});
			case 'FullMessage':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					A2(
						_elm_lang$core$Basics_ops['++'],
						model,
						{
							ctor: '::',
							_0: _p0._0,
							_1: {ctor: '[]'}
						}),
					{ctor: '[]'});
			case 'Tick':
				var _p1 = _elm_lang$core$List$head(model);
				if (_p1.ctor === 'Just') {
					var ks = _elm_lang$core$Time$inSeconds(_p1._0._1) + 5;
					var ts = _elm_lang$core$Time$inSeconds(_p0._0);
					return (_elm_lang$core$Native_Utils.cmp(ts, ks) > 0) ? A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						A2(_elm_lang$core$List$drop, 1, model),
						{ctor: '[]'}) : A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				} else {
					return A2(
						_elm_lang$core$Platform_Cmd_ops['!'],
						model,
						{ctor: '[]'});
				}
			default:
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
		}
	});

var _CareerPlug$ats$Snackbar_View$view = function (model) {
	var _p0 = function () {
		var _p1 = _elm_lang$core$List$head(model);
		if (_p1.ctor === 'Just') {
			return {ctor: '_Tuple2', _0: 'in', _1: _p1._0._0};
		} else {
			return {ctor: '_Tuple2', _0: '', _1: ''};
		}
	}();
	var visClass = _p0._0;
	var message = _p0._1;
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class(
				A2(
					_elm_lang$core$String$join,
					' ',
					{
						ctor: '::',
						_0: 'snackbar',
						_1: {
							ctor: '::',
							_0: visClass,
							_1: {ctor: '[]'}
						}
					})),
			_1: {ctor: '[]'}
		},
		{
			ctor: '::',
			_0: A2(
				_elm_lang$html$Html$span,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('snackbar-content'),
					_1: {ctor: '[]'}
				},
				{
					ctor: '::',
					_0: _elm_lang$html$Html$text(message),
					_1: {ctor: '[]'}
				}),
			_1: {ctor: '[]'}
		});
};

var _CareerPlug$ats$SnackbarMain$main = _elm_lang$html$Html$program(
	{init: _CareerPlug$ats$Snackbar_Model$init, update: _CareerPlug$ats$Snackbar_Update$update, view: _CareerPlug$ats$Snackbar_View$view, subscriptions: _CareerPlug$ats$Snackbar_Ports$subscriptions})();

var _CareerPlug$ats$TestimonialWidget$initialModel = {
	selected: 0,
	testimonials: {ctor: '[]'},
	highlightColor: _elm_lang$core$Maybe$Nothing,
	focusedIndex: _elm_lang$core$Maybe$Nothing
};
var _CareerPlug$ats$TestimonialWidget$init = function (flags) {
	return A2(
		_elm_lang$core$Platform_Cmd_ops['!'],
		_elm_lang$core$Native_Utils.update(
			_CareerPlug$ats$TestimonialWidget$initialModel,
			{
				testimonials: flags.testimonials,
				highlightColor: flags.highlightColor,
				focusedIndex: _elm_lang$core$List$isEmpty(flags.testimonials) ? _elm_lang$core$Maybe$Nothing : _elm_lang$core$Maybe$Just(0)
			}),
		{ctor: '[]'});
};
var _CareerPlug$ats$TestimonialWidget$testimonialView = F2(
	function (model, testimonial) {
		var quotationStyle = function () {
			var _p0 = model.highlightColor;
			if (_p0.ctor === 'Nothing') {
				return {ctor: '[]'};
			} else {
				return {
					ctor: '::',
					_0: {ctor: '_Tuple2', _0: 'color', _1: _p0._0},
					_1: {ctor: '[]'}
				};
			}
		}();
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('testimonial'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('quotation-mark'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$style(quotationStyle),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$i,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('fa fa-quote-left'),
								_1: {
									ctor: '::',
									_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-hidden', 'true'),
									_1: {ctor: '[]'}
								}
							},
							{ctor: '[]'}),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('testimonial-body'),
							_1: {
								ctor: '::',
								_0: A2(
									_elm_lang$html$Html_Attributes$property,
									'innerHTML',
									_elm_lang$core$Json_Encode$string(testimonial.testimonial)),
								_1: {ctor: '[]'}
							}
						},
						{ctor: '[]'}),
					_1: {ctor: '[]'}
				}
			});
	});
var _CareerPlug$ats$TestimonialWidget$update = F2(
	function (msg, model) {
		var _p1 = msg;
		switch (_p1.ctor) {
			case 'SelectTestimonial':
				var _p2 = _p1._0;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							selected: _p2,
							focusedIndex: _elm_lang$core$Maybe$Just(_p2)
						}),
					{ctor: '[]'});
			case 'FocusTestimonial':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{focusedIndex: _p1._0}),
					{ctor: '[]'});
			case 'ElementFocused':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					_elm_lang$core$Native_Utils.update(
						model,
						{
							focusedIndex: _elm_lang$core$Maybe$Just(_p1._0)
						}),
					{ctor: '[]'});
			case 'ElementBlurred':
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					model,
					{ctor: '[]'});
			default:
				var _p3 = _p1._1;
				var testimonialsLength = _elm_lang$core$List$length(model.testimonials);
				var nextIndex = _elm_lang$core$Native_Utils.eq(_p3, ' ') ? ((_elm_lang$core$Native_Utils.cmp(model.selected, testimonialsLength - 1) < 0) ? (model.selected + 1) : 0) : model.selected;
				var newModel = _elm_lang$core$Native_Utils.eq(_p3, ' ') ? _elm_lang$core$Native_Utils.update(
					model,
					{
						selected: nextIndex,
						focusedIndex: _elm_lang$core$Maybe$Just(nextIndex)
					}) : model;
				return A2(
					_elm_lang$core$Platform_Cmd_ops['!'],
					newModel,
					{ctor: '[]'});
		}
	});
var _CareerPlug$ats$TestimonialWidget$isActivationKey = function (key) {
	return _elm_lang$core$Native_Utils.eq(key, ' ');
};
var _CareerPlug$ats$TestimonialWidget$isArrowKey = function (key) {
	return A2(
		_elm_lang$core$List$member,
		key,
		{
			ctor: '::',
			_0: 'ArrowLeft',
			_1: {
				ctor: '::',
				_0: 'ArrowRight',
				_1: {
					ctor: '::',
					_0: 'ArrowUp',
					_1: {
						ctor: '::',
						_0: 'ArrowDown',
						_1: {ctor: '[]'}
					}
				}
			}
		});
};
var _CareerPlug$ats$TestimonialWidget$keyDecoder = A2(_elm_lang$core$Json_Decode$field, 'key', _elm_lang$core$Json_Decode$string);
var _CareerPlug$ats$TestimonialWidget$Testimonial = F5(
	function (a, b, c, d, e) {
		return {testimonial: a, name: b, title: c, location: d, avatar: e};
	});
var _CareerPlug$ats$TestimonialWidget$Model = F4(
	function (a, b, c, d) {
		return {selected: a, highlightColor: b, testimonials: c, focusedIndex: d};
	});
var _CareerPlug$ats$TestimonialWidget$Flags = F2(
	function (a, b) {
		return {testimonials: a, highlightColor: b};
	});
var _CareerPlug$ats$TestimonialWidget$ElementBlurred = function (a) {
	return {ctor: 'ElementBlurred', _0: a};
};
var _CareerPlug$ats$TestimonialWidget$ElementFocused = function (a) {
	return {ctor: 'ElementFocused', _0: a};
};
var _CareerPlug$ats$TestimonialWidget$FocusTestimonial = function (a) {
	return {ctor: 'FocusTestimonial', _0: a};
};
var _CareerPlug$ats$TestimonialWidget$KeyDown = F2(
	function (a, b) {
		return {ctor: 'KeyDown', _0: a, _1: b};
	});
var _CareerPlug$ats$TestimonialWidget$testimonialKeyDecoder = function (idx) {
	return A2(
		_elm_lang$core$Json_Decode$andThen,
		function (key) {
			return _elm_lang$core$Native_Utils.eq(key, ' ') ? _elm_lang$core$Json_Decode$succeed(
				A2(_CareerPlug$ats$TestimonialWidget$KeyDown, idx, key)) : _elm_lang$core$Json_Decode$fail('Ignoring non-space key');
		},
		_CareerPlug$ats$TestimonialWidget$keyDecoder);
};
var _CareerPlug$ats$TestimonialWidget$SelectTestimonial = function (a) {
	return {ctor: 'SelectTestimonial', _0: a};
};
var _CareerPlug$ats$TestimonialWidget$testimonialPickerView = function (model) {
	var avatarView = function (_p4) {
		var _p5 = _p4;
		var _p6 = _p5.avatar;
		if (_p6.ctor === 'Nothing') {
			return A2(
				_elm_lang$html$Html$i,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class('fa fa-user'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-hidden', 'true'),
						_1: {ctor: '[]'}
					}
				},
				{ctor: '[]'});
		} else {
			return A2(
				_elm_lang$html$Html$div,
				{ctor: '[]'},
				{ctor: '[]'});
		}
	};
	var isFocused = function (idx) {
		var _p7 = model.focusedIndex;
		if (_p7.ctor === 'Just') {
			return _elm_lang$core$Native_Utils.eq(idx, _p7._0);
		} else {
			return false;
		}
	};
	var isSelected = function (idx) {
		return _elm_lang$core$Native_Utils.eq(idx, model.selected);
	};
	var selectClass = function (idx) {
		var focusedClass = isFocused(idx) ? ' focused' : '';
		var selectedClass = isSelected(idx) ? ' selected' : '';
		var baseClass = 'testimonial-select';
		return A2(
			_elm_lang$core$Basics_ops['++'],
			baseClass,
			A2(_elm_lang$core$Basics_ops['++'], selectedClass, focusedClass));
	};
	var avatarStyle = F2(
		function (idx, _p8) {
			var _p9 = _p8;
			var borderStyle = function () {
				var _p10 = model.highlightColor;
				if (_p10.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return (isSelected(idx) || isFocused(idx)) ? {
						ctor: '::',
						_0: {ctor: '_Tuple2', _0: 'border-color', _1: _p10._0},
						_1: {
							ctor: '::',
							_0: {ctor: '_Tuple2', _0: 'border-width', _1: '2px'},
							_1: {
								ctor: '::',
								_0: {ctor: '_Tuple2', _0: 'border-style', _1: 'solid'},
								_1: {ctor: '[]'}
							}
						}
					} : {ctor: '[]'};
				}
			}();
			var baseStyle = function () {
				var _p11 = _p9.avatar;
				if (_p11.ctor === 'Nothing') {
					return {ctor: '[]'};
				} else {
					return {
						ctor: '::',
						_0: {
							ctor: '_Tuple2',
							_0: 'backgroundImage',
							_1: A2(
								_elm_lang$core$Basics_ops['++'],
								'url(',
								A2(_elm_lang$core$Basics_ops['++'], _p11._0, ')'))
						},
						_1: {ctor: '[]'}
					};
				}
			}();
			return A2(_elm_lang$core$Basics_ops['++'], baseStyle, borderStyle);
		});
	var attributes = F2(
		function (idx, testimonial) {
			return isSelected(idx) ? {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('avatar'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$style(
								A2(avatarStyle, idx, testimonial)),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: avatarView(testimonial),
						_1: {ctor: '[]'}
					}),
				_1: {
					ctor: '::',
					_0: A2(
						_elm_lang$html$Html$div,
						{
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$class('name'),
							_1: {ctor: '[]'}
						},
						{
							ctor: '::',
							_0: _elm_lang$html$Html$text(testimonial.name),
							_1: {ctor: '[]'}
						}),
					_1: {
						ctor: '::',
						_0: A2(
							_elm_lang$html$Html$div,
							{
								ctor: '::',
								_0: _elm_lang$html$Html_Attributes$class('title'),
								_1: {ctor: '[]'}
							},
							{
								ctor: '::',
								_0: _elm_lang$html$Html$text(
									A2(_elm_lang$core$Maybe$withDefault, ' ', testimonial.title)),
								_1: {ctor: '[]'}
							}),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html$div,
								{
									ctor: '::',
									_0: _elm_lang$html$Html_Attributes$class('location'),
									_1: {ctor: '[]'}
								},
								{
									ctor: '::',
									_0: _elm_lang$html$Html$text(
										A2(_elm_lang$core$Maybe$withDefault, ' ', testimonial.location)),
									_1: {ctor: '[]'}
								}),
							_1: {ctor: '[]'}
						}
					}
				}
			} : {
				ctor: '::',
				_0: A2(
					_elm_lang$html$Html$div,
					{
						ctor: '::',
						_0: _elm_lang$html$Html_Attributes$class('avatar'),
						_1: {
							ctor: '::',
							_0: _elm_lang$html$Html_Attributes$style(
								A2(avatarStyle, idx, testimonial)),
							_1: {ctor: '[]'}
						}
					},
					{
						ctor: '::',
						_0: avatarView(testimonial),
						_1: {ctor: '[]'}
					}),
				_1: {ctor: '[]'}
			};
		});
	var testimonialSelectView = F2(
		function (idx, testimonial) {
			var ariaLabel = A2(
				_elm_lang$core$Basics_ops['++'],
				'Select testimonial from ',
				A2(
					_elm_lang$core$Basics_ops['++'],
					testimonial.name,
					A2(
						_elm_lang$core$Basics_ops['++'],
						function () {
							var _p12 = testimonial.title;
							if (_p12.ctor === 'Just') {
								return A2(_elm_lang$core$Basics_ops['++'], ', ', _p12._0);
							} else {
								return '';
							}
						}(),
						function () {
							var _p13 = testimonial.location;
							if (_p13.ctor === 'Just') {
								return A2(_elm_lang$core$Basics_ops['++'], ', ', _p13._0);
							} else {
								return '';
							}
						}())));
			return A2(
				_elm_lang$html$Html$div,
				{
					ctor: '::',
					_0: _elm_lang$html$Html_Attributes$class(
						selectClass(idx)),
					_1: {
						ctor: '::',
						_0: _elm_lang$html$Html_Events$onClick(
							_CareerPlug$ats$TestimonialWidget$SelectTestimonial(idx)),
						_1: {
							ctor: '::',
							_0: A2(
								_elm_lang$html$Html_Events$on,
								'keydown',
								_CareerPlug$ats$TestimonialWidget$testimonialKeyDecoder(idx)),
							_1: {
								ctor: '::',
								_0: _elm_lang$html$Html_Events$onFocus(
									_CareerPlug$ats$TestimonialWidget$ElementFocused(idx)),
								_1: {
									ctor: '::',
									_0: _elm_lang$html$Html_Events$onBlur(
										_CareerPlug$ats$TestimonialWidget$ElementBlurred(idx)),
									_1: {
										ctor: '::',
										_0: _elm_lang$html$Html_Attributes$tabindex(0),
										_1: {
											ctor: '::',
											_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'button'),
											_1: {
												ctor: '::',
												_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-label', ariaLabel),
												_1: {
													ctor: '::',
													_0: A2(
														_elm_lang$html$Html_Attributes$attribute,
														'aria-pressed',
														isSelected(idx) ? 'true' : 'false'),
													_1: {
														ctor: '::',
														_0: _elm_lang$html$Html_Attributes$id(
															A2(
																_elm_lang$core$Basics_ops['++'],
																'testimonial-',
																_elm_lang$core$Basics$toString(idx))),
														_1: {ctor: '[]'}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				},
				A2(attributes, idx, testimonial));
		});
	return A2(
		_elm_lang$html$Html$div,
		{
			ctor: '::',
			_0: _elm_lang$html$Html_Attributes$class('testimonial-picker'),
			_1: {
				ctor: '::',
				_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'group'),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-label', 'Testimonial selection'),
					_1: {ctor: '[]'}
				}
			}
		},
		A2(_elm_lang$core$List$indexedMap, testimonialSelectView, model.testimonials));
};
var _CareerPlug$ats$TestimonialWidget$view = function (model) {
	var selectedTestimonial = A2(
		_elm_lang$core$Array$get,
		model.selected,
		_elm_lang$core$Array$fromList(model.testimonials));
	var _p14 = selectedTestimonial;
	if (_p14.ctor === 'Just') {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('testimonial-widget'),
				_1: {
					ctor: '::',
					_0: A2(_elm_lang$html$Html_Attributes$attribute, 'role', 'region'),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$html$Html_Attributes$attribute, 'aria-label', 'Customer testimonials'),
						_1: {ctor: '[]'}
					}
				}
			},
			{
				ctor: '::',
				_0: A2(_CareerPlug$ats$TestimonialWidget$testimonialView, model, _p14._0),
				_1: {
					ctor: '::',
					_0: _CareerPlug$ats$TestimonialWidget$testimonialPickerView(model),
					_1: {ctor: '[]'}
				}
			});
	} else {
		return A2(
			_elm_lang$html$Html$div,
			{
				ctor: '::',
				_0: _elm_lang$html$Html_Attributes$class('testimonial-widget-error'),
				_1: {ctor: '[]'}
			},
			{
				ctor: '::',
				_0: _elm_lang$html$Html$text('No testimonials available'),
				_1: {ctor: '[]'}
			});
	}
};
var _CareerPlug$ats$TestimonialWidget$main = _elm_lang$html$Html$programWithFlags(
	{
		init: _CareerPlug$ats$TestimonialWidget$init,
		update: _CareerPlug$ats$TestimonialWidget$update,
		view: _CareerPlug$ats$TestimonialWidget$view,
		subscriptions: function (_p15) {
			return _elm_lang$core$Platform_Sub$none;
		}
	})(
	A2(
		_elm_lang$core$Json_Decode$andThen,
		function (highlightColor) {
			return A2(
				_elm_lang$core$Json_Decode$andThen,
				function (testimonials) {
					return _elm_lang$core$Json_Decode$succeed(
						{highlightColor: highlightColor, testimonials: testimonials});
				},
				A2(
					_elm_lang$core$Json_Decode$field,
					'testimonials',
					_elm_lang$core$Json_Decode$list(
						A2(
							_elm_lang$core$Json_Decode$andThen,
							function (avatar) {
								return A2(
									_elm_lang$core$Json_Decode$andThen,
									function (location) {
										return A2(
											_elm_lang$core$Json_Decode$andThen,
											function (name) {
												return A2(
													_elm_lang$core$Json_Decode$andThen,
													function (testimonial) {
														return A2(
															_elm_lang$core$Json_Decode$andThen,
															function (title) {
																return _elm_lang$core$Json_Decode$succeed(
																	{avatar: avatar, location: location, name: name, testimonial: testimonial, title: title});
															},
															A2(
																_elm_lang$core$Json_Decode$field,
																'title',
																_elm_lang$core$Json_Decode$oneOf(
																	{
																		ctor: '::',
																		_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
																		_1: {
																			ctor: '::',
																			_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
																			_1: {ctor: '[]'}
																		}
																	})));
													},
													A2(_elm_lang$core$Json_Decode$field, 'testimonial', _elm_lang$core$Json_Decode$string));
											},
											A2(_elm_lang$core$Json_Decode$field, 'name', _elm_lang$core$Json_Decode$string));
									},
									A2(
										_elm_lang$core$Json_Decode$field,
										'location',
										_elm_lang$core$Json_Decode$oneOf(
											{
												ctor: '::',
												_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
												_1: {
													ctor: '::',
													_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
													_1: {ctor: '[]'}
												}
											})));
							},
							A2(
								_elm_lang$core$Json_Decode$field,
								'avatar',
								_elm_lang$core$Json_Decode$oneOf(
									{
										ctor: '::',
										_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
										_1: {
											ctor: '::',
											_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
											_1: {ctor: '[]'}
										}
									}))))));
		},
		A2(
			_elm_lang$core$Json_Decode$field,
			'highlightColor',
			_elm_lang$core$Json_Decode$oneOf(
				{
					ctor: '::',
					_0: _elm_lang$core$Json_Decode$null(_elm_lang$core$Maybe$Nothing),
					_1: {
						ctor: '::',
						_0: A2(_elm_lang$core$Json_Decode$map, _elm_lang$core$Maybe$Just, _elm_lang$core$Json_Decode$string),
						_1: {ctor: '[]'}
					}
				}))));

var Elm = {};
Elm['AlertCenterMain'] = Elm['AlertCenterMain'] || {};
if (typeof _CareerPlug$ats$AlertCenterMain$main !== 'undefined') {
    _CareerPlug$ats$AlertCenterMain$main(Elm['AlertCenterMain'], 'AlertCenterMain', undefined);
}
Elm['AppointmentsMain'] = Elm['AppointmentsMain'] || {};
if (typeof _CareerPlug$ats$AppointmentsMain$main !== 'undefined') {
    _CareerPlug$ats$AppointmentsMain$main(Elm['AppointmentsMain'], 'AppointmentsMain', undefined);
}
Elm['AvailabilityPicker'] = Elm['AvailabilityPicker'] || {};
if (typeof _CareerPlug$ats$AvailabilityPicker$main !== 'undefined') {
    _CareerPlug$ats$AvailabilityPicker$main(Elm['AvailabilityPicker'], 'AvailabilityPicker', undefined);
}
Elm['EmailMain'] = Elm['EmailMain'] || {};
if (typeof _CareerPlug$ats$EmailMain$main !== 'undefined') {
    _CareerPlug$ats$EmailMain$main(Elm['EmailMain'], 'EmailMain', undefined);
}
Elm['GlobalSearch'] = Elm['GlobalSearch'] || {};
if (typeof _CareerPlug$ats$GlobalSearch$main !== 'undefined') {
    _CareerPlug$ats$GlobalSearch$main(Elm['GlobalSearch'], 'GlobalSearch', undefined);
}
Elm['IconPickerWidget'] = Elm['IconPickerWidget'] || {};
if (typeof _CareerPlug$ats$IconPickerWidget$main !== 'undefined') {
    _CareerPlug$ats$IconPickerWidget$main(Elm['IconPickerWidget'], 'IconPickerWidget', undefined);
}
Elm['PdfForm'] = Elm['PdfForm'] || {};
if (typeof _CareerPlug$ats$PdfForm$main !== 'undefined') {
    _CareerPlug$ats$PdfForm$main(Elm['PdfForm'], 'PdfForm', undefined);
}
Elm['ReportBuilder'] = Elm['ReportBuilder'] || {};
if (typeof _CareerPlug$ats$ReportBuilder$main !== 'undefined') {
    _CareerPlug$ats$ReportBuilder$main(Elm['ReportBuilder'], 'ReportBuilder', undefined);
}
Elm['Signature'] = Elm['Signature'] || {};
if (typeof _CareerPlug$ats$Signature$main !== 'undefined') {
    _CareerPlug$ats$Signature$main(Elm['Signature'], 'Signature', undefined);
}
Elm['SnackbarMain'] = Elm['SnackbarMain'] || {};
if (typeof _CareerPlug$ats$SnackbarMain$main !== 'undefined') {
    _CareerPlug$ats$SnackbarMain$main(Elm['SnackbarMain'], 'SnackbarMain', undefined);
}
Elm['TestimonialWidget'] = Elm['TestimonialWidget'] || {};
if (typeof _CareerPlug$ats$TestimonialWidget$main !== 'undefined') {
    _CareerPlug$ats$TestimonialWidget$main(Elm['TestimonialWidget'], 'TestimonialWidget', undefined);
}

if (typeof define === "function" && define['amd'])
{
  define([], function() { return Elm; });
  return;
}

if (typeof module === "object")
{
  module['exports'] = Elm;
  return;
}

var globalElm = this['Elm'];
if (typeof globalElm === "undefined")
{
  this['Elm'] = Elm;
  return;
}

for (var publicModule in Elm)
{
  if (publicModule in globalElm)
  {
    throw new Error('There are two Elm modules called `' + publicModule + '` on this page! Rename one of them.');
  }
  globalElm[publicModule] = Elm[publicModule];
}

}).call(this);

